
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire239d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire239d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray, $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$noop$1() {}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop$1, $72b03fdf46effee2$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $72b03fdf46effee2$var$noop() {}
$72b03fdf46effee2$export$dca3b0875bd9a954 = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, void 0, void 0, null, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $72b03fdf46effee2$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.1.1";

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionLane = 256, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextTransitionLane() {
    var lane = $dca0ddb82b882518$var$nextTransitionLane;
    $dca0ddb82b882518$var$nextTransitionLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextTransitionLane & 4194048) && ($dca0ddb82b882518$var$nextTransitionLane = 256);
    return lane;
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node) {
    var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    node._valueTracker || (node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node));
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_417 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_417) {
            var $dca0ddb82b882518$var$element$jscomp$inline_418 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_418.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_417 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_418.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282 = $dca0ddb82b882518$var$isSupported$jscomp$inline_417;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_PROVIDER_TYPE:
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $dca0ddb82b882518$var$track(instance);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children), $dca0ddb82b882518$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            $dca0ddb82b882518$var$nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$noop$3() {}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$3, $dca0ddb82b882518$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$3, $dca0ddb82b882518$var$noop$3);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    $dca0ddb82b882518$var$thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState$1 = null);
        $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState$1 = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    var create = $dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe);
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, $dca0ddb82b882518$var$createEffectInstance(), $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 124) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$38);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, $dca0ddb82b882518$var$createEffectInstance(), $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, $dca0ddb82b882518$var$createEffectInstance(), create, createDeps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, createDeps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, createDeps);
}
function $dca0ddb82b882518$var$updateEffect(create, createDeps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, createDeps);
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop$2() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop$2 : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$41 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$41 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$41, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
}, $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 124) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, $dca0ddb82b882518$var$createEffectInstance(), $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
}, $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
}, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$thenableIndexCounter = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = fiber);
        }
    } else $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($dca0ddb82b882518$var$isHydrating) {
                var nextInstance = $dca0ddb82b882518$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                            id: $dca0ddb82b882518$var$treeContextId,
                            overflow: $dca0ddb82b882518$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, nextProps;
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            "$?" === nextInstance.data || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextInstance.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && ($dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId, $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow, $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider, $dca0ddb82b882518$var$treeContextId = current.id, $dca0ddb82b882518$var$treeContextOverflow = current.overflow, $dca0ddb82b882518$var$treeContextProvider = workInProgress), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = $dca0ddb82b882518$var$createWorkInProgress(digest, showFallback) : (showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $dca0ddb82b882518$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, nextProps;
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $dca0ddb82b882518$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $dca0ddb82b882518$var$shouldConstruct(lazyComponent) ? (current = $dca0ddb82b882518$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $dca0ddb82b882518$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError(init);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, lazyComponent[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(lazyComponent, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (lazyComponent = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, init = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = init, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(lazyComponent.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = init), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (init = lazyComponent = $dca0ddb82b882518$var$nextHydratableInstance) lazyComponent = $dca0ddb82b882518$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(lazyComponent.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = init);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), init = $dca0ddb82b882518$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), lazyComponent = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? (init = $dca0ddb82b882518$var$peekCacheFromPool(), null === init && (init = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        resource = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null !== $dca0ddb82b882518$var$shellBoundary : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || resource !== $dca0ddb82b882518$var$shellBoundary)) throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== renderLanes ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - type.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $dca0ddb82b882518$var$now(), workInProgress.sibling = null, current = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearSuspenseBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource($dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes) return $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes;
    if (null !== $dca0ddb82b882518$var$ReactSharedInternals.T) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $dca0ddb82b882518$var$requestTransitionLane();
    }
    return $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    0 === $dca0ddb82b882518$var$workInProgressDeferredLane && ($dca0ddb82b882518$var$workInProgressDeferredLane = 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if ($dca0ddb82b882518$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $dca0ddb82b882518$var$noop
        }, $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = $dca0ddb82b882518$var$waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$thenableIndexCounter = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : 1) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$169);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState = null;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects(wasDelayedCommit) {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects(wasDelayedCommit);
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$174, root$174 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane), $dca0ddb82b882518$var$currentEventTransitionLane = 0);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    0 === $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = $dca0ddb82b882518$var$claimNextTransitionLane());
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1528 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1528 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1528++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1529 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1528], $dca0ddb82b882518$var$domEventName$jscomp$inline_1530 = $dca0ddb82b882518$var$eventName$jscomp$inline_1529.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1531 = $dca0ddb82b882518$var$eventName$jscomp$inline_1529[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1529.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1530, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1531);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $dca0ddb82b882518$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $dca0ddb82b882518$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $dca0ddb82b882518$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $dca0ddb82b882518$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $dca0ddb82b882518$var$getParent(inCapturePhase);
                                reactEventName = $dca0ddb82b882518$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$noop$1() {}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $dca0ddb82b882518$var$track(domElement);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $dca0ddb82b882518$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && $dca0ddb82b882518$var$releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && $dca0ddb82b882518$var$releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, $dca0ddb82b882518$var$releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(suspenseInstance);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$244 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$244 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, $dca0ddb82b882518$var$markNodeAsHoistable(instance$250), instance$250;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$250)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $dca0ddb82b882518$var$suspendedState = null;
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $dca0ddb82b882518$var$suspendedState) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(475));
    var state = $dca0ddb82b882518$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $dca0ddb82b882518$var$waitForCommitToBeReady() {
    if (null === $dca0ddb82b882518$var$suspendedState) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(475));
    var state = $dca0ddb82b882518$var$suspendedState;
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $dca0ddb82b882518$var$requestUpdateLane();
                            lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
                            var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1785 = $acw62.version;
if ("19.1.1" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1785) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.1"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.1.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2257.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2257.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2257.inject($dca0ddb82b882518$var$internals$jscomp$inline_2256), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2257;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.1.1";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});

parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.1.1";

});



parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


parcelRegister("f504n", function(module, exports) {

var $23YZo = parcelRequire("23YZo");

var $fiQnm = parcelRequire("fiQnm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fiQnm;
module.exports = isBuffer;

});
parcelRegister("23YZo", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $ljJ8G || $180b2bc3c0deaf6c$var$freeSelf || Function('return this')();
module.exports = $180b2bc3c0deaf6c$var$root;

});
parcelRegister("ljJ8G", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f84e62f9db5b9ccd$var$freeGlobal;

});


parcelRegister("fiQnm", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b2412a30bba480f5$var$stubFalse() {
    return false;
}
module.exports = $b2412a30bba480f5$var$stubFalse;

});


parcelRegister("jIny1", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $ljJ8G.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $6b3372b60d35b33f$export$998bcd577473dd93, (v) => $6b3372b60d35b33f$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $6b3372b60d35b33f$export$3d6c20d97e46b957, (v) => $6b3372b60d35b33f$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$998bcd577473dd93;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$3d6c20d97e46b957;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
'use strict';
var $6b3372b60d35b33f$var$b = Symbol.for("react.element"), $6b3372b60d35b33f$var$c = Symbol.for("react.portal"), $6b3372b60d35b33f$var$d = Symbol.for("react.fragment"), $6b3372b60d35b33f$var$e = Symbol.for("react.strict_mode"), $6b3372b60d35b33f$var$f = Symbol.for("react.profiler"), $6b3372b60d35b33f$var$g = Symbol.for("react.provider"), $6b3372b60d35b33f$var$h = Symbol.for("react.context"), $6b3372b60d35b33f$var$k = Symbol.for("react.server_context"), $6b3372b60d35b33f$var$l = Symbol.for("react.forward_ref"), $6b3372b60d35b33f$var$m = Symbol.for("react.suspense"), $6b3372b60d35b33f$var$n = Symbol.for("react.suspense_list"), $6b3372b60d35b33f$var$p = Symbol.for("react.memo"), $6b3372b60d35b33f$var$q = Symbol.for("react.lazy"), $6b3372b60d35b33f$var$t = Symbol.for("react.offscreen"), $6b3372b60d35b33f$var$u;
$6b3372b60d35b33f$var$u = Symbol.for("react.module.reference");
function $6b3372b60d35b33f$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $6b3372b60d35b33f$var$b:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$d:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$h:
                            case $6b3372b60d35b33f$var$l:
                            case $6b3372b60d35b33f$var$q:
                            case $6b3372b60d35b33f$var$p:
                            case $6b3372b60d35b33f$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $6b3372b60d35b33f$var$c:
                return r;
        }
    }
}
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$b;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$q;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$998bcd577473dd93 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$92387174baf9b227 = function() {
    return !1;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = function() {
    return !1;
};
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$b;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$q;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$m;
};
$6b3372b60d35b33f$export$3d6c20d97e46b957 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$d || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$n || a === $6b3372b60d35b33f$var$t || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$q || a.$$typeof === $6b3372b60d35b33f$var$p || a.$$typeof === $6b3372b60d35b33f$var$g || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$l || a.$$typeof === $6b3372b60d35b33f$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$v;

});

parcelRegister("eTYpT", function(module, exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`

module.exports = (parcelRequire("3adcp"));

});
parcelRegister("3adcp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_band.default;
    }
});
Object.defineProperty(module.exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_diverging.divergingLog;
    }
});
Object.defineProperty(module.exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_diverging.divergingPow;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_diverging.divergingSqrt;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_diverging.divergingSymlog;
    }
});
Object.defineProperty(module.exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_identity.default;
    }
});
Object.defineProperty(module.exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_ordinal.implicit;
    }
});
Object.defineProperty(module.exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_log.default;
    }
});
Object.defineProperty(module.exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_ordinal.default;
    }
});
Object.defineProperty(module.exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_band.point;
    }
});
Object.defineProperty(module.exports, "scalePow", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_pow.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_quantize.default;
    }
});
Object.defineProperty(module.exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_radial.default;
    }
});
Object.defineProperty(module.exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_sequential.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_sequential.sequentialLog;
    }
});
Object.defineProperty(module.exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_sequential.sequentialPow;
    }
});
Object.defineProperty(module.exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_sequentialQuantile.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_sequential.sequentialSqrt;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_sequential.sequentialSymlog;
    }
});
Object.defineProperty(module.exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_pow.sqrt;
    }
});
Object.defineProperty(module.exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_symlog.default;
    }
});
Object.defineProperty(module.exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_threshold.default;
    }
});
Object.defineProperty(module.exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_time.default;
    }
});
Object.defineProperty(module.exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_utcTime.default;
    }
});
Object.defineProperty(module.exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_tickFormat.default;
    }
});

var $24dc8b55daa987f9$var$_band = $24dc8b55daa987f9$var$_interopRequireWildcard((parcelRequire("dlF1c")));

var $24dc8b55daa987f9$var$_identity = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("5Hf98")));

var $24dc8b55daa987f9$var$_linear = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("hvSDx")));

var $24dc8b55daa987f9$var$_log = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("aEI3x")));

var $24dc8b55daa987f9$var$_symlog = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("bzrFz")));

var $24dc8b55daa987f9$var$_ordinal = $24dc8b55daa987f9$var$_interopRequireWildcard((parcelRequire("cndqj")));

var $24dc8b55daa987f9$var$_pow = $24dc8b55daa987f9$var$_interopRequireWildcard((parcelRequire("cpAbf")));

var $24dc8b55daa987f9$var$_radial = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("5lxEG")));

var $24dc8b55daa987f9$var$_quantile = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("67PVh")));

var $24dc8b55daa987f9$var$_quantize = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("mgOAc")));

var $24dc8b55daa987f9$var$_threshold = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("g6ge9")));

var $24dc8b55daa987f9$var$_time = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("617BV")));

var $24dc8b55daa987f9$var$_utcTime = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("ne0st")));

var $24dc8b55daa987f9$var$_sequential = $24dc8b55daa987f9$var$_interopRequireWildcard((parcelRequire("5pVeE")));

var $24dc8b55daa987f9$var$_sequentialQuantile = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("l4TSc")));

var $24dc8b55daa987f9$var$_diverging = $24dc8b55daa987f9$var$_interopRequireWildcard((parcelRequire("fMWTD")));

var $24dc8b55daa987f9$var$_tickFormat = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("3ZXxn")));
function $24dc8b55daa987f9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $24dc8b55daa987f9$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($24dc8b55daa987f9$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $24dc8b55daa987f9$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $24dc8b55daa987f9$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("dlF1c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9b7d0de6b9b21ba7$var$band;
module.exports.point = $9b7d0de6b9b21ba7$var$point;

var $baM4h = parcelRequire("baM4h");

var $98nei = parcelRequire("98nei");

var $9b7d0de6b9b21ba7$var$_ordinal = $9b7d0de6b9b21ba7$var$_interopRequireDefault((parcelRequire("cndqj")));
function $9b7d0de6b9b21ba7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9b7d0de6b9b21ba7$var$band() {
    var scale = (0, $9b7d0de6b9b21ba7$var$_ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $baM4h.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $9b7d0de6b9b21ba7$var$band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return $98nei.initRange.apply(rescale(), arguments);
}
function $9b7d0de6b9b21ba7$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $9b7d0de6b9b21ba7$var$pointish(copy());
    };
    return scale;
}
function $9b7d0de6b9b21ba7$var$point() {
    return $9b7d0de6b9b21ba7$var$pointish($9b7d0de6b9b21ba7$var$band.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("baM4h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Adder", {
    enumerable: true,
    get: function() {
        return $aRMXC.Adder;
    }
});
Object.defineProperty(module.exports, "InternMap", {
    enumerable: true,
    get: function() {
        return $7sRhp.InternMap;
    }
});
Object.defineProperty(module.exports, "InternSet", {
    enumerable: true,
    get: function() {
        return $7sRhp.InternSet;
    }
});
Object.defineProperty(module.exports, "ascending", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "bin", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "bisect", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_bisect.default;
    }
});
Object.defineProperty(module.exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_bisect.bisectCenter;
    }
});
Object.defineProperty(module.exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_bisect.bisectLeft;
    }
});
Object.defineProperty(module.exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_bisect.bisectRight;
    }
});
Object.defineProperty(module.exports, "bisector", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_bisector.default;
    }
});
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_count.default;
    }
});
Object.defineProperty(module.exports, "cross", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "cumsum", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_cumsum.default;
    }
});
Object.defineProperty(module.exports, "descending", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "deviation", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_deviation.default;
    }
});
Object.defineProperty(module.exports, "difference", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_difference.default;
    }
});
Object.defineProperty(module.exports, "disjoint", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_disjoint.default;
    }
});
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_every.default;
    }
});
Object.defineProperty(module.exports, "extent", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_extent.default;
    }
});
Object.defineProperty(module.exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return $aRMXC.fcumsum;
    }
});
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_filter.default;
    }
});
Object.defineProperty(module.exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_group.flatGroup;
    }
});
Object.defineProperty(module.exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_group.flatRollup;
    }
});
Object.defineProperty(module.exports, "fsum", {
    enumerable: true,
    get: function() {
        return $aRMXC.fsum;
    }
});
Object.defineProperty(module.exports, "greatest", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_greatest.default;
    }
});
Object.defineProperty(module.exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_greatestIndex.default;
    }
});
Object.defineProperty(module.exports, "group", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_group.default;
    }
});
Object.defineProperty(module.exports, "groupSort", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_groupSort.default;
    }
});
Object.defineProperty(module.exports, "groups", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_group.groups;
    }
});
Object.defineProperty(module.exports, "histogram", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "index", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_group.index;
    }
});
Object.defineProperty(module.exports, "indexes", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_group.indexes;
    }
});
Object.defineProperty(module.exports, "intersection", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_intersection.default;
    }
});
Object.defineProperty(module.exports, "least", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_least.default;
    }
});
Object.defineProperty(module.exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_leastIndex.default;
    }
});
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_map.default;
    }
});
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_max.default;
    }
});
Object.defineProperty(module.exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_maxIndex.default;
    }
});
Object.defineProperty(module.exports, "mean", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_mean.default;
    }
});
Object.defineProperty(module.exports, "median", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_median.default;
    }
});
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_merge.default;
    }
});
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_min.default;
    }
});
Object.defineProperty(module.exports, "minIndex", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_minIndex.default;
    }
});
Object.defineProperty(module.exports, "mode", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_mode.default;
    }
});
Object.defineProperty(module.exports, "nice", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_nice.default;
    }
});
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_pairs.default;
    }
});
Object.defineProperty(module.exports, "permute", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_permute.default;
    }
});
Object.defineProperty(module.exports, "quantile", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_quantile.quantileSorted;
    }
});
Object.defineProperty(module.exports, "quickselect", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_quickselect.default;
    }
});
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_range.default;
    }
});
Object.defineProperty(module.exports, "rank", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_rank.default;
    }
});
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_reduce.default;
    }
});
Object.defineProperty(module.exports, "reverse", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "rollup", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_group.rollup;
    }
});
Object.defineProperty(module.exports, "rollups", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_group.rollups;
    }
});
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_scan.default;
    }
});
Object.defineProperty(module.exports, "shuffle", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_shuffle.default;
    }
});
Object.defineProperty(module.exports, "shuffler", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_shuffle.shuffler;
    }
});
Object.defineProperty(module.exports, "some", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_some.default;
    }
});
Object.defineProperty(module.exports, "sort", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_sort.default;
    }
});
Object.defineProperty(module.exports, "subset", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_subset.default;
    }
});
Object.defineProperty(module.exports, "sum", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_sum.default;
    }
});
Object.defineProperty(module.exports, "superset", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_superset.default;
    }
});
Object.defineProperty(module.exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_freedmanDiaconis.default;
    }
});
Object.defineProperty(module.exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_scott.default;
    }
});
Object.defineProperty(module.exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_sturges.default;
    }
});
Object.defineProperty(module.exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_ticks.tickIncrement;
    }
});
Object.defineProperty(module.exports, "tickStep", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_ticks.tickStep;
    }
});
Object.defineProperty(module.exports, "ticks", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_ticks.default;
    }
});
Object.defineProperty(module.exports, "transpose", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_transpose.default;
    }
});
Object.defineProperty(module.exports, "union", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_union.default;
    }
});
Object.defineProperty(module.exports, "variance", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_variance.default;
    }
});
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_zip.default;
    }
});

var $8225ea2cc440a857$var$_bisect = $8225ea2cc440a857$var$_interopRequireWildcard((parcelRequire("eiUsc")));

var $8225ea2cc440a857$var$_ascending = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("42JXN")));

var $8225ea2cc440a857$var$_bisector = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("7C7yR")));

var $8225ea2cc440a857$var$_count = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("ajdJT")));

var $8225ea2cc440a857$var$_cross = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("67S8D")));

var $8225ea2cc440a857$var$_cumsum = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("hG40Y")));

var $8225ea2cc440a857$var$_descending = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("j54An")));

var $8225ea2cc440a857$var$_deviation = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("7tsUa")));

var $8225ea2cc440a857$var$_extent = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("lRRFR")));

var $aRMXC = parcelRequire("aRMXC");

var $8225ea2cc440a857$var$_group = $8225ea2cc440a857$var$_interopRequireWildcard((parcelRequire("c1jhN")));

var $8225ea2cc440a857$var$_groupSort = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("g9Xbd")));

var $8225ea2cc440a857$var$_bin = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("cLuus")));

var $8225ea2cc440a857$var$_freedmanDiaconis = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("d1BC7")));

var $8225ea2cc440a857$var$_scott = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("6i8dH")));

var $8225ea2cc440a857$var$_sturges = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("i7tuN")));

var $8225ea2cc440a857$var$_max = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("kHUkZ")));

var $8225ea2cc440a857$var$_maxIndex = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("draOj")));

var $8225ea2cc440a857$var$_mean = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("6DBgh")));

var $8225ea2cc440a857$var$_median = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("4HwgR")));

var $8225ea2cc440a857$var$_merge = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("gnNvC")));

var $8225ea2cc440a857$var$_min = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("5raSG")));

var $8225ea2cc440a857$var$_minIndex = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("5nboE")));

var $8225ea2cc440a857$var$_mode = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("asMhi")));

var $8225ea2cc440a857$var$_nice = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("7mFci")));

var $8225ea2cc440a857$var$_pairs = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("ir717")));

var $8225ea2cc440a857$var$_permute = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("39H9X")));

var $8225ea2cc440a857$var$_quantile = $8225ea2cc440a857$var$_interopRequireWildcard((parcelRequire("26KnF")));

var $8225ea2cc440a857$var$_quickselect = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("3EDNm")));

var $8225ea2cc440a857$var$_range = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("hxxuu")));

var $8225ea2cc440a857$var$_rank = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("2Koeh")));

var $8225ea2cc440a857$var$_least = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("8ITro")));

var $8225ea2cc440a857$var$_leastIndex = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("akUwn")));

var $8225ea2cc440a857$var$_greatest = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("ldDLn")));

var $8225ea2cc440a857$var$_greatestIndex = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("6g8Yn")));

var $8225ea2cc440a857$var$_scan = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("lfHoP")));

var $8225ea2cc440a857$var$_shuffle = $8225ea2cc440a857$var$_interopRequireWildcard((parcelRequire("jL9vH")));

var $8225ea2cc440a857$var$_sum = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("2zFIX")));

var $8225ea2cc440a857$var$_ticks = $8225ea2cc440a857$var$_interopRequireWildcard((parcelRequire("5nk0u")));

var $8225ea2cc440a857$var$_transpose = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("lcJcg")));

var $8225ea2cc440a857$var$_variance = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("eUraa")));

var $8225ea2cc440a857$var$_zip = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("6s8G0")));

var $8225ea2cc440a857$var$_every = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("4tbza")));

var $8225ea2cc440a857$var$_some = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("1clrJ")));

var $8225ea2cc440a857$var$_filter = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("hR10Z")));

var $8225ea2cc440a857$var$_map = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("akUza")));

var $8225ea2cc440a857$var$_reduce = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("h6YjS")));

var $8225ea2cc440a857$var$_reverse = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("397w5")));

var $8225ea2cc440a857$var$_sort = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("c5SM0")));

var $8225ea2cc440a857$var$_difference = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("e1d1i")));

var $8225ea2cc440a857$var$_disjoint = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("fu4hi")));

var $8225ea2cc440a857$var$_intersection = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("YVzQY")));

var $8225ea2cc440a857$var$_subset = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("fg75q")));

var $8225ea2cc440a857$var$_superset = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("8D0Hg")));

var $8225ea2cc440a857$var$_union = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("aIUy7")));

var $7sRhp = parcelRequire("7sRhp");
function $8225ea2cc440a857$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8225ea2cc440a857$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8225ea2cc440a857$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8225ea2cc440a857$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8225ea2cc440a857$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("eiUsc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.bisectRight = module.exports.bisectLeft = module.exports.bisectCenter = void 0;

var $a69e89b1b00926f6$var$_ascending = $a69e89b1b00926f6$var$_interopRequireDefault((parcelRequire("42JXN")));

var $a69e89b1b00926f6$var$_bisector = $a69e89b1b00926f6$var$_interopRequireDefault((parcelRequire("7C7yR")));

var $a69e89b1b00926f6$var$_number = $a69e89b1b00926f6$var$_interopRequireDefault((parcelRequire("gcfbT")));
function $a69e89b1b00926f6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a69e89b1b00926f6$var$ascendingBisect = (0, $a69e89b1b00926f6$var$_bisector.default)($a69e89b1b00926f6$var$_ascending.default);
const $a69e89b1b00926f6$var$bisectRight = $a69e89b1b00926f6$var$ascendingBisect.right;
module.exports.bisectRight = $a69e89b1b00926f6$var$bisectRight;
const $a69e89b1b00926f6$var$bisectLeft = $a69e89b1b00926f6$var$ascendingBisect.left;
module.exports.bisectLeft = $a69e89b1b00926f6$var$bisectLeft;
const $a69e89b1b00926f6$var$bisectCenter = (0, $a69e89b1b00926f6$var$_bisector.default)($a69e89b1b00926f6$var$_number.default).center;
module.exports.bisectCenter = $a69e89b1b00926f6$var$bisectCenter;
var $a69e89b1b00926f6$var$_default = $a69e89b1b00926f6$var$bisectRight;
module.exports.default = $a69e89b1b00926f6$var$_default;

});
parcelRegister("42JXN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2f1b00b724dfee65$var$ascending;
function $2f1b00b724dfee65$var$ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("7C7yR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $58b1f287db5949a5$var$bisector;

var $58b1f287db5949a5$var$_ascending = $58b1f287db5949a5$var$_interopRequireDefault((parcelRequire("42JXN")));

var $58b1f287db5949a5$var$_descending = $58b1f287db5949a5$var$_interopRequireDefault((parcelRequire("j54An")));
function $58b1f287db5949a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $58b1f287db5949a5$var$bisector(f) {
    let compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = $58b1f287db5949a5$var$_ascending.default;
        compare2 = (d, x)=>(0, $58b1f287db5949a5$var$_ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === $58b1f287db5949a5$var$_ascending.default || f === $58b1f287db5949a5$var$_descending.default ? f : $58b1f287db5949a5$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $58b1f287db5949a5$var$zero() {
    return 0;
}

});
parcelRegister("j54An", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $de420a943e5c0a77$var$descending;
function $de420a943e5c0a77$var$descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("gcfbT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bca98cef4eb74909$var$number;
module.exports.numbers = $bca98cef4eb74909$var$numbers;
function $bca98cef4eb74909$var$number(x) {
    return x === null ? NaN : +x;
}
function* $bca98cef4eb74909$var$numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("ajdJT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7816560ab8fc6739$var$count;
function $7816560ab8fc6739$var$count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRegister("67S8D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $475d643bc06ac38a$var$cross;
function $475d643bc06ac38a$var$length(array) {
    return array.length | 0;
}
function $475d643bc06ac38a$var$empty(length) {
    return !(length > 0);
}
function $475d643bc06ac38a$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $475d643bc06ac38a$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $475d643bc06ac38a$var$cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $475d643bc06ac38a$var$reducer(values.pop());
    values = values.map($475d643bc06ac38a$var$arrayify);
    const lengths = values.map($475d643bc06ac38a$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($475d643bc06ac38a$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRegister("hG40Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cde979221a8d2882$var$cumsum;
function $cde979221a8d2882$var$cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRegister("7tsUa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5711a9c3c8056430$var$deviation;

var $5711a9c3c8056430$var$_variance = $5711a9c3c8056430$var$_interopRequireDefault((parcelRequire("eUraa")));
function $5711a9c3c8056430$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5711a9c3c8056430$var$deviation(values, valueof) {
    const v = (0, $5711a9c3c8056430$var$_variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("eUraa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $adab5da989fb8953$var$variance;
function $adab5da989fb8953$var$variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRegister("lRRFR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $feb82ec2fd27e17d$var$extent;
function $feb82ec2fd27e17d$var$extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("aRMXC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Adder = void 0;
module.exports.fcumsum = $7e94d527ee12243e$var$fcumsum;
module.exports.fsum = $7e94d527ee12243e$var$fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $7e94d527ee12243e$var$Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
module.exports.Adder = $7e94d527ee12243e$var$Adder;
function $7e94d527ee12243e$var$fsum(values, valueof) {
    const adder = new $7e94d527ee12243e$var$Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $7e94d527ee12243e$var$fcumsum(values, valueof) {
    const adder = new $7e94d527ee12243e$var$Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRegister("c1jhN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c0489d5df4dc49a$var$group;
module.exports.flatGroup = $8c0489d5df4dc49a$var$flatGroup;
module.exports.flatRollup = $8c0489d5df4dc49a$var$flatRollup;
module.exports.groups = $8c0489d5df4dc49a$var$groups;
module.exports.index = $8c0489d5df4dc49a$var$index;
module.exports.indexes = $8c0489d5df4dc49a$var$indexes;
module.exports.rollup = $8c0489d5df4dc49a$var$rollup;
module.exports.rollups = $8c0489d5df4dc49a$var$rollups;

var $7sRhp = parcelRequire("7sRhp");

var $8c0489d5df4dc49a$var$_identity = $8c0489d5df4dc49a$var$_interopRequireDefault((parcelRequire("8zLyq")));
function $8c0489d5df4dc49a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8c0489d5df4dc49a$var$group(values, ...keys) {
    return $8c0489d5df4dc49a$var$nest(values, $8c0489d5df4dc49a$var$_identity.default, $8c0489d5df4dc49a$var$_identity.default, keys);
}
function $8c0489d5df4dc49a$var$groups(values, ...keys) {
    return $8c0489d5df4dc49a$var$nest(values, Array.from, $8c0489d5df4dc49a$var$_identity.default, keys);
}
function $8c0489d5df4dc49a$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $8c0489d5df4dc49a$var$flatGroup(values, ...keys) {
    return $8c0489d5df4dc49a$var$flatten($8c0489d5df4dc49a$var$groups(values, ...keys), keys);
}
function $8c0489d5df4dc49a$var$flatRollup(values, reduce, ...keys) {
    return $8c0489d5df4dc49a$var$flatten($8c0489d5df4dc49a$var$rollups(values, reduce, ...keys), keys);
}
function $8c0489d5df4dc49a$var$rollup(values, reduce, ...keys) {
    return $8c0489d5df4dc49a$var$nest(values, $8c0489d5df4dc49a$var$_identity.default, reduce, keys);
}
function $8c0489d5df4dc49a$var$rollups(values, reduce, ...keys) {
    return $8c0489d5df4dc49a$var$nest(values, Array.from, reduce, keys);
}
function $8c0489d5df4dc49a$var$index(values, ...keys) {
    return $8c0489d5df4dc49a$var$nest(values, $8c0489d5df4dc49a$var$_identity.default, $8c0489d5df4dc49a$var$unique, keys);
}
function $8c0489d5df4dc49a$var$indexes(values, ...keys) {
    return $8c0489d5df4dc49a$var$nest(values, Array.from, $8c0489d5df4dc49a$var$unique, keys);
}
function $8c0489d5df4dc49a$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $8c0489d5df4dc49a$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new $7sRhp.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRegister("7sRhp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternSet = module.exports.InternMap = void 0;
class $56f47a2ee37085db$var$InternMap extends Map {
    constructor(entries, key = $56f47a2ee37085db$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($56f47a2ee37085db$var$intern_get(this, key));
    }
    has(key) {
        return super.has($56f47a2ee37085db$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($56f47a2ee37085db$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($56f47a2ee37085db$var$intern_delete(this, key));
    }
}
module.exports.InternMap = $56f47a2ee37085db$var$InternMap;
class $56f47a2ee37085db$var$InternSet extends Set {
    constructor(values, key = $56f47a2ee37085db$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($56f47a2ee37085db$var$intern_get(this, value));
    }
    add(value) {
        return super.add($56f47a2ee37085db$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($56f47a2ee37085db$var$intern_delete(this, value));
    }
}
module.exports.InternSet = $56f47a2ee37085db$var$InternSet;
function $56f47a2ee37085db$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $56f47a2ee37085db$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $56f47a2ee37085db$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $56f47a2ee37085db$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRegister("8zLyq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $63e67ae60b71c777$var$identity;
function $63e67ae60b71c777$var$identity(x) {
    return x;
}

});


parcelRegister("g9Xbd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bc3b647cce9788a6$var$groupSort;

var $bc3b647cce9788a6$var$_ascending = $bc3b647cce9788a6$var$_interopRequireDefault((parcelRequire("42JXN")));

var $bc3b647cce9788a6$var$_group = $bc3b647cce9788a6$var$_interopRequireWildcard((parcelRequire("c1jhN")));

var $bc3b647cce9788a6$var$_sort = $bc3b647cce9788a6$var$_interopRequireDefault((parcelRequire("c5SM0")));
function $bc3b647cce9788a6$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($bc3b647cce9788a6$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $bc3b647cce9788a6$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $bc3b647cce9788a6$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $bc3b647cce9788a6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bc3b647cce9788a6$var$groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $bc3b647cce9788a6$var$_sort.default)((0, $bc3b647cce9788a6$var$_group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $bc3b647cce9788a6$var$_ascending.default)(av, bv) || (0, $bc3b647cce9788a6$var$_ascending.default)(ak, bk)) : (0, $bc3b647cce9788a6$var$_sort.default)((0, $bc3b647cce9788a6$var$_group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $bc3b647cce9788a6$var$_ascending.default)(ak, bk))).map(([key])=>key);
}

});
parcelRegister("c5SM0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ascendingDefined = $8ce0707f2a6c02b5$var$ascendingDefined;
module.exports.compareDefined = $8ce0707f2a6c02b5$var$compareDefined;
module.exports.default = $8ce0707f2a6c02b5$var$sort;

var $8ce0707f2a6c02b5$var$_ascending = $8ce0707f2a6c02b5$var$_interopRequireDefault((parcelRequire("42JXN")));

var $8ce0707f2a6c02b5$var$_permute = $8ce0707f2a6c02b5$var$_interopRequireDefault((parcelRequire("39H9X")));
function $8ce0707f2a6c02b5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8ce0707f2a6c02b5$var$sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $8ce0707f2a6c02b5$var$ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$8ce0707f2a6c02b5$var$ascendingDefined(f[i], f[j]));
        }
        return (0, $8ce0707f2a6c02b5$var$_permute.default)(values, index);
    }
    return values.sort($8ce0707f2a6c02b5$var$compareDefined(f));
}
function $8ce0707f2a6c02b5$var$compareDefined(compare = $8ce0707f2a6c02b5$var$_ascending.default) {
    if (compare === $8ce0707f2a6c02b5$var$_ascending.default) return $8ce0707f2a6c02b5$var$ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $8ce0707f2a6c02b5$var$ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRegister("39H9X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $24c3b0f3203412d9$var$permute;
function $24c3b0f3203412d9$var$permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRegister("cLuus", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $94b18691700bad11$var$bin;

var $8fPjY = parcelRequire("8fPjY");

var $94b18691700bad11$var$_bisect = $94b18691700bad11$var$_interopRequireDefault((parcelRequire("eiUsc")));

var $94b18691700bad11$var$_constant = $94b18691700bad11$var$_interopRequireDefault((parcelRequire("lWOD3")));

var $94b18691700bad11$var$_extent = $94b18691700bad11$var$_interopRequireDefault((parcelRequire("lRRFR")));

var $94b18691700bad11$var$_identity = $94b18691700bad11$var$_interopRequireDefault((parcelRequire("8zLyq")));

var $94b18691700bad11$var$_nice = $94b18691700bad11$var$_interopRequireDefault((parcelRequire("7mFci")));

var $94b18691700bad11$var$_ticks = $94b18691700bad11$var$_interopRequireWildcard((parcelRequire("5nk0u")));

var $94b18691700bad11$var$_sturges = $94b18691700bad11$var$_interopRequireDefault((parcelRequire("i7tuN")));
function $94b18691700bad11$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($94b18691700bad11$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $94b18691700bad11$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $94b18691700bad11$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $94b18691700bad11$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $94b18691700bad11$var$bin() {
    var value = $94b18691700bad11$var$_identity.default, domain = $94b18691700bad11$var$_extent.default, threshold = $94b18691700bad11$var$_sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === $94b18691700bad11$var$_extent.default) [x0, x1] = (0, $94b18691700bad11$var$_nice.default)(x0, x1, tn);
            tz = (0, $94b18691700bad11$var$_ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $94b18691700bad11$var$_ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === $94b18691700bad11$var$_extent.default) {
                    const step = (0, $94b18691700bad11$var$_ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        } // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin; // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        } // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $94b18691700bad11$var$_bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $94b18691700bad11$var$_constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $94b18691700bad11$var$_constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $94b18691700bad11$var$_constant.default)($8fPjY.slice.call(_)) : (0, $94b18691700bad11$var$_constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("8fPjY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slice = module.exports.map = void 0;
var $602788bdac406ac0$var$array = Array.prototype;
var $602788bdac406ac0$var$slice = $602788bdac406ac0$var$array.slice;
module.exports.slice = $602788bdac406ac0$var$slice;
var $602788bdac406ac0$var$map = $602788bdac406ac0$var$array.map;
module.exports.map = $602788bdac406ac0$var$map;

});

parcelRegister("lWOD3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ffa649a02a5bb3a3$var$constant;
function $ffa649a02a5bb3a3$var$constant(x) {
    return ()=>x;
}

});

parcelRegister("7mFci", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $55ca8b6e985ae2f5$var$nice;

var $5nk0u = parcelRequire("5nk0u");
function $55ca8b6e985ae2f5$var$nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $5nk0u.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRegister("5nk0u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3e9e9eb054d2a742$var$ticks;
module.exports.tickIncrement = $3e9e9eb054d2a742$var$tickIncrement;
module.exports.tickStep = $3e9e9eb054d2a742$var$tickStep;
var $3e9e9eb054d2a742$var$e10 = Math.sqrt(50), $3e9e9eb054d2a742$var$e5 = Math.sqrt(10), $3e9e9eb054d2a742$var$e2 = Math.sqrt(2);
function $3e9e9eb054d2a742$var$ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $3e9e9eb054d2a742$var$tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $3e9e9eb054d2a742$var$tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $3e9e9eb054d2a742$var$e10 ? 10 : error >= $3e9e9eb054d2a742$var$e5 ? 5 : error >= $3e9e9eb054d2a742$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $3e9e9eb054d2a742$var$e10 ? 10 : error >= $3e9e9eb054d2a742$var$e5 ? 5 : error >= $3e9e9eb054d2a742$var$e2 ? 2 : 1);
}
function $3e9e9eb054d2a742$var$tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $3e9e9eb054d2a742$var$e10) step1 *= 10;
    else if (error >= $3e9e9eb054d2a742$var$e5) step1 *= 5;
    else if (error >= $3e9e9eb054d2a742$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRegister("i7tuN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d30fc2ac2a08428f$var$thresholdSturges;

var $d30fc2ac2a08428f$var$_count = $d30fc2ac2a08428f$var$_interopRequireDefault((parcelRequire("ajdJT")));
function $d30fc2ac2a08428f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d30fc2ac2a08428f$var$thresholdSturges(values) {
    return Math.ceil(Math.log((0, $d30fc2ac2a08428f$var$_count.default)(values)) / Math.LN2) + 1;
}

});


parcelRegister("d1BC7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $97b88ba8a5b45d42$var$thresholdFreedmanDiaconis;

var $97b88ba8a5b45d42$var$_count = $97b88ba8a5b45d42$var$_interopRequireDefault((parcelRequire("ajdJT")));

var $97b88ba8a5b45d42$var$_quantile = $97b88ba8a5b45d42$var$_interopRequireDefault((parcelRequire("26KnF")));
function $97b88ba8a5b45d42$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $97b88ba8a5b45d42$var$thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $97b88ba8a5b45d42$var$_quantile.default)(values, 0.75) - (0, $97b88ba8a5b45d42$var$_quantile.default)(values, 0.25)) * Math.pow((0, $97b88ba8a5b45d42$var$_count.default)(values), -1 / 3)));
}

});
parcelRegister("26KnF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $18901e8b3a4fd0ff$var$quantile;
module.exports.quantileSorted = $18901e8b3a4fd0ff$var$quantileSorted;

var $18901e8b3a4fd0ff$var$_max = $18901e8b3a4fd0ff$var$_interopRequireDefault((parcelRequire("kHUkZ")));

var $18901e8b3a4fd0ff$var$_min = $18901e8b3a4fd0ff$var$_interopRequireDefault((parcelRequire("5raSG")));

var $18901e8b3a4fd0ff$var$_quickselect = $18901e8b3a4fd0ff$var$_interopRequireDefault((parcelRequire("3EDNm")));

var $18901e8b3a4fd0ff$var$_number = $18901e8b3a4fd0ff$var$_interopRequireWildcard((parcelRequire("gcfbT")));
function $18901e8b3a4fd0ff$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($18901e8b3a4fd0ff$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $18901e8b3a4fd0ff$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $18901e8b3a4fd0ff$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $18901e8b3a4fd0ff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $18901e8b3a4fd0ff$var$quantile(values, p, valueof) {
    values = Float64Array.from((0, $18901e8b3a4fd0ff$var$_number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $18901e8b3a4fd0ff$var$_min.default)(values);
    if (p >= 1) return (0, $18901e8b3a4fd0ff$var$_max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $18901e8b3a4fd0ff$var$_max.default)((0, $18901e8b3a4fd0ff$var$_quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $18901e8b3a4fd0ff$var$_min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $18901e8b3a4fd0ff$var$quantileSorted(values, p, valueof = $18901e8b3a4fd0ff$var$_number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRegister("kHUkZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f1338644b4c67516$var$max;
function $f1338644b4c67516$var$max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("5raSG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f57ea15fd4fa697$var$min;
function $3f57ea15fd4fa697$var$min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRegister("3EDNm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2a93f9ffa4634b87$var$quickselect;

var $c5SM0 = parcelRequire("c5SM0");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function $2a93f9ffa4634b87$var$quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? $c5SM0.ascendingDefined : (0, $c5SM0.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $2a93f9ffa4634b87$var$quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $2a93f9ffa4634b87$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $2a93f9ffa4634b87$var$swap(array, left, right);
        while(i < j){
            $2a93f9ffa4634b87$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $2a93f9ffa4634b87$var$swap(array, left, j);
        else ++j, $2a93f9ffa4634b87$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $2a93f9ffa4634b87$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRegister("6i8dH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $494acccde647e16c$var$thresholdScott;

var $494acccde647e16c$var$_count = $494acccde647e16c$var$_interopRequireDefault((parcelRequire("ajdJT")));

var $494acccde647e16c$var$_deviation = $494acccde647e16c$var$_interopRequireDefault((parcelRequire("7tsUa")));
function $494acccde647e16c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $494acccde647e16c$var$thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, $494acccde647e16c$var$_count.default)(values)) / (3.49 * (0, $494acccde647e16c$var$_deviation.default)(values)));
}

});

parcelRegister("draOj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9c862eb3e14f7f21$var$maxIndex;
function $9c862eb3e14f7f21$var$maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRegister("6DBgh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4d5349f5a83ddf13$var$mean;
function $4d5349f5a83ddf13$var$mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRegister("4HwgR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $36c435e6cfd0c994$var$median;

var $36c435e6cfd0c994$var$_quantile = $36c435e6cfd0c994$var$_interopRequireDefault((parcelRequire("26KnF")));
function $36c435e6cfd0c994$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $36c435e6cfd0c994$var$median(values, valueof) {
    return (0, $36c435e6cfd0c994$var$_quantile.default)(values, 0.5, valueof);
}

});

parcelRegister("gnNvC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bed532caf95c2cc1$var$merge;
function* $bed532caf95c2cc1$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $bed532caf95c2cc1$var$merge(arrays) {
    return Array.from($bed532caf95c2cc1$var$flatten(arrays));
}

});

parcelRegister("5nboE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3e97f0d92d44cfb5$var$minIndex;
function $3e97f0d92d44cfb5$var$minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRegister("asMhi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $79e1f7e990dab177$var$mode;

var $7sRhp = parcelRequire("7sRhp");
function $79e1f7e990dab177$var$mode(values, valueof) {
    const counts = new $7sRhp.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

});

parcelRegister("ir717", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d6c03112fa117caf$var$pairs;
module.exports.pair = $d6c03112fa117caf$var$pair;
function $d6c03112fa117caf$var$pairs(values, pairof = $d6c03112fa117caf$var$pair) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function $d6c03112fa117caf$var$pair(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRegister("hxxuu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cc4f7f4c7cafdf17$var$range;
function $cc4f7f4c7cafdf17$var$range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("2Koeh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2002ac11cfb6d638$var$rank;

var $2002ac11cfb6d638$var$_ascending = $2002ac11cfb6d638$var$_interopRequireDefault((parcelRequire("42JXN")));

var $c5SM0 = parcelRequire("c5SM0");
function $2002ac11cfb6d638$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2002ac11cfb6d638$var$rank(values, valueof = $2002ac11cfb6d638$var$_ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = $2002ac11cfb6d638$var$_ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === $2002ac11cfb6d638$var$_ascending.default ? (i, j)=>(0, $c5SM0.ascendingDefined)(V[i], V[j]) : (0, $c5SM0.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRegister("8ITro", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $659d7030edb20224$var$least;

var $659d7030edb20224$var$_ascending = $659d7030edb20224$var$_interopRequireDefault((parcelRequire("42JXN")));
function $659d7030edb20224$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $659d7030edb20224$var$least(values, compare = $659d7030edb20224$var$_ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $659d7030edb20224$var$_ascending.default)(value, minValue) < 0 : (0, $659d7030edb20224$var$_ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRegister("akUwn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $78679d96d8a8dfa8$var$leastIndex;

var $78679d96d8a8dfa8$var$_ascending = $78679d96d8a8dfa8$var$_interopRequireDefault((parcelRequire("42JXN")));

var $78679d96d8a8dfa8$var$_minIndex = $78679d96d8a8dfa8$var$_interopRequireDefault((parcelRequire("5nboE")));
function $78679d96d8a8dfa8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $78679d96d8a8dfa8$var$leastIndex(values, compare = $78679d96d8a8dfa8$var$_ascending.default) {
    if (compare.length === 1) return (0, $78679d96d8a8dfa8$var$_minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRegister("ldDLn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f729a7fb558b06cf$var$greatest;

var $f729a7fb558b06cf$var$_ascending = $f729a7fb558b06cf$var$_interopRequireDefault((parcelRequire("42JXN")));
function $f729a7fb558b06cf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f729a7fb558b06cf$var$greatest(values, compare = $f729a7fb558b06cf$var$_ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $f729a7fb558b06cf$var$_ascending.default)(value, maxValue) > 0 : (0, $f729a7fb558b06cf$var$_ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});

parcelRegister("6g8Yn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $48eb32837203911a$var$greatestIndex;

var $48eb32837203911a$var$_ascending = $48eb32837203911a$var$_interopRequireDefault((parcelRequire("42JXN")));

var $48eb32837203911a$var$_maxIndex = $48eb32837203911a$var$_interopRequireDefault((parcelRequire("draOj")));
function $48eb32837203911a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $48eb32837203911a$var$greatestIndex(values, compare = $48eb32837203911a$var$_ascending.default) {
    if (compare.length === 1) return (0, $48eb32837203911a$var$_maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRegister("lfHoP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f78ca9ea19eaeee4$var$scan;

var $f78ca9ea19eaeee4$var$_leastIndex = $f78ca9ea19eaeee4$var$_interopRequireDefault((parcelRequire("akUwn")));
function $f78ca9ea19eaeee4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f78ca9ea19eaeee4$var$scan(values, compare) {
    const index = (0, $f78ca9ea19eaeee4$var$_leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRegister("jL9vH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.shuffler = $e629c8a42e8bf302$var$shuffler;
var $e629c8a42e8bf302$var$_default = $e629c8a42e8bf302$var$shuffler(Math.random);
module.exports.default = $e629c8a42e8bf302$var$_default;
function $e629c8a42e8bf302$var$shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRegister("2zFIX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1dff3733b9c4bd4d$var$sum;
function $1dff3733b9c4bd4d$var$sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("lcJcg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f6fdc71f51d85f9f$var$transpose;

var $f6fdc71f51d85f9f$var$_min = $f6fdc71f51d85f9f$var$_interopRequireDefault((parcelRequire("5raSG")));
function $f6fdc71f51d85f9f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f6fdc71f51d85f9f$var$transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $f6fdc71f51d85f9f$var$_min.default)(matrix, $f6fdc71f51d85f9f$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $f6fdc71f51d85f9f$var$length(d) {
    return d.length;
}

});

parcelRegister("6s8G0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4b2c16983adf6c04$var$zip;

var $4b2c16983adf6c04$var$_transpose = $4b2c16983adf6c04$var$_interopRequireDefault((parcelRequire("lcJcg")));
function $4b2c16983adf6c04$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4b2c16983adf6c04$var$zip() {
    return (0, $4b2c16983adf6c04$var$_transpose.default)(arguments);
}

});

parcelRegister("4tbza", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3412d7ab2a2d2c83$var$every;
function $3412d7ab2a2d2c83$var$every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRegister("1clrJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0df78c3c85287a4f$var$some;
function $0df78c3c85287a4f$var$some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRegister("hR10Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cff82c72a5b8b509$var$filter;
function $cff82c72a5b8b509$var$filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRegister("akUza", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7867a68277e09c2f$var$map;
function $7867a68277e09c2f$var$map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRegister("h6YjS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c751c9725add00ba$var$reduce;
function $c751c9725add00ba$var$reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRegister("397w5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $24a80b0230cdfb4b$var$reverse;
function $24a80b0230cdfb4b$var$reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRegister("e1d1i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a34b4226c9d69ac9$var$difference;

var $7sRhp = parcelRequire("7sRhp");
function $a34b4226c9d69ac9$var$difference(values, ...others) {
    values = new $7sRhp.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRegister("fu4hi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b45cf9dd28454a0d$var$disjoint;

var $7sRhp = parcelRequire("7sRhp");
function $b45cf9dd28454a0d$var$disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new $7sRhp.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRegister("YVzQY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b72445c1f450e7c$var$intersection;

var $7sRhp = parcelRequire("7sRhp");
function $0b72445c1f450e7c$var$intersection(values, ...others) {
    values = new $7sRhp.InternSet(values);
    others = others.map($0b72445c1f450e7c$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $0b72445c1f450e7c$var$set(values) {
    return values instanceof $7sRhp.InternSet ? values : new $7sRhp.InternSet(values);
}

});

parcelRegister("fg75q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b1bdd8db4dd52b60$var$subset;

var $b1bdd8db4dd52b60$var$_superset = $b1bdd8db4dd52b60$var$_interopRequireDefault((parcelRequire("8D0Hg")));
function $b1bdd8db4dd52b60$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b1bdd8db4dd52b60$var$subset(values, other) {
    return (0, $b1bdd8db4dd52b60$var$_superset.default)(other, values);
}

});
parcelRegister("8D0Hg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6482819a31cea494$var$superset;
function $6482819a31cea494$var$superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $6482819a31cea494$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            const ivalue = $6482819a31cea494$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $6482819a31cea494$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRegister("aIUy7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7ce9e0f4038492e4$var$union;

var $7sRhp = parcelRequire("7sRhp");
function $7ce9e0f4038492e4$var$union(...others) {
    const set = new $7sRhp.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRegister("98nei", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initInterpolator = $6a66e152678b40cc$var$initInterpolator;
module.exports.initRange = $6a66e152678b40cc$var$initRange;
function $6a66e152678b40cc$var$initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $6a66e152678b40cc$var$initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("cndqj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $90220b9f6d3aba30$var$ordinal;
module.exports.implicit = void 0;

var $baM4h = parcelRequire("baM4h");

var $98nei = parcelRequire("98nei");
const $90220b9f6d3aba30$var$implicit = Symbol("implicit");
module.exports.implicit = $90220b9f6d3aba30$var$implicit;
function $90220b9f6d3aba30$var$ordinal() {
    var index = new $baM4h.InternMap(), domain = [], range = [], unknown = $90220b9f6d3aba30$var$implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $90220b9f6d3aba30$var$implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new $baM4h.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $90220b9f6d3aba30$var$ordinal(domain, range).unknown(unknown);
    };
    $98nei.initRange.apply(scale, arguments);
    return scale;
}

});


parcelRegister("5Hf98", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $425cb7a96912c4d8$var$identity;

var $hvSDx = parcelRequire("hvSDx");

var $425cb7a96912c4d8$var$_number = $425cb7a96912c4d8$var$_interopRequireDefault((parcelRequire("jerFr")));
function $425cb7a96912c4d8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $425cb7a96912c4d8$var$identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, $425cb7a96912c4d8$var$_number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $425cb7a96912c4d8$var$identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, $425cb7a96912c4d8$var$_number.default) : [
        0,
        1
    ];
    return (0, $hvSDx.linearish)(scale);
}

});
parcelRegister("hvSDx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cbffb6a56efcbb3c$var$linear;
module.exports.linearish = $cbffb6a56efcbb3c$var$linearish;

var $baM4h = parcelRequire("baM4h");

var $cbffb6a56efcbb3c$var$_continuous = $cbffb6a56efcbb3c$var$_interopRequireWildcard((parcelRequire("dTLbh")));

var $98nei = parcelRequire("98nei");

var $cbffb6a56efcbb3c$var$_tickFormat = $cbffb6a56efcbb3c$var$_interopRequireDefault((parcelRequire("3ZXxn")));
function $cbffb6a56efcbb3c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cbffb6a56efcbb3c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($cbffb6a56efcbb3c$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $cbffb6a56efcbb3c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $cbffb6a56efcbb3c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $cbffb6a56efcbb3c$var$linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $baM4h.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $cbffb6a56efcbb3c$var$_tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $baM4h.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $cbffb6a56efcbb3c$var$linear() {
    var scale = (0, $cbffb6a56efcbb3c$var$_continuous.default)();
    scale.copy = function() {
        return (0, $cbffb6a56efcbb3c$var$_continuous.copy)(scale, $cbffb6a56efcbb3c$var$linear());
    };
    $98nei.initRange.apply(scale, arguments);
    return $cbffb6a56efcbb3c$var$linearish(scale);
}

});
parcelRegister("dTLbh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $a1e5028e49e95242$var$copy;
module.exports.default = $a1e5028e49e95242$var$continuous;
module.exports.identity = $a1e5028e49e95242$var$identity;
module.exports.transformer = $a1e5028e49e95242$var$transformer;

var $baM4h = parcelRequire("baM4h");

var $665th = parcelRequire("665th");

var $a1e5028e49e95242$var$_constant = $a1e5028e49e95242$var$_interopRequireDefault((parcelRequire("jgTuH")));

var $a1e5028e49e95242$var$_number = $a1e5028e49e95242$var$_interopRequireDefault((parcelRequire("jerFr")));
function $a1e5028e49e95242$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a1e5028e49e95242$var$unit = [
    0,
    1
];
function $a1e5028e49e95242$var$identity(x) {
    return x;
}
function $a1e5028e49e95242$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $a1e5028e49e95242$var$_constant.default)(isNaN(b) ? NaN : 0.5);
}
function $a1e5028e49e95242$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $a1e5028e49e95242$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $a1e5028e49e95242$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $a1e5028e49e95242$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $a1e5028e49e95242$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1; // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $a1e5028e49e95242$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $baM4h.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $a1e5028e49e95242$var$copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $a1e5028e49e95242$var$transformer() {
    var domain = $a1e5028e49e95242$var$unit, range = $a1e5028e49e95242$var$unit, interpolate = $665th.interpolate, transform, untransform, unknown, clamp = $a1e5028e49e95242$var$identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $a1e5028e49e95242$var$identity) clamp = $a1e5028e49e95242$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $a1e5028e49e95242$var$polymap : $a1e5028e49e95242$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), $665th.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, $a1e5028e49e95242$var$_number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = $665th.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $a1e5028e49e95242$var$identity, rescale()) : clamp !== $a1e5028e49e95242$var$identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $a1e5028e49e95242$var$continuous() {
    return $a1e5028e49e95242$var$transformer()($a1e5028e49e95242$var$identity, $a1e5028e49e95242$var$identity);
}

});
parcelRegister("665th", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interpolate", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_value.default;
    }
});
Object.defineProperty(module.exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_array.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_cubehelix.cubehelixLong;
    }
});
Object.defineProperty(module.exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_date.default;
    }
});
Object.defineProperty(module.exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_discrete.default;
    }
});
Object.defineProperty(module.exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_hcl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_hcl.hclLong;
    }
});
Object.defineProperty(module.exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_hsl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_hsl.hslLong;
    }
});
Object.defineProperty(module.exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_hue.default;
    }
});
Object.defineProperty(module.exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_number.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_numberArray.default;
    }
});
Object.defineProperty(module.exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_object.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_rgb.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_rgb.rgbBasis;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_rgb.rgbBasisClosed;
    }
});
Object.defineProperty(module.exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_round.default;
    }
});
Object.defineProperty(module.exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_string.default;
    }
});
Object.defineProperty(module.exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return $O407u.interpolateTransformCss;
    }
});
Object.defineProperty(module.exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return $O407u.interpolateTransformSvg;
    }
});
Object.defineProperty(module.exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_zoom.default;
    }
});
Object.defineProperty(module.exports, "piecewise", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_piecewise.default;
    }
});
Object.defineProperty(module.exports, "quantize", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_quantize.default;
    }
});

var $47078c155d673c7c$var$_value = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("k8gaa")));

var $47078c155d673c7c$var$_array = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("c2a7V")));

var $47078c155d673c7c$var$_basis = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("hurAB")));

var $47078c155d673c7c$var$_basisClosed = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("7JEhq")));

var $47078c155d673c7c$var$_date = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("ck059")));

var $47078c155d673c7c$var$_discrete = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("9bEkd")));

var $47078c155d673c7c$var$_hue = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("gPZC5")));

var $47078c155d673c7c$var$_number = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("4TXx0")));

var $47078c155d673c7c$var$_numberArray = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("4Xtub")));

var $47078c155d673c7c$var$_object = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("eWQsD")));

var $47078c155d673c7c$var$_round = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("1qcvW")));

var $47078c155d673c7c$var$_string = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("aQhro")));

var $O407u = parcelRequire("O407u");

var $47078c155d673c7c$var$_zoom = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("4ymTx")));

var $47078c155d673c7c$var$_rgb = $47078c155d673c7c$var$_interopRequireWildcard((parcelRequire("3CWNZ")));

var $47078c155d673c7c$var$_hsl = $47078c155d673c7c$var$_interopRequireWildcard((parcelRequire("h8Xdb")));

var $47078c155d673c7c$var$_lab = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("6bPgS")));

var $47078c155d673c7c$var$_hcl = $47078c155d673c7c$var$_interopRequireWildcard((parcelRequire("dWbd5")));

var $47078c155d673c7c$var$_cubehelix = $47078c155d673c7c$var$_interopRequireWildcard((parcelRequire("1chdf")));

var $47078c155d673c7c$var$_piecewise = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("1d2kq")));

var $47078c155d673c7c$var$_quantize = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("7rbIB")));
function $47078c155d673c7c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($47078c155d673c7c$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $47078c155d673c7c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $47078c155d673c7c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $47078c155d673c7c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("k8gaa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ea8117a067b5834a$var$_default;

var $4xVlj = parcelRequire("4xVlj");

var $ea8117a067b5834a$var$_rgb = $ea8117a067b5834a$var$_interopRequireDefault((parcelRequire("3CWNZ")));

var $c2a7V = parcelRequire("c2a7V");

var $ea8117a067b5834a$var$_date = $ea8117a067b5834a$var$_interopRequireDefault((parcelRequire("ck059")));

var $ea8117a067b5834a$var$_number = $ea8117a067b5834a$var$_interopRequireDefault((parcelRequire("4TXx0")));

var $ea8117a067b5834a$var$_object = $ea8117a067b5834a$var$_interopRequireDefault((parcelRequire("eWQsD")));

var $ea8117a067b5834a$var$_string = $ea8117a067b5834a$var$_interopRequireDefault((parcelRequire("aQhro")));

var $ea8117a067b5834a$var$_constant = $ea8117a067b5834a$var$_interopRequireDefault((parcelRequire("iRCSk")));

var $ea8117a067b5834a$var$_numberArray = $ea8117a067b5834a$var$_interopRequireWildcard((parcelRequire("4Xtub")));
function $ea8117a067b5834a$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ea8117a067b5834a$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ea8117a067b5834a$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ea8117a067b5834a$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $ea8117a067b5834a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ea8117a067b5834a$var$_default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $ea8117a067b5834a$var$_constant.default)(b) : (t === "number" ? $ea8117a067b5834a$var$_number.default : t === "string" ? (c = (0, $4xVlj.color)(b)) ? (b = c, $ea8117a067b5834a$var$_rgb.default) : $ea8117a067b5834a$var$_string.default : b instanceof $4xVlj.color ? $ea8117a067b5834a$var$_rgb.default : b instanceof Date ? $ea8117a067b5834a$var$_date.default : (0, $ea8117a067b5834a$var$_numberArray.isNumberArray)(b) ? $ea8117a067b5834a$var$_numberArray.default : Array.isArray(b) ? $c2a7V.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? $ea8117a067b5834a$var$_object.default : $ea8117a067b5834a$var$_number.default)(a, b);
}

});
parcelRegister("4xVlj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function() {
        return $34f6b991f3373171$var$_color.default;
    }
});
Object.defineProperty(module.exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return $34f6b991f3373171$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "gray", {
    enumerable: true,
    get: function() {
        return $34f6b991f3373171$var$_lab.gray;
    }
});
Object.defineProperty(module.exports, "hcl", {
    enumerable: true,
    get: function() {
        return $34f6b991f3373171$var$_lab.hcl;
    }
});
Object.defineProperty(module.exports, "hsl", {
    enumerable: true,
    get: function() {
        return $34f6b991f3373171$var$_color.hsl;
    }
});
Object.defineProperty(module.exports, "lab", {
    enumerable: true,
    get: function() {
        return $34f6b991f3373171$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "lch", {
    enumerable: true,
    get: function() {
        return $34f6b991f3373171$var$_lab.lch;
    }
});
Object.defineProperty(module.exports, "rgb", {
    enumerable: true,
    get: function() {
        return $34f6b991f3373171$var$_color.rgb;
    }
});

var $34f6b991f3373171$var$_color = $34f6b991f3373171$var$_interopRequireWildcard((parcelRequire("hCN5L")));

var $34f6b991f3373171$var$_lab = $34f6b991f3373171$var$_interopRequireWildcard((parcelRequire("9xOfl")));

var $34f6b991f3373171$var$_cubehelix = $34f6b991f3373171$var$_interopRequireDefault((parcelRequire("45fUy")));
function $34f6b991f3373171$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $34f6b991f3373171$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($34f6b991f3373171$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $34f6b991f3373171$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $34f6b991f3373171$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("hCN5L", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;

var _define = _interopRequireWildcard((parcelRequire("4Ivzr")));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function Color() {}
var darker = 0.7;
exports.darker = darker;
var brighter = 1 / darker;
exports.brighter = brighter;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("4Ivzr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $36f3c2bb271333d6$var$_default;
module.exports.extend = $36f3c2bb271333d6$var$extend;
function $36f3c2bb271333d6$var$_default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $36f3c2bb271333d6$var$extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("9xOfl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hcl = $6f2e2c04ae38a42e$var$Hcl;
module.exports.Lab = $6f2e2c04ae38a42e$var$Lab;
module.exports.default = $6f2e2c04ae38a42e$var$lab;
module.exports.gray = $6f2e2c04ae38a42e$var$gray;
module.exports.hcl = $6f2e2c04ae38a42e$var$hcl;
module.exports.lch = $6f2e2c04ae38a42e$var$lch;

var $6f2e2c04ae38a42e$var$_define = $6f2e2c04ae38a42e$var$_interopRequireWildcard((parcelRequire("4Ivzr")));

var $hCN5L = parcelRequire("hCN5L");

var $hPqOe = parcelRequire("hPqOe");
function $6f2e2c04ae38a42e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($6f2e2c04ae38a42e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $6f2e2c04ae38a42e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $6f2e2c04ae38a42e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const $6f2e2c04ae38a42e$var$K = 18, $6f2e2c04ae38a42e$var$Xn = 0.96422, $6f2e2c04ae38a42e$var$Yn = 1, $6f2e2c04ae38a42e$var$Zn = 0.82521, $6f2e2c04ae38a42e$var$t0 = 4 / 29, $6f2e2c04ae38a42e$var$t1 = 6 / 29, $6f2e2c04ae38a42e$var$t2 = 3 * $6f2e2c04ae38a42e$var$t1 * $6f2e2c04ae38a42e$var$t1, $6f2e2c04ae38a42e$var$t3 = $6f2e2c04ae38a42e$var$t1 * $6f2e2c04ae38a42e$var$t1 * $6f2e2c04ae38a42e$var$t1;
function $6f2e2c04ae38a42e$var$labConvert(o) {
    if (o instanceof $6f2e2c04ae38a42e$var$Lab) return new $6f2e2c04ae38a42e$var$Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof $6f2e2c04ae38a42e$var$Hcl) return $6f2e2c04ae38a42e$var$hcl2lab(o);
    if (!(o instanceof $hCN5L.Rgb)) o = (0, $hCN5L.rgbConvert)(o);
    var r = $6f2e2c04ae38a42e$var$rgb2lrgb(o.r), g = $6f2e2c04ae38a42e$var$rgb2lrgb(o.g), b = $6f2e2c04ae38a42e$var$rgb2lrgb(o.b), y = $6f2e2c04ae38a42e$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $6f2e2c04ae38a42e$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $6f2e2c04ae38a42e$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $6f2e2c04ae38a42e$var$Xn);
        z = $6f2e2c04ae38a42e$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $6f2e2c04ae38a42e$var$Zn);
    }
    return new $6f2e2c04ae38a42e$var$Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $6f2e2c04ae38a42e$var$gray(l, opacity) {
    return new $6f2e2c04ae38a42e$var$Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function $6f2e2c04ae38a42e$var$lab(l, a, b, opacity) {
    return arguments.length === 1 ? $6f2e2c04ae38a42e$var$labConvert(l) : new $6f2e2c04ae38a42e$var$Lab(l, a, b, opacity == null ? 1 : opacity);
}
function $6f2e2c04ae38a42e$var$Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $6f2e2c04ae38a42e$var$_define.default)($6f2e2c04ae38a42e$var$Lab, $6f2e2c04ae38a42e$var$lab, (0, $6f2e2c04ae38a42e$var$_define.extend)($hCN5L.Color, {
    brighter (k) {
        return new $6f2e2c04ae38a42e$var$Lab(this.l + $6f2e2c04ae38a42e$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $6f2e2c04ae38a42e$var$Lab(this.l - $6f2e2c04ae38a42e$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $6f2e2c04ae38a42e$var$Xn * $6f2e2c04ae38a42e$var$lab2xyz(x);
        y = $6f2e2c04ae38a42e$var$Yn * $6f2e2c04ae38a42e$var$lab2xyz(y);
        z = $6f2e2c04ae38a42e$var$Zn * $6f2e2c04ae38a42e$var$lab2xyz(z);
        return new $hCN5L.Rgb($6f2e2c04ae38a42e$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $6f2e2c04ae38a42e$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $6f2e2c04ae38a42e$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $6f2e2c04ae38a42e$var$xyz2lab(t) {
    return t > $6f2e2c04ae38a42e$var$t3 ? Math.pow(t, 1 / 3) : t / $6f2e2c04ae38a42e$var$t2 + $6f2e2c04ae38a42e$var$t0;
}
function $6f2e2c04ae38a42e$var$lab2xyz(t) {
    return t > $6f2e2c04ae38a42e$var$t1 ? t * t * t : $6f2e2c04ae38a42e$var$t2 * (t - $6f2e2c04ae38a42e$var$t0);
}
function $6f2e2c04ae38a42e$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $6f2e2c04ae38a42e$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $6f2e2c04ae38a42e$var$hclConvert(o) {
    if (o instanceof $6f2e2c04ae38a42e$var$Hcl) return new $6f2e2c04ae38a42e$var$Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $6f2e2c04ae38a42e$var$Lab)) o = $6f2e2c04ae38a42e$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $6f2e2c04ae38a42e$var$Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * $hPqOe.degrees;
    return new $6f2e2c04ae38a42e$var$Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $6f2e2c04ae38a42e$var$lch(l, c, h, opacity) {
    return arguments.length === 1 ? $6f2e2c04ae38a42e$var$hclConvert(l) : new $6f2e2c04ae38a42e$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $6f2e2c04ae38a42e$var$hcl(h, c, l, opacity) {
    return arguments.length === 1 ? $6f2e2c04ae38a42e$var$hclConvert(h) : new $6f2e2c04ae38a42e$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $6f2e2c04ae38a42e$var$Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $6f2e2c04ae38a42e$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $6f2e2c04ae38a42e$var$Lab(o.l, 0, 0, o.opacity);
    var h = o.h * $hPqOe.radians;
    return new $6f2e2c04ae38a42e$var$Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $6f2e2c04ae38a42e$var$_define.default)($6f2e2c04ae38a42e$var$Hcl, $6f2e2c04ae38a42e$var$hcl, (0, $6f2e2c04ae38a42e$var$_define.extend)($hCN5L.Color, {
    brighter (k) {
        return new $6f2e2c04ae38a42e$var$Hcl(this.h, this.c, this.l + $6f2e2c04ae38a42e$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $6f2e2c04ae38a42e$var$Hcl(this.h, this.c, this.l - $6f2e2c04ae38a42e$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $6f2e2c04ae38a42e$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("hPqOe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radians = module.exports.degrees = void 0;
const $cfabfed4d344b6c6$var$radians = Math.PI / 180;
module.exports.radians = $cfabfed4d344b6c6$var$radians;
const $cfabfed4d344b6c6$var$degrees = 180 / Math.PI;
module.exports.degrees = $cfabfed4d344b6c6$var$degrees;

});


parcelRegister("45fUy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cubehelix = $2f93f8ad649541d1$var$Cubehelix;
module.exports.default = $2f93f8ad649541d1$var$cubehelix;

var $2f93f8ad649541d1$var$_define = $2f93f8ad649541d1$var$_interopRequireWildcard((parcelRequire("4Ivzr")));

var $hCN5L = parcelRequire("hCN5L");

var $hPqOe = parcelRequire("hPqOe");
function $2f93f8ad649541d1$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($2f93f8ad649541d1$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $2f93f8ad649541d1$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $2f93f8ad649541d1$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $2f93f8ad649541d1$var$A = -0.14861, $2f93f8ad649541d1$var$B = 1.78277, $2f93f8ad649541d1$var$C = -0.29227, $2f93f8ad649541d1$var$D = -0.90649, $2f93f8ad649541d1$var$E = 1.97294, $2f93f8ad649541d1$var$ED = $2f93f8ad649541d1$var$E * $2f93f8ad649541d1$var$D, $2f93f8ad649541d1$var$EB = $2f93f8ad649541d1$var$E * $2f93f8ad649541d1$var$B, $2f93f8ad649541d1$var$BC_DA = $2f93f8ad649541d1$var$B * $2f93f8ad649541d1$var$C - $2f93f8ad649541d1$var$D * $2f93f8ad649541d1$var$A;
function $2f93f8ad649541d1$var$cubehelixConvert(o) {
    if (o instanceof $2f93f8ad649541d1$var$Cubehelix) return new $2f93f8ad649541d1$var$Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $hCN5L.Rgb)) o = (0, $hCN5L.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($2f93f8ad649541d1$var$BC_DA * b + $2f93f8ad649541d1$var$ED * r - $2f93f8ad649541d1$var$EB * g) / ($2f93f8ad649541d1$var$BC_DA + $2f93f8ad649541d1$var$ED - $2f93f8ad649541d1$var$EB), bl = b - l, k = ($2f93f8ad649541d1$var$E * (g - l) - $2f93f8ad649541d1$var$C * bl) / $2f93f8ad649541d1$var$D, s = Math.sqrt(k * k + bl * bl) / ($2f93f8ad649541d1$var$E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * $hPqOe.degrees - 120 : NaN;
    return new $2f93f8ad649541d1$var$Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $2f93f8ad649541d1$var$cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? $2f93f8ad649541d1$var$cubehelixConvert(h) : new $2f93f8ad649541d1$var$Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function $2f93f8ad649541d1$var$Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $2f93f8ad649541d1$var$_define.default)($2f93f8ad649541d1$var$Cubehelix, $2f93f8ad649541d1$var$cubehelix, (0, $2f93f8ad649541d1$var$_define.extend)($hCN5L.Color, {
    brighter (k) {
        k = k == null ? $hCN5L.brighter : Math.pow($hCN5L.brighter, k);
        return new $2f93f8ad649541d1$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $hCN5L.darker : Math.pow($hCN5L.darker, k);
        return new $2f93f8ad649541d1$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * $hPqOe.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new $hCN5L.Rgb(255 * (l + a * ($2f93f8ad649541d1$var$A * cosh + $2f93f8ad649541d1$var$B * sinh)), 255 * (l + a * ($2f93f8ad649541d1$var$C * cosh + $2f93f8ad649541d1$var$D * sinh)), 255 * (l + a * ($2f93f8ad649541d1$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("3CWNZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rgbBasisClosed = module.exports.rgbBasis = module.exports.default = void 0;

var $4xVlj = parcelRequire("4xVlj");

var $2a428938b73abdd0$var$_basis = $2a428938b73abdd0$var$_interopRequireDefault((parcelRequire("hurAB")));

var $2a428938b73abdd0$var$_basisClosed = $2a428938b73abdd0$var$_interopRequireDefault((parcelRequire("7JEhq")));

var $2a428938b73abdd0$var$_color = $2a428938b73abdd0$var$_interopRequireWildcard((parcelRequire("b3Scd")));
function $2a428938b73abdd0$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($2a428938b73abdd0$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $2a428938b73abdd0$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $2a428938b73abdd0$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $2a428938b73abdd0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2a428938b73abdd0$var$_default = function rgbGamma(y) {
    var color = (0, $2a428938b73abdd0$var$_color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $4xVlj.rgb)(start)).r, (end = (0, $4xVlj.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $2a428938b73abdd0$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
module.exports.default = $2a428938b73abdd0$var$_default;
function $2a428938b73abdd0$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $4xVlj.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $2a428938b73abdd0$var$rgbBasis = $2a428938b73abdd0$var$rgbSpline($2a428938b73abdd0$var$_basis.default);
module.exports.rgbBasis = $2a428938b73abdd0$var$rgbBasis;
var $2a428938b73abdd0$var$rgbBasisClosed = $2a428938b73abdd0$var$rgbSpline($2a428938b73abdd0$var$_basisClosed.default);
module.exports.rgbBasisClosed = $2a428938b73abdd0$var$rgbBasisClosed;

});
parcelRegister("hurAB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.basis = $cbbaa3aa677f5a3b$var$basis;
module.exports.default = $cbbaa3aa677f5a3b$var$_default;
function $cbbaa3aa677f5a3b$var$basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $cbbaa3aa677f5a3b$var$_default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $cbbaa3aa677f5a3b$var$basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("7JEhq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5a1bfb292f547c5a$var$_default;

var $hurAB = parcelRequire("hurAB");
function $5a1bfb292f547c5a$var$_default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $hurAB.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("b3Scd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $80da03bd38d34502$var$nogamma;
module.exports.gamma = $80da03bd38d34502$var$gamma;
module.exports.hue = $80da03bd38d34502$var$hue;

var $80da03bd38d34502$var$_constant = $80da03bd38d34502$var$_interopRequireDefault((parcelRequire("iRCSk")));
function $80da03bd38d34502$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $80da03bd38d34502$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $80da03bd38d34502$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $80da03bd38d34502$var$hue(a, b) {
    var d = b - a;
    return d ? $80da03bd38d34502$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $80da03bd38d34502$var$_constant.default)(isNaN(a) ? b : a);
}
function $80da03bd38d34502$var$gamma(y) {
    return (y = +y) === 1 ? $80da03bd38d34502$var$nogamma : function(a, b) {
        return b - a ? $80da03bd38d34502$var$exponential(a, b, y) : (0, $80da03bd38d34502$var$_constant.default)(isNaN(a) ? b : a);
    };
}
function $80da03bd38d34502$var$nogamma(a, b) {
    var d = b - a;
    return d ? $80da03bd38d34502$var$linear(a, d) : (0, $80da03bd38d34502$var$_constant.default)(isNaN(a) ? b : a);
}

});
parcelRegister("iRCSk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $dbbb550bf3b8cf75$var$_default = (x)=>()=>x;
module.exports.default = $dbbb550bf3b8cf75$var$_default;

});



parcelRegister("c2a7V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c2d86ed32487c0d$var$_default;
module.exports.genericArray = $8c2d86ed32487c0d$var$genericArray;

var $8c2d86ed32487c0d$var$_value = $8c2d86ed32487c0d$var$_interopRequireDefault((parcelRequire("k8gaa")));

var $8c2d86ed32487c0d$var$_numberArray = $8c2d86ed32487c0d$var$_interopRequireWildcard((parcelRequire("4Xtub")));
function $8c2d86ed32487c0d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8c2d86ed32487c0d$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8c2d86ed32487c0d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8c2d86ed32487c0d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8c2d86ed32487c0d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8c2d86ed32487c0d$var$_default(a, b) {
    return ((0, $8c2d86ed32487c0d$var$_numberArray.isNumberArray)(b) ? $8c2d86ed32487c0d$var$_numberArray.default : $8c2d86ed32487c0d$var$genericArray)(a, b);
}
function $8c2d86ed32487c0d$var$genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $8c2d86ed32487c0d$var$_value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("4Xtub", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $39c38b6190d0c1f6$var$_default;
module.exports.isNumberArray = $39c38b6190d0c1f6$var$isNumberArray;
function $39c38b6190d0c1f6$var$_default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $39c38b6190d0c1f6$var$isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("ck059", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8f876a9bd8834a98$var$_default;
function $8f876a9bd8834a98$var$_default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("4TXx0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $391a7a2535dd71f8$var$_default;
function $391a7a2535dd71f8$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("eWQsD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ae1f2d19cc5303ea$var$_default;

var $ae1f2d19cc5303ea$var$_value = $ae1f2d19cc5303ea$var$_interopRequireDefault((parcelRequire("k8gaa")));
function $ae1f2d19cc5303ea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ae1f2d19cc5303ea$var$_default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $ae1f2d19cc5303ea$var$_value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("aQhro", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7e4c4a1e1697197c$var$_default;

var $7e4c4a1e1697197c$var$_number = $7e4c4a1e1697197c$var$_interopRequireDefault((parcelRequire("4TXx0")));
function $7e4c4a1e1697197c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7e4c4a1e1697197c$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $7e4c4a1e1697197c$var$reB = new RegExp($7e4c4a1e1697197c$var$reA.source, "g");
function $7e4c4a1e1697197c$var$zero(b) {
    return function() {
        return b;
    };
}
function $7e4c4a1e1697197c$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $7e4c4a1e1697197c$var$_default(a, b) {
    var bi = $7e4c4a1e1697197c$var$reA.lastIndex = $7e4c4a1e1697197c$var$reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.
    while((am = $7e4c4a1e1697197c$var$reA.exec(a)) && (bm = $7e4c4a1e1697197c$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $7e4c4a1e1697197c$var$_number.default)(am, bm)
            });
        }
        bi = $7e4c4a1e1697197c$var$reB.lastIndex;
    } // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $7e4c4a1e1697197c$var$one(q[0].x) : $7e4c4a1e1697197c$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("9bEkd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6b046bd8ca223f2b$var$_default;
function $6b046bd8ca223f2b$var$_default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRegister("gPZC5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c42133e20db58540$var$_default;

var $b3Scd = parcelRequire("b3Scd");
function $c42133e20db58540$var$_default(a, b) {
    var i = (0, $b3Scd.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRegister("1qcvW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1091ed2fd6f93976$var$_default;
function $1091ed2fd6f93976$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("O407u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTransformSvg = module.exports.interpolateTransformCss = void 0;

var $0967c620c111940e$var$_number = $0967c620c111940e$var$_interopRequireDefault((parcelRequire("4TXx0")));

var $bJ37r = parcelRequire("bJ37r");
function $0967c620c111940e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0967c620c111940e$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $0967c620c111940e$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $0967c620c111940e$var$_number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $0967c620c111940e$var$_number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $0967c620c111940e$var$_number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $0967c620c111940e$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $0967c620c111940e$var$_number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $0967c620c111940e$var$interpolateTransformCss = $0967c620c111940e$var$interpolateTransform($bJ37r.parseCss, "px, ", "px)", "deg)");
module.exports.interpolateTransformCss = $0967c620c111940e$var$interpolateTransformCss;
var $0967c620c111940e$var$interpolateTransformSvg = $0967c620c111940e$var$interpolateTransform($bJ37r.parseSvg, ", ", ")", ")");
module.exports.interpolateTransformSvg = $0967c620c111940e$var$interpolateTransformSvg;

});
parcelRegister("bJ37r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCss = $8896510fbfd72d82$var$parseCss;
module.exports.parseSvg = $8896510fbfd72d82$var$parseSvg;

var $8896510fbfd72d82$var$_decompose = $8896510fbfd72d82$var$_interopRequireWildcard((parcelRequire("5pgbl")));
function $8896510fbfd72d82$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8896510fbfd72d82$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8896510fbfd72d82$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8896510fbfd72d82$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $8896510fbfd72d82$var$svgNode;
/* eslint-disable no-undef */ function $8896510fbfd72d82$var$parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? $8896510fbfd72d82$var$_decompose.identity : (0, $8896510fbfd72d82$var$_decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $8896510fbfd72d82$var$parseSvg(value) {
    if (value == null) return $8896510fbfd72d82$var$_decompose.identity;
    if (!$8896510fbfd72d82$var$svgNode) $8896510fbfd72d82$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $8896510fbfd72d82$var$svgNode.setAttribute("transform", value);
    if (!(value = $8896510fbfd72d82$var$svgNode.transform.baseVal.consolidate())) return $8896510fbfd72d82$var$_decompose.identity;
    value = value.matrix;
    return (0, $8896510fbfd72d82$var$_decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("5pgbl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3efbd6f206ca181f$var$_default;
module.exports.identity = void 0;
var $3efbd6f206ca181f$var$degrees = 180 / Math.PI;
var $3efbd6f206ca181f$var$identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
module.exports.identity = $3efbd6f206ca181f$var$identity;
function $3efbd6f206ca181f$var$_default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $3efbd6f206ca181f$var$degrees,
        skewX: Math.atan(skewX) * $3efbd6f206ca181f$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("4ymTx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $350c18cead77b4c8$var$epsilon2 = 1e-12;
function $350c18cead77b4c8$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $350c18cead77b4c8$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $350c18cead77b4c8$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $350c18cead77b4c8$var$_default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S; // Special case for u0 ≅ u1.
        if (d2 < $350c18cead77b4c8$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $350c18cead77b4c8$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $350c18cead77b4c8$var$tanh(rho * s + r0) - $350c18cead77b4c8$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $350c18cead77b4c8$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);
module.exports.default = $350c18cead77b4c8$var$_default;

});

parcelRegister("h8Xdb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hslLong = module.exports.default = void 0;

var $4xVlj = parcelRequire("4xVlj");

var $c7b11d37ff7aa7ad$var$_color = $c7b11d37ff7aa7ad$var$_interopRequireWildcard((parcelRequire("b3Scd")));
function $c7b11d37ff7aa7ad$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c7b11d37ff7aa7ad$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c7b11d37ff7aa7ad$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c7b11d37ff7aa7ad$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $c7b11d37ff7aa7ad$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $4xVlj.hsl)(start)).h, (end = (0, $4xVlj.hsl)(end)).h), s = (0, $c7b11d37ff7aa7ad$var$_color.default)(start.s, end.s), l = (0, $c7b11d37ff7aa7ad$var$_color.default)(start.l, end.l), opacity = (0, $c7b11d37ff7aa7ad$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $c7b11d37ff7aa7ad$var$_default = $c7b11d37ff7aa7ad$var$hsl($c7b11d37ff7aa7ad$var$_color.hue);
module.exports.default = $c7b11d37ff7aa7ad$var$_default;
var $c7b11d37ff7aa7ad$var$hslLong = $c7b11d37ff7aa7ad$var$hsl($c7b11d37ff7aa7ad$var$_color.default);
module.exports.hslLong = $c7b11d37ff7aa7ad$var$hslLong;

});

parcelRegister("6bPgS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $481b8a88abe10bce$var$lab;

var $4xVlj = parcelRequire("4xVlj");

var $481b8a88abe10bce$var$_color = $481b8a88abe10bce$var$_interopRequireDefault((parcelRequire("b3Scd")));
function $481b8a88abe10bce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $481b8a88abe10bce$var$lab(start, end) {
    var l = (0, $481b8a88abe10bce$var$_color.default)((start = (0, $4xVlj.lab)(start)).l, (end = (0, $4xVlj.lab)(end)).l), a = (0, $481b8a88abe10bce$var$_color.default)(start.a, end.a), b = (0, $481b8a88abe10bce$var$_color.default)(start.b, end.b), opacity = (0, $481b8a88abe10bce$var$_color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRegister("dWbd5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hclLong = module.exports.default = void 0;

var $4xVlj = parcelRequire("4xVlj");

var $a259633f8ae92865$var$_color = $a259633f8ae92865$var$_interopRequireWildcard((parcelRequire("b3Scd")));
function $a259633f8ae92865$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a259633f8ae92865$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a259633f8ae92865$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a259633f8ae92865$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $a259633f8ae92865$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $4xVlj.hcl)(start)).h, (end = (0, $4xVlj.hcl)(end)).h), c = (0, $a259633f8ae92865$var$_color.default)(start.c, end.c), l = (0, $a259633f8ae92865$var$_color.default)(start.l, end.l), opacity = (0, $a259633f8ae92865$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $a259633f8ae92865$var$_default = $a259633f8ae92865$var$hcl($a259633f8ae92865$var$_color.hue);
module.exports.default = $a259633f8ae92865$var$_default;
var $a259633f8ae92865$var$hclLong = $a259633f8ae92865$var$hcl($a259633f8ae92865$var$_color.default);
module.exports.hclLong = $a259633f8ae92865$var$hclLong;

});

parcelRegister("1chdf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.cubehelixLong = void 0;

var $4xVlj = parcelRequire("4xVlj");

var $0df4438370b2da5e$var$_color = $0df4438370b2da5e$var$_interopRequireWildcard((parcelRequire("b3Scd")));
function $0df4438370b2da5e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($0df4438370b2da5e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $0df4438370b2da5e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $0df4438370b2da5e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $0df4438370b2da5e$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $4xVlj.cubehelix)(start)).h, (end = (0, $4xVlj.cubehelix)(end)).h), s = (0, $0df4438370b2da5e$var$_color.default)(start.s, end.s), l = (0, $0df4438370b2da5e$var$_color.default)(start.l, end.l), opacity = (0, $0df4438370b2da5e$var$_color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $0df4438370b2da5e$var$_default = $0df4438370b2da5e$var$cubehelix($0df4438370b2da5e$var$_color.hue);
module.exports.default = $0df4438370b2da5e$var$_default;
var $0df4438370b2da5e$var$cubehelixLong = $0df4438370b2da5e$var$cubehelix($0df4438370b2da5e$var$_color.default);
module.exports.cubehelixLong = $0df4438370b2da5e$var$cubehelixLong;

});

parcelRegister("1d2kq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0e18cfb4c16c4104$var$piecewise;

var $0e18cfb4c16c4104$var$_value = $0e18cfb4c16c4104$var$_interopRequireDefault((parcelRequire("k8gaa")));
function $0e18cfb4c16c4104$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0e18cfb4c16c4104$var$piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = $0e18cfb4c16c4104$var$_value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("7rbIB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $56a425076c517cf9$var$_default;
function $56a425076c517cf9$var$_default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("jgTuH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e07a8ef03a1474be$var$constants;
function $e07a8ef03a1474be$var$constants(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("jerFr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e004c94f2a5276f3$var$number;
function $e004c94f2a5276f3$var$number(x) {
    return +x;
}

});


parcelRegister("3ZXxn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2e954078d0c875a8$var$tickFormat;

var $baM4h = parcelRequire("baM4h");

var $itzmc = parcelRequire("itzmc");
function $2e954078d0c875a8$var$tickFormat(start, stop, count, specifier) {
    var step = (0, $baM4h.tickStep)(start, stop, count), precision;
    specifier = (0, $itzmc.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $itzmc.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, $itzmc.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $itzmc.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $itzmc.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $itzmc.format)(specifier);
}

});
parcelRegister("itzmc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(module.exports, "format", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_defaultLocale.format;
    }
});
Object.defineProperty(module.exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_defaultLocale.formatPrefix;
    }
});
Object.defineProperty(module.exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_formatSpecifier.default;
    }
});
Object.defineProperty(module.exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_precisionFixed.default;
    }
});
Object.defineProperty(module.exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_precisionPrefix.default;
    }
});
Object.defineProperty(module.exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_precisionRound.default;
    }
});

var $d7365c9f4c120e49$var$_defaultLocale = $d7365c9f4c120e49$var$_interopRequireWildcard((parcelRequire("52crh")));

var $d7365c9f4c120e49$var$_locale = $d7365c9f4c120e49$var$_interopRequireDefault((parcelRequire("jdHNs")));

var $d7365c9f4c120e49$var$_formatSpecifier = $d7365c9f4c120e49$var$_interopRequireWildcard((parcelRequire("22nPw")));

var $d7365c9f4c120e49$var$_precisionFixed = $d7365c9f4c120e49$var$_interopRequireDefault((parcelRequire("lzwe8")));

var $d7365c9f4c120e49$var$_precisionPrefix = $d7365c9f4c120e49$var$_interopRequireDefault((parcelRequire("9ymIQ")));

var $d7365c9f4c120e49$var$_precisionRound = $d7365c9f4c120e49$var$_interopRequireDefault((parcelRequire("dK8tE")));
function $d7365c9f4c120e49$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d7365c9f4c120e49$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d7365c9f4c120e49$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d7365c9f4c120e49$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d7365c9f4c120e49$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("52crh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3aa6c9ca8743f64c$var$defaultLocale;
module.exports.formatPrefix = module.exports.format = void 0;

var $3aa6c9ca8743f64c$var$_locale = $3aa6c9ca8743f64c$var$_interopRequireDefault((parcelRequire("jdHNs")));
function $3aa6c9ca8743f64c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3aa6c9ca8743f64c$var$locale;
var $3aa6c9ca8743f64c$var$format;
module.exports.format = $3aa6c9ca8743f64c$var$format;
var $3aa6c9ca8743f64c$var$formatPrefix;
module.exports.formatPrefix = $3aa6c9ca8743f64c$var$formatPrefix;
$3aa6c9ca8743f64c$var$defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $3aa6c9ca8743f64c$var$defaultLocale(definition) {
    $3aa6c9ca8743f64c$var$locale = (0, $3aa6c9ca8743f64c$var$_locale.default)(definition);
    module.exports.format = $3aa6c9ca8743f64c$var$format = $3aa6c9ca8743f64c$var$locale.format;
    module.exports.formatPrefix = $3aa6c9ca8743f64c$var$formatPrefix = $3aa6c9ca8743f64c$var$locale.formatPrefix;
    return $3aa6c9ca8743f64c$var$locale;
}

});
parcelRegister("jdHNs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dfe1345305b146cd$var$_default;

var $dfe1345305b146cd$var$_exponent = $dfe1345305b146cd$var$_interopRequireDefault((parcelRequire("9WmdL")));

var $dfe1345305b146cd$var$_formatGroup = $dfe1345305b146cd$var$_interopRequireDefault((parcelRequire("bR58D")));

var $dfe1345305b146cd$var$_formatNumerals = $dfe1345305b146cd$var$_interopRequireDefault((parcelRequire("2gEYt")));

var $dfe1345305b146cd$var$_formatSpecifier = $dfe1345305b146cd$var$_interopRequireDefault((parcelRequire("22nPw")));

var $dfe1345305b146cd$var$_formatTrim = $dfe1345305b146cd$var$_interopRequireDefault((parcelRequire("sIRm4")));

var $dfe1345305b146cd$var$_formatTypes = $dfe1345305b146cd$var$_interopRequireDefault((parcelRequire("9AK8c")));

var $csczD = parcelRequire("csczD");

var $dfe1345305b146cd$var$_identity = $dfe1345305b146cd$var$_interopRequireDefault((parcelRequire("jJFZc")));
function $dfe1345305b146cd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $dfe1345305b146cd$var$map = Array.prototype.map, $dfe1345305b146cd$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $dfe1345305b146cd$var$_default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? $dfe1345305b146cd$var$_identity.default : (0, $dfe1345305b146cd$var$_formatGroup.default)($dfe1345305b146cd$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? $dfe1345305b146cd$var$_identity.default : (0, $dfe1345305b146cd$var$_formatNumerals.default)($dfe1345305b146cd$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $dfe1345305b146cd$var$_formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type; // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
        else if (!$dfe1345305b146cd$var$_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = $dfe1345305b146cd$var$_formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.
                if (trim) value = (0, $dfe1345305b146cd$var$_formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $dfe1345305b146cd$var$prefixes[8 + $csczD.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            } // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity); // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $dfe1345305b146cd$var$_formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $dfe1345305b146cd$var$_exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $dfe1345305b146cd$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("9WmdL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $73cac4781972bb68$var$_default;

var $ek6ef = parcelRequire("ek6ef");
function $73cac4781972bb68$var$_default(x) {
    return x = (0, $ek6ef.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("ek6ef", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a6d7c3d6a68b9f55$var$_default;
module.exports.formatDecimalParts = $a6d7c3d6a68b9f55$var$formatDecimalParts;
function $a6d7c3d6a68b9f55$var$_default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function $a6d7c3d6a68b9f55$var$formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("bR58D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8a18a14b4c6d5ad1$var$_default;
function $8a18a14b4c6d5ad1$var$_default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("2gEYt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1a6cdc0d667ac473$var$_default;
function $1a6cdc0d667ac473$var$_default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("22nPw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatSpecifier = $17be40d45524154b$var$FormatSpecifier;
module.exports.default = $17be40d45524154b$var$formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $17be40d45524154b$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $17be40d45524154b$var$formatSpecifier(specifier) {
    if (!(match = $17be40d45524154b$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $17be40d45524154b$var$FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$17be40d45524154b$var$formatSpecifier.prototype = $17be40d45524154b$var$FormatSpecifier.prototype; // instanceof
function $17be40d45524154b$var$FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$17be40d45524154b$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("sIRm4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $056569d07d5aff33$var$_default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $056569d07d5aff33$var$_default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("9AK8c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6fbb428c1ef09695$var$_formatDecimal = $6fbb428c1ef09695$var$_interopRequireDefault((parcelRequire("ek6ef")));

var $6fbb428c1ef09695$var$_formatPrefixAuto = $6fbb428c1ef09695$var$_interopRequireDefault((parcelRequire("csczD")));

var $6fbb428c1ef09695$var$_formatRounded = $6fbb428c1ef09695$var$_interopRequireDefault((parcelRequire("lNpva")));
function $6fbb428c1ef09695$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6fbb428c1ef09695$var$_default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": $6fbb428c1ef09695$var$_formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $6fbb428c1ef09695$var$_formatRounded.default)(x * 100, p),
    "r": $6fbb428c1ef09695$var$_formatRounded.default,
    "s": $6fbb428c1ef09695$var$_formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};
module.exports.default = $6fbb428c1ef09695$var$_default;

});
parcelRegister("csczD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9111da6de56a44e7$var$_default;
module.exports.prefixExponent = void 0;

var $ek6ef = parcelRequire("ek6ef");
var $9111da6de56a44e7$var$prefixExponent;
module.exports.prefixExponent = $9111da6de56a44e7$var$prefixExponent;
function $9111da6de56a44e7$var$_default(x, p) {
    var d = (0, $ek6ef.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (module.exports.prefixExponent = $9111da6de56a44e7$var$prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $ek6ef.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("lNpva", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fde1f4b20b992562$var$_default;

var $ek6ef = parcelRequire("ek6ef");
function $fde1f4b20b992562$var$_default(x, p) {
    var d = (0, $ek6ef.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("jJFZc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e5e2c9e09981bca9$var$_default;
function $e5e2c9e09981bca9$var$_default(x) {
    return x;
}

});



parcelRegister("lzwe8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fb45dd7ad9d5b52f$var$_default;

var $fb45dd7ad9d5b52f$var$_exponent = $fb45dd7ad9d5b52f$var$_interopRequireDefault((parcelRequire("9WmdL")));
function $fb45dd7ad9d5b52f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fb45dd7ad9d5b52f$var$_default(step) {
    return Math.max(0, -(0, $fb45dd7ad9d5b52f$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("9ymIQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6f48ea33e817f9e5$var$_default;

var $6f48ea33e817f9e5$var$_exponent = $6f48ea33e817f9e5$var$_interopRequireDefault((parcelRequire("9WmdL")));
function $6f48ea33e817f9e5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6f48ea33e817f9e5$var$_default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $6f48ea33e817f9e5$var$_exponent.default)(value) / 3))) * 3 - (0, $6f48ea33e817f9e5$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("dK8tE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a01625a8f580c632$var$_default;

var $a01625a8f580c632$var$_exponent = $a01625a8f580c632$var$_interopRequireDefault((parcelRequire("9WmdL")));
function $a01625a8f580c632$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a01625a8f580c632$var$_default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $a01625a8f580c632$var$_exponent.default)(max) - (0, $a01625a8f580c632$var$_exponent.default)(step)) + 1;
}

});





parcelRegister("aEI3x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7c1fd0730f0c3a86$var$log;
module.exports.loggish = $7c1fd0730f0c3a86$var$loggish;

var $baM4h = parcelRequire("baM4h");

var $itzmc = parcelRequire("itzmc");

var $7c1fd0730f0c3a86$var$_nice = $7c1fd0730f0c3a86$var$_interopRequireDefault((parcelRequire("3CPJt")));

var $dTLbh = parcelRequire("dTLbh");

var $98nei = parcelRequire("98nei");
function $7c1fd0730f0c3a86$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7c1fd0730f0c3a86$var$transformLog(x) {
    return Math.log(x);
}
function $7c1fd0730f0c3a86$var$transformExp(x) {
    return Math.exp(x);
}
function $7c1fd0730f0c3a86$var$transformLogn(x) {
    return -Math.log(-x);
}
function $7c1fd0730f0c3a86$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $7c1fd0730f0c3a86$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $7c1fd0730f0c3a86$var$powp(base) {
    return base === 10 ? $7c1fd0730f0c3a86$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $7c1fd0730f0c3a86$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $7c1fd0730f0c3a86$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $7c1fd0730f0c3a86$var$loggish(transform) {
    const scale = transform($7c1fd0730f0c3a86$var$transformLog, $7c1fd0730f0c3a86$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $7c1fd0730f0c3a86$var$logp(base), pows = $7c1fd0730f0c3a86$var$powp(base);
        if (domain()[0] < 0) {
            logs = $7c1fd0730f0c3a86$var$reflect(logs), pows = $7c1fd0730f0c3a86$var$reflect(pows);
            transform($7c1fd0730f0c3a86$var$transformLogn, $7c1fd0730f0c3a86$var$transformExpn);
        } else transform($7c1fd0730f0c3a86$var$transformLog, $7c1fd0730f0c3a86$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $baM4h.ticks)(u, v, n);
        } else z = (0, $baM4h.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $itzmc.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $itzmc.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $7c1fd0730f0c3a86$var$_nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $7c1fd0730f0c3a86$var$log() {
    const scale = $7c1fd0730f0c3a86$var$loggish((0, $dTLbh.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $dTLbh.copy)(scale, $7c1fd0730f0c3a86$var$log()).base(scale.base());
    $98nei.initRange.apply(scale, arguments);
    return scale;
}

});
parcelRegister("3CPJt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2a3d0cb2bab01a48$var$nice;
function $2a3d0cb2bab01a48$var$nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("bzrFz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $86c86d2b217611f5$var$symlog;
module.exports.symlogish = $86c86d2b217611f5$var$symlogish;

var $hvSDx = parcelRequire("hvSDx");

var $dTLbh = parcelRequire("dTLbh");

var $98nei = parcelRequire("98nei");
function $86c86d2b217611f5$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $86c86d2b217611f5$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $86c86d2b217611f5$var$symlogish(transform) {
    var c = 1, scale = transform($86c86d2b217611f5$var$transformSymlog(c), $86c86d2b217611f5$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($86c86d2b217611f5$var$transformSymlog(c = +_), $86c86d2b217611f5$var$transformSymexp(c)) : c;
    };
    return (0, $hvSDx.linearish)(scale);
}
function $86c86d2b217611f5$var$symlog() {
    var scale = $86c86d2b217611f5$var$symlogish((0, $dTLbh.transformer)());
    scale.copy = function() {
        return (0, $dTLbh.copy)(scale, $86c86d2b217611f5$var$symlog()).constant(scale.constant());
    };
    return $98nei.initRange.apply(scale, arguments);
}

});

parcelRegister("cpAbf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9093e282c6b6bc7f$var$pow;
module.exports.powish = $9093e282c6b6bc7f$var$powish;
module.exports.sqrt = $9093e282c6b6bc7f$var$sqrt;

var $hvSDx = parcelRequire("hvSDx");

var $dTLbh = parcelRequire("dTLbh");

var $98nei = parcelRequire("98nei");
function $9093e282c6b6bc7f$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $9093e282c6b6bc7f$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $9093e282c6b6bc7f$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $9093e282c6b6bc7f$var$powish(transform) {
    var scale = transform($dTLbh.identity, $dTLbh.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform($dTLbh.identity, $dTLbh.identity) : exponent === 0.5 ? transform($9093e282c6b6bc7f$var$transformSqrt, $9093e282c6b6bc7f$var$transformSquare) : transform($9093e282c6b6bc7f$var$transformPow(exponent), $9093e282c6b6bc7f$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $hvSDx.linearish)(scale);
}
function $9093e282c6b6bc7f$var$pow() {
    var scale = $9093e282c6b6bc7f$var$powish((0, $dTLbh.transformer)());
    scale.copy = function() {
        return (0, $dTLbh.copy)(scale, $9093e282c6b6bc7f$var$pow()).exponent(scale.exponent());
    };
    $98nei.initRange.apply(scale, arguments);
    return scale;
}
function $9093e282c6b6bc7f$var$sqrt() {
    return $9093e282c6b6bc7f$var$pow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("5lxEG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3e4905273b67de17$var$radial;

var $3e4905273b67de17$var$_continuous = $3e4905273b67de17$var$_interopRequireDefault((parcelRequire("dTLbh")));

var $98nei = parcelRequire("98nei");

var $hvSDx = parcelRequire("hvSDx");

var $3e4905273b67de17$var$_number = $3e4905273b67de17$var$_interopRequireDefault((parcelRequire("jerFr")));
function $3e4905273b67de17$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3e4905273b67de17$var$square(x) {
    return Math.sign(x) * x * x;
}
function $3e4905273b67de17$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $3e4905273b67de17$var$radial() {
    var squared = (0, $3e4905273b67de17$var$_continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $3e4905273b67de17$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($3e4905273b67de17$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, $3e4905273b67de17$var$_number.default)).map($3e4905273b67de17$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $3e4905273b67de17$var$radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    $98nei.initRange.apply(scale, arguments);
    return (0, $hvSDx.linearish)(scale);
}

});

parcelRegister("67PVh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $475bac569bb46018$var$quantile;

var $baM4h = parcelRequire("baM4h");

var $98nei = parcelRequire("98nei");
function $475bac569bb46018$var$quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $baM4h.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $baM4h.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($baM4h.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $475bac569bb46018$var$quantile().domain(domain).range(range).unknown(unknown);
    };
    return $98nei.initRange.apply(scale, arguments);
}

});

parcelRegister("mgOAc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $042f19449e73ffae$var$quantize;

var $baM4h = parcelRequire("baM4h");

var $hvSDx = parcelRequire("hvSDx");

var $98nei = parcelRequire("98nei");
function $042f19449e73ffae$var$quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $baM4h.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $042f19449e73ffae$var$quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return $98nei.initRange.apply((0, $hvSDx.linearish)(scale), arguments);
}

});

parcelRegister("g6ge9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bb89cb437536b92a$var$threshold;

var $baM4h = parcelRequire("baM4h");

var $98nei = parcelRequire("98nei");
function $bb89cb437536b92a$var$threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $baM4h.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $bb89cb437536b92a$var$threshold().domain(domain).range(range).unknown(unknown);
    };
    return $98nei.initRange.apply(scale, arguments);
}

});

parcelRegister("617BV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = $4618bd65b703261b$var$calendar;
module.exports.default = $4618bd65b703261b$var$time;

var $kym6t = parcelRequire("kym6t");

var $2qXVT = parcelRequire("2qXVT");

var $4618bd65b703261b$var$_continuous = $4618bd65b703261b$var$_interopRequireWildcard((parcelRequire("dTLbh")));

var $98nei = parcelRequire("98nei");

var $4618bd65b703261b$var$_nice = $4618bd65b703261b$var$_interopRequireDefault((parcelRequire("3CPJt")));
function $4618bd65b703261b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4618bd65b703261b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($4618bd65b703261b$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $4618bd65b703261b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4618bd65b703261b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $4618bd65b703261b$var$date(t) {
    return new Date(t);
}
function $4618bd65b703261b$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $4618bd65b703261b$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $4618bd65b703261b$var$_continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $4618bd65b703261b$var$number)) : domain().map($4618bd65b703261b$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $4618bd65b703261b$var$_nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $4618bd65b703261b$var$_continuous.copy)(scale, $4618bd65b703261b$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $4618bd65b703261b$var$time() {
    return $98nei.initRange.apply($4618bd65b703261b$var$calendar($kym6t.timeTicks, $kym6t.timeTickInterval, $kym6t.timeYear, $kym6t.timeMonth, $kym6t.timeWeek, $kym6t.timeDay, $kym6t.timeHour, $kym6t.timeMinute, $kym6t.timeSecond, $2qXVT.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("kym6t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "timeDay", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_day.default;
    }
});
Object.defineProperty(module.exports, "timeDays", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_day.days;
    }
});
Object.defineProperty(module.exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return $exwcm.friday;
    }
});
Object.defineProperty(module.exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return $exwcm.fridays;
    }
});
Object.defineProperty(module.exports, "timeHour", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_hour.default;
    }
});
Object.defineProperty(module.exports, "timeHours", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_hour.hours;
    }
});
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_minute.default;
    }
});
Object.defineProperty(module.exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_minute.minutes;
    }
});
Object.defineProperty(module.exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return $exwcm.monday;
    }
});
Object.defineProperty(module.exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return $exwcm.mondays;
    }
});
Object.defineProperty(module.exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_month.default;
    }
});
Object.defineProperty(module.exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_month.months;
    }
});
Object.defineProperty(module.exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return $exwcm.saturday;
    }
});
Object.defineProperty(module.exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return $exwcm.saturdays;
    }
});
Object.defineProperty(module.exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_second.default;
    }
});
Object.defineProperty(module.exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return $exwcm.sunday;
    }
});
Object.defineProperty(module.exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return $exwcm.sundays;
    }
});
Object.defineProperty(module.exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return $exwcm.thursday;
    }
});
Object.defineProperty(module.exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return $exwcm.thursdays;
    }
});
Object.defineProperty(module.exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return $c02Yy.timeTickInterval;
    }
});
Object.defineProperty(module.exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return $c02Yy.timeTicks;
    }
});
Object.defineProperty(module.exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return $exwcm.tuesday;
    }
});
Object.defineProperty(module.exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return $exwcm.tuesdays;
    }
});
Object.defineProperty(module.exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return $exwcm.wednesday;
    }
});
Object.defineProperty(module.exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return $exwcm.wednesdays;
    }
});
Object.defineProperty(module.exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return $exwcm.sunday;
    }
});
Object.defineProperty(module.exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return $exwcm.sundays;
    }
});
Object.defineProperty(module.exports, "timeYear", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_year.default;
    }
});
Object.defineProperty(module.exports, "timeYears", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_year.years;
    }
});
Object.defineProperty(module.exports, "utcDay", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcDay.default;
    }
});
Object.defineProperty(module.exports, "utcDays", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcDay.utcDays;
    }
});
Object.defineProperty(module.exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcFriday;
    }
});
Object.defineProperty(module.exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcFridays;
    }
});
Object.defineProperty(module.exports, "utcHour", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcHour.default;
    }
});
Object.defineProperty(module.exports, "utcHours", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcHour.utcHours;
    }
});
Object.defineProperty(module.exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcMinute.default;
    }
});
Object.defineProperty(module.exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcMinute.utcMinutes;
    }
});
Object.defineProperty(module.exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcMonday;
    }
});
Object.defineProperty(module.exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcMondays;
    }
});
Object.defineProperty(module.exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcMonth.default;
    }
});
Object.defineProperty(module.exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcMonth.utcMonths;
    }
});
Object.defineProperty(module.exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcSaturday;
    }
});
Object.defineProperty(module.exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcSaturdays;
    }
});
Object.defineProperty(module.exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_second.default;
    }
});
Object.defineProperty(module.exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcThursday;
    }
});
Object.defineProperty(module.exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcThursdays;
    }
});
Object.defineProperty(module.exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return $c02Yy.utcTickInterval;
    }
});
Object.defineProperty(module.exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return $c02Yy.utcTicks;
    }
});
Object.defineProperty(module.exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcTuesday;
    }
});
Object.defineProperty(module.exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcTuesdays;
    }
});
Object.defineProperty(module.exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcWednesday;
    }
});
Object.defineProperty(module.exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcWednesdays;
    }
});
Object.defineProperty(module.exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcYear", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcYear.default;
    }
});
Object.defineProperty(module.exports, "utcYears", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcYear.utcYears;
    }
});

var $ef6820ebdc1f168f$var$_interval = $ef6820ebdc1f168f$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $ef6820ebdc1f168f$var$_millisecond = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("hRCmg")));

var $ef6820ebdc1f168f$var$_second = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("jFJeY")));

var $ef6820ebdc1f168f$var$_minute = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("izQ7P")));

var $ef6820ebdc1f168f$var$_hour = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("4kq4i")));

var $ef6820ebdc1f168f$var$_day = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("kSMPp")));

var $exwcm = parcelRequire("exwcm");

var $ef6820ebdc1f168f$var$_month = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("4YFnz")));

var $ef6820ebdc1f168f$var$_year = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("lzVRI")));

var $ef6820ebdc1f168f$var$_utcMinute = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("9FVE8")));

var $ef6820ebdc1f168f$var$_utcHour = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("4wGkR")));

var $ef6820ebdc1f168f$var$_utcDay = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("i3XOj")));

var $kSPvm = parcelRequire("kSPvm");

var $ef6820ebdc1f168f$var$_utcMonth = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("9ILJ1")));

var $ef6820ebdc1f168f$var$_utcYear = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("4hSHL")));

var $c02Yy = parcelRequire("c02Yy");
function $ef6820ebdc1f168f$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ef6820ebdc1f168f$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ef6820ebdc1f168f$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ef6820ebdc1f168f$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $ef6820ebdc1f168f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("bSxHc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8a5ee026fcfc7249$var$newInterval;
var $8a5ee026fcfc7249$var$t0 = new Date(), $8a5ee026fcfc7249$var$t1 = new Date();
function $8a5ee026fcfc7249$var$newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $8a5ee026fcfc7249$var$newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $8a5ee026fcfc7249$var$t0.setTime(+start), $8a5ee026fcfc7249$var$t1.setTime(+end);
            floori($8a5ee026fcfc7249$var$t0), floori($8a5ee026fcfc7249$var$t1);
            return Math.floor(count($8a5ee026fcfc7249$var$t0, $8a5ee026fcfc7249$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("hRCmg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.milliseconds = module.exports.default = void 0;

var $d0152406c3f5521e$var$_interval = $d0152406c3f5521e$var$_interopRequireDefault((parcelRequire("bSxHc")));
function $d0152406c3f5521e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d0152406c3f5521e$var$millisecond = (0, $d0152406c3f5521e$var$_interval.default)(function() {}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
}); // An optimized implementation for this simple case.
$d0152406c3f5521e$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $d0152406c3f5521e$var$millisecond;
    return (0, $d0152406c3f5521e$var$_interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $d0152406c3f5521e$var$_default = $d0152406c3f5521e$var$millisecond;
module.exports.default = $d0152406c3f5521e$var$_default;
var $d0152406c3f5521e$var$milliseconds = $d0152406c3f5521e$var$millisecond.range;
module.exports.milliseconds = $d0152406c3f5521e$var$milliseconds;

});

parcelRegister("jFJeY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seconds = module.exports.default = void 0;

var $e524f07ae6002e66$var$_interval = $e524f07ae6002e66$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $e524f07ae6002e66$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e524f07ae6002e66$var$second = (0, $e524f07ae6002e66$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * $188mN.durationSecond);
}, function(start, end) {
    return (end - start) / $188mN.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var $e524f07ae6002e66$var$_default = $e524f07ae6002e66$var$second;
module.exports.default = $e524f07ae6002e66$var$_default;
var $e524f07ae6002e66$var$seconds = $e524f07ae6002e66$var$second.range;
module.exports.seconds = $e524f07ae6002e66$var$seconds;

});
parcelRegister("188mN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.durationYear = module.exports.durationWeek = module.exports.durationSecond = module.exports.durationMonth = module.exports.durationMinute = module.exports.durationHour = module.exports.durationDay = void 0;
const $0d2d073c443f27b5$var$durationSecond = 1000;
module.exports.durationSecond = $0d2d073c443f27b5$var$durationSecond;
const $0d2d073c443f27b5$var$durationMinute = $0d2d073c443f27b5$var$durationSecond * 60;
module.exports.durationMinute = $0d2d073c443f27b5$var$durationMinute;
const $0d2d073c443f27b5$var$durationHour = $0d2d073c443f27b5$var$durationMinute * 60;
module.exports.durationHour = $0d2d073c443f27b5$var$durationHour;
const $0d2d073c443f27b5$var$durationDay = $0d2d073c443f27b5$var$durationHour * 24;
module.exports.durationDay = $0d2d073c443f27b5$var$durationDay;
const $0d2d073c443f27b5$var$durationWeek = $0d2d073c443f27b5$var$durationDay * 7;
module.exports.durationWeek = $0d2d073c443f27b5$var$durationWeek;
const $0d2d073c443f27b5$var$durationMonth = $0d2d073c443f27b5$var$durationDay * 30;
module.exports.durationMonth = $0d2d073c443f27b5$var$durationMonth;
const $0d2d073c443f27b5$var$durationYear = $0d2d073c443f27b5$var$durationDay * 365;
module.exports.durationYear = $0d2d073c443f27b5$var$durationYear;

});


parcelRegister("izQ7P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minutes = module.exports.default = void 0;

var $d863eddd69e079ff$var$_interval = $d863eddd69e079ff$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $d863eddd69e079ff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d863eddd69e079ff$var$minute = (0, $d863eddd69e079ff$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $188mN.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * $188mN.durationMinute);
}, function(start, end) {
    return (end - start) / $188mN.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var $d863eddd69e079ff$var$_default = $d863eddd69e079ff$var$minute;
module.exports.default = $d863eddd69e079ff$var$_default;
var $d863eddd69e079ff$var$minutes = $d863eddd69e079ff$var$minute.range;
module.exports.minutes = $d863eddd69e079ff$var$minutes;

});

parcelRegister("4kq4i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hours = module.exports.default = void 0;

var $326d404cf7731152$var$_interval = $326d404cf7731152$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $326d404cf7731152$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $326d404cf7731152$var$hour = (0, $326d404cf7731152$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $188mN.durationSecond - date.getMinutes() * $188mN.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * $188mN.durationHour);
}, function(start, end) {
    return (end - start) / $188mN.durationHour;
}, function(date) {
    return date.getHours();
});
var $326d404cf7731152$var$_default = $326d404cf7731152$var$hour;
module.exports.default = $326d404cf7731152$var$_default;
var $326d404cf7731152$var$hours = $326d404cf7731152$var$hour.range;
module.exports.hours = $326d404cf7731152$var$hours;

});

parcelRegister("kSMPp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.days = void 0;

var $f33eba0c8fefd714$var$_interval = $f33eba0c8fefd714$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $f33eba0c8fefd714$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f33eba0c8fefd714$var$day = (0, $f33eba0c8fefd714$var$_interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $188mN.durationMinute) / $188mN.durationDay, (date)=>date.getDate() - 1);
var $f33eba0c8fefd714$var$_default = $f33eba0c8fefd714$var$day;
module.exports.default = $f33eba0c8fefd714$var$_default;
var $f33eba0c8fefd714$var$days = $f33eba0c8fefd714$var$day.range;
module.exports.days = $f33eba0c8fefd714$var$days;

});

parcelRegister("exwcm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wednesdays = module.exports.wednesday = module.exports.tuesdays = module.exports.tuesday = module.exports.thursdays = module.exports.thursday = module.exports.sundays = module.exports.sunday = module.exports.saturdays = module.exports.saturday = module.exports.mondays = module.exports.monday = module.exports.fridays = module.exports.friday = void 0;

var $a95d1fb36d555b21$var$_interval = $a95d1fb36d555b21$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $a95d1fb36d555b21$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a95d1fb36d555b21$var$weekday(i) {
    return (0, $a95d1fb36d555b21$var$_interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $188mN.durationMinute) / $188mN.durationWeek;
    });
}
var $a95d1fb36d555b21$var$sunday = $a95d1fb36d555b21$var$weekday(0);
module.exports.sunday = $a95d1fb36d555b21$var$sunday;
var $a95d1fb36d555b21$var$monday = $a95d1fb36d555b21$var$weekday(1);
module.exports.monday = $a95d1fb36d555b21$var$monday;
var $a95d1fb36d555b21$var$tuesday = $a95d1fb36d555b21$var$weekday(2);
module.exports.tuesday = $a95d1fb36d555b21$var$tuesday;
var $a95d1fb36d555b21$var$wednesday = $a95d1fb36d555b21$var$weekday(3);
module.exports.wednesday = $a95d1fb36d555b21$var$wednesday;
var $a95d1fb36d555b21$var$thursday = $a95d1fb36d555b21$var$weekday(4);
module.exports.thursday = $a95d1fb36d555b21$var$thursday;
var $a95d1fb36d555b21$var$friday = $a95d1fb36d555b21$var$weekday(5);
module.exports.friday = $a95d1fb36d555b21$var$friday;
var $a95d1fb36d555b21$var$saturday = $a95d1fb36d555b21$var$weekday(6);
module.exports.saturday = $a95d1fb36d555b21$var$saturday;
var $a95d1fb36d555b21$var$sundays = $a95d1fb36d555b21$var$sunday.range;
module.exports.sundays = $a95d1fb36d555b21$var$sundays;
var $a95d1fb36d555b21$var$mondays = $a95d1fb36d555b21$var$monday.range;
module.exports.mondays = $a95d1fb36d555b21$var$mondays;
var $a95d1fb36d555b21$var$tuesdays = $a95d1fb36d555b21$var$tuesday.range;
module.exports.tuesdays = $a95d1fb36d555b21$var$tuesdays;
var $a95d1fb36d555b21$var$wednesdays = $a95d1fb36d555b21$var$wednesday.range;
module.exports.wednesdays = $a95d1fb36d555b21$var$wednesdays;
var $a95d1fb36d555b21$var$thursdays = $a95d1fb36d555b21$var$thursday.range;
module.exports.thursdays = $a95d1fb36d555b21$var$thursdays;
var $a95d1fb36d555b21$var$fridays = $a95d1fb36d555b21$var$friday.range;
module.exports.fridays = $a95d1fb36d555b21$var$fridays;
var $a95d1fb36d555b21$var$saturdays = $a95d1fb36d555b21$var$saturday.range;
module.exports.saturdays = $a95d1fb36d555b21$var$saturdays;

});

parcelRegister("4YFnz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.months = module.exports.default = void 0;

var $39fcdd0c8c747959$var$_interval = $39fcdd0c8c747959$var$_interopRequireDefault((parcelRequire("bSxHc")));
function $39fcdd0c8c747959$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $39fcdd0c8c747959$var$month = (0, $39fcdd0c8c747959$var$_interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $39fcdd0c8c747959$var$_default = $39fcdd0c8c747959$var$month;
module.exports.default = $39fcdd0c8c747959$var$_default;
var $39fcdd0c8c747959$var$months = $39fcdd0c8c747959$var$month.range;
module.exports.months = $39fcdd0c8c747959$var$months;

});

parcelRegister("lzVRI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.years = module.exports.default = void 0;

var $fb59c0bdd551f11c$var$_interval = $fb59c0bdd551f11c$var$_interopRequireDefault((parcelRequire("bSxHc")));
function $fb59c0bdd551f11c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $fb59c0bdd551f11c$var$year = (0, $fb59c0bdd551f11c$var$_interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
}); // An optimized implementation for this simple case.
$fb59c0bdd551f11c$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $fb59c0bdd551f11c$var$_interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $fb59c0bdd551f11c$var$_default = $fb59c0bdd551f11c$var$year;
module.exports.default = $fb59c0bdd551f11c$var$_default;
var $fb59c0bdd551f11c$var$years = $fb59c0bdd551f11c$var$year.range;
module.exports.years = $fb59c0bdd551f11c$var$years;

});

parcelRegister("9FVE8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMinutes = module.exports.default = void 0;

var $70b4a8c4dc5c94df$var$_interval = $70b4a8c4dc5c94df$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $70b4a8c4dc5c94df$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $70b4a8c4dc5c94df$var$utcMinute = (0, $70b4a8c4dc5c94df$var$_interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * $188mN.durationMinute);
}, function(start, end) {
    return (end - start) / $188mN.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var $70b4a8c4dc5c94df$var$_default = $70b4a8c4dc5c94df$var$utcMinute;
module.exports.default = $70b4a8c4dc5c94df$var$_default;
var $70b4a8c4dc5c94df$var$utcMinutes = $70b4a8c4dc5c94df$var$utcMinute.range;
module.exports.utcMinutes = $70b4a8c4dc5c94df$var$utcMinutes;

});

parcelRegister("4wGkR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcHours = module.exports.default = void 0;

var $34bafd84c6844820$var$_interval = $34bafd84c6844820$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $34bafd84c6844820$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $34bafd84c6844820$var$utcHour = (0, $34bafd84c6844820$var$_interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * $188mN.durationHour);
}, function(start, end) {
    return (end - start) / $188mN.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var $34bafd84c6844820$var$_default = $34bafd84c6844820$var$utcHour;
module.exports.default = $34bafd84c6844820$var$_default;
var $34bafd84c6844820$var$utcHours = $34bafd84c6844820$var$utcHour.range;
module.exports.utcHours = $34bafd84c6844820$var$utcHours;

});

parcelRegister("i3XOj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcDays = module.exports.default = void 0;

var $d266e6f0c540d430$var$_interval = $d266e6f0c540d430$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $d266e6f0c540d430$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d266e6f0c540d430$var$utcDay = (0, $d266e6f0c540d430$var$_interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / $188mN.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var $d266e6f0c540d430$var$_default = $d266e6f0c540d430$var$utcDay;
module.exports.default = $d266e6f0c540d430$var$_default;
var $d266e6f0c540d430$var$utcDays = $d266e6f0c540d430$var$utcDay.range;
module.exports.utcDays = $d266e6f0c540d430$var$utcDays;

});

parcelRegister("kSPvm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcWednesdays = module.exports.utcWednesday = module.exports.utcTuesdays = module.exports.utcTuesday = module.exports.utcThursdays = module.exports.utcThursday = module.exports.utcSundays = module.exports.utcSunday = module.exports.utcSaturdays = module.exports.utcSaturday = module.exports.utcMondays = module.exports.utcMonday = module.exports.utcFridays = module.exports.utcFriday = void 0;

var $f340cd979f69f122$var$_interval = $f340cd979f69f122$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $f340cd979f69f122$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f340cd979f69f122$var$utcWeekday(i) {
    return (0, $f340cd979f69f122$var$_interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / $188mN.durationWeek;
    });
}
var $f340cd979f69f122$var$utcSunday = $f340cd979f69f122$var$utcWeekday(0);
module.exports.utcSunday = $f340cd979f69f122$var$utcSunday;
var $f340cd979f69f122$var$utcMonday = $f340cd979f69f122$var$utcWeekday(1);
module.exports.utcMonday = $f340cd979f69f122$var$utcMonday;
var $f340cd979f69f122$var$utcTuesday = $f340cd979f69f122$var$utcWeekday(2);
module.exports.utcTuesday = $f340cd979f69f122$var$utcTuesday;
var $f340cd979f69f122$var$utcWednesday = $f340cd979f69f122$var$utcWeekday(3);
module.exports.utcWednesday = $f340cd979f69f122$var$utcWednesday;
var $f340cd979f69f122$var$utcThursday = $f340cd979f69f122$var$utcWeekday(4);
module.exports.utcThursday = $f340cd979f69f122$var$utcThursday;
var $f340cd979f69f122$var$utcFriday = $f340cd979f69f122$var$utcWeekday(5);
module.exports.utcFriday = $f340cd979f69f122$var$utcFriday;
var $f340cd979f69f122$var$utcSaturday = $f340cd979f69f122$var$utcWeekday(6);
module.exports.utcSaturday = $f340cd979f69f122$var$utcSaturday;
var $f340cd979f69f122$var$utcSundays = $f340cd979f69f122$var$utcSunday.range;
module.exports.utcSundays = $f340cd979f69f122$var$utcSundays;
var $f340cd979f69f122$var$utcMondays = $f340cd979f69f122$var$utcMonday.range;
module.exports.utcMondays = $f340cd979f69f122$var$utcMondays;
var $f340cd979f69f122$var$utcTuesdays = $f340cd979f69f122$var$utcTuesday.range;
module.exports.utcTuesdays = $f340cd979f69f122$var$utcTuesdays;
var $f340cd979f69f122$var$utcWednesdays = $f340cd979f69f122$var$utcWednesday.range;
module.exports.utcWednesdays = $f340cd979f69f122$var$utcWednesdays;
var $f340cd979f69f122$var$utcThursdays = $f340cd979f69f122$var$utcThursday.range;
module.exports.utcThursdays = $f340cd979f69f122$var$utcThursdays;
var $f340cd979f69f122$var$utcFridays = $f340cd979f69f122$var$utcFriday.range;
module.exports.utcFridays = $f340cd979f69f122$var$utcFridays;
var $f340cd979f69f122$var$utcSaturdays = $f340cd979f69f122$var$utcSaturday.range;
module.exports.utcSaturdays = $f340cd979f69f122$var$utcSaturdays;

});

parcelRegister("9ILJ1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMonths = module.exports.default = void 0;

var $01d391858e0bc807$var$_interval = $01d391858e0bc807$var$_interopRequireDefault((parcelRequire("bSxHc")));
function $01d391858e0bc807$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $01d391858e0bc807$var$utcMonth = (0, $01d391858e0bc807$var$_interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $01d391858e0bc807$var$_default = $01d391858e0bc807$var$utcMonth;
module.exports.default = $01d391858e0bc807$var$_default;
var $01d391858e0bc807$var$utcMonths = $01d391858e0bc807$var$utcMonth.range;
module.exports.utcMonths = $01d391858e0bc807$var$utcMonths;

});

parcelRegister("4hSHL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcYears = module.exports.default = void 0;

var $31f32f2daf3ec1ad$var$_interval = $31f32f2daf3ec1ad$var$_interopRequireDefault((parcelRequire("bSxHc")));
function $31f32f2daf3ec1ad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $31f32f2daf3ec1ad$var$utcYear = (0, $31f32f2daf3ec1ad$var$_interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
}); // An optimized implementation for this simple case.
$31f32f2daf3ec1ad$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $31f32f2daf3ec1ad$var$_interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $31f32f2daf3ec1ad$var$_default = $31f32f2daf3ec1ad$var$utcYear;
module.exports.default = $31f32f2daf3ec1ad$var$_default;
var $31f32f2daf3ec1ad$var$utcYears = $31f32f2daf3ec1ad$var$utcYear.range;
module.exports.utcYears = $31f32f2daf3ec1ad$var$utcYears;

});

parcelRegister("c02Yy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcTicks = module.exports.utcTickInterval = module.exports.timeTicks = module.exports.timeTickInterval = void 0;

var $baM4h = parcelRequire("baM4h");

var $188mN = parcelRequire("188mN");

var $8bc7cb069ddd56a7$var$_millisecond = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("hRCmg")));

var $8bc7cb069ddd56a7$var$_second = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("jFJeY")));

var $8bc7cb069ddd56a7$var$_minute = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("izQ7P")));

var $8bc7cb069ddd56a7$var$_hour = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("4kq4i")));

var $8bc7cb069ddd56a7$var$_day = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("kSMPp")));

var $exwcm = parcelRequire("exwcm");

var $8bc7cb069ddd56a7$var$_month = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("4YFnz")));

var $8bc7cb069ddd56a7$var$_year = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("lzVRI")));

var $8bc7cb069ddd56a7$var$_utcMinute = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("9FVE8")));

var $8bc7cb069ddd56a7$var$_utcHour = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("4wGkR")));

var $8bc7cb069ddd56a7$var$_utcDay = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("i3XOj")));

var $kSPvm = parcelRequire("kSPvm");

var $8bc7cb069ddd56a7$var$_utcMonth = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("9ILJ1")));

var $8bc7cb069ddd56a7$var$_utcYear = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("4hSHL")));
function $8bc7cb069ddd56a7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8bc7cb069ddd56a7$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            $8bc7cb069ddd56a7$var$_second.default,
            1,
            $188mN.durationSecond
        ],
        [
            $8bc7cb069ddd56a7$var$_second.default,
            5,
            5 * $188mN.durationSecond
        ],
        [
            $8bc7cb069ddd56a7$var$_second.default,
            15,
            15 * $188mN.durationSecond
        ],
        [
            $8bc7cb069ddd56a7$var$_second.default,
            30,
            30 * $188mN.durationSecond
        ],
        [
            minute,
            1,
            $188mN.durationMinute
        ],
        [
            minute,
            5,
            5 * $188mN.durationMinute
        ],
        [
            minute,
            15,
            15 * $188mN.durationMinute
        ],
        [
            minute,
            30,
            30 * $188mN.durationMinute
        ],
        [
            hour,
            1,
            $188mN.durationHour
        ],
        [
            hour,
            3,
            3 * $188mN.durationHour
        ],
        [
            hour,
            6,
            6 * $188mN.durationHour
        ],
        [
            hour,
            12,
            12 * $188mN.durationHour
        ],
        [
            day,
            1,
            $188mN.durationDay
        ],
        [
            day,
            2,
            2 * $188mN.durationDay
        ],
        [
            week,
            1,
            $188mN.durationWeek
        ],
        [
            month,
            1,
            $188mN.durationMonth
        ],
        [
            month,
            3,
            3 * $188mN.durationMonth
        ],
        [
            year,
            1,
            $188mN.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $baM4h.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $baM4h.tickStep)(start / $188mN.durationYear, stop / $188mN.durationYear, count));
        if (i === 0) return $8bc7cb069ddd56a7$var$_millisecond.default.every(Math.max((0, $baM4h.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$8bc7cb069ddd56a7$var$utcTicks, $8bc7cb069ddd56a7$var$utcTickInterval] = $8bc7cb069ddd56a7$var$ticker($8bc7cb069ddd56a7$var$_utcYear.default, $8bc7cb069ddd56a7$var$_utcMonth.default, $kSPvm.utcSunday, $8bc7cb069ddd56a7$var$_utcDay.default, $8bc7cb069ddd56a7$var$_utcHour.default, $8bc7cb069ddd56a7$var$_utcMinute.default);
module.exports.utcTickInterval = $8bc7cb069ddd56a7$var$utcTickInterval;
module.exports.utcTicks = $8bc7cb069ddd56a7$var$utcTicks;
const [$8bc7cb069ddd56a7$var$timeTicks, $8bc7cb069ddd56a7$var$timeTickInterval] = $8bc7cb069ddd56a7$var$ticker($8bc7cb069ddd56a7$var$_year.default, $8bc7cb069ddd56a7$var$_month.default, $exwcm.sunday, $8bc7cb069ddd56a7$var$_day.default, $8bc7cb069ddd56a7$var$_hour.default, $8bc7cb069ddd56a7$var$_minute.default);
module.exports.timeTickInterval = $8bc7cb069ddd56a7$var$timeTickInterval;
module.exports.timeTicks = $8bc7cb069ddd56a7$var$timeTicks;

});


parcelRegister("2qXVT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return $1c5c7fdd0d9de9a3$var$_isoFormat.default;
    }
});
Object.defineProperty(module.exports, "isoParse", {
    enumerable: true,
    get: function() {
        return $1c5c7fdd0d9de9a3$var$_isoParse.default;
    }
});
Object.defineProperty(module.exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return $1c5c7fdd0d9de9a3$var$_defaultLocale.timeFormat;
    }
});
Object.defineProperty(module.exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $1c5c7fdd0d9de9a3$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return $1c5c7fdd0d9de9a3$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "timeParse", {
    enumerable: true,
    get: function() {
        return $1c5c7fdd0d9de9a3$var$_defaultLocale.timeParse;
    }
});
Object.defineProperty(module.exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return $1c5c7fdd0d9de9a3$var$_defaultLocale.utcFormat;
    }
});
Object.defineProperty(module.exports, "utcParse", {
    enumerable: true,
    get: function() {
        return $1c5c7fdd0d9de9a3$var$_defaultLocale.utcParse;
    }
});

var $1c5c7fdd0d9de9a3$var$_defaultLocale = $1c5c7fdd0d9de9a3$var$_interopRequireWildcard((parcelRequire("UhGoU")));

var $1c5c7fdd0d9de9a3$var$_locale = $1c5c7fdd0d9de9a3$var$_interopRequireDefault((parcelRequire("h1gUO")));

var $1c5c7fdd0d9de9a3$var$_isoFormat = $1c5c7fdd0d9de9a3$var$_interopRequireDefault((parcelRequire("k4LLC")));

var $1c5c7fdd0d9de9a3$var$_isoParse = $1c5c7fdd0d9de9a3$var$_interopRequireDefault((parcelRequire("ipWNh")));
function $1c5c7fdd0d9de9a3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1c5c7fdd0d9de9a3$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($1c5c7fdd0d9de9a3$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $1c5c7fdd0d9de9a3$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $1c5c7fdd0d9de9a3$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("UhGoU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0a92f287880e1421$var$defaultLocale;
module.exports.utcParse = module.exports.utcFormat = module.exports.timeParse = module.exports.timeFormat = void 0;

var $0a92f287880e1421$var$_locale = $0a92f287880e1421$var$_interopRequireDefault((parcelRequire("h1gUO")));
function $0a92f287880e1421$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0a92f287880e1421$var$locale;
var $0a92f287880e1421$var$timeFormat;
module.exports.timeFormat = $0a92f287880e1421$var$timeFormat;
var $0a92f287880e1421$var$timeParse;
module.exports.timeParse = $0a92f287880e1421$var$timeParse;
var $0a92f287880e1421$var$utcFormat;
module.exports.utcFormat = $0a92f287880e1421$var$utcFormat;
var $0a92f287880e1421$var$utcParse;
module.exports.utcParse = $0a92f287880e1421$var$utcParse;
$0a92f287880e1421$var$defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $0a92f287880e1421$var$defaultLocale(definition) {
    $0a92f287880e1421$var$locale = (0, $0a92f287880e1421$var$_locale.default)(definition);
    module.exports.timeFormat = $0a92f287880e1421$var$timeFormat = $0a92f287880e1421$var$locale.format;
    module.exports.timeParse = $0a92f287880e1421$var$timeParse = $0a92f287880e1421$var$locale.parse;
    module.exports.utcFormat = $0a92f287880e1421$var$utcFormat = $0a92f287880e1421$var$locale.utcFormat;
    module.exports.utcParse = $0a92f287880e1421$var$utcParse = $0a92f287880e1421$var$locale.utcParse;
    return $0a92f287880e1421$var$locale;
}

});
parcelRegister("h1gUO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c63fa6af19e13ce4$var$formatLocale;

var $kym6t = parcelRequire("kym6t");
function $c63fa6af19e13ce4$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $c63fa6af19e13ce4$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $c63fa6af19e13ce4$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $c63fa6af19e13ce4$var$formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $c63fa6af19e13ce4$var$formatRe(locale_periods), periodLookup = $c63fa6af19e13ce4$var$formatLookup(locale_periods), weekdayRe = $c63fa6af19e13ce4$var$formatRe(locale_weekdays), weekdayLookup = $c63fa6af19e13ce4$var$formatLookup(locale_weekdays), shortWeekdayRe = $c63fa6af19e13ce4$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $c63fa6af19e13ce4$var$formatLookup(locale_shortWeekdays), monthRe = $c63fa6af19e13ce4$var$formatRe(locale_months), monthLookup = $c63fa6af19e13ce4$var$formatLookup(locale_months), shortMonthRe = $c63fa6af19e13ce4$var$formatRe(locale_shortMonths), shortMonthLookup = $c63fa6af19e13ce4$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $c63fa6af19e13ce4$var$formatDayOfMonth,
        "e": $c63fa6af19e13ce4$var$formatDayOfMonth,
        "f": $c63fa6af19e13ce4$var$formatMicroseconds,
        "g": $c63fa6af19e13ce4$var$formatYearISO,
        "G": $c63fa6af19e13ce4$var$formatFullYearISO,
        "H": $c63fa6af19e13ce4$var$formatHour24,
        "I": $c63fa6af19e13ce4$var$formatHour12,
        "j": $c63fa6af19e13ce4$var$formatDayOfYear,
        "L": $c63fa6af19e13ce4$var$formatMilliseconds,
        "m": $c63fa6af19e13ce4$var$formatMonthNumber,
        "M": $c63fa6af19e13ce4$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $c63fa6af19e13ce4$var$formatUnixTimestamp,
        "s": $c63fa6af19e13ce4$var$formatUnixTimestampSeconds,
        "S": $c63fa6af19e13ce4$var$formatSeconds,
        "u": $c63fa6af19e13ce4$var$formatWeekdayNumberMonday,
        "U": $c63fa6af19e13ce4$var$formatWeekNumberSunday,
        "V": $c63fa6af19e13ce4$var$formatWeekNumberISO,
        "w": $c63fa6af19e13ce4$var$formatWeekdayNumberSunday,
        "W": $c63fa6af19e13ce4$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $c63fa6af19e13ce4$var$formatYear,
        "Y": $c63fa6af19e13ce4$var$formatFullYear,
        "Z": $c63fa6af19e13ce4$var$formatZone,
        "%": $c63fa6af19e13ce4$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $c63fa6af19e13ce4$var$formatUTCDayOfMonth,
        "e": $c63fa6af19e13ce4$var$formatUTCDayOfMonth,
        "f": $c63fa6af19e13ce4$var$formatUTCMicroseconds,
        "g": $c63fa6af19e13ce4$var$formatUTCYearISO,
        "G": $c63fa6af19e13ce4$var$formatUTCFullYearISO,
        "H": $c63fa6af19e13ce4$var$formatUTCHour24,
        "I": $c63fa6af19e13ce4$var$formatUTCHour12,
        "j": $c63fa6af19e13ce4$var$formatUTCDayOfYear,
        "L": $c63fa6af19e13ce4$var$formatUTCMilliseconds,
        "m": $c63fa6af19e13ce4$var$formatUTCMonthNumber,
        "M": $c63fa6af19e13ce4$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $c63fa6af19e13ce4$var$formatUnixTimestamp,
        "s": $c63fa6af19e13ce4$var$formatUnixTimestampSeconds,
        "S": $c63fa6af19e13ce4$var$formatUTCSeconds,
        "u": $c63fa6af19e13ce4$var$formatUTCWeekdayNumberMonday,
        "U": $c63fa6af19e13ce4$var$formatUTCWeekNumberSunday,
        "V": $c63fa6af19e13ce4$var$formatUTCWeekNumberISO,
        "w": $c63fa6af19e13ce4$var$formatUTCWeekdayNumberSunday,
        "W": $c63fa6af19e13ce4$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $c63fa6af19e13ce4$var$formatUTCYear,
        "Y": $c63fa6af19e13ce4$var$formatUTCFullYear,
        "Z": $c63fa6af19e13ce4$var$formatUTCZone,
        "%": $c63fa6af19e13ce4$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $c63fa6af19e13ce4$var$parseDayOfMonth,
        "e": $c63fa6af19e13ce4$var$parseDayOfMonth,
        "f": $c63fa6af19e13ce4$var$parseMicroseconds,
        "g": $c63fa6af19e13ce4$var$parseYear,
        "G": $c63fa6af19e13ce4$var$parseFullYear,
        "H": $c63fa6af19e13ce4$var$parseHour24,
        "I": $c63fa6af19e13ce4$var$parseHour24,
        "j": $c63fa6af19e13ce4$var$parseDayOfYear,
        "L": $c63fa6af19e13ce4$var$parseMilliseconds,
        "m": $c63fa6af19e13ce4$var$parseMonthNumber,
        "M": $c63fa6af19e13ce4$var$parseMinutes,
        "p": parsePeriod,
        "q": $c63fa6af19e13ce4$var$parseQuarter,
        "Q": $c63fa6af19e13ce4$var$parseUnixTimestamp,
        "s": $c63fa6af19e13ce4$var$parseUnixTimestampSeconds,
        "S": $c63fa6af19e13ce4$var$parseSeconds,
        "u": $c63fa6af19e13ce4$var$parseWeekdayNumberMonday,
        "U": $c63fa6af19e13ce4$var$parseWeekNumberSunday,
        "V": $c63fa6af19e13ce4$var$parseWeekNumberISO,
        "w": $c63fa6af19e13ce4$var$parseWeekdayNumberSunday,
        "W": $c63fa6af19e13ce4$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $c63fa6af19e13ce4$var$parseYear,
        "Y": $c63fa6af19e13ce4$var$parseFullYear,
        "Z": $c63fa6af19e13ce4$var$parseZone,
        "%": $c63fa6af19e13ce4$var$parseLiteralPercent
    }; // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $c63fa6af19e13ce4$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $c63fa6af19e13ce4$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null; // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $c63fa6af19e13ce4$var$utcDate($c63fa6af19e13ce4$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? $kym6t.utcMonday.ceil(week) : (0, $kym6t.utcMonday)(week);
                    week = $kym6t.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $c63fa6af19e13ce4$var$localDate($c63fa6af19e13ce4$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? $kym6t.timeMonday.ceil(week) : (0, $kym6t.timeMonday)(week);
                    week = $kym6t.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $c63fa6af19e13ce4$var$utcDate($c63fa6af19e13ce4$var$newDate(d.y, 0, 1)).getUTCDay() : $c63fa6af19e13ce4$var$localDate($c63fa6af19e13ce4$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            } // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $c63fa6af19e13ce4$var$utcDate(d);
            } // Otherwise, all fields are in local time.
            return $c63fa6af19e13ce4$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $c63fa6af19e13ce4$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $c63fa6af19e13ce4$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $c63fa6af19e13ce4$var$numberRe = /^\s*\d+/, // note: ignores next directive
$c63fa6af19e13ce4$var$percentRe = /^%/, $c63fa6af19e13ce4$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $c63fa6af19e13ce4$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $c63fa6af19e13ce4$var$requote(s) {
    return s.replace($c63fa6af19e13ce4$var$requoteRe, "\\$&");
}
function $c63fa6af19e13ce4$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($c63fa6af19e13ce4$var$requote).join("|") + ")", "i");
}
function $c63fa6af19e13ce4$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $c63fa6af19e13ce4$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseWeekNumberSunday(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseWeekNumberISO(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseWeekNumberMonday(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseFullYear(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseYear(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseQuarter(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseMonthNumber(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseDayOfMonth(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseDayOfYear(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseHour24(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseMinutes(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseSeconds(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseMilliseconds(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseMicroseconds(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseLiteralPercent(d, string, i) {
    var n = $c63fa6af19e13ce4$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $c63fa6af19e13ce4$var$parseUnixTimestamp(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$formatDayOfMonth(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getDate(), p, 2);
}
function $c63fa6af19e13ce4$var$formatHour24(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getHours(), p, 2);
}
function $c63fa6af19e13ce4$var$formatHour12(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $c63fa6af19e13ce4$var$formatDayOfYear(d, p) {
    return $c63fa6af19e13ce4$var$pad(1 + $kym6t.timeDay.count((0, $kym6t.timeYear)(d), d), p, 3);
}
function $c63fa6af19e13ce4$var$formatMilliseconds(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getMilliseconds(), p, 3);
}
function $c63fa6af19e13ce4$var$formatMicroseconds(d, p) {
    return $c63fa6af19e13ce4$var$formatMilliseconds(d, p) + "000";
}
function $c63fa6af19e13ce4$var$formatMonthNumber(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getMonth() + 1, p, 2);
}
function $c63fa6af19e13ce4$var$formatMinutes(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getMinutes(), p, 2);
}
function $c63fa6af19e13ce4$var$formatSeconds(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getSeconds(), p, 2);
}
function $c63fa6af19e13ce4$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $c63fa6af19e13ce4$var$formatWeekNumberSunday(d, p) {
    return $c63fa6af19e13ce4$var$pad($kym6t.timeSunday.count((0, $kym6t.timeYear)(d) - 1, d), p, 2);
}
function $c63fa6af19e13ce4$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $kym6t.timeThursday)(d) : $kym6t.timeThursday.ceil(d);
}
function $c63fa6af19e13ce4$var$formatWeekNumberISO(d, p) {
    d = $c63fa6af19e13ce4$var$dISO(d);
    return $c63fa6af19e13ce4$var$pad($kym6t.timeThursday.count((0, $kym6t.timeYear)(d), d) + ((0, $kym6t.timeYear)(d).getDay() === 4), p, 2);
}
function $c63fa6af19e13ce4$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $c63fa6af19e13ce4$var$formatWeekNumberMonday(d, p) {
    return $c63fa6af19e13ce4$var$pad($kym6t.timeMonday.count((0, $kym6t.timeYear)(d) - 1, d), p, 2);
}
function $c63fa6af19e13ce4$var$formatYear(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getFullYear() % 100, p, 2);
}
function $c63fa6af19e13ce4$var$formatYearISO(d, p) {
    d = $c63fa6af19e13ce4$var$dISO(d);
    return $c63fa6af19e13ce4$var$pad(d.getFullYear() % 100, p, 2);
}
function $c63fa6af19e13ce4$var$formatFullYear(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getFullYear() % 10000, p, 4);
}
function $c63fa6af19e13ce4$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $kym6t.timeThursday)(d) : $kym6t.timeThursday.ceil(d);
    return $c63fa6af19e13ce4$var$pad(d.getFullYear() % 10000, p, 4);
}
function $c63fa6af19e13ce4$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $c63fa6af19e13ce4$var$pad(z / 60 | 0, "0", 2) + $c63fa6af19e13ce4$var$pad(z % 60, "0", 2);
}
function $c63fa6af19e13ce4$var$formatUTCDayOfMonth(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCDate(), p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCHour24(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCHours(), p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCHour12(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCDayOfYear(d, p) {
    return $c63fa6af19e13ce4$var$pad(1 + $kym6t.utcDay.count((0, $kym6t.utcYear)(d), d), p, 3);
}
function $c63fa6af19e13ce4$var$formatUTCMilliseconds(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $c63fa6af19e13ce4$var$formatUTCMicroseconds(d, p) {
    return $c63fa6af19e13ce4$var$formatUTCMilliseconds(d, p) + "000";
}
function $c63fa6af19e13ce4$var$formatUTCMonthNumber(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCMinutes(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCMinutes(), p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCSeconds(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCSeconds(), p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $c63fa6af19e13ce4$var$formatUTCWeekNumberSunday(d, p) {
    return $c63fa6af19e13ce4$var$pad($kym6t.utcSunday.count((0, $kym6t.utcYear)(d) - 1, d), p, 2);
}
function $c63fa6af19e13ce4$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $kym6t.utcThursday)(d) : $kym6t.utcThursday.ceil(d);
}
function $c63fa6af19e13ce4$var$formatUTCWeekNumberISO(d, p) {
    d = $c63fa6af19e13ce4$var$UTCdISO(d);
    return $c63fa6af19e13ce4$var$pad($kym6t.utcThursday.count((0, $kym6t.utcYear)(d), d) + ((0, $kym6t.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $c63fa6af19e13ce4$var$formatUTCWeekNumberMonday(d, p) {
    return $c63fa6af19e13ce4$var$pad($kym6t.utcMonday.count((0, $kym6t.utcYear)(d) - 1, d), p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCYear(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCYearISO(d, p) {
    d = $c63fa6af19e13ce4$var$UTCdISO(d);
    return $c63fa6af19e13ce4$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCFullYear(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $c63fa6af19e13ce4$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $kym6t.utcThursday)(d) : $kym6t.utcThursday.ceil(d);
    return $c63fa6af19e13ce4$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $c63fa6af19e13ce4$var$formatUTCZone() {
    return "+0000";
}
function $c63fa6af19e13ce4$var$formatLiteralPercent() {
    return "%";
}
function $c63fa6af19e13ce4$var$formatUnixTimestamp(d) {
    return +d;
}
function $c63fa6af19e13ce4$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRegister("k4LLC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoSpecifier = module.exports.default = void 0;

var $UhGoU = parcelRequire("UhGoU");
var $e9d93beb7b18b592$var$isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
module.exports.isoSpecifier = $e9d93beb7b18b592$var$isoSpecifier;
function $e9d93beb7b18b592$var$formatIsoNative(date) {
    return date.toISOString();
}
var $e9d93beb7b18b592$var$formatIso = Date.prototype.toISOString ? $e9d93beb7b18b592$var$formatIsoNative : (0, $UhGoU.utcFormat)($e9d93beb7b18b592$var$isoSpecifier);
var $e9d93beb7b18b592$var$_default = $e9d93beb7b18b592$var$formatIso;
module.exports.default = $e9d93beb7b18b592$var$_default;

});

parcelRegister("ipWNh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $k4LLC = parcelRequire("k4LLC");

var $UhGoU = parcelRequire("UhGoU");
function $d6882b05ea79e09e$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $d6882b05ea79e09e$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $d6882b05ea79e09e$var$parseIsoNative : (0, $UhGoU.utcParse)($k4LLC.isoSpecifier);
var $d6882b05ea79e09e$var$_default = $d6882b05ea79e09e$var$parseIso;
module.exports.default = $d6882b05ea79e09e$var$_default;

});



parcelRegister("ne0st", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $045d0379864c58f8$var$utcTime;

var $kym6t = parcelRequire("kym6t");

var $2qXVT = parcelRequire("2qXVT");

var $617BV = parcelRequire("617BV");

var $98nei = parcelRequire("98nei");
function $045d0379864c58f8$var$utcTime() {
    return $98nei.initRange.apply((0, $617BV.calendar)($kym6t.utcTicks, $kym6t.utcTickInterval, $kym6t.utcYear, $kym6t.utcMonth, $kym6t.utcWeek, $kym6t.utcDay, $kym6t.utcHour, $kym6t.utcMinute, $kym6t.utcSecond, $2qXVT.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRegister("5pVeE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $3f1baf43dc1248ab$var$copy;
module.exports.default = $3f1baf43dc1248ab$var$sequential;
module.exports.sequentialLog = $3f1baf43dc1248ab$var$sequentialLog;
module.exports.sequentialPow = $3f1baf43dc1248ab$var$sequentialPow;
module.exports.sequentialSqrt = $3f1baf43dc1248ab$var$sequentialSqrt;
module.exports.sequentialSymlog = $3f1baf43dc1248ab$var$sequentialSymlog;

var $665th = parcelRequire("665th");

var $dTLbh = parcelRequire("dTLbh");

var $98nei = parcelRequire("98nei");

var $hvSDx = parcelRequire("hvSDx");

var $aEI3x = parcelRequire("aEI3x");

var $bzrFz = parcelRequire("bzrFz");

var $cpAbf = parcelRequire("cpAbf");
function $3f1baf43dc1248ab$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = $dTLbh.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range($665th.interpolate);
    scale.rangeRound = range($665th.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $3f1baf43dc1248ab$var$copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $3f1baf43dc1248ab$var$sequential() {
    var scale = (0, $hvSDx.linearish)($3f1baf43dc1248ab$var$transformer()($dTLbh.identity));
    scale.copy = function() {
        return $3f1baf43dc1248ab$var$copy(scale, $3f1baf43dc1248ab$var$sequential());
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}
function $3f1baf43dc1248ab$var$sequentialLog() {
    var scale = (0, $aEI3x.loggish)($3f1baf43dc1248ab$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $3f1baf43dc1248ab$var$copy(scale, $3f1baf43dc1248ab$var$sequentialLog()).base(scale.base());
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}
function $3f1baf43dc1248ab$var$sequentialSymlog() {
    var scale = (0, $bzrFz.symlogish)($3f1baf43dc1248ab$var$transformer());
    scale.copy = function() {
        return $3f1baf43dc1248ab$var$copy(scale, $3f1baf43dc1248ab$var$sequentialSymlog()).constant(scale.constant());
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}
function $3f1baf43dc1248ab$var$sequentialPow() {
    var scale = (0, $cpAbf.powish)($3f1baf43dc1248ab$var$transformer());
    scale.copy = function() {
        return $3f1baf43dc1248ab$var$copy(scale, $3f1baf43dc1248ab$var$sequentialPow()).exponent(scale.exponent());
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}
function $3f1baf43dc1248ab$var$sequentialSqrt() {
    return $3f1baf43dc1248ab$var$sequentialPow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("l4TSc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f5854ff20784e77c$var$sequentialQuantile;

var $baM4h = parcelRequire("baM4h");

var $dTLbh = parcelRequire("dTLbh");

var $98nei = parcelRequire("98nei");
function $f5854ff20784e77c$var$sequentialQuantile() {
    var domain = [], interpolator = $dTLbh.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $baM4h.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($baM4h.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $baM4h.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return $f5854ff20784e77c$var$sequentialQuantile(interpolator).domain(domain);
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}

});

parcelRegister("fMWTD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b7e906464bbf9363$var$diverging;
module.exports.divergingLog = $b7e906464bbf9363$var$divergingLog;
module.exports.divergingPow = $b7e906464bbf9363$var$divergingPow;
module.exports.divergingSqrt = $b7e906464bbf9363$var$divergingSqrt;
module.exports.divergingSymlog = $b7e906464bbf9363$var$divergingSymlog;

var $665th = parcelRequire("665th");

var $dTLbh = parcelRequire("dTLbh");

var $98nei = parcelRequire("98nei");

var $hvSDx = parcelRequire("hvSDx");

var $aEI3x = parcelRequire("aEI3x");

var $5pVeE = parcelRequire("5pVeE");

var $bzrFz = parcelRequire("bzrFz");

var $cpAbf = parcelRequire("cpAbf");
function $b7e906464bbf9363$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = $dTLbh.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $665th.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range($665th.interpolate);
    scale.rangeRound = range($665th.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $b7e906464bbf9363$var$diverging() {
    var scale = (0, $hvSDx.linearish)($b7e906464bbf9363$var$transformer()($dTLbh.identity));
    scale.copy = function() {
        return (0, $5pVeE.copy)(scale, $b7e906464bbf9363$var$diverging());
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}
function $b7e906464bbf9363$var$divergingLog() {
    var scale = (0, $aEI3x.loggish)($b7e906464bbf9363$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $5pVeE.copy)(scale, $b7e906464bbf9363$var$divergingLog()).base(scale.base());
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}
function $b7e906464bbf9363$var$divergingSymlog() {
    var scale = (0, $bzrFz.symlogish)($b7e906464bbf9363$var$transformer());
    scale.copy = function() {
        return (0, $5pVeE.copy)(scale, $b7e906464bbf9363$var$divergingSymlog()).constant(scale.constant());
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}
function $b7e906464bbf9363$var$divergingPow() {
    var scale = (0, $cpAbf.powish)($b7e906464bbf9363$var$transformer());
    scale.copy = function() {
        return (0, $5pVeE.copy)(scale, $b7e906464bbf9363$var$divergingPow()).exponent(scale.exponent());
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}
function $b7e906464bbf9363$var$divergingSqrt() {
    return $b7e906464bbf9363$var$divergingPow.apply(null, arguments).exponent(0.5);
}

});



parcelRegister("CKTDO", function(module, exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`

module.exports = (parcelRequire("bszMs"));

});
parcelRegister("bszMs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "arc", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_arc.default;
    }
});
Object.defineProperty(module.exports, "area", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_area.default;
    }
});
Object.defineProperty(module.exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_basisOpen.default;
    }
});
Object.defineProperty(module.exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return $evZCX.bumpX;
    }
});
Object.defineProperty(module.exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return $evZCX.bumpY;
    }
});
Object.defineProperty(module.exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_bundle.default;
    }
});
Object.defineProperty(module.exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_cardinal.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_cardinalClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_cardinalOpen.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_catmullRom.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_catmullRomClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_catmullRomOpen.default;
    }
});
Object.defineProperty(module.exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_linearClosed.default;
    }
});
Object.defineProperty(module.exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return $eqBPr.monotoneX;
    }
});
Object.defineProperty(module.exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return $eqBPr.monotoneY;
    }
});
Object.defineProperty(module.exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_natural.default;
    }
});
Object.defineProperty(module.exports, "curveStep", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_step.default;
    }
});
Object.defineProperty(module.exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_step.stepAfter;
    }
});
Object.defineProperty(module.exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_step.stepBefore;
    }
});
Object.defineProperty(module.exports, "line", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_line.default;
    }
});
Object.defineProperty(module.exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function() {
        return $3WvWY.link;
    }
});
Object.defineProperty(module.exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return $3WvWY.linkHorizontal;
    }
});
Object.defineProperty(module.exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return $3WvWY.linkRadial;
    }
});
Object.defineProperty(module.exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return $3WvWY.linkVertical;
    }
});
Object.defineProperty(module.exports, "pie", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_pie.default;
    }
});
Object.defineProperty(module.exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_pointRadial.default;
    }
});
Object.defineProperty(module.exports, "radialArea", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "radialLine", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "stack", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_stack.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_expand.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_none.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_silhouette.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_wiggle.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_appearance.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_insideOut.default;
    }
});
Object.defineProperty(module.exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_none2.default;
    }
});
Object.defineProperty(module.exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "symbol", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_symbol.default;
    }
});
Object.defineProperty(module.exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_asterisk.default;
    }
});
Object.defineProperty(module.exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_circle.default;
    }
});
Object.defineProperty(module.exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_diamond.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_diamond2.default;
    }
});
Object.defineProperty(module.exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_plus.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_square.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_square2.default;
    }
});
Object.defineProperty(module.exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_star.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_triangle.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_triangle2.default;
    }
});
Object.defineProperty(module.exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_wye.default;
    }
});
Object.defineProperty(module.exports, "symbolX", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_x.default;
    }
});
Object.defineProperty(module.exports, "symbols", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_symbol.symbolsStroke;
    }
});

var $857e1081b5aa9262$var$_arc = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("8sWC8")));

var $857e1081b5aa9262$var$_area = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("cYK15")));

var $857e1081b5aa9262$var$_line = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("2gJml")));

var $857e1081b5aa9262$var$_pie = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("fM93E")));

var $857e1081b5aa9262$var$_areaRadial = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("7s0ZM")));

var $857e1081b5aa9262$var$_lineRadial = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("7auFH")));

var $857e1081b5aa9262$var$_pointRadial = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("5wAin")));

var $3WvWY = parcelRequire("3WvWY");

var $857e1081b5aa9262$var$_symbol = $857e1081b5aa9262$var$_interopRequireWildcard((parcelRequire("l3mP4")));

var $857e1081b5aa9262$var$_asterisk = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("hNi5e")));

var $857e1081b5aa9262$var$_circle = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("80b5j")));

var $857e1081b5aa9262$var$_cross = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("34kQO")));

var $857e1081b5aa9262$var$_diamond = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("aSxHZ")));

var $857e1081b5aa9262$var$_diamond2 = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("3rBZo")));

var $857e1081b5aa9262$var$_plus = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("l9ST9")));

var $857e1081b5aa9262$var$_square = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("3oWT7")));

var $857e1081b5aa9262$var$_square2 = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("k3QGU")));

var $857e1081b5aa9262$var$_star = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("1WZhf")));

var $857e1081b5aa9262$var$_triangle = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("hQr8g")));

var $857e1081b5aa9262$var$_triangle2 = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("NGszi")));

var $857e1081b5aa9262$var$_wye = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("7fYkN")));

var $857e1081b5aa9262$var$_x = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("3oXF4")));

var $857e1081b5aa9262$var$_basisClosed = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("a65kp")));

var $857e1081b5aa9262$var$_basisOpen = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("aFwZp")));

var $857e1081b5aa9262$var$_basis = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("4MmJ6")));

var $evZCX = parcelRequire("evZCX");

var $857e1081b5aa9262$var$_bundle = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("1uOPP")));

var $857e1081b5aa9262$var$_cardinalClosed = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("1RBVE")));

var $857e1081b5aa9262$var$_cardinalOpen = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("88R3u")));

var $857e1081b5aa9262$var$_cardinal = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("8MEVA")));

var $857e1081b5aa9262$var$_catmullRomClosed = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("63Rg9")));

var $857e1081b5aa9262$var$_catmullRomOpen = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("4JV2s")));

var $857e1081b5aa9262$var$_catmullRom = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("jeCIz")));

var $857e1081b5aa9262$var$_linearClosed = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("7HCNf")));

var $857e1081b5aa9262$var$_linear = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("1wm0G")));

var $eqBPr = parcelRequire("eqBPr");

var $857e1081b5aa9262$var$_natural = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("dY7QQ")));

var $857e1081b5aa9262$var$_step = $857e1081b5aa9262$var$_interopRequireWildcard((parcelRequire("llSQy")));

var $857e1081b5aa9262$var$_stack = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("l6qno")));

var $857e1081b5aa9262$var$_expand = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("fpjqO")));

var $857e1081b5aa9262$var$_diverging = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("l5EV1")));

var $857e1081b5aa9262$var$_none = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("7CMPN")));

var $857e1081b5aa9262$var$_silhouette = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("4ViQy")));

var $857e1081b5aa9262$var$_wiggle = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("fIpqC")));

var $857e1081b5aa9262$var$_appearance = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("5qWRn")));

var $857e1081b5aa9262$var$_ascending = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("klspr")));

var $857e1081b5aa9262$var$_descending = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("kwAJ5")));

var $857e1081b5aa9262$var$_insideOut = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("4fWJp")));

var $857e1081b5aa9262$var$_none2 = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("5Nf2s")));

var $857e1081b5aa9262$var$_reverse = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("aFPqy")));
function $857e1081b5aa9262$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($857e1081b5aa9262$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $857e1081b5aa9262$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $857e1081b5aa9262$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $857e1081b5aa9262$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("8sWC8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $629e67c3e170e9e8$var$_default;

var $ahT4l = parcelRequire("ahT4l");

var $629e67c3e170e9e8$var$_constant = $629e67c3e170e9e8$var$_interopRequireDefault((parcelRequire("1SFIt")));

var $8EE7R = parcelRequire("8EE7R");
function $629e67c3e170e9e8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $629e67c3e170e9e8$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $629e67c3e170e9e8$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $629e67c3e170e9e8$var$arcStartAngle(d) {
    return d.startAngle;
}
function $629e67c3e170e9e8$var$arcEndAngle(d) {
    return d.endAngle;
}
function $629e67c3e170e9e8$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $629e67c3e170e9e8$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < $8EE7R.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $629e67c3e170e9e8$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $8EE7R.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $8EE7R.sqrt)((0, $8EE7R.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $629e67c3e170e9e8$var$_default() {
    var innerRadius = $629e67c3e170e9e8$var$arcInnerRadius, outerRadius = $629e67c3e170e9e8$var$arcOuterRadius, cornerRadius = (0, $629e67c3e170e9e8$var$_constant.default)(0), padRadius = null, startAngle = $629e67c3e170e9e8$var$arcStartAngle, endAngle = $629e67c3e170e9e8$var$arcEndAngle, padAngle = $629e67c3e170e9e8$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - $8EE7R.halfPi, a1 = endAngle.apply(this, arguments) - $8EE7R.halfPi, da = (0, $8EE7R.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $ahT4l.path)(); // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?
        if (!(r1 > $8EE7R.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
        else if (da > $8EE7R.tau - $8EE7R.epsilon) {
            context.moveTo(r1 * (0, $8EE7R.cos)(a0), r1 * (0, $8EE7R.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > $8EE7R.epsilon) {
                context.moveTo(r0 * (0, $8EE7R.cos)(a1), r0 * (0, $8EE7R.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > $8EE7R.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, $8EE7R.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $8EE7R.min)((0, $8EE7R.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > $8EE7R.epsilon) {
                var p0 = (0, $8EE7R.asin)(rp / r0 * (0, $8EE7R.sin)(ap)), p1 = (0, $8EE7R.asin)(rp / r1 * (0, $8EE7R.sin)(ap));
                if ((da0 -= p0 * 2) > $8EE7R.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > $8EE7R.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $8EE7R.cos)(a01), y01 = r1 * (0, $8EE7R.sin)(a01), x10 = r0 * (0, $8EE7R.cos)(a10), y10 = r0 * (0, $8EE7R.sin)(a10); // Apply rounded corners?
            if (rc > $8EE7R.epsilon) {
                var x11 = r1 * (0, $8EE7R.cos)(a11), y11 = r1 * (0, $8EE7R.sin)(a11), x00 = r0 * (0, $8EE7R.cos)(a00), y00 = r0 * (0, $8EE7R.sin)(a00), oc; // Restrict the corner radius according to the sector angle.
                if (da < $8EE7R.pi && (oc = $629e67c3e170e9e8$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $8EE7R.sin)((0, $8EE7R.acos)((ax * bx + ay * by) / ((0, $8EE7R.sqrt)(ax * ax + ay * ay) * (0, $8EE7R.sqrt)(bx * bx + by * by))) / 2), lc = (0, $8EE7R.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $8EE7R.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $8EE7R.min)(rc, (r1 - lc) / (kc + 1));
                }
            } // Is the sector collapsed to a line?
            if (!(da1 > $8EE7R.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > $8EE7R.epsilon) {
                t0 = $629e67c3e170e9e8$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $629e67c3e170e9e8$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $8EE7R.atan2)(t0.y01, t0.x01), (0, $8EE7R.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $8EE7R.atan2)(t0.y01, t0.x01), (0, $8EE7R.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $8EE7R.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $8EE7R.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $8EE7R.atan2)(t1.y11, t1.x11), (0, $8EE7R.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > $8EE7R.epsilon) || !(da0 > $8EE7R.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > $8EE7R.epsilon) {
                t0 = $629e67c3e170e9e8$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $629e67c3e170e9e8$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $8EE7R.atan2)(t0.y01, t0.x01), (0, $8EE7R.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $8EE7R.atan2)(t0.y01, t0.x01), (0, $8EE7R.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $8EE7R.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $8EE7R.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $8EE7R.atan2)(t1.y11, t1.x11), (0, $8EE7R.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - $8EE7R.pi / 2;
        return [
            (0, $8EE7R.cos)(a) * r,
            (0, $8EE7R.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $629e67c3e170e9e8$var$_constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $629e67c3e170e9e8$var$_constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $629e67c3e170e9e8$var$_constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $629e67c3e170e9e8$var$_constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $629e67c3e170e9e8$var$_constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $629e67c3e170e9e8$var$_constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $629e67c3e170e9e8$var$_constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("ahT4l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "path", {
    enumerable: true,
    get: function() {
        return $77d6357a38850c18$var$_path.default;
    }
});

var $77d6357a38850c18$var$_path = $77d6357a38850c18$var$_interopRequireDefault((parcelRequire("le6pz")));
function $77d6357a38850c18$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("le6pz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $f73fe0f2b8713871$var$pi = Math.PI, $f73fe0f2b8713871$var$tau = 2 * $f73fe0f2b8713871$var$pi, $f73fe0f2b8713871$var$epsilon = 1e-6, $f73fe0f2b8713871$var$tauEpsilon = $f73fe0f2b8713871$var$tau - $f73fe0f2b8713871$var$epsilon;
function $f73fe0f2b8713871$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $f73fe0f2b8713871$var$path() {
    return new $f73fe0f2b8713871$var$Path();
}
$f73fe0f2b8713871$var$Path.prototype = $f73fe0f2b8713871$var$path.prototype = {
    constructor: $f73fe0f2b8713871$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $f73fe0f2b8713871$var$epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $f73fe0f2b8713871$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($f73fe0f2b8713871$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $f73fe0f2b8713871$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $f73fe0f2b8713871$var$epsilon || Math.abs(this._y1 - y0) > $f73fe0f2b8713871$var$epsilon) this._ += "L" + x0 + "," + y0;
         // Is this arc empty? We’re done.
        if (!r) return; // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $f73fe0f2b8713871$var$tau + $f73fe0f2b8713871$var$tau; // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $f73fe0f2b8713871$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $f73fe0f2b8713871$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $f73fe0f2b8713871$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $f73fe0f2b8713871$var$_default = $f73fe0f2b8713871$var$path;
module.exports.default = $f73fe0f2b8713871$var$_default;

});


parcelRegister("1SFIt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $15eb3195f18fef30$var$_default;
function $15eb3195f18fef30$var$_default(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("8EE7R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.abs = void 0;
module.exports.acos = $64d12f47b5cdfb44$var$acos;
module.exports.asin = $64d12f47b5cdfb44$var$asin;
module.exports.tau = module.exports.sqrt = module.exports.sin = module.exports.pi = module.exports.min = module.exports.max = module.exports.halfPi = module.exports.epsilon = module.exports.cos = module.exports.atan2 = void 0;
const $64d12f47b5cdfb44$var$abs = Math.abs;
module.exports.abs = $64d12f47b5cdfb44$var$abs;
const $64d12f47b5cdfb44$var$atan2 = Math.atan2;
module.exports.atan2 = $64d12f47b5cdfb44$var$atan2;
const $64d12f47b5cdfb44$var$cos = Math.cos;
module.exports.cos = $64d12f47b5cdfb44$var$cos;
const $64d12f47b5cdfb44$var$max = Math.max;
module.exports.max = $64d12f47b5cdfb44$var$max;
const $64d12f47b5cdfb44$var$min = Math.min;
module.exports.min = $64d12f47b5cdfb44$var$min;
const $64d12f47b5cdfb44$var$sin = Math.sin;
module.exports.sin = $64d12f47b5cdfb44$var$sin;
const $64d12f47b5cdfb44$var$sqrt = Math.sqrt;
module.exports.sqrt = $64d12f47b5cdfb44$var$sqrt;
const $64d12f47b5cdfb44$var$epsilon = 1e-12;
module.exports.epsilon = $64d12f47b5cdfb44$var$epsilon;
const $64d12f47b5cdfb44$var$pi = Math.PI;
module.exports.pi = $64d12f47b5cdfb44$var$pi;
const $64d12f47b5cdfb44$var$halfPi = $64d12f47b5cdfb44$var$pi / 2;
module.exports.halfPi = $64d12f47b5cdfb44$var$halfPi;
const $64d12f47b5cdfb44$var$tau = 2 * $64d12f47b5cdfb44$var$pi;
module.exports.tau = $64d12f47b5cdfb44$var$tau;
function $64d12f47b5cdfb44$var$acos(x) {
    return x > 1 ? 0 : x < -1 ? $64d12f47b5cdfb44$var$pi : Math.acos(x);
}
function $64d12f47b5cdfb44$var$asin(x) {
    return x >= 1 ? $64d12f47b5cdfb44$var$halfPi : x <= -1 ? -$64d12f47b5cdfb44$var$halfPi : Math.asin(x);
}

});


parcelRegister("cYK15", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $972ec88a4d5ed3c6$var$_default;

var $ahT4l = parcelRequire("ahT4l");

var $972ec88a4d5ed3c6$var$_array = $972ec88a4d5ed3c6$var$_interopRequireDefault((parcelRequire("72xzV")));

var $972ec88a4d5ed3c6$var$_constant = $972ec88a4d5ed3c6$var$_interopRequireDefault((parcelRequire("1SFIt")));

var $972ec88a4d5ed3c6$var$_linear = $972ec88a4d5ed3c6$var$_interopRequireDefault((parcelRequire("1wm0G")));

var $972ec88a4d5ed3c6$var$_line = $972ec88a4d5ed3c6$var$_interopRequireDefault((parcelRequire("2gJml")));

var $97E2D = parcelRequire("97E2D");
function $972ec88a4d5ed3c6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $972ec88a4d5ed3c6$var$_default(x0, y0, y1) {
    var x1 = null, defined = (0, $972ec88a4d5ed3c6$var$_constant.default)(true), context = null, curve = $972ec88a4d5ed3c6$var$_linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? $97E2D.x : (0, $972ec88a4d5ed3c6$var$_constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $972ec88a4d5ed3c6$var$_constant.default)(0) : (0, $972ec88a4d5ed3c6$var$_constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? $97E2D.y : (0, $972ec88a4d5ed3c6$var$_constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $972ec88a4d5ed3c6$var$_array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $ahT4l.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $972ec88a4d5ed3c6$var$_line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $972ec88a4d5ed3c6$var$_constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $972ec88a4d5ed3c6$var$_constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $972ec88a4d5ed3c6$var$_constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $972ec88a4d5ed3c6$var$_constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $972ec88a4d5ed3c6$var$_constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $972ec88a4d5ed3c6$var$_constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $972ec88a4d5ed3c6$var$_constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("72xzV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5202c4444202b759$var$_default;
module.exports.slice = void 0;
var $5202c4444202b759$var$slice = Array.prototype.slice;
module.exports.slice = $5202c4444202b759$var$slice;
function $5202c4444202b759$var$_default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("1wm0G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $11b9da5b73dc4d76$var$_default;
function $11b9da5b73dc4d76$var$Linear(context) {
    this._context = context;
}
$11b9da5b73dc4d76$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $11b9da5b73dc4d76$var$_default(context) {
    return new $11b9da5b73dc4d76$var$Linear(context);
}

});

parcelRegister("2gJml", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1a7042d356f33d45$var$_default;

var $ahT4l = parcelRequire("ahT4l");

var $1a7042d356f33d45$var$_array = $1a7042d356f33d45$var$_interopRequireDefault((parcelRequire("72xzV")));

var $1a7042d356f33d45$var$_constant = $1a7042d356f33d45$var$_interopRequireDefault((parcelRequire("1SFIt")));

var $1a7042d356f33d45$var$_linear = $1a7042d356f33d45$var$_interopRequireDefault((parcelRequire("1wm0G")));

var $97E2D = parcelRequire("97E2D");
function $1a7042d356f33d45$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1a7042d356f33d45$var$_default(x, y) {
    var defined = (0, $1a7042d356f33d45$var$_constant.default)(true), context = null, curve = $1a7042d356f33d45$var$_linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? $97E2D.x : (0, $1a7042d356f33d45$var$_constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? $97E2D.y : (0, $1a7042d356f33d45$var$_constant.default)(y);
    function line(data) {
        var i, n = (data = (0, $1a7042d356f33d45$var$_array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $ahT4l.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $1a7042d356f33d45$var$_constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $1a7042d356f33d45$var$_constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $1a7042d356f33d45$var$_constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("97E2D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = $6a43d3ea9922a71a$var$x;
module.exports.y = $6a43d3ea9922a71a$var$y;
function $6a43d3ea9922a71a$var$x(p) {
    return p[0];
}
function $6a43d3ea9922a71a$var$y(p) {
    return p[1];
}

});



parcelRegister("fM93E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b7c25d6f0d698acb$var$_default;

var $b7c25d6f0d698acb$var$_array = $b7c25d6f0d698acb$var$_interopRequireDefault((parcelRequire("72xzV")));

var $b7c25d6f0d698acb$var$_constant = $b7c25d6f0d698acb$var$_interopRequireDefault((parcelRequire("1SFIt")));

var $b7c25d6f0d698acb$var$_descending = $b7c25d6f0d698acb$var$_interopRequireDefault((parcelRequire("fI7FW")));

var $b7c25d6f0d698acb$var$_identity = $b7c25d6f0d698acb$var$_interopRequireDefault((parcelRequire("gi9bQ")));

var $8EE7R = parcelRequire("8EE7R");
function $b7c25d6f0d698acb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b7c25d6f0d698acb$var$_default() {
    var value = $b7c25d6f0d698acb$var$_identity.default, sortValues = $b7c25d6f0d698acb$var$_descending.default, sort = null, startAngle = (0, $b7c25d6f0d698acb$var$_constant.default)(0), endAngle = (0, $b7c25d6f0d698acb$var$_constant.default)($8EE7R.tau), padAngle = (0, $b7c25d6f0d698acb$var$_constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, $b7c25d6f0d698acb$var$_array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min($8EE7R.tau, Math.max(-$8EE7R.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
         // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        }); // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $b7c25d6f0d698acb$var$_constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $b7c25d6f0d698acb$var$_constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $b7c25d6f0d698acb$var$_constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $b7c25d6f0d698acb$var$_constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("fI7FW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b700eb49b0c7926d$var$_default;
function $b700eb49b0c7926d$var$_default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("gi9bQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bdc574b68d16a31a$var$_default;
function $bdc574b68d16a31a$var$_default(d) {
    return d;
}

});


parcelRegister("7s0ZM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $56cbeb94d955b565$var$_default;

var $56cbeb94d955b565$var$_radial = $56cbeb94d955b565$var$_interopRequireWildcard((parcelRequire("dqrdl")));

var $56cbeb94d955b565$var$_area = $56cbeb94d955b565$var$_interopRequireDefault((parcelRequire("cYK15")));

var $7auFH = parcelRequire("7auFH");
function $56cbeb94d955b565$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $56cbeb94d955b565$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($56cbeb94d955b565$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $56cbeb94d955b565$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $56cbeb94d955b565$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $56cbeb94d955b565$var$_default() {
    var a = (0, $56cbeb94d955b565$var$_area.default)().curve($56cbeb94d955b565$var$_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $7auFH.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $7auFH.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $7auFH.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $7auFH.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $56cbeb94d955b565$var$_radial.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("dqrdl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.curveRadialLinear = void 0;
module.exports.default = $9c62d03c39ca9869$var$curveRadial;

var $9c62d03c39ca9869$var$_linear = $9c62d03c39ca9869$var$_interopRequireDefault((parcelRequire("1wm0G")));
function $9c62d03c39ca9869$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9c62d03c39ca9869$var$curveRadialLinear = $9c62d03c39ca9869$var$curveRadial($9c62d03c39ca9869$var$_linear.default);
module.exports.curveRadialLinear = $9c62d03c39ca9869$var$curveRadialLinear;
function $9c62d03c39ca9869$var$Radial(curve) {
    this._curve = curve;
}
$9c62d03c39ca9869$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $9c62d03c39ca9869$var$curveRadial(curve) {
    function radial(context) {
        return new $9c62d03c39ca9869$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("7auFH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5381424cea8627da$var$_default;
module.exports.lineRadial = $5381424cea8627da$var$lineRadial;

var $5381424cea8627da$var$_radial = $5381424cea8627da$var$_interopRequireWildcard((parcelRequire("dqrdl")));

var $5381424cea8627da$var$_line = $5381424cea8627da$var$_interopRequireDefault((parcelRequire("2gJml")));
function $5381424cea8627da$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5381424cea8627da$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($5381424cea8627da$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $5381424cea8627da$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $5381424cea8627da$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $5381424cea8627da$var$lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $5381424cea8627da$var$_radial.default)(_)) : c()._curve;
    };
    return l;
}
function $5381424cea8627da$var$_default() {
    return $5381424cea8627da$var$lineRadial((0, $5381424cea8627da$var$_line.default)().curve($5381424cea8627da$var$_radial.curveRadialLinear));
}

});


parcelRegister("5wAin", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $405c1869ebbc3c11$var$_default;
function $405c1869ebbc3c11$var$_default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("3WvWY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = $2def9285c4745f69$var$link;
module.exports.linkHorizontal = $2def9285c4745f69$var$linkHorizontal;
module.exports.linkRadial = $2def9285c4745f69$var$linkRadial;
module.exports.linkVertical = $2def9285c4745f69$var$linkVertical;

var $ahT4l = parcelRequire("ahT4l");

var $72xzV = parcelRequire("72xzV");

var $2def9285c4745f69$var$_constant = $2def9285c4745f69$var$_interopRequireDefault((parcelRequire("1SFIt")));

var $evZCX = parcelRequire("evZCX");

var $97E2D = parcelRequire("97E2D");
function $2def9285c4745f69$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2def9285c4745f69$var$linkSource(d) {
    return d.source;
}
function $2def9285c4745f69$var$linkTarget(d) {
    return d.target;
}
function $2def9285c4745f69$var$link(curve) {
    let source = $2def9285c4745f69$var$linkSource;
    let target = $2def9285c4745f69$var$linkTarget;
    let x = $97E2D.x;
    let y = $97E2D.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = $72xzV.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, $ahT4l.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $2def9285c4745f69$var$_constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $2def9285c4745f69$var$_constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $2def9285c4745f69$var$linkHorizontal() {
    return $2def9285c4745f69$var$link($evZCX.bumpX);
}
function $2def9285c4745f69$var$linkVertical() {
    return $2def9285c4745f69$var$link($evZCX.bumpY);
}
function $2def9285c4745f69$var$linkRadial() {
    const l = $2def9285c4745f69$var$link($evZCX.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRegister("evZCX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bumpRadial = $a913c3def1aa11e0$var$bumpRadial;
module.exports.bumpX = $a913c3def1aa11e0$var$bumpX;
module.exports.bumpY = $a913c3def1aa11e0$var$bumpY;

var $a913c3def1aa11e0$var$_pointRadial = $a913c3def1aa11e0$var$_interopRequireDefault((parcelRequire("5wAin")));
function $a913c3def1aa11e0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $a913c3def1aa11e0$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $a913c3def1aa11e0$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, $a913c3def1aa11e0$var$_pointRadial.default)(this._x0, this._y0);
            const p1 = (0, $a913c3def1aa11e0$var$_pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $a913c3def1aa11e0$var$_pointRadial.default)(x, this._y0);
            const p3 = (0, $a913c3def1aa11e0$var$_pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function $a913c3def1aa11e0$var$bumpX(context) {
    return new $a913c3def1aa11e0$var$Bump(context, true);
}
function $a913c3def1aa11e0$var$bumpY(context) {
    return new $a913c3def1aa11e0$var$Bump(context, false);
}
function $a913c3def1aa11e0$var$bumpRadial(context) {
    return new $a913c3def1aa11e0$var$BumpRadial(context);
}

});


parcelRegister("l3mP4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f53b94ec46d9e16d$var$Symbol;
module.exports.symbolsStroke = module.exports.symbolsFill = void 0;

var $ahT4l = parcelRequire("ahT4l");

var $f53b94ec46d9e16d$var$_constant = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("1SFIt")));

var $f53b94ec46d9e16d$var$_asterisk = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("hNi5e")));

var $f53b94ec46d9e16d$var$_circle = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("80b5j")));

var $f53b94ec46d9e16d$var$_cross = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("34kQO")));

var $f53b94ec46d9e16d$var$_diamond = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("aSxHZ")));

var $f53b94ec46d9e16d$var$_diamond2 = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("3rBZo")));

var $f53b94ec46d9e16d$var$_plus = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("l9ST9")));

var $f53b94ec46d9e16d$var$_square = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("3oWT7")));

var $f53b94ec46d9e16d$var$_square2 = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("k3QGU")));

var $f53b94ec46d9e16d$var$_star = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("1WZhf")));

var $f53b94ec46d9e16d$var$_triangle = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("hQr8g")));

var $f53b94ec46d9e16d$var$_triangle2 = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("NGszi")));

var $f53b94ec46d9e16d$var$_wye = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("7fYkN")));

var $f53b94ec46d9e16d$var$_x = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("3oXF4")));
function $f53b94ec46d9e16d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const $f53b94ec46d9e16d$var$symbolsFill = [
    $f53b94ec46d9e16d$var$_circle.default,
    $f53b94ec46d9e16d$var$_cross.default,
    $f53b94ec46d9e16d$var$_diamond.default,
    $f53b94ec46d9e16d$var$_square.default,
    $f53b94ec46d9e16d$var$_star.default,
    $f53b94ec46d9e16d$var$_triangle.default,
    $f53b94ec46d9e16d$var$_wye.default
]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).
module.exports.symbolsFill = $f53b94ec46d9e16d$var$symbolsFill;
const $f53b94ec46d9e16d$var$symbolsStroke = [
    $f53b94ec46d9e16d$var$_circle.default,
    $f53b94ec46d9e16d$var$_plus.default,
    $f53b94ec46d9e16d$var$_x.default,
    $f53b94ec46d9e16d$var$_triangle2.default,
    $f53b94ec46d9e16d$var$_asterisk.default,
    $f53b94ec46d9e16d$var$_square2.default,
    $f53b94ec46d9e16d$var$_diamond2.default
];
module.exports.symbolsStroke = $f53b94ec46d9e16d$var$symbolsStroke;
function $f53b94ec46d9e16d$var$Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, $f53b94ec46d9e16d$var$_constant.default)(type || $f53b94ec46d9e16d$var$_circle.default);
    size = typeof size === "function" ? size : (0, $f53b94ec46d9e16d$var$_constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, $ahT4l.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $f53b94ec46d9e16d$var$_constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $f53b94ec46d9e16d$var$_constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("hNi5e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
const $cf450a3c0731ada3$var$sqrt3 = (0, $8EE7R.sqrt)(3);
var $cf450a3c0731ada3$var$_default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size + (0, $8EE7R.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $cf450a3c0731ada3$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
module.exports.default = $cf450a3c0731ada3$var$_default;

});

parcelRegister("80b5j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
var $5d36ebfe49ab4f39$var$_default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size / $8EE7R.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, $8EE7R.tau);
    }
};
module.exports.default = $5d36ebfe49ab4f39$var$_default;

});

parcelRegister("34kQO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
var $23c1eb5d54df31fd$var$_default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};
module.exports.default = $23c1eb5d54df31fd$var$_default;

});

parcelRegister("aSxHZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
const $7eb9185183e161be$var$tan30 = (0, $8EE7R.sqrt)(1 / 3);
const $7eb9185183e161be$var$tan30_2 = $7eb9185183e161be$var$tan30 * 2;
var $7eb9185183e161be$var$_default = {
    draw (context, size) {
        const y = (0, $8EE7R.sqrt)(size / $7eb9185183e161be$var$tan30_2);
        const x = y * $7eb9185183e161be$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};
module.exports.default = $7eb9185183e161be$var$_default;

});

parcelRegister("3rBZo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
var $28215c91c44f670d$var$_default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};
module.exports.default = $28215c91c44f670d$var$_default;

});

parcelRegister("l9ST9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
var $f67503ef4c2b53b7$var$_default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size - (0, $8EE7R.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};
module.exports.default = $f67503ef4c2b53b7$var$_default;

});

parcelRegister("3oWT7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
var $27a14ae956ab4069$var$_default = {
    draw (context, size) {
        const w = (0, $8EE7R.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};
module.exports.default = $27a14ae956ab4069$var$_default;

});

parcelRegister("k3QGU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
var $e9acf5d321c8d9b2$var$_default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};
module.exports.default = $e9acf5d321c8d9b2$var$_default;

});

parcelRegister("1WZhf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
const $16babd934cfaf5dd$var$ka = 0.89081309152928522810;
const $16babd934cfaf5dd$var$kr = (0, $8EE7R.sin)($8EE7R.pi / 10) / (0, $8EE7R.sin)(7 * $8EE7R.pi / 10);
const $16babd934cfaf5dd$var$kx = (0, $8EE7R.sin)($8EE7R.tau / 10) * $16babd934cfaf5dd$var$kr;
const $16babd934cfaf5dd$var$ky = -(0, $8EE7R.cos)($8EE7R.tau / 10) * $16babd934cfaf5dd$var$kr;
var $16babd934cfaf5dd$var$_default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size * $16babd934cfaf5dd$var$ka);
        const x = $16babd934cfaf5dd$var$kx * r;
        const y = $16babd934cfaf5dd$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = $8EE7R.tau * i / 5;
            const c = (0, $8EE7R.cos)(a);
            const s = (0, $8EE7R.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};
module.exports.default = $16babd934cfaf5dd$var$_default;

});

parcelRegister("hQr8g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
const $cfdc56e10135b109$var$sqrt3 = (0, $8EE7R.sqrt)(3);
var $cfdc56e10135b109$var$_default = {
    draw (context, size) {
        const y = -(0, $8EE7R.sqrt)(size / ($cfdc56e10135b109$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$cfdc56e10135b109$var$sqrt3 * y, -y);
        context.lineTo($cfdc56e10135b109$var$sqrt3 * y, -y);
        context.closePath();
    }
};
module.exports.default = $cfdc56e10135b109$var$_default;

});

parcelRegister("NGszi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
const $095583585e5011bc$var$sqrt3 = (0, $8EE7R.sqrt)(3);
var $095583585e5011bc$var$_default = {
    draw (context, size) {
        const s = (0, $8EE7R.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $095583585e5011bc$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
module.exports.default = $095583585e5011bc$var$_default;

});

parcelRegister("7fYkN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
const $5488bc434537f81a$var$c = -0.5;
const $5488bc434537f81a$var$s = (0, $8EE7R.sqrt)(3) / 2;
const $5488bc434537f81a$var$k = 1 / (0, $8EE7R.sqrt)(12);
const $5488bc434537f81a$var$a = ($5488bc434537f81a$var$k / 2 + 1) * 3;
var $5488bc434537f81a$var$_default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size / $5488bc434537f81a$var$a);
        const x0 = r / 2, y0 = r * $5488bc434537f81a$var$k;
        const x1 = x0, y1 = r * $5488bc434537f81a$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($5488bc434537f81a$var$c * x0 - $5488bc434537f81a$var$s * y0, $5488bc434537f81a$var$s * x0 + $5488bc434537f81a$var$c * y0);
        context.lineTo($5488bc434537f81a$var$c * x1 - $5488bc434537f81a$var$s * y1, $5488bc434537f81a$var$s * x1 + $5488bc434537f81a$var$c * y1);
        context.lineTo($5488bc434537f81a$var$c * x2 - $5488bc434537f81a$var$s * y2, $5488bc434537f81a$var$s * x2 + $5488bc434537f81a$var$c * y2);
        context.lineTo($5488bc434537f81a$var$c * x0 + $5488bc434537f81a$var$s * y0, $5488bc434537f81a$var$c * y0 - $5488bc434537f81a$var$s * x0);
        context.lineTo($5488bc434537f81a$var$c * x1 + $5488bc434537f81a$var$s * y1, $5488bc434537f81a$var$c * y1 - $5488bc434537f81a$var$s * x1);
        context.lineTo($5488bc434537f81a$var$c * x2 + $5488bc434537f81a$var$s * y2, $5488bc434537f81a$var$c * y2 - $5488bc434537f81a$var$s * x2);
        context.closePath();
    }
};
module.exports.default = $5488bc434537f81a$var$_default;

});

parcelRegister("3oXF4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
var $27a1e47f32a4af98$var$_default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size - (0, $8EE7R.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};
module.exports.default = $27a1e47f32a4af98$var$_default;

});


parcelRegister("a65kp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $759e98ff97b5ba2e$var$_default;

var $759e98ff97b5ba2e$var$_noop = $759e98ff97b5ba2e$var$_interopRequireDefault((parcelRequire("9Id5q")));

var $4MmJ6 = parcelRequire("4MmJ6");
function $759e98ff97b5ba2e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $759e98ff97b5ba2e$var$BasisClosed(context) {
    this._context = context;
}
$759e98ff97b5ba2e$var$BasisClosed.prototype = {
    areaStart: $759e98ff97b5ba2e$var$_noop.default,
    areaEnd: $759e98ff97b5ba2e$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $4MmJ6.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $759e98ff97b5ba2e$var$_default(context) {
    return new $759e98ff97b5ba2e$var$BasisClosed(context);
}

});
parcelRegister("9Id5q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $71225fd811f521df$var$_default;
function $71225fd811f521df$var$_default() {}

});

parcelRegister("4MmJ6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Basis = $37ad461e07222a10$var$Basis;
module.exports.default = $37ad461e07222a10$var$_default;
module.exports.point = $37ad461e07222a10$var$point;
function $37ad461e07222a10$var$point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $37ad461e07222a10$var$Basis(context) {
    this._context = context;
}
$37ad461e07222a10$var$Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $37ad461e07222a10$var$point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                $37ad461e07222a10$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $37ad461e07222a10$var$_default(context) {
    return new $37ad461e07222a10$var$Basis(context);
}

});


parcelRegister("aFwZp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7c4752bb83e8ecae$var$_default;

var $4MmJ6 = parcelRequire("4MmJ6");
function $7c4752bb83e8ecae$var$BasisOpen(context) {
    this._context = context;
}
$7c4752bb83e8ecae$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $4MmJ6.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $7c4752bb83e8ecae$var$_default(context) {
    return new $7c4752bb83e8ecae$var$BasisOpen(context);
}

});

parcelRegister("1uOPP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4MmJ6 = parcelRequire("4MmJ6");
function $117006928d6a0b46$var$Bundle(context, beta) {
    this._basis = new $4MmJ6.Basis(context);
    this._beta = beta;
}
$117006928d6a0b46$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $117006928d6a0b46$var$_default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new $4MmJ6.Basis(context) : new $117006928d6a0b46$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);
module.exports.default = $117006928d6a0b46$var$_default;

});

parcelRegister("1RBVE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalClosed = $15b8298ff61d0817$var$CardinalClosed;
module.exports.default = void 0;

var $15b8298ff61d0817$var$_noop = $15b8298ff61d0817$var$_interopRequireDefault((parcelRequire("9Id5q")));

var $8MEVA = parcelRequire("8MEVA");
function $15b8298ff61d0817$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $15b8298ff61d0817$var$CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$15b8298ff61d0817$var$CardinalClosed.prototype = {
    areaStart: $15b8298ff61d0817$var$_noop.default,
    areaEnd: $15b8298ff61d0817$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $8MEVA.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $15b8298ff61d0817$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $15b8298ff61d0817$var$CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $15b8298ff61d0817$var$_default;

});
parcelRegister("8MEVA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cardinal = $66528dd5d1af4c7e$var$Cardinal;
module.exports.default = void 0;
module.exports.point = $66528dd5d1af4c7e$var$point;
function $66528dd5d1af4c7e$var$point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $66528dd5d1af4c7e$var$Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$66528dd5d1af4c7e$var$Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $66528dd5d1af4c7e$var$point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $66528dd5d1af4c7e$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $66528dd5d1af4c7e$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $66528dd5d1af4c7e$var$Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $66528dd5d1af4c7e$var$_default;

});


parcelRegister("88R3u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalOpen = $5ed839c05fa37c42$var$CardinalOpen;
module.exports.default = void 0;

var $8MEVA = parcelRequire("8MEVA");
function $5ed839c05fa37c42$var$CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$5ed839c05fa37c42$var$CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $8MEVA.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $5ed839c05fa37c42$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $5ed839c05fa37c42$var$CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $5ed839c05fa37c42$var$_default;

});

parcelRegister("63Rg9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1RBVE = parcelRequire("1RBVE");

var $469c561ba2a63423$var$_noop = $469c561ba2a63423$var$_interopRequireDefault((parcelRequire("9Id5q")));

var $jeCIz = parcelRequire("jeCIz");
function $469c561ba2a63423$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $469c561ba2a63423$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$469c561ba2a63423$var$CatmullRomClosed.prototype = {
    areaStart: $469c561ba2a63423$var$_noop.default,
    areaEnd: $469c561ba2a63423$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $jeCIz.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $469c561ba2a63423$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $469c561ba2a63423$var$CatmullRomClosed(context, alpha) : new $1RBVE.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $469c561ba2a63423$var$_default;

});
parcelRegister("jeCIz", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;

var $8EE7R = parcelRequire("8EE7R");

var $8MEVA = parcelRequire("8MEVA");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > $8EE7R.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > $8EE7R.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new $8MEVA.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

});


parcelRegister("4JV2s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88R3u = parcelRequire("88R3u");

var $jeCIz = parcelRequire("jeCIz");
function $37379c0e81acd368$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$37379c0e81acd368$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $jeCIz.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $37379c0e81acd368$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $37379c0e81acd368$var$CatmullRomOpen(context, alpha) : new $88R3u.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $37379c0e81acd368$var$_default;

});

parcelRegister("7HCNf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $59baa41516fc43b4$var$_default;

var $59baa41516fc43b4$var$_noop = $59baa41516fc43b4$var$_interopRequireDefault((parcelRequire("9Id5q")));
function $59baa41516fc43b4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $59baa41516fc43b4$var$LinearClosed(context) {
    this._context = context;
}
$59baa41516fc43b4$var$LinearClosed.prototype = {
    areaStart: $59baa41516fc43b4$var$_noop.default,
    areaEnd: $59baa41516fc43b4$var$_noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $59baa41516fc43b4$var$_default(context) {
    return new $59baa41516fc43b4$var$LinearClosed(context);
}

});

parcelRegister("eqBPr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneX = $a810d6679ecb238b$var$monotoneX;
module.exports.monotoneY = $a810d6679ecb238b$var$monotoneY;
function $a810d6679ecb238b$var$sign(x) {
    return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $a810d6679ecb238b$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($a810d6679ecb238b$var$sign(s0) + $a810d6679ecb238b$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.
function $a810d6679ecb238b$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $a810d6679ecb238b$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $a810d6679ecb238b$var$MonotoneX(context) {
    this._context = context;
}
$a810d6679ecb238b$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $a810d6679ecb238b$var$point(this, this._t0, $a810d6679ecb238b$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $a810d6679ecb238b$var$point(this, $a810d6679ecb238b$var$slope2(this, t1 = $a810d6679ecb238b$var$slope3(this, x, y)), t1);
                break;
            default:
                $a810d6679ecb238b$var$point(this, this._t0, t1 = $a810d6679ecb238b$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $a810d6679ecb238b$var$MonotoneY(context) {
    this._context = new $a810d6679ecb238b$var$ReflectContext(context);
}
($a810d6679ecb238b$var$MonotoneY.prototype = Object.create($a810d6679ecb238b$var$MonotoneX.prototype)).point = function(x, y) {
    $a810d6679ecb238b$var$MonotoneX.prototype.point.call(this, y, x);
};
function $a810d6679ecb238b$var$ReflectContext(context) {
    this._context = context;
}
$a810d6679ecb238b$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $a810d6679ecb238b$var$monotoneX(context) {
    return new $a810d6679ecb238b$var$MonotoneX(context);
}
function $a810d6679ecb238b$var$monotoneY(context) {
    return new $a810d6679ecb238b$var$MonotoneY(context);
}

});

parcelRegister("dY7QQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a2b6f811606136fa$var$_default;
function $a2b6f811606136fa$var$Natural(context) {
    this._context = context;
}
$a2b6f811606136fa$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $a2b6f811606136fa$var$controlPoints(x), py = $a2b6f811606136fa$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $a2b6f811606136fa$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $a2b6f811606136fa$var$_default(context) {
    return new $a2b6f811606136fa$var$Natural(context);
}

});

parcelRegister("llSQy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f8b61a9052882a76$var$_default;
module.exports.stepAfter = $f8b61a9052882a76$var$stepAfter;
module.exports.stepBefore = $f8b61a9052882a76$var$stepBefore;
function $f8b61a9052882a76$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$f8b61a9052882a76$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $f8b61a9052882a76$var$_default(context) {
    return new $f8b61a9052882a76$var$Step(context, 0.5);
}
function $f8b61a9052882a76$var$stepBefore(context) {
    return new $f8b61a9052882a76$var$Step(context, 0);
}
function $f8b61a9052882a76$var$stepAfter(context) {
    return new $f8b61a9052882a76$var$Step(context, 1);
}

});

parcelRegister("l6qno", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f5ce9e484cf7993d$var$_default;

var $f5ce9e484cf7993d$var$_array = $f5ce9e484cf7993d$var$_interopRequireDefault((parcelRequire("72xzV")));

var $f5ce9e484cf7993d$var$_constant = $f5ce9e484cf7993d$var$_interopRequireDefault((parcelRequire("1SFIt")));

var $f5ce9e484cf7993d$var$_none = $f5ce9e484cf7993d$var$_interopRequireDefault((parcelRequire("7CMPN")));

var $f5ce9e484cf7993d$var$_none2 = $f5ce9e484cf7993d$var$_interopRequireDefault((parcelRequire("5Nf2s")));
function $f5ce9e484cf7993d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f5ce9e484cf7993d$var$stackValue(d, key) {
    return d[key];
}
function $f5ce9e484cf7993d$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $f5ce9e484cf7993d$var$_default() {
    var keys = (0, $f5ce9e484cf7993d$var$_constant.default)([]), order = $f5ce9e484cf7993d$var$_none2.default, offset = $f5ce9e484cf7993d$var$_none.default, value = $f5ce9e484cf7993d$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $f5ce9e484cf7993d$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $f5ce9e484cf7993d$var$_array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $f5ce9e484cf7993d$var$_constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $f5ce9e484cf7993d$var$_constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? $f5ce9e484cf7993d$var$_none2.default : typeof _ === "function" ? _ : (0, $f5ce9e484cf7993d$var$_constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? $f5ce9e484cf7993d$var$_none.default : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("7CMPN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $58d1f689330b7a76$var$_default;
function $58d1f689330b7a76$var$_default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("5Nf2s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $437d31b0a43c0970$var$_default;
function $437d31b0a43c0970$var$_default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("fpjqO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b378437dd6c974d0$var$_default;

var $b378437dd6c974d0$var$_none = $b378437dd6c974d0$var$_interopRequireDefault((parcelRequire("7CMPN")));
function $b378437dd6c974d0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b378437dd6c974d0$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $b378437dd6c974d0$var$_none.default)(series, order);
}

});

parcelRegister("l5EV1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f5a9ce2ee69901dc$var$_default;
function $f5a9ce2ee69901dc$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("4ViQy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $395b1adc41e49f8c$var$_default;

var $395b1adc41e49f8c$var$_none = $395b1adc41e49f8c$var$_interopRequireDefault((parcelRequire("7CMPN")));
function $395b1adc41e49f8c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $395b1adc41e49f8c$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $395b1adc41e49f8c$var$_none.default)(series, order);
}

});

parcelRegister("fIpqC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b70eb098f6aa193f$var$_default;

var $b70eb098f6aa193f$var$_none = $b70eb098f6aa193f$var$_interopRequireDefault((parcelRequire("7CMPN")));
function $b70eb098f6aa193f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b70eb098f6aa193f$var$_default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $b70eb098f6aa193f$var$_none.default)(series, order);
}

});

parcelRegister("5qWRn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f4d09d5c255cbed$var$_default;

var $3f4d09d5c255cbed$var$_none = $3f4d09d5c255cbed$var$_interopRequireDefault((parcelRequire("5Nf2s")));
function $3f4d09d5c255cbed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3f4d09d5c255cbed$var$_default(series) {
    var peaks = series.map($3f4d09d5c255cbed$var$peak);
    return (0, $3f4d09d5c255cbed$var$_none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $3f4d09d5c255cbed$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRegister("klspr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ecfbce4dec6048ef$var$_default;
module.exports.sum = $ecfbce4dec6048ef$var$sum;

var $ecfbce4dec6048ef$var$_none = $ecfbce4dec6048ef$var$_interopRequireDefault((parcelRequire("5Nf2s")));
function $ecfbce4dec6048ef$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ecfbce4dec6048ef$var$_default(series) {
    var sums = series.map($ecfbce4dec6048ef$var$sum);
    return (0, $ecfbce4dec6048ef$var$_none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $ecfbce4dec6048ef$var$sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("kwAJ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ef1348de13f9b72a$var$_default;

var $ef1348de13f9b72a$var$_ascending = $ef1348de13f9b72a$var$_interopRequireDefault((parcelRequire("klspr")));
function $ef1348de13f9b72a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ef1348de13f9b72a$var$_default(series) {
    return (0, $ef1348de13f9b72a$var$_ascending.default)(series).reverse();
}

});

parcelRegister("4fWJp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $31961efae4ac3cd9$var$_default;

var $31961efae4ac3cd9$var$_appearance = $31961efae4ac3cd9$var$_interopRequireDefault((parcelRequire("5qWRn")));

var $klspr = parcelRequire("klspr");
function $31961efae4ac3cd9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $31961efae4ac3cd9$var$_default(series) {
    var n = series.length, i, j, sums = series.map($klspr.sum), order = (0, $31961efae4ac3cd9$var$_appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("aFPqy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7c55a01e302bb624$var$_default;

var $7c55a01e302bb624$var$_none = $7c55a01e302bb624$var$_interopRequireDefault((parcelRequire("5Nf2s")));
function $7c55a01e302bb624$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7c55a01e302bb624$var$_default(series) {
    return (0, $7c55a01e302bb624$var$_none.default)(series).reverse();
}

});



var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));



var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));




var $acw62 = parcelRequire("acw62");
var $ba3ca70f36990d50$export$27a5bd065ad55220 = /*#__PURE__*/ function(View) {
    View["DASHBOARD"] = "DASHBOARD";
    View["STUDY_PLAN"] = "STUDY_PLAN";
    View["PROGRESS"] = "PROGRESS";
    View["QUIZ"] = "QUIZ";
    View["PDF_CHAT"] = "PDF_CHAT";
    return View;
}({});



var $acw62 = parcelRequire("acw62");
function $db9b33d6dfbcb14b$var$useLocalStorage(key, initialValue) {
    const [storedValue, setStoredValue] = (0, $acw62.useState)(()=>{
        if (typeof window === 'undefined') return initialValue;
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            console.error(error);
            return initialValue;
        }
    });
    const setValue = (value)=>{
        try {
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            if (typeof window !== 'undefined') window.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (error) {
            console.error(error);
        }
    };
    (0, $acw62.useEffect)(()=>{
        const handleStorageChange = (e)=>{
            if (e.key === key && e.newValue) setStoredValue(JSON.parse(e.newValue));
        };
        window.addEventListener('storage', handleStorageChange);
        return ()=>{
            window.removeEventListener('storage', handleStorageChange);
        };
    }, [
        key
    ]);
    return [
        storedValue,
        setValue
    ];
}
var $db9b33d6dfbcb14b$export$2e2bcd8739ae039 = $db9b33d6dfbcb14b$var$useLocalStorage;



parcelRequire("acw62");


parcelRequire("acw62");
// Common props for icons for consistency
const $6e7fd069000a3c94$var$iconProps = {
    strokeWidth: "1.5",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor"
};
const $6e7fd069000a3c94$export$32d9dd3fbd9d1c94 = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        ...$6e7fd069000a3c94$var$iconProps,
        className: "w-6 h-6",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"
            })
        ]
    });
const $6e7fd069000a3c94$export$9da4f9d7ed027300 = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        ...$6e7fd069000a3c94$var$iconProps,
        className: "w-6 h-6",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3 3v18h18"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18 17V9"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13 17V5"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 17v-3"
            })
        ]
    });
const $6e7fd069000a3c94$export$92c8767b874048d = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        ...$6e7fd069000a3c94$var$iconProps,
        className: "w-6 h-6",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polyline", {
                points: "9 22 9 12 15 12 15 22"
            })
        ]
    });
const $6e7fd069000a3c94$export$c22e6465b9308d1c = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        ...$6e7fd069000a3c94$var$iconProps,
        className: "w-6 h-6",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
        })
    });
const $6e7fd069000a3c94$export$5e658a8851ae9322 = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        ...$6e7fd069000a3c94$var$iconProps,
        className: "w-6 h-6",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "18",
                y1: "6",
                x2: "6",
                y2: "18"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "6",
                y1: "6",
                x2: "18",
                y2: "18"
            })
        ]
    });
const $6e7fd069000a3c94$export$f6dd727656c97851 = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        ...$6e7fd069000a3c94$var$iconProps,
        className: "w-6 h-6",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M22 11.08V12a10 10 0 1 1-5.93-9.14"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polyline", {
                points: "22 4 12 14.01 9 11.01"
            })
        ]
    });
const $6e7fd069000a3c94$export$c1eff5f0d5951e22 = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        ...$6e7fd069000a3c94$var$iconProps,
        className: "w-6 h-6",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"
        })
    });
const $6e7fd069000a3c94$export$7dd004358974b05d = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        ...$6e7fd069000a3c94$var$iconProps,
        className: "w-4 h-4 text-white",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polyline", {
            points: "20 6 9 17 4 12"
        })
    });
const $6e7fd069000a3c94$export$647aae5028016fe9 = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: "w-6 h-6 animate-spin",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
        ]
    });
const $6e7fd069000a3c94$export$592efa5f07538585 = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        ...$6e7fd069000a3c94$var$iconProps,
        className: "w-6 h-6",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19 10v2a7 7 0 0 1-14 0v-2"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "12",
                y1: "19",
                x2: "12",
                y2: "22"
            })
        ]
    });
const $6e7fd069000a3c94$export$8ab25e1bd13dc8cb = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        ...$6e7fd069000a3c94$var$iconProps,
        className: "w-5 h-5",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M22 2 11 13"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m22 2-7 20-4-9-9-4 20-7z"
            })
        ]
    });
const $6e7fd069000a3c94$export$a05b22346a85e647 = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        ...$6e7fd069000a3c94$var$iconProps,
        className: "w-6 h-6",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "m12 3-1.9 1.9-1.4-1.4-1.9 1.9-1.9-1.9L3.5 5l-1.9 1.9L3 8.8l1.9 1.9-1.9 1.9-1.4 1.4 1.9 1.9 1.9-1.9L5 20.5l1.9-1.9L8.8 21l1.9-1.9 1.9 1.9 1.4 1.4-1.9-1.9-1.9 1.9L19 19.1l1.9-1.9-1.4-1.4 1.9-1.9 1.9 1.9L20.5 12l1.9-1.9-1.9-1.9L21 3.5l-1.9 1.9-1.9-1.9Z"
        })
    });
const $6e7fd069000a3c94$export$b441c9149b23e64e = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        ...$6e7fd069000a3c94$var$iconProps,
        className: "w-6 h-6",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.54 8.46a5 5 0 0 1 0 7.07"
            })
        ]
    });
const $6e7fd069000a3c94$export$2ea670c40c4ad81b = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        ...$6e7fd069000a3c94$var$iconProps,
        className: "w-6 h-6",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "8",
                height: "4",
                x: "8",
                y: "2",
                rx: "1",
                ry: "1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m9 14 2 2 4-4"
            })
        ]
    });
const $6e7fd069000a3c94$export$605674723bcc715c = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        ...$6e7fd069000a3c94$var$iconProps,
        className: "w-6 h-6",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polyline", {
                points: "14 2 14 8 20 8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "16",
                y1: "13",
                x2: "8",
                y2: "13"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "16",
                y1: "17",
                x2: "8",
                y2: "17"
            })
        ]
    });
const $6e7fd069000a3c94$export$6b5c34a0be8f60b9 = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        ...$6e7fd069000a3c94$var$iconProps,
        className: "w-12 h-12 mx-auto text-gray-500",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 12v9"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m16 16-4-4-4 4"
            })
        ]
    });


const $b993228d74a8acd1$var$StatCard = ({ icon: icon, title: title, value: value, color: color })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bg-gray-800/50 p-6 rounded-2xl shadow-lg flex items-center space-x-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `p-3 rounded-full ${color}`,
                children: icon
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-gray-400 text-sm",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-2xl font-bold text-white",
                        children: value
                    })
                ]
            })
        ]
    });
const $b993228d74a8acd1$var$Dashboard = ({ setView: setView, progress: progress, studyPlan: studyPlan })=>{
    const today = new Date().getDay(); // Sunday - 0, Monday - 1, etc.
    const todaysPlan = studyPlan?.days.find((d)=>d.day % 7 === today % 7);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "animate-fade-in space-y-8",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        className: "text-4xl font-extrabold text-white tracking-tight",
                        children: "Welcome Back!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-lg text-gray-400 mt-2",
                        children: "Ready to dive in and learn something new today?"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b993228d74a8acd1$var$StatCard, {
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e7fd069000a3c94$export$c1eff5f0d5951e22), {}),
                        title: "Current Streak",
                        value: `${progress.streak} days`,
                        color: "bg-orange-500/30"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b993228d74a8acd1$var$StatCard, {
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e7fd069000a3c94$export$f6dd727656c97851), {}),
                        title: "Tasks Completed",
                        value: progress.completedTasks,
                        color: "bg-green-500/30"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b993228d74a8acd1$var$StatCard, {
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e7fd069000a3c94$export$32d9dd3fbd9d1c94), {}),
                        title: "Current Subject",
                        value: studyPlan?.subject || 'None Set',
                        color: "bg-blue-500/30"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-gray-800/50 p-6 rounded-2xl shadow-lg space-y-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-2xl font-bold text-white",
                        children: "Today's Focus"
                    }),
                    todaysPlan ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-blue-400 font-semibold",
                                children: todaysPlan.topic
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                className: "list-disc list-inside text-gray-300 mt-2 space-y-1",
                                children: [
                                    todaysPlan.tasks.slice(0, 3).map((task)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: task.name
                                        }, task.id)),
                                    todaysPlan.tasks.length > 3 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: "...and more"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>setView((0, $ba3ca70f36990d50$export$27a5bd065ad55220).STUDY_PLAN),
                                className: "mt-4 text-blue-400 font-semibold hover:text-blue-300 transition-colors",
                                children: "View Full Plan \u2192"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-400",
                                children: "No study plan found for today."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>setView((0, $ba3ca70f36990d50$export$27a5bd065ad55220).STUDY_PLAN),
                                className: "mt-4 text-blue-400 font-semibold hover:text-blue-300 transition-colors",
                                children: "Generate a New Plan \u2192"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $b993228d74a8acd1$export$2e2bcd8739ae039 = $b993228d74a8acd1$var$Dashboard;




var $acw62 = parcelRequire("acw62");
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ let $e4deb49dba5321bc$var$_defaultBaseGeminiUrl = undefined;
let $e4deb49dba5321bc$var$_defaultBaseVertexUrl = undefined;
/**
 * Overrides the base URLs for the Gemini API and Vertex AI API.
 *
 * @remarks This function should be called before initializing the SDK. If the
 * base URLs are set after initializing the SDK, the base URLs will not be
 * updated. Base URLs provided in the HttpOptions will also take precedence over
 * URLs set here.
 *
 * @example
 * ```ts
 * import {GoogleGenAI, setDefaultBaseUrls} from '@google/genai';
 * // Override the base URL for the Gemini API.
 * setDefaultBaseUrls({geminiUrl:'https://gemini.google.com'});
 *
 * // Override the base URL for the Vertex AI API.
 * setDefaultBaseUrls({vertexUrl: 'https://vertexai.googleapis.com'});
 *
 * const ai = new GoogleGenAI({apiKey: 'GEMINI_API_KEY'});
 * ```
 */ function $e4deb49dba5321bc$export$73f5ab1d327f9edc(baseUrlParams) {
    $e4deb49dba5321bc$var$_defaultBaseGeminiUrl = baseUrlParams.geminiUrl;
    $e4deb49dba5321bc$var$_defaultBaseVertexUrl = baseUrlParams.vertexUrl;
}
/**
 * Returns the default base URLs for the Gemini API and Vertex AI API.
 */ function $e4deb49dba5321bc$var$getDefaultBaseUrls() {
    return {
        geminiUrl: $e4deb49dba5321bc$var$_defaultBaseGeminiUrl,
        vertexUrl: $e4deb49dba5321bc$var$_defaultBaseVertexUrl
    };
}
/**
 * Returns the default base URL based on the following priority:
 *   1. Base URLs set via HttpOptions.
 *   2. Base URLs set via the latest call to setDefaultBaseUrls.
 *   3. Base URLs set via environment variables.
 */ function $e4deb49dba5321bc$var$getBaseUrl(httpOptions, vertexai, vertexBaseUrlFromEnv, geminiBaseUrlFromEnv) {
    var _a, _b;
    if (!(httpOptions === null || httpOptions === void 0 ? void 0 : httpOptions.baseUrl)) {
        const defaultBaseUrls = $e4deb49dba5321bc$var$getDefaultBaseUrls();
        if (vertexai) return (_a = defaultBaseUrls.vertexUrl) !== null && _a !== void 0 ? _a : vertexBaseUrlFromEnv;
        else return (_b = defaultBaseUrls.geminiUrl) !== null && _b !== void 0 ? _b : geminiBaseUrlFromEnv;
    }
    return httpOptions.baseUrl;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$var$BaseModule {
}
function $e4deb49dba5321bc$var$formatMap(templateString, valueMap) {
    // Use a regular expression to find all placeholders in the template string
    const regex = /\{([^}]+)\}/g;
    // Replace each placeholder with its corresponding value from the valueMap
    return templateString.replace(regex, (match, key)=>{
        if (Object.prototype.hasOwnProperty.call(valueMap, key)) {
            const value = valueMap[key];
            // Convert the value to a string if it's not a string already
            return value !== undefined && value !== null ? String(value) : '';
        } else // Handle missing keys
        throw new Error(`Key '${key}' not found in valueMap.`);
    });
}
function $e4deb49dba5321bc$var$setValueByPath(data, keys, value) {
    for(let i = 0; i < keys.length - 1; i++){
        const key = keys[i];
        if (key.endsWith('[]')) {
            const keyName = key.slice(0, -2);
            if (!(keyName in data)) {
                if (Array.isArray(value)) data[keyName] = Array.from({
                    length: value.length
                }, ()=>({}));
                else throw new Error(`Value must be a list given an array path ${key}`);
            }
            if (Array.isArray(data[keyName])) {
                const arrayData = data[keyName];
                if (Array.isArray(value)) for(let j = 0; j < arrayData.length; j++){
                    const entry = arrayData[j];
                    $e4deb49dba5321bc$var$setValueByPath(entry, keys.slice(i + 1), value[j]);
                }
                else for (const d of arrayData)$e4deb49dba5321bc$var$setValueByPath(d, keys.slice(i + 1), value);
            }
            return;
        } else if (key.endsWith('[0]')) {
            const keyName = key.slice(0, -3);
            if (!(keyName in data)) data[keyName] = [
                {}
            ];
            const arrayData = data[keyName];
            $e4deb49dba5321bc$var$setValueByPath(arrayData[0], keys.slice(i + 1), value);
            return;
        }
        if (!data[key] || typeof data[key] !== 'object') data[key] = {};
        data = data[key];
    }
    const keyToSet = keys[keys.length - 1];
    const existingData = data[keyToSet];
    if (existingData !== undefined) {
        if (!value || typeof value === 'object' && Object.keys(value).length === 0) return;
        if (value === existingData) return;
        if (typeof existingData === 'object' && typeof value === 'object' && existingData !== null && value !== null) Object.assign(existingData, value);
        else throw new Error(`Cannot set value for an existing key. Key: ${keyToSet}`);
    } else if (keyToSet === '_self' && typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const valueAsRecord = value;
        Object.assign(data, valueAsRecord);
    } else data[keyToSet] = value;
}
function $e4deb49dba5321bc$var$getValueByPath(data, keys) {
    try {
        if (keys.length === 1 && keys[0] === '_self') return data;
        for(let i = 0; i < keys.length; i++){
            if (typeof data !== 'object' || data === null) return undefined;
            const key = keys[i];
            if (key.endsWith('[]')) {
                const keyName = key.slice(0, -2);
                if (keyName in data) {
                    const arrayData = data[keyName];
                    if (!Array.isArray(arrayData)) return undefined;
                    return arrayData.map((d)=>$e4deb49dba5321bc$var$getValueByPath(d, keys.slice(i + 1)));
                } else return undefined;
            } else data = data[key];
        }
        return data;
    } catch (error) {
        if (error instanceof TypeError) return undefined;
        throw error;
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$tBytes$1(fromBytes) {
    if (typeof fromBytes !== 'string') throw new Error('fromImageBytes must be a string');
    // TODO(b/389133914): Remove dummy bytes converter.
    return fromBytes;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // Code generated by the Google Gen AI SDK generator DO NOT EDIT.
function $e4deb49dba5321bc$var$getOperationParametersToMldev(fromObject) {
    const toObject = {};
    const fromOperationName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'operationName'
    ]);
    if (fromOperationName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'operationName'
    ], fromOperationName);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$fetchPredictOperationParametersToVertex(fromObject) {
    const toObject = {};
    const fromOperationName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'operationName'
    ]);
    if (fromOperationName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'operationName'
    ], fromOperationName);
    const fromResourceName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'resourceName'
    ]);
    if (fromResourceName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'resourceName'
    ], fromResourceName);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$getOperationParametersToVertex(fromObject) {
    const toObject = {};
    const fromOperationName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'operationName'
    ]);
    if (fromOperationName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'operationName'
    ], fromOperationName);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$videoFromMldev$1(fromObject) {
    const toObject = {};
    const fromUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video',
        'uri'
    ]);
    if (fromUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'uri'
    ], fromUri);
    const fromVideoBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video',
        'encodedVideo'
    ]);
    if (fromVideoBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoBytes'
    ], $e4deb49dba5321bc$var$tBytes$1(fromVideoBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'encoding'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$generatedVideoFromMldev$1(fromObject) {
    const toObject = {};
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'video'
    ], $e4deb49dba5321bc$var$videoFromMldev$1(fromVideo));
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosResponseFromMldev$1(fromObject) {
    const toObject = {};
    const fromGeneratedVideos = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generatedSamples'
    ]);
    if (fromGeneratedVideos != null) {
        let transformedList = fromGeneratedVideos;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedVideoFromMldev$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedVideos'
        ], transformedList);
    }
    const fromRaiMediaFilteredCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiMediaFilteredCount'
    ]);
    if (fromRaiMediaFilteredCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiMediaFilteredCount'
    ], fromRaiMediaFilteredCount);
    const fromRaiMediaFilteredReasons = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiMediaFilteredReasons'
    ]);
    if (fromRaiMediaFilteredReasons != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiMediaFilteredReasons'
    ], fromRaiMediaFilteredReasons);
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosOperationFromMldev$1(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response',
        'generateVideoResponse'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], $e4deb49dba5321bc$var$generateVideosResponseFromMldev$1(fromResponse));
    return toObject;
}
function $e4deb49dba5321bc$var$videoFromVertex$1(fromObject) {
    const toObject = {};
    const fromUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'uri'
    ], fromUri);
    const fromVideoBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bytesBase64Encoded'
    ]);
    if (fromVideoBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoBytes'
    ], $e4deb49dba5321bc$var$tBytes$1(fromVideoBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$generatedVideoFromVertex$1(fromObject) {
    const toObject = {};
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'video'
    ], $e4deb49dba5321bc$var$videoFromVertex$1(fromVideo));
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosResponseFromVertex$1(fromObject) {
    const toObject = {};
    const fromGeneratedVideos = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videos'
    ]);
    if (fromGeneratedVideos != null) {
        let transformedList = fromGeneratedVideos;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedVideoFromVertex$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedVideos'
        ], transformedList);
    }
    const fromRaiMediaFilteredCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiMediaFilteredCount'
    ]);
    if (fromRaiMediaFilteredCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiMediaFilteredCount'
    ], fromRaiMediaFilteredCount);
    const fromRaiMediaFilteredReasons = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiMediaFilteredReasons'
    ]);
    if (fromRaiMediaFilteredReasons != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiMediaFilteredReasons'
    ], fromRaiMediaFilteredReasons);
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosOperationFromVertex$1(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], $e4deb49dba5321bc$var$generateVideosResponseFromVertex$1(fromResponse));
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /** Required. Outcome of the code execution. */ var $e4deb49dba5321bc$export$524cbb9c5a897bf8;
(function(Outcome) {
    /**
     * Unspecified status. This value should not be used.
     */ Outcome["OUTCOME_UNSPECIFIED"] = "OUTCOME_UNSPECIFIED";
    /**
     * Code execution completed successfully.
     */ Outcome["OUTCOME_OK"] = "OUTCOME_OK";
    /**
     * Code execution finished but with a failure. `stderr` should contain the reason.
     */ Outcome["OUTCOME_FAILED"] = "OUTCOME_FAILED";
    /**
     * Code execution ran for too long, and was cancelled. There may or may not be a partial output present.
     */ Outcome["OUTCOME_DEADLINE_EXCEEDED"] = "OUTCOME_DEADLINE_EXCEEDED";
})($e4deb49dba5321bc$export$524cbb9c5a897bf8 || ($e4deb49dba5321bc$export$524cbb9c5a897bf8 = {}));
/** Required. Programming language of the `code`. */ var $e4deb49dba5321bc$export$ce4fe1c9e6520c1a;
(function(Language) {
    /**
     * Unspecified language. This value should not be used.
     */ Language["LANGUAGE_UNSPECIFIED"] = "LANGUAGE_UNSPECIFIED";
    /**
     * Python >= 3.10, with numpy and simpy available.
     */ Language["PYTHON"] = "PYTHON";
})($e4deb49dba5321bc$export$ce4fe1c9e6520c1a || ($e4deb49dba5321bc$export$ce4fe1c9e6520c1a = {}));
/** Optional. The type of the data. */ var $e4deb49dba5321bc$export$92738401e1603719;
(function(Type) {
    /**
     * Not specified, should not be used.
     */ Type["TYPE_UNSPECIFIED"] = "TYPE_UNSPECIFIED";
    /**
     * OpenAPI string type
     */ Type["STRING"] = "STRING";
    /**
     * OpenAPI number type
     */ Type["NUMBER"] = "NUMBER";
    /**
     * OpenAPI integer type
     */ Type["INTEGER"] = "INTEGER";
    /**
     * OpenAPI boolean type
     */ Type["BOOLEAN"] = "BOOLEAN";
    /**
     * OpenAPI array type
     */ Type["ARRAY"] = "ARRAY";
    /**
     * OpenAPI object type
     */ Type["OBJECT"] = "OBJECT";
    /**
     * Null type
     */ Type["NULL"] = "NULL";
})($e4deb49dba5321bc$export$92738401e1603719 || ($e4deb49dba5321bc$export$92738401e1603719 = {}));
/** Required. Harm category. */ var $e4deb49dba5321bc$export$798c77e44df53af3;
(function(HarmCategory) {
    /**
     * The harm category is unspecified.
     */ HarmCategory["HARM_CATEGORY_UNSPECIFIED"] = "HARM_CATEGORY_UNSPECIFIED";
    /**
     * The harm category is hate speech.
     */ HarmCategory["HARM_CATEGORY_HATE_SPEECH"] = "HARM_CATEGORY_HATE_SPEECH";
    /**
     * The harm category is dangerous content.
     */ HarmCategory["HARM_CATEGORY_DANGEROUS_CONTENT"] = "HARM_CATEGORY_DANGEROUS_CONTENT";
    /**
     * The harm category is harassment.
     */ HarmCategory["HARM_CATEGORY_HARASSMENT"] = "HARM_CATEGORY_HARASSMENT";
    /**
     * The harm category is sexually explicit content.
     */ HarmCategory["HARM_CATEGORY_SEXUALLY_EXPLICIT"] = "HARM_CATEGORY_SEXUALLY_EXPLICIT";
    /**
     * Deprecated: Election filter is not longer supported. The harm category is civic integrity.
     */ HarmCategory["HARM_CATEGORY_CIVIC_INTEGRITY"] = "HARM_CATEGORY_CIVIC_INTEGRITY";
    /**
     * The harm category is image hate.
     */ HarmCategory["HARM_CATEGORY_IMAGE_HATE"] = "HARM_CATEGORY_IMAGE_HATE";
    /**
     * The harm category is image dangerous content.
     */ HarmCategory["HARM_CATEGORY_IMAGE_DANGEROUS_CONTENT"] = "HARM_CATEGORY_IMAGE_DANGEROUS_CONTENT";
    /**
     * The harm category is image harassment.
     */ HarmCategory["HARM_CATEGORY_IMAGE_HARASSMENT"] = "HARM_CATEGORY_IMAGE_HARASSMENT";
    /**
     * The harm category is image sexually explicit content.
     */ HarmCategory["HARM_CATEGORY_IMAGE_SEXUALLY_EXPLICIT"] = "HARM_CATEGORY_IMAGE_SEXUALLY_EXPLICIT";
})($e4deb49dba5321bc$export$798c77e44df53af3 || ($e4deb49dba5321bc$export$798c77e44df53af3 = {}));
/** Optional. Specify if the threshold is used for probability or severity score. If not specified, the threshold is used for probability score. */ var $e4deb49dba5321bc$export$963daae60acaff70;
(function(HarmBlockMethod) {
    /**
     * The harm block method is unspecified.
     */ HarmBlockMethod["HARM_BLOCK_METHOD_UNSPECIFIED"] = "HARM_BLOCK_METHOD_UNSPECIFIED";
    /**
     * The harm block method uses both probability and severity scores.
     */ HarmBlockMethod["SEVERITY"] = "SEVERITY";
    /**
     * The harm block method uses the probability score.
     */ HarmBlockMethod["PROBABILITY"] = "PROBABILITY";
})($e4deb49dba5321bc$export$963daae60acaff70 || ($e4deb49dba5321bc$export$963daae60acaff70 = {}));
/** Required. The harm block threshold. */ var $e4deb49dba5321bc$export$b0bfc55fdde52aac;
(function(HarmBlockThreshold) {
    /**
     * Unspecified harm block threshold.
     */ HarmBlockThreshold["HARM_BLOCK_THRESHOLD_UNSPECIFIED"] = "HARM_BLOCK_THRESHOLD_UNSPECIFIED";
    /**
     * Block low threshold and above (i.e. block more).
     */ HarmBlockThreshold["BLOCK_LOW_AND_ABOVE"] = "BLOCK_LOW_AND_ABOVE";
    /**
     * Block medium threshold and above.
     */ HarmBlockThreshold["BLOCK_MEDIUM_AND_ABOVE"] = "BLOCK_MEDIUM_AND_ABOVE";
    /**
     * Block only high threshold (i.e. block less).
     */ HarmBlockThreshold["BLOCK_ONLY_HIGH"] = "BLOCK_ONLY_HIGH";
    /**
     * Block none.
     */ HarmBlockThreshold["BLOCK_NONE"] = "BLOCK_NONE";
    /**
     * Turn off the safety filter.
     */ HarmBlockThreshold["OFF"] = "OFF";
})($e4deb49dba5321bc$export$b0bfc55fdde52aac || ($e4deb49dba5321bc$export$b0bfc55fdde52aac = {}));
/** The mode of the predictor to be used in dynamic retrieval. */ var $e4deb49dba5321bc$export$9484bbecc3c49a2e;
(function(Mode) {
    /**
     * Always trigger retrieval.
     */ Mode["MODE_UNSPECIFIED"] = "MODE_UNSPECIFIED";
    /**
     * Run retrieval only when system decides it is necessary.
     */ Mode["MODE_DYNAMIC"] = "MODE_DYNAMIC";
})($e4deb49dba5321bc$export$9484bbecc3c49a2e || ($e4deb49dba5321bc$export$9484bbecc3c49a2e = {}));
/** Type of auth scheme. */ var $e4deb49dba5321bc$export$e04cb10fd7e39267;
(function(AuthType) {
    AuthType["AUTH_TYPE_UNSPECIFIED"] = "AUTH_TYPE_UNSPECIFIED";
    /**
     * No Auth.
     */ AuthType["NO_AUTH"] = "NO_AUTH";
    /**
     * API Key Auth.
     */ AuthType["API_KEY_AUTH"] = "API_KEY_AUTH";
    /**
     * HTTP Basic Auth.
     */ AuthType["HTTP_BASIC_AUTH"] = "HTTP_BASIC_AUTH";
    /**
     * Google Service Account Auth.
     */ AuthType["GOOGLE_SERVICE_ACCOUNT_AUTH"] = "GOOGLE_SERVICE_ACCOUNT_AUTH";
    /**
     * OAuth auth.
     */ AuthType["OAUTH"] = "OAUTH";
    /**
     * OpenID Connect (OIDC) Auth.
     */ AuthType["OIDC_AUTH"] = "OIDC_AUTH";
})($e4deb49dba5321bc$export$e04cb10fd7e39267 || ($e4deb49dba5321bc$export$e04cb10fd7e39267 = {}));
/** The API spec that the external API implements. */ var $e4deb49dba5321bc$export$31f7f72babb81944;
(function(ApiSpec) {
    /**
     * Unspecified API spec. This value should not be used.
     */ ApiSpec["API_SPEC_UNSPECIFIED"] = "API_SPEC_UNSPECIFIED";
    /**
     * Simple search API spec.
     */ ApiSpec["SIMPLE_SEARCH"] = "SIMPLE_SEARCH";
    /**
     * Elastic search API spec.
     */ ApiSpec["ELASTIC_SEARCH"] = "ELASTIC_SEARCH";
})($e4deb49dba5321bc$export$31f7f72babb81944 || ($e4deb49dba5321bc$export$31f7f72babb81944 = {}));
/** Status of the url retrieval. */ var $e4deb49dba5321bc$export$975c9cf3fb61453a;
(function(UrlRetrievalStatus) {
    /**
     * Default value. This value is unused
     */ UrlRetrievalStatus["URL_RETRIEVAL_STATUS_UNSPECIFIED"] = "URL_RETRIEVAL_STATUS_UNSPECIFIED";
    /**
     * Url retrieval is successful.
     */ UrlRetrievalStatus["URL_RETRIEVAL_STATUS_SUCCESS"] = "URL_RETRIEVAL_STATUS_SUCCESS";
    /**
     * Url retrieval is failed due to error.
     */ UrlRetrievalStatus["URL_RETRIEVAL_STATUS_ERROR"] = "URL_RETRIEVAL_STATUS_ERROR";
    /**
     * Url retrieval is failed because the content is behind paywall.
     */ UrlRetrievalStatus["URL_RETRIEVAL_STATUS_PAYWALL"] = "URL_RETRIEVAL_STATUS_PAYWALL";
    /**
     * Url retrieval is failed because the content is unsafe.
     */ UrlRetrievalStatus["URL_RETRIEVAL_STATUS_UNSAFE"] = "URL_RETRIEVAL_STATUS_UNSAFE";
})($e4deb49dba5321bc$export$975c9cf3fb61453a || ($e4deb49dba5321bc$export$975c9cf3fb61453a = {}));
/** Output only. The reason why the model stopped generating tokens.

  If empty, the model has not stopped generating the tokens.
   */ var $e4deb49dba5321bc$export$e94f0100e6b2fa1a;
(function(FinishReason) {
    /**
     * The finish reason is unspecified.
     */ FinishReason["FINISH_REASON_UNSPECIFIED"] = "FINISH_REASON_UNSPECIFIED";
    /**
     * Token generation reached a natural stopping point or a configured stop sequence.
     */ FinishReason["STOP"] = "STOP";
    /**
     * Token generation reached the configured maximum output tokens.
     */ FinishReason["MAX_TOKENS"] = "MAX_TOKENS";
    /**
     * Token generation stopped because the content potentially contains safety violations. NOTE: When streaming, [content][] is empty if content filters blocks the output.
     */ FinishReason["SAFETY"] = "SAFETY";
    /**
     * The token generation stopped because of potential recitation.
     */ FinishReason["RECITATION"] = "RECITATION";
    /**
     * The token generation stopped because of using an unsupported language.
     */ FinishReason["LANGUAGE"] = "LANGUAGE";
    /**
     * All other reasons that stopped the token generation.
     */ FinishReason["OTHER"] = "OTHER";
    /**
     * Token generation stopped because the content contains forbidden terms.
     */ FinishReason["BLOCKLIST"] = "BLOCKLIST";
    /**
     * Token generation stopped for potentially containing prohibited content.
     */ FinishReason["PROHIBITED_CONTENT"] = "PROHIBITED_CONTENT";
    /**
     * Token generation stopped because the content potentially contains Sensitive Personally Identifiable Information (SPII).
     */ FinishReason["SPII"] = "SPII";
    /**
     * The function call generated by the model is invalid.
     */ FinishReason["MALFORMED_FUNCTION_CALL"] = "MALFORMED_FUNCTION_CALL";
    /**
     * Token generation stopped because generated images have safety violations.
     */ FinishReason["IMAGE_SAFETY"] = "IMAGE_SAFETY";
    /**
     * The tool call generated by the model is invalid.
     */ FinishReason["UNEXPECTED_TOOL_CALL"] = "UNEXPECTED_TOOL_CALL";
})($e4deb49dba5321bc$export$e94f0100e6b2fa1a || ($e4deb49dba5321bc$export$e94f0100e6b2fa1a = {}));
/** Output only. Harm probability levels in the content. */ var $e4deb49dba5321bc$export$d51a615154b7f9a;
(function(HarmProbability) {
    /**
     * Harm probability unspecified.
     */ HarmProbability["HARM_PROBABILITY_UNSPECIFIED"] = "HARM_PROBABILITY_UNSPECIFIED";
    /**
     * Negligible level of harm.
     */ HarmProbability["NEGLIGIBLE"] = "NEGLIGIBLE";
    /**
     * Low level of harm.
     */ HarmProbability["LOW"] = "LOW";
    /**
     * Medium level of harm.
     */ HarmProbability["MEDIUM"] = "MEDIUM";
    /**
     * High level of harm.
     */ HarmProbability["HIGH"] = "HIGH";
})($e4deb49dba5321bc$export$d51a615154b7f9a || ($e4deb49dba5321bc$export$d51a615154b7f9a = {}));
/** Output only. Harm severity levels in the content. */ var $e4deb49dba5321bc$export$7b3efb76b33fbefa;
(function(HarmSeverity) {
    /**
     * Harm severity unspecified.
     */ HarmSeverity["HARM_SEVERITY_UNSPECIFIED"] = "HARM_SEVERITY_UNSPECIFIED";
    /**
     * Negligible level of harm severity.
     */ HarmSeverity["HARM_SEVERITY_NEGLIGIBLE"] = "HARM_SEVERITY_NEGLIGIBLE";
    /**
     * Low level of harm severity.
     */ HarmSeverity["HARM_SEVERITY_LOW"] = "HARM_SEVERITY_LOW";
    /**
     * Medium level of harm severity.
     */ HarmSeverity["HARM_SEVERITY_MEDIUM"] = "HARM_SEVERITY_MEDIUM";
    /**
     * High level of harm severity.
     */ HarmSeverity["HARM_SEVERITY_HIGH"] = "HARM_SEVERITY_HIGH";
})($e4deb49dba5321bc$export$7b3efb76b33fbefa || ($e4deb49dba5321bc$export$7b3efb76b33fbefa = {}));
/** Output only. Blocked reason. */ var $e4deb49dba5321bc$export$b3338cf9227c61d4;
(function(BlockedReason) {
    /**
     * Unspecified blocked reason.
     */ BlockedReason["BLOCKED_REASON_UNSPECIFIED"] = "BLOCKED_REASON_UNSPECIFIED";
    /**
     * Candidates blocked due to safety.
     */ BlockedReason["SAFETY"] = "SAFETY";
    /**
     * Candidates blocked due to other reason.
     */ BlockedReason["OTHER"] = "OTHER";
    /**
     * Candidates blocked due to the terms which are included from the terminology blocklist.
     */ BlockedReason["BLOCKLIST"] = "BLOCKLIST";
    /**
     * Candidates blocked due to prohibited content.
     */ BlockedReason["PROHIBITED_CONTENT"] = "PROHIBITED_CONTENT";
    /**
     * Candidates blocked due to unsafe image generation content.
     */ BlockedReason["IMAGE_SAFETY"] = "IMAGE_SAFETY";
})($e4deb49dba5321bc$export$b3338cf9227c61d4 || ($e4deb49dba5321bc$export$b3338cf9227c61d4 = {}));
/** Output only. Traffic type. This shows whether a request consumes Pay-As-You-Go or Provisioned Throughput quota. */ var $e4deb49dba5321bc$export$fd67c688a6010ded;
(function(TrafficType) {
    /**
     * Unspecified request traffic type.
     */ TrafficType["TRAFFIC_TYPE_UNSPECIFIED"] = "TRAFFIC_TYPE_UNSPECIFIED";
    /**
     * Type for Pay-As-You-Go traffic.
     */ TrafficType["ON_DEMAND"] = "ON_DEMAND";
    /**
     * Type for Provisioned Throughput traffic.
     */ TrafficType["PROVISIONED_THROUGHPUT"] = "PROVISIONED_THROUGHPUT";
})($e4deb49dba5321bc$export$fd67c688a6010ded || ($e4deb49dba5321bc$export$fd67c688a6010ded = {}));
/** Server content modalities. */ var $e4deb49dba5321bc$export$9c9a8220008ddfc0;
(function(Modality) {
    /**
     * The modality is unspecified.
     */ Modality["MODALITY_UNSPECIFIED"] = "MODALITY_UNSPECIFIED";
    /**
     * Indicates the model should return text
     */ Modality["TEXT"] = "TEXT";
    /**
     * Indicates the model should return images.
     */ Modality["IMAGE"] = "IMAGE";
    /**
     * Indicates the model should return audio.
     */ Modality["AUDIO"] = "AUDIO";
})($e4deb49dba5321bc$export$9c9a8220008ddfc0 || ($e4deb49dba5321bc$export$9c9a8220008ddfc0 = {}));
/** The media resolution to use. */ var $e4deb49dba5321bc$export$c7a89108d7123ab7;
(function(MediaResolution) {
    /**
     * Media resolution has not been set
     */ MediaResolution["MEDIA_RESOLUTION_UNSPECIFIED"] = "MEDIA_RESOLUTION_UNSPECIFIED";
    /**
     * Media resolution set to low (64 tokens).
     */ MediaResolution["MEDIA_RESOLUTION_LOW"] = "MEDIA_RESOLUTION_LOW";
    /**
     * Media resolution set to medium (256 tokens).
     */ MediaResolution["MEDIA_RESOLUTION_MEDIUM"] = "MEDIA_RESOLUTION_MEDIUM";
    /**
     * Media resolution set to high (zoomed reframing with 256 tokens).
     */ MediaResolution["MEDIA_RESOLUTION_HIGH"] = "MEDIA_RESOLUTION_HIGH";
})($e4deb49dba5321bc$export$c7a89108d7123ab7 || ($e4deb49dba5321bc$export$c7a89108d7123ab7 = {}));
/** Job state. */ var $e4deb49dba5321bc$export$d30a7cb66801c974;
(function(JobState) {
    /**
     * The job state is unspecified.
     */ JobState["JOB_STATE_UNSPECIFIED"] = "JOB_STATE_UNSPECIFIED";
    /**
     * The job has been just created or resumed and processing has not yet begun.
     */ JobState["JOB_STATE_QUEUED"] = "JOB_STATE_QUEUED";
    /**
     * The service is preparing to run the job.
     */ JobState["JOB_STATE_PENDING"] = "JOB_STATE_PENDING";
    /**
     * The job is in progress.
     */ JobState["JOB_STATE_RUNNING"] = "JOB_STATE_RUNNING";
    /**
     * The job completed successfully.
     */ JobState["JOB_STATE_SUCCEEDED"] = "JOB_STATE_SUCCEEDED";
    /**
     * The job failed.
     */ JobState["JOB_STATE_FAILED"] = "JOB_STATE_FAILED";
    /**
     * The job is being cancelled. From this state the job may only go to either `JOB_STATE_SUCCEEDED`, `JOB_STATE_FAILED` or `JOB_STATE_CANCELLED`.
     */ JobState["JOB_STATE_CANCELLING"] = "JOB_STATE_CANCELLING";
    /**
     * The job has been cancelled.
     */ JobState["JOB_STATE_CANCELLED"] = "JOB_STATE_CANCELLED";
    /**
     * The job has been stopped, and can be resumed.
     */ JobState["JOB_STATE_PAUSED"] = "JOB_STATE_PAUSED";
    /**
     * The job has expired.
     */ JobState["JOB_STATE_EXPIRED"] = "JOB_STATE_EXPIRED";
    /**
     * The job is being updated. Only jobs in the `JOB_STATE_RUNNING` state can be updated. After updating, the job goes back to the `JOB_STATE_RUNNING` state.
     */ JobState["JOB_STATE_UPDATING"] = "JOB_STATE_UPDATING";
    /**
     * The job is partially succeeded, some results may be missing due to errors.
     */ JobState["JOB_STATE_PARTIALLY_SUCCEEDED"] = "JOB_STATE_PARTIALLY_SUCCEEDED";
})($e4deb49dba5321bc$export$d30a7cb66801c974 || ($e4deb49dba5321bc$export$d30a7cb66801c974 = {}));
/** Tuning mode. */ var $e4deb49dba5321bc$export$8c0e99cba1f473f5;
(function(TuningMode) {
    /**
     * Tuning mode is unspecified.
     */ TuningMode["TUNING_MODE_UNSPECIFIED"] = "TUNING_MODE_UNSPECIFIED";
    /**
     * Full fine-tuning mode.
     */ TuningMode["TUNING_MODE_FULL"] = "TUNING_MODE_FULL";
    /**
     * PEFT adapter tuning mode.
     */ TuningMode["TUNING_MODE_PEFT_ADAPTER"] = "TUNING_MODE_PEFT_ADAPTER";
})($e4deb49dba5321bc$export$8c0e99cba1f473f5 || ($e4deb49dba5321bc$export$8c0e99cba1f473f5 = {}));
/** Optional. Adapter size for tuning. */ var $e4deb49dba5321bc$export$4d0388a23e87b9ee;
(function(AdapterSize) {
    /**
     * Adapter size is unspecified.
     */ AdapterSize["ADAPTER_SIZE_UNSPECIFIED"] = "ADAPTER_SIZE_UNSPECIFIED";
    /**
     * Adapter size 1.
     */ AdapterSize["ADAPTER_SIZE_ONE"] = "ADAPTER_SIZE_ONE";
    /**
     * Adapter size 2.
     */ AdapterSize["ADAPTER_SIZE_TWO"] = "ADAPTER_SIZE_TWO";
    /**
     * Adapter size 4.
     */ AdapterSize["ADAPTER_SIZE_FOUR"] = "ADAPTER_SIZE_FOUR";
    /**
     * Adapter size 8.
     */ AdapterSize["ADAPTER_SIZE_EIGHT"] = "ADAPTER_SIZE_EIGHT";
    /**
     * Adapter size 16.
     */ AdapterSize["ADAPTER_SIZE_SIXTEEN"] = "ADAPTER_SIZE_SIXTEEN";
    /**
     * Adapter size 32.
     */ AdapterSize["ADAPTER_SIZE_THIRTY_TWO"] = "ADAPTER_SIZE_THIRTY_TWO";
})($e4deb49dba5321bc$export$4d0388a23e87b9ee || ($e4deb49dba5321bc$export$4d0388a23e87b9ee = {}));
/** Options for feature selection preference. */ var $e4deb49dba5321bc$export$5154132c56fb1c00;
(function(FeatureSelectionPreference) {
    FeatureSelectionPreference["FEATURE_SELECTION_PREFERENCE_UNSPECIFIED"] = "FEATURE_SELECTION_PREFERENCE_UNSPECIFIED";
    FeatureSelectionPreference["PRIORITIZE_QUALITY"] = "PRIORITIZE_QUALITY";
    FeatureSelectionPreference["BALANCED"] = "BALANCED";
    FeatureSelectionPreference["PRIORITIZE_COST"] = "PRIORITIZE_COST";
})($e4deb49dba5321bc$export$5154132c56fb1c00 || ($e4deb49dba5321bc$export$5154132c56fb1c00 = {}));
/** Defines the function behavior. Defaults to `BLOCKING`. */ var $e4deb49dba5321bc$export$875db781adde08fb;
(function(Behavior) {
    /**
     * This value is unused.
     */ Behavior["UNSPECIFIED"] = "UNSPECIFIED";
    /**
     * If set, the system will wait to receive the function response before continuing the conversation.
     */ Behavior["BLOCKING"] = "BLOCKING";
    /**
     * If set, the system will not wait to receive the function response. Instead, it will attempt to handle function responses as they become available while maintaining the conversation between the user and the model.
     */ Behavior["NON_BLOCKING"] = "NON_BLOCKING";
})($e4deb49dba5321bc$export$875db781adde08fb || ($e4deb49dba5321bc$export$875db781adde08fb = {}));
/** Config for the dynamic retrieval config mode. */ var $e4deb49dba5321bc$export$a95ec93224b807c1;
(function(DynamicRetrievalConfigMode) {
    /**
     * Always trigger retrieval.
     */ DynamicRetrievalConfigMode["MODE_UNSPECIFIED"] = "MODE_UNSPECIFIED";
    /**
     * Run retrieval only when system decides it is necessary.
     */ DynamicRetrievalConfigMode["MODE_DYNAMIC"] = "MODE_DYNAMIC";
})($e4deb49dba5321bc$export$a95ec93224b807c1 || ($e4deb49dba5321bc$export$a95ec93224b807c1 = {}));
/** The environment being operated. */ var $e4deb49dba5321bc$export$7dc6752a22ab011a;
(function(Environment) {
    /**
     * Defaults to browser.
     */ Environment["ENVIRONMENT_UNSPECIFIED"] = "ENVIRONMENT_UNSPECIFIED";
    /**
     * Operates in a web browser.
     */ Environment["ENVIRONMENT_BROWSER"] = "ENVIRONMENT_BROWSER";
})($e4deb49dba5321bc$export$7dc6752a22ab011a || ($e4deb49dba5321bc$export$7dc6752a22ab011a = {}));
/** Config for the function calling config mode. */ var $e4deb49dba5321bc$export$dd6bff2bc68258b9;
(function(FunctionCallingConfigMode) {
    /**
     * The function calling config mode is unspecified. Should not be used.
     */ FunctionCallingConfigMode["MODE_UNSPECIFIED"] = "MODE_UNSPECIFIED";
    /**
     * Default model behavior, model decides to predict either function calls or natural language response.
     */ FunctionCallingConfigMode["AUTO"] = "AUTO";
    /**
     * Model is constrained to always predicting function calls only. If "allowed_function_names" are set, the predicted function calls will be limited to any one of "allowed_function_names", else the predicted function calls will be any one of the provided "function_declarations".
     */ FunctionCallingConfigMode["ANY"] = "ANY";
    /**
     * Model will not predict any function calls. Model behavior is same as when not passing any function declarations.
     */ FunctionCallingConfigMode["NONE"] = "NONE";
    /**
     * Model decides to predict either a function call or a natural language response, but will validate function calls with constrained decoding. If "allowed_function_names" are set, the predicted function call will be limited to any one of "allowed_function_names", else the predicted function call will be any one of the provided "function_declarations".
     */ FunctionCallingConfigMode["VALIDATED"] = "VALIDATED";
})($e4deb49dba5321bc$export$dd6bff2bc68258b9 || ($e4deb49dba5321bc$export$dd6bff2bc68258b9 = {}));
/** Enum that controls the safety filter level for objectionable content. */ var $e4deb49dba5321bc$export$5204024137f6aea1;
(function(SafetyFilterLevel) {
    SafetyFilterLevel["BLOCK_LOW_AND_ABOVE"] = "BLOCK_LOW_AND_ABOVE";
    SafetyFilterLevel["BLOCK_MEDIUM_AND_ABOVE"] = "BLOCK_MEDIUM_AND_ABOVE";
    SafetyFilterLevel["BLOCK_ONLY_HIGH"] = "BLOCK_ONLY_HIGH";
    SafetyFilterLevel["BLOCK_NONE"] = "BLOCK_NONE";
})($e4deb49dba5321bc$export$5204024137f6aea1 || ($e4deb49dba5321bc$export$5204024137f6aea1 = {}));
/** Enum that controls the generation of people. */ var $e4deb49dba5321bc$export$d9baac936bd08721;
(function(PersonGeneration) {
    /**
     * Block generation of images of people.
     */ PersonGeneration["DONT_ALLOW"] = "DONT_ALLOW";
    /**
     * Generate images of adults, but not children.
     */ PersonGeneration["ALLOW_ADULT"] = "ALLOW_ADULT";
    /**
     * Generate images that include adults and children.
     */ PersonGeneration["ALLOW_ALL"] = "ALLOW_ALL";
})($e4deb49dba5321bc$export$d9baac936bd08721 || ($e4deb49dba5321bc$export$d9baac936bd08721 = {}));
/** Enum that specifies the language of the text in the prompt. */ var $e4deb49dba5321bc$export$504293347a2f9b0;
(function(ImagePromptLanguage) {
    /**
     * Auto-detect the language.
     */ ImagePromptLanguage["auto"] = "auto";
    /**
     * English
     */ ImagePromptLanguage["en"] = "en";
    /**
     * Japanese
     */ ImagePromptLanguage["ja"] = "ja";
    /**
     * Korean
     */ ImagePromptLanguage["ko"] = "ko";
    /**
     * Hindi
     */ ImagePromptLanguage["hi"] = "hi";
    /**
     * Chinese
     */ ImagePromptLanguage["zh"] = "zh";
    /**
     * Portuguese
     */ ImagePromptLanguage["pt"] = "pt";
    /**
     * Spanish
     */ ImagePromptLanguage["es"] = "es";
})($e4deb49dba5321bc$export$504293347a2f9b0 || ($e4deb49dba5321bc$export$504293347a2f9b0 = {}));
/** Enum representing the mask mode of a mask reference image. */ var $e4deb49dba5321bc$export$76940fd539710332;
(function(MaskReferenceMode) {
    MaskReferenceMode["MASK_MODE_DEFAULT"] = "MASK_MODE_DEFAULT";
    MaskReferenceMode["MASK_MODE_USER_PROVIDED"] = "MASK_MODE_USER_PROVIDED";
    MaskReferenceMode["MASK_MODE_BACKGROUND"] = "MASK_MODE_BACKGROUND";
    MaskReferenceMode["MASK_MODE_FOREGROUND"] = "MASK_MODE_FOREGROUND";
    MaskReferenceMode["MASK_MODE_SEMANTIC"] = "MASK_MODE_SEMANTIC";
})($e4deb49dba5321bc$export$76940fd539710332 || ($e4deb49dba5321bc$export$76940fd539710332 = {}));
/** Enum representing the control type of a control reference image. */ var $e4deb49dba5321bc$export$26974b3b69e46d1d;
(function(ControlReferenceType) {
    ControlReferenceType["CONTROL_TYPE_DEFAULT"] = "CONTROL_TYPE_DEFAULT";
    ControlReferenceType["CONTROL_TYPE_CANNY"] = "CONTROL_TYPE_CANNY";
    ControlReferenceType["CONTROL_TYPE_SCRIBBLE"] = "CONTROL_TYPE_SCRIBBLE";
    ControlReferenceType["CONTROL_TYPE_FACE_MESH"] = "CONTROL_TYPE_FACE_MESH";
})($e4deb49dba5321bc$export$26974b3b69e46d1d || ($e4deb49dba5321bc$export$26974b3b69e46d1d = {}));
/** Enum representing the subject type of a subject reference image. */ var $e4deb49dba5321bc$export$59262bdf2638eb32;
(function(SubjectReferenceType) {
    SubjectReferenceType["SUBJECT_TYPE_DEFAULT"] = "SUBJECT_TYPE_DEFAULT";
    SubjectReferenceType["SUBJECT_TYPE_PERSON"] = "SUBJECT_TYPE_PERSON";
    SubjectReferenceType["SUBJECT_TYPE_ANIMAL"] = "SUBJECT_TYPE_ANIMAL";
    SubjectReferenceType["SUBJECT_TYPE_PRODUCT"] = "SUBJECT_TYPE_PRODUCT";
})($e4deb49dba5321bc$export$59262bdf2638eb32 || ($e4deb49dba5321bc$export$59262bdf2638eb32 = {}));
/** Enum representing the editing mode. */ var $e4deb49dba5321bc$export$5304145354a3bee9;
(function(EditMode) {
    EditMode["EDIT_MODE_DEFAULT"] = "EDIT_MODE_DEFAULT";
    EditMode["EDIT_MODE_INPAINT_REMOVAL"] = "EDIT_MODE_INPAINT_REMOVAL";
    EditMode["EDIT_MODE_INPAINT_INSERTION"] = "EDIT_MODE_INPAINT_INSERTION";
    EditMode["EDIT_MODE_OUTPAINT"] = "EDIT_MODE_OUTPAINT";
    EditMode["EDIT_MODE_CONTROLLED_EDITING"] = "EDIT_MODE_CONTROLLED_EDITING";
    EditMode["EDIT_MODE_STYLE"] = "EDIT_MODE_STYLE";
    EditMode["EDIT_MODE_BGSWAP"] = "EDIT_MODE_BGSWAP";
    EditMode["EDIT_MODE_PRODUCT_IMAGE"] = "EDIT_MODE_PRODUCT_IMAGE";
})($e4deb49dba5321bc$export$5304145354a3bee9 || ($e4deb49dba5321bc$export$5304145354a3bee9 = {}));
/** Enum that represents the segmentation mode. */ var $e4deb49dba5321bc$export$824f092534347f02;
(function(SegmentMode) {
    SegmentMode["FOREGROUND"] = "FOREGROUND";
    SegmentMode["BACKGROUND"] = "BACKGROUND";
    SegmentMode["PROMPT"] = "PROMPT";
    SegmentMode["SEMANTIC"] = "SEMANTIC";
    SegmentMode["INTERACTIVE"] = "INTERACTIVE";
})($e4deb49dba5321bc$export$824f092534347f02 || ($e4deb49dba5321bc$export$824f092534347f02 = {}));
/** Enum for the reference type of a video generation reference image. */ var $e4deb49dba5321bc$export$492cea19f892fe1e;
(function(VideoGenerationReferenceType) {
    /**
     * A reference image that provides assets to the generated video,
        such as the scene, an object, a character, etc.
     */ VideoGenerationReferenceType["ASSET"] = "ASSET";
    /**
     * A reference image that provides aesthetics including colors,
        lighting, texture, etc., to be used as the style of the generated video,
        such as 'anime', 'photography', 'origami', etc.
     */ VideoGenerationReferenceType["STYLE"] = "STYLE";
})($e4deb49dba5321bc$export$492cea19f892fe1e || ($e4deb49dba5321bc$export$492cea19f892fe1e = {}));
/** Enum for the mask mode of a video generation mask. */ var $e4deb49dba5321bc$export$99d85d0ee14173f1;
(function(VideoGenerationMaskMode) {
    /**
     * The image mask contains a masked rectangular region which is
        applied on the first frame of the input video. The object described in
        the prompt is inserted into this region and will appear in subsequent
        frames.
     */ VideoGenerationMaskMode["INSERT"] = "INSERT";
    /**
     * The image mask is used to determine an object in the
        first video frame to track. This object is removed from the video.
     */ VideoGenerationMaskMode["REMOVE"] = "REMOVE";
    /**
     * The image mask is used to determine a region in the
        video. Objects in this region will be removed.
     */ VideoGenerationMaskMode["REMOVE_STATIC"] = "REMOVE_STATIC";
    /**
     * The image mask contains a masked rectangular region where
        the input video will go. The remaining area will be generated. Video
        masks are not supported.
     */ VideoGenerationMaskMode["OUTPAINT"] = "OUTPAINT";
})($e4deb49dba5321bc$export$99d85d0ee14173f1 || ($e4deb49dba5321bc$export$99d85d0ee14173f1 = {}));
/** Enum that controls the compression quality of the generated videos. */ var $e4deb49dba5321bc$export$c8d56a80437cfac3;
(function(VideoCompressionQuality) {
    /**
     * Optimized video compression quality. This will produce videos
        with a compressed, smaller file size.
     */ VideoCompressionQuality["OPTIMIZED"] = "OPTIMIZED";
    /**
     * Lossless video compression quality. This will produce videos
        with a larger file size.
     */ VideoCompressionQuality["LOSSLESS"] = "LOSSLESS";
})($e4deb49dba5321bc$export$c8d56a80437cfac3 || ($e4deb49dba5321bc$export$c8d56a80437cfac3 = {}));
/** State for the lifecycle of a File. */ var $e4deb49dba5321bc$export$4ddb69e6513a9971;
(function(FileState) {
    FileState["STATE_UNSPECIFIED"] = "STATE_UNSPECIFIED";
    FileState["PROCESSING"] = "PROCESSING";
    FileState["ACTIVE"] = "ACTIVE";
    FileState["FAILED"] = "FAILED";
})($e4deb49dba5321bc$export$4ddb69e6513a9971 || ($e4deb49dba5321bc$export$4ddb69e6513a9971 = {}));
/** Source of the File. */ var $e4deb49dba5321bc$export$27a4864e1e35718c;
(function(FileSource) {
    FileSource["SOURCE_UNSPECIFIED"] = "SOURCE_UNSPECIFIED";
    FileSource["UPLOADED"] = "UPLOADED";
    FileSource["GENERATED"] = "GENERATED";
})($e4deb49dba5321bc$export$27a4864e1e35718c || ($e4deb49dba5321bc$export$27a4864e1e35718c = {}));
/** The reason why the turn is complete. */ var $e4deb49dba5321bc$export$99c4e0f48ba51160;
(function(TurnCompleteReason) {
    /**
     * Default value. Reason is unspecified.
     */ TurnCompleteReason["TURN_COMPLETE_REASON_UNSPECIFIED"] = "TURN_COMPLETE_REASON_UNSPECIFIED";
    /**
     * The function call generated by the model is invalid.
     */ TurnCompleteReason["MALFORMED_FUNCTION_CALL"] = "MALFORMED_FUNCTION_CALL";
    /**
     * The response is rejected by the model.
     */ TurnCompleteReason["RESPONSE_REJECTED"] = "RESPONSE_REJECTED";
    /**
     * Needs more input from the user.
     */ TurnCompleteReason["NEED_MORE_INPUT"] = "NEED_MORE_INPUT";
})($e4deb49dba5321bc$export$99c4e0f48ba51160 || ($e4deb49dba5321bc$export$99c4e0f48ba51160 = {}));
/** Server content modalities. */ var $e4deb49dba5321bc$export$cd2f9f264fad7b02;
(function(MediaModality) {
    /**
     * The modality is unspecified.
     */ MediaModality["MODALITY_UNSPECIFIED"] = "MODALITY_UNSPECIFIED";
    /**
     * Plain text.
     */ MediaModality["TEXT"] = "TEXT";
    /**
     * Images.
     */ MediaModality["IMAGE"] = "IMAGE";
    /**
     * Video.
     */ MediaModality["VIDEO"] = "VIDEO";
    /**
     * Audio.
     */ MediaModality["AUDIO"] = "AUDIO";
    /**
     * Document, e.g. PDF.
     */ MediaModality["DOCUMENT"] = "DOCUMENT";
})($e4deb49dba5321bc$export$cd2f9f264fad7b02 || ($e4deb49dba5321bc$export$cd2f9f264fad7b02 = {}));
/** Start of speech sensitivity. */ var $e4deb49dba5321bc$export$148372f2e0cd8282;
(function(StartSensitivity) {
    /**
     * The default is START_SENSITIVITY_LOW.
     */ StartSensitivity["START_SENSITIVITY_UNSPECIFIED"] = "START_SENSITIVITY_UNSPECIFIED";
    /**
     * Automatic detection will detect the start of speech more often.
     */ StartSensitivity["START_SENSITIVITY_HIGH"] = "START_SENSITIVITY_HIGH";
    /**
     * Automatic detection will detect the start of speech less often.
     */ StartSensitivity["START_SENSITIVITY_LOW"] = "START_SENSITIVITY_LOW";
})($e4deb49dba5321bc$export$148372f2e0cd8282 || ($e4deb49dba5321bc$export$148372f2e0cd8282 = {}));
/** End of speech sensitivity. */ var $e4deb49dba5321bc$export$c980be37f56c00d9;
(function(EndSensitivity) {
    /**
     * The default is END_SENSITIVITY_LOW.
     */ EndSensitivity["END_SENSITIVITY_UNSPECIFIED"] = "END_SENSITIVITY_UNSPECIFIED";
    /**
     * Automatic detection ends speech more often.
     */ EndSensitivity["END_SENSITIVITY_HIGH"] = "END_SENSITIVITY_HIGH";
    /**
     * Automatic detection ends speech less often.
     */ EndSensitivity["END_SENSITIVITY_LOW"] = "END_SENSITIVITY_LOW";
})($e4deb49dba5321bc$export$c980be37f56c00d9 || ($e4deb49dba5321bc$export$c980be37f56c00d9 = {}));
/** The different ways of handling user activity. */ var $e4deb49dba5321bc$export$d8dcee4c2401eaaa;
(function(ActivityHandling) {
    /**
     * If unspecified, the default behavior is `START_OF_ACTIVITY_INTERRUPTS`.
     */ ActivityHandling["ACTIVITY_HANDLING_UNSPECIFIED"] = "ACTIVITY_HANDLING_UNSPECIFIED";
    /**
     * If true, start of activity will interrupt the model's response (also called "barge in"). The model's current response will be cut-off in the moment of the interruption. This is the default behavior.
     */ ActivityHandling["START_OF_ACTIVITY_INTERRUPTS"] = "START_OF_ACTIVITY_INTERRUPTS";
    /**
     * The model's response will not be interrupted.
     */ ActivityHandling["NO_INTERRUPTION"] = "NO_INTERRUPTION";
})($e4deb49dba5321bc$export$d8dcee4c2401eaaa || ($e4deb49dba5321bc$export$d8dcee4c2401eaaa = {}));
/** Options about which input is included in the user's turn. */ var $e4deb49dba5321bc$export$23fe448c5e1fa7ce;
(function(TurnCoverage) {
    /**
     * If unspecified, the default behavior is `TURN_INCLUDES_ONLY_ACTIVITY`.
     */ TurnCoverage["TURN_COVERAGE_UNSPECIFIED"] = "TURN_COVERAGE_UNSPECIFIED";
    /**
     * The users turn only includes activity since the last turn, excluding inactivity (e.g. silence on the audio stream). This is the default behavior.
     */ TurnCoverage["TURN_INCLUDES_ONLY_ACTIVITY"] = "TURN_INCLUDES_ONLY_ACTIVITY";
    /**
     * The users turn includes all realtime input since the last turn, including inactivity (e.g. silence on the audio stream).
     */ TurnCoverage["TURN_INCLUDES_ALL_INPUT"] = "TURN_INCLUDES_ALL_INPUT";
})($e4deb49dba5321bc$export$23fe448c5e1fa7ce || ($e4deb49dba5321bc$export$23fe448c5e1fa7ce = {}));
/** Specifies how the response should be scheduled in the conversation. */ var $e4deb49dba5321bc$export$5faf5a36745d3723;
(function(FunctionResponseScheduling) {
    /**
     * This value is unused.
     */ FunctionResponseScheduling["SCHEDULING_UNSPECIFIED"] = "SCHEDULING_UNSPECIFIED";
    /**
     * Only add the result to the conversation context, do not interrupt or trigger generation.
     */ FunctionResponseScheduling["SILENT"] = "SILENT";
    /**
     * Add the result to the conversation context, and prompt to generate output without interrupting ongoing generation.
     */ FunctionResponseScheduling["WHEN_IDLE"] = "WHEN_IDLE";
    /**
     * Add the result to the conversation context, interrupt ongoing generation and prompt to generate output.
     */ FunctionResponseScheduling["INTERRUPT"] = "INTERRUPT";
})($e4deb49dba5321bc$export$5faf5a36745d3723 || ($e4deb49dba5321bc$export$5faf5a36745d3723 = {}));
/** Scale of the generated music. */ var $e4deb49dba5321bc$export$d60cfc58d3c358b6;
(function(Scale) {
    /**
     * Default value. This value is unused.
     */ Scale["SCALE_UNSPECIFIED"] = "SCALE_UNSPECIFIED";
    /**
     * C major or A minor.
     */ Scale["C_MAJOR_A_MINOR"] = "C_MAJOR_A_MINOR";
    /**
     * Db major or Bb minor.
     */ Scale["D_FLAT_MAJOR_B_FLAT_MINOR"] = "D_FLAT_MAJOR_B_FLAT_MINOR";
    /**
     * D major or B minor.
     */ Scale["D_MAJOR_B_MINOR"] = "D_MAJOR_B_MINOR";
    /**
     * Eb major or C minor
     */ Scale["E_FLAT_MAJOR_C_MINOR"] = "E_FLAT_MAJOR_C_MINOR";
    /**
     * E major or Db minor.
     */ Scale["E_MAJOR_D_FLAT_MINOR"] = "E_MAJOR_D_FLAT_MINOR";
    /**
     * F major or D minor.
     */ Scale["F_MAJOR_D_MINOR"] = "F_MAJOR_D_MINOR";
    /**
     * Gb major or Eb minor.
     */ Scale["G_FLAT_MAJOR_E_FLAT_MINOR"] = "G_FLAT_MAJOR_E_FLAT_MINOR";
    /**
     * G major or E minor.
     */ Scale["G_MAJOR_E_MINOR"] = "G_MAJOR_E_MINOR";
    /**
     * Ab major or F minor.
     */ Scale["A_FLAT_MAJOR_F_MINOR"] = "A_FLAT_MAJOR_F_MINOR";
    /**
     * A major or Gb minor.
     */ Scale["A_MAJOR_G_FLAT_MINOR"] = "A_MAJOR_G_FLAT_MINOR";
    /**
     * Bb major or G minor.
     */ Scale["B_FLAT_MAJOR_G_MINOR"] = "B_FLAT_MAJOR_G_MINOR";
    /**
     * B major or Ab minor.
     */ Scale["B_MAJOR_A_FLAT_MINOR"] = "B_MAJOR_A_FLAT_MINOR";
})($e4deb49dba5321bc$export$d60cfc58d3c358b6 || ($e4deb49dba5321bc$export$d60cfc58d3c358b6 = {}));
/** The mode of music generation. */ var $e4deb49dba5321bc$export$23b8931bd532ef11;
(function(MusicGenerationMode) {
    /**
     * Rely on the server default generation mode.
     */ MusicGenerationMode["MUSIC_GENERATION_MODE_UNSPECIFIED"] = "MUSIC_GENERATION_MODE_UNSPECIFIED";
    /**
     * Steer text prompts to regions of latent space with higher quality
        music.
     */ MusicGenerationMode["QUALITY"] = "QUALITY";
    /**
     * Steer text prompts to regions of latent space with a larger
        diversity of music.
     */ MusicGenerationMode["DIVERSITY"] = "DIVERSITY";
    /**
     * Steer text prompts to regions of latent space more likely to
        generate music with vocals.
     */ MusicGenerationMode["VOCALIZATION"] = "VOCALIZATION";
})($e4deb49dba5321bc$export$23b8931bd532ef11 || ($e4deb49dba5321bc$export$23b8931bd532ef11 = {}));
/** The playback control signal to apply to the music generation. */ var $e4deb49dba5321bc$export$3d1b3b2fa769f3a;
(function(LiveMusicPlaybackControl) {
    /**
     * This value is unused.
     */ LiveMusicPlaybackControl["PLAYBACK_CONTROL_UNSPECIFIED"] = "PLAYBACK_CONTROL_UNSPECIFIED";
    /**
     * Start generating the music.
     */ LiveMusicPlaybackControl["PLAY"] = "PLAY";
    /**
     * Hold the music generation. Use PLAY to resume from the current position.
     */ LiveMusicPlaybackControl["PAUSE"] = "PAUSE";
    /**
     * Stop the music generation and reset the context (prompts retained).
        Use PLAY to restart the music generation.
     */ LiveMusicPlaybackControl["STOP"] = "STOP";
    /**
     * Reset the context of the music generation without stopping it.
        Retains the current prompts and config.
     */ LiveMusicPlaybackControl["RESET_CONTEXT"] = "RESET_CONTEXT";
})($e4deb49dba5321bc$export$3d1b3b2fa769f3a || ($e4deb49dba5321bc$export$3d1b3b2fa769f3a = {}));
/** A function response. */ class $e4deb49dba5321bc$export$65d34e7763af8846 {
}
/**
 * Creates a `Part` object from a `URI` string.
 */ function $e4deb49dba5321bc$export$609bc3722c813117(uri, mimeType) {
    return {
        fileData: {
            fileUri: uri,
            mimeType: mimeType
        }
    };
}
/**
 * Creates a `Part` object from a `text` string.
 */ function $e4deb49dba5321bc$export$2db44f3a4d11da4c(text) {
    return {
        text: text
    };
}
/**
 * Creates a `Part` object from a `FunctionCall` object.
 */ function $e4deb49dba5321bc$export$a3e123769033f7c0(name, args) {
    return {
        functionCall: {
            name: name,
            args: args
        }
    };
}
/**
 * Creates a `Part` object from a `FunctionResponse` object.
 */ function $e4deb49dba5321bc$export$2636c86ed18e1200(id, name, response) {
    return {
        functionResponse: {
            id: id,
            name: name,
            response: response
        }
    };
}
/**
 * Creates a `Part` object from a `base64` encoded `string`.
 */ function $e4deb49dba5321bc$export$fff7d82602c9c90f(data, mimeType) {
    return {
        inlineData: {
            data: data,
            mimeType: mimeType
        }
    };
}
/**
 * Creates a `Part` object from the `outcome` and `output` of a `CodeExecutionResult` object.
 */ function $e4deb49dba5321bc$export$42aa341e98336a1b(outcome, output) {
    return {
        codeExecutionResult: {
            outcome: outcome,
            output: output
        }
    };
}
/**
 * Creates a `Part` object from the `code` and `language` of an `ExecutableCode` object.
 */ function $e4deb49dba5321bc$export$245f0e57663865ef(code, language) {
    return {
        executableCode: {
            code: code,
            language: language
        }
    };
}
function $e4deb49dba5321bc$var$_isPart(obj) {
    if (typeof obj === 'object' && obj !== null) return 'fileData' in obj || 'text' in obj || 'functionCall' in obj || 'functionResponse' in obj || 'inlineData' in obj || 'videoMetadata' in obj || 'codeExecutionResult' in obj || 'executableCode' in obj;
    return false;
}
function $e4deb49dba5321bc$var$_toParts(partOrString) {
    const parts = [];
    if (typeof partOrString === 'string') parts.push($e4deb49dba5321bc$export$2db44f3a4d11da4c(partOrString));
    else if ($e4deb49dba5321bc$var$_isPart(partOrString)) parts.push(partOrString);
    else if (Array.isArray(partOrString)) {
        if (partOrString.length === 0) throw new Error('partOrString cannot be an empty array');
        for (const part of partOrString){
            if (typeof part === 'string') parts.push($e4deb49dba5321bc$export$2db44f3a4d11da4c(part));
            else if ($e4deb49dba5321bc$var$_isPart(part)) parts.push(part);
            else throw new Error('element in PartUnion must be a Part object or string');
        }
    } else throw new Error('partOrString must be a Part object, string, or array');
    return parts;
}
/**
 * Creates a `Content` object with a user role from a `PartListUnion` object or `string`.
 */ function $e4deb49dba5321bc$export$fe075102324a2d5b(partOrString) {
    return {
        role: 'user',
        parts: $e4deb49dba5321bc$var$_toParts(partOrString)
    };
}
/**
 * Creates a `Content` object with a model role from a `PartListUnion` object or `string`.
 */ function $e4deb49dba5321bc$export$f32d0a9788adfa64(partOrString) {
    return {
        role: 'model',
        parts: $e4deb49dba5321bc$var$_toParts(partOrString)
    };
}
/** A wrapper class for the http response. */ class $e4deb49dba5321bc$export$1d94dfe0d9d1f1e7 {
    constructor(response){
        // Process the headers.
        const headers = {};
        for (const pair of response.headers.entries())headers[pair[0]] = pair[1];
        this.headers = headers;
        // Keep the original response.
        this.responseInternal = response;
    }
    json() {
        return this.responseInternal.json();
    }
}
/** Content filter results for a prompt sent in the request. */ class $e4deb49dba5321bc$export$37d485a092233165 {
}
/** Usage metadata about response(s). */ class $e4deb49dba5321bc$export$3248e9acea8b5df0 {
}
/** Response message for PredictionService.GenerateContent. */ class $e4deb49dba5321bc$export$87445595052c5212 {
    /**
     * Returns the concatenation of all text parts from the first candidate in the response.
     *
     * @remarks
     * If there are multiple candidates in the response, the text from the first
     * one will be returned.
     * If there are non-text parts in the response, the concatenation of all text
     * parts will be returned, and a warning will be logged.
     * If there are thought parts in the response, the concatenation of all text
     * parts excluding the thought parts will be returned.
     *
     * @example
     * ```ts
     * const response = await ai.models.generateContent({
     *   model: 'gemini-2.0-flash',
     *   contents:
     *     'Why is the sky blue?',
     * });
     *
     * console.debug(response.text);
     * ```
     */ get text() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (((_d = (_c = (_b = (_a = this.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.parts) === null || _d === void 0 ? void 0 : _d.length) === 0) return undefined;
        if (this.candidates && this.candidates.length > 1) console.warn('there are multiple candidates in the response, returning text from the first one.');
        let text = '';
        let anyTextPartText = false;
        const nonTextParts = [];
        for (const part of (_h = (_g = (_f = (_e = this.candidates) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.parts) !== null && _h !== void 0 ? _h : []){
            for (const [fieldName, fieldValue] of Object.entries(part))if (fieldName !== 'text' && fieldName !== 'thought' && (fieldValue !== null || fieldValue !== undefined)) nonTextParts.push(fieldName);
            if (typeof part.text === 'string') {
                if (typeof part.thought === 'boolean' && part.thought) continue;
                anyTextPartText = true;
                text += part.text;
            }
        }
        if (nonTextParts.length > 0) console.warn(`there are non-text parts ${nonTextParts} in the response, returning concatenation of all text parts. Please refer to the non text parts for a full response from model.`);
        // part.text === '' is different from part.text is null
        return anyTextPartText ? text : undefined;
    }
    /**
     * Returns the concatenation of all inline data parts from the first candidate
     * in the response.
     *
     * @remarks
     * If there are multiple candidates in the response, the inline data from the
     * first one will be returned. If there are non-inline data parts in the
     * response, the concatenation of all inline data parts will be returned, and
     * a warning will be logged.
     */ get data() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (((_d = (_c = (_b = (_a = this.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.parts) === null || _d === void 0 ? void 0 : _d.length) === 0) return undefined;
        if (this.candidates && this.candidates.length > 1) console.warn('there are multiple candidates in the response, returning data from the first one.');
        let data = '';
        const nonDataParts = [];
        for (const part of (_h = (_g = (_f = (_e = this.candidates) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.parts) !== null && _h !== void 0 ? _h : []){
            for (const [fieldName, fieldValue] of Object.entries(part))if (fieldName !== 'inlineData' && (fieldValue !== null || fieldValue !== undefined)) nonDataParts.push(fieldName);
            if (part.inlineData && typeof part.inlineData.data === 'string') data += atob(part.inlineData.data);
        }
        if (nonDataParts.length > 0) console.warn(`there are non-data parts ${nonDataParts} in the response, returning concatenation of all data parts. Please refer to the non data parts for a full response from model.`);
        return data.length > 0 ? btoa(data) : undefined;
    }
    /**
     * Returns the function calls from the first candidate in the response.
     *
     * @remarks
     * If there are multiple candidates in the response, the function calls from
     * the first one will be returned.
     * If there are no function calls in the response, undefined will be returned.
     *
     * @example
     * ```ts
     * const controlLightFunctionDeclaration: FunctionDeclaration = {
     *   name: 'controlLight',
     *   parameters: {
     *   type: Type.OBJECT,
     *   description: 'Set the brightness and color temperature of a room light.',
     *   properties: {
     *     brightness: {
     *       type: Type.NUMBER,
     *       description:
     *         'Light level from 0 to 100. Zero is off and 100 is full brightness.',
     *     },
     *     colorTemperature: {
     *       type: Type.STRING,
     *       description:
     *         'Color temperature of the light fixture which can be `daylight`, `cool` or `warm`.',
     *     },
     *   },
     *   required: ['brightness', 'colorTemperature'],
     *  };
     *  const response = await ai.models.generateContent({
     *     model: 'gemini-2.0-flash',
     *     contents: 'Dim the lights so the room feels cozy and warm.',
     *     config: {
     *       tools: [{functionDeclarations: [controlLightFunctionDeclaration]}],
     *       toolConfig: {
     *         functionCallingConfig: {
     *           mode: FunctionCallingConfigMode.ANY,
     *           allowedFunctionNames: ['controlLight'],
     *         },
     *       },
     *     },
     *   });
     *  console.debug(JSON.stringify(response.functionCalls));
     * ```
     */ get functionCalls() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (((_d = (_c = (_b = (_a = this.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.parts) === null || _d === void 0 ? void 0 : _d.length) === 0) return undefined;
        if (this.candidates && this.candidates.length > 1) console.warn('there are multiple candidates in the response, returning function calls from the first one.');
        const functionCalls = (_h = (_g = (_f = (_e = this.candidates) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.parts) === null || _h === void 0 ? void 0 : _h.filter((part)=>part.functionCall).map((part)=>part.functionCall).filter((functionCall)=>functionCall !== undefined);
        if ((functionCalls === null || functionCalls === void 0 ? void 0 : functionCalls.length) === 0) return undefined;
        return functionCalls;
    }
    /**
     * Returns the first executable code from the first candidate in the response.
     *
     * @remarks
     * If there are multiple candidates in the response, the executable code from
     * the first one will be returned.
     * If there are no executable code in the response, undefined will be
     * returned.
     *
     * @example
     * ```ts
     * const response = await ai.models.generateContent({
     *   model: 'gemini-2.0-flash',
     *   contents:
     *     'What is the sum of the first 50 prime numbers? Generate and run code for the calculation, and make sure you get all 50.'
     *   config: {
     *     tools: [{codeExecution: {}}],
     *   },
     * });
     *
     * console.debug(response.executableCode);
     * ```
     */ get executableCode() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (((_d = (_c = (_b = (_a = this.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.parts) === null || _d === void 0 ? void 0 : _d.length) === 0) return undefined;
        if (this.candidates && this.candidates.length > 1) console.warn('there are multiple candidates in the response, returning executable code from the first one.');
        const executableCode = (_h = (_g = (_f = (_e = this.candidates) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.parts) === null || _h === void 0 ? void 0 : _h.filter((part)=>part.executableCode).map((part)=>part.executableCode).filter((executableCode)=>executableCode !== undefined);
        if ((executableCode === null || executableCode === void 0 ? void 0 : executableCode.length) === 0) return undefined;
        return (_j = executableCode === null || executableCode === void 0 ? void 0 : executableCode[0]) === null || _j === void 0 ? void 0 : _j.code;
    }
    /**
     * Returns the first code execution result from the first candidate in the response.
     *
     * @remarks
     * If there are multiple candidates in the response, the code execution result from
     * the first one will be returned.
     * If there are no code execution result in the response, undefined will be returned.
     *
     * @example
     * ```ts
     * const response = await ai.models.generateContent({
     *   model: 'gemini-2.0-flash',
     *   contents:
     *     'What is the sum of the first 50 prime numbers? Generate and run code for the calculation, and make sure you get all 50.'
     *   config: {
     *     tools: [{codeExecution: {}}],
     *   },
     * });
     *
     * console.debug(response.codeExecutionResult);
     * ```
     */ get codeExecutionResult() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (((_d = (_c = (_b = (_a = this.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.parts) === null || _d === void 0 ? void 0 : _d.length) === 0) return undefined;
        if (this.candidates && this.candidates.length > 1) console.warn('there are multiple candidates in the response, returning code execution result from the first one.');
        const codeExecutionResult = (_h = (_g = (_f = (_e = this.candidates) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.parts) === null || _h === void 0 ? void 0 : _h.filter((part)=>part.codeExecutionResult).map((part)=>part.codeExecutionResult).filter((codeExecutionResult)=>codeExecutionResult !== undefined);
        if ((codeExecutionResult === null || codeExecutionResult === void 0 ? void 0 : codeExecutionResult.length) === 0) return undefined;
        return (_j = codeExecutionResult === null || codeExecutionResult === void 0 ? void 0 : codeExecutionResult[0]) === null || _j === void 0 ? void 0 : _j.output;
    }
}
/** Response for the embed_content method. */ class $e4deb49dba5321bc$export$1e9eee8641627f00 {
}
/** The output images response. */ class $e4deb49dba5321bc$export$f08095e7138eb0f4 {
}
/** Response for the request to edit an image. */ class $e4deb49dba5321bc$export$661afcf00ed2fbe8 {
}
class $e4deb49dba5321bc$export$690402256314214 {
}
/** The output images response. */ class $e4deb49dba5321bc$export$c2ead2074351d0f2 {
}
/** The output images response. */ class $e4deb49dba5321bc$export$304f360366a6eb53 {
}
class $e4deb49dba5321bc$export$f159131a50016456 {
}
class $e4deb49dba5321bc$export$179335935ae1d762 {
}
/** Response for counting tokens. */ class $e4deb49dba5321bc$export$b2422e769fe9acde {
}
/** Response for computing tokens. */ class $e4deb49dba5321bc$export$8fb35c7d28173be {
}
/** Response with generated videos. */ class $e4deb49dba5321bc$export$b2145aacd8f1c9d6 {
}
/** A video generation operation. */ class $e4deb49dba5321bc$export$d39812a6cdac2c57 {
    /**
     * Instantiates an Operation of the same type as the one being called with the fields set from the API response.
     * @internal
     */ _fromAPIResponse({ apiResponse: apiResponse, isVertexAI: isVertexAI }) {
        const operation = new $e4deb49dba5321bc$export$d39812a6cdac2c57();
        let response;
        const op = apiResponse;
        if (isVertexAI) response = $e4deb49dba5321bc$var$generateVideosOperationFromVertex$1(op);
        else response = $e4deb49dba5321bc$var$generateVideosOperationFromMldev$1(op);
        Object.assign(operation, response);
        return operation;
    }
}
/** Response for the list tuning jobs method. */ class $e4deb49dba5321bc$export$32bcd29afb9d1292 {
}
/** Empty response for caches.delete method. */ class $e4deb49dba5321bc$export$12b40cf453f95df4 {
}
class $e4deb49dba5321bc$export$b704e9f6d5866ff0 {
}
/** Response for the list files method. */ class $e4deb49dba5321bc$export$70c4c7aa1360da5a {
}
/** Response for the create file method. */ class $e4deb49dba5321bc$export$e6f7a7cf305d85e3 {
}
/** Response for the delete file method. */ class $e4deb49dba5321bc$export$a33f0b325263613a {
}
/** Config for `inlined_responses` parameter. */ class $e4deb49dba5321bc$export$5a6a720963f2cc93 {
}
/** Config for `response` parameter. */ class $e4deb49dba5321bc$export$bcc77db6b6164a92 {
}
/** Config for `inlined_embedding_responses` parameter. */ class $e4deb49dba5321bc$export$37d6004458e8d4bf {
}
/** Config for batches.list return value. */ class $e4deb49dba5321bc$export$aad8e472c65c38a4 {
}
/** Represents a single response in a replay. */ class $e4deb49dba5321bc$export$aacd0b67d1adb66d {
}
/** A raw reference image.

  A raw reference image represents the base image to edit, provided by the user.
  It can optionally be provided in addition to a mask reference image or
  a style reference image.
   */ class $e4deb49dba5321bc$export$66efc3ead37215f1 {
    /** Internal method to convert to ReferenceImageAPIInternal. */ toReferenceImageAPI() {
        const referenceImageAPI = {
            referenceType: 'REFERENCE_TYPE_RAW',
            referenceImage: this.referenceImage,
            referenceId: this.referenceId
        };
        return referenceImageAPI;
    }
}
/** A mask reference image.

  This encapsulates either a mask image provided by the user and configs for
  the user provided mask, or only config parameters for the model to generate
  a mask.

  A mask image is an image whose non-zero values indicate where to edit the base
  image. If the user provides a mask image, the mask must be in the same
  dimensions as the raw image.
   */ class $e4deb49dba5321bc$export$df9dc1e4034fa3a8 {
    /** Internal method to convert to ReferenceImageAPIInternal. */ toReferenceImageAPI() {
        const referenceImageAPI = {
            referenceType: 'REFERENCE_TYPE_MASK',
            referenceImage: this.referenceImage,
            referenceId: this.referenceId,
            maskImageConfig: this.config
        };
        return referenceImageAPI;
    }
}
/** A control reference image.

  The image of the control reference image is either a control image provided
  by the user, or a regular image which the backend will use to generate a
  control image of. In the case of the latter, the
  enable_control_image_computation field in the config should be set to True.

  A control image is an image that represents a sketch image of areas for the
  model to fill in based on the prompt.
   */ class $e4deb49dba5321bc$export$35d10f93a6c10713 {
    /** Internal method to convert to ReferenceImageAPIInternal. */ toReferenceImageAPI() {
        const referenceImageAPI = {
            referenceType: 'REFERENCE_TYPE_CONTROL',
            referenceImage: this.referenceImage,
            referenceId: this.referenceId,
            controlImageConfig: this.config
        };
        return referenceImageAPI;
    }
}
/** A style reference image.

  This encapsulates a style reference image provided by the user, and
  additionally optional config parameters for the style reference image.

  A raw reference image can also be provided as a destination for the style to
  be applied to.
   */ class $e4deb49dba5321bc$export$36a9e1f6d51bfc4f {
    /** Internal method to convert to ReferenceImageAPIInternal. */ toReferenceImageAPI() {
        const referenceImageAPI = {
            referenceType: 'REFERENCE_TYPE_STYLE',
            referenceImage: this.referenceImage,
            referenceId: this.referenceId,
            styleImageConfig: this.config
        };
        return referenceImageAPI;
    }
}
/** A subject reference image.

  This encapsulates a subject reference image provided by the user, and
  additionally optional config parameters for the subject reference image.

  A raw reference image can also be provided as a destination for the subject to
  be applied to.
   */ class $e4deb49dba5321bc$export$47ed4b5d00a5d70b {
    /* Internal method to convert to ReferenceImageAPIInternal. */ toReferenceImageAPI() {
        const referenceImageAPI = {
            referenceType: 'REFERENCE_TYPE_SUBJECT',
            referenceImage: this.referenceImage,
            referenceId: this.referenceId,
            subjectImageConfig: this.config
        };
        return referenceImageAPI;
    }
}
/** Response message for API call. */ class $e4deb49dba5321bc$export$a509bcf6072c871c {
    /**
     * Returns the concatenation of all text parts from the server content if present.
     *
     * @remarks
     * If there are non-text parts in the response, the concatenation of all text
     * parts will be returned, and a warning will be logged.
     */ get text() {
        var _a, _b, _c;
        let text = '';
        let anyTextPartFound = false;
        const nonTextParts = [];
        for (const part of (_c = (_b = (_a = this.serverContent) === null || _a === void 0 ? void 0 : _a.modelTurn) === null || _b === void 0 ? void 0 : _b.parts) !== null && _c !== void 0 ? _c : []){
            for (const [fieldName, fieldValue] of Object.entries(part))if (fieldName !== 'text' && fieldName !== 'thought' && fieldValue !== null) nonTextParts.push(fieldName);
            if (typeof part.text === 'string') {
                if (typeof part.thought === 'boolean' && part.thought) continue;
                anyTextPartFound = true;
                text += part.text;
            }
        }
        if (nonTextParts.length > 0) console.warn(`there are non-text parts ${nonTextParts} in the response, returning concatenation of all text parts. Please refer to the non text parts for a full response from model.`);
        // part.text === '' is different from part.text is null
        return anyTextPartFound ? text : undefined;
    }
    /**
     * Returns the concatenation of all inline data parts from the server content if present.
     *
     * @remarks
     * If there are non-inline data parts in the
     * response, the concatenation of all inline data parts will be returned, and
     * a warning will be logged.
     */ get data() {
        var _a, _b, _c;
        let data = '';
        const nonDataParts = [];
        for (const part of (_c = (_b = (_a = this.serverContent) === null || _a === void 0 ? void 0 : _a.modelTurn) === null || _b === void 0 ? void 0 : _b.parts) !== null && _c !== void 0 ? _c : []){
            for (const [fieldName, fieldValue] of Object.entries(part))if (fieldName !== 'inlineData' && fieldValue !== null) nonDataParts.push(fieldName);
            if (part.inlineData && typeof part.inlineData.data === 'string') data += atob(part.inlineData.data);
        }
        if (nonDataParts.length > 0) console.warn(`there are non-data parts ${nonDataParts} in the response, returning concatenation of all data parts. Please refer to the non data parts for a full response from model.`);
        return data.length > 0 ? btoa(data) : undefined;
    }
}
/** Client generated response to a `ToolCall` received from the server.

  Individual `FunctionResponse` objects are matched to the respective
  `FunctionCall` objects by the `id` field.

  Note that in the unary and server-streaming GenerateContent APIs function
  calling happens by exchanging the `Content` parts, while in the bidi
  GenerateContent APIs function calling happens over this dedicated set of
  messages.
   */ class $e4deb49dba5321bc$export$690fe23e241eac7d {
}
/** Parameters for sending tool responses to the live API. */ class $e4deb49dba5321bc$export$5e9f94bd32ad075f {
    constructor(){
        /** Tool responses to send to the session. */ this.functionResponses = [];
    }
}
/** Response message for the LiveMusicClientMessage call. */ class $e4deb49dba5321bc$export$5f085d7f78cd2680 {
    /**
     * Returns the first audio chunk from the server content, if present.
     *
     * @remarks
     * If there are no audio chunks in the response, undefined will be returned.
     */ get audioChunk() {
        if (this.serverContent && this.serverContent.audioChunks && this.serverContent.audioChunks.length > 0) return this.serverContent.audioChunks[0];
        return undefined;
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$tModel(apiClient, model) {
    if (!model || typeof model !== 'string') throw new Error('model is required and must be a string');
    if (apiClient.isVertexAI()) {
        if (model.startsWith('publishers/') || model.startsWith('projects/') || model.startsWith('models/')) return model;
        else if (model.indexOf('/') >= 0) {
            const parts = model.split('/', 2);
            return `publishers/${parts[0]}/models/${parts[1]}`;
        } else return `publishers/google/models/${model}`;
    } else {
        if (model.startsWith('models/') || model.startsWith('tunedModels/')) return model;
        else return `models/${model}`;
    }
}
function $e4deb49dba5321bc$var$tCachesModel(apiClient, model) {
    const transformedModel = $e4deb49dba5321bc$var$tModel(apiClient, model);
    if (!transformedModel) return '';
    if (transformedModel.startsWith('publishers/') && apiClient.isVertexAI()) // vertex caches only support model name start with projects.
    return `projects/${apiClient.getProject()}/locations/${apiClient.getLocation()}/${transformedModel}`;
    else if (transformedModel.startsWith('models/') && apiClient.isVertexAI()) return `projects/${apiClient.getProject()}/locations/${apiClient.getLocation()}/publishers/google/${transformedModel}`;
    else return transformedModel;
}
function $e4deb49dba5321bc$var$tBlobs(blobs) {
    if (Array.isArray(blobs)) return blobs.map((blob)=>$e4deb49dba5321bc$var$tBlob(blob));
    else return [
        $e4deb49dba5321bc$var$tBlob(blobs)
    ];
}
function $e4deb49dba5321bc$var$tBlob(blob) {
    if (typeof blob === 'object' && blob !== null) return blob;
    throw new Error(`Could not parse input as Blob. Unsupported blob type: ${typeof blob}`);
}
function $e4deb49dba5321bc$var$tImageBlob(blob) {
    const transformedBlob = $e4deb49dba5321bc$var$tBlob(blob);
    if (transformedBlob.mimeType && transformedBlob.mimeType.startsWith('image/')) return transformedBlob;
    throw new Error(`Unsupported mime type: ${transformedBlob.mimeType}`);
}
function $e4deb49dba5321bc$var$tAudioBlob(blob) {
    const transformedBlob = $e4deb49dba5321bc$var$tBlob(blob);
    if (transformedBlob.mimeType && transformedBlob.mimeType.startsWith('audio/')) return transformedBlob;
    throw new Error(`Unsupported mime type: ${transformedBlob.mimeType}`);
}
function $e4deb49dba5321bc$var$tPart(origin) {
    if (origin === null || origin === undefined) throw new Error('PartUnion is required');
    if (typeof origin === 'object') return origin;
    if (typeof origin === 'string') return {
        text: origin
    };
    throw new Error(`Unsupported part type: ${typeof origin}`);
}
function $e4deb49dba5321bc$var$tParts(origin) {
    if (origin === null || origin === undefined || Array.isArray(origin) && origin.length === 0) throw new Error('PartListUnion is required');
    if (Array.isArray(origin)) return origin.map((item)=>$e4deb49dba5321bc$var$tPart(item));
    return [
        $e4deb49dba5321bc$var$tPart(origin)
    ];
}
function $e4deb49dba5321bc$var$_isContent(origin) {
    return origin !== null && origin !== undefined && typeof origin === 'object' && 'parts' in origin && Array.isArray(origin.parts);
}
function $e4deb49dba5321bc$var$_isFunctionCallPart(origin) {
    return origin !== null && origin !== undefined && typeof origin === 'object' && 'functionCall' in origin;
}
function $e4deb49dba5321bc$var$_isFunctionResponsePart(origin) {
    return origin !== null && origin !== undefined && typeof origin === 'object' && 'functionResponse' in origin;
}
function $e4deb49dba5321bc$var$tContent(origin) {
    if (origin === null || origin === undefined) throw new Error('ContentUnion is required');
    if ($e4deb49dba5321bc$var$_isContent(origin)) // _isContent is a utility function that checks if the
    // origin is a Content.
    return origin;
    return {
        role: 'user',
        parts: $e4deb49dba5321bc$var$tParts(origin)
    };
}
function $e4deb49dba5321bc$var$tContentsForEmbed(apiClient, origin) {
    if (!origin) return [];
    if (apiClient.isVertexAI() && Array.isArray(origin)) return origin.flatMap((item)=>{
        const content = $e4deb49dba5321bc$var$tContent(item);
        if (content.parts && content.parts.length > 0 && content.parts[0].text !== undefined) return [
            content.parts[0].text
        ];
        return [];
    });
    else if (apiClient.isVertexAI()) {
        const content = $e4deb49dba5321bc$var$tContent(origin);
        if (content.parts && content.parts.length > 0 && content.parts[0].text !== undefined) return [
            content.parts[0].text
        ];
        return [];
    }
    if (Array.isArray(origin)) return origin.map((item)=>$e4deb49dba5321bc$var$tContent(item));
    return [
        $e4deb49dba5321bc$var$tContent(origin)
    ];
}
function $e4deb49dba5321bc$var$tContents(origin) {
    if (origin === null || origin === undefined || Array.isArray(origin) && origin.length === 0) throw new Error('contents are required');
    if (!Array.isArray(origin)) {
        // If it's not an array, it's a single content or a single PartUnion.
        if ($e4deb49dba5321bc$var$_isFunctionCallPart(origin) || $e4deb49dba5321bc$var$_isFunctionResponsePart(origin)) throw new Error('To specify functionCall or functionResponse parts, please wrap them in a Content object, specifying the role for them');
        return [
            $e4deb49dba5321bc$var$tContent(origin)
        ];
    }
    const result = [];
    const accumulatedParts = [];
    const isContentArray = $e4deb49dba5321bc$var$_isContent(origin[0]);
    for (const item of origin){
        const isContent = $e4deb49dba5321bc$var$_isContent(item);
        if (isContent != isContentArray) throw new Error('Mixing Content and Parts is not supported, please group the parts into a the appropriate Content objects and specify the roles for them');
        if (isContent) // `isContent` contains the result of _isContent, which is a utility
        // function that checks if the item is a Content.
        result.push(item);
        else if ($e4deb49dba5321bc$var$_isFunctionCallPart(item) || $e4deb49dba5321bc$var$_isFunctionResponsePart(item)) throw new Error('To specify functionCall or functionResponse parts, please wrap them, and any other parts, in Content objects as appropriate, specifying the role for them');
        else accumulatedParts.push(item);
    }
    if (!isContentArray) result.push({
        role: 'user',
        parts: $e4deb49dba5321bc$var$tParts(accumulatedParts)
    });
    return result;
}
/*
Transform the type field from an array of types to an array of anyOf fields.
Example:
  {type: ['STRING', 'NUMBER']}
will be transformed to
  {anyOf: [{type: 'STRING'}, {type: 'NUMBER'}]}
*/ function $e4deb49dba5321bc$var$flattenTypeArrayToAnyOf(typeList, resultingSchema) {
    if (typeList.includes('null')) resultingSchema['nullable'] = true;
    const listWithoutNull = typeList.filter((type)=>type !== 'null');
    if (listWithoutNull.length === 1) resultingSchema['type'] = Object.values($e4deb49dba5321bc$export$92738401e1603719).includes(listWithoutNull[0].toUpperCase()) ? listWithoutNull[0].toUpperCase() : $e4deb49dba5321bc$export$92738401e1603719.TYPE_UNSPECIFIED;
    else {
        resultingSchema['anyOf'] = [];
        for (const i of listWithoutNull)resultingSchema['anyOf'].push({
            'type': Object.values($e4deb49dba5321bc$export$92738401e1603719).includes(i.toUpperCase()) ? i.toUpperCase() : $e4deb49dba5321bc$export$92738401e1603719.TYPE_UNSPECIFIED
        });
    }
}
function $e4deb49dba5321bc$var$processJsonSchema(_jsonSchema) {
    const genAISchema = {};
    const schemaFieldNames = [
        'items'
    ];
    const listSchemaFieldNames = [
        'anyOf'
    ];
    const dictSchemaFieldNames = [
        'properties'
    ];
    if (_jsonSchema['type'] && _jsonSchema['anyOf']) throw new Error('type and anyOf cannot be both populated.');
    /*
    This is to handle the nullable array or object. The _jsonSchema will
    be in the format of {anyOf: [{type: 'null'}, {type: 'object'}]}. The
    logic is to check if anyOf has 2 elements and one of the element is null,
    if so, the anyOf field is unnecessary, so we need to get rid of the anyOf
    field and make the schema nullable. Then use the other element as the new
    _jsonSchema for processing. This is because the backend doesn't have a null
    type.
    This has to be checked before we process any other fields.
    For example:
      const objectNullable = z.object({
        nullableArray: z.array(z.string()).nullable(),
      });
    Will have the raw _jsonSchema as:
    {
      type: 'OBJECT',
      properties: {
          nullableArray: {
             anyOf: [
                {type: 'null'},
                {
                  type: 'array',
                  items: {type: 'string'},
                },
              ],
          }
      },
      required: [ 'nullableArray' ],
    }
    Will result in following schema compatible with Gemini API:
      {
        type: 'OBJECT',
        properties: {
           nullableArray: {
              nullable: true,
              type: 'ARRAY',
              items: {type: 'string'},
           }
        },
        required: [ 'nullableArray' ],
      }
    */ const incomingAnyOf = _jsonSchema['anyOf'];
    if (incomingAnyOf != null && incomingAnyOf.length == 2) {
        if (incomingAnyOf[0]['type'] === 'null') {
            genAISchema['nullable'] = true;
            _jsonSchema = incomingAnyOf[1];
        } else if (incomingAnyOf[1]['type'] === 'null') {
            genAISchema['nullable'] = true;
            _jsonSchema = incomingAnyOf[0];
        }
    }
    if (_jsonSchema['type'] instanceof Array) $e4deb49dba5321bc$var$flattenTypeArrayToAnyOf(_jsonSchema['type'], genAISchema);
    for (const [fieldName, fieldValue] of Object.entries(_jsonSchema)){
        // Skip if the fieldvalue is undefined or null.
        if (fieldValue == null) continue;
        if (fieldName == 'type') {
            if (fieldValue === 'null') throw new Error('type: null can not be the only possible type for the field.');
            if (fieldValue instanceof Array) continue;
            genAISchema['type'] = Object.values($e4deb49dba5321bc$export$92738401e1603719).includes(fieldValue.toUpperCase()) ? fieldValue.toUpperCase() : $e4deb49dba5321bc$export$92738401e1603719.TYPE_UNSPECIFIED;
        } else if (schemaFieldNames.includes(fieldName)) genAISchema[fieldName] = $e4deb49dba5321bc$var$processJsonSchema(fieldValue);
        else if (listSchemaFieldNames.includes(fieldName)) {
            const listSchemaFieldValue = [];
            for (const item of fieldValue){
                if (item['type'] == 'null') {
                    genAISchema['nullable'] = true;
                    continue;
                }
                listSchemaFieldValue.push($e4deb49dba5321bc$var$processJsonSchema(item));
            }
            genAISchema[fieldName] = listSchemaFieldValue;
        } else if (dictSchemaFieldNames.includes(fieldName)) {
            const dictSchemaFieldValue = {};
            for (const [key, value] of Object.entries(fieldValue))dictSchemaFieldValue[key] = $e4deb49dba5321bc$var$processJsonSchema(value);
            genAISchema[fieldName] = dictSchemaFieldValue;
        } else {
            // additionalProperties is not included in JSONSchema, skipping it.
            if (fieldName === 'additionalProperties') continue;
            genAISchema[fieldName] = fieldValue;
        }
    }
    return genAISchema;
}
// we take the unknown in the schema field because we want enable user to pass
// the output of major schema declaration tools without casting. Tools such as
// zodToJsonSchema, typebox, zodToJsonSchema function can return JsonSchema7Type
// or object, see details in
// https://github.com/StefanTerdell/zod-to-json-schema/blob/70525efe555cd226691e093d171370a3b10921d1/src/zodToJsonSchema.ts#L7
// typebox can return unknown, see details in
// https://github.com/sinclairzx81/typebox/blob/5a5431439f7d5ca6b494d0d18fbfd7b1a356d67c/src/type/create/type.ts#L35
// Note: proper json schemas with the $schema field set never arrive to this
// transformer. Schemas with $schema are routed to the equivalent API json
// schema field.
function $e4deb49dba5321bc$var$tSchema(schema) {
    return $e4deb49dba5321bc$var$processJsonSchema(schema);
}
function $e4deb49dba5321bc$var$tSpeechConfig(speechConfig) {
    if (typeof speechConfig === 'object') return speechConfig;
    else if (typeof speechConfig === 'string') return {
        voiceConfig: {
            prebuiltVoiceConfig: {
                voiceName: speechConfig
            }
        }
    };
    else throw new Error(`Unsupported speechConfig type: ${typeof speechConfig}`);
}
function $e4deb49dba5321bc$var$tLiveSpeechConfig(speechConfig) {
    if ('multiSpeakerVoiceConfig' in speechConfig) throw new Error('multiSpeakerVoiceConfig is not supported in the live API.');
    return speechConfig;
}
function $e4deb49dba5321bc$var$tTool(tool) {
    if (tool.functionDeclarations) for (const functionDeclaration of tool.functionDeclarations){
        if (functionDeclaration.parameters) {
            if (!Object.keys(functionDeclaration.parameters).includes('$schema')) functionDeclaration.parameters = $e4deb49dba5321bc$var$processJsonSchema(functionDeclaration.parameters);
            else if (!functionDeclaration.parametersJsonSchema) {
                functionDeclaration.parametersJsonSchema = functionDeclaration.parameters;
                delete functionDeclaration.parameters;
            }
        }
        if (functionDeclaration.response) {
            if (!Object.keys(functionDeclaration.response).includes('$schema')) functionDeclaration.response = $e4deb49dba5321bc$var$processJsonSchema(functionDeclaration.response);
            else if (!functionDeclaration.responseJsonSchema) {
                functionDeclaration.responseJsonSchema = functionDeclaration.response;
                delete functionDeclaration.response;
            }
        }
    }
    return tool;
}
function $e4deb49dba5321bc$var$tTools(tools) {
    // Check if the incoming type is defined.
    if (tools === undefined || tools === null) throw new Error('tools is required');
    if (!Array.isArray(tools)) throw new Error('tools is required and must be an array of Tools');
    const result = [];
    for (const tool of tools)result.push(tool);
    return result;
}
/**
 * Prepends resource name with project, location, resource_prefix if needed.
 *
 * @param client The API client.
 * @param resourceName The resource name.
 * @param resourcePrefix The resource prefix.
 * @param splitsAfterPrefix The number of splits after the prefix.
 * @returns The completed resource name.
 *
 * Examples:
 *
 * ```
 * resource_name = '123'
 * resource_prefix = 'cachedContents'
 * splits_after_prefix = 1
 * client.vertexai = True
 * client.project = 'bar'
 * client.location = 'us-west1'
 * _resource_name(client, resource_name, resource_prefix, splits_after_prefix)
 * returns: 'projects/bar/locations/us-west1/cachedContents/123'
 * ```
 *
 * ```
 * resource_name = 'projects/foo/locations/us-central1/cachedContents/123'
 * resource_prefix = 'cachedContents'
 * splits_after_prefix = 1
 * client.vertexai = True
 * client.project = 'bar'
 * client.location = 'us-west1'
 * _resource_name(client, resource_name, resource_prefix, splits_after_prefix)
 * returns: 'projects/foo/locations/us-central1/cachedContents/123'
 * ```
 *
 * ```
 * resource_name = '123'
 * resource_prefix = 'cachedContents'
 * splits_after_prefix = 1
 * client.vertexai = False
 * _resource_name(client, resource_name, resource_prefix, splits_after_prefix)
 * returns 'cachedContents/123'
 * ```
 *
 * ```
 * resource_name = 'some/wrong/cachedContents/resource/name/123'
 * resource_prefix = 'cachedContents'
 * splits_after_prefix = 1
 * client.vertexai = False
 * # client.vertexai = True
 * _resource_name(client, resource_name, resource_prefix, splits_after_prefix)
 * -> 'some/wrong/resource/name/123'
 * ```
 */ function $e4deb49dba5321bc$var$resourceName(client, resourceName1, resourcePrefix, splitsAfterPrefix = 1) {
    const shouldAppendPrefix = !resourceName1.startsWith(`${resourcePrefix}/`) && resourceName1.split('/').length === splitsAfterPrefix;
    if (client.isVertexAI()) {
        if (resourceName1.startsWith('projects/')) return resourceName1;
        else if (resourceName1.startsWith('locations/')) return `projects/${client.getProject()}/${resourceName1}`;
        else if (resourceName1.startsWith(`${resourcePrefix}/`)) return `projects/${client.getProject()}/locations/${client.getLocation()}/${resourceName1}`;
        else if (shouldAppendPrefix) return `projects/${client.getProject()}/locations/${client.getLocation()}/${resourcePrefix}/${resourceName1}`;
        else return resourceName1;
    }
    if (shouldAppendPrefix) return `${resourcePrefix}/${resourceName1}`;
    return resourceName1;
}
function $e4deb49dba5321bc$var$tCachedContentName(apiClient, name) {
    if (typeof name !== 'string') throw new Error('name must be a string');
    return $e4deb49dba5321bc$var$resourceName(apiClient, name, 'cachedContents');
}
function $e4deb49dba5321bc$var$tTuningJobStatus(status) {
    switch(status){
        case 'STATE_UNSPECIFIED':
            return 'JOB_STATE_UNSPECIFIED';
        case 'CREATING':
            return 'JOB_STATE_RUNNING';
        case 'ACTIVE':
            return 'JOB_STATE_SUCCEEDED';
        case 'FAILED':
            return 'JOB_STATE_FAILED';
        default:
            return status;
    }
}
function $e4deb49dba5321bc$var$tBytes(fromImageBytes) {
    return $e4deb49dba5321bc$var$tBytes$1(fromImageBytes);
}
function $e4deb49dba5321bc$var$_isFile(origin) {
    return origin !== null && origin !== undefined && typeof origin === 'object' && 'name' in origin;
}
function $e4deb49dba5321bc$var$isGeneratedVideo(origin) {
    return origin !== null && origin !== undefined && typeof origin === 'object' && 'video' in origin;
}
function $e4deb49dba5321bc$var$isVideo(origin) {
    return origin !== null && origin !== undefined && typeof origin === 'object' && 'uri' in origin;
}
function $e4deb49dba5321bc$var$tFileName(fromName) {
    var _a;
    let name;
    if ($e4deb49dba5321bc$var$_isFile(fromName)) name = fromName.name;
    if ($e4deb49dba5321bc$var$isVideo(fromName)) {
        name = fromName.uri;
        if (name === undefined) return undefined;
    }
    if ($e4deb49dba5321bc$var$isGeneratedVideo(fromName)) {
        name = (_a = fromName.video) === null || _a === void 0 ? void 0 : _a.uri;
        if (name === undefined) return undefined;
    }
    if (typeof fromName === 'string') name = fromName;
    if (name === undefined) throw new Error('Could not extract file name from the provided input.');
    if (name.startsWith('https://')) {
        const suffix = name.split('files/')[1];
        const match = suffix.match(/[a-z0-9]+/);
        if (match === null) throw new Error(`Could not extract file name from URI ${name}`);
        name = match[0];
    } else if (name.startsWith('files/')) name = name.split('files/')[1];
    return name;
}
function $e4deb49dba5321bc$var$tModelsUrl(apiClient, baseModels) {
    let res;
    if (apiClient.isVertexAI()) res = baseModels ? 'publishers/google/models' : 'models';
    else res = baseModels ? 'models' : 'tunedModels';
    return res;
}
function $e4deb49dba5321bc$var$tExtractModels(response) {
    for (const key of [
        'models',
        'tunedModels',
        'publisherModels'
    ]){
        if ($e4deb49dba5321bc$var$hasField(response, key)) return response[key];
    }
    return [];
}
function $e4deb49dba5321bc$var$hasField(data, fieldName) {
    return data !== null && typeof data === 'object' && fieldName in data;
}
function $e4deb49dba5321bc$var$mcpToGeminiTool(mcpTool, config = {}) {
    const mcpToolSchema = mcpTool;
    const functionDeclaration = {
        name: mcpToolSchema['name'],
        description: mcpToolSchema['description'],
        parametersJsonSchema: mcpToolSchema['inputSchema']
    };
    if (mcpToolSchema['outputSchema']) functionDeclaration['responseJsonSchema'] = mcpToolSchema['outputSchema'];
    if (config.behavior) functionDeclaration['behavior'] = config.behavior;
    const geminiTool = {
        functionDeclarations: [
            functionDeclaration
        ]
    };
    return geminiTool;
}
/**
 * Converts a list of MCP tools to a single Gemini tool with a list of function
 * declarations.
 */ function $e4deb49dba5321bc$var$mcpToolsToGeminiTool(mcpTools, config = {}) {
    const functionDeclarations = [];
    const toolNames = new Set();
    for (const mcpTool of mcpTools){
        const mcpToolName = mcpTool.name;
        if (toolNames.has(mcpToolName)) throw new Error(`Duplicate function name ${mcpToolName} found in MCP tools. Please ensure function names are unique.`);
        toolNames.add(mcpToolName);
        const geminiTool = $e4deb49dba5321bc$var$mcpToGeminiTool(mcpTool, config);
        if (geminiTool.functionDeclarations) functionDeclarations.push(...geminiTool.functionDeclarations);
    }
    return {
        functionDeclarations: functionDeclarations
    };
}
// Transforms a source input into a BatchJobSource object with validation.
function $e4deb49dba5321bc$var$tBatchJobSource(client, src) {
    let sourceObj;
    if (typeof src === 'string') {
        if (client.isVertexAI()) {
            if (src.startsWith('gs://')) sourceObj = {
                format: 'jsonl',
                gcsUri: [
                    src
                ]
            };
            else if (src.startsWith('bq://')) sourceObj = {
                format: 'bigquery',
                bigqueryUri: src
            };
            else throw new Error(`Unsupported string source for Vertex AI: ${src}`);
        } else {
            // MLDEV
            if (src.startsWith('files/')) sourceObj = {
                fileName: src
            }; // Default to fileName for string input
            else throw new Error(`Unsupported string source for Gemini API: ${src}`);
        }
    } else if (Array.isArray(src)) {
        if (client.isVertexAI()) throw new Error('InlinedRequest[] is not supported in Vertex AI.');
        sourceObj = {
            inlinedRequests: src
        };
    } else // It's already a BatchJobSource object
    sourceObj = src;
    // Validation logic
    const vertexSourcesCount = [
        sourceObj.gcsUri,
        sourceObj.bigqueryUri
    ].filter(Boolean).length;
    const mldevSourcesCount = [
        sourceObj.inlinedRequests,
        sourceObj.fileName
    ].filter(Boolean).length;
    if (client.isVertexAI()) {
        if (mldevSourcesCount > 0 || vertexSourcesCount !== 1) throw new Error('Exactly one of `gcsUri` or `bigqueryUri` must be set for Vertex AI.');
    } else {
        // MLDEV
        if (vertexSourcesCount > 0 || mldevSourcesCount !== 1) throw new Error("Exactly one of `inlinedRequests`, `fileName`, must be set for Gemini API.");
    }
    return sourceObj;
}
function $e4deb49dba5321bc$var$tBatchJobDestination(dest) {
    if (typeof dest !== 'string') return dest;
    const destString = dest;
    if (destString.startsWith('gs://')) return {
        format: 'jsonl',
        gcsUri: destString
    };
    else if (destString.startsWith('bq://')) return {
        format: 'bigquery',
        bigqueryUri: destString
    };
    else throw new Error(`Unsupported destination: ${destString}`);
}
function $e4deb49dba5321bc$var$tRecvBatchJobDestination(dest) {
    // Ensure dest is a non-null object before proceeding.
    if (typeof dest !== 'object' || dest === null) // If the input is not an object, it cannot be a valid BatchJobDestination
    // based on the operations performed. Return it cast, or handle as an error.
    // Casting an empty object might be a safe default.
    return {};
    // Cast to Record<string, unknown> to allow string property access.
    const obj = dest;
    // Safely access nested properties.
    const inlineResponsesVal = obj['inlinedResponses'];
    if (typeof inlineResponsesVal !== 'object' || inlineResponsesVal === null) return dest;
    const inlineResponsesObj = inlineResponsesVal;
    const responsesArray = inlineResponsesObj['inlinedResponses'];
    if (!Array.isArray(responsesArray) || responsesArray.length === 0) return dest;
    // Check if any response has the 'embedding' property.
    let hasEmbedding = false;
    for (const responseItem of responsesArray){
        if (typeof responseItem !== 'object' || responseItem === null) continue;
        const responseItemObj = responseItem;
        const responseVal = responseItemObj['response'];
        if (typeof responseVal !== 'object' || responseVal === null) continue;
        const responseObj = responseVal;
        // Check for the existence of the 'embedding' key.
        if (responseObj['embedding'] !== undefined) {
            hasEmbedding = true;
            break;
        }
    }
    // Perform the transformation if an embedding was found.
    if (hasEmbedding) {
        obj['inlinedEmbedContentResponses'] = obj['inlinedResponses'];
        delete obj['inlinedResponses'];
    }
    // Cast the (potentially) modified object to the target type.
    return dest;
}
function $e4deb49dba5321bc$var$tBatchJobName(apiClient, name) {
    const nameString = name;
    if (!apiClient.isVertexAI()) {
        const mldevPattern = /batches\/[^/]+$/;
        if (mldevPattern.test(nameString)) return nameString.split('/').pop();
        else throw new Error(`Invalid batch job name: ${nameString}.`);
    }
    const vertexPattern = /^projects\/[^/]+\/locations\/[^/]+\/batchPredictionJobs\/[^/]+$/;
    if (vertexPattern.test(nameString)) return nameString.split('/').pop();
    else if (/^\d+$/.test(nameString)) return nameString;
    else throw new Error(`Invalid batch job name: ${nameString}.`);
}
function $e4deb49dba5321bc$var$tJobState(state) {
    const stateString = state;
    if (stateString === 'BATCH_STATE_UNSPECIFIED') return 'JOB_STATE_UNSPECIFIED';
    else if (stateString === 'BATCH_STATE_PENDING') return 'JOB_STATE_PENDING';
    else if (stateString === 'BATCH_STATE_SUCCEEDED') return 'JOB_STATE_SUCCEEDED';
    else if (stateString === 'BATCH_STATE_FAILED') return 'JOB_STATE_FAILED';
    else if (stateString === 'BATCH_STATE_CANCELLED') return 'JOB_STATE_CANCELLED';
    else return stateString;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$videoMetadataToMldev$4(fromObject) {
    const toObject = {};
    const fromFps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fps'
    ]);
    if (fromFps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fps'
    ], fromFps);
    const fromEndOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endOffset'
    ]);
    if (fromEndOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endOffset'
    ], fromEndOffset);
    const fromStartOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startOffset'
    ]);
    if (fromStartOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startOffset'
    ], fromStartOffset);
    return toObject;
}
function $e4deb49dba5321bc$var$blobToMldev$4(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$fileDataToMldev$4(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromFileUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallToMldev$4(fromObject) {
    const toObject = {};
    const fromId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'id'
    ]);
    if (fromId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'id'
    ], fromId);
    const fromArgs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$partToMldev$4(fromObject) {
    const toObject = {};
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], $e4deb49dba5321bc$var$videoMetadataToMldev$4(fromVideoMetadata));
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], $e4deb49dba5321bc$var$blobToMldev$4(fromInlineData));
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], $e4deb49dba5321bc$var$fileDataToMldev$4(fromFileData));
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], $e4deb49dba5321bc$var$functionCallToMldev$4(fromFunctionCall));
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    return toObject;
}
function $e4deb49dba5321bc$var$contentToMldev$4(fromObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partToMldev$4(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$schemaToMldev$1(fromObject) {
    const toObject = {};
    const fromAnyOf = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'anyOf'
    ]);
    if (fromAnyOf != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'anyOf'
    ], fromAnyOf);
    const fromDefault = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'default'
    ]);
    if (fromDefault != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'default'
    ], fromDefault);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromEnum = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enum'
    ]);
    if (fromEnum != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enum'
    ], fromEnum);
    const fromExample = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'example'
    ]);
    if (fromExample != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'example'
    ], fromExample);
    const fromFormat = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'format'
    ]);
    if (fromFormat != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'format'
    ], fromFormat);
    const fromItems = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'items'
    ]);
    if (fromItems != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'items'
    ], fromItems);
    const fromMaxItems = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxItems'
    ]);
    if (fromMaxItems != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maxItems'
    ], fromMaxItems);
    const fromMaxLength = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxLength'
    ]);
    if (fromMaxLength != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maxLength'
    ], fromMaxLength);
    const fromMaxProperties = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxProperties'
    ]);
    if (fromMaxProperties != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maxProperties'
    ], fromMaxProperties);
    const fromMaximum = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maximum'
    ]);
    if (fromMaximum != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maximum'
    ], fromMaximum);
    const fromMinItems = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'minItems'
    ]);
    if (fromMinItems != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'minItems'
    ], fromMinItems);
    const fromMinLength = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'minLength'
    ]);
    if (fromMinLength != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'minLength'
    ], fromMinLength);
    const fromMinProperties = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'minProperties'
    ]);
    if (fromMinProperties != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'minProperties'
    ], fromMinProperties);
    const fromMinimum = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'minimum'
    ]);
    if (fromMinimum != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'minimum'
    ], fromMinimum);
    const fromNullable = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nullable'
    ]);
    if (fromNullable != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nullable'
    ], fromNullable);
    const fromPattern = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pattern'
    ]);
    if (fromPattern != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'pattern'
    ], fromPattern);
    const fromProperties = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'properties'
    ]);
    if (fromProperties != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'properties'
    ], fromProperties);
    const fromPropertyOrdering = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'propertyOrdering'
    ]);
    if (fromPropertyOrdering != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'propertyOrdering'
    ], fromPropertyOrdering);
    const fromRequired = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'required'
    ]);
    if (fromRequired != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'required'
    ], fromRequired);
    const fromTitle = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'title'
    ]);
    if (fromTitle != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'title'
    ], fromTitle);
    const fromType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'type'
    ]);
    if (fromType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'type'
    ], fromType);
    return toObject;
}
function $e4deb49dba5321bc$var$safetySettingToMldev$1(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'method'
    ]) !== undefined) throw new Error('method parameter is not supported in Gemini API.');
    const fromCategory = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'category'
    ]);
    if (fromCategory != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'category'
    ], fromCategory);
    const fromThreshold = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'threshold'
    ]);
    if (fromThreshold != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'threshold'
    ], fromThreshold);
    return toObject;
}
function $e4deb49dba5321bc$var$functionDeclarationToMldev$4(fromObject) {
    const toObject = {};
    const fromBehavior = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'behavior'
    ]);
    if (fromBehavior != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'behavior'
    ], fromBehavior);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromParameters = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parameters'
    ]);
    if (fromParameters != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parameters'
    ], fromParameters);
    const fromParametersJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parametersJsonSchema'
    ]);
    if (fromParametersJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parametersJsonSchema'
    ], fromParametersJsonSchema);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], fromResponse);
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    return toObject;
}
function $e4deb49dba5321bc$var$intervalToMldev$4(fromObject) {
    const toObject = {};
    const fromStartTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startTime'
    ]);
    if (fromStartTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endTime'
    ]);
    if (fromEndTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchToMldev$4(fromObject) {
    const toObject = {};
    const fromTimeRangeFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'timeRangeFilter'
    ], $e4deb49dba5321bc$var$intervalToMldev$4(fromTimeRangeFilter));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'excludeDomains'
    ]) !== undefined) throw new Error('excludeDomains parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$dynamicRetrievalConfigToMldev$4(fromObject) {
    const toObject = {};
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mode'
    ], fromMode);
    const fromDynamicThreshold = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'dynamicThreshold'
    ]);
    if (fromDynamicThreshold != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dynamicThreshold'
    ], fromDynamicThreshold);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchRetrievalToMldev$4(fromObject) {
    const toObject = {};
    const fromDynamicRetrievalConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'dynamicRetrievalConfig'
    ]);
    if (fromDynamicRetrievalConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dynamicRetrievalConfig'
    ], $e4deb49dba5321bc$var$dynamicRetrievalConfigToMldev$4(fromDynamicRetrievalConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$urlContextToMldev$4() {
    const toObject = {};
    return toObject;
}
function $e4deb49dba5321bc$var$toolComputerUseToMldev$4(fromObject) {
    const toObject = {};
    const fromEnvironment = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'environment'
    ]);
    if (fromEnvironment != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'environment'
    ], fromEnvironment);
    return toObject;
}
function $e4deb49dba5321bc$var$toolToMldev$4(fromObject) {
    const toObject = {};
    const fromFunctionDeclarations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$functionDeclarationToMldev$4(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrieval'
    ]) !== undefined) throw new Error('retrieval parameter is not supported in Gemini API.');
    const fromGoogleSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearch'
    ], $e4deb49dba5321bc$var$googleSearchToMldev$4(fromGoogleSearch));
    const fromGoogleSearchRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], $e4deb49dba5321bc$var$googleSearchRetrievalToMldev$4(fromGoogleSearchRetrieval));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]) !== undefined) throw new Error('enterpriseWebSearch parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleMaps'
    ]) !== undefined) throw new Error('googleMaps parameter is not supported in Gemini API.');
    const fromUrlContext = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContext'
    ], $e4deb49dba5321bc$var$urlContextToMldev$4());
    const fromComputerUse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'computerUse'
    ]);
    if (fromComputerUse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computerUse'
    ], $e4deb49dba5321bc$var$toolComputerUseToMldev$4(fromComputerUse));
    const fromCodeExecution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallingConfigToMldev$2(fromObject) {
    const toObject = {};
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mode'
    ], fromMode);
    const fromAllowedFunctionNames = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'allowedFunctionNames'
    ]);
    if (fromAllowedFunctionNames != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'allowedFunctionNames'
    ], fromAllowedFunctionNames);
    return toObject;
}
function $e4deb49dba5321bc$var$latLngToMldev$2(fromObject) {
    const toObject = {};
    const fromLatitude = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'latitude'
    ]);
    if (fromLatitude != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'latitude'
    ], fromLatitude);
    const fromLongitude = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'longitude'
    ]);
    if (fromLongitude != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'longitude'
    ], fromLongitude);
    return toObject;
}
function $e4deb49dba5321bc$var$retrievalConfigToMldev$2(fromObject) {
    const toObject = {};
    const fromLatLng = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'latLng'
    ]);
    if (fromLatLng != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'latLng'
    ], $e4deb49dba5321bc$var$latLngToMldev$2(fromLatLng));
    const fromLanguageCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'languageCode'
    ]);
    if (fromLanguageCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'languageCode'
    ], fromLanguageCode);
    return toObject;
}
function $e4deb49dba5321bc$var$toolConfigToMldev$2(fromObject) {
    const toObject = {};
    const fromFunctionCallingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCallingConfig'
    ]);
    if (fromFunctionCallingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCallingConfig'
    ], $e4deb49dba5321bc$var$functionCallingConfigToMldev$2(fromFunctionCallingConfig));
    const fromRetrievalConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrievalConfig'
    ]);
    if (fromRetrievalConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrievalConfig'
    ], $e4deb49dba5321bc$var$retrievalConfigToMldev$2(fromRetrievalConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$prebuiltVoiceConfigToMldev$3(fromObject) {
    const toObject = {};
    const fromVoiceName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceName'
    ]);
    if (fromVoiceName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceName'
    ], fromVoiceName);
    return toObject;
}
function $e4deb49dba5321bc$var$voiceConfigToMldev$3(fromObject) {
    const toObject = {};
    const fromPrebuiltVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prebuiltVoiceConfig'
    ]);
    if (fromPrebuiltVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'prebuiltVoiceConfig'
    ], $e4deb49dba5321bc$var$prebuiltVoiceConfigToMldev$3(fromPrebuiltVoiceConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$speakerVoiceConfigToMldev$3(fromObject) {
    const toObject = {};
    const fromSpeaker = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speaker'
    ]);
    if (fromSpeaker != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'speaker'
    ], fromSpeaker);
    const fromVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceConfig'
    ]);
    if (fromVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceConfig'
    ], $e4deb49dba5321bc$var$voiceConfigToMldev$3(fromVoiceConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$multiSpeakerVoiceConfigToMldev$3(fromObject) {
    const toObject = {};
    const fromSpeakerVoiceConfigs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speakerVoiceConfigs'
    ]);
    if (fromSpeakerVoiceConfigs != null) {
        let transformedList = fromSpeakerVoiceConfigs;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$speakerVoiceConfigToMldev$3(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'speakerVoiceConfigs'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$speechConfigToMldev$3(fromObject) {
    const toObject = {};
    const fromVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceConfig'
    ]);
    if (fromVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceConfig'
    ], $e4deb49dba5321bc$var$voiceConfigToMldev$3(fromVoiceConfig));
    const fromMultiSpeakerVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'multiSpeakerVoiceConfig'
    ]);
    if (fromMultiSpeakerVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'multiSpeakerVoiceConfig'
    ], $e4deb49dba5321bc$var$multiSpeakerVoiceConfigToMldev$3(fromMultiSpeakerVoiceConfig));
    const fromLanguageCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'languageCode'
    ]);
    if (fromLanguageCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'languageCode'
    ], fromLanguageCode);
    return toObject;
}
function $e4deb49dba5321bc$var$thinkingConfigToMldev$1(fromObject) {
    const toObject = {};
    const fromIncludeThoughts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeThoughts'
    ]);
    if (fromIncludeThoughts != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'includeThoughts'
    ], fromIncludeThoughts);
    const fromThinkingBudget = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thinkingBudget'
    ]);
    if (fromThinkingBudget != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thinkingBudget'
    ], fromThinkingBudget);
    return toObject;
}
function $e4deb49dba5321bc$var$generateContentConfigToMldev$1(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'systemInstruction'
    ], $e4deb49dba5321bc$var$contentToMldev$4($e4deb49dba5321bc$var$tContent(fromSystemInstruction)));
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'temperature'
    ], fromTemperature);
    const fromTopP = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topP'
    ]);
    if (fromTopP != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topP'
    ], fromTopP);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topK'
    ], fromTopK);
    const fromCandidateCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidateCount'
    ]);
    if (fromCandidateCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'candidateCount'
    ], fromCandidateCount);
    const fromMaxOutputTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (fromMaxOutputTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromStopSequences = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'stopSequences'
    ]);
    if (fromStopSequences != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'stopSequences'
    ], fromStopSequences);
    const fromResponseLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseLogprobs'
    ]);
    if (fromResponseLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseLogprobs'
    ], fromResponseLogprobs);
    const fromLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'logprobs'
    ]);
    if (fromLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'logprobs'
    ], fromLogprobs);
    const fromPresencePenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'presencePenalty'
    ]);
    if (fromPresencePenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'presencePenalty'
    ], fromPresencePenalty);
    const fromFrequencyPenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'frequencyPenalty'
    ]);
    if (fromFrequencyPenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'frequencyPenalty'
    ], fromFrequencyPenalty);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'seed'
    ], fromSeed);
    const fromResponseMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseMimeType'
    ]);
    if (fromResponseMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseMimeType'
    ], fromResponseMimeType);
    const fromResponseSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseSchema'
    ]);
    if (fromResponseSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseSchema'
    ], $e4deb49dba5321bc$var$schemaToMldev$1($e4deb49dba5321bc$var$tSchema(fromResponseSchema)));
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'routingConfig'
    ]) !== undefined) throw new Error('routingConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelSelectionConfig'
    ]) !== undefined) throw new Error('modelSelectionConfig parameter is not supported in Gemini API.');
    const fromSafetySettings = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetySettings'
    ]);
    if (parentObject !== undefined && fromSafetySettings != null) {
        let transformedList = fromSafetySettings;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$safetySettingToMldev$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'safetySettings'
        ], transformedList);
    }
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = $e4deb49dba5321bc$var$tTools(fromTools);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToMldev$4($e4deb49dba5321bc$var$tTool(item));
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'tools'
        ], transformedList);
    }
    const fromToolConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolConfig'
    ]);
    if (parentObject !== undefined && fromToolConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'toolConfig'
    ], $e4deb49dba5321bc$var$toolConfigToMldev$2(fromToolConfig));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]) !== undefined) throw new Error('labels parameter is not supported in Gemini API.');
    const fromCachedContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cachedContent'
    ]);
    if (parentObject !== undefined && fromCachedContent != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'cachedContent'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromCachedContent));
    const fromResponseModalities = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (fromResponseModalities != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseModalities'
    ], fromResponseModalities);
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromSpeechConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (fromSpeechConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'speechConfig'
    ], $e4deb49dba5321bc$var$speechConfigToMldev$3($e4deb49dba5321bc$var$tSpeechConfig(fromSpeechConfig)));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audioTimestamp'
    ]) !== undefined) throw new Error('audioTimestamp parameter is not supported in Gemini API.');
    const fromThinkingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thinkingConfig'
    ]);
    if (fromThinkingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thinkingConfig'
    ], $e4deb49dba5321bc$var$thinkingConfigToMldev$1(fromThinkingConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$inlinedRequestToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'request',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContents(fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$contentToMldev$4(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'request',
            'contents'
        ], transformedList);
    }
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'request',
        'generationConfig'
    ], $e4deb49dba5321bc$var$generateContentConfigToMldev$1(apiClient, fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$batchJobSourceToMldev(apiClient, fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'format'
    ]) !== undefined) throw new Error('format parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]) !== undefined) throw new Error('gcsUri parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bigqueryUri'
    ]) !== undefined) throw new Error('bigqueryUri parameter is not supported in Gemini API.');
    const fromFileName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileName'
    ]);
    if (fromFileName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileName'
    ], fromFileName);
    const fromInlinedRequests = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlinedRequests'
    ]);
    if (fromInlinedRequests != null) {
        let transformedList = fromInlinedRequests;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$inlinedRequestToMldev(apiClient, item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'requests',
            'requests'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$createBatchJobConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'batch',
        'displayName'
    ], fromDisplayName);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'dest'
    ]) !== undefined) throw new Error('dest parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$createBatchJobParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromSrc = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'src'
    ]);
    if (fromSrc != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'batch',
        'inputConfig'
    ], $e4deb49dba5321bc$var$batchJobSourceToMldev(apiClient, $e4deb49dba5321bc$var$tBatchJobSource(apiClient, fromSrc)));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$createBatchJobConfigToMldev(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentConfigToMldev$1(fromObject, parentObject) {
    const toObject = {};
    const fromTaskType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'taskType'
    ]);
    if (parentObject !== undefined && fromTaskType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'requests[]',
        'taskType'
    ], fromTaskType);
    const fromTitle = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'title'
    ]);
    if (parentObject !== undefined && fromTitle != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'requests[]',
        'title'
    ], fromTitle);
    const fromOutputDimensionality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputDimensionality'
    ]);
    if (parentObject !== undefined && fromOutputDimensionality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'requests[]',
        'outputDimensionality'
    ], fromOutputDimensionality);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]) !== undefined) throw new Error('mimeType parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'autoTruncate'
    ]) !== undefined) throw new Error('autoTruncate parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentBatchToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'requests[]',
        'request',
        'content'
    ], $e4deb49dba5321bc$var$tContentsForEmbed(apiClient, fromContents));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$embedContentConfigToMldev$1(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$embeddingsBatchJobSourceToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromFileName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileName'
    ]);
    if (fromFileName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'file_name'
    ], fromFileName);
    const fromInlinedRequests = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlinedRequests'
    ]);
    if (fromInlinedRequests != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'requests'
    ], $e4deb49dba5321bc$var$embedContentBatchToMldev(apiClient, fromInlinedRequests));
    return toObject;
}
function $e4deb49dba5321bc$var$createEmbeddingsBatchJobConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'batch',
        'displayName'
    ], fromDisplayName);
    return toObject;
}
function $e4deb49dba5321bc$var$createEmbeddingsBatchJobParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromSrc = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'src'
    ]);
    if (fromSrc != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'batch',
        'inputConfig'
    ], $e4deb49dba5321bc$var$embeddingsBatchJobSourceToMldev(apiClient, fromSrc));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$createEmbeddingsBatchJobConfigToMldev(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$getBatchJobParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tBatchJobName(apiClient, fromName));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$cancelBatchJobParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tBatchJobName(apiClient, fromName));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$listBatchJobsConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'filter'
    ]) !== undefined) throw new Error('filter parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$listBatchJobsParametersToMldev(fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$listBatchJobsConfigToMldev(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$deleteBatchJobParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tBatchJobName(apiClient, fromName));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$batchJobSourceToVertex(fromObject) {
    const toObject = {};
    const fromFormat = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'format'
    ]);
    if (fromFormat != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instancesFormat'
    ], fromFormat);
    const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'gcsSource',
        'uris'
    ], fromGcsUri);
    const fromBigqueryUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bigqueryUri'
    ]);
    if (fromBigqueryUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'bigquerySource',
        'inputUri'
    ], fromBigqueryUri);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileName'
    ]) !== undefined) throw new Error('fileName parameter is not supported in Vertex AI.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlinedRequests'
    ]) !== undefined) throw new Error('inlinedRequests parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$batchJobDestinationToVertex(fromObject) {
    const toObject = {};
    const fromFormat = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'format'
    ]);
    if (fromFormat != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'predictionsFormat'
    ], fromFormat);
    const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'gcsDestination',
        'outputUriPrefix'
    ], fromGcsUri);
    const fromBigqueryUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bigqueryUri'
    ]);
    if (fromBigqueryUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'bigqueryDestination',
        'outputUri'
    ], fromBigqueryUri);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileName'
    ]) !== undefined) throw new Error('fileName parameter is not supported in Vertex AI.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlinedResponses'
    ]) !== undefined) throw new Error('inlinedResponses parameter is not supported in Vertex AI.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlinedEmbedContentResponses'
    ]) !== undefined) throw new Error('inlinedEmbedContentResponses parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$createBatchJobConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'displayName'
    ], fromDisplayName);
    const fromDest = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'dest'
    ]);
    if (parentObject !== undefined && fromDest != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'outputConfig'
    ], $e4deb49dba5321bc$var$batchJobDestinationToVertex($e4deb49dba5321bc$var$tBatchJobDestination(fromDest)));
    return toObject;
}
function $e4deb49dba5321bc$var$createBatchJobParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromSrc = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'src'
    ]);
    if (fromSrc != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inputConfig'
    ], $e4deb49dba5321bc$var$batchJobSourceToVertex($e4deb49dba5321bc$var$tBatchJobSource(apiClient, fromSrc)));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$createBatchJobConfigToVertex(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$getBatchJobParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tBatchJobName(apiClient, fromName));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$cancelBatchJobParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tBatchJobName(apiClient, fromName));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$listBatchJobsConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    const fromFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'filter'
    ]);
    if (parentObject !== undefined && fromFilter != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'filter'
    ], fromFilter);
    return toObject;
}
function $e4deb49dba5321bc$var$listBatchJobsParametersToVertex(fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$listBatchJobsConfigToVertex(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$deleteBatchJobParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tBatchJobName(apiClient, fromName));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$videoMetadataFromMldev$2(fromObject) {
    const toObject = {};
    const fromFps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fps'
    ]);
    if (fromFps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fps'
    ], fromFps);
    const fromEndOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endOffset'
    ]);
    if (fromEndOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endOffset'
    ], fromEndOffset);
    const fromStartOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startOffset'
    ]);
    if (fromStartOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startOffset'
    ], fromStartOffset);
    return toObject;
}
function $e4deb49dba5321bc$var$blobFromMldev$2(fromObject) {
    const toObject = {};
    const fromData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$fileDataFromMldev$2(fromObject) {
    const toObject = {};
    const fromFileUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallFromMldev$2(fromObject) {
    const toObject = {};
    const fromId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'id'
    ]);
    if (fromId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'id'
    ], fromId);
    const fromArgs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$partFromMldev$2(fromObject) {
    const toObject = {};
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], $e4deb49dba5321bc$var$videoMetadataFromMldev$2(fromVideoMetadata));
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], $e4deb49dba5321bc$var$blobFromMldev$2(fromInlineData));
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], $e4deb49dba5321bc$var$fileDataFromMldev$2(fromFileData));
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], $e4deb49dba5321bc$var$functionCallFromMldev$2(fromFunctionCall));
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    return toObject;
}
function $e4deb49dba5321bc$var$contentFromMldev$2(fromObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partFromMldev$2(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$citationMetadataFromMldev$1(fromObject) {
    const toObject = {};
    const fromCitations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'citationSources'
    ]);
    if (fromCitations != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'citations'
    ], fromCitations);
    return toObject;
}
function $e4deb49dba5321bc$var$urlMetadataFromMldev$2(fromObject) {
    const toObject = {};
    const fromRetrievedUrl = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrievedUrl'
    ]);
    if (fromRetrievedUrl != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrievedUrl'
    ], fromRetrievedUrl);
    const fromUrlRetrievalStatus = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlRetrievalStatus'
    ]);
    if (fromUrlRetrievalStatus != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlRetrievalStatus'
    ], fromUrlRetrievalStatus);
    return toObject;
}
function $e4deb49dba5321bc$var$urlContextMetadataFromMldev$2(fromObject) {
    const toObject = {};
    const fromUrlMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlMetadata'
    ]);
    if (fromUrlMetadata != null) {
        let transformedList = fromUrlMetadata;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$urlMetadataFromMldev$2(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'urlMetadata'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$candidateFromMldev$1(fromObject) {
    const toObject = {};
    const fromContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'content'
    ]);
    if (fromContent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'content'
    ], $e4deb49dba5321bc$var$contentFromMldev$2(fromContent));
    const fromCitationMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'citationMetadata'
    ]);
    if (fromCitationMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'citationMetadata'
    ], $e4deb49dba5321bc$var$citationMetadataFromMldev$1(fromCitationMetadata));
    const fromTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tokenCount'
    ]);
    if (fromTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tokenCount'
    ], fromTokenCount);
    const fromFinishReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'finishReason'
    ]);
    if (fromFinishReason != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'finishReason'
    ], fromFinishReason);
    const fromUrlContextMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContextMetadata'
    ]);
    if (fromUrlContextMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContextMetadata'
    ], $e4deb49dba5321bc$var$urlContextMetadataFromMldev$2(fromUrlContextMetadata));
    const fromAvgLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'avgLogprobs'
    ]);
    if (fromAvgLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'avgLogprobs'
    ], fromAvgLogprobs);
    const fromGroundingMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'groundingMetadata'
    ]);
    if (fromGroundingMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'groundingMetadata'
    ], fromGroundingMetadata);
    const fromIndex = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'index'
    ]);
    if (fromIndex != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'index'
    ], fromIndex);
    const fromLogprobsResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'logprobsResult'
    ]);
    if (fromLogprobsResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'logprobsResult'
    ], fromLogprobsResult);
    const fromSafetyRatings = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyRatings'
    ]);
    if (fromSafetyRatings != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'safetyRatings'
    ], fromSafetyRatings);
    return toObject;
}
function $e4deb49dba5321bc$var$generateContentResponseFromMldev$1(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromCandidates = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidates'
    ]);
    if (fromCandidates != null) {
        let transformedList = fromCandidates;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$candidateFromMldev$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'candidates'
        ], transformedList);
    }
    const fromModelVersion = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelVersion'
    ]);
    if (fromModelVersion != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'modelVersion'
    ], fromModelVersion);
    const fromPromptFeedback = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'promptFeedback'
    ]);
    if (fromPromptFeedback != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'promptFeedback'
    ], fromPromptFeedback);
    const fromResponseId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseId'
    ]);
    if (fromResponseId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseId'
    ], fromResponseId);
    const fromUsageMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'usageMetadata'
    ]);
    if (fromUsageMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'usageMetadata'
    ], fromUsageMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$jobErrorFromMldev(fromObject) {
    const toObject = {};
    const fromDetails = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'details'
    ]);
    if (fromDetails != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'details'
    ], fromDetails);
    const fromCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'code'
    ]);
    if (fromCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'code'
    ], fromCode);
    const fromMessage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'message'
    ]);
    if (fromMessage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'message'
    ], fromMessage);
    return toObject;
}
function $e4deb49dba5321bc$var$inlinedResponseFromMldev(fromObject) {
    const toObject = {};
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], $e4deb49dba5321bc$var$generateContentResponseFromMldev$1(fromResponse));
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], $e4deb49dba5321bc$var$jobErrorFromMldev(fromError));
    return toObject;
}
function $e4deb49dba5321bc$var$contentEmbeddingFromMldev$1(fromObject) {
    const toObject = {};
    const fromValues = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'values'
    ]);
    if (fromValues != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'values'
    ], fromValues);
    return toObject;
}
function $e4deb49dba5321bc$var$singleEmbedContentResponseFromMldev(fromObject) {
    const toObject = {};
    const fromEmbedding = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'embedding'
    ]);
    if (fromEmbedding != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'embedding'
    ], $e4deb49dba5321bc$var$contentEmbeddingFromMldev$1(fromEmbedding));
    const fromTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tokenCount'
    ]);
    if (fromTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tokenCount'
    ], fromTokenCount);
    return toObject;
}
function $e4deb49dba5321bc$var$inlinedEmbedContentResponseFromMldev(fromObject) {
    const toObject = {};
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], $e4deb49dba5321bc$var$singleEmbedContentResponseFromMldev(fromResponse));
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], $e4deb49dba5321bc$var$jobErrorFromMldev(fromError));
    return toObject;
}
function $e4deb49dba5321bc$var$batchJobDestinationFromMldev(fromObject) {
    const toObject = {};
    const fromFileName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responsesFile'
    ]);
    if (fromFileName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileName'
    ], fromFileName);
    const fromInlinedResponses = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlinedResponses',
        'inlinedResponses'
    ]);
    if (fromInlinedResponses != null) {
        let transformedList = fromInlinedResponses;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$inlinedResponseFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'inlinedResponses'
        ], transformedList);
    }
    const fromInlinedEmbedContentResponses = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlinedEmbedContentResponses',
        'inlinedResponses'
    ]);
    if (fromInlinedEmbedContentResponses != null) {
        let transformedList = fromInlinedEmbedContentResponses;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$inlinedEmbedContentResponseFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'inlinedEmbedContentResponses'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$batchJobFromMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata',
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromState = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata',
        'state'
    ]);
    if (fromState != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'state'
    ], $e4deb49dba5321bc$var$tJobState(fromState));
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata',
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromEndTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata',
        'endTime'
    ]);
    if (fromEndTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    const fromUpdateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata',
        'updateTime'
    ]);
    if (fromUpdateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata',
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'model'
    ], fromModel);
    const fromDest = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata',
        'output'
    ]);
    if (fromDest != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dest'
    ], $e4deb49dba5321bc$var$batchJobDestinationFromMldev($e4deb49dba5321bc$var$tRecvBatchJobDestination(fromDest)));
    return toObject;
}
function $e4deb49dba5321bc$var$listBatchJobsResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromBatchJobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'operations'
    ]);
    if (fromBatchJobs != null) {
        let transformedList = fromBatchJobs;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$batchJobFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'batchJobs'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$deleteResourceJobFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], $e4deb49dba5321bc$var$jobErrorFromMldev(fromError));
    return toObject;
}
function $e4deb49dba5321bc$var$jobErrorFromVertex(fromObject) {
    const toObject = {};
    const fromDetails = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'details'
    ]);
    if (fromDetails != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'details'
    ], fromDetails);
    const fromCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'code'
    ]);
    if (fromCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'code'
    ], fromCode);
    const fromMessage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'message'
    ]);
    if (fromMessage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'message'
    ], fromMessage);
    return toObject;
}
function $e4deb49dba5321bc$var$batchJobSourceFromVertex(fromObject) {
    const toObject = {};
    const fromFormat = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'instancesFormat'
    ]);
    if (fromFormat != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'format'
    ], fromFormat);
    const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsSource',
        'uris'
    ]);
    if (fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'gcsUri'
    ], fromGcsUri);
    const fromBigqueryUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bigquerySource',
        'inputUri'
    ]);
    if (fromBigqueryUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'bigqueryUri'
    ], fromBigqueryUri);
    return toObject;
}
function $e4deb49dba5321bc$var$batchJobDestinationFromVertex(fromObject) {
    const toObject = {};
    const fromFormat = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'predictionsFormat'
    ]);
    if (fromFormat != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'format'
    ], fromFormat);
    const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsDestination',
        'outputUriPrefix'
    ]);
    if (fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'gcsUri'
    ], fromGcsUri);
    const fromBigqueryUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bigqueryDestination',
        'outputUri'
    ]);
    if (fromBigqueryUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'bigqueryUri'
    ], fromBigqueryUri);
    return toObject;
}
function $e4deb49dba5321bc$var$batchJobFromVertex(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromState = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'state'
    ]);
    if (fromState != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'state'
    ], $e4deb49dba5321bc$var$tJobState(fromState));
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], $e4deb49dba5321bc$var$jobErrorFromVertex(fromError));
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromStartTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startTime'
    ]);
    if (fromStartTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endTime'
    ]);
    if (fromEndTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    const fromUpdateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'model'
    ], fromModel);
    const fromSrc = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inputConfig'
    ]);
    if (fromSrc != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'src'
    ], $e4deb49dba5321bc$var$batchJobSourceFromVertex(fromSrc));
    const fromDest = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputConfig'
    ]);
    if (fromDest != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dest'
    ], $e4deb49dba5321bc$var$batchJobDestinationFromVertex($e4deb49dba5321bc$var$tRecvBatchJobDestination(fromDest)));
    return toObject;
}
function $e4deb49dba5321bc$var$listBatchJobsResponseFromVertex(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromBatchJobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'batchPredictionJobs'
    ]);
    if (fromBatchJobs != null) {
        let transformedList = fromBatchJobs;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$batchJobFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'batchJobs'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$deleteResourceJobFromVertex(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], $e4deb49dba5321bc$var$jobErrorFromVertex(fromError));
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ var $e4deb49dba5321bc$export$e18b8de308fd2439;
(function(PagedItem) {
    PagedItem["PAGED_ITEM_BATCH_JOBS"] = "batchJobs";
    PagedItem["PAGED_ITEM_MODELS"] = "models";
    PagedItem["PAGED_ITEM_TUNING_JOBS"] = "tuningJobs";
    PagedItem["PAGED_ITEM_FILES"] = "files";
    PagedItem["PAGED_ITEM_CACHED_CONTENTS"] = "cachedContents";
})($e4deb49dba5321bc$export$e18b8de308fd2439 || ($e4deb49dba5321bc$export$e18b8de308fd2439 = {}));
/**
 * Pager class for iterating through paginated results.
 */ class $e4deb49dba5321bc$export$57625d62e5386b09 {
    constructor(name, request, response, params){
        this.pageInternal = [];
        this.paramsInternal = {};
        this.requestInternal = request;
        this.init(name, response, params);
    }
    init(name, response, params) {
        var _a, _b;
        this.nameInternal = name;
        this.pageInternal = response[this.nameInternal] || [];
        this.sdkHttpResponseInternal = response === null || response === void 0 ? void 0 : response.sdkHttpResponse;
        this.idxInternal = 0;
        let requestParams = {
            config: {}
        };
        if (!params || Object.keys(params).length === 0) requestParams = {
            config: {}
        };
        else if (typeof params === 'object') requestParams = Object.assign({}, params);
        else requestParams = params;
        if (requestParams['config']) requestParams['config']['pageToken'] = response['nextPageToken'];
        this.paramsInternal = requestParams;
        this.pageInternalSize = (_b = (_a = requestParams['config']) === null || _a === void 0 ? void 0 : _a['pageSize']) !== null && _b !== void 0 ? _b : this.pageInternal.length;
    }
    initNextPage(response) {
        this.init(this.nameInternal, response, this.paramsInternal);
    }
    /**
     * Returns the current page, which is a list of items.
     *
     * @remarks
     * The first page is retrieved when the pager is created. The returned list of
     * items could be a subset of the entire list.
     */ get page() {
        return this.pageInternal;
    }
    /**
     * Returns the type of paged item (for example, ``batch_jobs``).
     */ get name() {
        return this.nameInternal;
    }
    /**
     * Returns the length of the page fetched each time by this pager.
     *
     * @remarks
     * The number of items in the page is less than or equal to the page length.
     */ get pageSize() {
        return this.pageInternalSize;
    }
    /**
     * Returns the headers of the API response.
     */ get sdkHttpResponse() {
        return this.sdkHttpResponseInternal;
    }
    /**
     * Returns the parameters when making the API request for the next page.
     *
     * @remarks
     * Parameters contain a set of optional configs that can be
     * used to customize the API request. For example, the `pageToken` parameter
     * contains the token to request the next page.
     */ get params() {
        return this.paramsInternal;
    }
    /**
     * Returns the total number of items in the current page.
     */ get pageLength() {
        return this.pageInternal.length;
    }
    /**
     * Returns the item at the given index.
     */ getItem(index) {
        return this.pageInternal[index];
    }
    /**
     * Returns an async iterator that support iterating through all items
     * retrieved from the API.
     *
     * @remarks
     * The iterator will automatically fetch the next page if there are more items
     * to fetch from the API.
     *
     * @example
     *
     * ```ts
     * const pager = await ai.files.list({config: {pageSize: 10}});
     * for await (const file of pager) {
     *   console.log(file.name);
     * }
     * ```
     */ [Symbol.asyncIterator]() {
        return {
            next: async ()=>{
                if (this.idxInternal >= this.pageLength) {
                    if (this.hasNextPage()) await this.nextPage();
                    else return {
                        value: undefined,
                        done: true
                    };
                }
                const item = this.getItem(this.idxInternal);
                this.idxInternal += 1;
                return {
                    value: item,
                    done: false
                };
            },
            return: async ()=>{
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     * Fetches the next page of items. This makes a new API request.
     *
     * @throws {Error} If there are no more pages to fetch.
     *
     * @example
     *
     * ```ts
     * const pager = await ai.files.list({config: {pageSize: 10}});
     * let page = pager.page;
     * while (true) {
     *   for (const file of page) {
     *     console.log(file.name);
     *   }
     *   if (!pager.hasNextPage()) {
     *     break;
     *   }
     *   page = await pager.nextPage();
     * }
     * ```
     */ async nextPage() {
        if (!this.hasNextPage()) throw new Error('No more pages to fetch.');
        const response = await this.requestInternal(this.params);
        this.initNextPage(response);
        return this.page;
    }
    /**
     * Returns true if there are more pages to fetch from the API.
     */ hasNextPage() {
        var _a;
        if (((_a = this.params['config']) === null || _a === void 0 ? void 0 : _a['pageToken']) !== undefined) return true;
        return false;
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$export$ed828fcd19953e0d extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
        /**
         * Create batch job.
         *
         * @param params - The parameters for create batch job request.
         * @return The created batch job.
         *
         * @example
         * ```ts
         * const response = await ai.batches.create({
         *   model: 'gemini-2.0-flash',
         *   src: {gcsUri: 'gs://bucket/path/to/file.jsonl', format: 'jsonl'},
         *   config: {
         *     dest: {gcsUri: 'gs://bucket/path/output/directory', format: 'jsonl'},
         *   }
         * });
         * console.log(response);
         * ```
         */ this.create = async (params)=>{
            var _a, _b;
            if (this.apiClient.isVertexAI()) {
                // Format destination if not provided
                // Cast params.src as Vertex AI path does not handle InlinedRequest[]
                params.config = this.formatDestination(params.src, params.config);
                return this.createInternal(params);
            }
            // MLDEV
            const src = params.src;
            const is_inlined = Array.isArray(params.src) || src.inlinedRequests !== undefined;
            if (!is_inlined) return this.createInternal(params);
            // Inlined generate content requests handling
            const result = this.createInlinedGenerateContentRequest(params);
            const path = result.path;
            const requestBody = result.body;
            const queryParams = $e4deb49dba5321bc$var$createBatchJobParametersToMldev(this.apiClient, params)['_query'] || {};
            const response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(requestBody),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$batchJobFromMldev(apiResponse);
                return resp;
            });
        };
        /**
         * **Experimental** Creates an embedding batch job.
         *
         * @param params - The parameters for create embedding batch job request.
         * @return The created batch job.
         *
         * @example
         * ```ts
         * const response = await ai.batches.createEmbeddings({
         *   model: 'text-embedding-004',
         *   src: {fileName: 'files/my_embedding_input'},
         * });
         * console.log(response);
         * ```
         */ this.createEmbeddings = async (params)=>{
            var _a, _b;
            console.warn('batches.createEmbeddings() is experimental and may change without notice.');
            if (this.apiClient.isVertexAI()) throw new Error('Vertex AI does not support batches.createEmbeddings.');
            // MLDEV
            const src = params.src;
            const is_inlined = src.inlinedRequests !== undefined;
            if (!is_inlined) return this.createEmbeddingsInternal(params); // Fixed typo here
            // Inlined embed content requests handling
            const result = this.createInlinedEmbedContentRequest(params);
            const path = result.path;
            const requestBody = result.body;
            const queryParams = $e4deb49dba5321bc$var$createEmbeddingsBatchJobParametersToMldev(this.apiClient, params)['_query'] || {};
            const response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(requestBody),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$batchJobFromMldev(apiResponse);
                return resp;
            });
        };
        /**
         * Lists batch job configurations.
         *
         * @param params - The parameters for the list request.
         * @return The paginated results of the list of batch jobs.
         *
         * @example
         * ```ts
         * const batchJobs = await ai.batches.list({config: {'pageSize': 2}});
         * for await (const batchJob of batchJobs) {
         *   console.log(batchJob);
         * }
         * ```
         */ this.list = async (params = {})=>{
            return new $e4deb49dba5321bc$export$57625d62e5386b09($e4deb49dba5321bc$export$e18b8de308fd2439.PAGED_ITEM_BATCH_JOBS, (x)=>this.listInternal(x), await this.listInternal(params), params);
        };
    }
    // Helper function to handle inlined generate content requests
    createInlinedGenerateContentRequest(params) {
        const body = $e4deb49dba5321bc$var$createBatchJobParametersToMldev(this.apiClient, params);
        const urlParams = body['_url'];
        const path = $e4deb49dba5321bc$var$formatMap('{model}:batchGenerateContent', urlParams);
        const batch = body['batch'];
        const inputConfig = batch['inputConfig'];
        const requestsWrapper = inputConfig['requests'];
        const requests = requestsWrapper['requests'];
        const newRequests = [];
        for (const request of requests){
            const requestDict = Object.assign({}, request); // Clone
            if (requestDict['systemInstruction']) {
                const systemInstructionValue = requestDict['systemInstruction'];
                delete requestDict['systemInstruction'];
                const requestContent = requestDict['request'];
                requestContent['systemInstruction'] = systemInstructionValue;
                requestDict['request'] = requestContent;
            }
            newRequests.push(requestDict);
        }
        requestsWrapper['requests'] = newRequests;
        delete body['config'];
        delete body['_url'];
        delete body['_query'];
        return {
            path: path,
            body: body
        };
    }
    // Helper function to handle inlined embedding requests
    createInlinedEmbedContentRequest(params) {
        const body = $e4deb49dba5321bc$var$createEmbeddingsBatchJobParametersToMldev(this.apiClient, params);
        const urlParams = body['_url'];
        const path = $e4deb49dba5321bc$var$formatMap('{model}:asyncBatchEmbedContent', urlParams);
        const batch = body['batch'];
        const inputConfig = batch['inputConfig'];
        const requestsWrapper = inputConfig['requests'];
        const requests = requestsWrapper['requests'];
        const newRequests = [];
        delete requestsWrapper['config']; // Remove top-level config
        for (const request of requests){
            const requestDict = Object.assign({}, request); // Clone
            const innerRequest = requestDict['request'];
            for(const key in requestDict)if (key !== 'request') {
                innerRequest[key] = requestDict[key];
                delete requestDict[key];
            }
            newRequests.push(requestDict);
        }
        requestsWrapper['requests'] = newRequests;
        delete body['config'];
        delete body['_url'];
        delete body['_query'];
        return {
            path: path,
            body: body
        };
    }
    // Helper function to get the first GCS URI
    getGcsUri(src) {
        if (typeof src === 'string') return src.startsWith('gs://') ? src : undefined;
        if (!Array.isArray(src) && src.gcsUri && src.gcsUri.length > 0) return src.gcsUri[0];
        return undefined;
    }
    // Helper function to get the BigQuery URI
    getBigqueryUri(src) {
        if (typeof src === 'string') return src.startsWith('bq://') ? src : undefined;
        if (!Array.isArray(src)) return src.bigqueryUri;
        return undefined;
    }
    // Function to format the destination configuration for Vertex AI
    formatDestination(src, config) {
        const newConfig = config ? Object.assign({}, config) : {};
        const timestampStr = Date.now().toString();
        if (!newConfig.displayName) newConfig.displayName = `genaiBatchJob_${timestampStr}`;
        if (newConfig.dest === undefined) {
            const gcsUri = this.getGcsUri(src);
            const bigqueryUri = this.getBigqueryUri(src);
            if (gcsUri) {
                if (gcsUri.endsWith('.jsonl')) // For .jsonl files, remove suffix and add /dest
                newConfig.dest = `${gcsUri.slice(0, -6)}/dest`;
                else // Fallback for other GCS URIs
                newConfig.dest = `${gcsUri}_dest_${timestampStr}`;
            } else if (bigqueryUri) newConfig.dest = `${bigqueryUri}_dest_${timestampStr}`;
            else throw new Error('Unsupported source for Vertex AI: No GCS or BigQuery URI found.');
        }
        return newConfig;
    }
    /**
     * Internal method to create batch job.
     *
     * @param params - The parameters for create batch job request.
     * @return The created batch job.
     *
     */ async createInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$createBatchJobParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('batchPredictionJobs', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$batchJobFromVertex(apiResponse);
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$createBatchJobParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:batchGenerateContent', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$batchJobFromMldev(apiResponse);
                return resp;
            });
        }
    }
    /**
     * Internal method to create batch job.
     *
     * @param params - The parameters for create batch job request.
     * @return The created batch job.
     *
     */ async createEmbeddingsInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$createEmbeddingsBatchJobParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:asyncBatchEmbedContent', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$batchJobFromMldev(apiResponse);
                return resp;
            });
        }
    }
    /**
     * Gets batch job configurations.
     *
     * @param params - The parameters for the get request.
     * @return The batch job.
     *
     * @example
     * ```ts
     * await ai.batches.get({name: '...'}); // The server-generated resource name.
     * ```
     */ async get(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$getBatchJobParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('batchPredictionJobs/{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$batchJobFromVertex(apiResponse);
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$getBatchJobParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('batches/{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$batchJobFromMldev(apiResponse);
                return resp;
            });
        }
    }
    /**
     * Cancels a batch job.
     *
     * @param params - The parameters for the cancel request.
     * @return The empty response returned by the API.
     *
     * @example
     * ```ts
     * await ai.batches.cancel({name: '...'}); // The server-generated resource name.
     * ```
     */ async cancel(params) {
        var _a, _b, _c, _d;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$cancelBatchJobParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('batchPredictionJobs/{name}:cancel', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            await this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            });
        } else {
            const body = $e4deb49dba5321bc$var$cancelBatchJobParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('batches/{name}:cancel', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            await this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            });
        }
    }
    async listInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$listBatchJobsParametersToVertex(params);
            path = $e4deb49dba5321bc$var$formatMap('batchPredictionJobs', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listBatchJobsResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$aad8e472c65c38a4();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$listBatchJobsParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('batches', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listBatchJobsResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$aad8e472c65c38a4();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Deletes a batch job.
     *
     * @param params - The parameters for the delete request.
     * @return The empty response returned by the API.
     *
     * @example
     * ```ts
     * await ai.batches.delete({name: '...'}); // The server-generated resource name.
     * ```
     */ async delete(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$deleteBatchJobParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('batchPredictionJobs/{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$deleteResourceJobFromVertex(apiResponse);
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$deleteBatchJobParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('batches/{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$deleteResourceJobFromMldev(apiResponse);
                return resp;
            });
        }
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$videoMetadataToMldev$3(fromObject) {
    const toObject = {};
    const fromFps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fps'
    ]);
    if (fromFps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fps'
    ], fromFps);
    const fromEndOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endOffset'
    ]);
    if (fromEndOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endOffset'
    ], fromEndOffset);
    const fromStartOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startOffset'
    ]);
    if (fromStartOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startOffset'
    ], fromStartOffset);
    return toObject;
}
function $e4deb49dba5321bc$var$blobToMldev$3(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$fileDataToMldev$3(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromFileUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallToMldev$3(fromObject) {
    const toObject = {};
    const fromId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'id'
    ]);
    if (fromId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'id'
    ], fromId);
    const fromArgs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$partToMldev$3(fromObject) {
    const toObject = {};
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], $e4deb49dba5321bc$var$videoMetadataToMldev$3(fromVideoMetadata));
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], $e4deb49dba5321bc$var$blobToMldev$3(fromInlineData));
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], $e4deb49dba5321bc$var$fileDataToMldev$3(fromFileData));
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], $e4deb49dba5321bc$var$functionCallToMldev$3(fromFunctionCall));
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    return toObject;
}
function $e4deb49dba5321bc$var$contentToMldev$3(fromObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partToMldev$3(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$functionDeclarationToMldev$3(fromObject) {
    const toObject = {};
    const fromBehavior = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'behavior'
    ]);
    if (fromBehavior != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'behavior'
    ], fromBehavior);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromParameters = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parameters'
    ]);
    if (fromParameters != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parameters'
    ], fromParameters);
    const fromParametersJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parametersJsonSchema'
    ]);
    if (fromParametersJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parametersJsonSchema'
    ], fromParametersJsonSchema);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], fromResponse);
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    return toObject;
}
function $e4deb49dba5321bc$var$intervalToMldev$3(fromObject) {
    const toObject = {};
    const fromStartTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startTime'
    ]);
    if (fromStartTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endTime'
    ]);
    if (fromEndTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchToMldev$3(fromObject) {
    const toObject = {};
    const fromTimeRangeFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'timeRangeFilter'
    ], $e4deb49dba5321bc$var$intervalToMldev$3(fromTimeRangeFilter));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'excludeDomains'
    ]) !== undefined) throw new Error('excludeDomains parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$dynamicRetrievalConfigToMldev$3(fromObject) {
    const toObject = {};
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mode'
    ], fromMode);
    const fromDynamicThreshold = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'dynamicThreshold'
    ]);
    if (fromDynamicThreshold != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dynamicThreshold'
    ], fromDynamicThreshold);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchRetrievalToMldev$3(fromObject) {
    const toObject = {};
    const fromDynamicRetrievalConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'dynamicRetrievalConfig'
    ]);
    if (fromDynamicRetrievalConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dynamicRetrievalConfig'
    ], $e4deb49dba5321bc$var$dynamicRetrievalConfigToMldev$3(fromDynamicRetrievalConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$urlContextToMldev$3() {
    const toObject = {};
    return toObject;
}
function $e4deb49dba5321bc$var$toolComputerUseToMldev$3(fromObject) {
    const toObject = {};
    const fromEnvironment = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'environment'
    ]);
    if (fromEnvironment != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'environment'
    ], fromEnvironment);
    return toObject;
}
function $e4deb49dba5321bc$var$toolToMldev$3(fromObject) {
    const toObject = {};
    const fromFunctionDeclarations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$functionDeclarationToMldev$3(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrieval'
    ]) !== undefined) throw new Error('retrieval parameter is not supported in Gemini API.');
    const fromGoogleSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearch'
    ], $e4deb49dba5321bc$var$googleSearchToMldev$3(fromGoogleSearch));
    const fromGoogleSearchRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], $e4deb49dba5321bc$var$googleSearchRetrievalToMldev$3(fromGoogleSearchRetrieval));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]) !== undefined) throw new Error('enterpriseWebSearch parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleMaps'
    ]) !== undefined) throw new Error('googleMaps parameter is not supported in Gemini API.');
    const fromUrlContext = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContext'
    ], $e4deb49dba5321bc$var$urlContextToMldev$3());
    const fromComputerUse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'computerUse'
    ]);
    if (fromComputerUse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computerUse'
    ], $e4deb49dba5321bc$var$toolComputerUseToMldev$3(fromComputerUse));
    const fromCodeExecution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallingConfigToMldev$1(fromObject) {
    const toObject = {};
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mode'
    ], fromMode);
    const fromAllowedFunctionNames = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'allowedFunctionNames'
    ]);
    if (fromAllowedFunctionNames != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'allowedFunctionNames'
    ], fromAllowedFunctionNames);
    return toObject;
}
function $e4deb49dba5321bc$var$latLngToMldev$1(fromObject) {
    const toObject = {};
    const fromLatitude = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'latitude'
    ]);
    if (fromLatitude != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'latitude'
    ], fromLatitude);
    const fromLongitude = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'longitude'
    ]);
    if (fromLongitude != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'longitude'
    ], fromLongitude);
    return toObject;
}
function $e4deb49dba5321bc$var$retrievalConfigToMldev$1(fromObject) {
    const toObject = {};
    const fromLatLng = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'latLng'
    ]);
    if (fromLatLng != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'latLng'
    ], $e4deb49dba5321bc$var$latLngToMldev$1(fromLatLng));
    const fromLanguageCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'languageCode'
    ]);
    if (fromLanguageCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'languageCode'
    ], fromLanguageCode);
    return toObject;
}
function $e4deb49dba5321bc$var$toolConfigToMldev$1(fromObject) {
    const toObject = {};
    const fromFunctionCallingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCallingConfig'
    ]);
    if (fromFunctionCallingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCallingConfig'
    ], $e4deb49dba5321bc$var$functionCallingConfigToMldev$1(fromFunctionCallingConfig));
    const fromRetrievalConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrievalConfig'
    ]);
    if (fromRetrievalConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrievalConfig'
    ], $e4deb49dba5321bc$var$retrievalConfigToMldev$1(fromRetrievalConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$createCachedContentConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromTtl = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'ttl'
    ]);
    if (parentObject !== undefined && fromTtl != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'ttl'
    ], fromTtl);
    const fromExpireTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'expireTime'
    ]);
    if (parentObject !== undefined && fromExpireTime != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'expireTime'
    ], fromExpireTime);
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'displayName'
    ], fromDisplayName);
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (parentObject !== undefined && fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContents(fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$contentToMldev$3(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'contents'
        ], transformedList);
    }
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'systemInstruction'
    ], $e4deb49dba5321bc$var$contentToMldev$3($e4deb49dba5321bc$var$tContent(fromSystemInstruction)));
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = fromTools;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToMldev$3(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'tools'
        ], transformedList);
    }
    const fromToolConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolConfig'
    ]);
    if (parentObject !== undefined && fromToolConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'toolConfig'
    ], $e4deb49dba5321bc$var$toolConfigToMldev$1(fromToolConfig));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'kmsKeyName'
    ]) !== undefined) throw new Error('kmsKeyName parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$createCachedContentParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'model'
    ], $e4deb49dba5321bc$var$tCachesModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$createCachedContentConfigToMldev(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$getCachedContentParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromName));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteCachedContentParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromName));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$updateCachedContentConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromTtl = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'ttl'
    ]);
    if (parentObject !== undefined && fromTtl != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'ttl'
    ], fromTtl);
    const fromExpireTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'expireTime'
    ]);
    if (parentObject !== undefined && fromExpireTime != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'expireTime'
    ], fromExpireTime);
    return toObject;
}
function $e4deb49dba5321bc$var$updateCachedContentParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromName));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$updateCachedContentConfigToMldev(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$listCachedContentsConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    return toObject;
}
function $e4deb49dba5321bc$var$listCachedContentsParametersToMldev(fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$listCachedContentsConfigToMldev(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$videoMetadataToVertex$2(fromObject) {
    const toObject = {};
    const fromFps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fps'
    ]);
    if (fromFps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fps'
    ], fromFps);
    const fromEndOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endOffset'
    ]);
    if (fromEndOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endOffset'
    ], fromEndOffset);
    const fromStartOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startOffset'
    ]);
    if (fromStartOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startOffset'
    ], fromStartOffset);
    return toObject;
}
function $e4deb49dba5321bc$var$blobToVertex$2(fromObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$fileDataToVertex$2(fromObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromFileUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallToVertex$2(fromObject) {
    const toObject = {};
    const fromId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'id'
    ]);
    if (fromId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'id'
    ], fromId);
    const fromArgs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$partToVertex$2(fromObject) {
    const toObject = {};
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], $e4deb49dba5321bc$var$videoMetadataToVertex$2(fromVideoMetadata));
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], $e4deb49dba5321bc$var$blobToVertex$2(fromInlineData));
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], $e4deb49dba5321bc$var$fileDataToVertex$2(fromFileData));
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], $e4deb49dba5321bc$var$functionCallToVertex$2(fromFunctionCall));
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    return toObject;
}
function $e4deb49dba5321bc$var$contentToVertex$2(fromObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partToVertex$2(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$functionDeclarationToVertex$2(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'behavior'
    ]) !== undefined) throw new Error('behavior parameter is not supported in Vertex AI.');
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromParameters = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parameters'
    ]);
    if (fromParameters != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parameters'
    ], fromParameters);
    const fromParametersJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parametersJsonSchema'
    ]);
    if (fromParametersJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parametersJsonSchema'
    ], fromParametersJsonSchema);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], fromResponse);
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    return toObject;
}
function $e4deb49dba5321bc$var$intervalToVertex$2(fromObject) {
    const toObject = {};
    const fromStartTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startTime'
    ]);
    if (fromStartTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endTime'
    ]);
    if (fromEndTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchToVertex$2(fromObject) {
    const toObject = {};
    const fromTimeRangeFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'timeRangeFilter'
    ], $e4deb49dba5321bc$var$intervalToVertex$2(fromTimeRangeFilter));
    const fromExcludeDomains = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'excludeDomains'
    ]);
    if (fromExcludeDomains != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'excludeDomains'
    ], fromExcludeDomains);
    return toObject;
}
function $e4deb49dba5321bc$var$dynamicRetrievalConfigToVertex$2(fromObject) {
    const toObject = {};
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mode'
    ], fromMode);
    const fromDynamicThreshold = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'dynamicThreshold'
    ]);
    if (fromDynamicThreshold != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dynamicThreshold'
    ], fromDynamicThreshold);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchRetrievalToVertex$2(fromObject) {
    const toObject = {};
    const fromDynamicRetrievalConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'dynamicRetrievalConfig'
    ]);
    if (fromDynamicRetrievalConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dynamicRetrievalConfig'
    ], $e4deb49dba5321bc$var$dynamicRetrievalConfigToVertex$2(fromDynamicRetrievalConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$enterpriseWebSearchToVertex$2(fromObject) {
    const toObject = {};
    const fromExcludeDomains = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'excludeDomains'
    ]);
    if (fromExcludeDomains != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'excludeDomains'
    ], fromExcludeDomains);
    return toObject;
}
function $e4deb49dba5321bc$var$apiKeyConfigToVertex$2(fromObject) {
    const toObject = {};
    const fromApiKeyString = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'apiKeyString'
    ]);
    if (fromApiKeyString != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'apiKeyString'
    ], fromApiKeyString);
    return toObject;
}
function $e4deb49dba5321bc$var$authConfigToVertex$2(fromObject) {
    const toObject = {};
    const fromApiKeyConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'apiKeyConfig'
    ]);
    if (fromApiKeyConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'apiKeyConfig'
    ], $e4deb49dba5321bc$var$apiKeyConfigToVertex$2(fromApiKeyConfig));
    const fromAuthType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'authType'
    ]);
    if (fromAuthType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'authType'
    ], fromAuthType);
    const fromGoogleServiceAccountConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleServiceAccountConfig'
    ]);
    if (fromGoogleServiceAccountConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleServiceAccountConfig'
    ], fromGoogleServiceAccountConfig);
    const fromHttpBasicAuthConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'httpBasicAuthConfig'
    ]);
    if (fromHttpBasicAuthConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'httpBasicAuthConfig'
    ], fromHttpBasicAuthConfig);
    const fromOauthConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'oauthConfig'
    ]);
    if (fromOauthConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'oauthConfig'
    ], fromOauthConfig);
    const fromOidcConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'oidcConfig'
    ]);
    if (fromOidcConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'oidcConfig'
    ], fromOidcConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$googleMapsToVertex$2(fromObject) {
    const toObject = {};
    const fromAuthConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'authConfig'
    ]);
    if (fromAuthConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'authConfig'
    ], $e4deb49dba5321bc$var$authConfigToVertex$2(fromAuthConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$urlContextToVertex$2() {
    const toObject = {};
    return toObject;
}
function $e4deb49dba5321bc$var$toolComputerUseToVertex$2(fromObject) {
    const toObject = {};
    const fromEnvironment = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'environment'
    ]);
    if (fromEnvironment != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'environment'
    ], fromEnvironment);
    return toObject;
}
function $e4deb49dba5321bc$var$toolToVertex$2(fromObject) {
    const toObject = {};
    const fromFunctionDeclarations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$functionDeclarationToVertex$2(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    const fromRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrieval'
    ]);
    if (fromRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrieval'
    ], fromRetrieval);
    const fromGoogleSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearch'
    ], $e4deb49dba5321bc$var$googleSearchToVertex$2(fromGoogleSearch));
    const fromGoogleSearchRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], $e4deb49dba5321bc$var$googleSearchRetrievalToVertex$2(fromGoogleSearchRetrieval));
    const fromEnterpriseWebSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]);
    if (fromEnterpriseWebSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enterpriseWebSearch'
    ], $e4deb49dba5321bc$var$enterpriseWebSearchToVertex$2(fromEnterpriseWebSearch));
    const fromGoogleMaps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleMaps'
    ]);
    if (fromGoogleMaps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleMaps'
    ], $e4deb49dba5321bc$var$googleMapsToVertex$2(fromGoogleMaps));
    const fromUrlContext = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContext'
    ], $e4deb49dba5321bc$var$urlContextToVertex$2());
    const fromComputerUse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'computerUse'
    ]);
    if (fromComputerUse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computerUse'
    ], $e4deb49dba5321bc$var$toolComputerUseToVertex$2(fromComputerUse));
    const fromCodeExecution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallingConfigToVertex$1(fromObject) {
    const toObject = {};
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mode'
    ], fromMode);
    const fromAllowedFunctionNames = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'allowedFunctionNames'
    ]);
    if (fromAllowedFunctionNames != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'allowedFunctionNames'
    ], fromAllowedFunctionNames);
    return toObject;
}
function $e4deb49dba5321bc$var$latLngToVertex$1(fromObject) {
    const toObject = {};
    const fromLatitude = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'latitude'
    ]);
    if (fromLatitude != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'latitude'
    ], fromLatitude);
    const fromLongitude = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'longitude'
    ]);
    if (fromLongitude != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'longitude'
    ], fromLongitude);
    return toObject;
}
function $e4deb49dba5321bc$var$retrievalConfigToVertex$1(fromObject) {
    const toObject = {};
    const fromLatLng = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'latLng'
    ]);
    if (fromLatLng != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'latLng'
    ], $e4deb49dba5321bc$var$latLngToVertex$1(fromLatLng));
    const fromLanguageCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'languageCode'
    ]);
    if (fromLanguageCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'languageCode'
    ], fromLanguageCode);
    return toObject;
}
function $e4deb49dba5321bc$var$toolConfigToVertex$1(fromObject) {
    const toObject = {};
    const fromFunctionCallingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCallingConfig'
    ]);
    if (fromFunctionCallingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCallingConfig'
    ], $e4deb49dba5321bc$var$functionCallingConfigToVertex$1(fromFunctionCallingConfig));
    const fromRetrievalConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrievalConfig'
    ]);
    if (fromRetrievalConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrievalConfig'
    ], $e4deb49dba5321bc$var$retrievalConfigToVertex$1(fromRetrievalConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$createCachedContentConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromTtl = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'ttl'
    ]);
    if (parentObject !== undefined && fromTtl != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'ttl'
    ], fromTtl);
    const fromExpireTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'expireTime'
    ]);
    if (parentObject !== undefined && fromExpireTime != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'expireTime'
    ], fromExpireTime);
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'displayName'
    ], fromDisplayName);
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (parentObject !== undefined && fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContents(fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$contentToVertex$2(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'contents'
        ], transformedList);
    }
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'systemInstruction'
    ], $e4deb49dba5321bc$var$contentToVertex$2($e4deb49dba5321bc$var$tContent(fromSystemInstruction)));
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = fromTools;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToVertex$2(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'tools'
        ], transformedList);
    }
    const fromToolConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolConfig'
    ]);
    if (parentObject !== undefined && fromToolConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'toolConfig'
    ], $e4deb49dba5321bc$var$toolConfigToVertex$1(fromToolConfig));
    const fromKmsKeyName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'kmsKeyName'
    ]);
    if (parentObject !== undefined && fromKmsKeyName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'encryption_spec',
        'kmsKeyName'
    ], fromKmsKeyName);
    return toObject;
}
function $e4deb49dba5321bc$var$createCachedContentParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'model'
    ], $e4deb49dba5321bc$var$tCachesModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$createCachedContentConfigToVertex(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$getCachedContentParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromName));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteCachedContentParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromName));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$updateCachedContentConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromTtl = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'ttl'
    ]);
    if (parentObject !== undefined && fromTtl != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'ttl'
    ], fromTtl);
    const fromExpireTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'expireTime'
    ]);
    if (parentObject !== undefined && fromExpireTime != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'expireTime'
    ], fromExpireTime);
    return toObject;
}
function $e4deb49dba5321bc$var$updateCachedContentParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromName));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$updateCachedContentConfigToVertex(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$listCachedContentsConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    return toObject;
}
function $e4deb49dba5321bc$var$listCachedContentsParametersToVertex(fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$listCachedContentsConfigToVertex(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$cachedContentFromMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'model'
    ], fromModel);
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromUpdateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    const fromExpireTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'expireTime'
    ]);
    if (fromExpireTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'expireTime'
    ], fromExpireTime);
    const fromUsageMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'usageMetadata'
    ]);
    if (fromUsageMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'usageMetadata'
    ], fromUsageMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteCachedContentResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    return toObject;
}
function $e4deb49dba5321bc$var$listCachedContentsResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromCachedContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cachedContents'
    ]);
    if (fromCachedContents != null) {
        let transformedList = fromCachedContents;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$cachedContentFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'cachedContents'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$cachedContentFromVertex(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'model'
    ], fromModel);
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromUpdateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    const fromExpireTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'expireTime'
    ]);
    if (fromExpireTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'expireTime'
    ], fromExpireTime);
    const fromUsageMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'usageMetadata'
    ]);
    if (fromUsageMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'usageMetadata'
    ], fromUsageMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteCachedContentResponseFromVertex(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    return toObject;
}
function $e4deb49dba5321bc$var$listCachedContentsResponseFromVertex(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromCachedContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cachedContents'
    ]);
    if (fromCachedContents != null) {
        let transformedList = fromCachedContents;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$cachedContentFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'cachedContents'
        ], transformedList);
    }
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$export$4c60919c4fe22d9 extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
        /**
         * Lists cached content configurations.
         *
         * @param params - The parameters for the list request.
         * @return The paginated results of the list of cached contents.
         *
         * @example
         * ```ts
         * const cachedContents = await ai.caches.list({config: {'pageSize': 2}});
         * for await (const cachedContent of cachedContents) {
         *   console.log(cachedContent);
         * }
         * ```
         */ this.list = async (params = {})=>{
            return new $e4deb49dba5321bc$export$57625d62e5386b09($e4deb49dba5321bc$export$e18b8de308fd2439.PAGED_ITEM_CACHED_CONTENTS, (x)=>this.listInternal(x), await this.listInternal(params), params);
        };
    }
    /**
     * Creates a cached contents resource.
     *
     * @remarks
     * Context caching is only supported for specific models. See [Gemini
     * Developer API reference](https://ai.google.dev/gemini-api/docs/caching?lang=node/context-cac)
     * and [Vertex AI reference](https://cloud.google.com/vertex-ai/generative-ai/docs/context-cache/context-cache-overview#supported_models)
     * for more information.
     *
     * @param params - The parameters for the create request.
     * @return The created cached content.
     *
     * @example
     * ```ts
     * const contents = ...; // Initialize the content to cache.
     * const response = await ai.caches.create({
     *   model: 'gemini-2.0-flash-001',
     *   config: {
     *    'contents': contents,
     *    'displayName': 'test cache',
     *    'systemInstruction': 'What is the sum of the two pdfs?',
     *    'ttl': '86400s',
     *  }
     * });
     * ```
     */ async create(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$createCachedContentParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('cachedContents', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$cachedContentFromVertex(apiResponse);
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$createCachedContentParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('cachedContents', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$cachedContentFromMldev(apiResponse);
                return resp;
            });
        }
    }
    /**
     * Gets cached content configurations.
     *
     * @param params - The parameters for the get request.
     * @return The cached content.
     *
     * @example
     * ```ts
     * await ai.caches.get({name: '...'}); // The server-generated resource name.
     * ```
     */ async get(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$getCachedContentParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$cachedContentFromVertex(apiResponse);
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$getCachedContentParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$cachedContentFromMldev(apiResponse);
                return resp;
            });
        }
    }
    /**
     * Deletes cached content.
     *
     * @param params - The parameters for the delete request.
     * @return The empty response returned by the API.
     *
     * @example
     * ```ts
     * await ai.caches.delete({name: '...'}); // The server-generated resource name.
     * ```
     */ async delete(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$deleteCachedContentParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$deleteCachedContentResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$12b40cf453f95df4();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$deleteCachedContentParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$deleteCachedContentResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$12b40cf453f95df4();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Updates cached content configurations.
     *
     * @param params - The parameters for the update request.
     * @return The updated cached content.
     *
     * @example
     * ```ts
     * const response = await ai.caches.update({
     *   name: '...',  // The server-generated resource name.
     *   config: {'ttl': '7600s'}
     * });
     * ```
     */ async update(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$updateCachedContentParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'PATCH',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$cachedContentFromVertex(apiResponse);
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$updateCachedContentParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'PATCH',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$cachedContentFromMldev(apiResponse);
                return resp;
            });
        }
    }
    async listInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$listCachedContentsParametersToVertex(params);
            path = $e4deb49dba5321bc$var$formatMap('cachedContents', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listCachedContentsResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$b704e9f6d5866ff0();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$listCachedContentsParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('cachedContents', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listCachedContentsResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$b704e9f6d5866ff0();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $e4deb49dba5321bc$var$__values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e4deb49dba5321bc$var$__await(v) {
    return this instanceof $e4deb49dba5321bc$var$__await ? (this.v = v, this) : new $e4deb49dba5321bc$var$__await(v);
}
function $e4deb49dba5321bc$var$__asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e4deb49dba5321bc$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e4deb49dba5321bc$var$__asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e4deb49dba5321bc$var$__values === "function" ? $e4deb49dba5321bc$var$__values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
typeof SuppressedError === "function" && SuppressedError;
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Returns true if the response is valid, false otherwise.
 */ function $e4deb49dba5321bc$var$isValidResponse(response) {
    var _a;
    if (response.candidates == undefined || response.candidates.length === 0) return false;
    const content = (_a = response.candidates[0]) === null || _a === void 0 ? void 0 : _a.content;
    if (content === undefined) return false;
    return $e4deb49dba5321bc$var$isValidContent(content);
}
function $e4deb49dba5321bc$var$isValidContent(content) {
    if (content.parts === undefined || content.parts.length === 0) return false;
    for (const part of content.parts){
        if (part === undefined || Object.keys(part).length === 0) return false;
    }
    return true;
}
/**
 * Validates the history contains the correct roles.
 *
 * @throws Error if the history does not start with a user turn.
 * @throws Error if the history contains an invalid role.
 */ function $e4deb49dba5321bc$var$validateHistory(history) {
    // Empty history is valid.
    if (history.length === 0) return;
    for (const content of history){
        if (content.role !== 'user' && content.role !== 'model') throw new Error(`Role must be user or model, but got ${content.role}.`);
    }
}
/**
 * Extracts the curated (valid) history from a comprehensive history.
 *
 * @remarks
 * The model may sometimes generate invalid or empty contents(e.g., due to safty
 * filters or recitation). Extracting valid turns from the history
 * ensures that subsequent requests could be accpeted by the model.
 */ function $e4deb49dba5321bc$var$extractCuratedHistory(comprehensiveHistory) {
    if (comprehensiveHistory === undefined || comprehensiveHistory.length === 0) return [];
    const curatedHistory = [];
    const length = comprehensiveHistory.length;
    let i = 0;
    while(i < length)if (comprehensiveHistory[i].role === 'user') {
        curatedHistory.push(comprehensiveHistory[i]);
        i++;
    } else {
        const modelOutput = [];
        let isValid = true;
        while(i < length && comprehensiveHistory[i].role === 'model'){
            modelOutput.push(comprehensiveHistory[i]);
            if (isValid && !$e4deb49dba5321bc$var$isValidContent(comprehensiveHistory[i])) isValid = false;
            i++;
        }
        if (isValid) curatedHistory.push(...modelOutput);
        else // Remove the last user input when model content is invalid.
        curatedHistory.pop();
    }
    return curatedHistory;
}
/**
 * A utility class to create a chat session.
 */ class $e4deb49dba5321bc$export$84088b07cfe11a74 {
    constructor(modelsModule, apiClient){
        this.modelsModule = modelsModule;
        this.apiClient = apiClient;
    }
    /**
     * Creates a new chat session.
     *
     * @remarks
     * The config in the params will be used for all requests within the chat
     * session unless overridden by a per-request `config` in
     * @see {@link types.SendMessageParameters#config}.
     *
     * @param params - Parameters for creating a chat session.
     * @returns A new chat session.
     *
     * @example
     * ```ts
     * const chat = ai.chats.create({
     *   model: 'gemini-2.0-flash'
     *   config: {
     *     temperature: 0.5,
     *     maxOutputTokens: 1024,
     *   }
     * });
     * ```
     */ create(params) {
        return new $e4deb49dba5321bc$export$d49dffca20dba6f7(this.apiClient, this.modelsModule, params.model, params.config, // Deep copy the history to avoid mutating the history outside of the
        // chat session.
        structuredClone(params.history));
    }
}
/**
 * Chat session that enables sending messages to the model with previous
 * conversation context.
 *
 * @remarks
 * The session maintains all the turns between user and model.
 */ class $e4deb49dba5321bc$export$d49dffca20dba6f7 {
    constructor(apiClient, modelsModule, model, config = {}, history = []){
        this.apiClient = apiClient;
        this.modelsModule = modelsModule;
        this.model = model;
        this.config = config;
        this.history = history;
        // A promise to represent the current state of the message being sent to the
        // model.
        this.sendPromise = Promise.resolve();
        $e4deb49dba5321bc$var$validateHistory(history);
    }
    /**
     * Sends a message to the model and returns the response.
     *
     * @remarks
     * This method will wait for the previous message to be processed before
     * sending the next message.
     *
     * @see {@link Chat#sendMessageStream} for streaming method.
     * @param params - parameters for sending messages within a chat session.
     * @returns The model's response.
     *
     * @example
     * ```ts
     * const chat = ai.chats.create({model: 'gemini-2.0-flash'});
     * const response = await chat.sendMessage({
     *   message: 'Why is the sky blue?'
     * });
     * console.log(response.text);
     * ```
     */ async sendMessage(params) {
        var _a;
        await this.sendPromise;
        const inputContent = $e4deb49dba5321bc$var$tContent(params.message);
        const responsePromise = this.modelsModule.generateContent({
            model: this.model,
            contents: this.getHistory(true).concat(inputContent),
            config: (_a = params.config) !== null && _a !== void 0 ? _a : this.config
        });
        this.sendPromise = (async ()=>{
            var _a, _b, _c;
            const response = await responsePromise;
            const outputContent = (_b = (_a = response.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content;
            // Because the AFC input contains the entire curated chat history in
            // addition to the new user input, we need to truncate the AFC history
            // to deduplicate the existing chat history.
            const fullAutomaticFunctionCallingHistory = response.automaticFunctionCallingHistory;
            const index = this.getHistory(true).length;
            let automaticFunctionCallingHistory = [];
            if (fullAutomaticFunctionCallingHistory != null) automaticFunctionCallingHistory = (_c = fullAutomaticFunctionCallingHistory.slice(index)) !== null && _c !== void 0 ? _c : [];
            const modelOutput = outputContent ? [
                outputContent
            ] : [];
            this.recordHistory(inputContent, modelOutput, automaticFunctionCallingHistory);
            return;
        })();
        await this.sendPromise.catch(()=>{
            // Resets sendPromise to avoid subsequent calls failing
            this.sendPromise = Promise.resolve();
        });
        return responsePromise;
    }
    /**
     * Sends a message to the model and returns the response in chunks.
     *
     * @remarks
     * This method will wait for the previous message to be processed before
     * sending the next message.
     *
     * @see {@link Chat#sendMessage} for non-streaming method.
     * @param params - parameters for sending the message.
     * @return The model's response.
     *
     * @example
     * ```ts
     * const chat = ai.chats.create({model: 'gemini-2.0-flash'});
     * const response = await chat.sendMessageStream({
     *   message: 'Why is the sky blue?'
     * });
     * for await (const chunk of response) {
     *   console.log(chunk.text);
     * }
     * ```
     */ async sendMessageStream(params) {
        var _a;
        await this.sendPromise;
        const inputContent = $e4deb49dba5321bc$var$tContent(params.message);
        const streamResponse = this.modelsModule.generateContentStream({
            model: this.model,
            contents: this.getHistory(true).concat(inputContent),
            config: (_a = params.config) !== null && _a !== void 0 ? _a : this.config
        });
        // Resolve the internal tracking of send completion promise - `sendPromise`
        // for both success and failure response. The actual failure is still
        // propagated by the `await streamResponse`.
        this.sendPromise = streamResponse.then(()=>undefined).catch(()=>undefined);
        const response = await streamResponse;
        const result = this.processStreamResponse(response, inputContent);
        return result;
    }
    /**
     * Returns the chat history.
     *
     * @remarks
     * The history is a list of contents alternating between user and model.
     *
     * There are two types of history:
     * - The `curated history` contains only the valid turns between user and
     * model, which will be included in the subsequent requests sent to the model.
     * - The `comprehensive history` contains all turns, including invalid or
     *   empty model outputs, providing a complete record of the history.
     *
     * The history is updated after receiving the response from the model,
     * for streaming response, it means receiving the last chunk of the response.
     *
     * The `comprehensive history` is returned by default. To get the `curated
     * history`, set the `curated` parameter to `true`.
     *
     * @param curated - whether to return the curated history or the comprehensive
     *     history.
     * @return History contents alternating between user and model for the entire
     *     chat session.
     */ getHistory(curated = false) {
        const history = curated ? $e4deb49dba5321bc$var$extractCuratedHistory(this.history) : this.history;
        // Deep copy the history to avoid mutating the history outside of the
        // chat session.
        return structuredClone(history);
    }
    processStreamResponse(streamResponse, inputContent) {
        var _a, _b;
        return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function* processStreamResponse_1() {
            var _c, e_1, _d, _e;
            const outputContent = [];
            try {
                for(var _f = true, streamResponse_1 = $e4deb49dba5321bc$var$__asyncValues(streamResponse), streamResponse_1_1; streamResponse_1_1 = yield $e4deb49dba5321bc$var$__await(streamResponse_1.next()), _c = streamResponse_1_1.done, !_c; _f = true){
                    _e = streamResponse_1_1.value;
                    _f = false;
                    const chunk = _e;
                    if ($e4deb49dba5321bc$var$isValidResponse(chunk)) {
                        const content = (_b = (_a = chunk.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content;
                        if (content !== undefined) outputContent.push(content);
                    }
                    yield yield $e4deb49dba5321bc$var$__await(chunk);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (!_f && !_c && (_d = streamResponse_1.return)) yield $e4deb49dba5321bc$var$__await(_d.call(streamResponse_1));
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            this.recordHistory(inputContent, outputContent);
        });
    }
    recordHistory(userInput, modelOutput, automaticFunctionCallingHistory) {
        let outputContents = [];
        if (modelOutput.length > 0 && modelOutput.every((content)=>content.role !== undefined)) outputContents = modelOutput;
        else // Appends an empty content when model returns empty response, so that the
        // history is always alternating between user and model.
        outputContents.push({
            role: 'model',
            parts: []
        });
        if (automaticFunctionCallingHistory && automaticFunctionCallingHistory.length > 0) this.history.push(...$e4deb49dba5321bc$var$extractCuratedHistory(automaticFunctionCallingHistory));
        else this.history.push(userInput);
        this.history.push(...outputContents);
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * API errors raised by the GenAI API.
 */ class $e4deb49dba5321bc$export$f2e832acab1bdd79 extends Error {
    constructor(options){
        super(options.message);
        this.name = 'ApiError';
        this.status = options.status;
        Object.setPrototypeOf(this, $e4deb49dba5321bc$export$f2e832acab1bdd79.prototype);
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // Code generated by the Google Gen AI SDK generator DO NOT EDIT.
function $e4deb49dba5321bc$var$listFilesConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    return toObject;
}
function $e4deb49dba5321bc$var$listFilesParametersToMldev(fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$listFilesConfigToMldev(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$fileStatusToMldev(fromObject) {
    const toObject = {};
    const fromDetails = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'details'
    ]);
    if (fromDetails != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'details'
    ], fromDetails);
    const fromMessage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'message'
    ]);
    if (fromMessage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'message'
    ], fromMessage);
    const fromCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'code'
    ]);
    if (fromCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'code'
    ], fromCode);
    return toObject;
}
function $e4deb49dba5321bc$var$fileToMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    const fromSizeBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sizeBytes'
    ]);
    if (fromSizeBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sizeBytes'
    ], fromSizeBytes);
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromExpirationTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'expirationTime'
    ]);
    if (fromExpirationTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'expirationTime'
    ], fromExpirationTime);
    const fromUpdateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    const fromSha256Hash = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sha256Hash'
    ]);
    if (fromSha256Hash != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sha256Hash'
    ], fromSha256Hash);
    const fromUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'uri'
    ]);
    if (fromUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'uri'
    ], fromUri);
    const fromDownloadUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'downloadUri'
    ]);
    if (fromDownloadUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'downloadUri'
    ], fromDownloadUri);
    const fromState = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'state'
    ]);
    if (fromState != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'state'
    ], fromState);
    const fromSource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'source'
    ]);
    if (fromSource != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'source'
    ], fromSource);
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], fromVideoMetadata);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], $e4deb49dba5321bc$var$fileStatusToMldev(fromError));
    return toObject;
}
function $e4deb49dba5321bc$var$createFileParametersToMldev(fromObject) {
    const toObject = {};
    const fromFile = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'file'
    ]);
    if (fromFile != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'file'
    ], $e4deb49dba5321bc$var$fileToMldev(fromFile));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$getFileParametersToMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'file'
    ], $e4deb49dba5321bc$var$tFileName(fromName));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteFileParametersToMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'file'
    ], $e4deb49dba5321bc$var$tFileName(fromName));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$fileStatusFromMldev(fromObject) {
    const toObject = {};
    const fromDetails = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'details'
    ]);
    if (fromDetails != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'details'
    ], fromDetails);
    const fromMessage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'message'
    ]);
    if (fromMessage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'message'
    ], fromMessage);
    const fromCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'code'
    ]);
    if (fromCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'code'
    ], fromCode);
    return toObject;
}
function $e4deb49dba5321bc$var$fileFromMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    const fromSizeBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sizeBytes'
    ]);
    if (fromSizeBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sizeBytes'
    ], fromSizeBytes);
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromExpirationTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'expirationTime'
    ]);
    if (fromExpirationTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'expirationTime'
    ], fromExpirationTime);
    const fromUpdateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    const fromSha256Hash = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sha256Hash'
    ]);
    if (fromSha256Hash != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sha256Hash'
    ], fromSha256Hash);
    const fromUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'uri'
    ]);
    if (fromUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'uri'
    ], fromUri);
    const fromDownloadUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'downloadUri'
    ]);
    if (fromDownloadUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'downloadUri'
    ], fromDownloadUri);
    const fromState = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'state'
    ]);
    if (fromState != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'state'
    ], fromState);
    const fromSource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'source'
    ]);
    if (fromSource != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'source'
    ], fromSource);
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], fromVideoMetadata);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], $e4deb49dba5321bc$var$fileStatusFromMldev(fromError));
    return toObject;
}
function $e4deb49dba5321bc$var$listFilesResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromFiles = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'files'
    ]);
    if (fromFiles != null) {
        let transformedList = fromFiles;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$fileFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'files'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$createFileResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteFileResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$export$9330ab61a7e5c11b extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
        /**
         * Lists all current project files from the service.
         *
         * @param params - The parameters for the list request
         * @return The paginated results of the list of files
         *
         * @example
         * The following code prints the names of all files from the service, the
         * size of each page is 10.
         *
         * ```ts
         * const listResponse = await ai.files.list({config: {'pageSize': 10}});
         * for await (const file of listResponse) {
         *   console.log(file.name);
         * }
         * ```
         */ this.list = async (params = {})=>{
            return new $e4deb49dba5321bc$export$57625d62e5386b09($e4deb49dba5321bc$export$e18b8de308fd2439.PAGED_ITEM_FILES, (x)=>this.listInternal(x), await this.listInternal(params), params);
        };
    }
    /**
     * Uploads a file asynchronously to the Gemini API.
     * This method is not available in Vertex AI.
     * Supported upload sources:
     * - Node.js: File path (string) or Blob object.
     * - Browser: Blob object (e.g., File).
     *
     * @remarks
     * The `mimeType` can be specified in the `config` parameter. If omitted:
     *  - For file path (string) inputs, the `mimeType` will be inferred from the
     *     file extension.
     *  - For Blob object inputs, the `mimeType` will be set to the Blob's `type`
     *     property.
     * Somex eamples for file extension to mimeType mapping:
     * .txt -> text/plain
     * .json -> application/json
     * .jpg  -> image/jpeg
     * .png -> image/png
     * .mp3 -> audio/mpeg
     * .mp4 -> video/mp4
     *
     * This section can contain multiple paragraphs and code examples.
     *
     * @param params - Optional parameters specified in the
     *        `types.UploadFileParameters` interface.
     *         @see {@link types.UploadFileParameters#config} for the optional
     *         config in the parameters.
     * @return A promise that resolves to a `types.File` object.
     * @throws An error if called on a Vertex AI client.
     * @throws An error if the `mimeType` is not provided and can not be inferred,
     * the `mimeType` can be provided in the `params.config` parameter.
     * @throws An error occurs if a suitable upload location cannot be established.
     *
     * @example
     * The following code uploads a file to Gemini API.
     *
     * ```ts
     * const file = await ai.files.upload({file: 'file.txt', config: {
     *   mimeType: 'text/plain',
     * }});
     * console.log(file.name);
     * ```
     */ async upload(params) {
        if (this.apiClient.isVertexAI()) throw new Error('Vertex AI does not support uploading files. You can share files through a GCS bucket.');
        return this.apiClient.uploadFile(params.file, params.config).then((response)=>{
            const file = $e4deb49dba5321bc$var$fileFromMldev(response);
            return file;
        });
    }
    /**
     * Downloads a remotely stored file asynchronously to a location specified in
     * the `params` object. This method only works on Node environment, to
     * download files in the browser, use a browser compliant method like an <a>
     * tag.
     *
     * @param params - The parameters for the download request.
     *
     * @example
     * The following code downloads an example file named "files/mehozpxf877d" as
     * "file.txt".
     *
     * ```ts
     * await ai.files.download({file: file.name, downloadPath: 'file.txt'});
     * ```
     */ async download(params) {
        await this.apiClient.downloadFile(params);
    }
    async listInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$listFilesParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('files', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listFilesResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$70c4c7aa1360da5a();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    async createInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$createFileParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('upload/v1beta/files', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$createFileResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$e6f7a7cf305d85e3();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Retrieves the file information from the service.
     *
     * @param params - The parameters for the get request
     * @return The Promise that resolves to the types.File object requested.
     *
     * @example
     * ```ts
     * const config: GetFileParameters = {
     *   name: fileName,
     * };
     * file = await ai.files.get(config);
     * console.log(file.name);
     * ```
     */ async get(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$getFileParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('files/{file}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$fileFromMldev(apiResponse);
                return resp;
            });
        }
    }
    /**
     * Deletes a remotely stored file.
     *
     * @param params - The parameters for the delete request.
     * @return The DeleteFileResponse, the response for the delete method.
     *
     * @example
     * The following code deletes an example file named "files/mehozpxf877d".
     *
     * ```ts
     * await ai.files.delete({name: file.name});
     * ```
     */ async delete(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$deleteFileParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('files/{file}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$deleteFileResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$a33f0b325263613a();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$prebuiltVoiceConfigToMldev$2(fromObject) {
    const toObject = {};
    const fromVoiceName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceName'
    ]);
    if (fromVoiceName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceName'
    ], fromVoiceName);
    return toObject;
}
function $e4deb49dba5321bc$var$voiceConfigToMldev$2(fromObject) {
    const toObject = {};
    const fromPrebuiltVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prebuiltVoiceConfig'
    ]);
    if (fromPrebuiltVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'prebuiltVoiceConfig'
    ], $e4deb49dba5321bc$var$prebuiltVoiceConfigToMldev$2(fromPrebuiltVoiceConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$speakerVoiceConfigToMldev$2(fromObject) {
    const toObject = {};
    const fromSpeaker = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speaker'
    ]);
    if (fromSpeaker != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'speaker'
    ], fromSpeaker);
    const fromVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceConfig'
    ]);
    if (fromVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceConfig'
    ], $e4deb49dba5321bc$var$voiceConfigToMldev$2(fromVoiceConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$multiSpeakerVoiceConfigToMldev$2(fromObject) {
    const toObject = {};
    const fromSpeakerVoiceConfigs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speakerVoiceConfigs'
    ]);
    if (fromSpeakerVoiceConfigs != null) {
        let transformedList = fromSpeakerVoiceConfigs;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$speakerVoiceConfigToMldev$2(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'speakerVoiceConfigs'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$speechConfigToMldev$2(fromObject) {
    const toObject = {};
    const fromVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceConfig'
    ]);
    if (fromVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceConfig'
    ], $e4deb49dba5321bc$var$voiceConfigToMldev$2(fromVoiceConfig));
    const fromMultiSpeakerVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'multiSpeakerVoiceConfig'
    ]);
    if (fromMultiSpeakerVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'multiSpeakerVoiceConfig'
    ], $e4deb49dba5321bc$var$multiSpeakerVoiceConfigToMldev$2(fromMultiSpeakerVoiceConfig));
    const fromLanguageCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'languageCode'
    ]);
    if (fromLanguageCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'languageCode'
    ], fromLanguageCode);
    return toObject;
}
function $e4deb49dba5321bc$var$videoMetadataToMldev$2(fromObject) {
    const toObject = {};
    const fromFps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fps'
    ]);
    if (fromFps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fps'
    ], fromFps);
    const fromEndOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endOffset'
    ]);
    if (fromEndOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endOffset'
    ], fromEndOffset);
    const fromStartOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startOffset'
    ]);
    if (fromStartOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startOffset'
    ], fromStartOffset);
    return toObject;
}
function $e4deb49dba5321bc$var$blobToMldev$2(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$fileDataToMldev$2(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromFileUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallToMldev$2(fromObject) {
    const toObject = {};
    const fromId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'id'
    ]);
    if (fromId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'id'
    ], fromId);
    const fromArgs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$partToMldev$2(fromObject) {
    const toObject = {};
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], $e4deb49dba5321bc$var$videoMetadataToMldev$2(fromVideoMetadata));
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], $e4deb49dba5321bc$var$blobToMldev$2(fromInlineData));
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], $e4deb49dba5321bc$var$fileDataToMldev$2(fromFileData));
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], $e4deb49dba5321bc$var$functionCallToMldev$2(fromFunctionCall));
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    return toObject;
}
function $e4deb49dba5321bc$var$contentToMldev$2(fromObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partToMldev$2(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$functionDeclarationToMldev$2(fromObject) {
    const toObject = {};
    const fromBehavior = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'behavior'
    ]);
    if (fromBehavior != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'behavior'
    ], fromBehavior);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromParameters = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parameters'
    ]);
    if (fromParameters != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parameters'
    ], fromParameters);
    const fromParametersJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parametersJsonSchema'
    ]);
    if (fromParametersJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parametersJsonSchema'
    ], fromParametersJsonSchema);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], fromResponse);
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    return toObject;
}
function $e4deb49dba5321bc$var$intervalToMldev$2(fromObject) {
    const toObject = {};
    const fromStartTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startTime'
    ]);
    if (fromStartTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endTime'
    ]);
    if (fromEndTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchToMldev$2(fromObject) {
    const toObject = {};
    const fromTimeRangeFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'timeRangeFilter'
    ], $e4deb49dba5321bc$var$intervalToMldev$2(fromTimeRangeFilter));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'excludeDomains'
    ]) !== undefined) throw new Error('excludeDomains parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$dynamicRetrievalConfigToMldev$2(fromObject) {
    const toObject = {};
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mode'
    ], fromMode);
    const fromDynamicThreshold = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'dynamicThreshold'
    ]);
    if (fromDynamicThreshold != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dynamicThreshold'
    ], fromDynamicThreshold);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchRetrievalToMldev$2(fromObject) {
    const toObject = {};
    const fromDynamicRetrievalConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'dynamicRetrievalConfig'
    ]);
    if (fromDynamicRetrievalConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dynamicRetrievalConfig'
    ], $e4deb49dba5321bc$var$dynamicRetrievalConfigToMldev$2(fromDynamicRetrievalConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$urlContextToMldev$2() {
    const toObject = {};
    return toObject;
}
function $e4deb49dba5321bc$var$toolComputerUseToMldev$2(fromObject) {
    const toObject = {};
    const fromEnvironment = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'environment'
    ]);
    if (fromEnvironment != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'environment'
    ], fromEnvironment);
    return toObject;
}
function $e4deb49dba5321bc$var$toolToMldev$2(fromObject) {
    const toObject = {};
    const fromFunctionDeclarations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$functionDeclarationToMldev$2(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrieval'
    ]) !== undefined) throw new Error('retrieval parameter is not supported in Gemini API.');
    const fromGoogleSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearch'
    ], $e4deb49dba5321bc$var$googleSearchToMldev$2(fromGoogleSearch));
    const fromGoogleSearchRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], $e4deb49dba5321bc$var$googleSearchRetrievalToMldev$2(fromGoogleSearchRetrieval));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]) !== undefined) throw new Error('enterpriseWebSearch parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleMaps'
    ]) !== undefined) throw new Error('googleMaps parameter is not supported in Gemini API.');
    const fromUrlContext = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContext'
    ], $e4deb49dba5321bc$var$urlContextToMldev$2());
    const fromComputerUse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'computerUse'
    ]);
    if (fromComputerUse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computerUse'
    ], $e4deb49dba5321bc$var$toolComputerUseToMldev$2(fromComputerUse));
    const fromCodeExecution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    return toObject;
}
function $e4deb49dba5321bc$var$sessionResumptionConfigToMldev$1(fromObject) {
    const toObject = {};
    const fromHandle = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'handle'
    ]);
    if (fromHandle != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'handle'
    ], fromHandle);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'transparent'
    ]) !== undefined) throw new Error('transparent parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$audioTranscriptionConfigToMldev$1() {
    const toObject = {};
    return toObject;
}
function $e4deb49dba5321bc$var$automaticActivityDetectionToMldev$1(fromObject) {
    const toObject = {};
    const fromDisabled = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'disabled'
    ]);
    if (fromDisabled != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'disabled'
    ], fromDisabled);
    const fromStartOfSpeechSensitivity = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startOfSpeechSensitivity'
    ]);
    if (fromStartOfSpeechSensitivity != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startOfSpeechSensitivity'
    ], fromStartOfSpeechSensitivity);
    const fromEndOfSpeechSensitivity = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endOfSpeechSensitivity'
    ]);
    if (fromEndOfSpeechSensitivity != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endOfSpeechSensitivity'
    ], fromEndOfSpeechSensitivity);
    const fromPrefixPaddingMs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prefixPaddingMs'
    ]);
    if (fromPrefixPaddingMs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'prefixPaddingMs'
    ], fromPrefixPaddingMs);
    const fromSilenceDurationMs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'silenceDurationMs'
    ]);
    if (fromSilenceDurationMs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'silenceDurationMs'
    ], fromSilenceDurationMs);
    return toObject;
}
function $e4deb49dba5321bc$var$realtimeInputConfigToMldev$1(fromObject) {
    const toObject = {};
    const fromAutomaticActivityDetection = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'automaticActivityDetection'
    ]);
    if (fromAutomaticActivityDetection != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'automaticActivityDetection'
    ], $e4deb49dba5321bc$var$automaticActivityDetectionToMldev$1(fromAutomaticActivityDetection));
    const fromActivityHandling = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'activityHandling'
    ]);
    if (fromActivityHandling != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'activityHandling'
    ], fromActivityHandling);
    const fromTurnCoverage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'turnCoverage'
    ]);
    if (fromTurnCoverage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'turnCoverage'
    ], fromTurnCoverage);
    return toObject;
}
function $e4deb49dba5321bc$var$slidingWindowToMldev$1(fromObject) {
    const toObject = {};
    const fromTargetTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'targetTokens'
    ]);
    if (fromTargetTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'targetTokens'
    ], fromTargetTokens);
    return toObject;
}
function $e4deb49dba5321bc$var$contextWindowCompressionConfigToMldev$1(fromObject) {
    const toObject = {};
    const fromTriggerTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'triggerTokens'
    ]);
    if (fromTriggerTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'triggerTokens'
    ], fromTriggerTokens);
    const fromSlidingWindow = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'slidingWindow'
    ]);
    if (fromSlidingWindow != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'slidingWindow'
    ], $e4deb49dba5321bc$var$slidingWindowToMldev$1(fromSlidingWindow));
    return toObject;
}
function $e4deb49dba5321bc$var$proactivityConfigToMldev$1(fromObject) {
    const toObject = {};
    const fromProactiveAudio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'proactiveAudio'
    ]);
    if (fromProactiveAudio != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'proactiveAudio'
    ], fromProactiveAudio);
    return toObject;
}
function $e4deb49dba5321bc$var$liveConnectConfigToMldev$1(fromObject, parentObject) {
    const toObject = {};
    const fromGenerationConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generationConfig'
    ]);
    if (parentObject !== undefined && fromGenerationConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig'
    ], fromGenerationConfig);
    const fromResponseModalities = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (parentObject !== undefined && fromResponseModalities != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'responseModalities'
    ], fromResponseModalities);
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (parentObject !== undefined && fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'temperature'
    ], fromTemperature);
    const fromTopP = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topP'
    ]);
    if (parentObject !== undefined && fromTopP != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'topP'
    ], fromTopP);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (parentObject !== undefined && fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'topK'
    ], fromTopK);
    const fromMaxOutputTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (parentObject !== undefined && fromMaxOutputTokens != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (parentObject !== undefined && fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'mediaResolution'
    ], fromMediaResolution);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'seed'
    ], fromSeed);
    const fromSpeechConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (parentObject !== undefined && fromSpeechConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'speechConfig'
    ], $e4deb49dba5321bc$var$speechConfigToMldev$2($e4deb49dba5321bc$var$tLiveSpeechConfig(fromSpeechConfig)));
    const fromEnableAffectiveDialog = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableAffectiveDialog'
    ]);
    if (parentObject !== undefined && fromEnableAffectiveDialog != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'enableAffectiveDialog'
    ], fromEnableAffectiveDialog);
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'systemInstruction'
    ], $e4deb49dba5321bc$var$contentToMldev$2($e4deb49dba5321bc$var$tContent(fromSystemInstruction)));
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = $e4deb49dba5321bc$var$tTools(fromTools);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToMldev$2($e4deb49dba5321bc$var$tTool(item));
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'setup',
            'tools'
        ], transformedList);
    }
    const fromSessionResumption = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sessionResumption'
    ]);
    if (parentObject !== undefined && fromSessionResumption != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'sessionResumption'
    ], $e4deb49dba5321bc$var$sessionResumptionConfigToMldev$1(fromSessionResumption));
    const fromInputAudioTranscription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inputAudioTranscription'
    ]);
    if (parentObject !== undefined && fromInputAudioTranscription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'inputAudioTranscription'
    ], $e4deb49dba5321bc$var$audioTranscriptionConfigToMldev$1());
    const fromOutputAudioTranscription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputAudioTranscription'
    ]);
    if (parentObject !== undefined && fromOutputAudioTranscription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'outputAudioTranscription'
    ], $e4deb49dba5321bc$var$audioTranscriptionConfigToMldev$1());
    const fromRealtimeInputConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'realtimeInputConfig'
    ]);
    if (parentObject !== undefined && fromRealtimeInputConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'realtimeInputConfig'
    ], $e4deb49dba5321bc$var$realtimeInputConfigToMldev$1(fromRealtimeInputConfig));
    const fromContextWindowCompression = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contextWindowCompression'
    ]);
    if (parentObject !== undefined && fromContextWindowCompression != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'contextWindowCompression'
    ], $e4deb49dba5321bc$var$contextWindowCompressionConfigToMldev$1(fromContextWindowCompression));
    const fromProactivity = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'proactivity'
    ]);
    if (parentObject !== undefined && fromProactivity != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'proactivity'
    ], $e4deb49dba5321bc$var$proactivityConfigToMldev$1(fromProactivity));
    return toObject;
}
function $e4deb49dba5321bc$var$liveConnectParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'setup',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$liveConnectConfigToMldev$1(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$activityStartToMldev() {
    const toObject = {};
    return toObject;
}
function $e4deb49dba5321bc$var$activityEndToMldev() {
    const toObject = {};
    return toObject;
}
function $e4deb49dba5321bc$var$liveSendRealtimeInputParametersToMldev(fromObject) {
    const toObject = {};
    const fromMedia = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'media'
    ]);
    if (fromMedia != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaChunks'
    ], $e4deb49dba5321bc$var$tBlobs(fromMedia));
    const fromAudio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audio'
    ]);
    if (fromAudio != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'audio'
    ], $e4deb49dba5321bc$var$tAudioBlob(fromAudio));
    const fromAudioStreamEnd = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audioStreamEnd'
    ]);
    if (fromAudioStreamEnd != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'audioStreamEnd'
    ], fromAudioStreamEnd);
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video'
    ]);
    if (fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'video'
    ], $e4deb49dba5321bc$var$tImageBlob(fromVideo));
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromActivityStart = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'activityStart'
    ]);
    if (fromActivityStart != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'activityStart'
    ], $e4deb49dba5321bc$var$activityStartToMldev());
    const fromActivityEnd = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'activityEnd'
    ]);
    if (fromActivityEnd != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'activityEnd'
    ], $e4deb49dba5321bc$var$activityEndToMldev());
    return toObject;
}
function $e4deb49dba5321bc$var$weightedPromptToMldev(fromObject) {
    const toObject = {};
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromWeight = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'weight'
    ]);
    if (fromWeight != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'weight'
    ], fromWeight);
    return toObject;
}
function $e4deb49dba5321bc$var$liveMusicSetWeightedPromptsParametersToMldev(fromObject) {
    const toObject = {};
    const fromWeightedPrompts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'weightedPrompts'
    ]);
    if (fromWeightedPrompts != null) {
        let transformedList = fromWeightedPrompts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$weightedPromptToMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'weightedPrompts'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$liveMusicGenerationConfigToMldev(fromObject) {
    const toObject = {};
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'temperature'
    ], fromTemperature);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topK'
    ], fromTopK);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'seed'
    ], fromSeed);
    const fromGuidance = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'guidance'
    ]);
    if (fromGuidance != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'guidance'
    ], fromGuidance);
    const fromBpm = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bpm'
    ]);
    if (fromBpm != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'bpm'
    ], fromBpm);
    const fromDensity = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'density'
    ]);
    if (fromDensity != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'density'
    ], fromDensity);
    const fromBrightness = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'brightness'
    ]);
    if (fromBrightness != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'brightness'
    ], fromBrightness);
    const fromScale = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'scale'
    ]);
    if (fromScale != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'scale'
    ], fromScale);
    const fromMuteBass = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'muteBass'
    ]);
    if (fromMuteBass != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'muteBass'
    ], fromMuteBass);
    const fromMuteDrums = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'muteDrums'
    ]);
    if (fromMuteDrums != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'muteDrums'
    ], fromMuteDrums);
    const fromOnlyBassAndDrums = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'onlyBassAndDrums'
    ]);
    if (fromOnlyBassAndDrums != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'onlyBassAndDrums'
    ], fromOnlyBassAndDrums);
    const fromMusicGenerationMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'musicGenerationMode'
    ]);
    if (fromMusicGenerationMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'musicGenerationMode'
    ], fromMusicGenerationMode);
    return toObject;
}
function $e4deb49dba5321bc$var$liveMusicSetConfigParametersToMldev(fromObject) {
    const toObject = {};
    const fromMusicGenerationConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'musicGenerationConfig'
    ]);
    if (fromMusicGenerationConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'musicGenerationConfig'
    ], $e4deb49dba5321bc$var$liveMusicGenerationConfigToMldev(fromMusicGenerationConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$liveMusicClientSetupToMldev(fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'model'
    ], fromModel);
    return toObject;
}
function $e4deb49dba5321bc$var$liveMusicClientContentToMldev(fromObject) {
    const toObject = {};
    const fromWeightedPrompts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'weightedPrompts'
    ]);
    if (fromWeightedPrompts != null) {
        let transformedList = fromWeightedPrompts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$weightedPromptToMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'weightedPrompts'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$liveMusicClientMessageToMldev(fromObject) {
    const toObject = {};
    const fromSetup = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'setup'
    ]);
    if (fromSetup != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'setup'
    ], $e4deb49dba5321bc$var$liveMusicClientSetupToMldev(fromSetup));
    const fromClientContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'clientContent'
    ]);
    if (fromClientContent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'clientContent'
    ], $e4deb49dba5321bc$var$liveMusicClientContentToMldev(fromClientContent));
    const fromMusicGenerationConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'musicGenerationConfig'
    ]);
    if (fromMusicGenerationConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'musicGenerationConfig'
    ], $e4deb49dba5321bc$var$liveMusicGenerationConfigToMldev(fromMusicGenerationConfig));
    const fromPlaybackControl = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'playbackControl'
    ]);
    if (fromPlaybackControl != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'playbackControl'
    ], fromPlaybackControl);
    return toObject;
}
function $e4deb49dba5321bc$var$prebuiltVoiceConfigToVertex$1(fromObject) {
    const toObject = {};
    const fromVoiceName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceName'
    ]);
    if (fromVoiceName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceName'
    ], fromVoiceName);
    return toObject;
}
function $e4deb49dba5321bc$var$voiceConfigToVertex$1(fromObject) {
    const toObject = {};
    const fromPrebuiltVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prebuiltVoiceConfig'
    ]);
    if (fromPrebuiltVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'prebuiltVoiceConfig'
    ], $e4deb49dba5321bc$var$prebuiltVoiceConfigToVertex$1(fromPrebuiltVoiceConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$speechConfigToVertex$1(fromObject) {
    const toObject = {};
    const fromVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceConfig'
    ]);
    if (fromVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceConfig'
    ], $e4deb49dba5321bc$var$voiceConfigToVertex$1(fromVoiceConfig));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'multiSpeakerVoiceConfig'
    ]) !== undefined) throw new Error('multiSpeakerVoiceConfig parameter is not supported in Vertex AI.');
    const fromLanguageCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'languageCode'
    ]);
    if (fromLanguageCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'languageCode'
    ], fromLanguageCode);
    return toObject;
}
function $e4deb49dba5321bc$var$videoMetadataToVertex$1(fromObject) {
    const toObject = {};
    const fromFps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fps'
    ]);
    if (fromFps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fps'
    ], fromFps);
    const fromEndOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endOffset'
    ]);
    if (fromEndOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endOffset'
    ], fromEndOffset);
    const fromStartOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startOffset'
    ]);
    if (fromStartOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startOffset'
    ], fromStartOffset);
    return toObject;
}
function $e4deb49dba5321bc$var$blobToVertex$1(fromObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$fileDataToVertex$1(fromObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromFileUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallToVertex$1(fromObject) {
    const toObject = {};
    const fromId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'id'
    ]);
    if (fromId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'id'
    ], fromId);
    const fromArgs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$partToVertex$1(fromObject) {
    const toObject = {};
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], $e4deb49dba5321bc$var$videoMetadataToVertex$1(fromVideoMetadata));
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], $e4deb49dba5321bc$var$blobToVertex$1(fromInlineData));
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], $e4deb49dba5321bc$var$fileDataToVertex$1(fromFileData));
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], $e4deb49dba5321bc$var$functionCallToVertex$1(fromFunctionCall));
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    return toObject;
}
function $e4deb49dba5321bc$var$contentToVertex$1(fromObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partToVertex$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$functionDeclarationToVertex$1(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'behavior'
    ]) !== undefined) throw new Error('behavior parameter is not supported in Vertex AI.');
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromParameters = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parameters'
    ]);
    if (fromParameters != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parameters'
    ], fromParameters);
    const fromParametersJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parametersJsonSchema'
    ]);
    if (fromParametersJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parametersJsonSchema'
    ], fromParametersJsonSchema);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], fromResponse);
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    return toObject;
}
function $e4deb49dba5321bc$var$intervalToVertex$1(fromObject) {
    const toObject = {};
    const fromStartTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startTime'
    ]);
    if (fromStartTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endTime'
    ]);
    if (fromEndTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchToVertex$1(fromObject) {
    const toObject = {};
    const fromTimeRangeFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'timeRangeFilter'
    ], $e4deb49dba5321bc$var$intervalToVertex$1(fromTimeRangeFilter));
    const fromExcludeDomains = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'excludeDomains'
    ]);
    if (fromExcludeDomains != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'excludeDomains'
    ], fromExcludeDomains);
    return toObject;
}
function $e4deb49dba5321bc$var$dynamicRetrievalConfigToVertex$1(fromObject) {
    const toObject = {};
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mode'
    ], fromMode);
    const fromDynamicThreshold = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'dynamicThreshold'
    ]);
    if (fromDynamicThreshold != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dynamicThreshold'
    ], fromDynamicThreshold);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchRetrievalToVertex$1(fromObject) {
    const toObject = {};
    const fromDynamicRetrievalConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'dynamicRetrievalConfig'
    ]);
    if (fromDynamicRetrievalConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dynamicRetrievalConfig'
    ], $e4deb49dba5321bc$var$dynamicRetrievalConfigToVertex$1(fromDynamicRetrievalConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$enterpriseWebSearchToVertex$1(fromObject) {
    const toObject = {};
    const fromExcludeDomains = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'excludeDomains'
    ]);
    if (fromExcludeDomains != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'excludeDomains'
    ], fromExcludeDomains);
    return toObject;
}
function $e4deb49dba5321bc$var$apiKeyConfigToVertex$1(fromObject) {
    const toObject = {};
    const fromApiKeyString = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'apiKeyString'
    ]);
    if (fromApiKeyString != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'apiKeyString'
    ], fromApiKeyString);
    return toObject;
}
function $e4deb49dba5321bc$var$authConfigToVertex$1(fromObject) {
    const toObject = {};
    const fromApiKeyConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'apiKeyConfig'
    ]);
    if (fromApiKeyConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'apiKeyConfig'
    ], $e4deb49dba5321bc$var$apiKeyConfigToVertex$1(fromApiKeyConfig));
    const fromAuthType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'authType'
    ]);
    if (fromAuthType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'authType'
    ], fromAuthType);
    const fromGoogleServiceAccountConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleServiceAccountConfig'
    ]);
    if (fromGoogleServiceAccountConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleServiceAccountConfig'
    ], fromGoogleServiceAccountConfig);
    const fromHttpBasicAuthConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'httpBasicAuthConfig'
    ]);
    if (fromHttpBasicAuthConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'httpBasicAuthConfig'
    ], fromHttpBasicAuthConfig);
    const fromOauthConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'oauthConfig'
    ]);
    if (fromOauthConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'oauthConfig'
    ], fromOauthConfig);
    const fromOidcConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'oidcConfig'
    ]);
    if (fromOidcConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'oidcConfig'
    ], fromOidcConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$googleMapsToVertex$1(fromObject) {
    const toObject = {};
    const fromAuthConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'authConfig'
    ]);
    if (fromAuthConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'authConfig'
    ], $e4deb49dba5321bc$var$authConfigToVertex$1(fromAuthConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$urlContextToVertex$1() {
    const toObject = {};
    return toObject;
}
function $e4deb49dba5321bc$var$toolComputerUseToVertex$1(fromObject) {
    const toObject = {};
    const fromEnvironment = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'environment'
    ]);
    if (fromEnvironment != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'environment'
    ], fromEnvironment);
    return toObject;
}
function $e4deb49dba5321bc$var$toolToVertex$1(fromObject) {
    const toObject = {};
    const fromFunctionDeclarations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$functionDeclarationToVertex$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    const fromRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrieval'
    ]);
    if (fromRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrieval'
    ], fromRetrieval);
    const fromGoogleSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearch'
    ], $e4deb49dba5321bc$var$googleSearchToVertex$1(fromGoogleSearch));
    const fromGoogleSearchRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], $e4deb49dba5321bc$var$googleSearchRetrievalToVertex$1(fromGoogleSearchRetrieval));
    const fromEnterpriseWebSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]);
    if (fromEnterpriseWebSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enterpriseWebSearch'
    ], $e4deb49dba5321bc$var$enterpriseWebSearchToVertex$1(fromEnterpriseWebSearch));
    const fromGoogleMaps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleMaps'
    ]);
    if (fromGoogleMaps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleMaps'
    ], $e4deb49dba5321bc$var$googleMapsToVertex$1(fromGoogleMaps));
    const fromUrlContext = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContext'
    ], $e4deb49dba5321bc$var$urlContextToVertex$1());
    const fromComputerUse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'computerUse'
    ]);
    if (fromComputerUse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computerUse'
    ], $e4deb49dba5321bc$var$toolComputerUseToVertex$1(fromComputerUse));
    const fromCodeExecution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    return toObject;
}
function $e4deb49dba5321bc$var$sessionResumptionConfigToVertex(fromObject) {
    const toObject = {};
    const fromHandle = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'handle'
    ]);
    if (fromHandle != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'handle'
    ], fromHandle);
    const fromTransparent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'transparent'
    ]);
    if (fromTransparent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'transparent'
    ], fromTransparent);
    return toObject;
}
function $e4deb49dba5321bc$var$audioTranscriptionConfigToVertex() {
    const toObject = {};
    return toObject;
}
function $e4deb49dba5321bc$var$automaticActivityDetectionToVertex(fromObject) {
    const toObject = {};
    const fromDisabled = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'disabled'
    ]);
    if (fromDisabled != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'disabled'
    ], fromDisabled);
    const fromStartOfSpeechSensitivity = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startOfSpeechSensitivity'
    ]);
    if (fromStartOfSpeechSensitivity != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startOfSpeechSensitivity'
    ], fromStartOfSpeechSensitivity);
    const fromEndOfSpeechSensitivity = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endOfSpeechSensitivity'
    ]);
    if (fromEndOfSpeechSensitivity != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endOfSpeechSensitivity'
    ], fromEndOfSpeechSensitivity);
    const fromPrefixPaddingMs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prefixPaddingMs'
    ]);
    if (fromPrefixPaddingMs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'prefixPaddingMs'
    ], fromPrefixPaddingMs);
    const fromSilenceDurationMs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'silenceDurationMs'
    ]);
    if (fromSilenceDurationMs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'silenceDurationMs'
    ], fromSilenceDurationMs);
    return toObject;
}
function $e4deb49dba5321bc$var$realtimeInputConfigToVertex(fromObject) {
    const toObject = {};
    const fromAutomaticActivityDetection = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'automaticActivityDetection'
    ]);
    if (fromAutomaticActivityDetection != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'automaticActivityDetection'
    ], $e4deb49dba5321bc$var$automaticActivityDetectionToVertex(fromAutomaticActivityDetection));
    const fromActivityHandling = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'activityHandling'
    ]);
    if (fromActivityHandling != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'activityHandling'
    ], fromActivityHandling);
    const fromTurnCoverage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'turnCoverage'
    ]);
    if (fromTurnCoverage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'turnCoverage'
    ], fromTurnCoverage);
    return toObject;
}
function $e4deb49dba5321bc$var$slidingWindowToVertex(fromObject) {
    const toObject = {};
    const fromTargetTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'targetTokens'
    ]);
    if (fromTargetTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'targetTokens'
    ], fromTargetTokens);
    return toObject;
}
function $e4deb49dba5321bc$var$contextWindowCompressionConfigToVertex(fromObject) {
    const toObject = {};
    const fromTriggerTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'triggerTokens'
    ]);
    if (fromTriggerTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'triggerTokens'
    ], fromTriggerTokens);
    const fromSlidingWindow = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'slidingWindow'
    ]);
    if (fromSlidingWindow != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'slidingWindow'
    ], $e4deb49dba5321bc$var$slidingWindowToVertex(fromSlidingWindow));
    return toObject;
}
function $e4deb49dba5321bc$var$proactivityConfigToVertex(fromObject) {
    const toObject = {};
    const fromProactiveAudio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'proactiveAudio'
    ]);
    if (fromProactiveAudio != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'proactiveAudio'
    ], fromProactiveAudio);
    return toObject;
}
function $e4deb49dba5321bc$var$liveConnectConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromGenerationConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generationConfig'
    ]);
    if (parentObject !== undefined && fromGenerationConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig'
    ], fromGenerationConfig);
    const fromResponseModalities = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (parentObject !== undefined && fromResponseModalities != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'responseModalities'
    ], fromResponseModalities);
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (parentObject !== undefined && fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'temperature'
    ], fromTemperature);
    const fromTopP = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topP'
    ]);
    if (parentObject !== undefined && fromTopP != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'topP'
    ], fromTopP);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (parentObject !== undefined && fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'topK'
    ], fromTopK);
    const fromMaxOutputTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (parentObject !== undefined && fromMaxOutputTokens != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (parentObject !== undefined && fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'mediaResolution'
    ], fromMediaResolution);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'seed'
    ], fromSeed);
    const fromSpeechConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (parentObject !== undefined && fromSpeechConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'speechConfig'
    ], $e4deb49dba5321bc$var$speechConfigToVertex$1($e4deb49dba5321bc$var$tLiveSpeechConfig(fromSpeechConfig)));
    const fromEnableAffectiveDialog = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableAffectiveDialog'
    ]);
    if (parentObject !== undefined && fromEnableAffectiveDialog != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'enableAffectiveDialog'
    ], fromEnableAffectiveDialog);
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'systemInstruction'
    ], $e4deb49dba5321bc$var$contentToVertex$1($e4deb49dba5321bc$var$tContent(fromSystemInstruction)));
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = $e4deb49dba5321bc$var$tTools(fromTools);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToVertex$1($e4deb49dba5321bc$var$tTool(item));
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'setup',
            'tools'
        ], transformedList);
    }
    const fromSessionResumption = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sessionResumption'
    ]);
    if (parentObject !== undefined && fromSessionResumption != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'sessionResumption'
    ], $e4deb49dba5321bc$var$sessionResumptionConfigToVertex(fromSessionResumption));
    const fromInputAudioTranscription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inputAudioTranscription'
    ]);
    if (parentObject !== undefined && fromInputAudioTranscription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'inputAudioTranscription'
    ], $e4deb49dba5321bc$var$audioTranscriptionConfigToVertex());
    const fromOutputAudioTranscription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputAudioTranscription'
    ]);
    if (parentObject !== undefined && fromOutputAudioTranscription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'outputAudioTranscription'
    ], $e4deb49dba5321bc$var$audioTranscriptionConfigToVertex());
    const fromRealtimeInputConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'realtimeInputConfig'
    ]);
    if (parentObject !== undefined && fromRealtimeInputConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'realtimeInputConfig'
    ], $e4deb49dba5321bc$var$realtimeInputConfigToVertex(fromRealtimeInputConfig));
    const fromContextWindowCompression = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contextWindowCompression'
    ]);
    if (parentObject !== undefined && fromContextWindowCompression != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'contextWindowCompression'
    ], $e4deb49dba5321bc$var$contextWindowCompressionConfigToVertex(fromContextWindowCompression));
    const fromProactivity = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'proactivity'
    ]);
    if (parentObject !== undefined && fromProactivity != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'proactivity'
    ], $e4deb49dba5321bc$var$proactivityConfigToVertex(fromProactivity));
    return toObject;
}
function $e4deb49dba5321bc$var$liveConnectParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'setup',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$liveConnectConfigToVertex(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$activityStartToVertex() {
    const toObject = {};
    return toObject;
}
function $e4deb49dba5321bc$var$activityEndToVertex() {
    const toObject = {};
    return toObject;
}
function $e4deb49dba5321bc$var$liveSendRealtimeInputParametersToVertex(fromObject) {
    const toObject = {};
    const fromMedia = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'media'
    ]);
    if (fromMedia != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaChunks'
    ], $e4deb49dba5321bc$var$tBlobs(fromMedia));
    const fromAudio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audio'
    ]);
    if (fromAudio != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'audio'
    ], $e4deb49dba5321bc$var$tAudioBlob(fromAudio));
    const fromAudioStreamEnd = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audioStreamEnd'
    ]);
    if (fromAudioStreamEnd != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'audioStreamEnd'
    ], fromAudioStreamEnd);
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video'
    ]);
    if (fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'video'
    ], $e4deb49dba5321bc$var$tImageBlob(fromVideo));
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromActivityStart = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'activityStart'
    ]);
    if (fromActivityStart != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'activityStart'
    ], $e4deb49dba5321bc$var$activityStartToVertex());
    const fromActivityEnd = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'activityEnd'
    ]);
    if (fromActivityEnd != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'activityEnd'
    ], $e4deb49dba5321bc$var$activityEndToVertex());
    return toObject;
}
function $e4deb49dba5321bc$var$liveServerSetupCompleteFromMldev() {
    const toObject = {};
    return toObject;
}
function $e4deb49dba5321bc$var$videoMetadataFromMldev$1(fromObject) {
    const toObject = {};
    const fromFps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fps'
    ]);
    if (fromFps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fps'
    ], fromFps);
    const fromEndOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endOffset'
    ]);
    if (fromEndOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endOffset'
    ], fromEndOffset);
    const fromStartOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startOffset'
    ]);
    if (fromStartOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startOffset'
    ], fromStartOffset);
    return toObject;
}
function $e4deb49dba5321bc$var$blobFromMldev$1(fromObject) {
    const toObject = {};
    const fromData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$fileDataFromMldev$1(fromObject) {
    const toObject = {};
    const fromFileUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallFromMldev$1(fromObject) {
    const toObject = {};
    const fromId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'id'
    ]);
    if (fromId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'id'
    ], fromId);
    const fromArgs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$partFromMldev$1(fromObject) {
    const toObject = {};
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], $e4deb49dba5321bc$var$videoMetadataFromMldev$1(fromVideoMetadata));
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], $e4deb49dba5321bc$var$blobFromMldev$1(fromInlineData));
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], $e4deb49dba5321bc$var$fileDataFromMldev$1(fromFileData));
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], $e4deb49dba5321bc$var$functionCallFromMldev$1(fromFunctionCall));
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    return toObject;
}
function $e4deb49dba5321bc$var$contentFromMldev$1(fromObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partFromMldev$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$transcriptionFromMldev(fromObject) {
    const toObject = {};
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromFinished = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'finished'
    ]);
    if (fromFinished != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'finished'
    ], fromFinished);
    return toObject;
}
function $e4deb49dba5321bc$var$urlMetadataFromMldev$1(fromObject) {
    const toObject = {};
    const fromRetrievedUrl = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrievedUrl'
    ]);
    if (fromRetrievedUrl != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrievedUrl'
    ], fromRetrievedUrl);
    const fromUrlRetrievalStatus = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlRetrievalStatus'
    ]);
    if (fromUrlRetrievalStatus != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlRetrievalStatus'
    ], fromUrlRetrievalStatus);
    return toObject;
}
function $e4deb49dba5321bc$var$urlContextMetadataFromMldev$1(fromObject) {
    const toObject = {};
    const fromUrlMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlMetadata'
    ]);
    if (fromUrlMetadata != null) {
        let transformedList = fromUrlMetadata;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$urlMetadataFromMldev$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'urlMetadata'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$liveServerContentFromMldev(fromObject) {
    const toObject = {};
    const fromModelTurn = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelTurn'
    ]);
    if (fromModelTurn != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'modelTurn'
    ], $e4deb49dba5321bc$var$contentFromMldev$1(fromModelTurn));
    const fromTurnComplete = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'turnComplete'
    ]);
    if (fromTurnComplete != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'turnComplete'
    ], fromTurnComplete);
    const fromInterrupted = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'interrupted'
    ]);
    if (fromInterrupted != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'interrupted'
    ], fromInterrupted);
    const fromGroundingMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'groundingMetadata'
    ]);
    if (fromGroundingMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'groundingMetadata'
    ], fromGroundingMetadata);
    const fromGenerationComplete = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generationComplete'
    ]);
    if (fromGenerationComplete != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'generationComplete'
    ], fromGenerationComplete);
    const fromInputTranscription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inputTranscription'
    ]);
    if (fromInputTranscription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inputTranscription'
    ], $e4deb49dba5321bc$var$transcriptionFromMldev(fromInputTranscription));
    const fromOutputTranscription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputTranscription'
    ]);
    if (fromOutputTranscription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'outputTranscription'
    ], $e4deb49dba5321bc$var$transcriptionFromMldev(fromOutputTranscription));
    const fromUrlContextMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContextMetadata'
    ]);
    if (fromUrlContextMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContextMetadata'
    ], $e4deb49dba5321bc$var$urlContextMetadataFromMldev$1(fromUrlContextMetadata));
    const fromTurnCompleteReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'turnCompleteReason'
    ]);
    if (fromTurnCompleteReason != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'turnCompleteReason'
    ], fromTurnCompleteReason);
    const fromWaitingForInput = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'waitingForInput'
    ]);
    if (fromWaitingForInput != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'waitingForInput'
    ], fromWaitingForInput);
    return toObject;
}
function $e4deb49dba5321bc$var$liveServerToolCallFromMldev(fromObject) {
    const toObject = {};
    const fromFunctionCalls = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCalls'
    ]);
    if (fromFunctionCalls != null) {
        let transformedList = fromFunctionCalls;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$functionCallFromMldev$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionCalls'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$liveServerToolCallCancellationFromMldev(fromObject) {
    const toObject = {};
    const fromIds = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'ids'
    ]);
    if (fromIds != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'ids'
    ], fromIds);
    return toObject;
}
function $e4deb49dba5321bc$var$modalityTokenCountFromMldev(fromObject) {
    const toObject = {};
    const fromModality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modality'
    ]);
    if (fromModality != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'modality'
    ], fromModality);
    const fromTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tokenCount'
    ]);
    if (fromTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tokenCount'
    ], fromTokenCount);
    return toObject;
}
function $e4deb49dba5321bc$var$usageMetadataFromMldev(fromObject) {
    const toObject = {};
    const fromPromptTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'promptTokenCount'
    ]);
    if (fromPromptTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'promptTokenCount'
    ], fromPromptTokenCount);
    const fromCachedContentTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cachedContentTokenCount'
    ]);
    if (fromCachedContentTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'cachedContentTokenCount'
    ], fromCachedContentTokenCount);
    const fromResponseTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseTokenCount'
    ]);
    if (fromResponseTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseTokenCount'
    ], fromResponseTokenCount);
    const fromToolUsePromptTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolUsePromptTokenCount'
    ]);
    if (fromToolUsePromptTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'toolUsePromptTokenCount'
    ], fromToolUsePromptTokenCount);
    const fromThoughtsTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtsTokenCount'
    ]);
    if (fromThoughtsTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtsTokenCount'
    ], fromThoughtsTokenCount);
    const fromTotalTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'totalTokenCount'
    ]);
    if (fromTotalTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'totalTokenCount'
    ], fromTotalTokenCount);
    const fromPromptTokensDetails = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'promptTokensDetails'
    ]);
    if (fromPromptTokensDetails != null) {
        let transformedList = fromPromptTokensDetails;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$modalityTokenCountFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'promptTokensDetails'
        ], transformedList);
    }
    const fromCacheTokensDetails = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cacheTokensDetails'
    ]);
    if (fromCacheTokensDetails != null) {
        let transformedList = fromCacheTokensDetails;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$modalityTokenCountFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'cacheTokensDetails'
        ], transformedList);
    }
    const fromResponseTokensDetails = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseTokensDetails'
    ]);
    if (fromResponseTokensDetails != null) {
        let transformedList = fromResponseTokensDetails;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$modalityTokenCountFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'responseTokensDetails'
        ], transformedList);
    }
    const fromToolUsePromptTokensDetails = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolUsePromptTokensDetails'
    ]);
    if (fromToolUsePromptTokensDetails != null) {
        let transformedList = fromToolUsePromptTokensDetails;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$modalityTokenCountFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'toolUsePromptTokensDetails'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$liveServerGoAwayFromMldev(fromObject) {
    const toObject = {};
    const fromTimeLeft = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'timeLeft'
    ]);
    if (fromTimeLeft != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'timeLeft'
    ], fromTimeLeft);
    return toObject;
}
function $e4deb49dba5321bc$var$liveServerSessionResumptionUpdateFromMldev(fromObject) {
    const toObject = {};
    const fromNewHandle = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'newHandle'
    ]);
    if (fromNewHandle != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'newHandle'
    ], fromNewHandle);
    const fromResumable = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'resumable'
    ]);
    if (fromResumable != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'resumable'
    ], fromResumable);
    const fromLastConsumedClientMessageIndex = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'lastConsumedClientMessageIndex'
    ]);
    if (fromLastConsumedClientMessageIndex != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'lastConsumedClientMessageIndex'
    ], fromLastConsumedClientMessageIndex);
    return toObject;
}
function $e4deb49dba5321bc$var$liveServerMessageFromMldev(fromObject) {
    const toObject = {};
    const fromSetupComplete = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'setupComplete'
    ]);
    if (fromSetupComplete != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'setupComplete'
    ], $e4deb49dba5321bc$var$liveServerSetupCompleteFromMldev());
    const fromServerContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'serverContent'
    ]);
    if (fromServerContent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'serverContent'
    ], $e4deb49dba5321bc$var$liveServerContentFromMldev(fromServerContent));
    const fromToolCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolCall'
    ]);
    if (fromToolCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'toolCall'
    ], $e4deb49dba5321bc$var$liveServerToolCallFromMldev(fromToolCall));
    const fromToolCallCancellation = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolCallCancellation'
    ]);
    if (fromToolCallCancellation != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'toolCallCancellation'
    ], $e4deb49dba5321bc$var$liveServerToolCallCancellationFromMldev(fromToolCallCancellation));
    const fromUsageMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'usageMetadata'
    ]);
    if (fromUsageMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'usageMetadata'
    ], $e4deb49dba5321bc$var$usageMetadataFromMldev(fromUsageMetadata));
    const fromGoAway = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'goAway'
    ]);
    if (fromGoAway != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'goAway'
    ], $e4deb49dba5321bc$var$liveServerGoAwayFromMldev(fromGoAway));
    const fromSessionResumptionUpdate = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sessionResumptionUpdate'
    ]);
    if (fromSessionResumptionUpdate != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sessionResumptionUpdate'
    ], $e4deb49dba5321bc$var$liveServerSessionResumptionUpdateFromMldev(fromSessionResumptionUpdate));
    return toObject;
}
function $e4deb49dba5321bc$var$liveMusicServerSetupCompleteFromMldev() {
    const toObject = {};
    return toObject;
}
function $e4deb49dba5321bc$var$weightedPromptFromMldev(fromObject) {
    const toObject = {};
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromWeight = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'weight'
    ]);
    if (fromWeight != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'weight'
    ], fromWeight);
    return toObject;
}
function $e4deb49dba5321bc$var$liveMusicClientContentFromMldev(fromObject) {
    const toObject = {};
    const fromWeightedPrompts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'weightedPrompts'
    ]);
    if (fromWeightedPrompts != null) {
        let transformedList = fromWeightedPrompts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$weightedPromptFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'weightedPrompts'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$liveMusicGenerationConfigFromMldev(fromObject) {
    const toObject = {};
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'temperature'
    ], fromTemperature);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topK'
    ], fromTopK);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'seed'
    ], fromSeed);
    const fromGuidance = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'guidance'
    ]);
    if (fromGuidance != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'guidance'
    ], fromGuidance);
    const fromBpm = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bpm'
    ]);
    if (fromBpm != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'bpm'
    ], fromBpm);
    const fromDensity = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'density'
    ]);
    if (fromDensity != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'density'
    ], fromDensity);
    const fromBrightness = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'brightness'
    ]);
    if (fromBrightness != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'brightness'
    ], fromBrightness);
    const fromScale = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'scale'
    ]);
    if (fromScale != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'scale'
    ], fromScale);
    const fromMuteBass = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'muteBass'
    ]);
    if (fromMuteBass != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'muteBass'
    ], fromMuteBass);
    const fromMuteDrums = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'muteDrums'
    ]);
    if (fromMuteDrums != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'muteDrums'
    ], fromMuteDrums);
    const fromOnlyBassAndDrums = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'onlyBassAndDrums'
    ]);
    if (fromOnlyBassAndDrums != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'onlyBassAndDrums'
    ], fromOnlyBassAndDrums);
    const fromMusicGenerationMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'musicGenerationMode'
    ]);
    if (fromMusicGenerationMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'musicGenerationMode'
    ], fromMusicGenerationMode);
    return toObject;
}
function $e4deb49dba5321bc$var$liveMusicSourceMetadataFromMldev(fromObject) {
    const toObject = {};
    const fromClientContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'clientContent'
    ]);
    if (fromClientContent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'clientContent'
    ], $e4deb49dba5321bc$var$liveMusicClientContentFromMldev(fromClientContent));
    const fromMusicGenerationConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'musicGenerationConfig'
    ]);
    if (fromMusicGenerationConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'musicGenerationConfig'
    ], $e4deb49dba5321bc$var$liveMusicGenerationConfigFromMldev(fromMusicGenerationConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$audioChunkFromMldev(fromObject) {
    const toObject = {};
    const fromData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    const fromSourceMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sourceMetadata'
    ]);
    if (fromSourceMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sourceMetadata'
    ], $e4deb49dba5321bc$var$liveMusicSourceMetadataFromMldev(fromSourceMetadata));
    return toObject;
}
function $e4deb49dba5321bc$var$liveMusicServerContentFromMldev(fromObject) {
    const toObject = {};
    const fromAudioChunks = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audioChunks'
    ]);
    if (fromAudioChunks != null) {
        let transformedList = fromAudioChunks;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$audioChunkFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'audioChunks'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$liveMusicFilteredPromptFromMldev(fromObject) {
    const toObject = {};
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromFilteredReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'filteredReason'
    ]);
    if (fromFilteredReason != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'filteredReason'
    ], fromFilteredReason);
    return toObject;
}
function $e4deb49dba5321bc$var$liveMusicServerMessageFromMldev(fromObject) {
    const toObject = {};
    const fromSetupComplete = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'setupComplete'
    ]);
    if (fromSetupComplete != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'setupComplete'
    ], $e4deb49dba5321bc$var$liveMusicServerSetupCompleteFromMldev());
    const fromServerContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'serverContent'
    ]);
    if (fromServerContent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'serverContent'
    ], $e4deb49dba5321bc$var$liveMusicServerContentFromMldev(fromServerContent));
    const fromFilteredPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'filteredPrompt'
    ]);
    if (fromFilteredPrompt != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'filteredPrompt'
    ], $e4deb49dba5321bc$var$liveMusicFilteredPromptFromMldev(fromFilteredPrompt));
    return toObject;
}
function $e4deb49dba5321bc$var$liveServerSetupCompleteFromVertex(fromObject) {
    const toObject = {};
    const fromSessionId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sessionId'
    ]);
    if (fromSessionId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sessionId'
    ], fromSessionId);
    return toObject;
}
function $e4deb49dba5321bc$var$videoMetadataFromVertex$1(fromObject) {
    const toObject = {};
    const fromFps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fps'
    ]);
    if (fromFps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fps'
    ], fromFps);
    const fromEndOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endOffset'
    ]);
    if (fromEndOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endOffset'
    ], fromEndOffset);
    const fromStartOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startOffset'
    ]);
    if (fromStartOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startOffset'
    ], fromStartOffset);
    return toObject;
}
function $e4deb49dba5321bc$var$blobFromVertex$1(fromObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$fileDataFromVertex$1(fromObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromFileUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallFromVertex$1(fromObject) {
    const toObject = {};
    const fromId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'id'
    ]);
    if (fromId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'id'
    ], fromId);
    const fromArgs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$partFromVertex$1(fromObject) {
    const toObject = {};
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], $e4deb49dba5321bc$var$videoMetadataFromVertex$1(fromVideoMetadata));
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], $e4deb49dba5321bc$var$blobFromVertex$1(fromInlineData));
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], $e4deb49dba5321bc$var$fileDataFromVertex$1(fromFileData));
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], $e4deb49dba5321bc$var$functionCallFromVertex$1(fromFunctionCall));
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    return toObject;
}
function $e4deb49dba5321bc$var$contentFromVertex$1(fromObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partFromVertex$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$transcriptionFromVertex(fromObject) {
    const toObject = {};
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromFinished = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'finished'
    ]);
    if (fromFinished != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'finished'
    ], fromFinished);
    return toObject;
}
function $e4deb49dba5321bc$var$liveServerContentFromVertex(fromObject) {
    const toObject = {};
    const fromModelTurn = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelTurn'
    ]);
    if (fromModelTurn != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'modelTurn'
    ], $e4deb49dba5321bc$var$contentFromVertex$1(fromModelTurn));
    const fromTurnComplete = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'turnComplete'
    ]);
    if (fromTurnComplete != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'turnComplete'
    ], fromTurnComplete);
    const fromInterrupted = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'interrupted'
    ]);
    if (fromInterrupted != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'interrupted'
    ], fromInterrupted);
    const fromGroundingMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'groundingMetadata'
    ]);
    if (fromGroundingMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'groundingMetadata'
    ], fromGroundingMetadata);
    const fromGenerationComplete = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generationComplete'
    ]);
    if (fromGenerationComplete != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'generationComplete'
    ], fromGenerationComplete);
    const fromInputTranscription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inputTranscription'
    ]);
    if (fromInputTranscription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inputTranscription'
    ], $e4deb49dba5321bc$var$transcriptionFromVertex(fromInputTranscription));
    const fromOutputTranscription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputTranscription'
    ]);
    if (fromOutputTranscription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'outputTranscription'
    ], $e4deb49dba5321bc$var$transcriptionFromVertex(fromOutputTranscription));
    const fromTurnCompleteReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'turnCompleteReason'
    ]);
    if (fromTurnCompleteReason != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'turnCompleteReason'
    ], fromTurnCompleteReason);
    const fromWaitingForInput = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'waitingForInput'
    ]);
    if (fromWaitingForInput != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'waitingForInput'
    ], fromWaitingForInput);
    return toObject;
}
function $e4deb49dba5321bc$var$liveServerToolCallFromVertex(fromObject) {
    const toObject = {};
    const fromFunctionCalls = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCalls'
    ]);
    if (fromFunctionCalls != null) {
        let transformedList = fromFunctionCalls;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$functionCallFromVertex$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionCalls'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$liveServerToolCallCancellationFromVertex(fromObject) {
    const toObject = {};
    const fromIds = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'ids'
    ]);
    if (fromIds != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'ids'
    ], fromIds);
    return toObject;
}
function $e4deb49dba5321bc$var$modalityTokenCountFromVertex(fromObject) {
    const toObject = {};
    const fromModality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modality'
    ]);
    if (fromModality != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'modality'
    ], fromModality);
    const fromTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tokenCount'
    ]);
    if (fromTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tokenCount'
    ], fromTokenCount);
    return toObject;
}
function $e4deb49dba5321bc$var$usageMetadataFromVertex(fromObject) {
    const toObject = {};
    const fromPromptTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'promptTokenCount'
    ]);
    if (fromPromptTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'promptTokenCount'
    ], fromPromptTokenCount);
    const fromCachedContentTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cachedContentTokenCount'
    ]);
    if (fromCachedContentTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'cachedContentTokenCount'
    ], fromCachedContentTokenCount);
    const fromResponseTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidatesTokenCount'
    ]);
    if (fromResponseTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseTokenCount'
    ], fromResponseTokenCount);
    const fromToolUsePromptTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolUsePromptTokenCount'
    ]);
    if (fromToolUsePromptTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'toolUsePromptTokenCount'
    ], fromToolUsePromptTokenCount);
    const fromThoughtsTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtsTokenCount'
    ]);
    if (fromThoughtsTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtsTokenCount'
    ], fromThoughtsTokenCount);
    const fromTotalTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'totalTokenCount'
    ]);
    if (fromTotalTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'totalTokenCount'
    ], fromTotalTokenCount);
    const fromPromptTokensDetails = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'promptTokensDetails'
    ]);
    if (fromPromptTokensDetails != null) {
        let transformedList = fromPromptTokensDetails;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$modalityTokenCountFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'promptTokensDetails'
        ], transformedList);
    }
    const fromCacheTokensDetails = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cacheTokensDetails'
    ]);
    if (fromCacheTokensDetails != null) {
        let transformedList = fromCacheTokensDetails;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$modalityTokenCountFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'cacheTokensDetails'
        ], transformedList);
    }
    const fromResponseTokensDetails = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidatesTokensDetails'
    ]);
    if (fromResponseTokensDetails != null) {
        let transformedList = fromResponseTokensDetails;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$modalityTokenCountFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'responseTokensDetails'
        ], transformedList);
    }
    const fromToolUsePromptTokensDetails = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolUsePromptTokensDetails'
    ]);
    if (fromToolUsePromptTokensDetails != null) {
        let transformedList = fromToolUsePromptTokensDetails;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$modalityTokenCountFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'toolUsePromptTokensDetails'
        ], transformedList);
    }
    const fromTrafficType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'trafficType'
    ]);
    if (fromTrafficType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'trafficType'
    ], fromTrafficType);
    return toObject;
}
function $e4deb49dba5321bc$var$liveServerGoAwayFromVertex(fromObject) {
    const toObject = {};
    const fromTimeLeft = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'timeLeft'
    ]);
    if (fromTimeLeft != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'timeLeft'
    ], fromTimeLeft);
    return toObject;
}
function $e4deb49dba5321bc$var$liveServerSessionResumptionUpdateFromVertex(fromObject) {
    const toObject = {};
    const fromNewHandle = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'newHandle'
    ]);
    if (fromNewHandle != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'newHandle'
    ], fromNewHandle);
    const fromResumable = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'resumable'
    ]);
    if (fromResumable != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'resumable'
    ], fromResumable);
    const fromLastConsumedClientMessageIndex = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'lastConsumedClientMessageIndex'
    ]);
    if (fromLastConsumedClientMessageIndex != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'lastConsumedClientMessageIndex'
    ], fromLastConsumedClientMessageIndex);
    return toObject;
}
function $e4deb49dba5321bc$var$liveServerMessageFromVertex(fromObject) {
    const toObject = {};
    const fromSetupComplete = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'setupComplete'
    ]);
    if (fromSetupComplete != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'setupComplete'
    ], $e4deb49dba5321bc$var$liveServerSetupCompleteFromVertex(fromSetupComplete));
    const fromServerContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'serverContent'
    ]);
    if (fromServerContent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'serverContent'
    ], $e4deb49dba5321bc$var$liveServerContentFromVertex(fromServerContent));
    const fromToolCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolCall'
    ]);
    if (fromToolCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'toolCall'
    ], $e4deb49dba5321bc$var$liveServerToolCallFromVertex(fromToolCall));
    const fromToolCallCancellation = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolCallCancellation'
    ]);
    if (fromToolCallCancellation != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'toolCallCancellation'
    ], $e4deb49dba5321bc$var$liveServerToolCallCancellationFromVertex(fromToolCallCancellation));
    const fromUsageMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'usageMetadata'
    ]);
    if (fromUsageMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'usageMetadata'
    ], $e4deb49dba5321bc$var$usageMetadataFromVertex(fromUsageMetadata));
    const fromGoAway = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'goAway'
    ]);
    if (fromGoAway != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'goAway'
    ], $e4deb49dba5321bc$var$liveServerGoAwayFromVertex(fromGoAway));
    const fromSessionResumptionUpdate = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sessionResumptionUpdate'
    ]);
    if (fromSessionResumptionUpdate != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sessionResumptionUpdate'
    ], $e4deb49dba5321bc$var$liveServerSessionResumptionUpdateFromVertex(fromSessionResumptionUpdate));
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$videoMetadataToMldev$1(fromObject) {
    const toObject = {};
    const fromFps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fps'
    ]);
    if (fromFps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fps'
    ], fromFps);
    const fromEndOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endOffset'
    ]);
    if (fromEndOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endOffset'
    ], fromEndOffset);
    const fromStartOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startOffset'
    ]);
    if (fromStartOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startOffset'
    ], fromStartOffset);
    return toObject;
}
function $e4deb49dba5321bc$var$blobToMldev$1(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$fileDataToMldev$1(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromFileUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallToMldev$1(fromObject) {
    const toObject = {};
    const fromId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'id'
    ]);
    if (fromId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'id'
    ], fromId);
    const fromArgs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$partToMldev$1(fromObject) {
    const toObject = {};
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], $e4deb49dba5321bc$var$videoMetadataToMldev$1(fromVideoMetadata));
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], $e4deb49dba5321bc$var$blobToMldev$1(fromInlineData));
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], $e4deb49dba5321bc$var$fileDataToMldev$1(fromFileData));
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], $e4deb49dba5321bc$var$functionCallToMldev$1(fromFunctionCall));
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    return toObject;
}
function $e4deb49dba5321bc$var$contentToMldev$1(fromObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partToMldev$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$schemaToMldev(fromObject) {
    const toObject = {};
    const fromAnyOf = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'anyOf'
    ]);
    if (fromAnyOf != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'anyOf'
    ], fromAnyOf);
    const fromDefault = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'default'
    ]);
    if (fromDefault != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'default'
    ], fromDefault);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromEnum = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enum'
    ]);
    if (fromEnum != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enum'
    ], fromEnum);
    const fromExample = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'example'
    ]);
    if (fromExample != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'example'
    ], fromExample);
    const fromFormat = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'format'
    ]);
    if (fromFormat != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'format'
    ], fromFormat);
    const fromItems = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'items'
    ]);
    if (fromItems != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'items'
    ], fromItems);
    const fromMaxItems = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxItems'
    ]);
    if (fromMaxItems != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maxItems'
    ], fromMaxItems);
    const fromMaxLength = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxLength'
    ]);
    if (fromMaxLength != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maxLength'
    ], fromMaxLength);
    const fromMaxProperties = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxProperties'
    ]);
    if (fromMaxProperties != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maxProperties'
    ], fromMaxProperties);
    const fromMaximum = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maximum'
    ]);
    if (fromMaximum != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maximum'
    ], fromMaximum);
    const fromMinItems = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'minItems'
    ]);
    if (fromMinItems != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'minItems'
    ], fromMinItems);
    const fromMinLength = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'minLength'
    ]);
    if (fromMinLength != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'minLength'
    ], fromMinLength);
    const fromMinProperties = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'minProperties'
    ]);
    if (fromMinProperties != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'minProperties'
    ], fromMinProperties);
    const fromMinimum = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'minimum'
    ]);
    if (fromMinimum != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'minimum'
    ], fromMinimum);
    const fromNullable = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nullable'
    ]);
    if (fromNullable != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nullable'
    ], fromNullable);
    const fromPattern = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pattern'
    ]);
    if (fromPattern != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'pattern'
    ], fromPattern);
    const fromProperties = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'properties'
    ]);
    if (fromProperties != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'properties'
    ], fromProperties);
    const fromPropertyOrdering = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'propertyOrdering'
    ]);
    if (fromPropertyOrdering != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'propertyOrdering'
    ], fromPropertyOrdering);
    const fromRequired = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'required'
    ]);
    if (fromRequired != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'required'
    ], fromRequired);
    const fromTitle = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'title'
    ]);
    if (fromTitle != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'title'
    ], fromTitle);
    const fromType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'type'
    ]);
    if (fromType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'type'
    ], fromType);
    return toObject;
}
function $e4deb49dba5321bc$var$safetySettingToMldev(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'method'
    ]) !== undefined) throw new Error('method parameter is not supported in Gemini API.');
    const fromCategory = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'category'
    ]);
    if (fromCategory != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'category'
    ], fromCategory);
    const fromThreshold = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'threshold'
    ]);
    if (fromThreshold != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'threshold'
    ], fromThreshold);
    return toObject;
}
function $e4deb49dba5321bc$var$functionDeclarationToMldev$1(fromObject) {
    const toObject = {};
    const fromBehavior = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'behavior'
    ]);
    if (fromBehavior != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'behavior'
    ], fromBehavior);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromParameters = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parameters'
    ]);
    if (fromParameters != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parameters'
    ], fromParameters);
    const fromParametersJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parametersJsonSchema'
    ]);
    if (fromParametersJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parametersJsonSchema'
    ], fromParametersJsonSchema);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], fromResponse);
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    return toObject;
}
function $e4deb49dba5321bc$var$intervalToMldev$1(fromObject) {
    const toObject = {};
    const fromStartTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startTime'
    ]);
    if (fromStartTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endTime'
    ]);
    if (fromEndTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchToMldev$1(fromObject) {
    const toObject = {};
    const fromTimeRangeFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'timeRangeFilter'
    ], $e4deb49dba5321bc$var$intervalToMldev$1(fromTimeRangeFilter));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'excludeDomains'
    ]) !== undefined) throw new Error('excludeDomains parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$dynamicRetrievalConfigToMldev$1(fromObject) {
    const toObject = {};
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mode'
    ], fromMode);
    const fromDynamicThreshold = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'dynamicThreshold'
    ]);
    if (fromDynamicThreshold != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dynamicThreshold'
    ], fromDynamicThreshold);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchRetrievalToMldev$1(fromObject) {
    const toObject = {};
    const fromDynamicRetrievalConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'dynamicRetrievalConfig'
    ]);
    if (fromDynamicRetrievalConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dynamicRetrievalConfig'
    ], $e4deb49dba5321bc$var$dynamicRetrievalConfigToMldev$1(fromDynamicRetrievalConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$urlContextToMldev$1() {
    const toObject = {};
    return toObject;
}
function $e4deb49dba5321bc$var$toolComputerUseToMldev$1(fromObject) {
    const toObject = {};
    const fromEnvironment = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'environment'
    ]);
    if (fromEnvironment != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'environment'
    ], fromEnvironment);
    return toObject;
}
function $e4deb49dba5321bc$var$toolToMldev$1(fromObject) {
    const toObject = {};
    const fromFunctionDeclarations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$functionDeclarationToMldev$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrieval'
    ]) !== undefined) throw new Error('retrieval parameter is not supported in Gemini API.');
    const fromGoogleSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearch'
    ], $e4deb49dba5321bc$var$googleSearchToMldev$1(fromGoogleSearch));
    const fromGoogleSearchRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], $e4deb49dba5321bc$var$googleSearchRetrievalToMldev$1(fromGoogleSearchRetrieval));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]) !== undefined) throw new Error('enterpriseWebSearch parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleMaps'
    ]) !== undefined) throw new Error('googleMaps parameter is not supported in Gemini API.');
    const fromUrlContext = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContext'
    ], $e4deb49dba5321bc$var$urlContextToMldev$1());
    const fromComputerUse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'computerUse'
    ]);
    if (fromComputerUse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computerUse'
    ], $e4deb49dba5321bc$var$toolComputerUseToMldev$1(fromComputerUse));
    const fromCodeExecution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallingConfigToMldev(fromObject) {
    const toObject = {};
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mode'
    ], fromMode);
    const fromAllowedFunctionNames = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'allowedFunctionNames'
    ]);
    if (fromAllowedFunctionNames != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'allowedFunctionNames'
    ], fromAllowedFunctionNames);
    return toObject;
}
function $e4deb49dba5321bc$var$latLngToMldev(fromObject) {
    const toObject = {};
    const fromLatitude = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'latitude'
    ]);
    if (fromLatitude != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'latitude'
    ], fromLatitude);
    const fromLongitude = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'longitude'
    ]);
    if (fromLongitude != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'longitude'
    ], fromLongitude);
    return toObject;
}
function $e4deb49dba5321bc$var$retrievalConfigToMldev(fromObject) {
    const toObject = {};
    const fromLatLng = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'latLng'
    ]);
    if (fromLatLng != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'latLng'
    ], $e4deb49dba5321bc$var$latLngToMldev(fromLatLng));
    const fromLanguageCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'languageCode'
    ]);
    if (fromLanguageCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'languageCode'
    ], fromLanguageCode);
    return toObject;
}
function $e4deb49dba5321bc$var$toolConfigToMldev(fromObject) {
    const toObject = {};
    const fromFunctionCallingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCallingConfig'
    ]);
    if (fromFunctionCallingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCallingConfig'
    ], $e4deb49dba5321bc$var$functionCallingConfigToMldev(fromFunctionCallingConfig));
    const fromRetrievalConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrievalConfig'
    ]);
    if (fromRetrievalConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrievalConfig'
    ], $e4deb49dba5321bc$var$retrievalConfigToMldev(fromRetrievalConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$prebuiltVoiceConfigToMldev$1(fromObject) {
    const toObject = {};
    const fromVoiceName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceName'
    ]);
    if (fromVoiceName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceName'
    ], fromVoiceName);
    return toObject;
}
function $e4deb49dba5321bc$var$voiceConfigToMldev$1(fromObject) {
    const toObject = {};
    const fromPrebuiltVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prebuiltVoiceConfig'
    ]);
    if (fromPrebuiltVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'prebuiltVoiceConfig'
    ], $e4deb49dba5321bc$var$prebuiltVoiceConfigToMldev$1(fromPrebuiltVoiceConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$speakerVoiceConfigToMldev$1(fromObject) {
    const toObject = {};
    const fromSpeaker = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speaker'
    ]);
    if (fromSpeaker != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'speaker'
    ], fromSpeaker);
    const fromVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceConfig'
    ]);
    if (fromVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceConfig'
    ], $e4deb49dba5321bc$var$voiceConfigToMldev$1(fromVoiceConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$multiSpeakerVoiceConfigToMldev$1(fromObject) {
    const toObject = {};
    const fromSpeakerVoiceConfigs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speakerVoiceConfigs'
    ]);
    if (fromSpeakerVoiceConfigs != null) {
        let transformedList = fromSpeakerVoiceConfigs;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$speakerVoiceConfigToMldev$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'speakerVoiceConfigs'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$speechConfigToMldev$1(fromObject) {
    const toObject = {};
    const fromVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceConfig'
    ]);
    if (fromVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceConfig'
    ], $e4deb49dba5321bc$var$voiceConfigToMldev$1(fromVoiceConfig));
    const fromMultiSpeakerVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'multiSpeakerVoiceConfig'
    ]);
    if (fromMultiSpeakerVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'multiSpeakerVoiceConfig'
    ], $e4deb49dba5321bc$var$multiSpeakerVoiceConfigToMldev$1(fromMultiSpeakerVoiceConfig));
    const fromLanguageCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'languageCode'
    ]);
    if (fromLanguageCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'languageCode'
    ], fromLanguageCode);
    return toObject;
}
function $e4deb49dba5321bc$var$thinkingConfigToMldev(fromObject) {
    const toObject = {};
    const fromIncludeThoughts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeThoughts'
    ]);
    if (fromIncludeThoughts != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'includeThoughts'
    ], fromIncludeThoughts);
    const fromThinkingBudget = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thinkingBudget'
    ]);
    if (fromThinkingBudget != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thinkingBudget'
    ], fromThinkingBudget);
    return toObject;
}
function $e4deb49dba5321bc$var$generateContentConfigToMldev(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'systemInstruction'
    ], $e4deb49dba5321bc$var$contentToMldev$1($e4deb49dba5321bc$var$tContent(fromSystemInstruction)));
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'temperature'
    ], fromTemperature);
    const fromTopP = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topP'
    ]);
    if (fromTopP != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topP'
    ], fromTopP);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topK'
    ], fromTopK);
    const fromCandidateCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidateCount'
    ]);
    if (fromCandidateCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'candidateCount'
    ], fromCandidateCount);
    const fromMaxOutputTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (fromMaxOutputTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromStopSequences = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'stopSequences'
    ]);
    if (fromStopSequences != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'stopSequences'
    ], fromStopSequences);
    const fromResponseLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseLogprobs'
    ]);
    if (fromResponseLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseLogprobs'
    ], fromResponseLogprobs);
    const fromLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'logprobs'
    ]);
    if (fromLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'logprobs'
    ], fromLogprobs);
    const fromPresencePenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'presencePenalty'
    ]);
    if (fromPresencePenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'presencePenalty'
    ], fromPresencePenalty);
    const fromFrequencyPenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'frequencyPenalty'
    ]);
    if (fromFrequencyPenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'frequencyPenalty'
    ], fromFrequencyPenalty);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'seed'
    ], fromSeed);
    const fromResponseMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseMimeType'
    ]);
    if (fromResponseMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseMimeType'
    ], fromResponseMimeType);
    const fromResponseSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseSchema'
    ]);
    if (fromResponseSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseSchema'
    ], $e4deb49dba5321bc$var$schemaToMldev($e4deb49dba5321bc$var$tSchema(fromResponseSchema)));
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'routingConfig'
    ]) !== undefined) throw new Error('routingConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelSelectionConfig'
    ]) !== undefined) throw new Error('modelSelectionConfig parameter is not supported in Gemini API.');
    const fromSafetySettings = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetySettings'
    ]);
    if (parentObject !== undefined && fromSafetySettings != null) {
        let transformedList = fromSafetySettings;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$safetySettingToMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'safetySettings'
        ], transformedList);
    }
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = $e4deb49dba5321bc$var$tTools(fromTools);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToMldev$1($e4deb49dba5321bc$var$tTool(item));
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'tools'
        ], transformedList);
    }
    const fromToolConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolConfig'
    ]);
    if (parentObject !== undefined && fromToolConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'toolConfig'
    ], $e4deb49dba5321bc$var$toolConfigToMldev(fromToolConfig));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]) !== undefined) throw new Error('labels parameter is not supported in Gemini API.');
    const fromCachedContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cachedContent'
    ]);
    if (parentObject !== undefined && fromCachedContent != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'cachedContent'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromCachedContent));
    const fromResponseModalities = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (fromResponseModalities != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseModalities'
    ], fromResponseModalities);
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromSpeechConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (fromSpeechConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'speechConfig'
    ], $e4deb49dba5321bc$var$speechConfigToMldev$1($e4deb49dba5321bc$var$tSpeechConfig(fromSpeechConfig)));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audioTimestamp'
    ]) !== undefined) throw new Error('audioTimestamp parameter is not supported in Gemini API.');
    const fromThinkingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thinkingConfig'
    ]);
    if (fromThinkingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thinkingConfig'
    ], $e4deb49dba5321bc$var$thinkingConfigToMldev(fromThinkingConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$generateContentParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContents(fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$contentToMldev$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'contents'
        ], transformedList);
    }
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'generationConfig'
    ], $e4deb49dba5321bc$var$generateContentConfigToMldev(apiClient, fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromTaskType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'taskType'
    ]);
    if (parentObject !== undefined && fromTaskType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'requests[]',
        'taskType'
    ], fromTaskType);
    const fromTitle = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'title'
    ]);
    if (parentObject !== undefined && fromTitle != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'requests[]',
        'title'
    ], fromTitle);
    const fromOutputDimensionality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputDimensionality'
    ]);
    if (parentObject !== undefined && fromOutputDimensionality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'requests[]',
        'outputDimensionality'
    ], fromOutputDimensionality);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]) !== undefined) throw new Error('mimeType parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'autoTruncate'
    ]) !== undefined) throw new Error('autoTruncate parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'requests[]',
        'content'
    ], $e4deb49dba5321bc$var$tContentsForEmbed(apiClient, fromContents));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$embedContentConfigToMldev(fromConfig, toObject));
    const fromModelForEmbedContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModelForEmbedContent !== undefined) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'requests[]',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModelForEmbedContent));
    return toObject;
}
function $e4deb49dba5321bc$var$generateImagesConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputGcsUri'
    ]) !== undefined) throw new Error('outputGcsUri parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'negativePrompt'
    ]) !== undefined) throw new Error('negativePrompt parameter is not supported in Gemini API.');
    const fromNumberOfImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'numberOfImages'
    ]);
    if (parentObject !== undefined && fromNumberOfImages != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfImages);
    const fromAspectRatio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (parentObject !== undefined && fromAspectRatio != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'aspectRatio'
    ], fromAspectRatio);
    const fromGuidanceScale = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'guidanceScale'
    ]);
    if (parentObject !== undefined && fromGuidanceScale != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'guidanceScale'
    ], fromGuidanceScale);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]) !== undefined) throw new Error('seed parameter is not supported in Gemini API.');
    const fromSafetyFilterLevel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyFilterLevel'
    ]);
    if (parentObject !== undefined && fromSafetyFilterLevel != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'safetySetting'
    ], fromSafetyFilterLevel);
    const fromPersonGeneration = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    const fromIncludeSafetyAttributes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeSafetyAttributes'
    ]);
    if (parentObject !== undefined && fromIncludeSafetyAttributes != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'includeSafetyAttributes'
    ], fromIncludeSafetyAttributes);
    const fromIncludeRaiReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeRaiReason'
    ]);
    if (parentObject !== undefined && fromIncludeRaiReason != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'includeRaiReason'
    ], fromIncludeRaiReason);
    const fromLanguage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'language'
    ]);
    if (parentObject !== undefined && fromLanguage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'language'
    ], fromLanguage);
    const fromOutputMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputMimeType'
    ]);
    if (parentObject !== undefined && fromOutputMimeType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'mimeType'
    ], fromOutputMimeType);
    const fromOutputCompressionQuality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]);
    if (parentObject !== undefined && fromOutputCompressionQuality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'compressionQuality'
    ], fromOutputCompressionQuality);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'addWatermark'
    ]) !== undefined) throw new Error('addWatermark parameter is not supported in Gemini API.');
    const fromImageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageSize'
    ]);
    if (parentObject !== undefined && fromImageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleImageSize'
    ], fromImageSize);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enhancePrompt'
    ]) !== undefined) throw new Error('enhancePrompt parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$generateImagesParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$generateImagesConfigToMldev(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$getModelParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$listModelsConfigToMldev(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    const fromFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'filter'
    ]);
    if (parentObject !== undefined && fromFilter != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'filter'
    ], fromFilter);
    const fromQueryBase = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'queryBase'
    ]);
    if (parentObject !== undefined && fromQueryBase != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_url',
        'models_url'
    ], $e4deb49dba5321bc$var$tModelsUrl(apiClient, fromQueryBase));
    return toObject;
}
function $e4deb49dba5321bc$var$listModelsParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$listModelsConfigToMldev(apiClient, fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$updateModelConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'displayName'
    ], fromDisplayName);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (parentObject !== undefined && fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'description'
    ], fromDescription);
    const fromDefaultCheckpointId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'defaultCheckpointId'
    ]);
    if (parentObject !== undefined && fromDefaultCheckpointId != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'defaultCheckpointId'
    ], fromDefaultCheckpointId);
    return toObject;
}
function $e4deb49dba5321bc$var$updateModelParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$updateModelConfigToMldev(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$deleteModelParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$countTokensConfigToMldev(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]) !== undefined) throw new Error('systemInstruction parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]) !== undefined) throw new Error('tools parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generationConfig'
    ]) !== undefined) throw new Error('generationConfig parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$countTokensParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContents(fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$contentToMldev$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'contents'
        ], transformedList);
    }
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$countTokensConfigToMldev(fromConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$imageToMldev(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]) !== undefined) throw new Error('gcsUri parameter is not supported in Gemini API.');
    const fromImageBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageBytes'
    ]);
    if (fromImageBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'bytesBase64Encoded'
    ], $e4deb49dba5321bc$var$tBytes(fromImageBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosSourceToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (parentObject !== undefined && fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (parentObject !== undefined && fromImage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'image'
    ], $e4deb49dba5321bc$var$imageToMldev(fromImage));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video'
    ]) !== undefined) throw new Error('video parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromNumberOfVideos = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'numberOfVideos'
    ]);
    if (parentObject !== undefined && fromNumberOfVideos != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfVideos);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputGcsUri'
    ]) !== undefined) throw new Error('outputGcsUri parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fps'
    ]) !== undefined) throw new Error('fps parameter is not supported in Gemini API.');
    const fromDurationSeconds = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'durationSeconds'
    ]);
    if (parentObject !== undefined && fromDurationSeconds != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'durationSeconds'
    ], fromDurationSeconds);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]) !== undefined) throw new Error('seed parameter is not supported in Gemini API.');
    const fromAspectRatio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (parentObject !== undefined && fromAspectRatio != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'aspectRatio'
    ], fromAspectRatio);
    const fromResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'resolution'
    ]);
    if (parentObject !== undefined && fromResolution != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'resolution'
    ], fromResolution);
    const fromPersonGeneration = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pubsubTopic'
    ]) !== undefined) throw new Error('pubsubTopic parameter is not supported in Gemini API.');
    const fromNegativePrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'negativePrompt'
    ]);
    if (parentObject !== undefined && fromNegativePrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'negativePrompt'
    ], fromNegativePrompt);
    const fromEnhancePrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enhancePrompt'
    ]);
    if (parentObject !== undefined && fromEnhancePrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'enhancePrompt'
    ], fromEnhancePrompt);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generateAudio'
    ]) !== undefined) throw new Error('generateAudio parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'lastFrame'
    ]) !== undefined) throw new Error('lastFrame parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'referenceImages'
    ]) !== undefined) throw new Error('referenceImages parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mask'
    ]) !== undefined) throw new Error('mask parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'compressionQuality'
    ]) !== undefined) throw new Error('compressionQuality parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'image'
    ], $e4deb49dba5321bc$var$imageToMldev(fromImage));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video'
    ]) !== undefined) throw new Error('video parameter is not supported in Gemini API.');
    const fromSource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'source'
    ]);
    if (fromSource != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$generateVideosSourceToMldev(fromSource, toObject));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$generateVideosConfigToMldev(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$videoMetadataToVertex(fromObject) {
    const toObject = {};
    const fromFps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fps'
    ]);
    if (fromFps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fps'
    ], fromFps);
    const fromEndOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endOffset'
    ]);
    if (fromEndOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endOffset'
    ], fromEndOffset);
    const fromStartOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startOffset'
    ]);
    if (fromStartOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startOffset'
    ], fromStartOffset);
    return toObject;
}
function $e4deb49dba5321bc$var$blobToVertex(fromObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$fileDataToVertex(fromObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromFileUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallToVertex(fromObject) {
    const toObject = {};
    const fromId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'id'
    ]);
    if (fromId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'id'
    ], fromId);
    const fromArgs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$partToVertex(fromObject) {
    const toObject = {};
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], $e4deb49dba5321bc$var$videoMetadataToVertex(fromVideoMetadata));
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], $e4deb49dba5321bc$var$blobToVertex(fromInlineData));
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], $e4deb49dba5321bc$var$fileDataToVertex(fromFileData));
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], $e4deb49dba5321bc$var$functionCallToVertex(fromFunctionCall));
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    return toObject;
}
function $e4deb49dba5321bc$var$contentToVertex(fromObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$schemaToVertex(fromObject) {
    const toObject = {};
    const fromAnyOf = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'anyOf'
    ]);
    if (fromAnyOf != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'anyOf'
    ], fromAnyOf);
    const fromDefault = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'default'
    ]);
    if (fromDefault != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'default'
    ], fromDefault);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromEnum = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enum'
    ]);
    if (fromEnum != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enum'
    ], fromEnum);
    const fromExample = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'example'
    ]);
    if (fromExample != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'example'
    ], fromExample);
    const fromFormat = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'format'
    ]);
    if (fromFormat != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'format'
    ], fromFormat);
    const fromItems = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'items'
    ]);
    if (fromItems != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'items'
    ], fromItems);
    const fromMaxItems = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxItems'
    ]);
    if (fromMaxItems != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maxItems'
    ], fromMaxItems);
    const fromMaxLength = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxLength'
    ]);
    if (fromMaxLength != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maxLength'
    ], fromMaxLength);
    const fromMaxProperties = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxProperties'
    ]);
    if (fromMaxProperties != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maxProperties'
    ], fromMaxProperties);
    const fromMaximum = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maximum'
    ]);
    if (fromMaximum != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maximum'
    ], fromMaximum);
    const fromMinItems = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'minItems'
    ]);
    if (fromMinItems != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'minItems'
    ], fromMinItems);
    const fromMinLength = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'minLength'
    ]);
    if (fromMinLength != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'minLength'
    ], fromMinLength);
    const fromMinProperties = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'minProperties'
    ]);
    if (fromMinProperties != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'minProperties'
    ], fromMinProperties);
    const fromMinimum = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'minimum'
    ]);
    if (fromMinimum != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'minimum'
    ], fromMinimum);
    const fromNullable = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nullable'
    ]);
    if (fromNullable != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nullable'
    ], fromNullable);
    const fromPattern = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pattern'
    ]);
    if (fromPattern != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'pattern'
    ], fromPattern);
    const fromProperties = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'properties'
    ]);
    if (fromProperties != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'properties'
    ], fromProperties);
    const fromPropertyOrdering = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'propertyOrdering'
    ]);
    if (fromPropertyOrdering != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'propertyOrdering'
    ], fromPropertyOrdering);
    const fromRequired = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'required'
    ]);
    if (fromRequired != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'required'
    ], fromRequired);
    const fromTitle = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'title'
    ]);
    if (fromTitle != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'title'
    ], fromTitle);
    const fromType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'type'
    ]);
    if (fromType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'type'
    ], fromType);
    return toObject;
}
function $e4deb49dba5321bc$var$modelSelectionConfigToVertex(fromObject) {
    const toObject = {};
    const fromFeatureSelectionPreference = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'featureSelectionPreference'
    ]);
    if (fromFeatureSelectionPreference != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'featureSelectionPreference'
    ], fromFeatureSelectionPreference);
    return toObject;
}
function $e4deb49dba5321bc$var$safetySettingToVertex(fromObject) {
    const toObject = {};
    const fromMethod = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'method'
    ]);
    if (fromMethod != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'method'
    ], fromMethod);
    const fromCategory = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'category'
    ]);
    if (fromCategory != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'category'
    ], fromCategory);
    const fromThreshold = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'threshold'
    ]);
    if (fromThreshold != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'threshold'
    ], fromThreshold);
    return toObject;
}
function $e4deb49dba5321bc$var$functionDeclarationToVertex(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'behavior'
    ]) !== undefined) throw new Error('behavior parameter is not supported in Vertex AI.');
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromParameters = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parameters'
    ]);
    if (fromParameters != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parameters'
    ], fromParameters);
    const fromParametersJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parametersJsonSchema'
    ]);
    if (fromParametersJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parametersJsonSchema'
    ], fromParametersJsonSchema);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], fromResponse);
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    return toObject;
}
function $e4deb49dba5321bc$var$intervalToVertex(fromObject) {
    const toObject = {};
    const fromStartTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startTime'
    ]);
    if (fromStartTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endTime'
    ]);
    if (fromEndTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchToVertex(fromObject) {
    const toObject = {};
    const fromTimeRangeFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'timeRangeFilter'
    ], $e4deb49dba5321bc$var$intervalToVertex(fromTimeRangeFilter));
    const fromExcludeDomains = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'excludeDomains'
    ]);
    if (fromExcludeDomains != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'excludeDomains'
    ], fromExcludeDomains);
    return toObject;
}
function $e4deb49dba5321bc$var$dynamicRetrievalConfigToVertex(fromObject) {
    const toObject = {};
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mode'
    ], fromMode);
    const fromDynamicThreshold = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'dynamicThreshold'
    ]);
    if (fromDynamicThreshold != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dynamicThreshold'
    ], fromDynamicThreshold);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchRetrievalToVertex(fromObject) {
    const toObject = {};
    const fromDynamicRetrievalConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'dynamicRetrievalConfig'
    ]);
    if (fromDynamicRetrievalConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dynamicRetrievalConfig'
    ], $e4deb49dba5321bc$var$dynamicRetrievalConfigToVertex(fromDynamicRetrievalConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$enterpriseWebSearchToVertex(fromObject) {
    const toObject = {};
    const fromExcludeDomains = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'excludeDomains'
    ]);
    if (fromExcludeDomains != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'excludeDomains'
    ], fromExcludeDomains);
    return toObject;
}
function $e4deb49dba5321bc$var$apiKeyConfigToVertex(fromObject) {
    const toObject = {};
    const fromApiKeyString = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'apiKeyString'
    ]);
    if (fromApiKeyString != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'apiKeyString'
    ], fromApiKeyString);
    return toObject;
}
function $e4deb49dba5321bc$var$authConfigToVertex(fromObject) {
    const toObject = {};
    const fromApiKeyConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'apiKeyConfig'
    ]);
    if (fromApiKeyConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'apiKeyConfig'
    ], $e4deb49dba5321bc$var$apiKeyConfigToVertex(fromApiKeyConfig));
    const fromAuthType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'authType'
    ]);
    if (fromAuthType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'authType'
    ], fromAuthType);
    const fromGoogleServiceAccountConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleServiceAccountConfig'
    ]);
    if (fromGoogleServiceAccountConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleServiceAccountConfig'
    ], fromGoogleServiceAccountConfig);
    const fromHttpBasicAuthConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'httpBasicAuthConfig'
    ]);
    if (fromHttpBasicAuthConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'httpBasicAuthConfig'
    ], fromHttpBasicAuthConfig);
    const fromOauthConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'oauthConfig'
    ]);
    if (fromOauthConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'oauthConfig'
    ], fromOauthConfig);
    const fromOidcConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'oidcConfig'
    ]);
    if (fromOidcConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'oidcConfig'
    ], fromOidcConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$googleMapsToVertex(fromObject) {
    const toObject = {};
    const fromAuthConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'authConfig'
    ]);
    if (fromAuthConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'authConfig'
    ], $e4deb49dba5321bc$var$authConfigToVertex(fromAuthConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$urlContextToVertex() {
    const toObject = {};
    return toObject;
}
function $e4deb49dba5321bc$var$toolComputerUseToVertex(fromObject) {
    const toObject = {};
    const fromEnvironment = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'environment'
    ]);
    if (fromEnvironment != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'environment'
    ], fromEnvironment);
    return toObject;
}
function $e4deb49dba5321bc$var$toolToVertex(fromObject) {
    const toObject = {};
    const fromFunctionDeclarations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$functionDeclarationToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    const fromRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrieval'
    ]);
    if (fromRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrieval'
    ], fromRetrieval);
    const fromGoogleSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearch'
    ], $e4deb49dba5321bc$var$googleSearchToVertex(fromGoogleSearch));
    const fromGoogleSearchRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], $e4deb49dba5321bc$var$googleSearchRetrievalToVertex(fromGoogleSearchRetrieval));
    const fromEnterpriseWebSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]);
    if (fromEnterpriseWebSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enterpriseWebSearch'
    ], $e4deb49dba5321bc$var$enterpriseWebSearchToVertex(fromEnterpriseWebSearch));
    const fromGoogleMaps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleMaps'
    ]);
    if (fromGoogleMaps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleMaps'
    ], $e4deb49dba5321bc$var$googleMapsToVertex(fromGoogleMaps));
    const fromUrlContext = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContext'
    ], $e4deb49dba5321bc$var$urlContextToVertex());
    const fromComputerUse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'computerUse'
    ]);
    if (fromComputerUse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computerUse'
    ], $e4deb49dba5321bc$var$toolComputerUseToVertex(fromComputerUse));
    const fromCodeExecution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallingConfigToVertex(fromObject) {
    const toObject = {};
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mode'
    ], fromMode);
    const fromAllowedFunctionNames = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'allowedFunctionNames'
    ]);
    if (fromAllowedFunctionNames != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'allowedFunctionNames'
    ], fromAllowedFunctionNames);
    return toObject;
}
function $e4deb49dba5321bc$var$latLngToVertex(fromObject) {
    const toObject = {};
    const fromLatitude = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'latitude'
    ]);
    if (fromLatitude != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'latitude'
    ], fromLatitude);
    const fromLongitude = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'longitude'
    ]);
    if (fromLongitude != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'longitude'
    ], fromLongitude);
    return toObject;
}
function $e4deb49dba5321bc$var$retrievalConfigToVertex(fromObject) {
    const toObject = {};
    const fromLatLng = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'latLng'
    ]);
    if (fromLatLng != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'latLng'
    ], $e4deb49dba5321bc$var$latLngToVertex(fromLatLng));
    const fromLanguageCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'languageCode'
    ]);
    if (fromLanguageCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'languageCode'
    ], fromLanguageCode);
    return toObject;
}
function $e4deb49dba5321bc$var$toolConfigToVertex(fromObject) {
    const toObject = {};
    const fromFunctionCallingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCallingConfig'
    ]);
    if (fromFunctionCallingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCallingConfig'
    ], $e4deb49dba5321bc$var$functionCallingConfigToVertex(fromFunctionCallingConfig));
    const fromRetrievalConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrievalConfig'
    ]);
    if (fromRetrievalConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrievalConfig'
    ], $e4deb49dba5321bc$var$retrievalConfigToVertex(fromRetrievalConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$prebuiltVoiceConfigToVertex(fromObject) {
    const toObject = {};
    const fromVoiceName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceName'
    ]);
    if (fromVoiceName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceName'
    ], fromVoiceName);
    return toObject;
}
function $e4deb49dba5321bc$var$voiceConfigToVertex(fromObject) {
    const toObject = {};
    const fromPrebuiltVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prebuiltVoiceConfig'
    ]);
    if (fromPrebuiltVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'prebuiltVoiceConfig'
    ], $e4deb49dba5321bc$var$prebuiltVoiceConfigToVertex(fromPrebuiltVoiceConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$speechConfigToVertex(fromObject) {
    const toObject = {};
    const fromVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceConfig'
    ]);
    if (fromVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceConfig'
    ], $e4deb49dba5321bc$var$voiceConfigToVertex(fromVoiceConfig));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'multiSpeakerVoiceConfig'
    ]) !== undefined) throw new Error('multiSpeakerVoiceConfig parameter is not supported in Vertex AI.');
    const fromLanguageCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'languageCode'
    ]);
    if (fromLanguageCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'languageCode'
    ], fromLanguageCode);
    return toObject;
}
function $e4deb49dba5321bc$var$thinkingConfigToVertex(fromObject) {
    const toObject = {};
    const fromIncludeThoughts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeThoughts'
    ]);
    if (fromIncludeThoughts != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'includeThoughts'
    ], fromIncludeThoughts);
    const fromThinkingBudget = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thinkingBudget'
    ]);
    if (fromThinkingBudget != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thinkingBudget'
    ], fromThinkingBudget);
    return toObject;
}
function $e4deb49dba5321bc$var$generateContentConfigToVertex(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'systemInstruction'
    ], $e4deb49dba5321bc$var$contentToVertex($e4deb49dba5321bc$var$tContent(fromSystemInstruction)));
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'temperature'
    ], fromTemperature);
    const fromTopP = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topP'
    ]);
    if (fromTopP != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topP'
    ], fromTopP);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topK'
    ], fromTopK);
    const fromCandidateCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidateCount'
    ]);
    if (fromCandidateCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'candidateCount'
    ], fromCandidateCount);
    const fromMaxOutputTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (fromMaxOutputTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromStopSequences = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'stopSequences'
    ]);
    if (fromStopSequences != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'stopSequences'
    ], fromStopSequences);
    const fromResponseLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseLogprobs'
    ]);
    if (fromResponseLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseLogprobs'
    ], fromResponseLogprobs);
    const fromLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'logprobs'
    ]);
    if (fromLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'logprobs'
    ], fromLogprobs);
    const fromPresencePenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'presencePenalty'
    ]);
    if (fromPresencePenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'presencePenalty'
    ], fromPresencePenalty);
    const fromFrequencyPenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'frequencyPenalty'
    ]);
    if (fromFrequencyPenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'frequencyPenalty'
    ], fromFrequencyPenalty);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'seed'
    ], fromSeed);
    const fromResponseMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseMimeType'
    ]);
    if (fromResponseMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseMimeType'
    ], fromResponseMimeType);
    const fromResponseSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseSchema'
    ]);
    if (fromResponseSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseSchema'
    ], $e4deb49dba5321bc$var$schemaToVertex($e4deb49dba5321bc$var$tSchema(fromResponseSchema)));
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    const fromRoutingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'routingConfig'
    ]);
    if (fromRoutingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'routingConfig'
    ], fromRoutingConfig);
    const fromModelSelectionConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelSelectionConfig'
    ]);
    if (fromModelSelectionConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'modelConfig'
    ], $e4deb49dba5321bc$var$modelSelectionConfigToVertex(fromModelSelectionConfig));
    const fromSafetySettings = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetySettings'
    ]);
    if (parentObject !== undefined && fromSafetySettings != null) {
        let transformedList = fromSafetySettings;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$safetySettingToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'safetySettings'
        ], transformedList);
    }
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = $e4deb49dba5321bc$var$tTools(fromTools);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToVertex($e4deb49dba5321bc$var$tTool(item));
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'tools'
        ], transformedList);
    }
    const fromToolConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolConfig'
    ]);
    if (parentObject !== undefined && fromToolConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'toolConfig'
    ], $e4deb49dba5321bc$var$toolConfigToVertex(fromToolConfig));
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (parentObject !== undefined && fromLabels != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'labels'
    ], fromLabels);
    const fromCachedContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cachedContent'
    ]);
    if (parentObject !== undefined && fromCachedContent != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'cachedContent'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromCachedContent));
    const fromResponseModalities = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (fromResponseModalities != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseModalities'
    ], fromResponseModalities);
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromSpeechConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (fromSpeechConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'speechConfig'
    ], $e4deb49dba5321bc$var$speechConfigToVertex($e4deb49dba5321bc$var$tSpeechConfig(fromSpeechConfig)));
    const fromAudioTimestamp = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audioTimestamp'
    ]);
    if (fromAudioTimestamp != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'audioTimestamp'
    ], fromAudioTimestamp);
    const fromThinkingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thinkingConfig'
    ]);
    if (fromThinkingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thinkingConfig'
    ], $e4deb49dba5321bc$var$thinkingConfigToVertex(fromThinkingConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$generateContentParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContents(fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$contentToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'contents'
        ], transformedList);
    }
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'generationConfig'
    ], $e4deb49dba5321bc$var$generateContentConfigToVertex(apiClient, fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromTaskType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'taskType'
    ]);
    if (parentObject !== undefined && fromTaskType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[]',
        'task_type'
    ], fromTaskType);
    const fromTitle = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'title'
    ]);
    if (parentObject !== undefined && fromTitle != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[]',
        'title'
    ], fromTitle);
    const fromOutputDimensionality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputDimensionality'
    ]);
    if (parentObject !== undefined && fromOutputDimensionality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputDimensionality'
    ], fromOutputDimensionality);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (parentObject !== undefined && fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[]',
        'mimeType'
    ], fromMimeType);
    const fromAutoTruncate = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'autoTruncate'
    ]);
    if (parentObject !== undefined && fromAutoTruncate != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'autoTruncate'
    ], fromAutoTruncate);
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[]',
        'content'
    ], $e4deb49dba5321bc$var$tContentsForEmbed(apiClient, fromContents));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$embedContentConfigToVertex(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$generateImagesConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromOutputGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputGcsUri'
    ]);
    if (parentObject !== undefined && fromOutputGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'storageUri'
    ], fromOutputGcsUri);
    const fromNegativePrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'negativePrompt'
    ]);
    if (parentObject !== undefined && fromNegativePrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'negativePrompt'
    ], fromNegativePrompt);
    const fromNumberOfImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'numberOfImages'
    ]);
    if (parentObject !== undefined && fromNumberOfImages != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfImages);
    const fromAspectRatio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (parentObject !== undefined && fromAspectRatio != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'aspectRatio'
    ], fromAspectRatio);
    const fromGuidanceScale = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'guidanceScale'
    ]);
    if (parentObject !== undefined && fromGuidanceScale != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'guidanceScale'
    ], fromGuidanceScale);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'seed'
    ], fromSeed);
    const fromSafetyFilterLevel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyFilterLevel'
    ]);
    if (parentObject !== undefined && fromSafetyFilterLevel != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'safetySetting'
    ], fromSafetyFilterLevel);
    const fromPersonGeneration = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    const fromIncludeSafetyAttributes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeSafetyAttributes'
    ]);
    if (parentObject !== undefined && fromIncludeSafetyAttributes != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'includeSafetyAttributes'
    ], fromIncludeSafetyAttributes);
    const fromIncludeRaiReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeRaiReason'
    ]);
    if (parentObject !== undefined && fromIncludeRaiReason != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'includeRaiReason'
    ], fromIncludeRaiReason);
    const fromLanguage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'language'
    ]);
    if (parentObject !== undefined && fromLanguage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'language'
    ], fromLanguage);
    const fromOutputMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputMimeType'
    ]);
    if (parentObject !== undefined && fromOutputMimeType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'mimeType'
    ], fromOutputMimeType);
    const fromOutputCompressionQuality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]);
    if (parentObject !== undefined && fromOutputCompressionQuality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'compressionQuality'
    ], fromOutputCompressionQuality);
    const fromAddWatermark = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'addWatermark'
    ]);
    if (parentObject !== undefined && fromAddWatermark != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'addWatermark'
    ], fromAddWatermark);
    const fromImageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageSize'
    ]);
    if (parentObject !== undefined && fromImageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleImageSize'
    ], fromImageSize);
    const fromEnhancePrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enhancePrompt'
    ]);
    if (parentObject !== undefined && fromEnhancePrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'enhancePrompt'
    ], fromEnhancePrompt);
    return toObject;
}
function $e4deb49dba5321bc$var$generateImagesParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$generateImagesConfigToVertex(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$imageToVertex(fromObject) {
    const toObject = {};
    const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'gcsUri'
    ], fromGcsUri);
    const fromImageBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageBytes'
    ]);
    if (fromImageBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'bytesBase64Encoded'
    ], $e4deb49dba5321bc$var$tBytes(fromImageBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$maskReferenceConfigToVertex(fromObject) {
    const toObject = {};
    const fromMaskMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maskMode'
    ]);
    if (fromMaskMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maskMode'
    ], fromMaskMode);
    const fromSegmentationClasses = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'segmentationClasses'
    ]);
    if (fromSegmentationClasses != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maskClasses'
    ], fromSegmentationClasses);
    const fromMaskDilation = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maskDilation'
    ]);
    if (fromMaskDilation != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dilation'
    ], fromMaskDilation);
    return toObject;
}
function $e4deb49dba5321bc$var$controlReferenceConfigToVertex(fromObject) {
    const toObject = {};
    const fromControlType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'controlType'
    ]);
    if (fromControlType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'controlType'
    ], fromControlType);
    const fromEnableControlImageComputation = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableControlImageComputation'
    ]);
    if (fromEnableControlImageComputation != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computeControl'
    ], fromEnableControlImageComputation);
    return toObject;
}
function $e4deb49dba5321bc$var$styleReferenceConfigToVertex(fromObject) {
    const toObject = {};
    const fromStyleDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'styleDescription'
    ]);
    if (fromStyleDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'styleDescription'
    ], fromStyleDescription);
    return toObject;
}
function $e4deb49dba5321bc$var$subjectReferenceConfigToVertex(fromObject) {
    const toObject = {};
    const fromSubjectType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'subjectType'
    ]);
    if (fromSubjectType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'subjectType'
    ], fromSubjectType);
    const fromSubjectDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'subjectDescription'
    ]);
    if (fromSubjectDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'subjectDescription'
    ], fromSubjectDescription);
    return toObject;
}
function $e4deb49dba5321bc$var$referenceImageAPIInternalToVertex(fromObject) {
    const toObject = {};
    const fromReferenceImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'referenceImage'
    ]);
    if (fromReferenceImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'referenceImage'
    ], $e4deb49dba5321bc$var$imageToVertex(fromReferenceImage));
    const fromReferenceId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'referenceId'
    ]);
    if (fromReferenceId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'referenceId'
    ], fromReferenceId);
    const fromReferenceType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'referenceType'
    ]);
    if (fromReferenceType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'referenceType'
    ], fromReferenceType);
    const fromMaskImageConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maskImageConfig'
    ]);
    if (fromMaskImageConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maskImageConfig'
    ], $e4deb49dba5321bc$var$maskReferenceConfigToVertex(fromMaskImageConfig));
    const fromControlImageConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'controlImageConfig'
    ]);
    if (fromControlImageConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'controlImageConfig'
    ], $e4deb49dba5321bc$var$controlReferenceConfigToVertex(fromControlImageConfig));
    const fromStyleImageConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'styleImageConfig'
    ]);
    if (fromStyleImageConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'styleImageConfig'
    ], $e4deb49dba5321bc$var$styleReferenceConfigToVertex(fromStyleImageConfig));
    const fromSubjectImageConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'subjectImageConfig'
    ]);
    if (fromSubjectImageConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'subjectImageConfig'
    ], $e4deb49dba5321bc$var$subjectReferenceConfigToVertex(fromSubjectImageConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$editImageConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromOutputGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputGcsUri'
    ]);
    if (parentObject !== undefined && fromOutputGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'storageUri'
    ], fromOutputGcsUri);
    const fromNegativePrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'negativePrompt'
    ]);
    if (parentObject !== undefined && fromNegativePrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'negativePrompt'
    ], fromNegativePrompt);
    const fromNumberOfImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'numberOfImages'
    ]);
    if (parentObject !== undefined && fromNumberOfImages != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfImages);
    const fromAspectRatio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (parentObject !== undefined && fromAspectRatio != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'aspectRatio'
    ], fromAspectRatio);
    const fromGuidanceScale = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'guidanceScale'
    ]);
    if (parentObject !== undefined && fromGuidanceScale != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'guidanceScale'
    ], fromGuidanceScale);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'seed'
    ], fromSeed);
    const fromSafetyFilterLevel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyFilterLevel'
    ]);
    if (parentObject !== undefined && fromSafetyFilterLevel != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'safetySetting'
    ], fromSafetyFilterLevel);
    const fromPersonGeneration = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    const fromIncludeSafetyAttributes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeSafetyAttributes'
    ]);
    if (parentObject !== undefined && fromIncludeSafetyAttributes != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'includeSafetyAttributes'
    ], fromIncludeSafetyAttributes);
    const fromIncludeRaiReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeRaiReason'
    ]);
    if (parentObject !== undefined && fromIncludeRaiReason != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'includeRaiReason'
    ], fromIncludeRaiReason);
    const fromLanguage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'language'
    ]);
    if (parentObject !== undefined && fromLanguage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'language'
    ], fromLanguage);
    const fromOutputMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputMimeType'
    ]);
    if (parentObject !== undefined && fromOutputMimeType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'mimeType'
    ], fromOutputMimeType);
    const fromOutputCompressionQuality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]);
    if (parentObject !== undefined && fromOutputCompressionQuality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'compressionQuality'
    ], fromOutputCompressionQuality);
    const fromAddWatermark = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'addWatermark'
    ]);
    if (parentObject !== undefined && fromAddWatermark != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'addWatermark'
    ], fromAddWatermark);
    const fromEditMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'editMode'
    ]);
    if (parentObject !== undefined && fromEditMode != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'editMode'
    ], fromEditMode);
    const fromBaseSteps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseSteps'
    ]);
    if (parentObject !== undefined && fromBaseSteps != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'editConfig',
        'baseSteps'
    ], fromBaseSteps);
    return toObject;
}
function $e4deb49dba5321bc$var$editImageParametersInternalToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromReferenceImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'referenceImages'
    ]);
    if (fromReferenceImages != null) {
        let transformedList = fromReferenceImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$referenceImageAPIInternalToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'instances[0]',
            'referenceImages'
        ], transformedList);
    }
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$editImageConfigToVertex(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$upscaleImageAPIConfigInternalToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromOutputGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputGcsUri'
    ]);
    if (parentObject !== undefined && fromOutputGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'storageUri'
    ], fromOutputGcsUri);
    const fromIncludeRaiReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeRaiReason'
    ]);
    if (parentObject !== undefined && fromIncludeRaiReason != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'includeRaiReason'
    ], fromIncludeRaiReason);
    const fromOutputMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputMimeType'
    ]);
    if (parentObject !== undefined && fromOutputMimeType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'mimeType'
    ], fromOutputMimeType);
    const fromOutputCompressionQuality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]);
    if (parentObject !== undefined && fromOutputCompressionQuality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'compressionQuality'
    ], fromOutputCompressionQuality);
    const fromEnhanceInputImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enhanceInputImage'
    ]);
    if (parentObject !== undefined && fromEnhanceInputImage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'upscaleConfig',
        'enhanceInputImage'
    ], fromEnhanceInputImage);
    const fromImagePreservationFactor = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imagePreservationFactor'
    ]);
    if (parentObject !== undefined && fromImagePreservationFactor != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'upscaleConfig',
        'imagePreservationFactor'
    ], fromImagePreservationFactor);
    const fromNumberOfImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'numberOfImages'
    ]);
    if (parentObject !== undefined && fromNumberOfImages != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfImages);
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (parentObject !== undefined && fromMode != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'mode'
    ], fromMode);
    return toObject;
}
function $e4deb49dba5321bc$var$upscaleImageAPIParametersInternalToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'image'
    ], $e4deb49dba5321bc$var$imageToVertex(fromImage));
    const fromUpscaleFactor = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'upscaleFactor'
    ]);
    if (fromUpscaleFactor != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parameters',
        'upscaleConfig',
        'upscaleFactor'
    ], fromUpscaleFactor);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$upscaleImageAPIConfigInternalToVertex(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$productImageToVertex(fromObject) {
    const toObject = {};
    const fromProductImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'productImage'
    ]);
    if (fromProductImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'image'
    ], $e4deb49dba5321bc$var$imageToVertex(fromProductImage));
    return toObject;
}
function $e4deb49dba5321bc$var$recontextImageSourceToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (parentObject !== undefined && fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromPersonImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personImage'
    ]);
    if (parentObject !== undefined && fromPersonImage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'personImage',
        'image'
    ], $e4deb49dba5321bc$var$imageToVertex(fromPersonImage));
    const fromProductImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'productImages'
    ]);
    if (parentObject !== undefined && fromProductImages != null) {
        let transformedList = fromProductImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$productImageToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'instances[0]',
            'productImages'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$recontextImageConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromNumberOfImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'numberOfImages'
    ]);
    if (parentObject !== undefined && fromNumberOfImages != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfImages);
    const fromBaseSteps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseSteps'
    ]);
    if (parentObject !== undefined && fromBaseSteps != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'editConfig',
        'baseSteps'
    ], fromBaseSteps);
    const fromOutputGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputGcsUri'
    ]);
    if (parentObject !== undefined && fromOutputGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'storageUri'
    ], fromOutputGcsUri);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'seed'
    ], fromSeed);
    const fromSafetyFilterLevel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyFilterLevel'
    ]);
    if (parentObject !== undefined && fromSafetyFilterLevel != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'safetySetting'
    ], fromSafetyFilterLevel);
    const fromPersonGeneration = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    const fromAddWatermark = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'addWatermark'
    ]);
    if (parentObject !== undefined && fromAddWatermark != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'addWatermark'
    ], fromAddWatermark);
    const fromOutputMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputMimeType'
    ]);
    if (parentObject !== undefined && fromOutputMimeType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'mimeType'
    ], fromOutputMimeType);
    const fromOutputCompressionQuality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]);
    if (parentObject !== undefined && fromOutputCompressionQuality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'compressionQuality'
    ], fromOutputCompressionQuality);
    const fromEnhancePrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enhancePrompt'
    ]);
    if (parentObject !== undefined && fromEnhancePrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'enhancePrompt'
    ], fromEnhancePrompt);
    return toObject;
}
function $e4deb49dba5321bc$var$recontextImageParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromSource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'source'
    ]);
    if (fromSource != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$recontextImageSourceToVertex(fromSource, toObject));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$recontextImageConfigToVertex(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$scribbleImageToVertex(fromObject) {
    const toObject = {};
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'image'
    ], $e4deb49dba5321bc$var$imageToVertex(fromImage));
    return toObject;
}
function $e4deb49dba5321bc$var$segmentImageSourceToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (parentObject !== undefined && fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (parentObject !== undefined && fromImage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'image'
    ], $e4deb49dba5321bc$var$imageToVertex(fromImage));
    const fromScribbleImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'scribbleImage'
    ]);
    if (parentObject !== undefined && fromScribbleImage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'scribble'
    ], $e4deb49dba5321bc$var$scribbleImageToVertex(fromScribbleImage));
    return toObject;
}
function $e4deb49dba5321bc$var$segmentImageConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (parentObject !== undefined && fromMode != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'mode'
    ], fromMode);
    const fromMaxPredictions = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxPredictions'
    ]);
    if (parentObject !== undefined && fromMaxPredictions != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'maxPredictions'
    ], fromMaxPredictions);
    const fromConfidenceThreshold = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'confidenceThreshold'
    ]);
    if (parentObject !== undefined && fromConfidenceThreshold != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'confidenceThreshold'
    ], fromConfidenceThreshold);
    const fromMaskDilation = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maskDilation'
    ]);
    if (parentObject !== undefined && fromMaskDilation != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'maskDilation'
    ], fromMaskDilation);
    const fromBinaryColorThreshold = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'binaryColorThreshold'
    ]);
    if (parentObject !== undefined && fromBinaryColorThreshold != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'binaryColorThreshold'
    ], fromBinaryColorThreshold);
    return toObject;
}
function $e4deb49dba5321bc$var$segmentImageParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromSource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'source'
    ]);
    if (fromSource != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$segmentImageSourceToVertex(fromSource, toObject));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$segmentImageConfigToVertex(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$getModelParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$listModelsConfigToVertex(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    const fromFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'filter'
    ]);
    if (parentObject !== undefined && fromFilter != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'filter'
    ], fromFilter);
    const fromQueryBase = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'queryBase'
    ]);
    if (parentObject !== undefined && fromQueryBase != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_url',
        'models_url'
    ], $e4deb49dba5321bc$var$tModelsUrl(apiClient, fromQueryBase));
    return toObject;
}
function $e4deb49dba5321bc$var$listModelsParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$listModelsConfigToVertex(apiClient, fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$updateModelConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'displayName'
    ], fromDisplayName);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (parentObject !== undefined && fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'description'
    ], fromDescription);
    const fromDefaultCheckpointId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'defaultCheckpointId'
    ]);
    if (parentObject !== undefined && fromDefaultCheckpointId != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'defaultCheckpointId'
    ], fromDefaultCheckpointId);
    return toObject;
}
function $e4deb49dba5321bc$var$updateModelParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$updateModelConfigToVertex(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$deleteModelParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$countTokensConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'systemInstruction'
    ], $e4deb49dba5321bc$var$contentToVertex($e4deb49dba5321bc$var$tContent(fromSystemInstruction)));
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = fromTools;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'tools'
        ], transformedList);
    }
    const fromGenerationConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generationConfig'
    ]);
    if (parentObject !== undefined && fromGenerationConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'generationConfig'
    ], fromGenerationConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$countTokensParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContents(fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$contentToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'contents'
        ], transformedList);
    }
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$countTokensConfigToVertex(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$computeTokensParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContents(fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$contentToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'contents'
        ], transformedList);
    }
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$videoToVertex(fromObject) {
    const toObject = {};
    const fromUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'uri'
    ]);
    if (fromUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'gcsUri'
    ], fromUri);
    const fromVideoBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoBytes'
    ]);
    if (fromVideoBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'bytesBase64Encoded'
    ], $e4deb49dba5321bc$var$tBytes(fromVideoBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosSourceToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (parentObject !== undefined && fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (parentObject !== undefined && fromImage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'image'
    ], $e4deb49dba5321bc$var$imageToVertex(fromImage));
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video'
    ]);
    if (parentObject !== undefined && fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'video'
    ], $e4deb49dba5321bc$var$videoToVertex(fromVideo));
    return toObject;
}
function $e4deb49dba5321bc$var$videoGenerationReferenceImageToVertex(fromObject) {
    const toObject = {};
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'image'
    ], $e4deb49dba5321bc$var$imageToVertex(fromImage));
    const fromReferenceType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'referenceType'
    ]);
    if (fromReferenceType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'referenceType'
    ], fromReferenceType);
    return toObject;
}
function $e4deb49dba5321bc$var$videoGenerationMaskToVertex(fromObject) {
    const toObject = {};
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_self'
    ], $e4deb49dba5321bc$var$imageToVertex(fromImage));
    const fromMaskMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maskMode'
    ]);
    if (fromMaskMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maskMode'
    ], fromMaskMode);
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromNumberOfVideos = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'numberOfVideos'
    ]);
    if (parentObject !== undefined && fromNumberOfVideos != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfVideos);
    const fromOutputGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputGcsUri'
    ]);
    if (parentObject !== undefined && fromOutputGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'storageUri'
    ], fromOutputGcsUri);
    const fromFps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fps'
    ]);
    if (parentObject !== undefined && fromFps != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'fps'
    ], fromFps);
    const fromDurationSeconds = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'durationSeconds'
    ]);
    if (parentObject !== undefined && fromDurationSeconds != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'durationSeconds'
    ], fromDurationSeconds);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'seed'
    ], fromSeed);
    const fromAspectRatio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (parentObject !== undefined && fromAspectRatio != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'aspectRatio'
    ], fromAspectRatio);
    const fromResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'resolution'
    ]);
    if (parentObject !== undefined && fromResolution != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'resolution'
    ], fromResolution);
    const fromPersonGeneration = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    const fromPubsubTopic = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pubsubTopic'
    ]);
    if (parentObject !== undefined && fromPubsubTopic != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'pubsubTopic'
    ], fromPubsubTopic);
    const fromNegativePrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'negativePrompt'
    ]);
    if (parentObject !== undefined && fromNegativePrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'negativePrompt'
    ], fromNegativePrompt);
    const fromEnhancePrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enhancePrompt'
    ]);
    if (parentObject !== undefined && fromEnhancePrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'enhancePrompt'
    ], fromEnhancePrompt);
    const fromGenerateAudio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generateAudio'
    ]);
    if (parentObject !== undefined && fromGenerateAudio != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'generateAudio'
    ], fromGenerateAudio);
    const fromLastFrame = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'lastFrame'
    ]);
    if (parentObject !== undefined && fromLastFrame != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'lastFrame'
    ], $e4deb49dba5321bc$var$imageToVertex(fromLastFrame));
    const fromReferenceImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'referenceImages'
    ]);
    if (parentObject !== undefined && fromReferenceImages != null) {
        let transformedList = fromReferenceImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$videoGenerationReferenceImageToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'instances[0]',
            'referenceImages'
        ], transformedList);
    }
    const fromMask = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mask'
    ]);
    if (parentObject !== undefined && fromMask != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'mask'
    ], $e4deb49dba5321bc$var$videoGenerationMaskToVertex(fromMask));
    const fromCompressionQuality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'compressionQuality'
    ]);
    if (parentObject !== undefined && fromCompressionQuality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'compressionQuality'
    ], fromCompressionQuality);
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'image'
    ], $e4deb49dba5321bc$var$imageToVertex(fromImage));
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video'
    ]);
    if (fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'video'
    ], $e4deb49dba5321bc$var$videoToVertex(fromVideo));
    const fromSource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'source'
    ]);
    if (fromSource != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$generateVideosSourceToVertex(fromSource, toObject));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$generateVideosConfigToVertex(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$videoMetadataFromMldev(fromObject) {
    const toObject = {};
    const fromFps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fps'
    ]);
    if (fromFps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fps'
    ], fromFps);
    const fromEndOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endOffset'
    ]);
    if (fromEndOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endOffset'
    ], fromEndOffset);
    const fromStartOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startOffset'
    ]);
    if (fromStartOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startOffset'
    ], fromStartOffset);
    return toObject;
}
function $e4deb49dba5321bc$var$blobFromMldev(fromObject) {
    const toObject = {};
    const fromData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$fileDataFromMldev(fromObject) {
    const toObject = {};
    const fromFileUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallFromMldev(fromObject) {
    const toObject = {};
    const fromId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'id'
    ]);
    if (fromId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'id'
    ], fromId);
    const fromArgs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$partFromMldev(fromObject) {
    const toObject = {};
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], $e4deb49dba5321bc$var$videoMetadataFromMldev(fromVideoMetadata));
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], $e4deb49dba5321bc$var$blobFromMldev(fromInlineData));
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], $e4deb49dba5321bc$var$fileDataFromMldev(fromFileData));
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], $e4deb49dba5321bc$var$functionCallFromMldev(fromFunctionCall));
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    return toObject;
}
function $e4deb49dba5321bc$var$contentFromMldev(fromObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$citationMetadataFromMldev(fromObject) {
    const toObject = {};
    const fromCitations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'citationSources'
    ]);
    if (fromCitations != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'citations'
    ], fromCitations);
    return toObject;
}
function $e4deb49dba5321bc$var$urlMetadataFromMldev(fromObject) {
    const toObject = {};
    const fromRetrievedUrl = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrievedUrl'
    ]);
    if (fromRetrievedUrl != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrievedUrl'
    ], fromRetrievedUrl);
    const fromUrlRetrievalStatus = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlRetrievalStatus'
    ]);
    if (fromUrlRetrievalStatus != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlRetrievalStatus'
    ], fromUrlRetrievalStatus);
    return toObject;
}
function $e4deb49dba5321bc$var$urlContextMetadataFromMldev(fromObject) {
    const toObject = {};
    const fromUrlMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlMetadata'
    ]);
    if (fromUrlMetadata != null) {
        let transformedList = fromUrlMetadata;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$urlMetadataFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'urlMetadata'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$candidateFromMldev(fromObject) {
    const toObject = {};
    const fromContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'content'
    ]);
    if (fromContent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'content'
    ], $e4deb49dba5321bc$var$contentFromMldev(fromContent));
    const fromCitationMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'citationMetadata'
    ]);
    if (fromCitationMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'citationMetadata'
    ], $e4deb49dba5321bc$var$citationMetadataFromMldev(fromCitationMetadata));
    const fromTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tokenCount'
    ]);
    if (fromTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tokenCount'
    ], fromTokenCount);
    const fromFinishReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'finishReason'
    ]);
    if (fromFinishReason != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'finishReason'
    ], fromFinishReason);
    const fromUrlContextMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContextMetadata'
    ]);
    if (fromUrlContextMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContextMetadata'
    ], $e4deb49dba5321bc$var$urlContextMetadataFromMldev(fromUrlContextMetadata));
    const fromAvgLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'avgLogprobs'
    ]);
    if (fromAvgLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'avgLogprobs'
    ], fromAvgLogprobs);
    const fromGroundingMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'groundingMetadata'
    ]);
    if (fromGroundingMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'groundingMetadata'
    ], fromGroundingMetadata);
    const fromIndex = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'index'
    ]);
    if (fromIndex != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'index'
    ], fromIndex);
    const fromLogprobsResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'logprobsResult'
    ]);
    if (fromLogprobsResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'logprobsResult'
    ], fromLogprobsResult);
    const fromSafetyRatings = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyRatings'
    ]);
    if (fromSafetyRatings != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'safetyRatings'
    ], fromSafetyRatings);
    return toObject;
}
function $e4deb49dba5321bc$var$generateContentResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromCandidates = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidates'
    ]);
    if (fromCandidates != null) {
        let transformedList = fromCandidates;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$candidateFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'candidates'
        ], transformedList);
    }
    const fromModelVersion = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelVersion'
    ]);
    if (fromModelVersion != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'modelVersion'
    ], fromModelVersion);
    const fromPromptFeedback = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'promptFeedback'
    ]);
    if (fromPromptFeedback != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'promptFeedback'
    ], fromPromptFeedback);
    const fromResponseId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseId'
    ]);
    if (fromResponseId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseId'
    ], fromResponseId);
    const fromUsageMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'usageMetadata'
    ]);
    if (fromUsageMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'usageMetadata'
    ], fromUsageMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$contentEmbeddingFromMldev(fromObject) {
    const toObject = {};
    const fromValues = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'values'
    ]);
    if (fromValues != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'values'
    ], fromValues);
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentMetadataFromMldev() {
    const toObject = {};
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromEmbeddings = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'embeddings'
    ]);
    if (fromEmbeddings != null) {
        let transformedList = fromEmbeddings;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$contentEmbeddingFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'embeddings'
        ], transformedList);
    }
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], $e4deb49dba5321bc$var$embedContentMetadataFromMldev());
    return toObject;
}
function $e4deb49dba5321bc$var$imageFromMldev(fromObject) {
    const toObject = {};
    const fromImageBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bytesBase64Encoded'
    ]);
    if (fromImageBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'imageBytes'
    ], $e4deb49dba5321bc$var$tBytes(fromImageBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$safetyAttributesFromMldev(fromObject) {
    const toObject = {};
    const fromCategories = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyAttributes',
        'categories'
    ]);
    if (fromCategories != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'categories'
    ], fromCategories);
    const fromScores = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyAttributes',
        'scores'
    ]);
    if (fromScores != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'scores'
    ], fromScores);
    const fromContentType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contentType'
    ]);
    if (fromContentType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'contentType'
    ], fromContentType);
    return toObject;
}
function $e4deb49dba5321bc$var$generatedImageFromMldev(fromObject) {
    const toObject = {};
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'image'
    ], $e4deb49dba5321bc$var$imageFromMldev(fromImage));
    const fromRaiFilteredReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiFilteredReason'
    ]);
    if (fromRaiFilteredReason != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiFilteredReason'
    ], fromRaiFilteredReason);
    const fromSafetyAttributes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromSafetyAttributes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'safetyAttributes'
    ], $e4deb49dba5321bc$var$safetyAttributesFromMldev(fromSafetyAttributes));
    return toObject;
}
function $e4deb49dba5321bc$var$generateImagesResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromGeneratedImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'predictions'
    ]);
    if (fromGeneratedImages != null) {
        let transformedList = fromGeneratedImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedImageFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedImages'
        ], transformedList);
    }
    const fromPositivePromptSafetyAttributes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'positivePromptSafetyAttributes'
    ]);
    if (fromPositivePromptSafetyAttributes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'positivePromptSafetyAttributes'
    ], $e4deb49dba5321bc$var$safetyAttributesFromMldev(fromPositivePromptSafetyAttributes));
    return toObject;
}
function $e4deb49dba5321bc$var$tunedModelInfoFromMldev(fromObject) {
    const toObject = {};
    const fromBaseModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseModel'
    ]);
    if (fromBaseModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'baseModel'
    ], fromBaseModel);
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromUpdateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    return toObject;
}
function $e4deb49dba5321bc$var$modelFromMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromVersion = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'version'
    ]);
    if (fromVersion != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'version'
    ], fromVersion);
    const fromTunedModelInfo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromTunedModelInfo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tunedModelInfo'
    ], $e4deb49dba5321bc$var$tunedModelInfoFromMldev(fromTunedModelInfo));
    const fromInputTokenLimit = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inputTokenLimit'
    ]);
    if (fromInputTokenLimit != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inputTokenLimit'
    ], fromInputTokenLimit);
    const fromOutputTokenLimit = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputTokenLimit'
    ]);
    if (fromOutputTokenLimit != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'outputTokenLimit'
    ], fromOutputTokenLimit);
    const fromSupportedActions = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'supportedGenerationMethods'
    ]);
    if (fromSupportedActions != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'supportedActions'
    ], fromSupportedActions);
    return toObject;
}
function $e4deb49dba5321bc$var$listModelsResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromModels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromModels != null) {
        let transformedList = $e4deb49dba5321bc$var$tExtractModels(fromModels);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$modelFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'models'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$deleteModelResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    return toObject;
}
function $e4deb49dba5321bc$var$countTokensResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromTotalTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'totalTokens'
    ]);
    if (fromTotalTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'totalTokens'
    ], fromTotalTokens);
    const fromCachedContentTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cachedContentTokenCount'
    ]);
    if (fromCachedContentTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'cachedContentTokenCount'
    ], fromCachedContentTokenCount);
    return toObject;
}
function $e4deb49dba5321bc$var$videoFromMldev(fromObject) {
    const toObject = {};
    const fromUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video',
        'uri'
    ]);
    if (fromUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'uri'
    ], fromUri);
    const fromVideoBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video',
        'encodedVideo'
    ]);
    if (fromVideoBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoBytes'
    ], $e4deb49dba5321bc$var$tBytes(fromVideoBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'encoding'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$generatedVideoFromMldev(fromObject) {
    const toObject = {};
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'video'
    ], $e4deb49dba5321bc$var$videoFromMldev(fromVideo));
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosResponseFromMldev(fromObject) {
    const toObject = {};
    const fromGeneratedVideos = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generatedSamples'
    ]);
    if (fromGeneratedVideos != null) {
        let transformedList = fromGeneratedVideos;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedVideoFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedVideos'
        ], transformedList);
    }
    const fromRaiMediaFilteredCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiMediaFilteredCount'
    ]);
    if (fromRaiMediaFilteredCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiMediaFilteredCount'
    ], fromRaiMediaFilteredCount);
    const fromRaiMediaFilteredReasons = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiMediaFilteredReasons'
    ]);
    if (fromRaiMediaFilteredReasons != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiMediaFilteredReasons'
    ], fromRaiMediaFilteredReasons);
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosOperationFromMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response',
        'generateVideoResponse'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], $e4deb49dba5321bc$var$generateVideosResponseFromMldev(fromResponse));
    return toObject;
}
function $e4deb49dba5321bc$var$videoMetadataFromVertex(fromObject) {
    const toObject = {};
    const fromFps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fps'
    ]);
    if (fromFps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fps'
    ], fromFps);
    const fromEndOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endOffset'
    ]);
    if (fromEndOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endOffset'
    ], fromEndOffset);
    const fromStartOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startOffset'
    ]);
    if (fromStartOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startOffset'
    ], fromStartOffset);
    return toObject;
}
function $e4deb49dba5321bc$var$blobFromVertex(fromObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$fileDataFromVertex(fromObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromFileUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallFromVertex(fromObject) {
    const toObject = {};
    const fromId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'id'
    ]);
    if (fromId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'id'
    ], fromId);
    const fromArgs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$partFromVertex(fromObject) {
    const toObject = {};
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], $e4deb49dba5321bc$var$videoMetadataFromVertex(fromVideoMetadata));
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], $e4deb49dba5321bc$var$blobFromVertex(fromInlineData));
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], $e4deb49dba5321bc$var$fileDataFromVertex(fromFileData));
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], $e4deb49dba5321bc$var$functionCallFromVertex(fromFunctionCall));
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    return toObject;
}
function $e4deb49dba5321bc$var$contentFromVertex(fromObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$citationMetadataFromVertex(fromObject) {
    const toObject = {};
    const fromCitations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'citations'
    ]);
    if (fromCitations != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'citations'
    ], fromCitations);
    return toObject;
}
function $e4deb49dba5321bc$var$urlMetadataFromVertex(fromObject) {
    const toObject = {};
    const fromRetrievedUrl = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrievedUrl'
    ]);
    if (fromRetrievedUrl != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrievedUrl'
    ], fromRetrievedUrl);
    const fromUrlRetrievalStatus = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlRetrievalStatus'
    ]);
    if (fromUrlRetrievalStatus != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlRetrievalStatus'
    ], fromUrlRetrievalStatus);
    return toObject;
}
function $e4deb49dba5321bc$var$urlContextMetadataFromVertex(fromObject) {
    const toObject = {};
    const fromUrlMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlMetadata'
    ]);
    if (fromUrlMetadata != null) {
        let transformedList = fromUrlMetadata;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$urlMetadataFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'urlMetadata'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$candidateFromVertex(fromObject) {
    const toObject = {};
    const fromContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'content'
    ]);
    if (fromContent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'content'
    ], $e4deb49dba5321bc$var$contentFromVertex(fromContent));
    const fromCitationMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'citationMetadata'
    ]);
    if (fromCitationMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'citationMetadata'
    ], $e4deb49dba5321bc$var$citationMetadataFromVertex(fromCitationMetadata));
    const fromFinishMessage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'finishMessage'
    ]);
    if (fromFinishMessage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'finishMessage'
    ], fromFinishMessage);
    const fromFinishReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'finishReason'
    ]);
    if (fromFinishReason != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'finishReason'
    ], fromFinishReason);
    const fromUrlContextMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContextMetadata'
    ]);
    if (fromUrlContextMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContextMetadata'
    ], $e4deb49dba5321bc$var$urlContextMetadataFromVertex(fromUrlContextMetadata));
    const fromAvgLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'avgLogprobs'
    ]);
    if (fromAvgLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'avgLogprobs'
    ], fromAvgLogprobs);
    const fromGroundingMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'groundingMetadata'
    ]);
    if (fromGroundingMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'groundingMetadata'
    ], fromGroundingMetadata);
    const fromIndex = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'index'
    ]);
    if (fromIndex != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'index'
    ], fromIndex);
    const fromLogprobsResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'logprobsResult'
    ]);
    if (fromLogprobsResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'logprobsResult'
    ], fromLogprobsResult);
    const fromSafetyRatings = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyRatings'
    ]);
    if (fromSafetyRatings != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'safetyRatings'
    ], fromSafetyRatings);
    return toObject;
}
function $e4deb49dba5321bc$var$generateContentResponseFromVertex(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromCandidates = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidates'
    ]);
    if (fromCandidates != null) {
        let transformedList = fromCandidates;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$candidateFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'candidates'
        ], transformedList);
    }
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromModelVersion = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelVersion'
    ]);
    if (fromModelVersion != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'modelVersion'
    ], fromModelVersion);
    const fromPromptFeedback = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'promptFeedback'
    ]);
    if (fromPromptFeedback != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'promptFeedback'
    ], fromPromptFeedback);
    const fromResponseId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseId'
    ]);
    if (fromResponseId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseId'
    ], fromResponseId);
    const fromUsageMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'usageMetadata'
    ]);
    if (fromUsageMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'usageMetadata'
    ], fromUsageMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$contentEmbeddingStatisticsFromVertex(fromObject) {
    const toObject = {};
    const fromTruncated = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'truncated'
    ]);
    if (fromTruncated != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'truncated'
    ], fromTruncated);
    const fromTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'token_count'
    ]);
    if (fromTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tokenCount'
    ], fromTokenCount);
    return toObject;
}
function $e4deb49dba5321bc$var$contentEmbeddingFromVertex(fromObject) {
    const toObject = {};
    const fromValues = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'values'
    ]);
    if (fromValues != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'values'
    ], fromValues);
    const fromStatistics = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'statistics'
    ]);
    if (fromStatistics != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'statistics'
    ], $e4deb49dba5321bc$var$contentEmbeddingStatisticsFromVertex(fromStatistics));
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentMetadataFromVertex(fromObject) {
    const toObject = {};
    const fromBillableCharacterCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'billableCharacterCount'
    ]);
    if (fromBillableCharacterCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'billableCharacterCount'
    ], fromBillableCharacterCount);
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentResponseFromVertex(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromEmbeddings = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'predictions[]',
        'embeddings'
    ]);
    if (fromEmbeddings != null) {
        let transformedList = fromEmbeddings;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$contentEmbeddingFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'embeddings'
        ], transformedList);
    }
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], $e4deb49dba5321bc$var$embedContentMetadataFromVertex(fromMetadata));
    return toObject;
}
function $e4deb49dba5321bc$var$imageFromVertex(fromObject) {
    const toObject = {};
    const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'gcsUri'
    ], fromGcsUri);
    const fromImageBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bytesBase64Encoded'
    ]);
    if (fromImageBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'imageBytes'
    ], $e4deb49dba5321bc$var$tBytes(fromImageBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$safetyAttributesFromVertex(fromObject) {
    const toObject = {};
    const fromCategories = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyAttributes',
        'categories'
    ]);
    if (fromCategories != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'categories'
    ], fromCategories);
    const fromScores = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyAttributes',
        'scores'
    ]);
    if (fromScores != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'scores'
    ], fromScores);
    const fromContentType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contentType'
    ]);
    if (fromContentType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'contentType'
    ], fromContentType);
    return toObject;
}
function $e4deb49dba5321bc$var$generatedImageFromVertex(fromObject) {
    const toObject = {};
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'image'
    ], $e4deb49dba5321bc$var$imageFromVertex(fromImage));
    const fromRaiFilteredReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiFilteredReason'
    ]);
    if (fromRaiFilteredReason != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiFilteredReason'
    ], fromRaiFilteredReason);
    const fromSafetyAttributes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromSafetyAttributes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'safetyAttributes'
    ], $e4deb49dba5321bc$var$safetyAttributesFromVertex(fromSafetyAttributes));
    const fromEnhancedPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (fromEnhancedPrompt != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enhancedPrompt'
    ], fromEnhancedPrompt);
    return toObject;
}
function $e4deb49dba5321bc$var$generateImagesResponseFromVertex(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromGeneratedImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'predictions'
    ]);
    if (fromGeneratedImages != null) {
        let transformedList = fromGeneratedImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedImageFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedImages'
        ], transformedList);
    }
    const fromPositivePromptSafetyAttributes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'positivePromptSafetyAttributes'
    ]);
    if (fromPositivePromptSafetyAttributes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'positivePromptSafetyAttributes'
    ], $e4deb49dba5321bc$var$safetyAttributesFromVertex(fromPositivePromptSafetyAttributes));
    return toObject;
}
function $e4deb49dba5321bc$var$editImageResponseFromVertex(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromGeneratedImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'predictions'
    ]);
    if (fromGeneratedImages != null) {
        let transformedList = fromGeneratedImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedImageFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedImages'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$upscaleImageResponseFromVertex(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromGeneratedImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'predictions'
    ]);
    if (fromGeneratedImages != null) {
        let transformedList = fromGeneratedImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedImageFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedImages'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$recontextImageResponseFromVertex(fromObject) {
    const toObject = {};
    const fromGeneratedImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'predictions'
    ]);
    if (fromGeneratedImages != null) {
        let transformedList = fromGeneratedImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedImageFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedImages'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$entityLabelFromVertex(fromObject) {
    const toObject = {};
    const fromLabel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'label'
    ]);
    if (fromLabel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'label'
    ], fromLabel);
    const fromScore = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'score'
    ]);
    if (fromScore != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'score'
    ], fromScore);
    return toObject;
}
function $e4deb49dba5321bc$var$generatedImageMaskFromVertex(fromObject) {
    const toObject = {};
    const fromMask = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromMask != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mask'
    ], $e4deb49dba5321bc$var$imageFromVertex(fromMask));
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (fromLabels != null) {
        let transformedList = fromLabels;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$entityLabelFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'labels'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$segmentImageResponseFromVertex(fromObject) {
    const toObject = {};
    const fromGeneratedMasks = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'predictions'
    ]);
    if (fromGeneratedMasks != null) {
        let transformedList = fromGeneratedMasks;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedImageMaskFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedMasks'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$endpointFromVertex(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endpoint'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDeployedModelId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'deployedModelId'
    ]);
    if (fromDeployedModelId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'deployedModelId'
    ], fromDeployedModelId);
    return toObject;
}
function $e4deb49dba5321bc$var$tunedModelInfoFromVertex(fromObject) {
    const toObject = {};
    const fromBaseModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels',
        'google-vertex-llm-tuning-base-model-id'
    ]);
    if (fromBaseModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'baseModel'
    ], fromBaseModel);
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromUpdateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    return toObject;
}
function $e4deb49dba5321bc$var$checkpointFromVertex(fromObject) {
    const toObject = {};
    const fromCheckpointId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'checkpointId'
    ]);
    if (fromCheckpointId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'checkpointId'
    ], fromCheckpointId);
    const fromEpoch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'epoch'
    ]);
    if (fromEpoch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'epoch'
    ], fromEpoch);
    const fromStep = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'step'
    ]);
    if (fromStep != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'step'
    ], fromStep);
    return toObject;
}
function $e4deb49dba5321bc$var$modelFromVertex(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromVersion = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'versionId'
    ]);
    if (fromVersion != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'version'
    ], fromVersion);
    const fromEndpoints = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'deployedModels'
    ]);
    if (fromEndpoints != null) {
        let transformedList = fromEndpoints;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$endpointFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'endpoints'
        ], transformedList);
    }
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (fromLabels != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'labels'
    ], fromLabels);
    const fromTunedModelInfo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromTunedModelInfo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tunedModelInfo'
    ], $e4deb49dba5321bc$var$tunedModelInfoFromVertex(fromTunedModelInfo));
    const fromDefaultCheckpointId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'defaultCheckpointId'
    ]);
    if (fromDefaultCheckpointId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'defaultCheckpointId'
    ], fromDefaultCheckpointId);
    const fromCheckpoints = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'checkpoints'
    ]);
    if (fromCheckpoints != null) {
        let transformedList = fromCheckpoints;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$checkpointFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'checkpoints'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$listModelsResponseFromVertex(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromModels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromModels != null) {
        let transformedList = $e4deb49dba5321bc$var$tExtractModels(fromModels);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$modelFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'models'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$deleteModelResponseFromVertex(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    return toObject;
}
function $e4deb49dba5321bc$var$countTokensResponseFromVertex(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromTotalTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'totalTokens'
    ]);
    if (fromTotalTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'totalTokens'
    ], fromTotalTokens);
    return toObject;
}
function $e4deb49dba5321bc$var$computeTokensResponseFromVertex(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromTokensInfo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tokensInfo'
    ]);
    if (fromTokensInfo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tokensInfo'
    ], fromTokensInfo);
    return toObject;
}
function $e4deb49dba5321bc$var$videoFromVertex(fromObject) {
    const toObject = {};
    const fromUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'uri'
    ], fromUri);
    const fromVideoBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bytesBase64Encoded'
    ]);
    if (fromVideoBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoBytes'
    ], $e4deb49dba5321bc$var$tBytes(fromVideoBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$generatedVideoFromVertex(fromObject) {
    const toObject = {};
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'video'
    ], $e4deb49dba5321bc$var$videoFromVertex(fromVideo));
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosResponseFromVertex(fromObject) {
    const toObject = {};
    const fromGeneratedVideos = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videos'
    ]);
    if (fromGeneratedVideos != null) {
        let transformedList = fromGeneratedVideos;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedVideoFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedVideos'
        ], transformedList);
    }
    const fromRaiMediaFilteredCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiMediaFilteredCount'
    ]);
    if (fromRaiMediaFilteredCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiMediaFilteredCount'
    ], fromRaiMediaFilteredCount);
    const fromRaiMediaFilteredReasons = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiMediaFilteredReasons'
    ]);
    if (fromRaiMediaFilteredReasons != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiMediaFilteredReasons'
    ], fromRaiMediaFilteredReasons);
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosOperationFromVertex(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], $e4deb49dba5321bc$var$generateVideosResponseFromVertex(fromResponse));
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $e4deb49dba5321bc$var$CONTENT_TYPE_HEADER = 'Content-Type';
const $e4deb49dba5321bc$var$SERVER_TIMEOUT_HEADER = 'X-Server-Timeout';
const $e4deb49dba5321bc$var$USER_AGENT_HEADER = 'User-Agent';
const $e4deb49dba5321bc$var$GOOGLE_API_CLIENT_HEADER = 'x-goog-api-client';
const $e4deb49dba5321bc$var$SDK_VERSION = '1.20.0'; // x-release-please-version
const $e4deb49dba5321bc$var$LIBRARY_LABEL = `google-genai-sdk/${$e4deb49dba5321bc$var$SDK_VERSION}`;
const $e4deb49dba5321bc$var$VERTEX_AI_API_DEFAULT_VERSION = 'v1beta1';
const $e4deb49dba5321bc$var$GOOGLE_AI_API_DEFAULT_VERSION = 'v1beta';
const $e4deb49dba5321bc$var$responseLineRE = /^data: (.*)(?:\n\n|\r\r|\r\n\r\n)/;
/**
 * The ApiClient class is used to send requests to the Gemini API or Vertex AI
 * endpoints.
 */ class $e4deb49dba5321bc$var$ApiClient {
    constructor(opts){
        var _a, _b;
        this.clientOptions = Object.assign(Object.assign({}, opts), {
            project: opts.project,
            location: opts.location,
            apiKey: opts.apiKey,
            vertexai: opts.vertexai
        });
        const initHttpOptions = {};
        if (this.clientOptions.vertexai) {
            initHttpOptions.apiVersion = (_a = this.clientOptions.apiVersion) !== null && _a !== void 0 ? _a : $e4deb49dba5321bc$var$VERTEX_AI_API_DEFAULT_VERSION;
            initHttpOptions.baseUrl = this.baseUrlFromProjectLocation();
            this.normalizeAuthParameters();
        } else {
            // Gemini API
            initHttpOptions.apiVersion = (_b = this.clientOptions.apiVersion) !== null && _b !== void 0 ? _b : $e4deb49dba5321bc$var$GOOGLE_AI_API_DEFAULT_VERSION;
            initHttpOptions.baseUrl = `https://generativelanguage.googleapis.com/`;
        }
        initHttpOptions.headers = this.getDefaultHeaders();
        this.clientOptions.httpOptions = initHttpOptions;
        if (opts.httpOptions) this.clientOptions.httpOptions = this.patchHttpOptions(initHttpOptions, opts.httpOptions);
    }
    /**
     * Determines the base URL for Vertex AI based on project and location.
     * Uses the global endpoint if location is 'global' or if project/location
     * are not specified (implying API key usage).
     * @private
     */ baseUrlFromProjectLocation() {
        if (this.clientOptions.project && this.clientOptions.location && this.clientOptions.location !== 'global') // Regional endpoint
        return `https://${this.clientOptions.location}-aiplatform.googleapis.com/`;
        // Global endpoint (covers 'global' location and API key usage)
        return `https://aiplatform.googleapis.com/`;
    }
    /**
     * Normalizes authentication parameters for Vertex AI.
     * If project and location are provided, API key is cleared.
     * If project and location are not provided (implying API key usage),
     * project and location are cleared.
     * @private
     */ normalizeAuthParameters() {
        if (this.clientOptions.project && this.clientOptions.location) {
            // Using project/location for auth, clear potential API key
            this.clientOptions.apiKey = undefined;
            return;
        }
        // Using API key for auth (or no auth provided yet), clear project/location
        this.clientOptions.project = undefined;
        this.clientOptions.location = undefined;
    }
    isVertexAI() {
        var _a;
        return (_a = this.clientOptions.vertexai) !== null && _a !== void 0 ? _a : false;
    }
    getProject() {
        return this.clientOptions.project;
    }
    getLocation() {
        return this.clientOptions.location;
    }
    getApiVersion() {
        if (this.clientOptions.httpOptions && this.clientOptions.httpOptions.apiVersion !== undefined) return this.clientOptions.httpOptions.apiVersion;
        throw new Error('API version is not set.');
    }
    getBaseUrl() {
        if (this.clientOptions.httpOptions && this.clientOptions.httpOptions.baseUrl !== undefined) return this.clientOptions.httpOptions.baseUrl;
        throw new Error('Base URL is not set.');
    }
    getRequestUrl() {
        return this.getRequestUrlInternal(this.clientOptions.httpOptions);
    }
    getHeaders() {
        if (this.clientOptions.httpOptions && this.clientOptions.httpOptions.headers !== undefined) return this.clientOptions.httpOptions.headers;
        else throw new Error('Headers are not set.');
    }
    getRequestUrlInternal(httpOptions) {
        if (!httpOptions || httpOptions.baseUrl === undefined || httpOptions.apiVersion === undefined) throw new Error('HTTP options are not correctly set.');
        const baseUrl = httpOptions.baseUrl.endsWith('/') ? httpOptions.baseUrl.slice(0, -1) : httpOptions.baseUrl;
        const urlElement = [
            baseUrl
        ];
        if (httpOptions.apiVersion && httpOptions.apiVersion !== '') urlElement.push(httpOptions.apiVersion);
        return urlElement.join('/');
    }
    getBaseResourcePath() {
        return `projects/${this.clientOptions.project}/locations/${this.clientOptions.location}`;
    }
    getApiKey() {
        return this.clientOptions.apiKey;
    }
    getWebsocketBaseUrl() {
        const baseUrl = this.getBaseUrl();
        const urlParts = new URL(baseUrl);
        urlParts.protocol = urlParts.protocol == 'http:' ? 'ws' : 'wss';
        return urlParts.toString();
    }
    setBaseUrl(url) {
        if (this.clientOptions.httpOptions) this.clientOptions.httpOptions.baseUrl = url;
        else throw new Error('HTTP options are not correctly set.');
    }
    constructUrl(path, httpOptions, prependProjectLocation) {
        const urlElement = [
            this.getRequestUrlInternal(httpOptions)
        ];
        if (prependProjectLocation) urlElement.push(this.getBaseResourcePath());
        if (path !== '') urlElement.push(path);
        const url = new URL(`${urlElement.join('/')}`);
        return url;
    }
    shouldPrependVertexProjectPath(request) {
        if (this.clientOptions.apiKey) return false;
        if (!this.clientOptions.vertexai) return false;
        if (request.path.startsWith('projects/')) // Assume the path already starts with
        // `projects/<project>/location/<location>`.
        return false;
        if (request.httpMethod === 'GET' && request.path.startsWith('publishers/google/models')) // These paths are used by Vertex's models.get and models.list
        // calls. For base models Vertex does not accept a project/location
        // prefix (for tuned model the prefix is required).
        return false;
        return true;
    }
    async request(request) {
        let patchedHttpOptions = this.clientOptions.httpOptions;
        if (request.httpOptions) patchedHttpOptions = this.patchHttpOptions(this.clientOptions.httpOptions, request.httpOptions);
        const prependProjectLocation = this.shouldPrependVertexProjectPath(request);
        const url = this.constructUrl(request.path, patchedHttpOptions, prependProjectLocation);
        if (request.queryParams) for (const [key, value] of Object.entries(request.queryParams))url.searchParams.append(key, String(value));
        let requestInit = {};
        if (request.httpMethod === 'GET') {
            if (request.body && request.body !== '{}') throw new Error('Request body should be empty for GET request, but got non empty request body');
        } else requestInit.body = request.body;
        requestInit = await this.includeExtraHttpOptionsToRequestInit(requestInit, patchedHttpOptions, request.abortSignal);
        return this.unaryApiCall(url, requestInit, request.httpMethod);
    }
    patchHttpOptions(baseHttpOptions, requestHttpOptions) {
        const patchedHttpOptions = JSON.parse(JSON.stringify(baseHttpOptions));
        for (const [key, value] of Object.entries(requestHttpOptions)){
            // Records compile to objects.
            if (typeof value === 'object') // @ts-expect-error TS2345TS7053: Element implicitly has an 'any' type
            // because expression of type 'string' can't be used to index type
            // 'HttpOptions'.
            patchedHttpOptions[key] = Object.assign(Object.assign({}, patchedHttpOptions[key]), value);
            else if (value !== undefined) // @ts-expect-error TS2345TS7053: Element implicitly has an 'any' type
            // because expression of type 'string' can't be used to index type
            // 'HttpOptions'.
            patchedHttpOptions[key] = value;
        }
        return patchedHttpOptions;
    }
    async requestStream(request) {
        let patchedHttpOptions = this.clientOptions.httpOptions;
        if (request.httpOptions) patchedHttpOptions = this.patchHttpOptions(this.clientOptions.httpOptions, request.httpOptions);
        const prependProjectLocation = this.shouldPrependVertexProjectPath(request);
        const url = this.constructUrl(request.path, patchedHttpOptions, prependProjectLocation);
        if (!url.searchParams.has('alt') || url.searchParams.get('alt') !== 'sse') url.searchParams.set('alt', 'sse');
        let requestInit = {};
        requestInit.body = request.body;
        requestInit = await this.includeExtraHttpOptionsToRequestInit(requestInit, patchedHttpOptions, request.abortSignal);
        return this.streamApiCall(url, requestInit, request.httpMethod);
    }
    async includeExtraHttpOptionsToRequestInit(requestInit, httpOptions, abortSignal) {
        if (httpOptions && httpOptions.timeout || abortSignal) {
            const abortController = new AbortController();
            const signal = abortController.signal;
            if (httpOptions.timeout && (httpOptions === null || httpOptions === void 0 ? void 0 : httpOptions.timeout) > 0) {
                const timeoutHandle = setTimeout(()=>abortController.abort(), httpOptions.timeout);
                if (timeoutHandle && typeof timeoutHandle.unref === 'function') // call unref to prevent nodejs process from hanging, see
                // https://nodejs.org/api/timers.html#timeoutunref
                timeoutHandle.unref();
            }
            if (abortSignal) abortSignal.addEventListener('abort', ()=>{
                abortController.abort();
            });
            requestInit.signal = signal;
        }
        if (httpOptions && httpOptions.extraBody !== null) $e4deb49dba5321bc$var$includeExtraBodyToRequestInit(requestInit, httpOptions.extraBody);
        requestInit.headers = await this.getHeadersInternal(httpOptions);
        return requestInit;
    }
    async unaryApiCall(url, requestInit, httpMethod) {
        return this.apiCall(url.toString(), Object.assign(Object.assign({}, requestInit), {
            method: httpMethod
        })).then(async (response)=>{
            await $e4deb49dba5321bc$var$throwErrorIfNotOK(response);
            return new $e4deb49dba5321bc$export$1d94dfe0d9d1f1e7(response);
        }).catch((e)=>{
            if (e instanceof Error) throw e;
            else throw new Error(JSON.stringify(e));
        });
    }
    async streamApiCall(url, requestInit, httpMethod) {
        return this.apiCall(url.toString(), Object.assign(Object.assign({}, requestInit), {
            method: httpMethod
        })).then(async (response)=>{
            await $e4deb49dba5321bc$var$throwErrorIfNotOK(response);
            return this.processStreamResponse(response);
        }).catch((e)=>{
            if (e instanceof Error) throw e;
            else throw new Error(JSON.stringify(e));
        });
    }
    processStreamResponse(response) {
        var _a;
        return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function* processStreamResponse_1() {
            const reader = (_a = response === null || response === void 0 ? void 0 : response.body) === null || _a === void 0 ? void 0 : _a.getReader();
            const decoder = new TextDecoder('utf-8');
            if (!reader) throw new Error('Response body is empty');
            try {
                let buffer = '';
                while(true){
                    const { done: done, value: value } = yield $e4deb49dba5321bc$var$__await(reader.read());
                    if (done) {
                        if (buffer.trim().length > 0) throw new Error('Incomplete JSON segment at the end');
                        break;
                    }
                    const chunkString = decoder.decode(value, {
                        stream: true
                    });
                    // Parse and throw an error if the chunk contains an error.
                    try {
                        const chunkJson = JSON.parse(chunkString);
                        if ('error' in chunkJson) {
                            const errorJson = JSON.parse(JSON.stringify(chunkJson['error']));
                            const status = errorJson['status'];
                            const code = errorJson['code'];
                            const errorMessage = `got status: ${status}. ${JSON.stringify(chunkJson)}`;
                            if (code >= 400 && code < 600) {
                                const apiError = new $e4deb49dba5321bc$export$f2e832acab1bdd79({
                                    message: errorMessage,
                                    status: code
                                });
                                throw apiError;
                            }
                        }
                    } catch (e) {
                        const error = e;
                        if (error.name === 'ApiError') throw e;
                    }
                    buffer += chunkString;
                    let match = buffer.match($e4deb49dba5321bc$var$responseLineRE);
                    while(match){
                        const processedChunkString = match[1];
                        try {
                            const partialResponse = new Response(processedChunkString, {
                                headers: response === null || response === void 0 ? void 0 : response.headers,
                                status: response === null || response === void 0 ? void 0 : response.status,
                                statusText: response === null || response === void 0 ? void 0 : response.statusText
                            });
                            yield yield $e4deb49dba5321bc$var$__await(new $e4deb49dba5321bc$export$1d94dfe0d9d1f1e7(partialResponse));
                            buffer = buffer.slice(match[0].length);
                            match = buffer.match($e4deb49dba5321bc$var$responseLineRE);
                        } catch (e) {
                            throw new Error(`exception parsing stream chunk ${processedChunkString}. ${e}`);
                        }
                    }
                }
            } finally{
                reader.releaseLock();
            }
        });
    }
    async apiCall(url, requestInit) {
        return fetch(url, requestInit).catch((e)=>{
            throw new Error(`exception ${e} sending request`);
        });
    }
    getDefaultHeaders() {
        const headers = {};
        const versionHeaderValue = $e4deb49dba5321bc$var$LIBRARY_LABEL + ' ' + this.clientOptions.userAgentExtra;
        headers[$e4deb49dba5321bc$var$USER_AGENT_HEADER] = versionHeaderValue;
        headers[$e4deb49dba5321bc$var$GOOGLE_API_CLIENT_HEADER] = versionHeaderValue;
        headers[$e4deb49dba5321bc$var$CONTENT_TYPE_HEADER] = 'application/json';
        return headers;
    }
    async getHeadersInternal(httpOptions) {
        const headers = new Headers();
        if (httpOptions && httpOptions.headers) {
            for (const [key, value] of Object.entries(httpOptions.headers))headers.append(key, value);
            // Append a timeout header if it is set, note that the timeout option is
            // in milliseconds but the header is in seconds.
            if (httpOptions.timeout && httpOptions.timeout > 0) headers.append($e4deb49dba5321bc$var$SERVER_TIMEOUT_HEADER, String(Math.ceil(httpOptions.timeout / 1000)));
        }
        await this.clientOptions.auth.addAuthHeaders(headers);
        return headers;
    }
    /**
     * Uploads a file asynchronously using Gemini API only, this is not supported
     * in Vertex AI.
     *
     * @param file The string path to the file to be uploaded or a Blob object.
     * @param config Optional parameters specified in the `UploadFileConfig`
     *     interface. @see {@link UploadFileConfig}
     * @return A promise that resolves to a `File` object.
     * @throws An error if called on a Vertex AI client.
     * @throws An error if the `mimeType` is not provided and can not be inferred,
     */ async uploadFile(file, config) {
        var _a;
        const fileToUpload = {};
        if (config != null) {
            fileToUpload.mimeType = config.mimeType;
            fileToUpload.name = config.name;
            fileToUpload.displayName = config.displayName;
        }
        if (fileToUpload.name && !fileToUpload.name.startsWith('files/')) fileToUpload.name = `files/${fileToUpload.name}`;
        const uploader = this.clientOptions.uploader;
        const fileStat = await uploader.stat(file);
        fileToUpload.sizeBytes = String(fileStat.size);
        const mimeType = (_a = config === null || config === void 0 ? void 0 : config.mimeType) !== null && _a !== void 0 ? _a : fileStat.type;
        if (mimeType === undefined || mimeType === '') throw new Error('Can not determine mimeType. Please provide mimeType in the config.');
        fileToUpload.mimeType = mimeType;
        const uploadUrl = await this.fetchUploadUrl(fileToUpload, config);
        return uploader.upload(file, uploadUrl, this);
    }
    /**
     * Downloads a file asynchronously to the specified path.
     *
     * @params params - The parameters for the download request, see {@link
     * DownloadFileParameters}
     */ async downloadFile(params) {
        const downloader = this.clientOptions.downloader;
        await downloader.download(params, this);
    }
    async fetchUploadUrl(file, config) {
        var _a;
        let httpOptions = {};
        if (config === null || config === void 0 ? void 0 : config.httpOptions) httpOptions = config.httpOptions;
        else httpOptions = {
            apiVersion: '',
            headers: {
                'Content-Type': 'application/json',
                'X-Goog-Upload-Protocol': 'resumable',
                'X-Goog-Upload-Command': 'start',
                'X-Goog-Upload-Header-Content-Length': `${file.sizeBytes}`,
                'X-Goog-Upload-Header-Content-Type': `${file.mimeType}`
            }
        };
        const body = {
            'file': file
        };
        const httpResponse = await this.request({
            path: $e4deb49dba5321bc$var$formatMap('upload/v1beta/files', body['_url']),
            body: JSON.stringify(body),
            httpMethod: 'POST',
            httpOptions: httpOptions
        });
        if (!httpResponse || !(httpResponse === null || httpResponse === void 0 ? void 0 : httpResponse.headers)) throw new Error('Server did not return an HttpResponse or the returned HttpResponse did not have headers.');
        const uploadUrl = (_a = httpResponse === null || httpResponse === void 0 ? void 0 : httpResponse.headers) === null || _a === void 0 ? void 0 : _a['x-goog-upload-url'];
        if (uploadUrl === undefined) throw new Error('Failed to get upload url. Server did not return the x-google-upload-url in the headers');
        return uploadUrl;
    }
}
async function $e4deb49dba5321bc$var$throwErrorIfNotOK(response) {
    var _a;
    if (response === undefined) throw new Error('response is undefined');
    if (!response.ok) {
        const status = response.status;
        let errorBody;
        if ((_a = response.headers.get('content-type')) === null || _a === void 0 ? void 0 : _a.includes('application/json')) errorBody = await response.json();
        else errorBody = {
            error: {
                message: await response.text(),
                code: response.status,
                status: response.statusText
            }
        };
        const errorMessage = JSON.stringify(errorBody);
        if (status >= 400 && status < 600) {
            const apiError = new $e4deb49dba5321bc$export$f2e832acab1bdd79({
                message: errorMessage,
                status: status
            });
            throw apiError;
        }
        throw new Error(errorMessage);
    }
}
/**
 * Recursively updates the `requestInit.body` with values from an `extraBody` object.
 *
 * If `requestInit.body` is a string, it's assumed to be JSON and will be parsed.
 * The `extraBody` is then deeply merged into this parsed object.
 * If `requestInit.body` is a Blob, `extraBody` will be ignored, and a warning logged,
 * as merging structured data into an opaque Blob is not supported.
 *
 * The function does not enforce that updated values from `extraBody` have the
 * same type as existing values in `requestInit.body`. Type mismatches during
 * the merge will result in a warning, but the value from `extraBody` will overwrite
 * the original. `extraBody` users are responsible for ensuring `extraBody` has the correct structure.
 *
 * @param requestInit The RequestInit object whose body will be updated.
 * @param extraBody The object containing updates to be merged into `requestInit.body`.
 */ function $e4deb49dba5321bc$var$includeExtraBodyToRequestInit(requestInit, extraBody) {
    if (!extraBody || Object.keys(extraBody).length === 0) return;
    if (requestInit.body instanceof Blob) {
        console.warn('includeExtraBodyToRequestInit: extraBody provided but current request body is a Blob. extraBody will be ignored as merging is not supported for Blob bodies.');
        return;
    }
    let currentBodyObject = {};
    // If adding new type to HttpRequest.body, please check the code below to
    // see if we need to update the logic.
    if (typeof requestInit.body === 'string' && requestInit.body.length > 0) try {
        const parsedBody = JSON.parse(requestInit.body);
        if (typeof parsedBody === 'object' && parsedBody !== null && !Array.isArray(parsedBody)) currentBodyObject = parsedBody;
        else {
            console.warn('includeExtraBodyToRequestInit: Original request body is valid JSON but not a non-array object. Skip applying extraBody to the request body.');
            return;
        }
    /*  eslint-disable-next-line @typescript-eslint/no-unused-vars */ } catch (e) {
        console.warn('includeExtraBodyToRequestInit: Original request body is not valid JSON. Skip applying extraBody to the request body.');
        return;
    }
    function deepMerge(target, source) {
        const output = Object.assign({}, target);
        for(const key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
            const sourceValue = source[key];
            const targetValue = output[key];
            if (sourceValue && typeof sourceValue === 'object' && !Array.isArray(sourceValue) && targetValue && typeof targetValue === 'object' && !Array.isArray(targetValue)) output[key] = deepMerge(targetValue, sourceValue);
            else {
                if (targetValue && sourceValue && typeof targetValue !== typeof sourceValue) console.warn(`includeExtraBodyToRequestInit:deepMerge: Type mismatch for key "${key}". Original type: ${typeof targetValue}, New type: ${typeof sourceValue}. Overwriting.`);
                output[key] = sourceValue;
            }
        }
        return output;
    }
    const mergedBody = deepMerge(currentBodyObject, extraBody);
    requestInit.body = JSON.stringify(mergedBody);
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // TODO: b/416041229 - Determine how to retrieve the MCP package version.
const $e4deb49dba5321bc$var$MCP_LABEL = 'mcp_used/unknown';
// Whether MCP tool usage is detected from mcpToTool. This is used for
// telemetry.
let $e4deb49dba5321bc$var$hasMcpToolUsageFromMcpToTool = false;
// Checks whether the list of tools contains any MCP tools.
function $e4deb49dba5321bc$var$hasMcpToolUsage(tools) {
    for (const tool of tools){
        if ($e4deb49dba5321bc$var$isMcpCallableTool(tool)) return true;
        if (typeof tool === 'object' && 'inputSchema' in tool) return true;
    }
    return $e4deb49dba5321bc$var$hasMcpToolUsageFromMcpToTool;
}
// Sets the MCP version label in the Google API client header.
function $e4deb49dba5321bc$var$setMcpUsageHeader(headers) {
    var _a;
    const existingHeader = (_a = headers[$e4deb49dba5321bc$var$GOOGLE_API_CLIENT_HEADER]) !== null && _a !== void 0 ? _a : '';
    headers[$e4deb49dba5321bc$var$GOOGLE_API_CLIENT_HEADER] = (existingHeader + ` ${$e4deb49dba5321bc$var$MCP_LABEL}`).trimStart();
}
// Returns true if the object is a MCP CallableTool, otherwise false.
function $e4deb49dba5321bc$var$isMcpCallableTool(object) {
    return object !== null && typeof object === 'object' && object instanceof $e4deb49dba5321bc$var$McpCallableTool;
}
// List all tools from the MCP client.
function $e4deb49dba5321bc$var$listAllTools(mcpClient, maxTools = 100) {
    return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function* listAllTools_1() {
        let cursor = undefined;
        let numTools = 0;
        while(numTools < maxTools){
            const t = yield $e4deb49dba5321bc$var$__await(mcpClient.listTools({
                cursor: cursor
            }));
            for (const tool of t.tools){
                yield yield $e4deb49dba5321bc$var$__await(tool);
                numTools++;
            }
            if (!t.nextCursor) break;
            cursor = t.nextCursor;
        }
    });
}
/**
 * McpCallableTool can be used for model inference and invoking MCP clients with
 * given function call arguments.
 *
 * @experimental Built-in MCP support is an experimental feature, may change in future
 * versions.
 */ class $e4deb49dba5321bc$var$McpCallableTool {
    constructor(mcpClients = [], config){
        this.mcpTools = [];
        this.functionNameToMcpClient = {};
        this.mcpClients = mcpClients;
        this.config = config;
    }
    /**
     * Creates a McpCallableTool.
     */ static create(mcpClients, config) {
        return new $e4deb49dba5321bc$var$McpCallableTool(mcpClients, config);
    }
    /**
     * Validates the function names are not duplicate and initialize the function
     * name to MCP client mapping.
     *
     * @throws {Error} if the MCP tools from the MCP clients have duplicate tool
     *     names.
     */ async initialize() {
        var _a, e_1, _b, _c;
        if (this.mcpTools.length > 0) return;
        const functionMap = {};
        const mcpTools = [];
        for (const mcpClient of this.mcpClients)try {
            for(var _d = true, _e = (e_1 = void 0, $e4deb49dba5321bc$var$__asyncValues($e4deb49dba5321bc$var$listAllTools(mcpClient))), _f; _f = await _e.next(), _a = _f.done, !_a; _d = true){
                _c = _f.value;
                _d = false;
                const mcpTool = _c;
                mcpTools.push(mcpTool);
                const mcpToolName = mcpTool.name;
                if (functionMap[mcpToolName]) throw new Error(`Duplicate function name ${mcpToolName} found in MCP tools. Please ensure function names are unique.`);
                functionMap[mcpToolName] = mcpClient;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (!_d && !_a && (_b = _e.return)) await _b.call(_e);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        this.mcpTools = mcpTools;
        this.functionNameToMcpClient = functionMap;
    }
    async tool() {
        await this.initialize();
        return $e4deb49dba5321bc$var$mcpToolsToGeminiTool(this.mcpTools, this.config);
    }
    async callTool(functionCalls) {
        await this.initialize();
        const functionCallResponseParts = [];
        for (const functionCall of functionCalls)if (functionCall.name in this.functionNameToMcpClient) {
            const mcpClient = this.functionNameToMcpClient[functionCall.name];
            let requestOptions = undefined;
            // TODO: b/424238654 - Add support for finer grained timeout control.
            if (this.config.timeout) requestOptions = {
                timeout: this.config.timeout
            };
            const callToolResponse = await mcpClient.callTool({
                name: functionCall.name,
                arguments: functionCall.args
            }, // Set the result schema to undefined to allow MCP to rely on the
            // default schema.
            undefined, requestOptions);
            functionCallResponseParts.push({
                functionResponse: {
                    name: functionCall.name,
                    response: callToolResponse.isError ? {
                        error: callToolResponse
                    } : callToolResponse
                }
            });
        }
        return functionCallResponseParts;
    }
}
function $e4deb49dba5321bc$var$isMcpClient(client) {
    return client !== null && typeof client === 'object' && 'listTools' in client && typeof client.listTools === 'function';
}
/**
 * Creates a McpCallableTool from MCP clients and an optional config.
 *
 * The callable tool can invoke the MCP clients with given function call
 * arguments. (often for automatic function calling).
 * Use the config to modify tool parameters such as behavior.
 *
 * @experimental Built-in MCP support is an experimental feature, may change in future
 * versions.
 */ function $e4deb49dba5321bc$export$836b74d9f63bb1cd(...args) {
    // Set MCP usage for telemetry.
    $e4deb49dba5321bc$var$hasMcpToolUsageFromMcpToTool = true;
    if (args.length === 0) throw new Error('No MCP clients provided');
    const maybeConfig = args[args.length - 1];
    if ($e4deb49dba5321bc$var$isMcpClient(maybeConfig)) return $e4deb49dba5321bc$var$McpCallableTool.create(args, {});
    return $e4deb49dba5321bc$var$McpCallableTool.create(args.slice(0, args.length - 1), maybeConfig);
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Handles incoming messages from the WebSocket.
 *
 * @remarks
 * This function is responsible for parsing incoming messages, transforming them
 * into LiveMusicServerMessage, and then calling the onmessage callback.
 * Note that the first message which is received from the server is a
 * setupComplete message.
 *
 * @param apiClient The ApiClient instance.
 * @param onmessage The user-provided onmessage callback (if any).
 * @param event The MessageEvent from the WebSocket.
 */ async function $e4deb49dba5321bc$var$handleWebSocketMessage$1(apiClient, onmessage, event) {
    const serverMessage = new $e4deb49dba5321bc$export$5f085d7f78cd2680();
    let data;
    if (event.data instanceof Blob) data = JSON.parse(await event.data.text());
    else data = JSON.parse(event.data);
    const response = $e4deb49dba5321bc$var$liveMusicServerMessageFromMldev(data);
    Object.assign(serverMessage, response);
    onmessage(serverMessage);
}
/**
   LiveMusic class encapsulates the configuration for live music
   generation via Lyria Live models.

   @experimental
  */ class $e4deb49dba5321bc$var$LiveMusic {
    constructor(apiClient, auth, webSocketFactory){
        this.apiClient = apiClient;
        this.auth = auth;
        this.webSocketFactory = webSocketFactory;
    }
    /**
       Establishes a connection to the specified model and returns a
       LiveMusicSession object representing that connection.
  
       @experimental
  
       @remarks
  
       @param params - The parameters for establishing a connection to the model.
       @return A live session.
  
       @example
       ```ts
       let model = 'models/lyria-realtime-exp';
       const session = await ai.live.music.connect({
         model: model,
         callbacks: {
           onmessage: (e: MessageEvent) => {
             console.log('Received message from the server: %s\n', debug(e.data));
           },
           onerror: (e: ErrorEvent) => {
             console.log('Error occurred: %s\n', debug(e.error));
           },
           onclose: (e: CloseEvent) => {
             console.log('Connection closed.');
           },
         },
       });
       ```
      */ async connect(params) {
        var _a, _b;
        if (this.apiClient.isVertexAI()) throw new Error('Live music is not supported for Vertex AI.');
        console.warn('Live music generation is experimental and may change in future versions.');
        const websocketBaseUrl = this.apiClient.getWebsocketBaseUrl();
        const apiVersion = this.apiClient.getApiVersion();
        const headers = $e4deb49dba5321bc$var$mapToHeaders$1(this.apiClient.getDefaultHeaders());
        const apiKey = this.apiClient.getApiKey();
        const url = `${websocketBaseUrl}/ws/google.ai.generativelanguage.${apiVersion}.GenerativeService.BidiGenerateMusic?key=${apiKey}`;
        let onopenResolve = ()=>{};
        const onopenPromise = new Promise((resolve)=>{
            onopenResolve = resolve;
        });
        const callbacks = params.callbacks;
        const onopenAwaitedCallback = function() {
            onopenResolve({});
        };
        const apiClient = this.apiClient;
        const websocketCallbacks = {
            onopen: onopenAwaitedCallback,
            onmessage: (event)=>{
                $e4deb49dba5321bc$var$handleWebSocketMessage$1(apiClient, callbacks.onmessage, event);
            },
            onerror: (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onerror) !== null && _a !== void 0 ? _a : function(e) {},
            onclose: (_b = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onclose) !== null && _b !== void 0 ? _b : function(e) {}
        };
        const conn = this.webSocketFactory.create(url, $e4deb49dba5321bc$var$headersToMap$1(headers), websocketCallbacks);
        conn.connect();
        // Wait for the websocket to open before sending requests.
        await onopenPromise;
        const model = $e4deb49dba5321bc$var$tModel(this.apiClient, params.model);
        const setup = $e4deb49dba5321bc$var$liveMusicClientSetupToMldev({
            model: model
        });
        const clientMessage = $e4deb49dba5321bc$var$liveMusicClientMessageToMldev({
            setup: setup
        });
        conn.send(JSON.stringify(clientMessage));
        return new $e4deb49dba5321bc$var$LiveMusicSession(conn, this.apiClient);
    }
}
/**
   Represents a connection to the API.

   @experimental
  */ class $e4deb49dba5321bc$var$LiveMusicSession {
    constructor(conn, apiClient){
        this.conn = conn;
        this.apiClient = apiClient;
    }
    /**
      Sets inputs to steer music generation. Updates the session's current
      weighted prompts.
  
      @param params - Contains one property, `weightedPrompts`.
  
        - `weightedPrompts` to send to the model; weights are normalized to
          sum to 1.0.
  
      @experimental
     */ async setWeightedPrompts(params) {
        if (!params.weightedPrompts || Object.keys(params.weightedPrompts).length === 0) throw new Error('Weighted prompts must be set and contain at least one entry.');
        const setWeightedPromptsParameters = $e4deb49dba5321bc$var$liveMusicSetWeightedPromptsParametersToMldev(params);
        const clientContent = $e4deb49dba5321bc$var$liveMusicClientContentToMldev(setWeightedPromptsParameters);
        this.conn.send(JSON.stringify({
            clientContent: clientContent
        }));
    }
    /**
      Sets a configuration to the model. Updates the session's current
      music generation config.
  
      @param params - Contains one property, `musicGenerationConfig`.
  
        - `musicGenerationConfig` to set in the model. Passing an empty or
      undefined config to the model will reset the config to defaults.
  
      @experimental
     */ async setMusicGenerationConfig(params) {
        if (!params.musicGenerationConfig) params.musicGenerationConfig = {};
        const setConfigParameters = $e4deb49dba5321bc$var$liveMusicSetConfigParametersToMldev(params);
        const clientMessage = $e4deb49dba5321bc$var$liveMusicClientMessageToMldev(setConfigParameters);
        this.conn.send(JSON.stringify(clientMessage));
    }
    sendPlaybackControl(playbackControl) {
        const clientMessage = $e4deb49dba5321bc$var$liveMusicClientMessageToMldev({
            playbackControl: playbackControl
        });
        this.conn.send(JSON.stringify(clientMessage));
    }
    /**
     * Start the music stream.
     *
     * @experimental
     */ play() {
        this.sendPlaybackControl($e4deb49dba5321bc$export$3d1b3b2fa769f3a.PLAY);
    }
    /**
     * Temporarily halt the music stream. Use `play` to resume from the current
     * position.
     *
     * @experimental
     */ pause() {
        this.sendPlaybackControl($e4deb49dba5321bc$export$3d1b3b2fa769f3a.PAUSE);
    }
    /**
     * Stop the music stream and reset the state. Retains the current prompts
     * and config.
     *
     * @experimental
     */ stop() {
        this.sendPlaybackControl($e4deb49dba5321bc$export$3d1b3b2fa769f3a.STOP);
    }
    /**
     * Resets the context of the music generation without stopping it.
     * Retains the current prompts and config.
     *
     * @experimental
     */ resetContext() {
        this.sendPlaybackControl($e4deb49dba5321bc$export$3d1b3b2fa769f3a.RESET_CONTEXT);
    }
    /**
       Terminates the WebSocket connection.
  
       @experimental
     */ close() {
        this.conn.close();
    }
}
// Converts an headers object to a "map" object as expected by the WebSocket
// constructor. We use this as the Auth interface works with Headers objects
// while the WebSocket constructor takes a map.
function $e4deb49dba5321bc$var$headersToMap$1(headers) {
    const headerMap = {};
    headers.forEach((value, key)=>{
        headerMap[key] = value;
    });
    return headerMap;
}
// Converts a "map" object to a headers object. We use this as the Auth
// interface works with Headers objects while the API client default headers
// returns a map.
function $e4deb49dba5321bc$var$mapToHeaders$1(map) {
    const headers = new Headers();
    for (const [key, value] of Object.entries(map))headers.append(key, value);
    return headers;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $e4deb49dba5321bc$var$FUNCTION_RESPONSE_REQUIRES_ID = 'FunctionResponse request must have an `id` field from the response of a ToolCall.FunctionalCalls in Google AI.';
/**
 * Handles incoming messages from the WebSocket.
 *
 * @remarks
 * This function is responsible for parsing incoming messages, transforming them
 * into LiveServerMessages, and then calling the onmessage callback. Note that
 * the first message which is received from the server is a setupComplete
 * message.
 *
 * @param apiClient The ApiClient instance.
 * @param onmessage The user-provided onmessage callback (if any).
 * @param event The MessageEvent from the WebSocket.
 */ async function $e4deb49dba5321bc$var$handleWebSocketMessage(apiClient, onmessage, event) {
    const serverMessage = new $e4deb49dba5321bc$export$a509bcf6072c871c();
    let jsonData;
    if (event.data instanceof Blob) jsonData = await event.data.text();
    else if (event.data instanceof ArrayBuffer) jsonData = new TextDecoder().decode(event.data);
    else jsonData = event.data;
    const data = JSON.parse(jsonData);
    if (apiClient.isVertexAI()) {
        const resp = $e4deb49dba5321bc$var$liveServerMessageFromVertex(data);
        Object.assign(serverMessage, resp);
    } else {
        const resp = $e4deb49dba5321bc$var$liveServerMessageFromMldev(data);
        Object.assign(serverMessage, resp);
    }
    onmessage(serverMessage);
}
/**
   Live class encapsulates the configuration for live interaction with the
   Generative Language API. It embeds ApiClient for general API settings.

   @experimental
  */ class $e4deb49dba5321bc$export$db78b3d0b2aa666a {
    constructor(apiClient, auth, webSocketFactory){
        this.apiClient = apiClient;
        this.auth = auth;
        this.webSocketFactory = webSocketFactory;
        this.music = new $e4deb49dba5321bc$var$LiveMusic(this.apiClient, this.auth, this.webSocketFactory);
    }
    /**
       Establishes a connection to the specified model with the given
       configuration and returns a Session object representing that connection.
  
       @experimental Built-in MCP support is an experimental feature, may change in
       future versions.
  
       @remarks
  
       @param params - The parameters for establishing a connection to the model.
       @return A live session.
  
       @example
       ```ts
       let model: string;
       if (GOOGLE_GENAI_USE_VERTEXAI) {
         model = 'gemini-2.0-flash-live-preview-04-09';
       } else {
         model = 'gemini-live-2.5-flash-preview';
       }
       const session = await ai.live.connect({
         model: model,
         config: {
           responseModalities: [Modality.AUDIO],
         },
         callbacks: {
           onopen: () => {
             console.log('Connected to the socket.');
           },
           onmessage: (e: MessageEvent) => {
             console.log('Received message from the server: %s\n', debug(e.data));
           },
           onerror: (e: ErrorEvent) => {
             console.log('Error occurred: %s\n', debug(e.error));
           },
           onclose: (e: CloseEvent) => {
             console.log('Connection closed.');
           },
         },
       });
       ```
      */ async connect(params) {
        var _a, _b, _c, _d, _e, _f;
        // TODO: b/404946746 - Support per request HTTP options.
        if (params.config && params.config.httpOptions) throw new Error("The Live module does not support httpOptions at request-level in LiveConnectConfig yet. Please use the client-level httpOptions configuration instead.");
        const websocketBaseUrl = this.apiClient.getWebsocketBaseUrl();
        const apiVersion = this.apiClient.getApiVersion();
        let url;
        const clientHeaders = this.apiClient.getHeaders();
        if (params.config && params.config.tools && $e4deb49dba5321bc$var$hasMcpToolUsage(params.config.tools)) $e4deb49dba5321bc$var$setMcpUsageHeader(clientHeaders);
        const headers = $e4deb49dba5321bc$var$mapToHeaders(clientHeaders);
        if (this.apiClient.isVertexAI()) {
            url = `${websocketBaseUrl}/ws/google.cloud.aiplatform.${apiVersion}.LlmBidiService/BidiGenerateContent`;
            await this.auth.addAuthHeaders(headers);
        } else {
            const apiKey = this.apiClient.getApiKey();
            let method = 'BidiGenerateContent';
            let keyName = 'key';
            if (apiKey === null || apiKey === void 0 ? void 0 : apiKey.startsWith('auth_tokens/')) {
                console.warn('Warning: Ephemeral token support is experimental and may change in future versions.');
                if (apiVersion !== 'v1alpha') console.warn("Warning: The SDK's ephemeral token support is in v1alpha only. Please use const ai = new GoogleGenAI({apiKey: token.name, httpOptions: { apiVersion: 'v1alpha' }}); before session connection.");
                method = 'BidiGenerateContentConstrained';
                keyName = 'access_token';
            }
            url = `${websocketBaseUrl}/ws/google.ai.generativelanguage.${apiVersion}.GenerativeService.${method}?${keyName}=${apiKey}`;
        }
        let onopenResolve = ()=>{};
        const onopenPromise = new Promise((resolve)=>{
            onopenResolve = resolve;
        });
        const callbacks = params.callbacks;
        const onopenAwaitedCallback = function() {
            var _a;
            (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onopen) === null || _a === void 0 || _a.call(callbacks);
            onopenResolve({});
        };
        const apiClient = this.apiClient;
        const websocketCallbacks = {
            onopen: onopenAwaitedCallback,
            onmessage: (event)=>{
                $e4deb49dba5321bc$var$handleWebSocketMessage(apiClient, callbacks.onmessage, event);
            },
            onerror: (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onerror) !== null && _a !== void 0 ? _a : function(e) {},
            onclose: (_b = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onclose) !== null && _b !== void 0 ? _b : function(e) {}
        };
        const conn = this.webSocketFactory.create(url, $e4deb49dba5321bc$var$headersToMap(headers), websocketCallbacks);
        conn.connect();
        // Wait for the websocket to open before sending requests.
        await onopenPromise;
        let transformedModel = $e4deb49dba5321bc$var$tModel(this.apiClient, params.model);
        if (this.apiClient.isVertexAI() && transformedModel.startsWith('publishers/')) {
            const project = this.apiClient.getProject();
            const location = this.apiClient.getLocation();
            transformedModel = `projects/${project}/locations/${location}/` + transformedModel;
        }
        let clientMessage = {};
        if (this.apiClient.isVertexAI() && ((_c = params.config) === null || _c === void 0 ? void 0 : _c.responseModalities) === undefined) {
            // Set default to AUDIO to align with MLDev API.
            if (params.config === undefined) params.config = {
                responseModalities: [
                    $e4deb49dba5321bc$export$9c9a8220008ddfc0.AUDIO
                ]
            };
            else params.config.responseModalities = [
                $e4deb49dba5321bc$export$9c9a8220008ddfc0.AUDIO
            ];
        }
        if ((_d = params.config) === null || _d === void 0 ? void 0 : _d.generationConfig) // Raise deprecation warning for generationConfig.
        console.warn('Setting `LiveConnectConfig.generation_config` is deprecated, please set the fields on `LiveConnectConfig` directly. This will become an error in a future version (not before Q3 2025).');
        const inputTools = (_f = (_e = params.config) === null || _e === void 0 ? void 0 : _e.tools) !== null && _f !== void 0 ? _f : [];
        const convertedTools = [];
        for (const tool of inputTools)if (this.isCallableTool(tool)) {
            const callableTool = tool;
            convertedTools.push(await callableTool.tool());
        } else convertedTools.push(tool);
        if (convertedTools.length > 0) params.config.tools = convertedTools;
        const liveConnectParameters = {
            model: transformedModel,
            config: params.config,
            callbacks: params.callbacks
        };
        if (this.apiClient.isVertexAI()) clientMessage = $e4deb49dba5321bc$var$liveConnectParametersToVertex(this.apiClient, liveConnectParameters);
        else clientMessage = $e4deb49dba5321bc$var$liveConnectParametersToMldev(this.apiClient, liveConnectParameters);
        delete clientMessage['config'];
        conn.send(JSON.stringify(clientMessage));
        return new $e4deb49dba5321bc$export$1fb4852a55678982(conn, this.apiClient);
    }
    // TODO: b/416041229 - Abstract this method to a common place.
    isCallableTool(tool) {
        return 'callTool' in tool && typeof tool.callTool === 'function';
    }
}
const $e4deb49dba5321bc$var$defaultLiveSendClientContentParamerters = {
    turnComplete: true
};
/**
   Represents a connection to the API.

   @experimental
  */ class $e4deb49dba5321bc$export$1fb4852a55678982 {
    constructor(conn, apiClient){
        this.conn = conn;
        this.apiClient = apiClient;
    }
    tLiveClientContent(apiClient, params) {
        if (params.turns !== null && params.turns !== undefined) {
            let contents = [];
            try {
                contents = $e4deb49dba5321bc$var$tContents(params.turns);
                if (apiClient.isVertexAI()) contents = contents.map((item)=>$e4deb49dba5321bc$var$contentToVertex(item));
                else contents = contents.map((item)=>$e4deb49dba5321bc$var$contentToMldev$1(item));
            } catch (_a) {
                throw new Error(`Failed to parse client content "turns", type: '${typeof params.turns}'`);
            }
            return {
                clientContent: {
                    turns: contents,
                    turnComplete: params.turnComplete
                }
            };
        }
        return {
            clientContent: {
                turnComplete: params.turnComplete
            }
        };
    }
    tLiveClienttToolResponse(apiClient, params) {
        let functionResponses = [];
        if (params.functionResponses == null) throw new Error('functionResponses is required.');
        if (!Array.isArray(params.functionResponses)) functionResponses = [
            params.functionResponses
        ];
        else functionResponses = params.functionResponses;
        if (functionResponses.length === 0) throw new Error('functionResponses is required.');
        for (const functionResponse of functionResponses){
            if (typeof functionResponse !== 'object' || functionResponse === null || !('name' in functionResponse) || !('response' in functionResponse)) throw new Error(`Could not parse function response, type '${typeof functionResponse}'.`);
            if (!apiClient.isVertexAI() && !('id' in functionResponse)) throw new Error($e4deb49dba5321bc$var$FUNCTION_RESPONSE_REQUIRES_ID);
        }
        const clientMessage = {
            toolResponse: {
                functionResponses: functionResponses
            }
        };
        return clientMessage;
    }
    /**
      Send a message over the established connection.
  
      @param params - Contains two **optional** properties, `turns` and
          `turnComplete`.
  
        - `turns` will be converted to a `Content[]`
        - `turnComplete: true` [default] indicates that you are done sending
          content and expect a response. If `turnComplete: false`, the server
          will wait for additional messages before starting generation.
  
      @experimental
  
      @remarks
      There are two ways to send messages to the live API:
      `sendClientContent` and `sendRealtimeInput`.
  
      `sendClientContent` messages are added to the model context **in order**.
      Having a conversation using `sendClientContent` messages is roughly
      equivalent to using the `Chat.sendMessageStream`, except that the state of
      the `chat` history is stored on the API server instead of locally.
  
      Because of `sendClientContent`'s order guarantee, the model cannot respons
      as quickly to `sendClientContent` messages as to `sendRealtimeInput`
      messages. This makes the biggest difference when sending objects that have
      significant preprocessing time (typically images).
  
      The `sendClientContent` message sends a `Content[]`
      which has more options than the `Blob` sent by `sendRealtimeInput`.
  
      So the main use-cases for `sendClientContent` over `sendRealtimeInput` are:
  
      - Sending anything that can't be represented as a `Blob` (text,
      `sendClientContent({turns="Hello?"}`)).
      - Managing turns when not using audio input and voice activity detection.
        (`sendClientContent({turnComplete:true})` or the short form
      `sendClientContent()`)
      - Prefilling a conversation context
        ```
        sendClientContent({
            turns: [
              Content({role:user, parts:...}),
              Content({role:user, parts:...}),
              ...
            ]
        })
        ```
      @experimental
     */ sendClientContent(params) {
        params = Object.assign(Object.assign({}, $e4deb49dba5321bc$var$defaultLiveSendClientContentParamerters), params);
        const clientMessage = this.tLiveClientContent(this.apiClient, params);
        this.conn.send(JSON.stringify(clientMessage));
    }
    /**
      Send a realtime message over the established connection.
  
      @param params - Contains one property, `media`.
  
        - `media` will be converted to a `Blob`
  
      @experimental
  
      @remarks
      Use `sendRealtimeInput` for realtime audio chunks and video frames (images).
  
      With `sendRealtimeInput` the api will respond to audio automatically
      based on voice activity detection (VAD).
  
      `sendRealtimeInput` is optimized for responsivness at the expense of
      deterministic ordering guarantees. Audio and video tokens are to the
      context when they become available.
  
      Note: The Call signature expects a `Blob` object, but only a subset
      of audio and image mimetypes are allowed.
     */ sendRealtimeInput(params) {
        let clientMessage = {};
        if (this.apiClient.isVertexAI()) clientMessage = {
            'realtimeInput': $e4deb49dba5321bc$var$liveSendRealtimeInputParametersToVertex(params)
        };
        else clientMessage = {
            'realtimeInput': $e4deb49dba5321bc$var$liveSendRealtimeInputParametersToMldev(params)
        };
        this.conn.send(JSON.stringify(clientMessage));
    }
    /**
      Send a function response message over the established connection.
  
      @param params - Contains property `functionResponses`.
  
        - `functionResponses` will be converted to a `functionResponses[]`
  
      @remarks
      Use `sendFunctionResponse` to reply to `LiveServerToolCall` from the server.
  
      Use {@link types.LiveConnectConfig#tools} to configure the callable functions.
  
      @experimental
     */ sendToolResponse(params) {
        if (params.functionResponses == null) throw new Error('Tool response parameters are required.');
        const clientMessage = this.tLiveClienttToolResponse(this.apiClient, params);
        this.conn.send(JSON.stringify(clientMessage));
    }
    /**
       Terminates the WebSocket connection.
  
       @experimental
  
       @example
       ```ts
       let model: string;
       if (GOOGLE_GENAI_USE_VERTEXAI) {
         model = 'gemini-2.0-flash-live-preview-04-09';
       } else {
         model = 'gemini-live-2.5-flash-preview';
       }
       const session = await ai.live.connect({
         model: model,
         config: {
           responseModalities: [Modality.AUDIO],
         }
       });
  
       session.close();
       ```
     */ close() {
        this.conn.close();
    }
}
// Converts an headers object to a "map" object as expected by the WebSocket
// constructor. We use this as the Auth interface works with Headers objects
// while the WebSocket constructor takes a map.
function $e4deb49dba5321bc$var$headersToMap(headers) {
    const headerMap = {};
    headers.forEach((value, key)=>{
        headerMap[key] = value;
    });
    return headerMap;
}
// Converts a "map" object to a headers object. We use this as the Auth
// interface works with Headers objects while the API client default headers
// returns a map.
function $e4deb49dba5321bc$var$mapToHeaders(map) {
    const headers = new Headers();
    for (const [key, value] of Object.entries(map))headers.append(key, value);
    return headers;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $e4deb49dba5321bc$var$DEFAULT_MAX_REMOTE_CALLS = 10;
/** Returns whether automatic function calling is disabled. */ function $e4deb49dba5321bc$var$shouldDisableAfc(config) {
    var _a, _b, _c;
    if ((_a = config === null || config === void 0 ? void 0 : config.automaticFunctionCalling) === null || _a === void 0 ? void 0 : _a.disable) return true;
    let callableToolsPresent = false;
    for (const tool of (_b = config === null || config === void 0 ? void 0 : config.tools) !== null && _b !== void 0 ? _b : [])if ($e4deb49dba5321bc$var$isCallableTool(tool)) {
        callableToolsPresent = true;
        break;
    }
    if (!callableToolsPresent) return true;
    const maxCalls = (_c = config === null || config === void 0 ? void 0 : config.automaticFunctionCalling) === null || _c === void 0 ? void 0 : _c.maximumRemoteCalls;
    if (maxCalls && (maxCalls < 0 || !Number.isInteger(maxCalls)) || maxCalls == 0) {
        console.warn('Invalid maximumRemoteCalls value provided for automatic function calling. Disabled automatic function calling. Please provide a valid integer value greater than 0. maximumRemoteCalls provided:', maxCalls);
        return true;
    }
    return false;
}
function $e4deb49dba5321bc$var$isCallableTool(tool) {
    return 'callTool' in tool && typeof tool.callTool === 'function';
}
// Checks whether the list of tools contains any CallableTools. Will return true
// if there is at least one CallableTool.
function $e4deb49dba5321bc$var$hasCallableTools(params) {
    var _a, _b, _c;
    return (_c = (_b = (_a = params.config) === null || _a === void 0 ? void 0 : _a.tools) === null || _b === void 0 ? void 0 : _b.some((tool)=>$e4deb49dba5321bc$var$isCallableTool(tool))) !== null && _c !== void 0 ? _c : false;
}
// Checks whether the list of tools contains any non-callable tools. Will return
// true if there is at least one non-Callable tool.
function $e4deb49dba5321bc$var$hasNonCallableTools(params) {
    var _a, _b, _c;
    return (_c = (_b = (_a = params.config) === null || _a === void 0 ? void 0 : _a.tools) === null || _b === void 0 ? void 0 : _b.some((tool)=>!$e4deb49dba5321bc$var$isCallableTool(tool))) !== null && _c !== void 0 ? _c : false;
}
/**
 * Returns whether to append automatic function calling history to the
 * response.
 */ function $e4deb49dba5321bc$var$shouldAppendAfcHistory(config) {
    var _a;
    return !((_a = config === null || config === void 0 ? void 0 : config.automaticFunctionCalling) === null || _a === void 0 ? void 0 : _a.ignoreCallHistory);
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$export$6edbc060ce567afa extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
        /**
         * Makes an API request to generate content with a given model.
         *
         * For the `model` parameter, supported formats for Vertex AI API include:
         * - The Gemini model ID, for example: 'gemini-2.0-flash'
         * - The full resource name starts with 'projects/', for example:
         *  'projects/my-project-id/locations/us-central1/publishers/google/models/gemini-2.0-flash'
         * - The partial resource name with 'publishers/', for example:
         *  'publishers/google/models/gemini-2.0-flash' or
         *  'publishers/meta/models/llama-3.1-405b-instruct-maas'
         * - `/` separated publisher and model name, for example:
         * 'google/gemini-2.0-flash' or 'meta/llama-3.1-405b-instruct-maas'
         *
         * For the `model` parameter, supported formats for Gemini API include:
         * - The Gemini model ID, for example: 'gemini-2.0-flash'
         * - The model name starts with 'models/', for example:
         *  'models/gemini-2.0-flash'
         * - For tuned models, the model name starts with 'tunedModels/',
         * for example:
         * 'tunedModels/1234567890123456789'
         *
         * Some models support multimodal input and output.
         *
         * @param params - The parameters for generating content.
         * @return The response from generating content.
         *
         * @example
         * ```ts
         * const response = await ai.models.generateContent({
         *   model: 'gemini-2.0-flash',
         *   contents: 'why is the sky blue?',
         *   config: {
         *     candidateCount: 2,
         *   }
         * });
         * console.log(response);
         * ```
         */ this.generateContent = async (params)=>{
            var _a, _b, _c, _d, _e;
            const transformedParams = await this.processParamsMaybeAddMcpUsage(params);
            this.maybeMoveToResponseJsonSchem(params);
            if (!$e4deb49dba5321bc$var$hasCallableTools(params) || $e4deb49dba5321bc$var$shouldDisableAfc(params.config)) return await this.generateContentInternal(transformedParams);
            if ($e4deb49dba5321bc$var$hasNonCallableTools(params)) throw new Error('Automatic function calling with CallableTools and Tools is not yet supported.');
            let response;
            let functionResponseContent;
            const automaticFunctionCallingHistory = $e4deb49dba5321bc$var$tContents(transformedParams.contents);
            const maxRemoteCalls = (_c = (_b = (_a = transformedParams.config) === null || _a === void 0 ? void 0 : _a.automaticFunctionCalling) === null || _b === void 0 ? void 0 : _b.maximumRemoteCalls) !== null && _c !== void 0 ? _c : $e4deb49dba5321bc$var$DEFAULT_MAX_REMOTE_CALLS;
            let remoteCalls = 0;
            while(remoteCalls < maxRemoteCalls){
                response = await this.generateContentInternal(transformedParams);
                if (!response.functionCalls || response.functionCalls.length === 0) break;
                const responseContent = response.candidates[0].content;
                const functionResponseParts = [];
                for (const tool of (_e = (_d = params.config) === null || _d === void 0 ? void 0 : _d.tools) !== null && _e !== void 0 ? _e : [])if ($e4deb49dba5321bc$var$isCallableTool(tool)) {
                    const callableTool = tool;
                    const parts = await callableTool.callTool(response.functionCalls);
                    functionResponseParts.push(...parts);
                }
                remoteCalls++;
                functionResponseContent = {
                    role: 'user',
                    parts: functionResponseParts
                };
                transformedParams.contents = $e4deb49dba5321bc$var$tContents(transformedParams.contents);
                transformedParams.contents.push(responseContent);
                transformedParams.contents.push(functionResponseContent);
                if ($e4deb49dba5321bc$var$shouldAppendAfcHistory(transformedParams.config)) {
                    automaticFunctionCallingHistory.push(responseContent);
                    automaticFunctionCallingHistory.push(functionResponseContent);
                }
            }
            if ($e4deb49dba5321bc$var$shouldAppendAfcHistory(transformedParams.config)) response.automaticFunctionCallingHistory = automaticFunctionCallingHistory;
            return response;
        };
        /**
         * Makes an API request to generate content with a given model and yields the
         * response in chunks.
         *
         * For the `model` parameter, supported formats for Vertex AI API include:
         * - The Gemini model ID, for example: 'gemini-2.0-flash'
         * - The full resource name starts with 'projects/', for example:
         *  'projects/my-project-id/locations/us-central1/publishers/google/models/gemini-2.0-flash'
         * - The partial resource name with 'publishers/', for example:
         *  'publishers/google/models/gemini-2.0-flash' or
         *  'publishers/meta/models/llama-3.1-405b-instruct-maas'
         * - `/` separated publisher and model name, for example:
         * 'google/gemini-2.0-flash' or 'meta/llama-3.1-405b-instruct-maas'
         *
         * For the `model` parameter, supported formats for Gemini API include:
         * - The Gemini model ID, for example: 'gemini-2.0-flash'
         * - The model name starts with 'models/', for example:
         *  'models/gemini-2.0-flash'
         * - For tuned models, the model name starts with 'tunedModels/',
         * for example:
         *  'tunedModels/1234567890123456789'
         *
         * Some models support multimodal input and output.
         *
         * @param params - The parameters for generating content with streaming response.
         * @return The response from generating content.
         *
         * @example
         * ```ts
         * const response = await ai.models.generateContentStream({
         *   model: 'gemini-2.0-flash',
         *   contents: 'why is the sky blue?',
         *   config: {
         *     maxOutputTokens: 200,
         *   }
         * });
         * for await (const chunk of response) {
         *   console.log(chunk);
         * }
         * ```
         */ this.generateContentStream = async (params)=>{
            this.maybeMoveToResponseJsonSchem(params);
            if ($e4deb49dba5321bc$var$shouldDisableAfc(params.config)) {
                const transformedParams = await this.processParamsMaybeAddMcpUsage(params);
                return await this.generateContentStreamInternal(transformedParams);
            } else return await this.processAfcStream(params);
        };
        /**
         * Generates an image based on a text description and configuration.
         *
         * @param params - The parameters for generating images.
         * @return The response from the API.
         *
         * @example
         * ```ts
         * const response = await client.models.generateImages({
         *  model: 'imagen-3.0-generate-002',
         *  prompt: 'Robot holding a red skateboard',
         *  config: {
         *    numberOfImages: 1,
         *    includeRaiReason: true,
         *  },
         * });
         * console.log(response?.generatedImages?.[0]?.image?.imageBytes);
         * ```
         */ this.generateImages = async (params)=>{
            return await this.generateImagesInternal(params).then((apiResponse)=>{
                var _a;
                let positivePromptSafetyAttributes;
                const generatedImages = [];
                if (apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.generatedImages) {
                    for (const generatedImage of apiResponse.generatedImages)if (generatedImage && (generatedImage === null || generatedImage === void 0 ? void 0 : generatedImage.safetyAttributes) && ((_a = generatedImage === null || generatedImage === void 0 ? void 0 : generatedImage.safetyAttributes) === null || _a === void 0 ? void 0 : _a.contentType) === 'Positive Prompt') positivePromptSafetyAttributes = generatedImage === null || generatedImage === void 0 ? void 0 : generatedImage.safetyAttributes;
                    else generatedImages.push(generatedImage);
                }
                let response;
                if (positivePromptSafetyAttributes) response = {
                    generatedImages: generatedImages,
                    positivePromptSafetyAttributes: positivePromptSafetyAttributes,
                    sdkHttpResponse: apiResponse.sdkHttpResponse
                };
                else response = {
                    generatedImages: generatedImages,
                    sdkHttpResponse: apiResponse.sdkHttpResponse
                };
                return response;
            });
        };
        this.list = async (params)=>{
            var _a;
            const defaultConfig = {
                queryBase: true
            };
            const actualConfig = Object.assign(Object.assign({}, defaultConfig), params === null || params === void 0 ? void 0 : params.config);
            const actualParams = {
                config: actualConfig
            };
            if (this.apiClient.isVertexAI()) {
                if (!actualParams.config.queryBase) {
                    if ((_a = actualParams.config) === null || _a === void 0 ? void 0 : _a.filter) throw new Error('Filtering tuned models list for Vertex AI is not currently supported');
                    else actualParams.config.filter = 'labels.tune-type:*';
                }
            }
            return new $e4deb49dba5321bc$export$57625d62e5386b09($e4deb49dba5321bc$export$e18b8de308fd2439.PAGED_ITEM_MODELS, (x)=>this.listInternal(x), await this.listInternal(actualParams), actualParams);
        };
        /**
         * Edits an image based on a prompt, list of reference images, and configuration.
         *
         * @param params - The parameters for editing an image.
         * @return The response from the API.
         *
         * @example
         * ```ts
         * const response = await client.models.editImage({
         *  model: 'imagen-3.0-capability-001',
         *  prompt: 'Generate an image containing a mug with the product logo [1] visible on the side of the mug.',
         *  referenceImages: [subjectReferenceImage]
         *  config: {
         *    numberOfImages: 1,
         *    includeRaiReason: true,
         *  },
         * });
         * console.log(response?.generatedImages?.[0]?.image?.imageBytes);
         * ```
         */ this.editImage = async (params)=>{
            const paramsInternal = {
                model: params.model,
                prompt: params.prompt,
                referenceImages: [],
                config: params.config
            };
            if (params.referenceImages) {
                if (params.referenceImages) paramsInternal.referenceImages = params.referenceImages.map((img)=>img.toReferenceImageAPI());
            }
            return await this.editImageInternal(paramsInternal);
        };
        /**
         * Upscales an image based on an image, upscale factor, and configuration.
         * Only supported in Vertex AI currently.
         *
         * @param params - The parameters for upscaling an image.
         * @return The response from the API.
         *
         * @example
         * ```ts
         * const response = await client.models.upscaleImage({
         *  model: 'imagen-3.0-generate-002',
         *  image: image,
         *  upscaleFactor: 'x2',
         *  config: {
         *    includeRaiReason: true,
         *  },
         * });
         * console.log(response?.generatedImages?.[0]?.image?.imageBytes);
         * ```
         */ this.upscaleImage = async (params)=>{
            let apiConfig = {
                numberOfImages: 1,
                mode: 'upscale'
            };
            if (params.config) apiConfig = Object.assign(Object.assign({}, apiConfig), params.config);
            const apiParams = {
                model: params.model,
                image: params.image,
                upscaleFactor: params.upscaleFactor,
                config: apiConfig
            };
            return await this.upscaleImageInternal(apiParams);
        };
        /**
         *  Generates videos based on a text description and configuration.
         *
         * @param params - The parameters for generating videos.
         * @return A Promise<GenerateVideosOperation> which allows you to track the progress and eventually retrieve the generated videos using the operations.get method.
         *
         * @example
         * ```ts
         * const operation = await ai.models.generateVideos({
         *  model: 'veo-2.0-generate-001',
         *  source: {
         *    prompt: 'A neon hologram of a cat driving at top speed',
         *  },
         *  config: {
         *    numberOfVideos: 1
         * });
         *
         * while (!operation.done) {
         *   await new Promise(resolve => setTimeout(resolve, 10000));
         *   operation = await ai.operations.getVideosOperation({operation: operation});
         * }
         *
         * console.log(operation.response?.generatedVideos?.[0]?.video?.uri);
         * ```
         */ this.generateVideos = async (params)=>{
            if ((params.prompt || params.image || params.video) && params.source) throw new Error('Source and prompt/image/video are mutually exclusive. Please only use source.');
            return await this.generateVideosInternal(params);
        };
    }
    /**
     * This logic is needed for GenerateContentConfig only.
     * Previously we made GenerateContentConfig.responseSchema field to accept
     * unknown. Since v1.9.0, we switch to use backend JSON schema support.
     * To maintain backward compatibility, we move the data that was treated as
     * JSON schema from the responseSchema field to the responseJsonSchema field.
     */ maybeMoveToResponseJsonSchem(params) {
        if (params.config && params.config.responseSchema) {
            if (!params.config.responseJsonSchema) {
                if (Object.keys(params.config.responseSchema).includes('$schema')) {
                    params.config.responseJsonSchema = params.config.responseSchema;
                    delete params.config.responseSchema;
                }
            }
        }
        return;
    }
    /**
     * Transforms the CallableTools in the parameters to be simply Tools, it
     * copies the params into a new object and replaces the tools, it does not
     * modify the original params. Also sets the MCP usage header if there are
     * MCP tools in the parameters.
     */ async processParamsMaybeAddMcpUsage(params) {
        var _a, _b, _c;
        const tools = (_a = params.config) === null || _a === void 0 ? void 0 : _a.tools;
        if (!tools) return params;
        const transformedTools = await Promise.all(tools.map(async (tool)=>{
            if ($e4deb49dba5321bc$var$isCallableTool(tool)) {
                const callableTool = tool;
                return await callableTool.tool();
            }
            return tool;
        }));
        const newParams = {
            model: params.model,
            contents: params.contents,
            config: Object.assign(Object.assign({}, params.config), {
                tools: transformedTools
            })
        };
        newParams.config.tools = transformedTools;
        if (params.config && params.config.tools && $e4deb49dba5321bc$var$hasMcpToolUsage(params.config.tools)) {
            const headers = (_c = (_b = params.config.httpOptions) === null || _b === void 0 ? void 0 : _b.headers) !== null && _c !== void 0 ? _c : {};
            let newHeaders = Object.assign({}, headers);
            if (Object.keys(newHeaders).length === 0) newHeaders = this.apiClient.getDefaultHeaders();
            $e4deb49dba5321bc$var$setMcpUsageHeader(newHeaders);
            newParams.config.httpOptions = Object.assign(Object.assign({}, params.config.httpOptions), {
                headers: newHeaders
            });
        }
        return newParams;
    }
    async initAfcToolsMap(params) {
        var _a, _b, _c;
        const afcTools = new Map();
        for (const tool of (_b = (_a = params.config) === null || _a === void 0 ? void 0 : _a.tools) !== null && _b !== void 0 ? _b : [])if ($e4deb49dba5321bc$var$isCallableTool(tool)) {
            const callableTool = tool;
            const toolDeclaration = await callableTool.tool();
            for (const declaration of (_c = toolDeclaration.functionDeclarations) !== null && _c !== void 0 ? _c : []){
                if (!declaration.name) throw new Error('Function declaration name is required.');
                if (afcTools.has(declaration.name)) throw new Error(`Duplicate tool declaration name: ${declaration.name}`);
                afcTools.set(declaration.name, callableTool);
            }
        }
        return afcTools;
    }
    async processAfcStream(params) {
        var _a, _b, _c;
        const maxRemoteCalls = (_c = (_b = (_a = params.config) === null || _a === void 0 ? void 0 : _a.automaticFunctionCalling) === null || _b === void 0 ? void 0 : _b.maximumRemoteCalls) !== null && _c !== void 0 ? _c : $e4deb49dba5321bc$var$DEFAULT_MAX_REMOTE_CALLS;
        let wereFunctionsCalled = false;
        let remoteCallCount = 0;
        const afcToolsMap = await this.initAfcToolsMap(params);
        return function(models, afcTools, params) {
            var _a, _b;
            return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function*() {
                var _c, e_1, _d, _e;
                while(remoteCallCount < maxRemoteCalls){
                    if (wereFunctionsCalled) {
                        remoteCallCount++;
                        wereFunctionsCalled = false;
                    }
                    const transformedParams = yield $e4deb49dba5321bc$var$__await(models.processParamsMaybeAddMcpUsage(params));
                    const response = yield $e4deb49dba5321bc$var$__await(models.generateContentStreamInternal(transformedParams));
                    const functionResponses = [];
                    const responseContents = [];
                    try {
                        for(var _f = true, response_1 = (e_1 = void 0, $e4deb49dba5321bc$var$__asyncValues(response)), response_1_1; response_1_1 = yield $e4deb49dba5321bc$var$__await(response_1.next()), _c = response_1_1.done, !_c; _f = true){
                            _e = response_1_1.value;
                            _f = false;
                            const chunk = _e;
                            yield yield $e4deb49dba5321bc$var$__await(chunk);
                            if (chunk.candidates && ((_a = chunk.candidates[0]) === null || _a === void 0 ? void 0 : _a.content)) {
                                responseContents.push(chunk.candidates[0].content);
                                for (const part of (_b = chunk.candidates[0].content.parts) !== null && _b !== void 0 ? _b : [])if (remoteCallCount < maxRemoteCalls && part.functionCall) {
                                    if (!part.functionCall.name) throw new Error('Function call name was not returned by the model.');
                                    if (!afcTools.has(part.functionCall.name)) throw new Error(`Automatic function calling was requested, but not all the tools the model used implement the CallableTool interface. Available tools: ${afcTools.keys()}, mising tool: ${part.functionCall.name}`);
                                    else {
                                        const responseParts = yield $e4deb49dba5321bc$var$__await(afcTools.get(part.functionCall.name).callTool([
                                            part.functionCall
                                        ]));
                                        functionResponses.push(...responseParts);
                                    }
                                }
                            }
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (!_f && !_c && (_d = response_1.return)) yield $e4deb49dba5321bc$var$__await(_d.call(response_1));
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    if (functionResponses.length > 0) {
                        wereFunctionsCalled = true;
                        const typedResponseChunk = new $e4deb49dba5321bc$export$87445595052c5212();
                        typedResponseChunk.candidates = [
                            {
                                content: {
                                    role: 'user',
                                    parts: functionResponses
                                }
                            }
                        ];
                        yield yield $e4deb49dba5321bc$var$__await(typedResponseChunk);
                        const newContents = [];
                        newContents.push(...responseContents);
                        newContents.push({
                            role: 'user',
                            parts: functionResponses
                        });
                        const updatedContents = $e4deb49dba5321bc$var$tContents(params.contents).concat(newContents);
                        params.contents = updatedContents;
                    } else break;
                }
            });
        }(this, afcToolsMap, params);
    }
    async generateContentInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$generateContentParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:generateContent', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$generateContentResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$87445595052c5212();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$generateContentParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:generateContent', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$generateContentResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$87445595052c5212();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    async generateContentStreamInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$generateContentParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:streamGenerateContent?alt=sse', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            const apiClient = this.apiClient;
            response = apiClient.requestStream({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            });
            return response.then(function(apiResponse) {
                return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function*() {
                    var _a, e_2, _b, _c;
                    try {
                        for(var _d = true, apiResponse_1 = $e4deb49dba5321bc$var$__asyncValues(apiResponse), apiResponse_1_1; apiResponse_1_1 = yield $e4deb49dba5321bc$var$__await(apiResponse_1.next()), _a = apiResponse_1_1.done, !_a; _d = true){
                            _c = apiResponse_1_1.value;
                            _d = false;
                            const chunk = _c;
                            const resp = $e4deb49dba5321bc$var$generateContentResponseFromVertex((yield $e4deb49dba5321bc$var$__await(chunk.json())));
                            resp['sdkHttpResponse'] = {
                                headers: chunk.headers
                            };
                            const typedResp = new $e4deb49dba5321bc$export$87445595052c5212();
                            Object.assign(typedResp, resp);
                            yield yield $e4deb49dba5321bc$var$__await(typedResp);
                        }
                    } catch (e_2_1) {
                        e_2 = {
                            error: e_2_1
                        };
                    } finally{
                        try {
                            if (!_d && !_a && (_b = apiResponse_1.return)) yield $e4deb49dba5321bc$var$__await(_b.call(apiResponse_1));
                        } finally{
                            if (e_2) throw e_2.error;
                        }
                    }
                });
            });
        } else {
            const body = $e4deb49dba5321bc$var$generateContentParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:streamGenerateContent?alt=sse', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            const apiClient = this.apiClient;
            response = apiClient.requestStream({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            });
            return response.then(function(apiResponse) {
                return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function*() {
                    var _a, e_3, _b, _c;
                    try {
                        for(var _d = true, apiResponse_2 = $e4deb49dba5321bc$var$__asyncValues(apiResponse), apiResponse_2_1; apiResponse_2_1 = yield $e4deb49dba5321bc$var$__await(apiResponse_2.next()), _a = apiResponse_2_1.done, !_a; _d = true){
                            _c = apiResponse_2_1.value;
                            _d = false;
                            const chunk = _c;
                            const resp = $e4deb49dba5321bc$var$generateContentResponseFromMldev((yield $e4deb49dba5321bc$var$__await(chunk.json())));
                            resp['sdkHttpResponse'] = {
                                headers: chunk.headers
                            };
                            const typedResp = new $e4deb49dba5321bc$export$87445595052c5212();
                            Object.assign(typedResp, resp);
                            yield yield $e4deb49dba5321bc$var$__await(typedResp);
                        }
                    } catch (e_3_1) {
                        e_3 = {
                            error: e_3_1
                        };
                    } finally{
                        try {
                            if (!_d && !_a && (_b = apiResponse_2.return)) yield $e4deb49dba5321bc$var$__await(_b.call(apiResponse_2));
                        } finally{
                            if (e_3) throw e_3.error;
                        }
                    }
                });
            });
        }
    }
    /**
     * Calculates embeddings for the given contents. Only text is supported.
     *
     * @param params - The parameters for embedding contents.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response = await ai.models.embedContent({
     *  model: 'text-embedding-004',
     *  contents: [
     *    'What is your name?',
     *    'What is your favorite color?',
     *  ],
     *  config: {
     *    outputDimensionality: 64,
     *  },
     * });
     * console.log(response);
     * ```
     */ async embedContent(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$embedContentParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predict', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$embedContentResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$1e9eee8641627f00();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$embedContentParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:batchEmbedContents', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$embedContentResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$1e9eee8641627f00();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Private method for generating images.
     */ async generateImagesInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$generateImagesParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predict', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$generateImagesResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$f08095e7138eb0f4();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$generateImagesParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predict', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$generateImagesResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$f08095e7138eb0f4();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Private method for editing an image.
     */ async editImageInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$editImageParametersInternalToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predict', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$editImageResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$661afcf00ed2fbe8();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
    /**
     * Private method for upscaling an image.
     */ async upscaleImageInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$upscaleImageAPIParametersInternalToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predict', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$upscaleImageResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$690402256314214();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
    /**
     * Recontextualizes an image.
     *
     * There are two types of recontextualization currently supported:
     * 1) Imagen Product Recontext - Generate images of products in new scenes
     *    and contexts.
     * 2) Virtual Try-On: Generate images of persons modeling fashion products.
     *
     * @param params - The parameters for recontextualizing an image.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response1 = await ai.models.recontextImage({
     *  model: 'imagen-product-recontext-preview-06-30',
     *  source: {
     *    prompt: 'In a modern kitchen setting.',
     *    productImages: [productImage],
     *  },
     *  config: {
     *    numberOfImages: 1,
     *  },
     * });
     * console.log(response1?.generatedImages?.[0]?.image?.imageBytes);
     *
     * const response2 = await ai.models.recontextImage({
     *  model: 'virtual-try-on-preview-08-04',
     *  source: {
     *    personImage: personImage,
     *    productImages: [productImage],
     *  },
     *  config: {
     *    numberOfImages: 1,
     *  },
     * });
     * console.log(response2?.generatedImages?.[0]?.image?.imageBytes);
     * ```
     */ async recontextImage(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$recontextImageParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predict', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$recontextImageResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$c2ead2074351d0f2();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
    /**
     * Segments an image, creating a mask of a specified area.
     *
     * @param params - The parameters for segmenting an image.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response = await ai.models.segmentImage({
     *  model: 'image-segmentation-001',
     *  source: {
     *    image: image,
     *  },
     *  config: {
     *    mode: 'foreground',
     *  },
     * });
     * console.log(response?.generatedMasks?.[0]?.mask?.imageBytes);
     * ```
     */ async segmentImage(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$segmentImageParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predict', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$segmentImageResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$304f360366a6eb53();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
    /**
     * Fetches information about a model by name.
     *
     * @example
     * ```ts
     * const modelInfo = await ai.models.get({model: 'gemini-2.0-flash'});
     * ```
     */ async get(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$getModelParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$modelFromVertex(apiResponse);
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$getModelParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$modelFromMldev(apiResponse);
                return resp;
            });
        }
    }
    async listInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$listModelsParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{models_url}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listModelsResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$f159131a50016456();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$listModelsParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{models_url}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listModelsResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$f159131a50016456();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Updates a tuned model by its name.
     *
     * @param params - The parameters for updating the model.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response = await ai.models.update({
     *   model: 'tuned-model-name',
     *   config: {
     *     displayName: 'New display name',
     *     description: 'New description',
     *   },
     * });
     * ```
     */ async update(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$updateModelParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'PATCH',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$modelFromVertex(apiResponse);
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$updateModelParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'PATCH',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$modelFromMldev(apiResponse);
                return resp;
            });
        }
    }
    /**
     * Deletes a tuned model by its name.
     *
     * @param params - The parameters for deleting the model.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response = await ai.models.delete({model: 'tuned-model-name'});
     * ```
     */ async delete(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$deleteModelParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$deleteModelResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$179335935ae1d762();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$deleteModelParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$deleteModelResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$179335935ae1d762();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Counts the number of tokens in the given contents. Multimodal input is
     * supported for Gemini models.
     *
     * @param params - The parameters for counting tokens.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response = await ai.models.countTokens({
     *  model: 'gemini-2.0-flash',
     *  contents: 'The quick brown fox jumps over the lazy dog.'
     * });
     * console.log(response);
     * ```
     */ async countTokens(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$countTokensParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:countTokens', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$countTokensResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$b2422e769fe9acde();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$countTokensParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:countTokens', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$countTokensResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$b2422e769fe9acde();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Given a list of contents, returns a corresponding TokensInfo containing
     * the list of tokens and list of token ids.
     *
     * This method is not supported by the Gemini Developer API.
     *
     * @param params - The parameters for computing tokens.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response = await ai.models.computeTokens({
     *  model: 'gemini-2.0-flash',
     *  contents: 'What is your name?'
     * });
     * console.log(response);
     * ```
     */ async computeTokens(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$computeTokensParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:computeTokens', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$computeTokensResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$8fb35c7d28173be();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
    /**
     * Private method for generating videos.
     */ async generateVideosInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$generateVideosParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predictLongRunning', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$generateVideosOperationFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$d39812a6cdac2c57();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$generateVideosParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predictLongRunning', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$generateVideosOperationFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$d39812a6cdac2c57();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$export$3d72bd1ae0aee044 extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
    }
    /**
     * Gets the status of a long-running operation.
     *
     * @param parameters The parameters for the get operation request.
     * @return The updated Operation object, with the latest status or result.
     */ async getVideosOperation(parameters) {
        const operation = parameters.operation;
        const config = parameters.config;
        if (operation.name === undefined || operation.name === '') throw new Error('Operation name is required.');
        if (this.apiClient.isVertexAI()) {
            const resourceName = operation.name.split('/operations/')[0];
            let httpOptions = undefined;
            if (config && 'httpOptions' in config) httpOptions = config.httpOptions;
            const rawOperation = await this.fetchPredictVideosOperationInternal({
                operationName: operation.name,
                resourceName: resourceName,
                config: {
                    httpOptions: httpOptions
                }
            });
            return operation._fromAPIResponse({
                apiResponse: rawOperation,
                isVertexAI: true
            });
        } else {
            const rawOperation = await this.getVideosOperationInternal({
                operationName: operation.name,
                config: config
            });
            return operation._fromAPIResponse({
                apiResponse: rawOperation,
                isVertexAI: false
            });
        }
    }
    /**
     * Gets the status of a long-running operation.
     *
     * @param parameters The parameters for the get operation request.
     * @return The updated Operation object, with the latest status or result.
     */ async get(parameters) {
        const operation = parameters.operation;
        const config = parameters.config;
        if (operation.name === undefined || operation.name === '') throw new Error('Operation name is required.');
        if (this.apiClient.isVertexAI()) {
            const resourceName = operation.name.split('/operations/')[0];
            let httpOptions = undefined;
            if (config && 'httpOptions' in config) httpOptions = config.httpOptions;
            const rawOperation = await this.fetchPredictVideosOperationInternal({
                operationName: operation.name,
                resourceName: resourceName,
                config: {
                    httpOptions: httpOptions
                }
            });
            return operation._fromAPIResponse({
                apiResponse: rawOperation,
                isVertexAI: true
            });
        } else {
            const rawOperation = await this.getVideosOperationInternal({
                operationName: operation.name,
                config: config
            });
            return operation._fromAPIResponse({
                apiResponse: rawOperation,
                isVertexAI: false
            });
        }
    }
    async getVideosOperationInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$getOperationParametersToVertex(params);
            path = $e4deb49dba5321bc$var$formatMap('{operationName}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response;
        } else {
            const body = $e4deb49dba5321bc$var$getOperationParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('{operationName}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response;
        }
    }
    async fetchPredictVideosOperationInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$fetchPredictOperationParametersToVertex(params);
            path = $e4deb49dba5321bc$var$formatMap('{resourceName}:fetchPredictOperation', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response;
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$prebuiltVoiceConfigToMldev(fromObject) {
    const toObject = {};
    const fromVoiceName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceName'
    ]);
    if (fromVoiceName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceName'
    ], fromVoiceName);
    return toObject;
}
function $e4deb49dba5321bc$var$voiceConfigToMldev(fromObject) {
    const toObject = {};
    const fromPrebuiltVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prebuiltVoiceConfig'
    ]);
    if (fromPrebuiltVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'prebuiltVoiceConfig'
    ], $e4deb49dba5321bc$var$prebuiltVoiceConfigToMldev(fromPrebuiltVoiceConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$speakerVoiceConfigToMldev(fromObject) {
    const toObject = {};
    const fromSpeaker = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speaker'
    ]);
    if (fromSpeaker != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'speaker'
    ], fromSpeaker);
    const fromVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceConfig'
    ]);
    if (fromVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceConfig'
    ], $e4deb49dba5321bc$var$voiceConfigToMldev(fromVoiceConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$multiSpeakerVoiceConfigToMldev(fromObject) {
    const toObject = {};
    const fromSpeakerVoiceConfigs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speakerVoiceConfigs'
    ]);
    if (fromSpeakerVoiceConfigs != null) {
        let transformedList = fromSpeakerVoiceConfigs;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$speakerVoiceConfigToMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'speakerVoiceConfigs'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$speechConfigToMldev(fromObject) {
    const toObject = {};
    const fromVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceConfig'
    ]);
    if (fromVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceConfig'
    ], $e4deb49dba5321bc$var$voiceConfigToMldev(fromVoiceConfig));
    const fromMultiSpeakerVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'multiSpeakerVoiceConfig'
    ]);
    if (fromMultiSpeakerVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'multiSpeakerVoiceConfig'
    ], $e4deb49dba5321bc$var$multiSpeakerVoiceConfigToMldev(fromMultiSpeakerVoiceConfig));
    const fromLanguageCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'languageCode'
    ]);
    if (fromLanguageCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'languageCode'
    ], fromLanguageCode);
    return toObject;
}
function $e4deb49dba5321bc$var$videoMetadataToMldev(fromObject) {
    const toObject = {};
    const fromFps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fps'
    ]);
    if (fromFps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fps'
    ], fromFps);
    const fromEndOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endOffset'
    ]);
    if (fromEndOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endOffset'
    ], fromEndOffset);
    const fromStartOffset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startOffset'
    ]);
    if (fromStartOffset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startOffset'
    ], fromStartOffset);
    return toObject;
}
function $e4deb49dba5321bc$var$blobToMldev(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$fileDataToMldev(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromFileUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallToMldev(fromObject) {
    const toObject = {};
    const fromId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'id'
    ]);
    if (fromId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'id'
    ], fromId);
    const fromArgs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$partToMldev(fromObject) {
    const toObject = {};
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], $e4deb49dba5321bc$var$videoMetadataToMldev(fromVideoMetadata));
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], $e4deb49dba5321bc$var$blobToMldev(fromInlineData));
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], $e4deb49dba5321bc$var$fileDataToMldev(fromFileData));
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], $e4deb49dba5321bc$var$functionCallToMldev(fromFunctionCall));
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    return toObject;
}
function $e4deb49dba5321bc$var$contentToMldev(fromObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partToMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$functionDeclarationToMldev(fromObject) {
    const toObject = {};
    const fromBehavior = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'behavior'
    ]);
    if (fromBehavior != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'behavior'
    ], fromBehavior);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromParameters = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parameters'
    ]);
    if (fromParameters != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parameters'
    ], fromParameters);
    const fromParametersJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parametersJsonSchema'
    ]);
    if (fromParametersJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parametersJsonSchema'
    ], fromParametersJsonSchema);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], fromResponse);
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    return toObject;
}
function $e4deb49dba5321bc$var$intervalToMldev(fromObject) {
    const toObject = {};
    const fromStartTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startTime'
    ]);
    if (fromStartTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endTime'
    ]);
    if (fromEndTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchToMldev(fromObject) {
    const toObject = {};
    const fromTimeRangeFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'timeRangeFilter'
    ], $e4deb49dba5321bc$var$intervalToMldev(fromTimeRangeFilter));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'excludeDomains'
    ]) !== undefined) throw new Error('excludeDomains parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$dynamicRetrievalConfigToMldev(fromObject) {
    const toObject = {};
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mode'
    ], fromMode);
    const fromDynamicThreshold = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'dynamicThreshold'
    ]);
    if (fromDynamicThreshold != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dynamicThreshold'
    ], fromDynamicThreshold);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchRetrievalToMldev(fromObject) {
    const toObject = {};
    const fromDynamicRetrievalConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'dynamicRetrievalConfig'
    ]);
    if (fromDynamicRetrievalConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dynamicRetrievalConfig'
    ], $e4deb49dba5321bc$var$dynamicRetrievalConfigToMldev(fromDynamicRetrievalConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$urlContextToMldev() {
    const toObject = {};
    return toObject;
}
function $e4deb49dba5321bc$var$toolComputerUseToMldev(fromObject) {
    const toObject = {};
    const fromEnvironment = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'environment'
    ]);
    if (fromEnvironment != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'environment'
    ], fromEnvironment);
    return toObject;
}
function $e4deb49dba5321bc$var$toolToMldev(fromObject) {
    const toObject = {};
    const fromFunctionDeclarations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$functionDeclarationToMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrieval'
    ]) !== undefined) throw new Error('retrieval parameter is not supported in Gemini API.');
    const fromGoogleSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearch'
    ], $e4deb49dba5321bc$var$googleSearchToMldev(fromGoogleSearch));
    const fromGoogleSearchRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], $e4deb49dba5321bc$var$googleSearchRetrievalToMldev(fromGoogleSearchRetrieval));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]) !== undefined) throw new Error('enterpriseWebSearch parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleMaps'
    ]) !== undefined) throw new Error('googleMaps parameter is not supported in Gemini API.');
    const fromUrlContext = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContext'
    ], $e4deb49dba5321bc$var$urlContextToMldev());
    const fromComputerUse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'computerUse'
    ]);
    if (fromComputerUse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computerUse'
    ], $e4deb49dba5321bc$var$toolComputerUseToMldev(fromComputerUse));
    const fromCodeExecution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    return toObject;
}
function $e4deb49dba5321bc$var$sessionResumptionConfigToMldev(fromObject) {
    const toObject = {};
    const fromHandle = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'handle'
    ]);
    if (fromHandle != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'handle'
    ], fromHandle);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'transparent'
    ]) !== undefined) throw new Error('transparent parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$audioTranscriptionConfigToMldev() {
    const toObject = {};
    return toObject;
}
function $e4deb49dba5321bc$var$automaticActivityDetectionToMldev(fromObject) {
    const toObject = {};
    const fromDisabled = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'disabled'
    ]);
    if (fromDisabled != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'disabled'
    ], fromDisabled);
    const fromStartOfSpeechSensitivity = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startOfSpeechSensitivity'
    ]);
    if (fromStartOfSpeechSensitivity != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startOfSpeechSensitivity'
    ], fromStartOfSpeechSensitivity);
    const fromEndOfSpeechSensitivity = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endOfSpeechSensitivity'
    ]);
    if (fromEndOfSpeechSensitivity != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endOfSpeechSensitivity'
    ], fromEndOfSpeechSensitivity);
    const fromPrefixPaddingMs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prefixPaddingMs'
    ]);
    if (fromPrefixPaddingMs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'prefixPaddingMs'
    ], fromPrefixPaddingMs);
    const fromSilenceDurationMs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'silenceDurationMs'
    ]);
    if (fromSilenceDurationMs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'silenceDurationMs'
    ], fromSilenceDurationMs);
    return toObject;
}
function $e4deb49dba5321bc$var$realtimeInputConfigToMldev(fromObject) {
    const toObject = {};
    const fromAutomaticActivityDetection = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'automaticActivityDetection'
    ]);
    if (fromAutomaticActivityDetection != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'automaticActivityDetection'
    ], $e4deb49dba5321bc$var$automaticActivityDetectionToMldev(fromAutomaticActivityDetection));
    const fromActivityHandling = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'activityHandling'
    ]);
    if (fromActivityHandling != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'activityHandling'
    ], fromActivityHandling);
    const fromTurnCoverage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'turnCoverage'
    ]);
    if (fromTurnCoverage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'turnCoverage'
    ], fromTurnCoverage);
    return toObject;
}
function $e4deb49dba5321bc$var$slidingWindowToMldev(fromObject) {
    const toObject = {};
    const fromTargetTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'targetTokens'
    ]);
    if (fromTargetTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'targetTokens'
    ], fromTargetTokens);
    return toObject;
}
function $e4deb49dba5321bc$var$contextWindowCompressionConfigToMldev(fromObject) {
    const toObject = {};
    const fromTriggerTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'triggerTokens'
    ]);
    if (fromTriggerTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'triggerTokens'
    ], fromTriggerTokens);
    const fromSlidingWindow = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'slidingWindow'
    ]);
    if (fromSlidingWindow != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'slidingWindow'
    ], $e4deb49dba5321bc$var$slidingWindowToMldev(fromSlidingWindow));
    return toObject;
}
function $e4deb49dba5321bc$var$proactivityConfigToMldev(fromObject) {
    const toObject = {};
    const fromProactiveAudio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'proactiveAudio'
    ]);
    if (fromProactiveAudio != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'proactiveAudio'
    ], fromProactiveAudio);
    return toObject;
}
function $e4deb49dba5321bc$var$liveConnectConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromGenerationConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generationConfig'
    ]);
    if (parentObject !== undefined && fromGenerationConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig'
    ], fromGenerationConfig);
    const fromResponseModalities = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (parentObject !== undefined && fromResponseModalities != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'responseModalities'
    ], fromResponseModalities);
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (parentObject !== undefined && fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'temperature'
    ], fromTemperature);
    const fromTopP = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topP'
    ]);
    if (parentObject !== undefined && fromTopP != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'topP'
    ], fromTopP);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (parentObject !== undefined && fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'topK'
    ], fromTopK);
    const fromMaxOutputTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (parentObject !== undefined && fromMaxOutputTokens != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (parentObject !== undefined && fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'mediaResolution'
    ], fromMediaResolution);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'seed'
    ], fromSeed);
    const fromSpeechConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (parentObject !== undefined && fromSpeechConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'speechConfig'
    ], $e4deb49dba5321bc$var$speechConfigToMldev($e4deb49dba5321bc$var$tLiveSpeechConfig(fromSpeechConfig)));
    const fromEnableAffectiveDialog = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableAffectiveDialog'
    ]);
    if (parentObject !== undefined && fromEnableAffectiveDialog != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'enableAffectiveDialog'
    ], fromEnableAffectiveDialog);
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'systemInstruction'
    ], $e4deb49dba5321bc$var$contentToMldev($e4deb49dba5321bc$var$tContent(fromSystemInstruction)));
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = $e4deb49dba5321bc$var$tTools(fromTools);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToMldev($e4deb49dba5321bc$var$tTool(item));
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'setup',
            'tools'
        ], transformedList);
    }
    const fromSessionResumption = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sessionResumption'
    ]);
    if (parentObject !== undefined && fromSessionResumption != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'sessionResumption'
    ], $e4deb49dba5321bc$var$sessionResumptionConfigToMldev(fromSessionResumption));
    const fromInputAudioTranscription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inputAudioTranscription'
    ]);
    if (parentObject !== undefined && fromInputAudioTranscription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'inputAudioTranscription'
    ], $e4deb49dba5321bc$var$audioTranscriptionConfigToMldev());
    const fromOutputAudioTranscription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputAudioTranscription'
    ]);
    if (parentObject !== undefined && fromOutputAudioTranscription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'outputAudioTranscription'
    ], $e4deb49dba5321bc$var$audioTranscriptionConfigToMldev());
    const fromRealtimeInputConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'realtimeInputConfig'
    ]);
    if (parentObject !== undefined && fromRealtimeInputConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'realtimeInputConfig'
    ], $e4deb49dba5321bc$var$realtimeInputConfigToMldev(fromRealtimeInputConfig));
    const fromContextWindowCompression = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contextWindowCompression'
    ]);
    if (parentObject !== undefined && fromContextWindowCompression != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'contextWindowCompression'
    ], $e4deb49dba5321bc$var$contextWindowCompressionConfigToMldev(fromContextWindowCompression));
    const fromProactivity = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'proactivity'
    ]);
    if (parentObject !== undefined && fromProactivity != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'proactivity'
    ], $e4deb49dba5321bc$var$proactivityConfigToMldev(fromProactivity));
    return toObject;
}
function $e4deb49dba5321bc$var$liveConnectConstraintsToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'setup',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$liveConnectConfigToMldev(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$createAuthTokenConfigToMldev(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromExpireTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'expireTime'
    ]);
    if (parentObject !== undefined && fromExpireTime != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'expireTime'
    ], fromExpireTime);
    const fromNewSessionExpireTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'newSessionExpireTime'
    ]);
    if (parentObject !== undefined && fromNewSessionExpireTime != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'newSessionExpireTime'
    ], fromNewSessionExpireTime);
    const fromUses = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'uses'
    ]);
    if (parentObject !== undefined && fromUses != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'uses'
    ], fromUses);
    const fromLiveConnectConstraints = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'liveConnectConstraints'
    ]);
    if (parentObject !== undefined && fromLiveConnectConstraints != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'bidiGenerateContentSetup'
    ], $e4deb49dba5321bc$var$liveConnectConstraintsToMldev(apiClient, fromLiveConnectConstraints));
    const fromLockAdditionalFields = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'lockAdditionalFields'
    ]);
    if (parentObject !== undefined && fromLockAdditionalFields != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'fieldMask'
    ], fromLockAdditionalFields);
    return toObject;
}
function $e4deb49dba5321bc$var$createAuthTokenParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$createAuthTokenConfigToMldev(apiClient, fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$authTokenFromMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Returns a comma-separated list of field masks from a given object.
 *
 * @param setup The object to extract field masks from.
 * @return A comma-separated list of field masks.
 */ function $e4deb49dba5321bc$var$getFieldMasks(setup) {
    const fields = [];
    for(const key in setup)if (Object.prototype.hasOwnProperty.call(setup, key)) {
        const value = setup[key];
        // 2nd layer, recursively get field masks see TODO(b/418290100)
        if (typeof value === 'object' && value != null && Object.keys(value).length > 0) {
            const field = Object.keys(value).map((kk)=>`${key}.${kk}`);
            fields.push(...field);
        } else fields.push(key); // 1st layer
    }
    return fields.join(',');
}
/**
 * Converts bidiGenerateContentSetup.
 * @param requestDict - The request dictionary.
 * @param config - The configuration object.
 * @return - The modified request dictionary.
 */ function $e4deb49dba5321bc$var$convertBidiSetupToTokenSetup(requestDict, config) {
    // Convert bidiGenerateContentSetup from bidiGenerateContentSetup.setup.
    let setupForMaskGeneration = null;
    const bidiGenerateContentSetupValue = requestDict['bidiGenerateContentSetup'];
    if (typeof bidiGenerateContentSetupValue === 'object' && bidiGenerateContentSetupValue !== null && 'setup' in bidiGenerateContentSetupValue) {
        // Now we know bidiGenerateContentSetupValue is an object and has a 'setup'
        // property.
        const innerSetup = bidiGenerateContentSetupValue.setup;
        if (typeof innerSetup === 'object' && innerSetup !== null) {
            // Valid inner setup found.
            requestDict['bidiGenerateContentSetup'] = innerSetup;
            setupForMaskGeneration = innerSetup;
        } else // `bidiGenerateContentSetupValue.setup` is not a valid object; treat as
        // if bidiGenerateContentSetup is invalid.
        delete requestDict['bidiGenerateContentSetup'];
    } else if (bidiGenerateContentSetupValue !== undefined) // `bidiGenerateContentSetup` exists but not in the expected
    // shape {setup: {...}}; treat as invalid.
    delete requestDict['bidiGenerateContentSetup'];
    const preExistingFieldMask = requestDict['fieldMask'];
    // Handle mask generation setup.
    if (setupForMaskGeneration) {
        const generatedMaskFromBidi = $e4deb49dba5321bc$var$getFieldMasks(setupForMaskGeneration);
        if (Array.isArray(config === null || config === void 0 ? void 0 : config.lockAdditionalFields) && (config === null || config === void 0 ? void 0 : config.lockAdditionalFields.length) === 0) {
            // Case 1: lockAdditionalFields is an empty array. Lock only fields from
            // bidi setup.
            if (generatedMaskFromBidi) // Only assign if mask is not empty
            requestDict['fieldMask'] = generatedMaskFromBidi;
            else delete requestDict['fieldMask']; // If mask is empty, effectively no
        } else if ((config === null || config === void 0 ? void 0 : config.lockAdditionalFields) && config.lockAdditionalFields.length > 0 && preExistingFieldMask !== null && Array.isArray(preExistingFieldMask) && preExistingFieldMask.length > 0) {
            // Case 2: Lock fields from bidi setup + additional fields
            // (preExistingFieldMask).
            const generationConfigFields = [
                'temperature',
                'topK',
                'topP',
                'maxOutputTokens',
                'responseModalities',
                'seed',
                'speechConfig'
            ];
            let mappedFieldsFromPreExisting = [];
            if (preExistingFieldMask.length > 0) mappedFieldsFromPreExisting = preExistingFieldMask.map((field)=>{
                if (generationConfigFields.includes(field)) return `generationConfig.${field}`;
                return field; // Keep original field name if not in
            // generationConfigFields
            });
            const finalMaskParts = [];
            if (generatedMaskFromBidi) finalMaskParts.push(generatedMaskFromBidi);
            if (mappedFieldsFromPreExisting.length > 0) finalMaskParts.push(...mappedFieldsFromPreExisting);
            if (finalMaskParts.length > 0) requestDict['fieldMask'] = finalMaskParts.join(',');
            else // If no fields from bidi and no valid additional fields from
            // pre-existing mask.
            delete requestDict['fieldMask'];
        } else // Case 3: "Lock all fields" (meaning, don't send a field_mask, let server
        // defaults apply or all are mutable). This is hit if:
        //  - `config.lockAdditionalFields` is undefined.
        //  - `config.lockAdditionalFields` is non-empty, BUT
        //  `preExistingFieldMask` is null, not a string, or an empty string.
        delete requestDict['fieldMask'];
    } else // No valid `bidiGenerateContentSetup` was found or extracted.
    // "Lock additional null fields if any".
    if (preExistingFieldMask !== null && Array.isArray(preExistingFieldMask) && preExistingFieldMask.length > 0) // If there's a pre-existing field mask, it's a string, and it's not
    // empty, then we should lock all fields.
    requestDict['fieldMask'] = preExistingFieldMask.join(',');
    else delete requestDict['fieldMask'];
    return requestDict;
}
class $e4deb49dba5321bc$export$8e1e81ac145e31be extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
    }
    /**
     * Creates an ephemeral auth token resource.
     *
     * @experimental
     *
     * @remarks
     * Ephemeral auth tokens is only supported in the Gemini Developer API.
     * It can be used for the session connection to the Live constrained API.
     * Support in v1alpha only.
     *
     * @param params - The parameters for the create request.
     * @return The created auth token.
     *
     * @example
     * ```ts
     * const ai = new GoogleGenAI({
     *     apiKey: token.name,
     *     httpOptions: { apiVersion: 'v1alpha' }  // Support in v1alpha only.
     * });
     *
     * // Case 1: If LiveEphemeralParameters is unset, unlock LiveConnectConfig
     * // when using the token in Live API sessions. Each session connection can
     * // use a different configuration.
     * const config: CreateAuthTokenConfig = {
     *     uses: 3,
     *     expireTime: '2025-05-01T00:00:00Z',
     * }
     * const token = await ai.tokens.create(config);
     *
     * // Case 2: If LiveEphemeralParameters is set, lock all fields in
     * // LiveConnectConfig when using the token in Live API sessions. For
     * // example, changing `outputAudioTranscription` in the Live API
     * // connection will be ignored by the API.
     * const config: CreateAuthTokenConfig =
     *     uses: 3,
     *     expireTime: '2025-05-01T00:00:00Z',
     *     LiveEphemeralParameters: {
     *        model: 'gemini-2.0-flash-001',
     *        config: {
     *           'responseModalities': ['AUDIO'],
     *           'systemInstruction': 'Always answer in English.',
     *        }
     *     }
     * }
     * const token = await ai.tokens.create(config);
     *
     * // Case 3: If LiveEphemeralParameters is set and lockAdditionalFields is
     * // set, lock LiveConnectConfig with set and additional fields (e.g.
     * // responseModalities, systemInstruction, temperature in this example) when
     * // using the token in Live API sessions.
     * const config: CreateAuthTokenConfig =
     *     uses: 3,
     *     expireTime: '2025-05-01T00:00:00Z',
     *     LiveEphemeralParameters: {
     *        model: 'gemini-2.0-flash-001',
     *        config: {
     *           'responseModalities': ['AUDIO'],
     *           'systemInstruction': 'Always answer in English.',
     *        }
     *     },
     *     lockAdditionalFields: ['temperature'],
     * }
     * const token = await ai.tokens.create(config);
     *
     * // Case 4: If LiveEphemeralParameters is set and lockAdditionalFields is
     * // empty array, lock LiveConnectConfig with set fields (e.g.
     * // responseModalities, systemInstruction in this example) when using the
     * // token in Live API sessions.
     * const config: CreateAuthTokenConfig =
     *     uses: 3,
     *     expireTime: '2025-05-01T00:00:00Z',
     *     LiveEphemeralParameters: {
     *        model: 'gemini-2.0-flash-001',
     *        config: {
     *           'responseModalities': ['AUDIO'],
     *           'systemInstruction': 'Always answer in English.',
     *        }
     *     },
     *     lockAdditionalFields: [],
     * }
     * const token = await ai.tokens.create(config);
     * ```
     */ async create(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('The client.tokens.create method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$createAuthTokenParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('auth_tokens', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            const transformedBody = $e4deb49dba5321bc$var$convertBidiSetupToTokenSetup(body, params.config);
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(transformedBody),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$authTokenFromMldev(apiResponse);
                return resp;
            });
        }
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // Code generated by the Google Gen AI SDK generator DO NOT EDIT.
function $e4deb49dba5321bc$var$getTuningJobParametersToMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], fromName);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$listTuningJobsConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    const fromFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'filter'
    ]);
    if (parentObject !== undefined && fromFilter != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'filter'
    ], fromFilter);
    return toObject;
}
function $e4deb49dba5321bc$var$listTuningJobsParametersToMldev(fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$listTuningJobsConfigToMldev(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$cancelTuningJobParametersToMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], fromName);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$tuningExampleToMldev(fromObject) {
    const toObject = {};
    const fromTextInput = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'textInput'
    ]);
    if (fromTextInput != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'textInput'
    ], fromTextInput);
    const fromOutput = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'output'
    ]);
    if (fromOutput != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'output'
    ], fromOutput);
    return toObject;
}
function $e4deb49dba5321bc$var$tuningDatasetToMldev(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]) !== undefined) throw new Error('gcsUri parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'vertexDatasetResource'
    ]) !== undefined) throw new Error('vertexDatasetResource parameter is not supported in Gemini API.');
    const fromExamples = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'examples'
    ]);
    if (fromExamples != null) {
        let transformedList = fromExamples;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$tuningExampleToMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'examples',
            'examples'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$createTuningJobConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'validationDataset'
    ]) !== undefined) throw new Error('validationDataset parameter is not supported in Gemini API.');
    const fromTunedModelDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tunedModelDisplayName'
    ]);
    if (parentObject !== undefined && fromTunedModelDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'displayName'
    ], fromTunedModelDisplayName);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]) !== undefined) throw new Error('description parameter is not supported in Gemini API.');
    const fromEpochCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'epochCount'
    ]);
    if (parentObject !== undefined && fromEpochCount != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'tuningTask',
        'hyperparameters',
        'epochCount'
    ], fromEpochCount);
    const fromLearningRateMultiplier = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'learningRateMultiplier'
    ]);
    if (fromLearningRateMultiplier != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tuningTask',
        'hyperparameters',
        'learningRateMultiplier'
    ], fromLearningRateMultiplier);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'exportLastCheckpointOnly'
    ]) !== undefined) throw new Error('exportLastCheckpointOnly parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'preTunedModelCheckpointId'
    ]) !== undefined) throw new Error('preTunedModelCheckpointId parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'adapterSize'
    ]) !== undefined) throw new Error('adapterSize parameter is not supported in Gemini API.');
    const fromBatchSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'batchSize'
    ]);
    if (parentObject !== undefined && fromBatchSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'tuningTask',
        'hyperparameters',
        'batchSize'
    ], fromBatchSize);
    const fromLearningRate = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'learningRate'
    ]);
    if (parentObject !== undefined && fromLearningRate != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'tuningTask',
        'hyperparameters',
        'learningRate'
    ], fromLearningRate);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]) !== undefined) throw new Error('labels parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$createTuningJobParametersPrivateToMldev(fromObject) {
    const toObject = {};
    const fromBaseModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseModel'
    ]);
    if (fromBaseModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'baseModel'
    ], fromBaseModel);
    const fromPreTunedModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'preTunedModel'
    ]);
    if (fromPreTunedModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'preTunedModel'
    ], fromPreTunedModel);
    const fromTrainingDataset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'trainingDataset'
    ]);
    if (fromTrainingDataset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tuningTask',
        'trainingData'
    ], $e4deb49dba5321bc$var$tuningDatasetToMldev(fromTrainingDataset));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$createTuningJobConfigToMldev(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$getTuningJobParametersToVertex(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], fromName);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$listTuningJobsConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    const fromFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'filter'
    ]);
    if (parentObject !== undefined && fromFilter != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'filter'
    ], fromFilter);
    return toObject;
}
function $e4deb49dba5321bc$var$listTuningJobsParametersToVertex(fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$listTuningJobsConfigToVertex(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$cancelTuningJobParametersToVertex(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], fromName);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$tuningDatasetToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (parentObject !== undefined && fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'supervisedTuningSpec',
        'trainingDatasetUri'
    ], fromGcsUri);
    const fromVertexDatasetResource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'vertexDatasetResource'
    ]);
    if (parentObject !== undefined && fromVertexDatasetResource != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'supervisedTuningSpec',
        'trainingDatasetUri'
    ], fromVertexDatasetResource);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'examples'
    ]) !== undefined) throw new Error('examples parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$tuningValidationDatasetToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'validationDatasetUri'
    ], fromGcsUri);
    const fromVertexDatasetResource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'vertexDatasetResource'
    ]);
    if (parentObject !== undefined && fromVertexDatasetResource != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'supervisedTuningSpec',
        'trainingDatasetUri'
    ], fromVertexDatasetResource);
    return toObject;
}
function $e4deb49dba5321bc$var$createTuningJobConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromValidationDataset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'validationDataset'
    ]);
    if (parentObject !== undefined && fromValidationDataset != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'supervisedTuningSpec'
    ], $e4deb49dba5321bc$var$tuningValidationDatasetToVertex(fromValidationDataset, toObject));
    const fromTunedModelDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tunedModelDisplayName'
    ]);
    if (parentObject !== undefined && fromTunedModelDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'tunedModelDisplayName'
    ], fromTunedModelDisplayName);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (parentObject !== undefined && fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'description'
    ], fromDescription);
    const fromEpochCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'epochCount'
    ]);
    if (parentObject !== undefined && fromEpochCount != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'supervisedTuningSpec',
        'hyperParameters',
        'epochCount'
    ], fromEpochCount);
    const fromLearningRateMultiplier = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'learningRateMultiplier'
    ]);
    if (parentObject !== undefined && fromLearningRateMultiplier != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'supervisedTuningSpec',
        'hyperParameters',
        'learningRateMultiplier'
    ], fromLearningRateMultiplier);
    const fromExportLastCheckpointOnly = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'exportLastCheckpointOnly'
    ]);
    if (parentObject !== undefined && fromExportLastCheckpointOnly != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'supervisedTuningSpec',
        'exportLastCheckpointOnly'
    ], fromExportLastCheckpointOnly);
    const fromPreTunedModelCheckpointId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'preTunedModelCheckpointId'
    ]);
    if (fromPreTunedModelCheckpointId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'preTunedModel',
        'checkpointId'
    ], fromPreTunedModelCheckpointId);
    const fromAdapterSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'adapterSize'
    ]);
    if (parentObject !== undefined && fromAdapterSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'supervisedTuningSpec',
        'hyperParameters',
        'adapterSize'
    ], fromAdapterSize);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'batchSize'
    ]) !== undefined) throw new Error('batchSize parameter is not supported in Vertex AI.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'learningRate'
    ]) !== undefined) throw new Error('learningRate parameter is not supported in Vertex AI.');
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (parentObject !== undefined && fromLabels != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'labels'
    ], fromLabels);
    return toObject;
}
function $e4deb49dba5321bc$var$createTuningJobParametersPrivateToVertex(fromObject) {
    const toObject = {};
    const fromBaseModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseModel'
    ]);
    if (fromBaseModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'baseModel'
    ], fromBaseModel);
    const fromPreTunedModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'preTunedModel'
    ]);
    if (fromPreTunedModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'preTunedModel'
    ], fromPreTunedModel);
    const fromTrainingDataset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'trainingDataset'
    ]);
    if (fromTrainingDataset != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'supervisedTuningSpec',
        'trainingDatasetUri'
    ], $e4deb49dba5321bc$var$tuningDatasetToVertex(fromTrainingDataset, toObject));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$createTuningJobConfigToVertex(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$tunedModelFromMldev(fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'model'
    ], fromModel);
    const fromEndpoint = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromEndpoint != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endpoint'
    ], fromEndpoint);
    return toObject;
}
function $e4deb49dba5321bc$var$tuningJobFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromState = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'state'
    ]);
    if (fromState != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'state'
    ], $e4deb49dba5321bc$var$tTuningJobStatus(fromState));
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromStartTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tuningTask',
        'startTime'
    ]);
    if (fromStartTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tuningTask',
        'completeTime'
    ]);
    if (fromEndTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    const fromUpdateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromBaseModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseModel'
    ]);
    if (fromBaseModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'baseModel'
    ], fromBaseModel);
    const fromTunedModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromTunedModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tunedModel'
    ], $e4deb49dba5321bc$var$tunedModelFromMldev(fromTunedModel));
    const fromCustomBaseModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'customBaseModel'
    ]);
    if (fromCustomBaseModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'customBaseModel'
    ], fromCustomBaseModel);
    const fromExperiment = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'experiment'
    ]);
    if (fromExperiment != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'experiment'
    ], fromExperiment);
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (fromLabels != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'labels'
    ], fromLabels);
    const fromOutputUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputUri'
    ]);
    if (fromOutputUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'outputUri'
    ], fromOutputUri);
    const fromPipelineJob = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pipelineJob'
    ]);
    if (fromPipelineJob != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'pipelineJob'
    ], fromPipelineJob);
    const fromServiceAccount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'serviceAccount'
    ]);
    if (fromServiceAccount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'serviceAccount'
    ], fromServiceAccount);
    const fromTunedModelDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tunedModelDisplayName'
    ]);
    if (fromTunedModelDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tunedModelDisplayName'
    ], fromTunedModelDisplayName);
    return toObject;
}
function $e4deb49dba5321bc$var$listTuningJobsResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromTuningJobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tunedModels'
    ]);
    if (fromTuningJobs != null) {
        let transformedList = fromTuningJobs;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$tuningJobFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'tuningJobs'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$tuningOperationFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    return toObject;
}
function $e4deb49dba5321bc$var$tunedModelCheckpointFromVertex(fromObject) {
    const toObject = {};
    const fromCheckpointId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'checkpointId'
    ]);
    if (fromCheckpointId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'checkpointId'
    ], fromCheckpointId);
    const fromEpoch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'epoch'
    ]);
    if (fromEpoch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'epoch'
    ], fromEpoch);
    const fromStep = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'step'
    ]);
    if (fromStep != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'step'
    ], fromStep);
    const fromEndpoint = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endpoint'
    ]);
    if (fromEndpoint != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endpoint'
    ], fromEndpoint);
    return toObject;
}
function $e4deb49dba5321bc$var$tunedModelFromVertex(fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'model'
    ], fromModel);
    const fromEndpoint = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endpoint'
    ]);
    if (fromEndpoint != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endpoint'
    ], fromEndpoint);
    const fromCheckpoints = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'checkpoints'
    ]);
    if (fromCheckpoints != null) {
        let transformedList = fromCheckpoints;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$tunedModelCheckpointFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'checkpoints'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$tuningJobFromVertex(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromState = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'state'
    ]);
    if (fromState != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'state'
    ], $e4deb49dba5321bc$var$tTuningJobStatus(fromState));
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromStartTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startTime'
    ]);
    if (fromStartTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endTime'
    ]);
    if (fromEndTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    const fromUpdateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromBaseModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseModel'
    ]);
    if (fromBaseModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'baseModel'
    ], fromBaseModel);
    const fromTunedModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tunedModel'
    ]);
    if (fromTunedModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tunedModel'
    ], $e4deb49dba5321bc$var$tunedModelFromVertex(fromTunedModel));
    const fromPreTunedModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'preTunedModel'
    ]);
    if (fromPreTunedModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'preTunedModel'
    ], fromPreTunedModel);
    const fromSupervisedTuningSpec = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'supervisedTuningSpec'
    ]);
    if (fromSupervisedTuningSpec != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'supervisedTuningSpec'
    ], fromSupervisedTuningSpec);
    const fromTuningDataStats = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tuningDataStats'
    ]);
    if (fromTuningDataStats != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tuningDataStats'
    ], fromTuningDataStats);
    const fromEncryptionSpec = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'encryptionSpec'
    ]);
    if (fromEncryptionSpec != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'encryptionSpec'
    ], fromEncryptionSpec);
    const fromPartnerModelTuningSpec = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'partnerModelTuningSpec'
    ]);
    if (fromPartnerModelTuningSpec != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'partnerModelTuningSpec'
    ], fromPartnerModelTuningSpec);
    const fromCustomBaseModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'customBaseModel'
    ]);
    if (fromCustomBaseModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'customBaseModel'
    ], fromCustomBaseModel);
    const fromExperiment = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'experiment'
    ]);
    if (fromExperiment != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'experiment'
    ], fromExperiment);
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (fromLabels != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'labels'
    ], fromLabels);
    const fromOutputUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputUri'
    ]);
    if (fromOutputUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'outputUri'
    ], fromOutputUri);
    const fromPipelineJob = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pipelineJob'
    ]);
    if (fromPipelineJob != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'pipelineJob'
    ], fromPipelineJob);
    const fromServiceAccount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'serviceAccount'
    ]);
    if (fromServiceAccount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'serviceAccount'
    ], fromServiceAccount);
    const fromTunedModelDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tunedModelDisplayName'
    ]);
    if (fromTunedModelDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tunedModelDisplayName'
    ], fromTunedModelDisplayName);
    return toObject;
}
function $e4deb49dba5321bc$var$listTuningJobsResponseFromVertex(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromTuningJobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tuningJobs'
    ]);
    if (fromTuningJobs != null) {
        let transformedList = fromTuningJobs;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$tuningJobFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'tuningJobs'
        ], transformedList);
    }
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$var$Tunings extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
        /**
         * Gets a TuningJob.
         *
         * @param name - The resource name of the tuning job.
         * @return - A TuningJob object.
         *
         * @experimental - The SDK's tuning implementation is experimental, and may
         * change in future versions.
         */ this.get = async (params)=>{
            return await this.getInternal(params);
        };
        /**
         * Lists tuning jobs.
         *
         * @param config - The configuration for the list request.
         * @return - A list of tuning jobs.
         *
         * @experimental - The SDK's tuning implementation is experimental, and may
         * change in future versions.
         */ this.list = async (params = {})=>{
            return new $e4deb49dba5321bc$export$57625d62e5386b09($e4deb49dba5321bc$export$e18b8de308fd2439.PAGED_ITEM_TUNING_JOBS, (x)=>this.listInternal(x), await this.listInternal(params), params);
        };
        /**
         * Creates a supervised fine-tuning job.
         *
         * @param params - The parameters for the tuning job.
         * @return - A TuningJob operation.
         *
         * @experimental - The SDK's tuning implementation is experimental, and may
         * change in future versions.
         */ this.tune = async (params)=>{
            if (this.apiClient.isVertexAI()) {
                if (params.baseModel.startsWith('projects/')) {
                    const preTunedModel = {
                        tunedModelName: params.baseModel
                    };
                    const paramsPrivate = Object.assign(Object.assign({}, params), {
                        preTunedModel: preTunedModel
                    });
                    paramsPrivate.baseModel = undefined;
                    return await this.tuneInternal(paramsPrivate);
                } else {
                    const paramsPrivate = Object.assign({}, params);
                    return await this.tuneInternal(paramsPrivate);
                }
            } else {
                const paramsPrivate = Object.assign({}, params);
                const operation = await this.tuneMldevInternal(paramsPrivate);
                let tunedModelName = '';
                if (operation['metadata'] !== undefined && operation['metadata']['tunedModel'] !== undefined) tunedModelName = operation['metadata']['tunedModel'];
                else if (operation['name'] !== undefined && operation['name'].includes('/operations/')) tunedModelName = operation['name'].split('/operations/')[0];
                const tuningJob = {
                    name: tunedModelName,
                    state: $e4deb49dba5321bc$export$d30a7cb66801c974.JOB_STATE_QUEUED
                };
                return tuningJob;
            }
        };
    }
    async getInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$getTuningJobParametersToVertex(params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$tuningJobFromVertex(apiResponse);
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$getTuningJobParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$tuningJobFromMldev(apiResponse);
                return resp;
            });
        }
    }
    async listInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$listTuningJobsParametersToVertex(params);
            path = $e4deb49dba5321bc$var$formatMap('tuningJobs', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listTuningJobsResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$32bcd29afb9d1292();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$listTuningJobsParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('tunedModels', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listTuningJobsResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$32bcd29afb9d1292();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Cancels a tuning job.
     *
     * @param params - The parameters for the cancel request.
     * @return The empty response returned by the API.
     *
     * @example
     * ```ts
     * await ai.tunings.cancel({name: '...'}); // The server-generated resource name.
     * ```
     */ async cancel(params) {
        var _a, _b, _c, _d;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$cancelTuningJobParametersToVertex(params);
            path = $e4deb49dba5321bc$var$formatMap('{name}:cancel', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            await this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            });
        } else {
            const body = $e4deb49dba5321bc$var$cancelTuningJobParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('{name}:cancel', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            await this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            });
        }
    }
    async tuneInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$createTuningJobParametersPrivateToVertex(params);
            path = $e4deb49dba5321bc$var$formatMap('tuningJobs', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$tuningJobFromVertex(apiResponse);
                return resp;
            });
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
    async tuneMldevInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$createTuningJobParametersPrivateToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('tunedModels', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$tuningOperationFromMldev(apiResponse);
                return resp;
            });
        }
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$var$BrowserDownloader {
    async download(_params, _apiClient) {
        throw new Error('Download to file is not supported in the browser, please use a browser compliant download like an <a> tag.');
    }
}
const $e4deb49dba5321bc$var$MAX_CHUNK_SIZE = 8388608; // bytes
const $e4deb49dba5321bc$var$MAX_RETRY_COUNT = 3;
const $e4deb49dba5321bc$var$INITIAL_RETRY_DELAY_MS = 1000;
const $e4deb49dba5321bc$var$DELAY_MULTIPLIER = 2;
const $e4deb49dba5321bc$var$X_GOOG_UPLOAD_STATUS_HEADER_FIELD = 'x-goog-upload-status';
async function $e4deb49dba5321bc$var$uploadBlob(file, uploadUrl, apiClient) {
    var _a, _b, _c;
    let fileSize = 0;
    let offset = 0;
    let response = new $e4deb49dba5321bc$export$1d94dfe0d9d1f1e7(new Response());
    let uploadCommand = 'upload';
    fileSize = file.size;
    while(offset < fileSize){
        const chunkSize = Math.min($e4deb49dba5321bc$var$MAX_CHUNK_SIZE, fileSize - offset);
        const chunk = file.slice(offset, offset + chunkSize);
        if (offset + chunkSize >= fileSize) uploadCommand += ', finalize';
        let retryCount = 0;
        let currentDelayMs = $e4deb49dba5321bc$var$INITIAL_RETRY_DELAY_MS;
        while(retryCount < $e4deb49dba5321bc$var$MAX_RETRY_COUNT){
            response = await apiClient.request({
                path: '',
                body: chunk,
                httpMethod: 'POST',
                httpOptions: {
                    apiVersion: '',
                    baseUrl: uploadUrl,
                    headers: {
                        'X-Goog-Upload-Command': uploadCommand,
                        'X-Goog-Upload-Offset': String(offset),
                        'Content-Length': String(chunkSize)
                    }
                }
            });
            if ((_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a[$e4deb49dba5321bc$var$X_GOOG_UPLOAD_STATUS_HEADER_FIELD]) break;
            retryCount++;
            await $e4deb49dba5321bc$var$sleep(currentDelayMs);
            currentDelayMs = currentDelayMs * $e4deb49dba5321bc$var$DELAY_MULTIPLIER;
        }
        offset += chunkSize;
        // The `x-goog-upload-status` header field can be `active`, `final` and
        //`cancelled` in resposne.
        if (((_b = response === null || response === void 0 ? void 0 : response.headers) === null || _b === void 0 ? void 0 : _b[$e4deb49dba5321bc$var$X_GOOG_UPLOAD_STATUS_HEADER_FIELD]) !== 'active') break;
        // TODO(b/401391430) Investigate why the upload status is not finalized
        // even though all content has been uploaded.
        if (fileSize <= offset) throw new Error('All content has been uploaded, but the upload status is not finalized.');
    }
    const responseJson = await (response === null || response === void 0 ? void 0 : response.json());
    if (((_c = response === null || response === void 0 ? void 0 : response.headers) === null || _c === void 0 ? void 0 : _c[$e4deb49dba5321bc$var$X_GOOG_UPLOAD_STATUS_HEADER_FIELD]) !== 'final') throw new Error('Failed to upload file: Upload status is not finalized.');
    return responseJson['file'];
}
async function $e4deb49dba5321bc$var$getBlobStat(file) {
    const fileStat = {
        size: file.size,
        type: file.type
    };
    return fileStat;
}
function $e4deb49dba5321bc$var$sleep(ms) {
    return new Promise((resolvePromise)=>setTimeout(resolvePromise, ms));
}
class $e4deb49dba5321bc$var$BrowserUploader {
    async upload(file, uploadUrl, apiClient) {
        if (typeof file === 'string') throw new Error('File path is not supported in browser uploader.');
        return await $e4deb49dba5321bc$var$uploadBlob(file, uploadUrl, apiClient);
    }
    async stat(file) {
        if (typeof file === 'string') throw new Error('File path is not supported in browser uploader.');
        else return await $e4deb49dba5321bc$var$getBlobStat(file);
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$var$BrowserWebSocketFactory {
    create(url, headers, callbacks) {
        return new $e4deb49dba5321bc$var$BrowserWebSocket(url, headers, callbacks);
    }
}
class $e4deb49dba5321bc$var$BrowserWebSocket {
    constructor(url, headers, callbacks){
        this.url = url;
        this.headers = headers;
        this.callbacks = callbacks;
    }
    connect() {
        this.ws = new WebSocket(this.url);
        this.ws.onopen = this.callbacks.onopen;
        this.ws.onerror = this.callbacks.onerror;
        this.ws.onclose = this.callbacks.onclose;
        this.ws.onmessage = this.callbacks.onmessage;
    }
    send(message) {
        if (this.ws === undefined) throw new Error('WebSocket is not connected');
        this.ws.send(message);
    }
    close() {
        if (this.ws === undefined) throw new Error('WebSocket is not connected');
        this.ws.close();
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $e4deb49dba5321bc$var$GOOGLE_API_KEY_HEADER = 'x-goog-api-key';
// TODO(b/395122533): We need a secure client side authentication mechanism.
class $e4deb49dba5321bc$var$WebAuth {
    constructor(apiKey){
        this.apiKey = apiKey;
    }
    async addAuthHeaders(headers) {
        if (headers.get($e4deb49dba5321bc$var$GOOGLE_API_KEY_HEADER) !== null) return;
        if (this.apiKey.startsWith('auth_tokens/')) throw new Error('Ephemeral tokens are only supported by the live API.');
        // Check if API key is empty or null
        if (!this.apiKey) throw new Error('API key is missing. Please provide a valid API key.');
        headers.append($e4deb49dba5321bc$var$GOOGLE_API_KEY_HEADER, this.apiKey);
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $e4deb49dba5321bc$var$LANGUAGE_LABEL_PREFIX = 'gl-node/';
/**
 * The Google GenAI SDK.
 *
 * @remarks
 * Provides access to the GenAI features through either the {@link
 * https://cloud.google.com/vertex-ai/docs/reference/rest | Gemini API} or
 * the {@link https://cloud.google.com/vertex-ai/docs/reference/rest | Vertex AI
 * API}.
 *
 * The {@link GoogleGenAIOptions.vertexai} value determines which of the API
 * services to use.
 *
 * When using the Gemini API, a {@link GoogleGenAIOptions.apiKey} must also be
 * set. When using Vertex AI, currently only {@link GoogleGenAIOptions.apiKey}
 * is supported via Express mode. {@link GoogleGenAIOptions.project} and {@link
 * GoogleGenAIOptions.location} should not be set.
 *
 * @example
 * Initializing the SDK for using the Gemini API:
 * ```ts
 * import {GoogleGenAI} from '@google/genai';
 * const ai = new GoogleGenAI({apiKey: 'GEMINI_API_KEY'});
 * ```
 *
 * @example
 * Initializing the SDK for using the Vertex AI API:
 * ```ts
 * import {GoogleGenAI} from '@google/genai';
 * const ai = new GoogleGenAI({
 *   vertexai: true,
 *   project: 'PROJECT_ID',
 *   location: 'PROJECT_LOCATION'
 * });
 * ```
 *
 */ class $e4deb49dba5321bc$export$60336eb45c8b7f44 {
    constructor(options){
        var _a;
        if (options.apiKey == null) throw new Error('An API Key must be set when running in a browser');
        // Web client only supports API key mode for Vertex AI.
        if (options.project || options.location) throw new Error('Vertex AI project based authentication is not supported on browser runtimes. Please do not provide a project or location.');
        this.vertexai = (_a = options.vertexai) !== null && _a !== void 0 ? _a : false;
        this.apiKey = options.apiKey;
        const baseUrl = $e4deb49dba5321bc$var$getBaseUrl(options.httpOptions, options.vertexai, /*vertexBaseUrlFromEnv*/ undefined, /*geminiBaseUrlFromEnv*/ undefined);
        if (baseUrl) {
            if (options.httpOptions) options.httpOptions.baseUrl = baseUrl;
            else options.httpOptions = {
                baseUrl: baseUrl
            };
        }
        this.apiVersion = options.apiVersion;
        const auth = new $e4deb49dba5321bc$var$WebAuth(this.apiKey);
        this.apiClient = new $e4deb49dba5321bc$var$ApiClient({
            auth: auth,
            apiVersion: this.apiVersion,
            apiKey: this.apiKey,
            vertexai: this.vertexai,
            httpOptions: options.httpOptions,
            userAgentExtra: $e4deb49dba5321bc$var$LANGUAGE_LABEL_PREFIX + 'web',
            uploader: new $e4deb49dba5321bc$var$BrowserUploader(),
            downloader: new $e4deb49dba5321bc$var$BrowserDownloader()
        });
        this.models = new $e4deb49dba5321bc$export$6edbc060ce567afa(this.apiClient);
        this.live = new $e4deb49dba5321bc$export$db78b3d0b2aa666a(this.apiClient, auth, new $e4deb49dba5321bc$var$BrowserWebSocketFactory());
        this.batches = new $e4deb49dba5321bc$export$ed828fcd19953e0d(this.apiClient);
        this.chats = new $e4deb49dba5321bc$export$84088b07cfe11a74(this.models, this.apiClient);
        this.caches = new $e4deb49dba5321bc$export$4c60919c4fe22d9(this.apiClient);
        this.files = new $e4deb49dba5321bc$export$9330ab61a7e5c11b(this.apiClient);
        this.operations = new $e4deb49dba5321bc$export$3d72bd1ae0aee044(this.apiClient);
        this.authTokens = new $e4deb49dba5321bc$export$8e1e81ac145e31be(this.apiClient);
        this.tunings = new $e4deb49dba5321bc$var$Tunings(this.apiClient);
    }
}


const $116f6b541640fbf7$var$ai = new (0, $e4deb49dba5321bc$export$60336eb45c8b7f44)({
    apiKey: "AIzaSyB2OVxRWctqfuBg6k3kGQh8INUy7hgzJs0"
});
const $116f6b541640fbf7$var$model = 'gemini-2.5-flash';
const $116f6b541640fbf7$var$studyPlanSchema = {
    type: (0, $e4deb49dba5321bc$export$92738401e1603719).OBJECT,
    properties: {
        subject: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING
        },
        dailyHours: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).NUMBER
        },
        goal: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING
        },
        days: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).ARRAY,
            items: {
                type: (0, $e4deb49dba5321bc$export$92738401e1603719).OBJECT,
                properties: {
                    day: {
                        type: (0, $e4deb49dba5321bc$export$92738401e1603719).NUMBER
                    },
                    topic: {
                        type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING
                    },
                    tasks: {
                        type: (0, $e4deb49dba5321bc$export$92738401e1603719).ARRAY,
                        items: {
                            type: (0, $e4deb49dba5321bc$export$92738401e1603719).OBJECT,
                            properties: {
                                id: {
                                    type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
                                    description: "A unique ID for the task, e.g., a timestamp or random string."
                                },
                                name: {
                                    type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING
                                },
                                duration: {
                                    type: (0, $e4deb49dba5321bc$export$92738401e1603719).NUMBER
                                },
                                completed: {
                                    type: (0, $e4deb49dba5321bc$export$92738401e1603719).BOOLEAN,
                                    description: "Should always be false initially."
                                }
                            },
                            required: [
                                "id",
                                "name",
                                "duration",
                                "completed"
                            ]
                        }
                    }
                },
                required: [
                    "day",
                    "topic",
                    "tasks"
                ]
            }
        }
    },
    required: [
        "subject",
        "dailyHours",
        "goal",
        "days"
    ]
};
const $116f6b541640fbf7$export$6abced54ab58bb66 = async (subject, dailyHours, goal)=>{
    const prompt = `You are a study planner. Given the subject "${subject}", daily study time of ${dailyHours} hours, and the goal "${goal}", generate a balanced 7-day study plan. Include daily topics and specific tasks with time allocations in minutes. Each task must have a unique ID.`;
    try {
        const response = await $116f6b541640fbf7$var$ai.models.generateContent({
            model: $116f6b541640fbf7$var$model,
            contents: prompt,
            config: {
                responseMimeType: "application/json",
                responseSchema: $116f6b541640fbf7$var$studyPlanSchema
            }
        });
        const plan = JSON.parse(response.text);
        // Ensure all tasks have a completed field
        plan.days.forEach((day)=>{
            day.tasks.forEach((task)=>{
                task.completed = false;
            });
        });
        return plan;
    } catch (error) {
        console.error("Error generating study plan:", error);
        throw new Error("Failed to generate a study plan. The model might be unavailable or the request was malformed.");
    }
};
const $116f6b541640fbf7$export$b9d3b0f451a43d0 = async (subject, topic, taskName)=>{
    const prompt = `You are an expert tutor for a student studying "${subject}".
The topic for the day is "${topic}".
The specific task is: "${taskName}".

Please provide a detailed and clear explanation for this task. 
- Start with a simple overview.
- Break down complex concepts into smaller, easy-to-understand parts.
- Use examples or analogies where helpful.
- If it's a practical task (like coding), provide a brief code snippet or pseudocode.
- Format your response using Markdown for readability (headings, lists, bold text, etc.).
- Keep the tone encouraging and supportive.`;
    try {
        const response = await $116f6b541640fbf7$var$ai.models.generateContent({
            model: $116f6b541640fbf7$var$model,
            contents: prompt
        });
        return response.text;
    } catch (error) {
        console.error("Error generating task explanation:", error);
        throw new Error("Failed to generate an explanation for the task.");
    }
};
const $116f6b541640fbf7$export$a5575dbeeffdad98 = async (fileToUpload)=>{
    try {
        const file = await $116f6b541640fbf7$var$ai.files.upload({
            file: fileToUpload,
            config: {
                displayName: fileToUpload.name
            }
        });
        return file;
    } catch (error) {
        console.error("Error uploading file:", error);
        throw new Error("Failed to upload the file to the server.");
    }
};
const $116f6b541640fbf7$export$8b3ca78f81ec578c = async (name)=>{
    try {
        const file = await $116f6b541640fbf7$var$ai.files.get({
            name: name
        });
        return file;
    } catch (error) {
        console.error("Error getting file state:", error);
        throw new Error("Failed to get file status from the server.");
    }
};
const $116f6b541640fbf7$export$c17ea0f2f35725c5 = async (chatHistory, fileUri, mimeType)=>{
    const systemInstruction = `You are an AI assistant. Your task is to answer questions based *only* on the content of the provided document. Do not use any external knowledge. If the information to answer a question is not in the document, you must clearly state that the answer is not found in the provided text.`;
    const contents = chatHistory.map(({ role: role, text: text })=>({
            role: role,
            parts: [
                {
                    text: text
                }
            ]
        }));
    const lastUserMessage = contents[contents.length - 1];
    if (lastUserMessage && lastUserMessage.role === 'user') lastUserMessage.parts.unshift({
        fileData: {
            mimeType: mimeType,
            fileUri: fileUri
        }
    });
    const response = await $116f6b541640fbf7$var$ai.models.generateContentStream({
        model: $116f6b541640fbf7$var$model,
        contents: contents,
        config: {
            systemInstruction: systemInstruction
        }
    });
    return response;
};
const $116f6b541640fbf7$export$62956ae0c4716710 = async (chatHistory, useWebSearch)=>{
    const systemInstruction = `You are a friendly and knowledgeable AI tutor. Your goal is to help users understand complex topics in a clear and concise way. Be encouraging and supportive.`;
    const contents = chatHistory.map(({ role: role, text: text })=>({
            role: role,
            parts: [
                {
                    text: text
                }
            ]
        }));
    const config = {
        systemInstruction: systemInstruction
    };
    if (useWebSearch) config.tools = [
        {
            googleSearch: {}
        }
    ];
    const response = await $116f6b541640fbf7$var$ai.models.generateContentStream({
        model: $116f6b541640fbf7$var$model,
        contents: contents,
        config: config
    });
    return response;
};
const $116f6b541640fbf7$var$quizSchema = {
    type: (0, $e4deb49dba5321bc$export$92738401e1603719).OBJECT,
    properties: {
        topic: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING
        },
        questions: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).ARRAY,
            items: {
                type: (0, $e4deb49dba5321bc$export$92738401e1603719).OBJECT,
                properties: {
                    question: {
                        type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING
                    },
                    type: {
                        type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
                        enum: [
                            'multiple-choice'
                        ]
                    },
                    options: {
                        type: (0, $e4deb49dba5321bc$export$92738401e1603719).ARRAY,
                        items: {
                            type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING
                        }
                    },
                    answer: {
                        type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING
                    },
                    explanation: {
                        type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
                        description: "A brief explanation of why the answer is correct."
                    }
                },
                required: [
                    "question",
                    "type",
                    "options",
                    "answer",
                    "explanation"
                ]
            }
        }
    },
    required: [
        "topic",
        "questions"
    ]
};
const $116f6b541640fbf7$export$9c32e01ad104c2c0 = async (topic, questionCount)=>{
    const prompt = `Generate a quiz with exactly ${questionCount} multiple-choice questions on the topic of "${topic}". For each question, provide the question text, its type as 'multiple-choice', an array of options (ideally 4), the correct answer, and a brief explanation for the correct answer.`;
    try {
        const response = await $116f6b541640fbf7$var$ai.models.generateContent({
            model: $116f6b541640fbf7$var$model,
            contents: prompt,
            config: {
                responseMimeType: "application/json",
                responseSchema: $116f6b541640fbf7$var$quizSchema
            }
        });
        const quizData = JSON.parse(response.text);
        if (!quizData.questions || quizData.questions.length === 0) throw new Error("Generated quiz has no questions.");
        return quizData;
    } catch (error) {
        console.error("Error generating custom quiz:", error);
        throw new Error("Failed to generate a quiz. Please try a different topic or try again later.");
    }
};



var $d55025bea272cdc1$exports = {};
/**
 * marked v16.3.0 - a markdown parser
 * Copyright (c) 2011-2025, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ (function(g, f) {
    $d55025bea272cdc1$exports = f();
})(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : $d55025bea272cdc1$exports, function() {
    var exports = {};
    var __exports = exports;
    var module1 = {
        exports: exports
    };
    "use strict";
    var G = Object.defineProperty;
    var be = Object.getOwnPropertyDescriptor;
    var Re = Object.getOwnPropertyNames;
    var Oe = Object.prototype.hasOwnProperty;
    var Te = (a, e)=>{
        for(var t in e)G(a, t, {
            get: e[t],
            enumerable: !0
        });
    }, we = (a, e, t, n)=>{
        if (e && typeof e == "object" || typeof e == "function") for (let r of Re(e))!Oe.call(a, r) && r !== t && G(a, r, {
            get: ()=>e[r],
            enumerable: !(n = be(e, r)) || n.enumerable
        });
        return a;
    };
    var ye = (a)=>we(G({}, "__esModule", {
            value: !0
        }), a);
    var dt = {};
    Te(dt, {
        Hooks: ()=>S,
        Lexer: ()=>x,
        Marked: ()=>A,
        Parser: ()=>b,
        Renderer: ()=>P,
        TextRenderer: ()=>$,
        Tokenizer: ()=>y,
        defaults: ()=>O,
        getDefaults: ()=>_,
        lexer: ()=>ht,
        marked: ()=>d,
        options: ()=>it,
        parse: ()=>pt,
        parseInline: ()=>ut,
        parser: ()=>ct,
        setOptions: ()=>ot,
        use: ()=>at,
        walkTokens: ()=>lt
    });
    module1.exports = ye(dt);
    function _() {
        return {
            async: !1,
            breaks: !1,
            extensions: null,
            gfm: !0,
            hooks: null,
            pedantic: !1,
            renderer: null,
            silent: !1,
            tokenizer: null,
            walkTokens: null
        };
    }
    var O = _();
    function N(a) {
        O = a;
    }
    var C = {
        exec: ()=>null
    };
    function h(a, e = "") {
        let t = typeof a == "string" ? a : a.source, n = {
            replace: (r, i)=>{
                let s = typeof i == "string" ? i : i.source;
                return s = s.replace(m.caret, "$1"), t = t.replace(r, s), n;
            },
            getRegex: ()=>new RegExp(t, e)
        };
        return n;
    }
    var m = {
        codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
        outputLinkReplace: /\\([\[\]])/g,
        indentCodeCompensation: /^(\s+)(?:```)/,
        beginningSpace: /^\s+/,
        endingHash: /#$/,
        startingSpaceChar: /^ /,
        endingSpaceChar: / $/,
        nonSpaceChar: /[^ ]/,
        newLineCharGlobal: /\n/g,
        tabCharGlobal: /\t/g,
        multipleSpaceGlobal: /\s+/g,
        blankLine: /^[ \t]*$/,
        doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
        blockquoteStart: /^ {0,3}>/,
        blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
        blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
        listReplaceTabs: /^\t+/,
        listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
        listIsTask: /^\[[ xX]\] /,
        listReplaceTask: /^\[[ xX]\] +/,
        anyLine: /\n.*\n/,
        hrefBrackets: /^<(.*)>$/,
        tableDelimiter: /[:|]/,
        tableAlignChars: /^\||\| *$/g,
        tableRowBlankLine: /\n[ \t]*$/,
        tableAlignRight: /^ *-+: *$/,
        tableAlignCenter: /^ *:-+: *$/,
        tableAlignLeft: /^ *:-+ *$/,
        startATag: /^<a /i,
        endATag: /^<\/a>/i,
        startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
        endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
        startAngleBracket: /^</,
        endAngleBracket: />$/,
        pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
        unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
        escapeTest: /[&<>"']/,
        escapeReplace: /[&<>"']/g,
        escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
        escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
        unescapeTest: /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig,
        caret: /(^|[^\[])\^/g,
        percentDecode: /%25/g,
        findPipe: /\|/g,
        splitPipe: / \|/,
        slashPipe: /\\\|/g,
        carriageReturn: /\r\n|\r/g,
        spaceLine: /^ +$/gm,
        notSpaceStart: /^\S*/,
        endingNewline: /\n$/,
        listItemRegex: (a)=>new RegExp(`^( {0,3}${a})((?:[	 ][^\\n]*)?(?:\\n|$))`),
        nextBulletRegex: (a)=>new RegExp(`^ {0,${Math.min(3, a - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`),
        hrRegex: (a)=>new RegExp(`^ {0,${Math.min(3, a - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
        fencesBeginRegex: (a)=>new RegExp(`^ {0,${Math.min(3, a - 1)}}(?:\`\`\`|~~~)`),
        headingBeginRegex: (a)=>new RegExp(`^ {0,${Math.min(3, a - 1)}}#`),
        htmlBeginRegex: (a)=>new RegExp(`^ {0,${Math.min(3, a - 1)}}<(?:[a-z].*>|!--)`, "i")
    }, Pe = /^(?:[ \t]*(?:\n|$))+/, Se = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/, $e = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, I = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, _e = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, F = /(?:[*+-]|\d{1,9}[.)])/, ie = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/, oe = h(ie).replace(/bull/g, F).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex(), Le = h(ie).replace(/bull/g, F).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex(), Q = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, Me = /^[^\n]+/, U = /(?!\s*\])(?:\\[\s\S]|[^\[\]\\])+/, ze = h(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", U).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), Ae = h(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, F).getRegex(), v = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", K = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, Ee = h("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", K).replace("tag", v).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), ae = h(Q).replace("hr", I).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", v).getRegex(), Ce = h(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", ae).getRegex(), W = {
        blockquote: Ce,
        code: Se,
        def: ze,
        fences: $e,
        heading: _e,
        hr: I,
        html: Ee,
        lheading: oe,
        list: Ae,
        newline: Pe,
        paragraph: ae,
        table: C,
        text: Me
    }, se = h("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", I).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", v).getRegex(), Ie = {
        ...W,
        lheading: Le,
        table: se,
        paragraph: h(Q).replace("hr", I).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", se).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", v).getRegex()
    }, Be = {
        ...W,
        html: h(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", K).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: C,
        lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        paragraph: h(Q).replace("hr", I).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", oe).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
    }, qe = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, ve = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, le = /^( {2,}|\\)\n(?!\s*$)/, De = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, D = /[\p{P}\p{S}]/u, X = /[\s\p{P}\p{S}]/u, ue = /[^\s\p{P}\p{S}]/u, He = h(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, X).getRegex(), pe = /(?!~)[\p{P}\p{S}]/u, Ze = /(?!~)[\s\p{P}\p{S}]/u, Ge = /(?:[^\s\p{P}\p{S}]|~)/u, Ne = /\[[^\[\]]*?\]\((?:\\[\s\S]|[^\\\(\)]|\((?:\\[\s\S]|[^\\\(\)])*\))*\)|`[^`]*?`|<(?! )[^<>]*?>/g, ce = /^(?:\*+(?:((?!\*)punct)|[^\s*]))|^_+(?:((?!_)punct)|([^\s_]))/, je = h(ce, "u").replace(/punct/g, D).getRegex(), Fe = h(ce, "u").replace(/punct/g, pe).getRegex(), he = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)", Qe = h(he, "gu").replace(/notPunctSpace/g, ue).replace(/punctSpace/g, X).replace(/punct/g, D).getRegex(), Ue = h(he, "gu").replace(/notPunctSpace/g, Ge).replace(/punctSpace/g, Ze).replace(/punct/g, pe).getRegex(), Ke = h("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, ue).replace(/punctSpace/g, X).replace(/punct/g, D).getRegex(), We = h(/\\(punct)/, "gu").replace(/punct/g, D).getRegex(), Xe = h(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), Je = h(K).replace("(?:-->|$)", "-->").getRegex(), Ve = h("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", Je).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), q = /(?:\[(?:\\[\s\S]|[^\[\]\\])*\]|\\[\s\S]|`[^`]*`|[^\[\]\\`])*?/, Ye = h(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]*(?:\n[ \t]*)?)(title))?\s*\)/).replace("label", q).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), de = h(/^!?\[(label)\]\[(ref)\]/).replace("label", q).replace("ref", U).getRegex(), ke = h(/^!?\[(ref)\](?:\[\])?/).replace("ref", U).getRegex(), et = h("reflink|nolink(?!\\()", "g").replace("reflink", de).replace("nolink", ke).getRegex(), J = {
        _backpedal: C,
        anyPunctuation: We,
        autolink: Xe,
        blockSkip: Ne,
        br: le,
        code: ve,
        del: C,
        emStrongLDelim: je,
        emStrongRDelimAst: Qe,
        emStrongRDelimUnd: Ke,
        escape: qe,
        link: Ye,
        nolink: ke,
        punctuation: He,
        reflink: de,
        reflinkSearch: et,
        tag: Ve,
        text: De,
        url: C
    }, tt = {
        ...J,
        link: h(/^!?\[(label)\]\((.*?)\)/).replace("label", q).getRegex(),
        reflink: h(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", q).getRegex()
    }, j = {
        ...J,
        emStrongRDelimAst: Ue,
        emStrongLDelim: Fe,
        url: h(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
        _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])((?:\\[\s\S]|[^\\])*?(?:\\[\s\S]|[^\s~\\]))\1(?=[^~]|$)/,
        text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
    }, nt = {
        ...j,
        br: h(le).replace("{2,}", "*").getRegex(),
        text: h(j.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
    }, B = {
        normal: W,
        gfm: Ie,
        pedantic: Be
    }, M = {
        normal: J,
        gfm: j,
        breaks: nt,
        pedantic: tt
    };
    var rt = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    }, ge = (a)=>rt[a];
    function w(a, e) {
        if (e) {
            if (m.escapeTest.test(a)) return a.replace(m.escapeReplace, ge);
        } else if (m.escapeTestNoEncode.test(a)) return a.replace(m.escapeReplaceNoEncode, ge);
        return a;
    }
    function V(a) {
        try {
            a = encodeURI(a).replace(m.percentDecode, "%");
        } catch  {
            return null;
        }
        return a;
    }
    function Y(a, e) {
        let t = a.replace(m.findPipe, (i, s, o)=>{
            let l = !1, u = s;
            for(; --u >= 0 && o[u] === "\\";)l = !l;
            return l ? "|" : " |";
        }), n = t.split(m.splitPipe), r = 0;
        if (n[0].trim() || n.shift(), n.length > 0 && !n.at(-1)?.trim() && n.pop(), e) {
            if (n.length > e) n.splice(e);
            else for(; n.length < e;)n.push("");
        }
        for(; r < n.length; r++)n[r] = n[r].trim().replace(m.slashPipe, "|");
        return n;
    }
    function z(a, e, t) {
        let n = a.length;
        if (n === 0) return "";
        let r = 0;
        for(; r < n;){
            let i = a.charAt(n - r - 1);
            if (i === e && !t) r++;
            else if (i !== e && t) r++;
            else break;
        }
        return a.slice(0, n - r);
    }
    function fe(a, e) {
        if (a.indexOf(e[1]) === -1) return -1;
        let t = 0;
        for(let n = 0; n < a.length; n++)if (a[n] === "\\") n++;
        else if (a[n] === e[0]) t++;
        else if (a[n] === e[1] && (t--, t < 0)) return n;
        return t > 0 ? -2 : -1;
    }
    function me(a, e, t, n, r) {
        let i = e.href, s = e.title || null, o = a[1].replace(r.other.outputLinkReplace, "$1");
        n.state.inLink = !0;
        let l = {
            type: a[0].charAt(0) === "!" ? "image" : "link",
            raw: t,
            href: i,
            title: s,
            text: o,
            tokens: n.inlineTokens(o)
        };
        return n.state.inLink = !1, l;
    }
    function st(a, e, t) {
        let n = a.match(t.other.indentCodeCompensation);
        if (n === null) return e;
        let r = n[1];
        return e.split(`
`).map((i)=>{
            let s = i.match(t.other.beginningSpace);
            if (s === null) return i;
            let [o] = s;
            return o.length >= r.length ? i.slice(r.length) : i;
        }).join(`
`);
    }
    var y = class {
        options;
        rules;
        lexer;
        constructor(e){
            this.options = e || O;
        }
        space(e) {
            let t = this.rules.block.newline.exec(e);
            if (t && t[0].length > 0) return {
                type: "space",
                raw: t[0]
            };
        }
        code(e) {
            let t = this.rules.block.code.exec(e);
            if (t) {
                let n = t[0].replace(this.rules.other.codeRemoveIndent, "");
                return {
                    type: "code",
                    raw: t[0],
                    codeBlockStyle: "indented",
                    text: this.options.pedantic ? n : z(n, `
`)
                };
            }
        }
        fences(e) {
            let t = this.rules.block.fences.exec(e);
            if (t) {
                let n = t[0], r = st(n, t[3] || "", this.rules);
                return {
                    type: "code",
                    raw: n,
                    lang: t[2] ? t[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : t[2],
                    text: r
                };
            }
        }
        heading(e) {
            let t = this.rules.block.heading.exec(e);
            if (t) {
                let n = t[2].trim();
                if (this.rules.other.endingHash.test(n)) {
                    let r = z(n, "#");
                    (this.options.pedantic || !r || this.rules.other.endingSpaceChar.test(r)) && (n = r.trim());
                }
                return {
                    type: "heading",
                    raw: t[0],
                    depth: t[1].length,
                    text: n,
                    tokens: this.lexer.inline(n)
                };
            }
        }
        hr(e) {
            let t = this.rules.block.hr.exec(e);
            if (t) return {
                type: "hr",
                raw: z(t[0], `
`)
            };
        }
        blockquote(e) {
            let t = this.rules.block.blockquote.exec(e);
            if (t) {
                let n = z(t[0], `
`).split(`
`), r = "", i = "", s = [];
                for(; n.length > 0;){
                    let o = !1, l = [], u;
                    for(u = 0; u < n.length; u++)if (this.rules.other.blockquoteStart.test(n[u])) l.push(n[u]), o = !0;
                    else if (!o) l.push(n[u]);
                    else break;
                    n = n.slice(u);
                    let p = l.join(`
`), c = p.replace(this.rules.other.blockquoteSetextReplace, `
    $1`).replace(this.rules.other.blockquoteSetextReplace2, "");
                    r = r ? `${r}
${p}` : p, i = i ? `${i}
${c}` : c;
                    let f = this.lexer.state.top;
                    if (this.lexer.state.top = !0, this.lexer.blockTokens(c, s, !0), this.lexer.state.top = f, n.length === 0) break;
                    let k = s.at(-1);
                    if (k?.type === "code") break;
                    if (k?.type === "blockquote") {
                        let R = k, g = R.raw + `
` + n.join(`
`), T = this.blockquote(g);
                        s[s.length - 1] = T, r = r.substring(0, r.length - R.raw.length) + T.raw, i = i.substring(0, i.length - R.text.length) + T.text;
                        break;
                    } else if (k?.type === "list") {
                        let R = k, g = R.raw + `
` + n.join(`
`), T = this.list(g);
                        s[s.length - 1] = T, r = r.substring(0, r.length - k.raw.length) + T.raw, i = i.substring(0, i.length - R.raw.length) + T.raw, n = g.substring(s.at(-1).raw.length).split(`
`);
                        continue;
                    }
                }
                return {
                    type: "blockquote",
                    raw: r,
                    tokens: s,
                    text: i
                };
            }
        }
        list(e) {
            let t = this.rules.block.list.exec(e);
            if (t) {
                let n = t[1].trim(), r = n.length > 1, i = {
                    type: "list",
                    raw: "",
                    ordered: r,
                    start: r ? +n.slice(0, -1) : "",
                    loose: !1,
                    items: []
                };
                n = r ? `\\d{1,9}\\${n.slice(-1)}` : `\\${n}`, this.options.pedantic && (n = r ? n : "[*+-]");
                let s = this.rules.other.listItemRegex(n), o = !1;
                for(; e;){
                    let u = !1, p = "", c = "";
                    if (!(t = s.exec(e)) || this.rules.block.hr.test(e)) break;
                    p = t[0], e = e.substring(p.length);
                    let f = t[2].split(`
`, 1)[0].replace(this.rules.other.listReplaceTabs, (H)=>" ".repeat(3 * H.length)), k = e.split(`
`, 1)[0], R = !f.trim(), g = 0;
                    if (this.options.pedantic ? (g = 2, c = f.trimStart()) : R ? g = t[1].length + 1 : (g = t[2].search(this.rules.other.nonSpaceChar), g = g > 4 ? 1 : g, c = f.slice(g), g += t[1].length), R && this.rules.other.blankLine.test(k) && (p += k + `
`, e = e.substring(k.length + 1), u = !0), !u) {
                        let H = this.rules.other.nextBulletRegex(g), te = this.rules.other.hrRegex(g), ne = this.rules.other.fencesBeginRegex(g), re = this.rules.other.headingBeginRegex(g), xe = this.rules.other.htmlBeginRegex(g);
                        for(; e;){
                            let Z = e.split(`
`, 1)[0], E;
                            if (k = Z, this.options.pedantic ? (k = k.replace(this.rules.other.listReplaceNesting, "  "), E = k) : E = k.replace(this.rules.other.tabCharGlobal, "    "), ne.test(k) || re.test(k) || xe.test(k) || H.test(k) || te.test(k)) break;
                            if (E.search(this.rules.other.nonSpaceChar) >= g || !k.trim()) c += `
` + E.slice(g);
                            else {
                                if (R || f.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4 || ne.test(f) || re.test(f) || te.test(f)) break;
                                c += `
` + k;
                            }
                            !R && !k.trim() && (R = !0), p += Z + `
`, e = e.substring(Z.length + 1), f = E.slice(g);
                        }
                    }
                    i.loose || (o ? i.loose = !0 : this.rules.other.doubleBlankLine.test(p) && (o = !0));
                    let T = null, ee;
                    this.options.gfm && (T = this.rules.other.listIsTask.exec(c), T && (ee = T[0] !== "[ ] ", c = c.replace(this.rules.other.listReplaceTask, ""))), i.items.push({
                        type: "list_item",
                        raw: p,
                        task: !!T,
                        checked: ee,
                        loose: !1,
                        text: c,
                        tokens: []
                    }), i.raw += p;
                }
                let l = i.items.at(-1);
                if (l) l.raw = l.raw.trimEnd(), l.text = l.text.trimEnd();
                else return;
                i.raw = i.raw.trimEnd();
                for(let u = 0; u < i.items.length; u++)if (this.lexer.state.top = !1, i.items[u].tokens = this.lexer.blockTokens(i.items[u].text, []), !i.loose) {
                    let p = i.items[u].tokens.filter((f)=>f.type === "space"), c = p.length > 0 && p.some((f)=>this.rules.other.anyLine.test(f.raw));
                    i.loose = c;
                }
                if (i.loose) for(let u = 0; u < i.items.length; u++)i.items[u].loose = !0;
                return i;
            }
        }
        html(e) {
            let t = this.rules.block.html.exec(e);
            if (t) return {
                type: "html",
                block: !0,
                raw: t[0],
                pre: t[1] === "pre" || t[1] === "script" || t[1] === "style",
                text: t[0]
            };
        }
        def(e) {
            let t = this.rules.block.def.exec(e);
            if (t) {
                let n = t[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " "), r = t[2] ? t[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", i = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : t[3];
                return {
                    type: "def",
                    tag: n,
                    raw: t[0],
                    href: r,
                    title: i
                };
            }
        }
        table(e) {
            let t = this.rules.block.table.exec(e);
            if (!t || !this.rules.other.tableDelimiter.test(t[2])) return;
            let n = Y(t[1]), r = t[2].replace(this.rules.other.tableAlignChars, "").split("|"), i = t[3]?.trim() ? t[3].replace(this.rules.other.tableRowBlankLine, "").split(`
`) : [], s = {
                type: "table",
                raw: t[0],
                header: [],
                align: [],
                rows: []
            };
            if (n.length === r.length) {
                for (let o of r)this.rules.other.tableAlignRight.test(o) ? s.align.push("right") : this.rules.other.tableAlignCenter.test(o) ? s.align.push("center") : this.rules.other.tableAlignLeft.test(o) ? s.align.push("left") : s.align.push(null);
                for(let o = 0; o < n.length; o++)s.header.push({
                    text: n[o],
                    tokens: this.lexer.inline(n[o]),
                    header: !0,
                    align: s.align[o]
                });
                for (let o of i)s.rows.push(Y(o, s.header.length).map((l, u)=>({
                        text: l,
                        tokens: this.lexer.inline(l),
                        header: !1,
                        align: s.align[u]
                    })));
                return s;
            }
        }
        lheading(e) {
            let t = this.rules.block.lheading.exec(e);
            if (t) return {
                type: "heading",
                raw: t[0],
                depth: t[2].charAt(0) === "=" ? 1 : 2,
                text: t[1],
                tokens: this.lexer.inline(t[1])
            };
        }
        paragraph(e) {
            let t = this.rules.block.paragraph.exec(e);
            if (t) {
                let n = t[1].charAt(t[1].length - 1) === `
` ? t[1].slice(0, -1) : t[1];
                return {
                    type: "paragraph",
                    raw: t[0],
                    text: n,
                    tokens: this.lexer.inline(n)
                };
            }
        }
        text(e) {
            let t = this.rules.block.text.exec(e);
            if (t) return {
                type: "text",
                raw: t[0],
                text: t[0],
                tokens: this.lexer.inline(t[0])
            };
        }
        escape(e) {
            let t = this.rules.inline.escape.exec(e);
            if (t) return {
                type: "escape",
                raw: t[0],
                text: t[1]
            };
        }
        tag(e) {
            let t = this.rules.inline.tag.exec(e);
            if (t) return !this.lexer.state.inLink && this.rules.other.startATag.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && this.rules.other.endATag.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
                type: "html",
                raw: t[0],
                inLink: this.lexer.state.inLink,
                inRawBlock: this.lexer.state.inRawBlock,
                block: !1,
                text: t[0]
            };
        }
        link(e) {
            let t = this.rules.inline.link.exec(e);
            if (t) {
                let n = t[2].trim();
                if (!this.options.pedantic && this.rules.other.startAngleBracket.test(n)) {
                    if (!this.rules.other.endAngleBracket.test(n)) return;
                    let s = z(n.slice(0, -1), "\\");
                    if ((n.length - s.length) % 2 === 0) return;
                } else {
                    let s = fe(t[2], "()");
                    if (s === -2) return;
                    if (s > -1) {
                        let l = (t[0].indexOf("!") === 0 ? 5 : 4) + t[1].length + s;
                        t[2] = t[2].substring(0, s), t[0] = t[0].substring(0, l).trim(), t[3] = "";
                    }
                }
                let r = t[2], i = "";
                if (this.options.pedantic) {
                    let s = this.rules.other.pedanticHrefTitle.exec(r);
                    s && (r = s[1], i = s[3]);
                } else i = t[3] ? t[3].slice(1, -1) : "";
                return r = r.trim(), this.rules.other.startAngleBracket.test(r) && (this.options.pedantic && !this.rules.other.endAngleBracket.test(n) ? r = r.slice(1) : r = r.slice(1, -1)), me(t, {
                    href: r && r.replace(this.rules.inline.anyPunctuation, "$1"),
                    title: i && i.replace(this.rules.inline.anyPunctuation, "$1")
                }, t[0], this.lexer, this.rules);
            }
        }
        reflink(e, t) {
            let n;
            if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
                let r = (n[2] || n[1]).replace(this.rules.other.multipleSpaceGlobal, " "), i = t[r.toLowerCase()];
                if (!i) {
                    let s = n[0].charAt(0);
                    return {
                        type: "text",
                        raw: s,
                        text: s
                    };
                }
                return me(n, i, n[0], this.lexer, this.rules);
            }
        }
        emStrong(e, t, n = "") {
            let r = this.rules.inline.emStrongLDelim.exec(e);
            if (!r || r[3] && n.match(this.rules.other.unicodeAlphaNumeric)) return;
            if (!(r[1] || r[2] || "") || !n || this.rules.inline.punctuation.exec(n)) {
                let s = [
                    ...r[0]
                ].length - 1, o, l, u = s, p = 0, c = r[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
                for(c.lastIndex = 0, t = t.slice(-1 * e.length + s); (r = c.exec(t)) != null;){
                    if (o = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !o) continue;
                    if (l = [
                        ...o
                    ].length, r[3] || r[4]) {
                        u += l;
                        continue;
                    } else if ((r[5] || r[6]) && s % 3 && !((s + l) % 3)) {
                        p += l;
                        continue;
                    }
                    if (u -= l, u > 0) continue;
                    l = Math.min(l, l + u + p);
                    let f = [
                        ...r[0]
                    ][0].length, k = e.slice(0, s + r.index + f + l);
                    if (Math.min(s, l) % 2) {
                        let g = k.slice(1, -1);
                        return {
                            type: "em",
                            raw: k,
                            text: g,
                            tokens: this.lexer.inlineTokens(g)
                        };
                    }
                    let R = k.slice(2, -2);
                    return {
                        type: "strong",
                        raw: k,
                        text: R,
                        tokens: this.lexer.inlineTokens(R)
                    };
                }
            }
        }
        codespan(e) {
            let t = this.rules.inline.code.exec(e);
            if (t) {
                let n = t[2].replace(this.rules.other.newLineCharGlobal, " "), r = this.rules.other.nonSpaceChar.test(n), i = this.rules.other.startingSpaceChar.test(n) && this.rules.other.endingSpaceChar.test(n);
                return r && i && (n = n.substring(1, n.length - 1)), {
                    type: "codespan",
                    raw: t[0],
                    text: n
                };
            }
        }
        br(e) {
            let t = this.rules.inline.br.exec(e);
            if (t) return {
                type: "br",
                raw: t[0]
            };
        }
        del(e) {
            let t = this.rules.inline.del.exec(e);
            if (t) return {
                type: "del",
                raw: t[0],
                text: t[2],
                tokens: this.lexer.inlineTokens(t[2])
            };
        }
        autolink(e) {
            let t = this.rules.inline.autolink.exec(e);
            if (t) {
                let n, r;
                return t[2] === "@" ? (n = t[1], r = "mailto:" + n) : (n = t[1], r = n), {
                    type: "link",
                    raw: t[0],
                    text: n,
                    href: r,
                    tokens: [
                        {
                            type: "text",
                            raw: n,
                            text: n
                        }
                    ]
                };
            }
        }
        url(e) {
            let t;
            if (t = this.rules.inline.url.exec(e)) {
                let n, r;
                if (t[2] === "@") n = t[0], r = "mailto:" + n;
                else {
                    let i;
                    do i = t[0], t[0] = this.rules.inline._backpedal.exec(t[0])?.[0] ?? "";
                    while (i !== t[0]);
                    n = t[0], t[1] === "www." ? r = "http://" + t[0] : r = t[0];
                }
                return {
                    type: "link",
                    raw: t[0],
                    text: n,
                    href: r,
                    tokens: [
                        {
                            type: "text",
                            raw: n,
                            text: n
                        }
                    ]
                };
            }
        }
        inlineText(e) {
            let t = this.rules.inline.text.exec(e);
            if (t) {
                let n = this.lexer.state.inRawBlock;
                return {
                    type: "text",
                    raw: t[0],
                    text: t[0],
                    escaped: n
                };
            }
        }
    };
    var x = class a {
        tokens;
        options;
        state;
        tokenizer;
        inlineQueue;
        constructor(e){
            this.tokens = [], this.tokens.links = Object.create(null), this.options = e || O, this.options.tokenizer = this.options.tokenizer || new y, this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
                inLink: !1,
                inRawBlock: !1,
                top: !0
            };
            let t = {
                other: m,
                block: B.normal,
                inline: M.normal
            };
            this.options.pedantic ? (t.block = B.pedantic, t.inline = M.pedantic) : this.options.gfm && (t.block = B.gfm, this.options.breaks ? t.inline = M.breaks : t.inline = M.gfm), this.tokenizer.rules = t;
        }
        static get rules() {
            return {
                block: B,
                inline: M
            };
        }
        static lex(e, t) {
            return new a(t).lex(e);
        }
        static lexInline(e, t) {
            return new a(t).inlineTokens(e);
        }
        lex(e) {
            e = e.replace(m.carriageReturn, `
`), this.blockTokens(e, this.tokens);
            for(let t = 0; t < this.inlineQueue.length; t++){
                let n = this.inlineQueue[t];
                this.inlineTokens(n.src, n.tokens);
            }
            return this.inlineQueue = [], this.tokens;
        }
        blockTokens(e, t = [], n = !1) {
            for(this.options.pedantic && (e = e.replace(m.tabCharGlobal, "    ").replace(m.spaceLine, "")); e;){
                let r;
                if (this.options.extensions?.block?.some((s)=>(r = s.call({
                        lexer: this
                    }, e, t)) ? (e = e.substring(r.raw.length), t.push(r), !0) : !1)) continue;
                if (r = this.tokenizer.space(e)) {
                    e = e.substring(r.raw.length);
                    let s = t.at(-1);
                    r.raw.length === 1 && s !== void 0 ? s.raw += `
` : t.push(r);
                    continue;
                }
                if (r = this.tokenizer.code(e)) {
                    e = e.substring(r.raw.length);
                    let s = t.at(-1);
                    s?.type === "paragraph" || s?.type === "text" ? (s.raw += (s.raw.endsWith(`
`) ? "" : `
`) + r.raw, s.text += `
` + r.text, this.inlineQueue.at(-1).src = s.text) : t.push(r);
                    continue;
                }
                if (r = this.tokenizer.fences(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.heading(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.hr(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.blockquote(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.list(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.html(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.def(e)) {
                    e = e.substring(r.raw.length);
                    let s = t.at(-1);
                    s?.type === "paragraph" || s?.type === "text" ? (s.raw += (s.raw.endsWith(`
`) ? "" : `
`) + r.raw, s.text += `
` + r.raw, this.inlineQueue.at(-1).src = s.text) : this.tokens.links[r.tag] || (this.tokens.links[r.tag] = {
                        href: r.href,
                        title: r.title
                    }, t.push(r));
                    continue;
                }
                if (r = this.tokenizer.table(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.lheading(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                let i = e;
                if (this.options.extensions?.startBlock) {
                    let s = 1 / 0, o = e.slice(1), l;
                    this.options.extensions.startBlock.forEach((u)=>{
                        l = u.call({
                            lexer: this
                        }, o), typeof l == "number" && l >= 0 && (s = Math.min(s, l));
                    }), s < 1 / 0 && s >= 0 && (i = e.substring(0, s + 1));
                }
                if (this.state.top && (r = this.tokenizer.paragraph(i))) {
                    let s = t.at(-1);
                    n && s?.type === "paragraph" ? (s.raw += (s.raw.endsWith(`
`) ? "" : `
`) + r.raw, s.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = s.text) : t.push(r), n = i.length !== e.length, e = e.substring(r.raw.length);
                    continue;
                }
                if (r = this.tokenizer.text(e)) {
                    e = e.substring(r.raw.length);
                    let s = t.at(-1);
                    s?.type === "text" ? (s.raw += (s.raw.endsWith(`
`) ? "" : `
`) + r.raw, s.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = s.text) : t.push(r);
                    continue;
                }
                if (e) {
                    let s = "Infinite loop on byte: " + e.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(s);
                        break;
                    } else throw new Error(s);
                }
            }
            return this.state.top = !0, t;
        }
        inline(e, t = []) {
            return this.inlineQueue.push({
                src: e,
                tokens: t
            }), t;
        }
        inlineTokens(e, t = []) {
            let n = e, r = null;
            if (this.tokens.links) {
                let o = Object.keys(this.tokens.links);
                if (o.length > 0) for(; (r = this.tokenizer.rules.inline.reflinkSearch.exec(n)) != null;)o.includes(r[0].slice(r[0].lastIndexOf("[") + 1, -1)) && (n = n.slice(0, r.index) + "[" + "a".repeat(r[0].length - 2) + "]" + n.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
            }
            for(; (r = this.tokenizer.rules.inline.anyPunctuation.exec(n)) != null;)n = n.slice(0, r.index) + "++" + n.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
            for(; (r = this.tokenizer.rules.inline.blockSkip.exec(n)) != null;)n = n.slice(0, r.index) + "[" + "a".repeat(r[0].length - 2) + "]" + n.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
            n = this.options.hooks?.emStrongMask?.call({
                lexer: this
            }, n) ?? n;
            let i = !1, s = "";
            for(; e;){
                i || (s = ""), i = !1;
                let o;
                if (this.options.extensions?.inline?.some((u)=>(o = u.call({
                        lexer: this
                    }, e, t)) ? (e = e.substring(o.raw.length), t.push(o), !0) : !1)) continue;
                if (o = this.tokenizer.escape(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.tag(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.link(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.reflink(e, this.tokens.links)) {
                    e = e.substring(o.raw.length);
                    let u = t.at(-1);
                    o.type === "text" && u?.type === "text" ? (u.raw += o.raw, u.text += o.text) : t.push(o);
                    continue;
                }
                if (o = this.tokenizer.emStrong(e, n, s)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.codespan(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.br(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.del(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.autolink(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (!this.state.inLink && (o = this.tokenizer.url(e))) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                let l = e;
                if (this.options.extensions?.startInline) {
                    let u = 1 / 0, p = e.slice(1), c;
                    this.options.extensions.startInline.forEach((f)=>{
                        c = f.call({
                            lexer: this
                        }, p), typeof c == "number" && c >= 0 && (u = Math.min(u, c));
                    }), u < 1 / 0 && u >= 0 && (l = e.substring(0, u + 1));
                }
                if (o = this.tokenizer.inlineText(l)) {
                    e = e.substring(o.raw.length), o.raw.slice(-1) !== "_" && (s = o.raw.slice(-1)), i = !0;
                    let u = t.at(-1);
                    u?.type === "text" ? (u.raw += o.raw, u.text += o.text) : t.push(o);
                    continue;
                }
                if (e) {
                    let u = "Infinite loop on byte: " + e.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(u);
                        break;
                    } else throw new Error(u);
                }
            }
            return t;
        }
    };
    var P = class {
        options;
        parser;
        constructor(e){
            this.options = e || O;
        }
        space(e) {
            return "";
        }
        code({ text: e, lang: t, escaped: n }) {
            let r = (t || "").match(m.notSpaceStart)?.[0], i = e.replace(m.endingNewline, "") + `
`;
            return r ? '<pre><code class="language-' + w(r) + '">' + (n ? i : w(i, !0)) + `</code></pre>
` : "<pre><code>" + (n ? i : w(i, !0)) + `</code></pre>
`;
        }
        blockquote({ tokens: e }) {
            return `<blockquote>
${this.parser.parse(e)}</blockquote>
`;
        }
        html({ text: e }) {
            return e;
        }
        def(e) {
            return "";
        }
        heading({ tokens: e, depth: t }) {
            return `<h${t}>${this.parser.parseInline(e)}</h${t}>
`;
        }
        hr(e) {
            return `<hr>
`;
        }
        list(e) {
            let t = e.ordered, n = e.start, r = "";
            for(let o = 0; o < e.items.length; o++){
                let l = e.items[o];
                r += this.listitem(l);
            }
            let i = t ? "ol" : "ul", s = t && n !== 1 ? ' start="' + n + '"' : "";
            return "<" + i + s + `>
` + r + "</" + i + `>
`;
        }
        listitem(e) {
            let t = "";
            if (e.task) {
                let n = this.checkbox({
                    checked: !!e.checked
                });
                e.loose ? e.tokens[0]?.type === "paragraph" ? (e.tokens[0].text = n + " " + e.tokens[0].text, e.tokens[0].tokens && e.tokens[0].tokens.length > 0 && e.tokens[0].tokens[0].type === "text" && (e.tokens[0].tokens[0].text = n + " " + w(e.tokens[0].tokens[0].text), e.tokens[0].tokens[0].escaped = !0)) : e.tokens.unshift({
                    type: "text",
                    raw: n + " ",
                    text: n + " ",
                    escaped: !0
                }) : t += n + " ";
            }
            return t += this.parser.parse(e.tokens, !!e.loose), `<li>${t}</li>
`;
        }
        checkbox({ checked: e }) {
            return "<input " + (e ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
        }
        paragraph({ tokens: e }) {
            return `<p>${this.parser.parseInline(e)}</p>
`;
        }
        table(e) {
            let t = "", n = "";
            for(let i = 0; i < e.header.length; i++)n += this.tablecell(e.header[i]);
            t += this.tablerow({
                text: n
            });
            let r = "";
            for(let i = 0; i < e.rows.length; i++){
                let s = e.rows[i];
                n = "";
                for(let o = 0; o < s.length; o++)n += this.tablecell(s[o]);
                r += this.tablerow({
                    text: n
                });
            }
            return r && (r = `<tbody>${r}</tbody>`), `<table>
<thead>
` + t + `</thead>
` + r + `</table>
`;
        }
        tablerow({ text: e }) {
            return `<tr>
${e}</tr>
`;
        }
        tablecell(e) {
            let t = this.parser.parseInline(e.tokens), n = e.header ? "th" : "td";
            return (e.align ? `<${n} align="${e.align}">` : `<${n}>`) + t + `</${n}>
`;
        }
        strong({ tokens: e }) {
            return `<strong>${this.parser.parseInline(e)}</strong>`;
        }
        em({ tokens: e }) {
            return `<em>${this.parser.parseInline(e)}</em>`;
        }
        codespan({ text: e }) {
            return `<code>${w(e, !0)}</code>`;
        }
        br(e) {
            return "<br>";
        }
        del({ tokens: e }) {
            return `<del>${this.parser.parseInline(e)}</del>`;
        }
        link({ href: e, title: t, tokens: n }) {
            let r = this.parser.parseInline(n), i = V(e);
            if (i === null) return r;
            e = i;
            let s = '<a href="' + e + '"';
            return t && (s += ' title="' + w(t) + '"'), s += ">" + r + "</a>", s;
        }
        image({ href: e, title: t, text: n, tokens: r }) {
            r && (n = this.parser.parseInline(r, this.parser.textRenderer));
            let i = V(e);
            if (i === null) return w(n);
            e = i;
            let s = `<img src="${e}" alt="${n}"`;
            return t && (s += ` title="${w(t)}"`), s += ">", s;
        }
        text(e) {
            return "tokens" in e && e.tokens ? this.parser.parseInline(e.tokens) : "escaped" in e && e.escaped ? e.text : w(e.text);
        }
    };
    var $ = class {
        strong({ text: e }) {
            return e;
        }
        em({ text: e }) {
            return e;
        }
        codespan({ text: e }) {
            return e;
        }
        del({ text: e }) {
            return e;
        }
        html({ text: e }) {
            return e;
        }
        text({ text: e }) {
            return e;
        }
        link({ text: e }) {
            return "" + e;
        }
        image({ text: e }) {
            return "" + e;
        }
        br() {
            return "";
        }
    };
    var b = class a {
        options;
        renderer;
        textRenderer;
        constructor(e){
            this.options = e || O, this.options.renderer = this.options.renderer || new P, this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new $;
        }
        static parse(e, t) {
            return new a(t).parse(e);
        }
        static parseInline(e, t) {
            return new a(t).parseInline(e);
        }
        parse(e, t = !0) {
            let n = "";
            for(let r = 0; r < e.length; r++){
                let i = e[r];
                if (this.options.extensions?.renderers?.[i.type]) {
                    let o = i, l = this.options.extensions.renderers[o.type].call({
                        parser: this
                    }, o);
                    if (l !== !1 || ![
                        "space",
                        "hr",
                        "heading",
                        "code",
                        "table",
                        "blockquote",
                        "list",
                        "html",
                        "def",
                        "paragraph",
                        "text"
                    ].includes(o.type)) {
                        n += l || "";
                        continue;
                    }
                }
                let s = i;
                switch(s.type){
                    case "space":
                        n += this.renderer.space(s);
                        continue;
                    case "hr":
                        n += this.renderer.hr(s);
                        continue;
                    case "heading":
                        n += this.renderer.heading(s);
                        continue;
                    case "code":
                        n += this.renderer.code(s);
                        continue;
                    case "table":
                        n += this.renderer.table(s);
                        continue;
                    case "blockquote":
                        n += this.renderer.blockquote(s);
                        continue;
                    case "list":
                        n += this.renderer.list(s);
                        continue;
                    case "html":
                        n += this.renderer.html(s);
                        continue;
                    case "def":
                        n += this.renderer.def(s);
                        continue;
                    case "paragraph":
                        n += this.renderer.paragraph(s);
                        continue;
                    case "text":
                        {
                            let o = s, l = this.renderer.text(o);
                            for(; r + 1 < e.length && e[r + 1].type === "text";)o = e[++r], l += `
` + this.renderer.text(o);
                            t ? n += this.renderer.paragraph({
                                type: "paragraph",
                                raw: l,
                                text: l,
                                tokens: [
                                    {
                                        type: "text",
                                        raw: l,
                                        text: l,
                                        escaped: !0
                                    }
                                ]
                            }) : n += l;
                            continue;
                        }
                    default:
                        {
                            let o = 'Token with "' + s.type + '" type was not found.';
                            if (this.options.silent) return console.error(o), "";
                            throw new Error(o);
                        }
                }
            }
            return n;
        }
        parseInline(e, t = this.renderer) {
            let n = "";
            for(let r = 0; r < e.length; r++){
                let i = e[r];
                if (this.options.extensions?.renderers?.[i.type]) {
                    let o = this.options.extensions.renderers[i.type].call({
                        parser: this
                    }, i);
                    if (o !== !1 || ![
                        "escape",
                        "html",
                        "link",
                        "image",
                        "strong",
                        "em",
                        "codespan",
                        "br",
                        "del",
                        "text"
                    ].includes(i.type)) {
                        n += o || "";
                        continue;
                    }
                }
                let s = i;
                switch(s.type){
                    case "escape":
                        n += t.text(s);
                        break;
                    case "html":
                        n += t.html(s);
                        break;
                    case "link":
                        n += t.link(s);
                        break;
                    case "image":
                        n += t.image(s);
                        break;
                    case "strong":
                        n += t.strong(s);
                        break;
                    case "em":
                        n += t.em(s);
                        break;
                    case "codespan":
                        n += t.codespan(s);
                        break;
                    case "br":
                        n += t.br(s);
                        break;
                    case "del":
                        n += t.del(s);
                        break;
                    case "text":
                        n += t.text(s);
                        break;
                    default:
                        {
                            let o = 'Token with "' + s.type + '" type was not found.';
                            if (this.options.silent) return console.error(o), "";
                            throw new Error(o);
                        }
                }
            }
            return n;
        }
    };
    var S = class {
        options;
        block;
        constructor(e){
            this.options = e || O;
        }
        static passThroughHooks = new Set([
            "preprocess",
            "postprocess",
            "processAllTokens",
            "emStrongMask"
        ]);
        static passThroughHooksRespectAsync = new Set([
            "preprocess",
            "postprocess",
            "processAllTokens"
        ]);
        preprocess(e) {
            return e;
        }
        postprocess(e) {
            return e;
        }
        processAllTokens(e) {
            return e;
        }
        emStrongMask(e) {
            return e;
        }
        provideLexer() {
            return this.block ? x.lex : x.lexInline;
        }
        provideParser() {
            return this.block ? b.parse : b.parseInline;
        }
    };
    var A = class {
        defaults = _();
        options = this.setOptions;
        parse = this.parseMarkdown(!0);
        parseInline = this.parseMarkdown(!1);
        Parser = b;
        Renderer = P;
        TextRenderer = $;
        Lexer = x;
        Tokenizer = y;
        Hooks = S;
        constructor(...e){
            this.use(...e);
        }
        walkTokens(e, t) {
            let n = [];
            for (let r of e)switch(n = n.concat(t.call(this, r)), r.type){
                case "table":
                    {
                        let i = r;
                        for (let s of i.header)n = n.concat(this.walkTokens(s.tokens, t));
                        for (let s of i.rows)for (let o of s)n = n.concat(this.walkTokens(o.tokens, t));
                        break;
                    }
                case "list":
                    {
                        let i = r;
                        n = n.concat(this.walkTokens(i.items, t));
                        break;
                    }
                default:
                    {
                        let i = r;
                        this.defaults.extensions?.childTokens?.[i.type] ? this.defaults.extensions.childTokens[i.type].forEach((s)=>{
                            let o = i[s].flat(1 / 0);
                            n = n.concat(this.walkTokens(o, t));
                        }) : i.tokens && (n = n.concat(this.walkTokens(i.tokens, t)));
                    }
            }
            return n;
        }
        use(...e) {
            let t = this.defaults.extensions || {
                renderers: {},
                childTokens: {}
            };
            return e.forEach((n)=>{
                let r = {
                    ...n
                };
                if (r.async = this.defaults.async || r.async || !1, n.extensions && (n.extensions.forEach((i)=>{
                    if (!i.name) throw new Error("extension name required");
                    if ("renderer" in i) {
                        let s = t.renderers[i.name];
                        s ? t.renderers[i.name] = function(...o) {
                            let l = i.renderer.apply(this, o);
                            return l === !1 && (l = s.apply(this, o)), l;
                        } : t.renderers[i.name] = i.renderer;
                    }
                    if ("tokenizer" in i) {
                        if (!i.level || i.level !== "block" && i.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                        let s = t[i.level];
                        s ? s.unshift(i.tokenizer) : t[i.level] = [
                            i.tokenizer
                        ], i.start && (i.level === "block" ? t.startBlock ? t.startBlock.push(i.start) : t.startBlock = [
                            i.start
                        ] : i.level === "inline" && (t.startInline ? t.startInline.push(i.start) : t.startInline = [
                            i.start
                        ]));
                    }
                    "childTokens" in i && i.childTokens && (t.childTokens[i.name] = i.childTokens);
                }), r.extensions = t), n.renderer) {
                    let i = this.defaults.renderer || new P(this.defaults);
                    for(let s in n.renderer){
                        if (!(s in i)) throw new Error(`renderer '${s}' does not exist`);
                        if ([
                            "options",
                            "parser"
                        ].includes(s)) continue;
                        let o = s, l = n.renderer[o], u = i[o];
                        i[o] = (...p)=>{
                            let c = l.apply(i, p);
                            return c === !1 && (c = u.apply(i, p)), c || "";
                        };
                    }
                    r.renderer = i;
                }
                if (n.tokenizer) {
                    let i = this.defaults.tokenizer || new y(this.defaults);
                    for(let s in n.tokenizer){
                        if (!(s in i)) throw new Error(`tokenizer '${s}' does not exist`);
                        if ([
                            "options",
                            "rules",
                            "lexer"
                        ].includes(s)) continue;
                        let o = s, l = n.tokenizer[o], u = i[o];
                        i[o] = (...p)=>{
                            let c = l.apply(i, p);
                            return c === !1 && (c = u.apply(i, p)), c;
                        };
                    }
                    r.tokenizer = i;
                }
                if (n.hooks) {
                    let i = this.defaults.hooks || new S;
                    for(let s in n.hooks){
                        if (!(s in i)) throw new Error(`hook '${s}' does not exist`);
                        if ([
                            "options",
                            "block"
                        ].includes(s)) continue;
                        let o = s, l = n.hooks[o], u = i[o];
                        S.passThroughHooks.has(s) ? i[o] = (p)=>{
                            if (this.defaults.async && S.passThroughHooksRespectAsync.has(s)) return Promise.resolve(l.call(i, p)).then((f)=>u.call(i, f));
                            let c = l.call(i, p);
                            return u.call(i, c);
                        } : i[o] = (...p)=>{
                            let c = l.apply(i, p);
                            return c === !1 && (c = u.apply(i, p)), c;
                        };
                    }
                    r.hooks = i;
                }
                if (n.walkTokens) {
                    let i = this.defaults.walkTokens, s = n.walkTokens;
                    r.walkTokens = function(o) {
                        let l = [];
                        return l.push(s.call(this, o)), i && (l = l.concat(i.call(this, o))), l;
                    };
                }
                this.defaults = {
                    ...this.defaults,
                    ...r
                };
            }), this;
        }
        setOptions(e) {
            return this.defaults = {
                ...this.defaults,
                ...e
            }, this;
        }
        lexer(e, t) {
            return x.lex(e, t ?? this.defaults);
        }
        parser(e, t) {
            return b.parse(e, t ?? this.defaults);
        }
        parseMarkdown(e) {
            return (n, r)=>{
                let i = {
                    ...r
                }, s = {
                    ...this.defaults,
                    ...i
                }, o = this.onError(!!s.silent, !!s.async);
                if (this.defaults.async === !0 && i.async === !1) return o(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
                if (typeof n > "u" || n === null) return o(new Error("marked(): input parameter is undefined or null"));
                if (typeof n != "string") return o(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(n) + ", string expected"));
                s.hooks && (s.hooks.options = s, s.hooks.block = e);
                let l = s.hooks ? s.hooks.provideLexer() : e ? x.lex : x.lexInline, u = s.hooks ? s.hooks.provideParser() : e ? b.parse : b.parseInline;
                if (s.async) return Promise.resolve(s.hooks ? s.hooks.preprocess(n) : n).then((p)=>l(p, s)).then((p)=>s.hooks ? s.hooks.processAllTokens(p) : p).then((p)=>s.walkTokens ? Promise.all(this.walkTokens(p, s.walkTokens)).then(()=>p) : p).then((p)=>u(p, s)).then((p)=>s.hooks ? s.hooks.postprocess(p) : p).catch(o);
                try {
                    s.hooks && (n = s.hooks.preprocess(n));
                    let p = l(n, s);
                    s.hooks && (p = s.hooks.processAllTokens(p)), s.walkTokens && this.walkTokens(p, s.walkTokens);
                    let c = u(p, s);
                    return s.hooks && (c = s.hooks.postprocess(c)), c;
                } catch (p) {
                    return o(p);
                }
            };
        }
        onError(e, t) {
            return (n)=>{
                if (n.message += `
Please report this to https://github.com/markedjs/marked.`, e) {
                    let r = "<p>An error occurred:</p><pre>" + w(n.message + "", !0) + "</pre>";
                    return t ? Promise.resolve(r) : r;
                }
                if (t) return Promise.reject(n);
                throw n;
            };
        }
    };
    var L = new A;
    function d(a, e) {
        return L.parse(a, e);
    }
    d.options = d.setOptions = function(a) {
        return L.setOptions(a), d.defaults = L.defaults, N(d.defaults), d;
    };
    d.getDefaults = _;
    d.defaults = O;
    d.use = function(...a) {
        return L.use(...a), d.defaults = L.defaults, N(d.defaults), d;
    };
    d.walkTokens = function(a, e) {
        return L.walkTokens(a, e);
    };
    d.parseInline = L.parseInline;
    d.Parser = b;
    d.parser = b.parse;
    d.Renderer = P;
    d.TextRenderer = $;
    d.Lexer = x;
    d.lexer = x.lex;
    d.Tokenizer = y;
    d.Hooks = S;
    d.parse = d;
    var it = d.options, ot = d.setOptions, at = d.use, lt = d.walkTokens, ut = d.parseInline, pt = d, ct = b.parse, ht = x.lex;
    if (__exports != exports) module1.exports = exports;
    return module1.exports;
});


var $d349326c2b62c55f$exports = {};
/*! @license DOMPurify 3.2.7 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.7/LICENSE */ (function(global, factory) {
    $d349326c2b62c55f$exports = factory();
})($d349326c2b62c55f$exports, function() {
    'use strict';
    const { entries: entries, setPrototypeOf: setPrototypeOf, isFrozen: isFrozen, getPrototypeOf: getPrototypeOf, getOwnPropertyDescriptor: getOwnPropertyDescriptor } = Object;
    let { freeze: freeze, seal: seal, create: create } = Object; // eslint-disable-line import/no-mutable-exports
    let { apply: apply, construct: construct } = typeof Reflect !== 'undefined' && Reflect;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(func, thisArg) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        return func.apply(thisArg, args);
    };
    if (!construct) construct = function construct(Func) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const arraySplice = unapply(Array.prototype.splice);
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param func - The function to be wrapped and called.
   * @returns A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param func - The constructor function to be wrapped and called.
   * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(Func) {
        return function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return construct(Func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param set - The set to which elements will be added.
   * @param array - The array containing elements to be added to the set.
   * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === 'string') {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param array - The array to be cleaned.
   * @returns The cleaned version of the array
   */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param object - The object to be cloned.
   * @returns A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const [property, value] of entries(object)){
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (Array.isArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param object - The object to look up the getter function in its prototype chain.
   * @param prop - The property name for which to find the getter function.
   * @returns The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    const html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'search',
        'section',
        'select',
        'shadow',
        'slot',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    const svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'enterkeyhint',
        'exportparts',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'inputmode',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'part',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'slot',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    const svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feDropShadow',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    const mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover',
        'mprescripts'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    const text = freeze([
        '#text'
    ]);
    const html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'exportparts',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inert',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'part',
        'pattern',
        'placeholder',
        'playsinline',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'slot',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'wrap',
        'xmlns',
        'slot'
    ]);
    const svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'amplitude',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'exponent',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'intercept',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'slope',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'tablevalues',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    const mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    const xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    const TMPLIT_EXPR = seal(/\$\{[\w\W]*/gm); // eslint-disable-line unicorn/better-regex
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var EXPRESSIONS = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        ARIA_ATTR: ARIA_ATTR,
        ATTR_WHITESPACE: ATTR_WHITESPACE,
        CUSTOM_ELEMENT: CUSTOM_ELEMENT,
        DATA_ATTR: DATA_ATTR,
        DOCTYPE_NAME: DOCTYPE_NAME,
        ERB_EXPR: ERB_EXPR,
        IS_ALLOWED_URI: IS_ALLOWED_URI,
        IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
        MUSTACHE_EXPR: MUSTACHE_EXPR,
        TMPLIT_EXPR: TMPLIT_EXPR
    });
    /* eslint-disable @typescript-eslint/indent */ // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        // Deprecated
        entityNode: 6,
        // Deprecated
        progressingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12 // Deprecated
    };
    const getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param trustedTypes The policy factory.
   * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = 'data-tt-policy-suffix';
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    const _createHooksMap = function _createHooksMap() {
        return {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        DOMPurify.version = '3.2.7';
        DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document || !window1.Element) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let { document: document } = window1;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        const { DocumentFragment: DocumentFragment, HTMLTemplateElement: HTMLTemplateElement, Node: Node, Element: Element, NodeFilter: NodeFilter, NamedNodeMap: NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement: HTMLFormElement, DOMParser: DOMParser, trustedTypes: trustedTypes } = window1;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        const remove = lookupGetter(ElementPrototype, 'remove');
        const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            const template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = '';
        const { implementation: implementation, createNodeIterator: createNodeIterator, createDocumentFragment: createDocumentFragment, getElementsByTagName: getElementsByTagName } = document;
        const { importNode: importNode } = originalDocument;
        let hooks = _createHooksMap();
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
        const { MUSTACHE_EXPR: MUSTACHE_EXPR, ERB_EXPR: ERB_EXPR, TMPLIT_EXPR: TMPLIT_EXPR, DATA_ATTR: DATA_ATTR, ARIA_ATTR: ARIA_ATTR, IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA, ATTR_WHITESPACE: ATTR_WHITESPACE, CUSTOM_ELEMENT: CUSTOM_ELEMENT } = EXPRESSIONS;
        let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = EXPRESSIONS;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        let HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : clone({});
            FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : clone({});
            USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
            HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // Overwrite existing TrustedTypes policy.
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`.
                emptyHTML = trustedTypesPolicy.createHTML('');
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                // If creating the internal policy succeeded sign internal variables.
                if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') emptyHTML = trustedTypesPolicy.createHTML('');
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
     * @param element a DOM element whose namespace is being checked
     * @returns Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
            }
        };
        /**
     * _removeAttribute
     *
     * @param name an Attribute name
     * @param element a DOM node
     */ const _removeAttribute = function _removeAttribute(name, element) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: element.getAttributeNode(name),
                    from: element
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: element
                });
            }
            element.removeAttribute(name);
            // We void attribute values for unremovable "is" attributes
            if (name === 'is') {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(element);
                } catch (_) {}
                else try {
                    element.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param dirty - a string of dirty markup
     * @return a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param root The root element or node to start traversing on.
     * @return The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * _isClobbered
     *
     * @param element element to check for clobbering attacks
     * @return true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(element) {
            return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
        };
        /**
     * Checks whether the given object is a DOM node.
     *
     * @param value object to check whether it's a DOM node
     * @return true is object is a DOM node
     */ const _isNode = function _isNode(value) {
            return typeof Node === 'function' && value instanceof Node;
        };
        function _executeHooks(hooks, currentNode, data) {
            arrayForEach(hooks, (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        }
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     * @param currentNode to check for permission to exist
     * @return true if node was killed, false if left alive
     */ const _sanitizeElements = function _sanitizeElements(currentNode) {
            let content = null;
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w!]/g, currentNode.innerHTML) && regExpTest(/<[/\w!]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        const childCount = childNodes.length;
                        for(let i = childCount - 1; i >= 0; --i){
                            const childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    content = stringReplace(content, expr, ' ');
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param lcTag Lowercase tag name of containing element.
     * @param lcName Lowercase attribute name.
     * @param value Attribute value.
     * @return Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName, lcTag)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param tagName name of the tag of the node to sanitize
     * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
            const { attributes: attributes } = currentNode;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            const hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR,
                forceKeepAttr: undefined
            };
            let l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const { name: name, namespaceURI: namespaceURI, value: attrValue } = attr;
                const lcName = transformCaseFunc(name);
                const initValue = attrValue;
                let value = name === 'value' ? initValue : stringTrim(initValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title|textarea)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Make sure we cannot easily use animated hrefs, even if animations are allowed */ if (lcName === 'attributename' && stringMatch(value, 'href')) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    value = stringReplace(value, expr, ' ');
                });
                /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ if (value !== initValue) try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {
                    _removeAttribute(name, currentNode);
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param fragment to iterate over recursively
     */ const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
        };
        // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    const tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                serializedHTML = stringReplace(serializedHTML, expr, ' ');
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            arrayPush(hooks[entryPoint], hookFunction);
        };
        DOMPurify.removeHook = function(entryPoint, hookFunction) {
            if (hookFunction !== undefined) {
                const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
                return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
            }
            return arrayPop(hooks[entryPoint]);
        };
        DOMPurify.removeHooks = function(entryPoint) {
            hooks[entryPoint] = [];
        };
        DOMPurify.removeAllHooks = function() {
            hooks = _createHooksMap();
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});


const $bddcd414e638c254$var$PlanGenerator = ({ setStudyPlan: setStudyPlan, setLoading: setLoading })=>{
    const [subject, setSubject] = (0, $acw62.useState)('');
    const [hours, setHours] = (0, $acw62.useState)('2');
    const [goal, setGoal] = (0, $acw62.useState)('');
    const [error, setError] = (0, $acw62.useState)('');
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (!subject || !hours || !goal) {
            setError('Please fill out all fields.');
            return;
        }
        setError('');
        setLoading(true);
        try {
            const plan = await (0, $116f6b541640fbf7$export$6abced54ab58bb66)(subject, parseInt(hours), goal);
            setStudyPlan(plan);
        } catch (err) {
            setError(err.message);
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bg-gray-800 p-6 rounded-2xl shadow-lg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "text-2xl font-bold text-white mb-4",
                children: "Create Your Study Plan"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                onSubmit: handleSubmit,
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-sm font-medium text-gray-300",
                                children: "Subject"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "text",
                                value: subject,
                                onChange: (e)=>setSubject(e.target.value),
                                placeholder: "e.g., React & TypeScript",
                                className: "w-full bg-gray-700 text-white p-2 mt-1 rounded-md border border-gray-600 focus:ring-blue-500 focus:border-blue-500"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-sm font-medium text-gray-300",
                                children: "Daily Study Time (hours)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "number",
                                value: hours,
                                onChange: (e)=>setHours(e.target.value),
                                min: "1",
                                max: "12",
                                className: "w-full bg-gray-700 text-white p-2 mt-1 rounded-md border border-gray-600 focus:ring-blue-500 focus:border-blue-500"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-sm font-medium text-gray-300",
                                children: "Your Goal"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                value: goal,
                                onChange: (e)=>setGoal(e.target.value),
                                placeholder: "e.g., Build a full-stack application",
                                rows: 3,
                                className: "w-full bg-gray-700 text-white p-2 mt-1 rounded-md border border-gray-600 focus:ring-blue-500 focus:border-blue-500"
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-red-400 text-sm",
                        children: error
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "submit",
                        className: "w-full bg-blue-600 text-white font-bold py-2 px-4 rounded-md hover:bg-blue-700 transition-colors",
                        children: "Generate Plan"
                    })
                ]
            })
        ]
    });
};
const $bddcd414e638c254$var$TaskItem = ({ task: task, onToggle: onToggle, onExplain: onExplain })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center space-x-3 p-3 bg-gray-800/50 rounded-lg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                onClick: onToggle,
                className: `w-6 h-6 rounded-md flex-shrink-0 flex items-center justify-center border-2 transition-all cursor-pointer ${task.completed ? 'bg-blue-500 border-blue-500' : 'border-gray-500 hover:border-blue-400'}`,
                children: task.completed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e7fd069000a3c94$export$7dd004358974b05d), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                onClick: onExplain,
                className: `flex-1 cursor-pointer hover:text-blue-400 transition-colors ${task.completed ? 'line-through text-gray-500' : 'text-gray-200'}`,
                children: task.name
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "text-sm text-gray-400",
                children: [
                    task.duration,
                    " min"
                ]
            })
        ]
    });
const $bddcd414e638c254$var$ExplanationModal = ({ task: task, explanation: explanation, isLoading: isLoading, onClose: onClose })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 bg-black/70 flex items-center justify-center z-50 animate-fade-in",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "explanation-modal-title",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bg-gray-800 rounded-2xl shadow-xl p-6 w-full max-w-2xl max-h-[80vh] flex flex-col",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex justify-between items-center border-b border-gray-700 pb-3 mb-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                            id: "explanation-modal-title",
                            className: "text-xl font-bold text-white",
                            children: [
                                "Explanation: ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-blue-400",
                                    children: task.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: onClose,
                            "aria-label": "Close",
                            className: "p-1 rounded-full hover:bg-gray-700 transition-colors",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e7fd069000a3c94$export$5e658a8851ae9322), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "overflow-y-auto pr-2",
                    children: isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex justify-center items-center py-10",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e7fd069000a3c94$export$647aae5028016fe9), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "ml-3",
                                children: "Generating explanation..."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "prose prose-invert max-w-none",
                        dangerouslySetInnerHTML: {
                            __html: (0, (/*@__PURE__*/$parcel$interopDefault($d349326c2b62c55f$exports))).sanitize((0, $d55025bea272cdc1$exports.marked).parse(explanation))
                        }
                    })
                })
            ]
        })
    });
const $bddcd414e638c254$var$StudyPlanComponent = ({ studyPlan: studyPlan, setStudyPlan: setStudyPlan, updateProgress: updateProgress })=>{
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [selectedTask, setSelectedTask] = (0, $acw62.useState)(null);
    const [explanation, setExplanation] = (0, $acw62.useState)('');
    const [isExplanationLoading, setIsExplanationLoading] = (0, $acw62.useState)(false);
    const handleCloseModal = (0, $acw62.useCallback)(()=>{
        setSelectedTask(null);
        setExplanation('');
    }, []);
    (0, $acw62.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === 'Escape') handleCloseModal();
        };
        if (selectedTask) window.addEventListener('keydown', handleKeyDown);
        return ()=>{
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        selectedTask,
        handleCloseModal
    ]);
    const handleExplainClick = async (task, topic)=>{
        setSelectedTask({
            task: task,
            topic: topic
        });
        setIsExplanationLoading(true);
        setExplanation('');
        try {
            const result = await (0, $116f6b541640fbf7$export$b9d3b0f451a43d0)(studyPlan.subject, topic, task.name);
            setExplanation(result);
        } catch (error) {
            setExplanation("Sorry, I couldn't generate an explanation for this task. Please try again later.");
            console.error(error);
        } finally{
            setIsExplanationLoading(false);
        }
    };
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex justify-center items-center h-full",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e7fd069000a3c94$export$647aae5028016fe9), {}),
            " ",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "ml-3 text-lg",
                children: "Generating your personalized plan..."
            })
        ]
    });
    if (!studyPlan) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bddcd414e638c254$var$PlanGenerator, {
        setStudyPlan: setStudyPlan,
        setLoading: setLoading
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-6 animate-fade-in",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                        className: "flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                                        className: "text-3xl font-bold text-white",
                                        children: [
                                            "Your Plan: ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-blue-400",
                                                children: studyPlan.subject
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-gray-400",
                                        children: studyPlan.goal
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>setStudyPlan(null),
                                className: "bg-gray-700 text-white font-semibold py-2 px-4 rounded-md hover:bg-gray-600 transition-colors",
                                children: "New Plan"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6",
                        children: studyPlan.days.map((day)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-gray-800 p-5 rounded-2xl shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                        className: "text-xl font-bold text-white",
                                        children: [
                                            "Day ",
                                            day.day
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-blue-400 mb-4 font-medium",
                                        children: day.topic
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "space-y-3",
                                        children: day.tasks.map((task)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bddcd414e638c254$var$TaskItem, {
                                                task: task,
                                                onToggle: ()=>updateProgress(task.id),
                                                onExplain: ()=>handleExplainClick(task, day.topic)
                                            }, task.id))
                                    })
                                ]
                            }, day.day))
                    })
                ]
            }),
            selectedTask && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bddcd414e638c254$var$ExplanationModal, {
                task: selectedTask.task,
                explanation: explanation,
                isLoading: isExplanationLoading,
                onClose: handleCloseModal
            })
        ]
    });
};
var $bddcd414e638c254$export$2e2bcd8739ae039 = $bddcd414e638c254$var$StudyPlanComponent;



parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;



var $acw62 = parcelRequire("acw62");
var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$8da5bfbbed271cd7$exports = (parcelRequire("hOzOt"))();


var $2405e375887ef8eb$exports = {};
(function(global, factory) {
    factory($2405e375887ef8eb$exports);
})($2405e375887ef8eb$exports, function(exports1) {
    'use strict';
    var getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
     * Combine two comparators into a single comparators.
     */ function combineComparators(comparatorA, comparatorB) {
        return function isEqual(a, b, state) {
            return comparatorA(a, b, state) && comparatorB(a, b, state);
        };
    }
    /**
     * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
     * for circular references to be safely included in the comparison without creating
     * stack overflows.
     */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, state) {
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return areItemsEqual(a, b, state);
            var cache = state.cache;
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, state);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
     * Get the properties to strictly examine, which include both own properties that are
     * not enumerable and symbol properties.
     */ function getStrictProperties(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Whether the object contains the property passed as an own property.
     */ var hasOwn = Object.hasOwn || function(object, property) {
        return hasOwnProperty.call(object, property);
    };
    /**
     * Whether the values passed are strictly equal or both NaN.
     */ function sameValueZeroEqual(a, b) {
        return a === b || !a && !b && a !== a && b !== b;
    }
    var PREACT_VNODE = '__v';
    var PREACT_OWNER = '__o';
    var REACT_OWNER = '_owner';
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys = Object.keys;
    /**
     * Whether the arrays are equal in value.
     */ function areArraysEqual(a, b, state) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the dates passed are equal in value.
     */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.getTime(), b.getTime());
    }
    /**
     * Whether the errors passed are equal in value.
     */ function areErrorsEqual(a, b) {
        return a.name === b.name && a.message === b.message && a.cause === b.cause && a.stack === b.stack;
    }
    /**
     * Whether the functions passed are equal in value.
     */ function areFunctionsEqual(a, b) {
        return a === b;
    }
    /**
     * Whether the `Map`s are equal in value.
     */ function areMapsEqual(a, b, state) {
        var size = a.size;
        if (size !== b.size) return false;
        if (!size) return true;
        var matchedIndices = new Array(size);
        var aIterable = a.entries();
        var aResult;
        var bResult;
        var index = 0;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.entries();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (matchedIndices[matchIndex]) {
                    matchIndex++;
                    continue;
                }
                var aEntry = aResult.value;
                var bEntry = bResult.value;
                if (state.equals(aEntry[0], bEntry[0], index, matchIndex, a, b, state) && state.equals(aEntry[1], bEntry[1], aEntry[0], bEntry[0], a, b, state)) {
                    hasMatch = matchedIndices[matchIndex] = true;
                    break;
                }
                matchIndex++;
            }
            if (!hasMatch) return false;
            index++;
        }
        return true;
    }
    /**
     * Whether the numbers are equal in value.
     */ var areNumbersEqual = sameValueZeroEqual;
    /**
     * Whether the objects are equal in value.
     */ function areObjectsEqual(a, b, state) {
        var properties = keys(a);
        var index = properties.length;
        if (keys(b).length !== index) return false;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            if (!isPropertyEqual(a, b, state, properties[index])) return false;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value with strict property checking.
     */ function areObjectsEqualStrict(a, b, state) {
        var properties = getStrictProperties(a);
        var index = properties.length;
        if (getStrictProperties(b).length !== index) return false;
        var property;
        var descriptorA;
        var descriptorB;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (!isPropertyEqual(a, b, state, property)) return false;
            descriptorA = getOwnPropertyDescriptor(a, property);
            descriptorB = getOwnPropertyDescriptor(b, property);
            if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
        }
        return true;
    }
    /**
     * Whether the primitive wrappers passed are equal in value.
     */ function arePrimitiveWrappersEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
     * Whether the regexps passed are equal in value.
     */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
     * Whether the `Set`s are equal in value.
     */ function areSetsEqual(a, b, state) {
        var size = a.size;
        if (size !== b.size) return false;
        if (!size) return true;
        var matchedIndices = new Array(size);
        var aIterable = a.values();
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.values();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (!matchedIndices[matchIndex] && state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state)) {
                    hasMatch = matchedIndices[matchIndex] = true;
                    break;
                }
                matchIndex++;
            }
            if (!hasMatch) return false;
        }
        return true;
    }
    /**
     * Whether the TypedArray instances are equal in value.
     */ function areTypedArraysEqual(a, b) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (a[index] !== b[index]) return false;
        }
        return true;
    }
    /**
     * Whether the URL instances are equal in value.
     */ function areUrlsEqual(a, b) {
        return a.hostname === b.hostname && a.pathname === b.pathname && a.protocol === b.protocol && a.port === b.port && a.hash === b.hash && a.username === b.username && a.password === b.password;
    }
    function isPropertyEqual(a, b, state, property) {
        if ((property === REACT_OWNER || property === PREACT_OWNER || property === PREACT_VNODE) && (a.$$typeof || b.$$typeof)) return true;
        return hasOwn(b, property) && state.equals(a[property], b[property], property, property, a, b, state);
    }
    var ARGUMENTS_TAG = '[object Arguments]';
    var BOOLEAN_TAG = '[object Boolean]';
    var DATE_TAG = '[object Date]';
    var ERROR_TAG = '[object Error]';
    var MAP_TAG = '[object Map]';
    var NUMBER_TAG = '[object Number]';
    var OBJECT_TAG = '[object Object]';
    var REG_EXP_TAG = '[object RegExp]';
    var SET_TAG = '[object Set]';
    var STRING_TAG = '[object String]';
    var URL_TAG = '[object URL]';
    var isArray = Array.isArray;
    var isTypedArray = typeof ArrayBuffer === 'function' && ArrayBuffer.isView ? ArrayBuffer.isView : null;
    var assign = Object.assign;
    var getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
    /**
     * Create a comparator method based on the type-specific equality comparators passed.
     */ function createEqualityComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areErrorsEqual = _a.areErrorsEqual, areFunctionsEqual = _a.areFunctionsEqual, areMapsEqual = _a.areMapsEqual, areNumbersEqual = _a.areNumbersEqual, areObjectsEqual = _a.areObjectsEqual, arePrimitiveWrappersEqual = _a.arePrimitiveWrappersEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, areTypedArraysEqual = _a.areTypedArraysEqual, areUrlsEqual = _a.areUrlsEqual;
        /**
         * compare the value of the two objects and return true if they are equivalent in values
         */ return function comparator(a, b, state) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If either of the items are nullish and fail the strictly equal check
            // above, then they must be unequal.
            if (a == null || b == null) return false;
            var type = typeof a;
            if (type !== typeof b) return false;
            if (type !== 'object') {
                if (type === 'number') return areNumbersEqual(a, b, state);
                if (type === 'function') return areFunctionsEqual(a, b, state);
                // If a primitive value that is not strictly equal, it must be unequal.
                return false;
            }
            var constructor = a.constructor;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // Constructors should match, otherwise there is potential for false positives
            // between class and subclass or custom object and POJO.
            if (constructor !== b.constructor) return false;
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid capturing the string tag.
            if (constructor === Object) return areObjectsEqual(a, b, state);
            // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
            // the string tag or doing an `instanceof` check.
            if (isArray(a)) return areArraysEqual(a, b, state);
            // `isTypedArray()` works on all possible TypedArray classes, so we can avoid
            // capturing the string tag or comparing against all possible constructors.
            if (isTypedArray != null && isTypedArray(a)) return areTypedArraysEqual(a, b, state);
            // Try to fast-path equality checks for other complex object types in the
            // same realm to avoid capturing the string tag. Strict equality is used
            // instead of `instanceof` because it is more performant for the common
            // use-case. If someone is subclassing a native class, it will be handled
            // with the string tag comparison.
            if (constructor === Date) return areDatesEqual(a, b, state);
            if (constructor === RegExp) return areRegExpsEqual(a, b, state);
            if (constructor === Map) return areMapsEqual(a, b, state);
            if (constructor === Set) return areSetsEqual(a, b, state);
            // Since this is a custom object, capture the string tag to determing its type.
            // This is reasonably performant in modern environments like v8 and SpiderMonkey.
            var tag = getTag(a);
            if (tag === DATE_TAG) return areDatesEqual(a, b, state);
            // For RegExp, the properties are not enumerable, and therefore will give false positives if
            // tested like a standard object.
            if (tag === REG_EXP_TAG) return areRegExpsEqual(a, b, state);
            if (tag === MAP_TAG) return areMapsEqual(a, b, state);
            if (tag === SET_TAG) return areSetsEqual(a, b, state);
            if (tag === OBJECT_TAG) // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return typeof a.then !== 'function' && typeof b.then !== 'function' && areObjectsEqual(a, b, state);
            // If a URL tag, it should be tested explicitly. Like RegExp, the properties are not
            // enumerable, and therefore will give false positives if tested like a standard object.
            if (tag === URL_TAG) return areUrlsEqual(a, b, state);
            // If an error tag, it should be tested explicitly. Like RegExp, the properties are not
            // enumerable, and therefore will give false positives if tested like a standard object.
            if (tag === ERROR_TAG) return areErrorsEqual(a, b, state);
            // If an arguments tag, it should be treated as a standard object.
            if (tag === ARGUMENTS_TAG) return areObjectsEqual(a, b, state);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) return arePrimitiveWrappersEqual(a, b, state);
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        };
    }
    /**
     * Create the configuration object used for building comparators.
     */ function createEqualityComparatorConfig(_a) {
        var circular = _a.circular, createCustomConfig = _a.createCustomConfig, strict = _a.strict;
        var config = {
            areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
            areDatesEqual: areDatesEqual,
            areErrorsEqual: areErrorsEqual,
            areFunctionsEqual: areFunctionsEqual,
            areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
            areNumbersEqual: areNumbersEqual,
            areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
            arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
            areRegExpsEqual: areRegExpsEqual,
            areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
            areTypedArraysEqual: strict ? areObjectsEqualStrict : areTypedArraysEqual,
            areUrlsEqual: areUrlsEqual
        };
        if (createCustomConfig) config = assign({}, config, createCustomConfig(config));
        if (circular) {
            var areArraysEqual$1 = createIsCircular(config.areArraysEqual);
            var areMapsEqual$1 = createIsCircular(config.areMapsEqual);
            var areObjectsEqual$1 = createIsCircular(config.areObjectsEqual);
            var areSetsEqual$1 = createIsCircular(config.areSetsEqual);
            config = assign({}, config, {
                areArraysEqual: areArraysEqual$1,
                areMapsEqual: areMapsEqual$1,
                areObjectsEqual: areObjectsEqual$1,
                areSetsEqual: areSetsEqual$1
            });
        }
        return config;
    }
    /**
     * Default equality comparator pass-through, used as the standard `isEqual` creator for
     * use inside the built comparator.
     */ function createInternalEqualityComparator(compare) {
        return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
            return compare(a, b, state);
        };
    }
    /**
     * Create the `isEqual` function used by the consuming application.
     */ function createIsEqual(_a) {
        var circular = _a.circular, comparator = _a.comparator, createState = _a.createState, equals = _a.equals, strict = _a.strict;
        if (createState) return function isEqual(a, b) {
            var _a = createState(), _b = _a.cache, cache = _b === void 0 ? circular ? new WeakMap() : undefined : _b, meta = _a.meta;
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict
            });
        };
        if (circular) return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict
            });
        };
        var state = {
            cache: undefined,
            equals: equals,
            meta: undefined,
            strict: strict
        };
        return function isEqual(a, b) {
            return comparator(a, b, state);
        };
    }
    /**
     * Whether the items passed are deeply-equal in value.
     */ var deepEqual = createCustomEqual();
    /**
     * Whether the items passed are deeply-equal in value based on strict comparison.
     */ var strictDeepEqual = createCustomEqual({
        strict: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references.
     */ var circularDeepEqual = createCustomEqual({
        circular: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularDeepEqual = createCustomEqual({
        circular: true,
        strict: true
    });
    /**
     * Whether the items passed are shallowly-equal in value.
     */ var shallowEqual = createCustomEqual({
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value based on strict comparison
     */ var strictShallowEqual = createCustomEqual({
        strict: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references.
     */ var circularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        },
        strict: true
    });
    /**
     * Create a custom equality comparison method.
     *
     * This can be done to create very targeted comparisons in extreme hot-path scenarios
     * where the standard methods are not performant enough, but can also be used to provide
     * support for legacy environments that do not support expected features like
     * `RegExp.prototype.flags` out of the box.
     */ function createCustomEqual(options) {
        if (options === void 0) options = {};
        var _a = options.circular, circular = _a === void 0 ? false : _a, createCustomInternalComparator = options.createInternalComparator, createState = options.createState, _b = options.strict, strict = _b === void 0 ? false : _b;
        var config = createEqualityComparatorConfig(options);
        var comparator = createEqualityComparator(config);
        var equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
        return createIsEqual({
            circular: circular,
            comparator: comparator,
            createState: createState,
            equals: equals,
            strict: strict
        });
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    exports1.strictCircularDeepEqual = strictCircularDeepEqual;
    exports1.strictCircularShallowEqual = strictCircularShallowEqual;
    exports1.strictDeepEqual = strictDeepEqual;
    exports1.strictShallowEqual = strictShallowEqual;
});


function $7ff7dc42bcdc16d6$var$safeRequestAnimationFrame(callback) {
    if (typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(callback);
}
function $7ff7dc42bcdc16d6$export$2e2bcd8739ae039(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else $7ff7dc42bcdc16d6$var$safeRequestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}


function $8fc08b46df15d7b3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8fc08b46df15d7b3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8fc08b46df15d7b3$var$_typeof(o);
}
function $8fc08b46df15d7b3$var$_toArray(arr) {
    return $8fc08b46df15d7b3$var$_arrayWithHoles(arr) || $8fc08b46df15d7b3$var$_iterableToArray(arr) || $8fc08b46df15d7b3$var$_unsupportedIterableToArray(arr) || $8fc08b46df15d7b3$var$_nonIterableRest();
}
function $8fc08b46df15d7b3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8fc08b46df15d7b3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8fc08b46df15d7b3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8fc08b46df15d7b3$var$_arrayLikeToArray(o, minLen);
}
function $8fc08b46df15d7b3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8fc08b46df15d7b3$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $8fc08b46df15d7b3$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $8fc08b46df15d7b3$export$2e2bcd8739ae039() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = $8fc08b46df15d7b3$var$_toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === 'number') {
                (0, $7ff7dc42bcdc16d6$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, $7ff7dc42bcdc16d6$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles));
            return;
        }
        if ($8fc08b46df15d7b3$var$_typeof(_style) === 'object') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'function') _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}


function $28cf6a7385103719$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $28cf6a7385103719$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $28cf6a7385103719$var$_typeof(o);
}
function $28cf6a7385103719$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $28cf6a7385103719$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $28cf6a7385103719$var$ownKeys(Object(t), !0).forEach(function(r) {
            $28cf6a7385103719$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $28cf6a7385103719$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $28cf6a7385103719$var$_defineProperty(obj, key, value) {
    key = $28cf6a7385103719$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $28cf6a7385103719$var$_toPropertyKey(arg) {
    var key = $28cf6a7385103719$var$_toPrimitive(arg, "string");
    return $28cf6a7385103719$var$_typeof(key) === "symbol" ? key : String(key);
}
function $28cf6a7385103719$var$_toPrimitive(input, hint) {
    if ($28cf6a7385103719$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($28cf6a7385103719$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $28cf6a7385103719$export$59e29973723da0b3 = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var $28cf6a7385103719$export$f0954fd7d5368655 = function identity(param) {
    return param;
};
var $28cf6a7385103719$export$51610fddbf64bc9d = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var $28cf6a7385103719$export$bef1f36f5486a6a3 = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var $28cf6a7385103719$export$1c9f709888824e05 = function debug(name) {
    return function(item) {
        $28cf6a7385103719$export$bef1f36f5486a6a3(name, item);
        return item;
    };
};
var $28cf6a7385103719$export$1dc45301cd23a8c7 = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || 'anonymous function';
        var argNames = "(".concat(args.map(JSON.stringify).join(', '), ")");
        $28cf6a7385103719$export$bef1f36f5486a6a3("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var $28cf6a7385103719$export$d6051a0f7a227332 = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return $28cf6a7385103719$var$_objectSpread($28cf6a7385103719$var$_objectSpread({}, res), {}, $28cf6a7385103719$var$_defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var $28cf6a7385103719$export$1594c78389ee3429 = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat($28cf6a7385103719$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(',');
};
var $28cf6a7385103719$var$isDev = false;
var $28cf6a7385103719$export$c106dd0671a0fc2d = function warn(condition, format, a, b, c, d, e, f) {
    if ($28cf6a7385103719$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};


function $76a15591a87ba8e0$var$_slicedToArray(arr, i) {
    return $76a15591a87ba8e0$var$_arrayWithHoles(arr) || $76a15591a87ba8e0$var$_iterableToArrayLimit(arr, i) || $76a15591a87ba8e0$var$_unsupportedIterableToArray(arr, i) || $76a15591a87ba8e0$var$_nonIterableRest();
}
function $76a15591a87ba8e0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $76a15591a87ba8e0$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $76a15591a87ba8e0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $76a15591a87ba8e0$var$_toConsumableArray(arr) {
    return $76a15591a87ba8e0$var$_arrayWithoutHoles(arr) || $76a15591a87ba8e0$var$_iterableToArray(arr) || $76a15591a87ba8e0$var$_unsupportedIterableToArray(arr) || $76a15591a87ba8e0$var$_nonIterableSpread();
}
function $76a15591a87ba8e0$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $76a15591a87ba8e0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $76a15591a87ba8e0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $76a15591a87ba8e0$var$_arrayLikeToArray(o, minLen);
}
function $76a15591a87ba8e0$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $76a15591a87ba8e0$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $76a15591a87ba8e0$var$_arrayLikeToArray(arr);
}
function $76a15591a87ba8e0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $76a15591a87ba8e0$var$ACCURACY = 1e-4;
var $76a15591a87ba8e0$var$cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var $76a15591a87ba8e0$var$multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var $76a15591a87ba8e0$var$cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = $76a15591a87ba8e0$var$cubicBezierFactor(c1, c2);
        return $76a15591a87ba8e0$var$multyTime(params, t);
    };
};
var $76a15591a87ba8e0$var$derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = $76a15591a87ba8e0$var$cubicBezierFactor(c1, c2);
        var newParams = [].concat($76a15591a87ba8e0$var$_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return $76a15591a87ba8e0$var$multyTime(newParams, t);
    };
};
var $76a15591a87ba8e0$export$56c51296f72f0592 = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case 'linear':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease':
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case 'ease-in':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease-out':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case 'ease-in-out':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split('(');
            if (easing[0] === 'cubic-bezier' && easing[1].split(')')[0].split(',').length === 4) {
                var _easing$1$split$0$spl = easing[1].split(')')[0].split(',').map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = $76a15591a87ba8e0$var$_slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, $28cf6a7385103719$export$c106dd0671a0fc2d)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, $28cf6a7385103719$export$c106dd0671a0fc2d)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === 'number' && num >= 0 && num <= 1;
    }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
    var curveX = $76a15591a87ba8e0$var$cubicBezier(x1, x2);
    var curveY = $76a15591a87ba8e0$var$cubicBezier(y1, y2);
    var derCurveX = $76a15591a87ba8e0$var$derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $76a15591a87ba8e0$var$ACCURACY || derVal < $76a15591a87ba8e0$var$ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $76a15591a87ba8e0$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $76a15591a87ba8e0$var$ACCURACY && Math.abs(newV) < $76a15591a87ba8e0$var$ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $76a15591a87ba8e0$export$e3e04925801e5434 = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === 'string') switch(easing){
        case 'ease':
        case 'ease-in-out':
        case 'ease-out':
        case 'ease-in':
        case 'linear':
            return $76a15591a87ba8e0$export$56c51296f72f0592(easing);
        case 'spring':
            return $76a15591a87ba8e0$export$12fc25daf62b865a();
        default:
            if (easing.split('(')[0] === 'cubic-bezier') return $76a15591a87ba8e0$export$56c51296f72f0592(easing);
            (0, $28cf6a7385103719$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === 'function') return easing;
    (0, $28cf6a7385103719$export$c106dd0671a0fc2d)(false, '[configEasing]: first argument type should be function or string, instead received %s', args);
    return null;
};



function $4cbf2cae0e990b76$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4cbf2cae0e990b76$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4cbf2cae0e990b76$var$_typeof(o);
}
function $4cbf2cae0e990b76$var$_toConsumableArray(arr) {
    return $4cbf2cae0e990b76$var$_arrayWithoutHoles(arr) || $4cbf2cae0e990b76$var$_iterableToArray(arr) || $4cbf2cae0e990b76$var$_unsupportedIterableToArray(arr) || $4cbf2cae0e990b76$var$_nonIterableSpread();
}
function $4cbf2cae0e990b76$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4cbf2cae0e990b76$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $4cbf2cae0e990b76$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $4cbf2cae0e990b76$var$_arrayLikeToArray(arr);
}
function $4cbf2cae0e990b76$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4cbf2cae0e990b76$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4cbf2cae0e990b76$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4cbf2cae0e990b76$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4cbf2cae0e990b76$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4cbf2cae0e990b76$var$_defineProperty(obj, key, value) {
    key = $4cbf2cae0e990b76$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4cbf2cae0e990b76$var$_toPropertyKey(arg) {
    var key = $4cbf2cae0e990b76$var$_toPrimitive(arg, "string");
    return $4cbf2cae0e990b76$var$_typeof(key) === "symbol" ? key : String(key);
}
function $4cbf2cae0e990b76$var$_toPrimitive(input, hint) {
    if ($4cbf2cae0e990b76$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($4cbf2cae0e990b76$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $4cbf2cae0e990b76$var$_slicedToArray(arr, i) {
    return $4cbf2cae0e990b76$var$_arrayWithHoles(arr) || $4cbf2cae0e990b76$var$_iterableToArrayLimit(arr, i) || $4cbf2cae0e990b76$var$_unsupportedIterableToArray(arr, i) || $4cbf2cae0e990b76$var$_nonIterableRest();
}
function $4cbf2cae0e990b76$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4cbf2cae0e990b76$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4cbf2cae0e990b76$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4cbf2cae0e990b76$var$_arrayLikeToArray(o, minLen);
}
function $4cbf2cae0e990b76$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4cbf2cae0e990b76$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $4cbf2cae0e990b76$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $4cbf2cae0e990b76$var$alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var $4cbf2cae0e990b76$var$needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $4cbf2cae0e990b76$var$calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, $28cf6a7385103719$export$d6051a0f7a227332)(function(key, val) {
        if ($4cbf2cae0e990b76$var$needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = $4cbf2cae0e990b76$var$_slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return $4cbf2cae0e990b76$var$_objectSpread($4cbf2cae0e990b76$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $28cf6a7385103719$export$d6051a0f7a227332)(function(key, val) {
        if ($4cbf2cae0e990b76$var$needContinue(val)) return $4cbf2cae0e990b76$var$_objectSpread($4cbf2cae0e990b76$var$_objectSpread({}, val), {}, {
            velocity: $4cbf2cae0e990b76$var$alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: $4cbf2cae0e990b76$var$alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
};
var // configure update function
$4cbf2cae0e990b76$export$2e2bcd8739ae039 = function(from, to, easing, duration, render) {
    var interKeys = (0, $28cf6a7385103719$export$59e29973723da0b3)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return $4cbf2cae0e990b76$var$_objectSpread($4cbf2cae0e990b76$var$_objectSpread({}, res), {}, $4cbf2cae0e990b76$var$_defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return $4cbf2cae0e990b76$var$_objectSpread($4cbf2cae0e990b76$var$_objectSpread({}, res), {}, $4cbf2cae0e990b76$var$_defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, $28cf6a7385103719$export$d6051a0f7a227332)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter($4cbf2cae0e990b76$var$needContinue).length;
    };
    // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $4cbf2cae0e990b76$var$calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render($4cbf2cae0e990b76$var$_objectSpread($4cbf2cae0e990b76$var$_objectSpread($4cbf2cae0e990b76$var$_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    };
    // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $28cf6a7385103719$export$d6051a0f7a227332)(function(key, val) {
            return $4cbf2cae0e990b76$var$alpha.apply(void 0, $4cbf2cae0e990b76$var$_toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle);
        // get union set and add compatible prefix
        render($4cbf2cae0e990b76$var$_objectSpread($4cbf2cae0e990b76$var$_objectSpread($4cbf2cae0e990b76$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, $28cf6a7385103719$export$d6051a0f7a227332)(function(key, val) {
                return $4cbf2cae0e990b76$var$alpha.apply(void 0, $4cbf2cae0e990b76$var$_toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render($4cbf2cae0e990b76$var$_objectSpread($4cbf2cae0e990b76$var$_objectSpread($4cbf2cae0e990b76$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate;
    // return start animation method
    return function() {
        requestAnimationFrame(update);
        // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};



function $85b251bbd816cf83$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $85b251bbd816cf83$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $85b251bbd816cf83$var$_typeof(o);
}
var $85b251bbd816cf83$var$_excluded = [
    "children",
    "begin",
    "duration",
    "attributeName",
    "easing",
    "isActive",
    "steps",
    "from",
    "to",
    "canBegin",
    "onAnimationEnd",
    "shouldReAnimate",
    "onAnimationReStart"
];
function $85b251bbd816cf83$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $85b251bbd816cf83$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $85b251bbd816cf83$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $85b251bbd816cf83$var$_toConsumableArray(arr) {
    return $85b251bbd816cf83$var$_arrayWithoutHoles(arr) || $85b251bbd816cf83$var$_iterableToArray(arr) || $85b251bbd816cf83$var$_unsupportedIterableToArray(arr) || $85b251bbd816cf83$var$_nonIterableSpread();
}
function $85b251bbd816cf83$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $85b251bbd816cf83$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $85b251bbd816cf83$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $85b251bbd816cf83$var$_arrayLikeToArray(o, minLen);
}
function $85b251bbd816cf83$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $85b251bbd816cf83$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $85b251bbd816cf83$var$_arrayLikeToArray(arr);
}
function $85b251bbd816cf83$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $85b251bbd816cf83$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $85b251bbd816cf83$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $85b251bbd816cf83$var$ownKeys(Object(t), !0).forEach(function(r) {
            $85b251bbd816cf83$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $85b251bbd816cf83$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $85b251bbd816cf83$var$_defineProperty(obj, key, value) {
    key = $85b251bbd816cf83$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $85b251bbd816cf83$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $85b251bbd816cf83$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $85b251bbd816cf83$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $85b251bbd816cf83$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $85b251bbd816cf83$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $85b251bbd816cf83$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $85b251bbd816cf83$var$_toPropertyKey(arg) {
    var key = $85b251bbd816cf83$var$_toPrimitive(arg, "string");
    return $85b251bbd816cf83$var$_typeof(key) === "symbol" ? key : String(key);
}
function $85b251bbd816cf83$var$_toPrimitive(input, hint) {
    if ($85b251bbd816cf83$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($85b251bbd816cf83$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $85b251bbd816cf83$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $85b251bbd816cf83$var$_setPrototypeOf(subClass, superClass);
}
function $85b251bbd816cf83$var$_setPrototypeOf(o, p) {
    $85b251bbd816cf83$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $85b251bbd816cf83$var$_setPrototypeOf(o, p);
}
function $85b251bbd816cf83$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $85b251bbd816cf83$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $85b251bbd816cf83$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $85b251bbd816cf83$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $85b251bbd816cf83$var$_possibleConstructorReturn(this, result);
    };
}
function $85b251bbd816cf83$var$_possibleConstructorReturn(self, call) {
    if (call && ($85b251bbd816cf83$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $85b251bbd816cf83$var$_assertThisInitialized(self);
}
function $85b251bbd816cf83$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $85b251bbd816cf83$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $85b251bbd816cf83$var$_getPrototypeOf(o) {
    $85b251bbd816cf83$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $85b251bbd816cf83$var$_getPrototypeOf(o);
}
var $85b251bbd816cf83$var$Animate = /*#__PURE__*/ function(_PureComponent) {
    $85b251bbd816cf83$var$_inherits(Animate, _PureComponent);
    var _super = $85b251bbd816cf83$var$_createSuper(Animate);
    function Animate(props, context) {
        var _this;
        $85b251bbd816cf83$var$_classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
        _this.handleStyleChange = _this.handleStyleChange.bind($85b251bbd816cf83$var$_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind($85b251bbd816cf83$var$_assertThisInitialized(_this));
        if (!isActive || duration <= 0) {
            _this.state = {
                style: {}
            };
            // if children is a function and animation is not active, set style to 'to'
            if (typeof children === 'function') _this.state = {
                style: to
            };
            return $85b251bbd816cf83$var$_possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === 'function') {
                _this.state = {
                    style: from
                };
                return $85b251bbd816cf83$var$_possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? $85b251bbd816cf83$var$_defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    $85b251bbd816cf83$var$_createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
                var style = this.state.style;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? $85b251bbd816cf83$var$_defineProperty({}, attributeName, to) : to
                    };
                    if (this.state && style) {
                        if (attributeName && style[attributeName] !== to || !attributeName && style !== to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, $2405e375887ef8eb$exports.deepEqual)(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
                if (this.state && style) {
                    var _newState = {
                        style: attributeName ? $85b251bbd816cf83$var$_defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && style[attributeName] !== from || !attributeName && style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation($85b251bbd816cf83$var$_objectSpread($85b251bbd816cf83$var$_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                var onAnimationEnd = this.props.onAnimationEnd;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
                if (onAnimationEnd) onAnimationEnd();
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, $4cbf2cae0e990b76$export$2e2bcd8739ae039)(from, to, (0, $76a15591a87ba8e0$export$e3e04925801e5434)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === 'function' || easing === 'spring') return [].concat($85b251bbd816cf83$var$_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, $28cf6a7385103719$export$1594c78389ee3429)(properties, duration, easing);
                    var newStyle = $85b251bbd816cf83$var$_objectSpread($85b251bbd816cf83$var$_objectSpread($85b251bbd816cf83$var$_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat($85b251bbd816cf83$var$_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, $28cf6a7385103719$export$f0954fd7d5368655));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat($85b251bbd816cf83$var$_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, $8fc08b46df15d7b3$export$2e2bcd8739ae039)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? $85b251bbd816cf83$var$_defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, $28cf6a7385103719$export$1594c78389ee3429)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    $85b251bbd816cf83$var$_objectSpread($85b251bbd816cf83$var$_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = $85b251bbd816cf83$var$_objectWithoutProperties(_this$props4, $85b251bbd816cf83$var$_excluded);
                var count = (0, $acw62.Children).count(children);
                // eslint-disable-next-line react/destructuring-assignment
                var stateStyle = this.state.style;
                if (typeof children === 'function') return children(stateStyle);
                if (!isActive || count === 0 || duration <= 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, $acw62.cloneElement)(container, $85b251bbd816cf83$var$_objectSpread($85b251bbd816cf83$var$_objectSpread({}, others), {}, {
                        style: $85b251bbd816cf83$var$_objectSpread($85b251bbd816cf83$var$_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, $acw62.Children).only(children));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, (0, $acw62.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, $acw62.PureComponent));
$85b251bbd816cf83$var$Animate.displayName = 'Animate';
$85b251bbd816cf83$var$Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: '',
    to: '',
    attributeName: '',
    easing: 'ease',
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
$85b251bbd816cf83$var$Animate.propTypes = {
    from: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
    ]),
    to: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
    ]),
    attributeName: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    // animation duration
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    begin: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    easing: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        duration: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object.isRequired,
        easing: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
                'ease',
                'ease-in',
                'ease-out',
                'ease-in-out',
                'linear'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf('string'),
        onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    })),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    canBegin: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    onAnimationStart: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onAnimationReStart: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
};
var $85b251bbd816cf83$export$2e2bcd8739ae039 = $85b251bbd816cf83$var$Animate;




var $324cdcf3b9db18d1$export$2e2bcd8739ae039 = (0, $85b251bbd816cf83$export$2e2bcd8739ae039);


var $394ab417e9bd75cc$exports = {};
var $769812b29c18141e$exports = {};
var $567f2dd161ebd4f6$exports = {};
var $bbb2d98cae25b61a$exports = {};
var $dd14efc87ba1cd5b$exports = {};
var $83df40714bf7006e$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $83df40714bf7006e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$83df40714bf7006e$exports = $83df40714bf7006e$var$listCacheClear;


var $d22fe27824ff9351$exports = {};
var $87257b05f5d9ad81$exports = {};
var $50557587dab070a0$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $50557587dab070a0$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$50557587dab070a0$exports = $50557587dab070a0$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87257b05f5d9ad81$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($50557587dab070a0$exports(array[length][0], key)) return length;
    }
    return -1;
}
$87257b05f5d9ad81$exports = $87257b05f5d9ad81$var$assocIndexOf;


/** Used for built-in method references. */ var $d22fe27824ff9351$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d22fe27824ff9351$var$splice = $d22fe27824ff9351$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d22fe27824ff9351$var$listCacheDelete(key) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d22fe27824ff9351$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$d22fe27824ff9351$exports = $d22fe27824ff9351$var$listCacheDelete;


var $b2e6263d81cdc1b3$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2e6263d81cdc1b3$var$listCacheGet(key) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$b2e6263d81cdc1b3$exports = $b2e6263d81cdc1b3$var$listCacheGet;


var $29e2bc7b7348833e$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $29e2bc7b7348833e$var$listCacheHas(key) {
    return $87257b05f5d9ad81$exports(this.__data__, key) > -1;
}
$29e2bc7b7348833e$exports = $29e2bc7b7348833e$var$listCacheHas;


var $ff9311500b60ab72$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ff9311500b60ab72$var$listCacheSet(key, value) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$ff9311500b60ab72$exports = $ff9311500b60ab72$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd14efc87ba1cd5b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dd14efc87ba1cd5b$var$ListCache.prototype.clear = $83df40714bf7006e$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype['delete'] = $d22fe27824ff9351$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.get = $b2e6263d81cdc1b3$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.has = $29e2bc7b7348833e$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.set = $ff9311500b60ab72$exports;
$dd14efc87ba1cd5b$exports = $dd14efc87ba1cd5b$var$ListCache;


var $e8ee1d354807980a$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $e8ee1d354807980a$var$stackClear() {
    this.__data__ = new $dd14efc87ba1cd5b$exports;
    this.size = 0;
}
$e8ee1d354807980a$exports = $e8ee1d354807980a$var$stackClear;


var $b2ddb9d63293f3a5$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2ddb9d63293f3a5$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$b2ddb9d63293f3a5$exports = $b2ddb9d63293f3a5$var$stackDelete;


var $80d0940a423a17dc$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $80d0940a423a17dc$var$stackGet(key) {
    return this.__data__.get(key);
}
$80d0940a423a17dc$exports = $80d0940a423a17dc$var$stackGet;


var $010f38d5d914cfa2$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $010f38d5d914cfa2$var$stackHas(key) {
    return this.__data__.has(key);
}
$010f38d5d914cfa2$exports = $010f38d5d914cfa2$var$stackHas;


var $9280d00f89f25fa9$exports = {};

var $19b02faa57603249$exports = {};
var $5037fd2e597c2a03$exports = {};
var $8360225fb63098b3$exports = {};
var $004783abbde551e4$exports = {};
var $a7f8a2555793d7d3$exports = {};
var $3ba72ebe7e4419b5$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $23YZo.Symbol;
$3ba72ebe7e4419b5$exports = $3ba72ebe7e4419b5$var$Symbol;


var $dabe9ecbecc6d0b5$exports = {};

/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
$dabe9ecbecc6d0b5$exports = $dabe9ecbecc6d0b5$var$getRawTag;


var $3fce91ec3914aaed$exports = {};
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
$3fce91ec3914aaed$exports = $3fce91ec3914aaed$var$objectToString;


/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = '[object Null]', $a7f8a2555793d7d3$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $dabe9ecbecc6d0b5$exports(value) : $3fce91ec3914aaed$exports(value);
}
$a7f8a2555793d7d3$exports = $a7f8a2555793d7d3$var$baseGetTag;


var $f9ff2e983beb6b86$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$f9ff2e983beb6b86$exports = $f9ff2e983beb6b86$var$isObject;


/** `Object#toString` result references. */ var $004783abbde551e4$var$asyncTag = '[object AsyncFunction]', $004783abbde551e4$var$funcTag = '[object Function]', $004783abbde551e4$var$genTag = '[object GeneratorFunction]', $004783abbde551e4$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $004783abbde551e4$var$isFunction(value) {
    if (!$f9ff2e983beb6b86$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $a7f8a2555793d7d3$exports(value);
    return tag == $004783abbde551e4$var$funcTag || tag == $004783abbde551e4$var$genTag || tag == $004783abbde551e4$var$asyncTag || tag == $004783abbde551e4$var$proxyTag;
}
$004783abbde551e4$exports = $004783abbde551e4$var$isFunction;


var $5e8d211f630cd46d$exports = {};
var $baf78e1246b3b18f$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Used to detect overreaching core-js shims. */ var $baf78e1246b3b18f$var$coreJsData = $23YZo["__core-js_shared__"];
$baf78e1246b3b18f$exports = $baf78e1246b3b18f$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $5e8d211f630cd46d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($baf78e1246b3b18f$exports && $baf78e1246b3b18f$exports.keys && $baf78e1246b3b18f$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5e8d211f630cd46d$var$isMasked(func) {
    return !!$5e8d211f630cd46d$var$maskSrcKey && $5e8d211f630cd46d$var$maskSrcKey in func;
}
$5e8d211f630cd46d$exports = $5e8d211f630cd46d$var$isMasked;



var $9c6b3ec69362487e$exports = {};
/** Used for built-in method references. */ var $9c6b3ec69362487e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9c6b3ec69362487e$var$funcToString = $9c6b3ec69362487e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9c6b3ec69362487e$var$toSource(func) {
    if (func != null) {
        try {
            return $9c6b3ec69362487e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$9c6b3ec69362487e$exports = $9c6b3ec69362487e$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8360225fb63098b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8360225fb63098b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8360225fb63098b3$var$funcProto = Function.prototype, $8360225fb63098b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8360225fb63098b3$var$funcToString = $8360225fb63098b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8360225fb63098b3$var$hasOwnProperty = $8360225fb63098b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8360225fb63098b3$var$reIsNative = RegExp('^' + $8360225fb63098b3$var$funcToString.call($8360225fb63098b3$var$hasOwnProperty).replace($8360225fb63098b3$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8360225fb63098b3$var$baseIsNative(value) {
    if (!$f9ff2e983beb6b86$exports(value) || $5e8d211f630cd46d$exports(value)) return false;
    var pattern = $004783abbde551e4$exports(value) ? $8360225fb63098b3$var$reIsNative : $8360225fb63098b3$var$reIsHostCtor;
    return pattern.test($9c6b3ec69362487e$exports(value));
}
$8360225fb63098b3$exports = $8360225fb63098b3$var$baseIsNative;


var $d50b255f8680c47a$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d50b255f8680c47a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$d50b255f8680c47a$exports = $d50b255f8680c47a$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5037fd2e597c2a03$var$getNative(object, key) {
    var value = $d50b255f8680c47a$exports(object, key);
    return $8360225fb63098b3$exports(value) ? value : undefined;
}
$5037fd2e597c2a03$exports = $5037fd2e597c2a03$var$getNative;



var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $19b02faa57603249$var$Map = $5037fd2e597c2a03$exports($23YZo, 'Map');
$19b02faa57603249$exports = $19b02faa57603249$var$Map;


var $4902f64a16640324$exports = {};
var $df2cd4bc93f21548$exports = {};
var $8d50e526a9e9b7fa$exports = {};
var $80f20c637ba11563$exports = {};
var $e95343b7bf5d617b$exports = {};

/* Built-in method references that are verified to be native. */ var $e95343b7bf5d617b$var$nativeCreate = $5037fd2e597c2a03$exports(Object, 'create');
$e95343b7bf5d617b$exports = $e95343b7bf5d617b$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $80f20c637ba11563$var$hashClear() {
    this.__data__ = $e95343b7bf5d617b$exports ? $e95343b7bf5d617b$exports(null) : {};
    this.size = 0;
}
$80f20c637ba11563$exports = $80f20c637ba11563$var$hashClear;


var $60a2188452e03a76$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $60a2188452e03a76$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$60a2188452e03a76$exports = $60a2188452e03a76$var$hashDelete;


var $0ade0ffa62051a98$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $0ade0ffa62051a98$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $0ade0ffa62051a98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0ade0ffa62051a98$var$hasOwnProperty = $0ade0ffa62051a98$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0ade0ffa62051a98$var$hashGet(key) {
    var data = this.__data__;
    if ($e95343b7bf5d617b$exports) {
        var result = data[key];
        return result === $0ade0ffa62051a98$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0ade0ffa62051a98$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$0ade0ffa62051a98$exports = $0ade0ffa62051a98$var$hashGet;


var $0d7f9677a17b6bef$exports = {};

/** Used for built-in method references. */ var $0d7f9677a17b6bef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d7f9677a17b6bef$var$hasOwnProperty = $0d7f9677a17b6bef$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0d7f9677a17b6bef$var$hashHas(key) {
    var data = this.__data__;
    return $e95343b7bf5d617b$exports ? data[key] !== undefined : $0d7f9677a17b6bef$var$hasOwnProperty.call(data, key);
}
$0d7f9677a17b6bef$exports = $0d7f9677a17b6bef$var$hashHas;


var $d33db65186b62952$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $d33db65186b62952$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d33db65186b62952$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $e95343b7bf5d617b$exports && value === undefined ? $d33db65186b62952$var$HASH_UNDEFINED : value;
    return this;
}
$d33db65186b62952$exports = $d33db65186b62952$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8d50e526a9e9b7fa$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8d50e526a9e9b7fa$var$Hash.prototype.clear = $80f20c637ba11563$exports;
$8d50e526a9e9b7fa$var$Hash.prototype['delete'] = $60a2188452e03a76$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.get = $0ade0ffa62051a98$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.has = $0d7f9677a17b6bef$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.set = $d33db65186b62952$exports;
$8d50e526a9e9b7fa$exports = $8d50e526a9e9b7fa$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $df2cd4bc93f21548$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $8d50e526a9e9b7fa$exports,
        'map': new ($19b02faa57603249$exports || $dd14efc87ba1cd5b$exports),
        'string': new $8d50e526a9e9b7fa$exports
    };
}
$df2cd4bc93f21548$exports = $df2cd4bc93f21548$var$mapCacheClear;


var $44464964ade29765$exports = {};
var $c0b23e5f03c2595b$exports = {};
var $09c4668903e66c1d$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $09c4668903e66c1d$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$09c4668903e66c1d$exports = $09c4668903e66c1d$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c0b23e5f03c2595b$var$getMapData(map, key) {
    var data = map.__data__;
    return $09c4668903e66c1d$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$c0b23e5f03c2595b$exports = $c0b23e5f03c2595b$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44464964ade29765$var$mapCacheDelete(key) {
    var result = $c0b23e5f03c2595b$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$44464964ade29765$exports = $44464964ade29765$var$mapCacheDelete;


var $ba80406da5503086$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba80406da5503086$var$mapCacheGet(key) {
    return $c0b23e5f03c2595b$exports(this, key).get(key);
}
$ba80406da5503086$exports = $ba80406da5503086$var$mapCacheGet;


var $d3abe18ea687dfb7$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3abe18ea687dfb7$var$mapCacheHas(key) {
    return $c0b23e5f03c2595b$exports(this, key).has(key);
}
$d3abe18ea687dfb7$exports = $d3abe18ea687dfb7$var$mapCacheHas;


var $347643e3dcfcc207$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $347643e3dcfcc207$var$mapCacheSet(key, value) {
    var data = $c0b23e5f03c2595b$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$347643e3dcfcc207$exports = $347643e3dcfcc207$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4902f64a16640324$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4902f64a16640324$var$MapCache.prototype.clear = $df2cd4bc93f21548$exports;
$4902f64a16640324$var$MapCache.prototype['delete'] = $44464964ade29765$exports;
$4902f64a16640324$var$MapCache.prototype.get = $ba80406da5503086$exports;
$4902f64a16640324$var$MapCache.prototype.has = $d3abe18ea687dfb7$exports;
$4902f64a16640324$var$MapCache.prototype.set = $347643e3dcfcc207$exports;
$4902f64a16640324$exports = $4902f64a16640324$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9280d00f89f25fa9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $dd14efc87ba1cd5b$exports) {
        var pairs = data.__data__;
        if (!$19b02faa57603249$exports || pairs.length < $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $4902f64a16640324$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$9280d00f89f25fa9$exports = $9280d00f89f25fa9$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bbb2d98cae25b61a$var$Stack(entries) {
    var data = this.__data__ = new $dd14efc87ba1cd5b$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$bbb2d98cae25b61a$var$Stack.prototype.clear = $e8ee1d354807980a$exports;
$bbb2d98cae25b61a$var$Stack.prototype['delete'] = $b2ddb9d63293f3a5$exports;
$bbb2d98cae25b61a$var$Stack.prototype.get = $80d0940a423a17dc$exports;
$bbb2d98cae25b61a$var$Stack.prototype.has = $010f38d5d914cfa2$exports;
$bbb2d98cae25b61a$var$Stack.prototype.set = $9280d00f89f25fa9$exports;
$bbb2d98cae25b61a$exports = $bbb2d98cae25b61a$var$Stack;


var $1081bd3a2e361911$exports = {};
var $a29ccdc0f60e279e$exports = {};

var $dda8f7b6b589544e$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $dda8f7b6b589544e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $dda8f7b6b589544e$var$setCacheAdd(value) {
    this.__data__.set(value, $dda8f7b6b589544e$var$HASH_UNDEFINED);
    return this;
}
$dda8f7b6b589544e$exports = $dda8f7b6b589544e$var$setCacheAdd;


var $66732c92c350622c$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $66732c92c350622c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$66732c92c350622c$exports = $66732c92c350622c$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a29ccdc0f60e279e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $4902f64a16640324$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a29ccdc0f60e279e$var$SetCache.prototype.add = $a29ccdc0f60e279e$var$SetCache.prototype.push = $dda8f7b6b589544e$exports;
$a29ccdc0f60e279e$var$SetCache.prototype.has = $66732c92c350622c$exports;
$a29ccdc0f60e279e$exports = $a29ccdc0f60e279e$var$SetCache;


var $aae24ad60cc3cfcb$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $aae24ad60cc3cfcb$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$aae24ad60cc3cfcb$exports = $aae24ad60cc3cfcb$var$arraySome;


var $1b44096ad4b9e2d5$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1b44096ad4b9e2d5$var$cacheHas(cache, key) {
    return cache.has(key);
}
$1b44096ad4b9e2d5$exports = $1b44096ad4b9e2d5$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG = 1, $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1081bd3a2e361911$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG ? new $a29ccdc0f60e279e$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$aae24ad60cc3cfcb$exports(other, function(othValue, othIndex) {
                if (!$1b44096ad4b9e2d5$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$1081bd3a2e361911$exports = $1081bd3a2e361911$var$equalArrays;


var $baf52b9e146f3da7$exports = {};

var $facf83d1449a27b8$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $facf83d1449a27b8$var$Uint8Array = $23YZo.Uint8Array;
$facf83d1449a27b8$exports = $facf83d1449a27b8$var$Uint8Array;




var $91d4444cbb077e0c$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $91d4444cbb077e0c$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$91d4444cbb077e0c$exports = $91d4444cbb077e0c$var$mapToArray;


var $11f509f8f53d8c36$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $11f509f8f53d8c36$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$11f509f8f53d8c36$exports = $11f509f8f53d8c36$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG = 1, $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $baf52b9e146f3da7$var$boolTag = '[object Boolean]', $baf52b9e146f3da7$var$dateTag = '[object Date]', $baf52b9e146f3da7$var$errorTag = '[object Error]', $baf52b9e146f3da7$var$mapTag = '[object Map]', $baf52b9e146f3da7$var$numberTag = '[object Number]', $baf52b9e146f3da7$var$regexpTag = '[object RegExp]', $baf52b9e146f3da7$var$setTag = '[object Set]', $baf52b9e146f3da7$var$stringTag = '[object String]', $baf52b9e146f3da7$var$symbolTag = '[object Symbol]';
var $baf52b9e146f3da7$var$arrayBufferTag = '[object ArrayBuffer]', $baf52b9e146f3da7$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $baf52b9e146f3da7$var$symbolProto = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.prototype : undefined, $baf52b9e146f3da7$var$symbolValueOf = $baf52b9e146f3da7$var$symbolProto ? $baf52b9e146f3da7$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $baf52b9e146f3da7$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $baf52b9e146f3da7$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $baf52b9e146f3da7$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $facf83d1449a27b8$exports(object), new $facf83d1449a27b8$exports(other))) return false;
            return true;
        case $baf52b9e146f3da7$var$boolTag:
        case $baf52b9e146f3da7$var$dateTag:
        case $baf52b9e146f3da7$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $50557587dab070a0$exports(+object, +other);
        case $baf52b9e146f3da7$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $baf52b9e146f3da7$var$regexpTag:
        case $baf52b9e146f3da7$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $baf52b9e146f3da7$var$mapTag:
            var convert = $91d4444cbb077e0c$exports;
        case $baf52b9e146f3da7$var$setTag:
            var isPartial = bitmask & $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $11f509f8f53d8c36$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1081bd3a2e361911$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $baf52b9e146f3da7$var$symbolTag:
            if ($baf52b9e146f3da7$var$symbolValueOf) return $baf52b9e146f3da7$var$symbolValueOf.call(object) == $baf52b9e146f3da7$var$symbolValueOf.call(other);
    }
    return false;
}
$baf52b9e146f3da7$exports = $baf52b9e146f3da7$var$equalByTag;


var $ac8a81cbae0357e8$exports = {};
var $7958eecccfe4cef6$exports = {};
var $9144d49da7a47a72$exports = {};
var $cc77dbb7c08db6a8$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cc77dbb7c08db6a8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$cc77dbb7c08db6a8$exports = $cc77dbb7c08db6a8$var$arrayPush;


var $0488fde9aa355453$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
$0488fde9aa355453$exports = $0488fde9aa355453$var$isArray;


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9144d49da7a47a72$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $0488fde9aa355453$exports(object) ? result : $cc77dbb7c08db6a8$exports(result, symbolsFunc(object));
}
$9144d49da7a47a72$exports = $9144d49da7a47a72$var$baseGetAllKeys;


var $51326a29f571e7cd$exports = {};
var $6549fed720324048$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6549fed720324048$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$6549fed720324048$exports = $6549fed720324048$var$arrayFilter;


var $8fc9f7df9b0c06bb$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $8fc9f7df9b0c06bb$var$stubArray() {
    return [];
}
$8fc9f7df9b0c06bb$exports = $8fc9f7df9b0c06bb$var$stubArray;


/** Used for built-in method references. */ var $51326a29f571e7cd$var$objectProto = Object.prototype;
/** Built-in value references. */ var $51326a29f571e7cd$var$propertyIsEnumerable = $51326a29f571e7cd$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $51326a29f571e7cd$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $51326a29f571e7cd$var$getSymbols = !$51326a29f571e7cd$var$nativeGetSymbols ? $8fc9f7df9b0c06bb$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $6549fed720324048$exports($51326a29f571e7cd$var$nativeGetSymbols(object), function(symbol) {
        return $51326a29f571e7cd$var$propertyIsEnumerable.call(object, symbol);
    });
};
$51326a29f571e7cd$exports = $51326a29f571e7cd$var$getSymbols;


var $08f0eaf3fbcb2fde$exports = {};
var $64568844439edb7f$exports = {};
var $b14d62a510ae7f2d$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b14d62a510ae7f2d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$b14d62a510ae7f2d$exports = $b14d62a510ae7f2d$var$baseTimes;


var $7d0c6fd0eb26be0e$exports = {};
var $fb8f823cdc90f511$exports = {};

var $61269cf1f3e020be$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$61269cf1f3e020be$exports = $61269cf1f3e020be$var$isObjectLike;


/** `Object#toString` result references. */ var $fb8f823cdc90f511$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $fb8f823cdc90f511$var$baseIsArguments(value) {
    return $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $fb8f823cdc90f511$var$argsTag;
}
$fb8f823cdc90f511$exports = $fb8f823cdc90f511$var$baseIsArguments;



/** Used for built-in method references. */ var $7d0c6fd0eb26be0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0c6fd0eb26be0e$var$hasOwnProperty = $7d0c6fd0eb26be0e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $7d0c6fd0eb26be0e$var$propertyIsEnumerable = $7d0c6fd0eb26be0e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $7d0c6fd0eb26be0e$var$isArguments = $fb8f823cdc90f511$exports(function() {
    return arguments;
}()) ? $fb8f823cdc90f511$exports : function(value) {
    return $61269cf1f3e020be$exports(value) && $7d0c6fd0eb26be0e$var$hasOwnProperty.call(value, 'callee') && !$7d0c6fd0eb26be0e$var$propertyIsEnumerable.call(value, 'callee');
};
$7d0c6fd0eb26be0e$exports = $7d0c6fd0eb26be0e$var$isArguments;




var $f504n = parcelRequire("f504n");
var $d83738e053b5eb08$exports = {};
/** Used as references for various `Number` constants. */ var $d83738e053b5eb08$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d83738e053b5eb08$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d83738e053b5eb08$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d83738e053b5eb08$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $d83738e053b5eb08$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$d83738e053b5eb08$exports = $d83738e053b5eb08$var$isIndex;


var $156c3727697ab085$exports = {};
var $9d076681a0e29d68$exports = {};

var $15d215b19bcf1187$exports = {};
/** Used as references for various `Number` constants. */ var $15d215b19bcf1187$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $15d215b19bcf1187$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $15d215b19bcf1187$var$MAX_SAFE_INTEGER;
}
$15d215b19bcf1187$exports = $15d215b19bcf1187$var$isLength;



/** `Object#toString` result references. */ var $9d076681a0e29d68$var$argsTag = '[object Arguments]', $9d076681a0e29d68$var$arrayTag = '[object Array]', $9d076681a0e29d68$var$boolTag = '[object Boolean]', $9d076681a0e29d68$var$dateTag = '[object Date]', $9d076681a0e29d68$var$errorTag = '[object Error]', $9d076681a0e29d68$var$funcTag = '[object Function]', $9d076681a0e29d68$var$mapTag = '[object Map]', $9d076681a0e29d68$var$numberTag = '[object Number]', $9d076681a0e29d68$var$objectTag = '[object Object]', $9d076681a0e29d68$var$regexpTag = '[object RegExp]', $9d076681a0e29d68$var$setTag = '[object Set]', $9d076681a0e29d68$var$stringTag = '[object String]', $9d076681a0e29d68$var$weakMapTag = '[object WeakMap]';
var $9d076681a0e29d68$var$arrayBufferTag = '[object ArrayBuffer]', $9d076681a0e29d68$var$dataViewTag = '[object DataView]', $9d076681a0e29d68$var$float32Tag = '[object Float32Array]', $9d076681a0e29d68$var$float64Tag = '[object Float64Array]', $9d076681a0e29d68$var$int8Tag = '[object Int8Array]', $9d076681a0e29d68$var$int16Tag = '[object Int16Array]', $9d076681a0e29d68$var$int32Tag = '[object Int32Array]', $9d076681a0e29d68$var$uint8Tag = '[object Uint8Array]', $9d076681a0e29d68$var$uint8ClampedTag = '[object Uint8ClampedArray]', $9d076681a0e29d68$var$uint16Tag = '[object Uint16Array]', $9d076681a0e29d68$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $9d076681a0e29d68$var$typedArrayTags = {};
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float64Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8ClampedTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint32Tag] = true;
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$argsTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayBufferTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$boolTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dataViewTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dateTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$errorTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$funcTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$mapTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$numberTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$objectTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$regexpTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$setTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$stringTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $9d076681a0e29d68$var$baseIsTypedArray(value) {
    return $61269cf1f3e020be$exports(value) && $15d215b19bcf1187$exports(value.length) && !!$9d076681a0e29d68$var$typedArrayTags[$a7f8a2555793d7d3$exports(value)];
}
$9d076681a0e29d68$exports = $9d076681a0e29d68$var$baseIsTypedArray;


var $692cb5474f422969$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $692cb5474f422969$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$692cb5474f422969$exports = $692cb5474f422969$var$baseUnary;



var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $156c3727697ab085$var$nodeIsTypedArray = $jIny1 && $jIny1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $156c3727697ab085$var$isTypedArray = $156c3727697ab085$var$nodeIsTypedArray ? $692cb5474f422969$exports($156c3727697ab085$var$nodeIsTypedArray) : $9d076681a0e29d68$exports;
$156c3727697ab085$exports = $156c3727697ab085$var$isTypedArray;


/** Used for built-in method references. */ var $64568844439edb7f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64568844439edb7f$var$hasOwnProperty = $64568844439edb7f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $64568844439edb7f$var$arrayLikeKeys(value, inherited) {
    var isArr = $0488fde9aa355453$exports(value), isArg = !isArr && $7d0c6fd0eb26be0e$exports(value), isBuff = !isArr && !isArg && $f504n(value), isType = !isArr && !isArg && !isBuff && $156c3727697ab085$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $b14d62a510ae7f2d$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $64568844439edb7f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $d83738e053b5eb08$exports(key, length)))) result.push(key);
    return result;
}
$64568844439edb7f$exports = $64568844439edb7f$var$arrayLikeKeys;


var $e811d2e210fb58cc$exports = {};
var $292432068be14a79$exports = {};
/** Used for built-in method references. */ var $292432068be14a79$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $292432068be14a79$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $292432068be14a79$var$objectProto;
    return value === proto;
}
$292432068be14a79$exports = $292432068be14a79$var$isPrototype;


var $0b26005314403d97$exports = {};
var $ff813e49bf3cca3d$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ff813e49bf3cca3d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$ff813e49bf3cca3d$exports = $ff813e49bf3cca3d$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $0b26005314403d97$var$nativeKeys = $ff813e49bf3cca3d$exports(Object.keys, Object);
$0b26005314403d97$exports = $0b26005314403d97$var$nativeKeys;


/** Used for built-in method references. */ var $e811d2e210fb58cc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e811d2e210fb58cc$var$hasOwnProperty = $e811d2e210fb58cc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e811d2e210fb58cc$var$baseKeys(object) {
    if (!$292432068be14a79$exports(object)) return $0b26005314403d97$exports(object);
    var result = [];
    for(var key in Object(object))if ($e811d2e210fb58cc$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$e811d2e210fb58cc$exports = $e811d2e210fb58cc$var$baseKeys;


var $ac2c42592aa05543$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ac2c42592aa05543$var$isArrayLike(value) {
    return value != null && $15d215b19bcf1187$exports(value.length) && !$004783abbde551e4$exports(value);
}
$ac2c42592aa05543$exports = $ac2c42592aa05543$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $08f0eaf3fbcb2fde$var$keys(object) {
    return $ac2c42592aa05543$exports(object) ? $64568844439edb7f$exports(object) : $e811d2e210fb58cc$exports(object);
}
$08f0eaf3fbcb2fde$exports = $08f0eaf3fbcb2fde$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7958eecccfe4cef6$var$getAllKeys(object) {
    return $9144d49da7a47a72$exports(object, $08f0eaf3fbcb2fde$exports, $51326a29f571e7cd$exports);
}
$7958eecccfe4cef6$exports = $7958eecccfe4cef6$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ac8a81cbae0357e8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ac8a81cbae0357e8$var$hasOwnProperty = $ac8a81cbae0357e8$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ac8a81cbae0357e8$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG, objProps = $7958eecccfe4cef6$exports(object), objLength = objProps.length, othProps = $7958eecccfe4cef6$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ac8a81cbae0357e8$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$ac8a81cbae0357e8$exports = $ac8a81cbae0357e8$var$equalObjects;


var $474f685f496bfe31$exports = {};
var $41ce0ff3b38ee753$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $41ce0ff3b38ee753$var$DataView = $5037fd2e597c2a03$exports($23YZo, 'DataView');
$41ce0ff3b38ee753$exports = $41ce0ff3b38ee753$var$DataView;



var $b0226bdea11cb834$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $b0226bdea11cb834$var$Promise = $5037fd2e597c2a03$exports($23YZo, 'Promise');
$b0226bdea11cb834$exports = $b0226bdea11cb834$var$Promise;


var $05f44e958da968eb$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $05f44e958da968eb$var$Set = $5037fd2e597c2a03$exports($23YZo, 'Set');
$05f44e958da968eb$exports = $05f44e958da968eb$var$Set;


var $aedce50092a1e6a6$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $aedce50092a1e6a6$var$WeakMap = $5037fd2e597c2a03$exports($23YZo, 'WeakMap');
$aedce50092a1e6a6$exports = $aedce50092a1e6a6$var$WeakMap;




/** `Object#toString` result references. */ var $474f685f496bfe31$var$mapTag = '[object Map]', $474f685f496bfe31$var$objectTag = '[object Object]', $474f685f496bfe31$var$promiseTag = '[object Promise]', $474f685f496bfe31$var$setTag = '[object Set]', $474f685f496bfe31$var$weakMapTag = '[object WeakMap]';
var $474f685f496bfe31$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $474f685f496bfe31$var$dataViewCtorString = $9c6b3ec69362487e$exports($41ce0ff3b38ee753$exports), $474f685f496bfe31$var$mapCtorString = $9c6b3ec69362487e$exports($19b02faa57603249$exports), $474f685f496bfe31$var$promiseCtorString = $9c6b3ec69362487e$exports($b0226bdea11cb834$exports), $474f685f496bfe31$var$setCtorString = $9c6b3ec69362487e$exports($05f44e958da968eb$exports), $474f685f496bfe31$var$weakMapCtorString = $9c6b3ec69362487e$exports($aedce50092a1e6a6$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $474f685f496bfe31$var$getTag = $a7f8a2555793d7d3$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($41ce0ff3b38ee753$exports && $474f685f496bfe31$var$getTag(new $41ce0ff3b38ee753$exports(new ArrayBuffer(1))) != $474f685f496bfe31$var$dataViewTag || $19b02faa57603249$exports && $474f685f496bfe31$var$getTag(new $19b02faa57603249$exports) != $474f685f496bfe31$var$mapTag || $b0226bdea11cb834$exports && $474f685f496bfe31$var$getTag($b0226bdea11cb834$exports.resolve()) != $474f685f496bfe31$var$promiseTag || $05f44e958da968eb$exports && $474f685f496bfe31$var$getTag(new $05f44e958da968eb$exports) != $474f685f496bfe31$var$setTag || $aedce50092a1e6a6$exports && $474f685f496bfe31$var$getTag(new $aedce50092a1e6a6$exports) != $474f685f496bfe31$var$weakMapTag) $474f685f496bfe31$var$getTag = function(value) {
    var result = $a7f8a2555793d7d3$exports(value), Ctor = result == $474f685f496bfe31$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $9c6b3ec69362487e$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $474f685f496bfe31$var$dataViewCtorString:
            return $474f685f496bfe31$var$dataViewTag;
        case $474f685f496bfe31$var$mapCtorString:
            return $474f685f496bfe31$var$mapTag;
        case $474f685f496bfe31$var$promiseCtorString:
            return $474f685f496bfe31$var$promiseTag;
        case $474f685f496bfe31$var$setCtorString:
            return $474f685f496bfe31$var$setTag;
        case $474f685f496bfe31$var$weakMapCtorString:
            return $474f685f496bfe31$var$weakMapTag;
    }
    return result;
};
$474f685f496bfe31$exports = $474f685f496bfe31$var$getTag;




var $f504n = parcelRequire("f504n");

/** Used to compose bitmasks for value comparisons. */ var $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $567f2dd161ebd4f6$var$argsTag = '[object Arguments]', $567f2dd161ebd4f6$var$arrayTag = '[object Array]', $567f2dd161ebd4f6$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $567f2dd161ebd4f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $567f2dd161ebd4f6$var$hasOwnProperty = $567f2dd161ebd4f6$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $567f2dd161ebd4f6$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $0488fde9aa355453$exports(object), othIsArr = $0488fde9aa355453$exports(other), objTag = objIsArr ? $567f2dd161ebd4f6$var$arrayTag : $474f685f496bfe31$exports(object), othTag = othIsArr ? $567f2dd161ebd4f6$var$arrayTag : $474f685f496bfe31$exports(other);
    objTag = objTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : objTag;
    othTag = othTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : othTag;
    var objIsObj = objTag == $567f2dd161ebd4f6$var$objectTag, othIsObj = othTag == $567f2dd161ebd4f6$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $f504n(object)) {
        if (!$f504n(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $bbb2d98cae25b61a$exports);
        return objIsArr || $156c3727697ab085$exports(object) ? $1081bd3a2e361911$exports(object, other, bitmask, customizer, equalFunc, stack) : $baf52b9e146f3da7$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $bbb2d98cae25b61a$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $bbb2d98cae25b61a$exports);
    return $ac8a81cbae0357e8$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$567f2dd161ebd4f6$exports = $567f2dd161ebd4f6$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $769812b29c18141e$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$61269cf1f3e020be$exports(value) && !$61269cf1f3e020be$exports(other)) return value !== value && other !== other;
    return $567f2dd161ebd4f6$exports(value, other, bitmask, customizer, $769812b29c18141e$var$baseIsEqual, stack);
}
$769812b29c18141e$exports = $769812b29c18141e$var$baseIsEqual;


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $394ab417e9bd75cc$var$isEqual(value, other) {
    return $769812b29c18141e$exports(value, other);
}
$394ab417e9bd75cc$exports = $394ab417e9bd75cc$var$isEqual;


var $0ada68b02fed3a09$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $0ada68b02fed3a09$var$isNil(value) {
    return value == null;
}
$0ada68b02fed3a09$exports = $0ada68b02fed3a09$var$isNil;



var $acw62 = parcelRequire("acw62");

var $d299ac421c05c135$exports = {};
var $fd2d90f592c63519$exports = {};
var $38afcbfab85a0553$exports = {};

var $03e9beb856e9b4cd$exports = {};

var $6b5a5095e0934938$exports = {};


/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == 'symbol' || $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $6b5a5095e0934938$var$symbolTag;
}
$6b5a5095e0934938$exports = $6b5a5095e0934938$var$isSymbol;


/** Used to match property names within property paths. */ var $03e9beb856e9b4cd$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $03e9beb856e9b4cd$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $03e9beb856e9b4cd$var$isKey(value, object) {
    if ($0488fde9aa355453$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $6b5a5095e0934938$exports(value)) return true;
    return $03e9beb856e9b4cd$var$reIsPlainProp.test(value) || !$03e9beb856e9b4cd$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$03e9beb856e9b4cd$exports = $03e9beb856e9b4cd$var$isKey;


var $f9135a667399ede4$exports = {};
var $6aae515404bf5dd2$exports = {};
var $17f5c88c594eac51$exports = {};

/** Error message constants. */ var $17f5c88c594eac51$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $17f5c88c594eac51$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($17f5c88c594eac51$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($17f5c88c594eac51$var$memoize.Cache || $4902f64a16640324$exports);
    return memoized;
}
// Expose `MapCache`.
$17f5c88c594eac51$var$memoize.Cache = $4902f64a16640324$exports;
$17f5c88c594eac51$exports = $17f5c88c594eac51$var$memoize;


/** Used as the maximum memoize cache size. */ var $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $6aae515404bf5dd2$var$memoizeCapped(func) {
    var result = $17f5c88c594eac51$exports(func, function(key) {
        if (cache.size === $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$6aae515404bf5dd2$exports = $6aae515404bf5dd2$var$memoizeCapped;


/** Used to match property names within property paths. */ var $f9135a667399ede4$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $f9135a667399ede4$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9135a667399ede4$var$stringToPath = $6aae515404bf5dd2$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($f9135a667399ede4$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($f9135a667399ede4$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$f9135a667399ede4$exports = $f9135a667399ede4$var$stringToPath;


var $f5d9385a9cc7e413$exports = {};
var $f16f644742c27c21$exports = {};

var $d26d80da1ba3948c$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$d26d80da1ba3948c$exports = $d26d80da1ba3948c$var$arrayMap;




/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($0488fde9aa355453$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $d26d80da1ba3948c$exports(value, $f16f644742c27c21$var$baseToString) + '';
    if ($6b5a5095e0934938$exports(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$f16f644742c27c21$var$INFINITY ? '-0' : result;
}
$f16f644742c27c21$exports = $f16f644742c27c21$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? '' : $f16f644742c27c21$exports(value);
}
$f5d9385a9cc7e413$exports = $f5d9385a9cc7e413$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $38afcbfab85a0553$var$castPath(value, object) {
    if ($0488fde9aa355453$exports(value)) return value;
    return $03e9beb856e9b4cd$exports(value, object) ? [
        value
    ] : $f9135a667399ede4$exports($f5d9385a9cc7e413$exports(value));
}
$38afcbfab85a0553$exports = $38afcbfab85a0553$var$castPath;


var $4d60aa8c33155976$exports = {};

/** Used as references for various `Number` constants. */ var $4d60aa8c33155976$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4d60aa8c33155976$var$toKey(value) {
    if (typeof value == 'string' || $6b5a5095e0934938$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$4d60aa8c33155976$var$INFINITY ? '-0' : result;
}
$4d60aa8c33155976$exports = $4d60aa8c33155976$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $fd2d90f592c63519$var$baseGet(object, path) {
    path = $38afcbfab85a0553$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$4d60aa8c33155976$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$fd2d90f592c63519$exports = $fd2d90f592c63519$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $d299ac421c05c135$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $fd2d90f592c63519$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$d299ac421c05c135$exports = $d299ac421c05c135$var$get;



var $15ee4628980e0994$exports = {};



/** `Object#toString` result references. */ var $15ee4628980e0994$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $15ee4628980e0994$var$isString(value) {
    return typeof value == 'string' || !$0488fde9aa355453$exports(value) && $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $15ee4628980e0994$var$stringTag;
}
$15ee4628980e0994$exports = $15ee4628980e0994$var$isString;





var $acw62 = parcelRequire("acw62");
var $3251146683c5d714$exports = {};
'use strict';

$3251146683c5d714$exports = (parcelRequire("9cCWX"));



var $10ed4ab35db4c025$exports = {};
var $8f2e1f7d7f8ca8b6$exports = {};


/** `Object#toString` result references. */ var $8f2e1f7d7f8ca8b6$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $8f2e1f7d7f8ca8b6$var$isNumber(value) {
    return typeof value == 'number' || $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $8f2e1f7d7f8ca8b6$var$numberTag;
}
$8f2e1f7d7f8ca8b6$exports = $8f2e1f7d7f8ca8b6$var$isNumber;


/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $10ed4ab35db4c025$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $8f2e1f7d7f8ca8b6$exports(value) && value != +value;
}
$10ed4ab35db4c025$exports = $10ed4ab35db4c025$var$isNaN;





var $2ab3a7e25c8aba74$export$9d334328eb75e624 = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $2ab3a7e25c8aba74$export$e50269385c77c348 = function isPercent(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($15ee4628980e0994$exports)))(value) && value.indexOf('%') === value.length - 1;
};
var $2ab3a7e25c8aba74$export$7e4aa119212bc614 = function isNumber(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8f2e1f7d7f8ca8b6$exports)))(value) && !(0, (/*@__PURE__*/$parcel$interopDefault($10ed4ab35db4c025$exports)))(value);
};
var $2ab3a7e25c8aba74$export$b931b78cbb3caf86 = function isNullish(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(value);
};
var $2ab3a7e25c8aba74$export$402a499e1ea44294 = function isNumOrStr(value) {
    return $2ab3a7e25c8aba74$export$7e4aa119212bc614(value) || (0, (/*@__PURE__*/$parcel$interopDefault($15ee4628980e0994$exports)))(value);
};
var $2ab3a7e25c8aba74$var$idCounter = 0;
var $2ab3a7e25c8aba74$export$8b15d37bc3f197d4 = function uniqueId(prefix) {
    var id = ++$2ab3a7e25c8aba74$var$idCounter;
    return "".concat(prefix || '').concat(id);
};
var $2ab3a7e25c8aba74$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$2ab3a7e25c8aba74$export$7e4aa119212bc614(percent) && !(0, (/*@__PURE__*/$parcel$interopDefault($15ee4628980e0994$exports)))(percent)) return defaultValue;
    var value;
    if ($2ab3a7e25c8aba74$export$e50269385c77c348(percent)) {
        var index = percent.indexOf('%');
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($10ed4ab35db4c025$exports)))(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var $2ab3a7e25c8aba74$export$b88993f0aa0bf776 = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var $2ab3a7e25c8aba74$export$732baf6a98f122 = function hasDuplicate(ary) {
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var $2ab3a7e25c8aba74$export$d871d53bd7eeb390 = function interpolateNumber(numberA, numberB) {
    if ($2ab3a7e25c8aba74$export$7e4aa119212bc614(numberA) && $2ab3a7e25c8aba74$export$7e4aa119212bc614(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function $2ab3a7e25c8aba74$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(entry, specifiedKey)) === specifiedValue;
    });
}
var $2ab3a7e25c8aba74$export$484982720961754e = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};
var $2ab3a7e25c8aba74$export$6ab1df3197f7c641 = function compareValues(a, b) {
    if ($2ab3a7e25c8aba74$export$7e4aa119212bc614(a) && $2ab3a7e25c8aba74$export$7e4aa119212bc614(b)) return a - b;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($15ee4628980e0994$exports)))(a) && (0, (/*@__PURE__*/$parcel$interopDefault($15ee4628980e0994$exports)))(b)) return a.localeCompare(b);
    if (a instanceof Date && b instanceof Date) return a.getTime() - b.getTime();
    return String(a).localeCompare(String(b));
};


function $0f60d716238978d6$export$d36bdfa510afb180(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}



var $acw62 = parcelRequire("acw62");

function $909d5f835f4e917b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $909d5f835f4e917b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $909d5f835f4e917b$var$_typeof(o);
}
/**
 * Determines how values are stacked:
 *
 * - `none` is the default, it adds values on top of each other. No smarts. Negative values will overlap.
 * - `expand` make it so that the values always add up to 1 - so the chart will look like a rectangle.
 * - `wiggle` and `silhouette` tries to keep the chart centered.
 * - `sign` stacks positive values above zero and negative values below zero. Similar to `none` but handles negatives.
 * - `positive` ignores all negative values, and then behaves like \`none\`.
 *
 * Also see https://d3js.org/d3-shape/stack#stack-offsets
 * (note that the `diverging` offset in d3 is named `sign` in recharts)
 */ //
// Event Handler Types -- Copied from @types/react/index.d.ts and adapted for Props.
//
var $909d5f835f4e917b$var$SVGContainerPropKeys = [
    'viewBox',
    'children'
];
var $909d5f835f4e917b$export$190f430946f96110 = [
    'aria-activedescendant',
    'aria-atomic',
    'aria-autocomplete',
    'aria-busy',
    'aria-checked',
    'aria-colcount',
    'aria-colindex',
    'aria-colspan',
    'aria-controls',
    'aria-current',
    'aria-describedby',
    'aria-details',
    'aria-disabled',
    'aria-errormessage',
    'aria-expanded',
    'aria-flowto',
    'aria-haspopup',
    'aria-hidden',
    'aria-invalid',
    'aria-keyshortcuts',
    'aria-label',
    'aria-labelledby',
    'aria-level',
    'aria-live',
    'aria-modal',
    'aria-multiline',
    'aria-multiselectable',
    'aria-orientation',
    'aria-owns',
    'aria-placeholder',
    'aria-posinset',
    'aria-pressed',
    'aria-readonly',
    'aria-relevant',
    'aria-required',
    'aria-roledescription',
    'aria-rowcount',
    'aria-rowindex',
    'aria-rowspan',
    'aria-selected',
    'aria-setsize',
    'aria-sort',
    'aria-valuemax',
    'aria-valuemin',
    'aria-valuenow',
    'aria-valuetext',
    'className',
    'color',
    'height',
    'id',
    'lang',
    'max',
    'media',
    'method',
    'min',
    'name',
    'style',
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    'target',
    'width',
    'role',
    'tabIndex',
    'accentHeight',
    'accumulate',
    'additive',
    'alignmentBaseline',
    'allowReorder',
    'alphabetic',
    'amplitude',
    'arabicForm',
    'ascent',
    'attributeName',
    'attributeType',
    'autoReverse',
    'azimuth',
    'baseFrequency',
    'baselineShift',
    'baseProfile',
    'bbox',
    'begin',
    'bias',
    'by',
    'calcMode',
    'capHeight',
    'clip',
    'clipPath',
    'clipPathUnits',
    'clipRule',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorProfile',
    'colorRendering',
    'contentScriptType',
    'contentStyleType',
    'cursor',
    'cx',
    'cy',
    'd',
    'decelerate',
    'descent',
    'diffuseConstant',
    'direction',
    'display',
    'divisor',
    'dominantBaseline',
    'dur',
    'dx',
    'dy',
    'edgeMode',
    'elevation',
    'enableBackground',
    'end',
    'exponent',
    'externalResourcesRequired',
    'fill',
    'fillOpacity',
    'fillRule',
    'filter',
    'filterRes',
    'filterUnits',
    'floodColor',
    'floodOpacity',
    'focusable',
    'fontFamily',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'format',
    'from',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyphName',
    'glyphOrientationHorizontal',
    'glyphOrientationVertical',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'hanging',
    'horizAdvX',
    'horizOriginX',
    'href',
    'ideographic',
    'imageRendering',
    'in2',
    'in',
    'intercept',
    'k1',
    'k2',
    'k3',
    'k4',
    'k',
    'kernelMatrix',
    'kernelUnitLength',
    'kerning',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'letterSpacing',
    'lightingColor',
    'limitingConeAngle',
    'local',
    'markerEnd',
    'markerHeight',
    'markerMid',
    'markerStart',
    'markerUnits',
    'markerWidth',
    'mask',
    'maskContentUnits',
    'maskUnits',
    'mathematical',
    'mode',
    'numOctaves',
    'offset',
    'opacity',
    'operator',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'overlinePosition',
    'overlineThickness',
    'paintOrder',
    'panose1',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointerEvents',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'r',
    'radius',
    'refX',
    'refY',
    'renderingIntent',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'restart',
    'result',
    'rotate',
    'rx',
    'ry',
    'seed',
    'shapeRendering',
    'slope',
    'spacing',
    'specularConstant',
    'specularExponent',
    'speed',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stemh',
    'stemv',
    'stitchTiles',
    'stopColor',
    'stopOpacity',
    'strikethroughPosition',
    'strikethroughThickness',
    'string',
    'stroke',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeLinecap',
    'strokeLinejoin',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textAnchor',
    'textDecoration',
    'textLength',
    'textRendering',
    'to',
    'transform',
    'u1',
    'u2',
    'underlinePosition',
    'underlineThickness',
    'unicode',
    'unicodeBidi',
    'unicodeRange',
    'unitsPerEm',
    'vAlphabetic',
    'values',
    'vectorEffect',
    'version',
    'vertAdvY',
    'vertOriginX',
    'vertOriginY',
    'vHanging',
    'vIdeographic',
    'viewTarget',
    'visibility',
    'vMathematical',
    'widths',
    'wordSpacing',
    'writingMode',
    'x1',
    'x2',
    'x',
    'xChannelSelector',
    'xHeight',
    'xlinkActuate',
    'xlinkArcrole',
    'xlinkHref',
    'xlinkRole',
    'xlinkShow',
    'xlinkTitle',
    'xlinkType',
    'xmlBase',
    'xmlLang',
    'xmlns',
    'xmlnsXlink',
    'xmlSpace',
    'y1',
    'y2',
    'y',
    'yChannelSelector',
    'z',
    'zoomAndPan',
    'ref',
    'key',
    'angle'
];
var $909d5f835f4e917b$var$PolyElementKeys = [
    'points',
    'pathLength'
];
var $909d5f835f4e917b$export$2b22758266a6fa48 = {
    svg: $909d5f835f4e917b$var$SVGContainerPropKeys,
    polygon: $909d5f835f4e917b$var$PolyElementKeys,
    polyline: $909d5f835f4e917b$var$PolyElementKeys
};
var $909d5f835f4e917b$export$f30789245f2c4d11 = [
    'dangerouslySetInnerHTML',
    'onCopy',
    'onCopyCapture',
    'onCut',
    'onCutCapture',
    'onPaste',
    'onPasteCapture',
    'onCompositionEnd',
    'onCompositionEndCapture',
    'onCompositionStart',
    'onCompositionStartCapture',
    'onCompositionUpdate',
    'onCompositionUpdateCapture',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onChangeCapture',
    'onBeforeInput',
    'onBeforeInputCapture',
    'onInput',
    'onInputCapture',
    'onReset',
    'onResetCapture',
    'onSubmit',
    'onSubmitCapture',
    'onInvalid',
    'onInvalidCapture',
    'onLoad',
    'onLoadCapture',
    'onError',
    'onErrorCapture',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyPressCapture',
    'onKeyUp',
    'onKeyUpCapture',
    'onAbort',
    'onAbortCapture',
    'onCanPlay',
    'onCanPlayCapture',
    'onCanPlayThrough',
    'onCanPlayThroughCapture',
    'onDurationChange',
    'onDurationChangeCapture',
    'onEmptied',
    'onEmptiedCapture',
    'onEncrypted',
    'onEncryptedCapture',
    'onEnded',
    'onEndedCapture',
    'onLoadedData',
    'onLoadedDataCapture',
    'onLoadedMetadata',
    'onLoadedMetadataCapture',
    'onLoadStart',
    'onLoadStartCapture',
    'onPause',
    'onPauseCapture',
    'onPlay',
    'onPlayCapture',
    'onPlaying',
    'onPlayingCapture',
    'onProgress',
    'onProgressCapture',
    'onRateChange',
    'onRateChangeCapture',
    'onSeeked',
    'onSeekedCapture',
    'onSeeking',
    'onSeekingCapture',
    'onStalled',
    'onStalledCapture',
    'onSuspend',
    'onSuspendCapture',
    'onTimeUpdate',
    'onTimeUpdateCapture',
    'onVolumeChange',
    'onVolumeChangeCapture',
    'onWaiting',
    'onWaitingCapture',
    'onAuxClick',
    'onAuxClickCapture',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onContextMenuCapture',
    'onDoubleClick',
    'onDoubleClickCapture',
    'onDrag',
    'onDragCapture',
    'onDragEnd',
    'onDragEndCapture',
    'onDragEnter',
    'onDragEnterCapture',
    'onDragExit',
    'onDragExitCapture',
    'onDragLeave',
    'onDragLeaveCapture',
    'onDragOver',
    'onDragOverCapture',
    'onDragStart',
    'onDragStartCapture',
    'onDrop',
    'onDropCapture',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseMoveCapture',
    'onMouseOut',
    'onMouseOutCapture',
    'onMouseOver',
    'onMouseOverCapture',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onSelectCapture',
    'onTouchCancel',
    'onTouchCancelCapture',
    'onTouchEnd',
    'onTouchEndCapture',
    'onTouchMove',
    'onTouchMoveCapture',
    'onTouchStart',
    'onTouchStartCapture',
    'onPointerDown',
    'onPointerDownCapture',
    'onPointerMove',
    'onPointerMoveCapture',
    'onPointerUp',
    'onPointerUpCapture',
    'onPointerCancel',
    'onPointerCancelCapture',
    'onPointerEnter',
    'onPointerEnterCapture',
    'onPointerLeave',
    'onPointerLeaveCapture',
    'onPointerOver',
    'onPointerOverCapture',
    'onPointerOut',
    'onPointerOutCapture',
    'onGotPointerCapture',
    'onGotPointerCaptureCapture',
    'onLostPointerCapture',
    'onLostPointerCaptureCapture',
    'onScroll',
    'onScrollCapture',
    'onWheel',
    'onWheelCapture',
    'onAnimationStart',
    'onAnimationStartCapture',
    'onAnimationEnd',
    'onAnimationEndCapture',
    'onAnimationIteration',
    'onAnimationIterationCapture',
    'onTransitionEnd',
    'onTransitionEndCapture'
];
var $909d5f835f4e917b$export$7c4c290a4a9c1b1e = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($f9ff2e983beb6b86$exports)))(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if ($909d5f835f4e917b$export$f30789245f2c4d11.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var $909d5f835f4e917b$var$getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var $909d5f835f4e917b$export$ca62be0d67a3158c = function adaptEventsOfChild(props, data, index) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($f9ff2e983beb6b86$exports)))(props) || $909d5f835f4e917b$var$_typeof(props) !== 'object') return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if ($909d5f835f4e917b$export$f30789245f2c4d11.includes(key) && typeof item === 'function') {
            if (!out) out = {};
            out[key] = $909d5f835f4e917b$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};


var $008f02516c156322$var$_excluded = [
    "children"
], $008f02516c156322$var$_excluded2 = [
    "children"
];
function $008f02516c156322$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $008f02516c156322$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $008f02516c156322$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $008f02516c156322$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $008f02516c156322$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $008f02516c156322$var$_typeof(o);
}
var $008f02516c156322$var$REACT_BROWSER_EVENT_MAP = {
    click: 'onClick',
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    mouseover: 'onMouseOver',
    mousemove: 'onMouseMove',
    mouseout: 'onMouseOut',
    mouseenter: 'onMouseEnter',
    mouseleave: 'onMouseLeave',
    touchcancel: 'onTouchCancel',
    touchend: 'onTouchEnd',
    touchmove: 'onTouchMove',
    touchstart: 'onTouchStart',
    contextmenu: 'onContextMenu',
    dblclick: 'onDoubleClick'
};
var $008f02516c156322$export$e65e0ff8d3882b46 = [
    'auto',
    'linear',
    'pow',
    'sqrt',
    'log',
    'identity',
    'time',
    'band',
    'point',
    'ordinal',
    'quantile',
    'quantize',
    'utc',
    'sequential',
    'threshold'
];
var $008f02516c156322$export$84dbd3b52ff06578 = [
    'plainline',
    'line',
    'square',
    'rect',
    'circle',
    'cross',
    'diamond',
    'star',
    'triangle',
    'wye',
    'none'
];
var $008f02516c156322$export$59a4d7d024cf1025 = [
    'none'
];
var $008f02516c156322$export$be63e0664592e141 = function getDisplayName(Comp) {
    if (typeof Comp === 'string') return Comp;
    if (!Comp) return '';
    return Comp.displayName || Comp.name || 'Component';
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $008f02516c156322$var$lastChildren = null;
var $008f02516c156322$var$lastResult = null;
var $008f02516c156322$export$45b10814cc054894 = function toArray(children) {
    if (children === $008f02516c156322$var$lastChildren && Array.isArray($008f02516c156322$var$lastResult)) return $008f02516c156322$var$lastResult;
    var result = [];
    (0, $acw62.Children).forEach(children, function(child) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(child)) return;
        if ((0, $3251146683c5d714$exports.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else // @ts-expect-error this could still be Iterable<ReactNode> and TS does not like that
        result.push(child);
    });
    $008f02516c156322$var$lastResult = result;
    $008f02516c156322$var$lastChildren = children;
    return result;
};
function $008f02516c156322$export$fdd5e64c0e8495bb(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map(function(t) {
        return $008f02516c156322$export$be63e0664592e141(t);
    });
    else types = [
        $008f02516c156322$export$be63e0664592e141(type)
    ];
    $008f02516c156322$export$45b10814cc054894(children).forEach(function(child) {
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(child, 'type.displayName') || (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(child, 'type.name');
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
function $008f02516c156322$export$64c61536a2b72e0f(children, type) {
    var result = $008f02516c156322$export$fdd5e64c0e8495bb(children, type);
    return result && result[0];
}
var $008f02516c156322$export$d0b46a9571fa5ebf = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if (Array.isArray(type)) types = type.map(function(t) {
        return $008f02516c156322$export$be63e0664592e141(t);
    });
    else types = [
        $008f02516c156322$export$be63e0664592e141(type)
    ];
    $008f02516c156322$export$45b10814cc054894(children).forEach(function(child) {
        var displayName = (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(child, 'type.displayName');
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var $008f02516c156322$export$5301de6bfd3cfa2a = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(height) || height <= 0) return false;
    return true;
};
var $008f02516c156322$var$SVG_TAGS = [
    'a',
    'altGlyph',
    'altGlyphDef',
    'altGlyphItem',
    'animate',
    'animateColor',
    'animateMotion',
    'animateTransform',
    'circle',
    'clipPath',
    'color-profile',
    'cursor',
    'defs',
    'desc',
    'ellipse',
    'feBlend',
    'feColormatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'filter',
    'font',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-url',
    'foreignObject',
    'g',
    'glyph',
    'glyphRef',
    'hkern',
    'image',
    'line',
    'lineGradient',
    'marker',
    'mask',
    'metadata',
    'missing-glyph',
    'mpath',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'script',
    'set',
    'stop',
    'style',
    'svg',
    'switch',
    'symbol',
    'text',
    'textPath',
    'title',
    'tref',
    'tspan',
    'use',
    'view',
    'vkern'
];
var $008f02516c156322$var$isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, (/*@__PURE__*/$parcel$interopDefault($15ee4628980e0994$exports)))(child.type) && $008f02516c156322$var$SVG_TAGS.indexOf(child.type) >= 0;
};
var $008f02516c156322$export$392f6c9701718a4e = function hasClipDot(dot) {
    return dot && $008f02516c156322$var$_typeof(dot) === 'object' && 'clipDot' in dot;
};
var $008f02516c156322$export$be767fcc756dddf6 = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
    var _FilteredElementKeyMa;
    /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */ var matchingElementTypeKeys = (_FilteredElementKeyMa = (0, $909d5f835f4e917b$export$2b22758266a6fa48) === null || (0, $909d5f835f4e917b$export$2b22758266a6fa48) === void 0 ? void 0 : (0, $909d5f835f4e917b$export$2b22758266a6fa48)[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
    return key.startsWith('data-') || !(0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(property) && (svgElementType && matchingElementTypeKeys.includes(key) || (0, $909d5f835f4e917b$export$190f430946f96110).includes(key)) || includeEvents && (0, $909d5f835f4e917b$export$f30789245f2c4d11).includes(key);
};
var $008f02516c156322$export$ef6f3b46dcb37b3f = function filterSvgElements(children) {
    var svgElements = [];
    $008f02516c156322$export$45b10814cc054894(children).forEach(function(entry) {
        if ($008f02516c156322$var$isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var $008f02516c156322$export$d697c39a2985a4c = function filterProps(props, includeEvents, svgElementType) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($f9ff2e983beb6b86$exports)))(inputProps)) return null;
    var out = {};
    /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */ Object.keys(inputProps).forEach(function(key) {
        var _inputProps;
        if ($008f02516c156322$export$be767fcc756dddf6((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) out[key] = inputProps[key];
    });
    return out;
};
var $008f02516c156322$export$acdc716e08572f94 = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, $acw62.Children).count(nextChildren);
    if (count !== (0, $acw62.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $008f02516c156322$export$96bceecf65400492(Array.isArray(nextChildren) ? nextChildren[0] : nextChildren, Array.isArray(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if (Array.isArray(nextChild) || Array.isArray(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        } else if (!$008f02516c156322$export$96bceecf65400492(nextChild, prevChild)) return false;
    }
    return true;
};
var $008f02516c156322$export$96bceecf65400492 = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(nextChild) && (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(prevChild)) return true;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(nextChild) && !(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = $008f02516c156322$var$_objectWithoutProperties(_ref, $008f02516c156322$var$_excluded);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = $008f02516c156322$var$_objectWithoutProperties(_ref2, $008f02516c156322$var$_excluded2);
        if (nextChildren && prevChildren) return (0, $0f60d716238978d6$export$d36bdfa510afb180)(nextProps, prevProps) && $008f02516c156322$export$acdc716e08572f94(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, $0f60d716238978d6$export$d36bdfa510afb180)(nextProps, prevProps);
        return false;
    }
    return false;
};
var $008f02516c156322$export$a98d6da55570cb82 = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    $008f02516c156322$export$45b10814cc054894(children).forEach(function(child, index) {
        if ($008f02516c156322$var$isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = $008f02516c156322$export$be63e0664592e141(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var $008f02516c156322$export$afb3591bc51a0b70 = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && $008f02516c156322$var$REACT_BROWSER_EVENT_MAP[type]) return $008f02516c156322$var$REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var $008f02516c156322$export$857ca101f741953 = function parseChildIndex(child, children) {
    return $008f02516c156322$export$45b10814cc054894(children).indexOf(child);
};


var $04149ae279e74c50$var$_excluded = [
    "children",
    "className"
];
function $04149ae279e74c50$var$_extends() {
    $04149ae279e74c50$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $04149ae279e74c50$var$_extends.apply(this, arguments);
}
function $04149ae279e74c50$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $04149ae279e74c50$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $04149ae279e74c50$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $04149ae279e74c50$export$936d0764594b6eb3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var children = props.children, className = props.className, others = $04149ae279e74c50$var$_objectWithoutProperties(props, $04149ae279e74c50$var$_excluded);
    var layerClass = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-layer', className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", $04149ae279e74c50$var$_extends({
        className: layerClass
    }, (0, $008f02516c156322$export$d697c39a2985a4c)(others, true), {
        ref: ref
    }), children);
});



var $acw62 = parcelRequire("acw62");
var $85f606e562c81b96$var$isProduction = true;
var $85f606e562c81b96$var$prefix = 'Invariant failed';
function $85f606e562c81b96$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($85f606e562c81b96$var$isProduction) throw new Error($85f606e562c81b96$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($85f606e562c81b96$var$prefix, ": ").concat(provided) : $85f606e562c81b96$var$prefix;
    throw new Error(value);
}




var $7f4b989d0f2e91c6$var$_excluded = [
    "offset",
    "layout",
    "width",
    "dataKey",
    "data",
    "dataPointFormatter",
    "xAxis",
    "yAxis"
];
function $7f4b989d0f2e91c6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7f4b989d0f2e91c6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7f4b989d0f2e91c6$var$_typeof(o);
}
function $7f4b989d0f2e91c6$var$_extends() {
    $7f4b989d0f2e91c6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7f4b989d0f2e91c6$var$_extends.apply(this, arguments);
}
function $7f4b989d0f2e91c6$var$_slicedToArray(arr, i) {
    return $7f4b989d0f2e91c6$var$_arrayWithHoles(arr) || $7f4b989d0f2e91c6$var$_iterableToArrayLimit(arr, i) || $7f4b989d0f2e91c6$var$_unsupportedIterableToArray(arr, i) || $7f4b989d0f2e91c6$var$_nonIterableRest();
}
function $7f4b989d0f2e91c6$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7f4b989d0f2e91c6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7f4b989d0f2e91c6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7f4b989d0f2e91c6$var$_arrayLikeToArray(o, minLen);
}
function $7f4b989d0f2e91c6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7f4b989d0f2e91c6$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $7f4b989d0f2e91c6$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $7f4b989d0f2e91c6$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7f4b989d0f2e91c6$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7f4b989d0f2e91c6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7f4b989d0f2e91c6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7f4b989d0f2e91c6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7f4b989d0f2e91c6$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7f4b989d0f2e91c6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7f4b989d0f2e91c6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7f4b989d0f2e91c6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7f4b989d0f2e91c6$var$_callSuper(t, o, e) {
    return o = $7f4b989d0f2e91c6$var$_getPrototypeOf(o), $7f4b989d0f2e91c6$var$_possibleConstructorReturn(t, $7f4b989d0f2e91c6$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $7f4b989d0f2e91c6$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $7f4b989d0f2e91c6$var$_possibleConstructorReturn(self, call) {
    if (call && ($7f4b989d0f2e91c6$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7f4b989d0f2e91c6$var$_assertThisInitialized(self);
}
function $7f4b989d0f2e91c6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7f4b989d0f2e91c6$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7f4b989d0f2e91c6$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $7f4b989d0f2e91c6$var$_getPrototypeOf(o) {
    $7f4b989d0f2e91c6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7f4b989d0f2e91c6$var$_getPrototypeOf(o);
}
function $7f4b989d0f2e91c6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7f4b989d0f2e91c6$var$_setPrototypeOf(subClass, superClass);
}
function $7f4b989d0f2e91c6$var$_setPrototypeOf(o, p) {
    $7f4b989d0f2e91c6$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7f4b989d0f2e91c6$var$_setPrototypeOf(o, p);
}
function $7f4b989d0f2e91c6$var$_defineProperty(obj, key, value) {
    key = $7f4b989d0f2e91c6$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7f4b989d0f2e91c6$var$_toPropertyKey(t) {
    var i = $7f4b989d0f2e91c6$var$_toPrimitive(t, "string");
    return "symbol" == $7f4b989d0f2e91c6$var$_typeof(i) ? i : i + "";
}
function $7f4b989d0f2e91c6$var$_toPrimitive(t, r) {
    if ("object" != $7f4b989d0f2e91c6$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7f4b989d0f2e91c6$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $7f4b989d0f2e91c6$export$4f4d7676bdf949e5 = /*#__PURE__*/ function(_React$Component) {
    function ErrorBar() {
        $7f4b989d0f2e91c6$var$_classCallCheck(this, ErrorBar);
        return $7f4b989d0f2e91c6$var$_callSuper(this, ErrorBar, arguments);
    }
    $7f4b989d0f2e91c6$var$_inherits(ErrorBar, _React$Component);
    return $7f4b989d0f2e91c6$var$_createClass(ErrorBar, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, offset = _this$props.offset, layout = _this$props.layout, width = _this$props.width, dataKey = _this$props.dataKey, data = _this$props.data, dataPointFormatter = _this$props.dataPointFormatter, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, others = $7f4b989d0f2e91c6$var$_objectWithoutProperties(_this$props, $7f4b989d0f2e91c6$var$_excluded);
                var svgProps = (0, $008f02516c156322$export$d697c39a2985a4c)(others, false);
                !!(this.props.direction === 'x' && xAxis.type !== 'number') && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
                var errorBars = data.map(function(entry) {
                    var _dataPointFormatter = dataPointFormatter(entry, dataKey), x = _dataPointFormatter.x, y = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
                    if (!errorVal) return null;
                    var lineCoordinates = [];
                    var lowBound, highBound;
                    if (Array.isArray(errorVal)) {
                        var _errorVal = $7f4b989d0f2e91c6$var$_slicedToArray(errorVal, 2);
                        lowBound = _errorVal[0];
                        highBound = _errorVal[1];
                    } else lowBound = highBound = errorVal;
                    if (layout === 'vertical') {
                        // error bar for horizontal charts, the y is fixed, x is a range value
                        var scale = xAxis.scale;
                        var yMid = y + offset;
                        var yMin = yMid + width;
                        var yMax = yMid - width;
                        var xMin = scale(value - lowBound);
                        var xMax = scale(value + highBound);
                        // the right line of |--|
                        lineCoordinates.push({
                            x1: xMax,
                            y1: yMin,
                            x2: xMax,
                            y2: yMax
                        });
                        // the middle line of |--|
                        lineCoordinates.push({
                            x1: xMin,
                            y1: yMid,
                            x2: xMax,
                            y2: yMid
                        });
                        // the left line of |--|
                        lineCoordinates.push({
                            x1: xMin,
                            y1: yMin,
                            x2: xMin,
                            y2: yMax
                        });
                    } else if (layout === 'horizontal') {
                        // error bar for horizontal charts, the x is fixed, y is a range value
                        var _scale = yAxis.scale;
                        var xMid = x + offset;
                        var _xMin = xMid - width;
                        var _xMax = xMid + width;
                        var _yMin = _scale(value - lowBound);
                        var _yMax = _scale(value + highBound);
                        // the top line
                        lineCoordinates.push({
                            x1: _xMin,
                            y1: _yMax,
                            x2: _xMax,
                            y2: _yMax
                        });
                        // the middle line
                        lineCoordinates.push({
                            x1: xMid,
                            y1: _yMin,
                            x2: xMid,
                            y2: _yMax
                        });
                        // the bottom line
                        lineCoordinates.push({
                            x1: _xMin,
                            y1: _yMin,
                            x2: _xMax,
                            y2: _yMin
                        });
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), $7f4b989d0f2e91c6$var$_extends({
                        className: "recharts-errorBar",
                        key: "bar-".concat(lineCoordinates.map(function(c) {
                            return "".concat(c.x1, "-").concat(c.x2, "-").concat(c.y1, "-").concat(c.y2);
                        }))
                    }, svgProps), lineCoordinates.map(function(coordinates) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", $7f4b989d0f2e91c6$var$_extends({}, coordinates, {
                            key: "line-".concat(coordinates.x1, "-").concat(coordinates.x2, "-").concat(coordinates.y1, "-").concat(coordinates.y2)
                        }));
                    }));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                    className: "recharts-errorBars"
                }, errorBars);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$7f4b989d0f2e91c6$var$_defineProperty($7f4b989d0f2e91c6$export$4f4d7676bdf949e5, "defaultProps", {
    stroke: 'black',
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: 'horizontal'
});
$7f4b989d0f2e91c6$var$_defineProperty($7f4b989d0f2e91c6$export$4f4d7676bdf949e5, "displayName", 'ErrorBar');


/**
 * @fileOverview Cross
 */ var $b43ffe30f81b14f2$export$f6f0c3fe4ec306ea = function Cell(_props) {
    return null;
};
$b43ffe30f81b14f2$export$f6f0c3fe4ec306ea.displayName = 'Cell';



var $acw62 = parcelRequire("acw62");



var $c9d0ae50fd1d1372$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $c9d0ae50fd1d1372$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$c9d0ae50fd1d1372$exports = $c9d0ae50fd1d1372$var$last;



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");



var $795299547b24e258$var$parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
};
var $795299547b24e258$export$98f03c5d19621d70 = {
    isSsr: $795299547b24e258$var$parseIsSsrByDefault(),
    get: function get(key) {
        return $795299547b24e258$export$98f03c5d19621d70[key];
    },
    set: function set(key, value) {
        if (typeof key === 'string') $795299547b24e258$export$98f03c5d19621d70[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                $795299547b24e258$export$98f03c5d19621d70[k] = key[k];
            });
        }
    }
};




function $41867cca6cb93873$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $41867cca6cb93873$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $41867cca6cb93873$var$_typeof(o);
}
function $41867cca6cb93873$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $41867cca6cb93873$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $41867cca6cb93873$var$ownKeys(Object(t), !0).forEach(function(r) {
            $41867cca6cb93873$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $41867cca6cb93873$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $41867cca6cb93873$var$_defineProperty(obj, key, value) {
    key = $41867cca6cb93873$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $41867cca6cb93873$var$_toPropertyKey(t) {
    var i = $41867cca6cb93873$var$_toPrimitive(t, "string");
    return "symbol" == $41867cca6cb93873$var$_typeof(i) ? i : i + "";
}
function $41867cca6cb93873$var$_toPrimitive(t, r) {
    if ("object" != $41867cca6cb93873$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $41867cca6cb93873$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $41867cca6cb93873$var$_toConsumableArray(arr) {
    return $41867cca6cb93873$var$_arrayWithoutHoles(arr) || $41867cca6cb93873$var$_iterableToArray(arr) || $41867cca6cb93873$var$_unsupportedIterableToArray(arr) || $41867cca6cb93873$var$_nonIterableSpread();
}
function $41867cca6cb93873$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $41867cca6cb93873$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $41867cca6cb93873$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $41867cca6cb93873$var$_arrayLikeToArray(o, minLen);
}
function $41867cca6cb93873$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $41867cca6cb93873$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $41867cca6cb93873$var$_arrayLikeToArray(arr);
}
function $41867cca6cb93873$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $41867cca6cb93873$var$stringCache = {
    widthCache: {},
    cacheCount: 0
};
var $41867cca6cb93873$var$MAX_CACHE_NUM = 2000;
var $41867cca6cb93873$var$SPAN_STYLE = {
    position: 'absolute',
    top: '-20000px',
    left: 0,
    padding: 0,
    margin: 0,
    border: 'none',
    whiteSpace: 'pre'
};
var $41867cca6cb93873$var$STYLE_LIST = [
    'minWidth',
    'maxWidth',
    'width',
    'minHeight',
    'maxHeight',
    'height',
    'top',
    'left',
    'fontSize',
    'lineHeight',
    'padding',
    'margin',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'paddingBottom',
    'marginLeft',
    'marginRight',
    'marginTop',
    'marginBottom'
];
var $41867cca6cb93873$var$MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
function $41867cca6cb93873$var$autoCompleteStyle(name, value) {
    if ($41867cca6cb93873$var$STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function $41867cca6cb93873$var$camelToMiddleLine(text) {
    var strs = text.split('');
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat($41867cca6cb93873$var$_toConsumableArray(result), [
            '-',
            entry.toLowerCase()
        ]);
        return [].concat($41867cca6cb93873$var$_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join('');
}
var $41867cca6cb93873$export$9a2c38fb88d8e30 = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat($41867cca6cb93873$var$camelToMiddleLine(s), ":").concat($41867cca6cb93873$var$autoCompleteStyle(s, style[s]), ";");
    }, '');
};
function $41867cca6cb93873$var$removeInvalidKeys(obj) {
    var copyObj = $41867cca6cb93873$var$_objectSpread({}, obj);
    Object.keys(copyObj).forEach(function(key) {
        if (!copyObj[key]) delete copyObj[key];
    });
    return copyObj;
}
var $41867cca6cb93873$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $795299547b24e258$export$98f03c5d19621d70).isSsr) return {
        width: 0,
        height: 0
    };
    var copyStyle = $41867cca6cb93873$var$removeInvalidKeys(style);
    var cacheKey = JSON.stringify({
        text: text,
        copyStyle: copyStyle
    });
    if ($41867cca6cb93873$var$stringCache.widthCache[cacheKey]) return $41867cca6cb93873$var$stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById($41867cca6cb93873$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement('span');
            measurementSpan.setAttribute('id', $41867cca6cb93873$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute('aria-hidden', 'true');
            document.body.appendChild(measurementSpan);
        }
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = $41867cca6cb93873$var$_objectSpread($41867cca6cb93873$var$_objectSpread({}, $41867cca6cb93873$var$SPAN_STYLE), copyStyle);
        Object.assign(measurementSpan.style, measurementSpanStyle);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        $41867cca6cb93873$var$stringCache.widthCache[cacheKey] = result;
        if (++$41867cca6cb93873$var$stringCache.cacheCount > $41867cca6cb93873$var$MAX_CACHE_NUM) {
            $41867cca6cb93873$var$stringCache.cacheCount = 0;
            $41867cca6cb93873$var$stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $41867cca6cb93873$export$622cea445a1c5b7d = function getOffset(rect) {
    return {
        top: rect.top + window.scrollY - document.documentElement.clientTop,
        left: rect.left + window.scrollX - document.documentElement.clientLeft
    };
};


function $59d4ad4b8fae5b14$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $59d4ad4b8fae5b14$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $59d4ad4b8fae5b14$var$_typeof(o);
}
function $59d4ad4b8fae5b14$var$_slicedToArray(arr, i) {
    return $59d4ad4b8fae5b14$var$_arrayWithHoles(arr) || $59d4ad4b8fae5b14$var$_iterableToArrayLimit(arr, i) || $59d4ad4b8fae5b14$var$_unsupportedIterableToArray(arr, i) || $59d4ad4b8fae5b14$var$_nonIterableRest();
}
function $59d4ad4b8fae5b14$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $59d4ad4b8fae5b14$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $59d4ad4b8fae5b14$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $59d4ad4b8fae5b14$var$_arrayLikeToArray(o, minLen);
}
function $59d4ad4b8fae5b14$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $59d4ad4b8fae5b14$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $59d4ad4b8fae5b14$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $59d4ad4b8fae5b14$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $59d4ad4b8fae5b14$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $59d4ad4b8fae5b14$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $59d4ad4b8fae5b14$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $59d4ad4b8fae5b14$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $59d4ad4b8fae5b14$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $59d4ad4b8fae5b14$var$_toPropertyKey(t) {
    var i = $59d4ad4b8fae5b14$var$_toPrimitive(t, "string");
    return "symbol" == $59d4ad4b8fae5b14$var$_typeof(i) ? i : i + "";
}
function $59d4ad4b8fae5b14$var$_toPrimitive(t, r) {
    if ("object" != $59d4ad4b8fae5b14$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $59d4ad4b8fae5b14$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $59d4ad4b8fae5b14$var$MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $59d4ad4b8fae5b14$var$ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $59d4ad4b8fae5b14$var$CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var $59d4ad4b8fae5b14$var$NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var $59d4ad4b8fae5b14$var$CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    "in": 96,
    Q: 96 / 101.6,
    px: 1
};
var $59d4ad4b8fae5b14$var$FIXED_CSS_LENGTH_UNITS = Object.keys($59d4ad4b8fae5b14$var$CONVERSION_RATES);
var $59d4ad4b8fae5b14$var$STR_NAN = 'NaN';
function $59d4ad4b8fae5b14$var$convertToPx(value, unit) {
    return value * $59d4ad4b8fae5b14$var$CONVERSION_RATES[unit];
}
var $59d4ad4b8fae5b14$var$DecimalCSS = /*#__PURE__*/ function() {
    function DecimalCSS(num, unit) {
        $59d4ad4b8fae5b14$var$_classCallCheck(this, DecimalCSS);
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if (Number.isNaN(num)) this.unit = '';
        if (unit !== '' && !$59d4ad4b8fae5b14$var$CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = '';
        }
        if ($59d4ad4b8fae5b14$var$FIXED_CSS_LENGTH_UNITS.includes(unit)) {
            this.num = $59d4ad4b8fae5b14$var$convertToPx(num, unit);
            this.unit = 'px';
        }
    }
    return $59d4ad4b8fae5b14$var$_createClass(DecimalCSS, [
        {
            key: "add",
            value: function add(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num + other.num, this.unit);
            }
        },
        {
            key: "subtract",
            value: function subtract(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num - other.num, this.unit);
            }
        },
        {
            key: "multiply",
            value: function multiply(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num * other.num, this.unit || other.unit);
            }
        },
        {
            key: "divide",
            value: function divide(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num / other.num, this.unit || other.unit);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.num).concat(this.unit);
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.num);
            }
        }
    ], [
        {
            key: "parse",
            value: function parse(str) {
                var _NUM_SPLIT_REGEX$exec;
                var _ref = (_NUM_SPLIT_REGEX$exec = $59d4ad4b8fae5b14$var$NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [], _ref2 = $59d4ad4b8fae5b14$var$_slicedToArray(_ref, 3), numStr = _ref2[1], unit = _ref2[2];
                return new DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : '');
            }
        }
    ]);
}();
function $59d4ad4b8fae5b14$var$calculateArithmetic(expr) {
    if (expr.includes($59d4ad4b8fae5b14$var$STR_NAN)) return $59d4ad4b8fae5b14$var$STR_NAN;
    var newExpr = expr;
    while(newExpr.includes('*') || newExpr.includes('/')){
        var _MULTIPLY_OR_DIVIDE_R;
        var _ref3 = (_MULTIPLY_OR_DIVIDE_R = $59d4ad4b8fae5b14$var$MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [], _ref4 = $59d4ad4b8fae5b14$var$_slicedToArray(_ref3, 4), leftOperand = _ref4[1], operator = _ref4[2], rightOperand = _ref4[3];
        var lTs = $59d4ad4b8fae5b14$var$DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : '');
        var rTs = $59d4ad4b8fae5b14$var$DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : '');
        var result = operator === '*' ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return $59d4ad4b8fae5b14$var$STR_NAN;
        newExpr = newExpr.replace($59d4ad4b8fae5b14$var$MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes('+') || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var _ref5 = (_ADD_OR_SUBTRACT_REGE = $59d4ad4b8fae5b14$var$ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [], _ref6 = $59d4ad4b8fae5b14$var$_slicedToArray(_ref5, 4), _leftOperand = _ref6[1], _operator = _ref6[2], _rightOperand = _ref6[3];
        var _lTs = $59d4ad4b8fae5b14$var$DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : '');
        var _rTs = $59d4ad4b8fae5b14$var$DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : '');
        var _result = _operator === '+' ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return $59d4ad4b8fae5b14$var$STR_NAN;
        newExpr = newExpr.replace($59d4ad4b8fae5b14$var$ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var $59d4ad4b8fae5b14$var$PARENTHESES_REGEX = /\(([^()]*)\)/;
function $59d4ad4b8fae5b14$var$calculateParentheses(expr) {
    var newExpr = expr;
    while(newExpr.includes('(')){
        var _PARENTHESES_REGEX$ex = $59d4ad4b8fae5b14$var$PARENTHESES_REGEX.exec(newExpr), _PARENTHESES_REGEX$ex2 = $59d4ad4b8fae5b14$var$_slicedToArray(_PARENTHESES_REGEX$ex, 2), parentheticalExpression = _PARENTHESES_REGEX$ex2[1];
        newExpr = newExpr.replace($59d4ad4b8fae5b14$var$PARENTHESES_REGEX, $59d4ad4b8fae5b14$var$calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function $59d4ad4b8fae5b14$var$evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, '');
    newExpr = $59d4ad4b8fae5b14$var$calculateParentheses(newExpr);
    newExpr = $59d4ad4b8fae5b14$var$calculateArithmetic(newExpr);
    return newExpr;
}
function $59d4ad4b8fae5b14$export$c891f73c9c6d00c9(expression) {
    try {
        return $59d4ad4b8fae5b14$var$evaluateExpression(expression);
    } catch (e) {
        /* istanbul ignore next */ return $59d4ad4b8fae5b14$var$STR_NAN;
    }
}
function $59d4ad4b8fae5b14$export$254eac204f89fd7d(expression) {
    var result = $59d4ad4b8fae5b14$export$c891f73c9c6d00c9(expression.slice(5, -1));
    if (result === $59d4ad4b8fae5b14$var$STR_NAN) // notify the user
    return '';
    return result;
}


var $964be52cc11879b4$var$_excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor",
    "fill"
], $964be52cc11879b4$var$_excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function $964be52cc11879b4$var$_extends() {
    $964be52cc11879b4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $964be52cc11879b4$var$_extends.apply(this, arguments);
}
function $964be52cc11879b4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $964be52cc11879b4$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $964be52cc11879b4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $964be52cc11879b4$var$_slicedToArray(arr, i) {
    return $964be52cc11879b4$var$_arrayWithHoles(arr) || $964be52cc11879b4$var$_iterableToArrayLimit(arr, i) || $964be52cc11879b4$var$_unsupportedIterableToArray(arr, i) || $964be52cc11879b4$var$_nonIterableRest();
}
function $964be52cc11879b4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $964be52cc11879b4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $964be52cc11879b4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $964be52cc11879b4$var$_arrayLikeToArray(o, minLen);
}
function $964be52cc11879b4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $964be52cc11879b4$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $964be52cc11879b4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $964be52cc11879b4$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $964be52cc11879b4$var$calculateWordWidths = function calculateWordWidths(_ref) {
    var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
    try {
        var words = [];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(children)) {
            if (breakAll) words = children.toString().split('');
            else words = children.toString().split($964be52cc11879b4$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, $41867cca6cb93873$export$e5560531f057ad5d)(word, style).width
            };
        });
        var spaceWidth = breakAll ? 0 : (0, $41867cca6cb93873$export$e5560531f057ad5d)("\xA0", style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var $964be52cc11879b4$var$calculateWordsByLines = function calculateWordsByLines(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
    var shouldLimitLines = (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(maxLines);
    var text = children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref3) {
            var word = _ref3.word, width = _ref3.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "\u2026";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = $964be52cc11879b4$var$calculateWordWidths({
            breakAll: breakAll,
            style: style,
            children: tempText + suffix
        }).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = $964be52cc11879b4$var$_slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = $964be52cc11879b4$var$_slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $964be52cc11879b4$var$getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(children) ? children.toString().split($964be52cc11879b4$var$BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var $964be52cc11879b4$var$getWordsByLines = function getWordsByLines(_ref4) {
    var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, $795299547b24e258$export$98f03c5d19621d70).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = $964be52cc11879b4$var$calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return $964be52cc11879b4$var$getWordsWithoutCalculate(children);
        return $964be52cc11879b4$var$calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
    }
    return $964be52cc11879b4$var$getWordsWithoutCalculate(children);
};
var $964be52cc11879b4$var$DEFAULT_FILL = '#808080';
var $964be52cc11879b4$export$5f1af8db9871e1d6 = function Text(_ref5) {
    var _ref5$x = _ref5.x, propsX = _ref5$x === void 0 ? 0 : _ref5$x, _ref5$y = _ref5.y, propsY = _ref5$y === void 0 ? 0 : _ref5$y, _ref5$lineHeight = _ref5.lineHeight, lineHeight = _ref5$lineHeight === void 0 ? '1em' : _ref5$lineHeight, _ref5$capHeight = _ref5.capHeight, capHeight = _ref5$capHeight === void 0 ? '0.71em' : _ref5$capHeight, _ref5$scaleToFit = _ref5.scaleToFit, scaleToFit = _ref5$scaleToFit === void 0 ? false : _ref5$scaleToFit, _ref5$textAnchor = _ref5.textAnchor, textAnchor = _ref5$textAnchor === void 0 ? 'start' : _ref5$textAnchor, _ref5$verticalAnchor = _ref5.verticalAnchor, verticalAnchor = _ref5$verticalAnchor === void 0 ? 'end' : _ref5$verticalAnchor, _ref5$fill = _ref5.fill, fill = _ref5$fill === void 0 ? $964be52cc11879b4$var$DEFAULT_FILL : _ref5$fill, props = $964be52cc11879b4$var$_objectWithoutProperties(_ref5, $964be52cc11879b4$var$_excluded);
    var wordsByLines = (0, $acw62.useMemo)(function() {
        return $964be52cc11879b4$var$getWordsByLines({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var dx = props.dx, dy = props.dy, angle = props.angle, className = props.className, breakAll = props.breakAll, textProps = $964be52cc11879b4$var$_objectWithoutProperties(props, $964be52cc11879b4$var$_excluded2);
    if (!(0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(propsX) || !(0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(propsY)) return null;
    var x = propsX + ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(dx) ? dx : 0);
    var y = propsY + ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(dy) ? dy : 0);
    var startDy;
    switch(verticalAnchor){
        case 'start':
            startDy = (0, $59d4ad4b8fae5b14$export$254eac204f89fd7d)("calc(".concat(capHeight, ")"));
            break;
        case 'middle':
            startDy = (0, $59d4ad4b8fae5b14$export$254eac204f89fd7d)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, $59d4ad4b8fae5b14$export$254eac204f89fd7d)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var width = props.width;
        transforms.push("scale(".concat(((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(width) ? width / lineWidth : 1) / lineWidth, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(' ');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", $964be52cc11879b4$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(textProps, true), {
        x: x,
        y: y,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-text', className),
        textAnchor: textAnchor,
        fill: fill.includes('url') ? $964be52cc11879b4$var$DEFAULT_FILL : fill
    }), wordsByLines.map(function(line, index) {
        var words = line.words.join(breakAll ? '' : ' ');
        return(/*#__PURE__*/ // duplicate words will cause duplicate keys
        // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: "".concat(words, "-").concat(index)
        }, words));
    }));
};






var $acw62 = parcelRequire("acw62");


var $d8f008d3b0c1a5c3$exports = {};
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$d8f008d3b0c1a5c3$exports = (parcelRequire("eTYpT"));


var $9b23116271105198$exports = {};
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$9b23116271105198$exports = (parcelRequire("CKTDO"));


var $7d231ba5a67a42db$exports = {};
var $c032706da200ef36$exports = {};

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $c032706da200ef36$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$6b5a5095e0934938$exports(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
$c032706da200ef36$exports = $c032706da200ef36$var$baseExtremum;


var $da4e1fe5f8bd1939$exports = {};
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $da4e1fe5f8bd1939$var$baseGt(value, other) {
    return value > other;
}
$da4e1fe5f8bd1939$exports = $da4e1fe5f8bd1939$var$baseGt;


var $37dff9aa04444f9c$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $37dff9aa04444f9c$var$identity(value) {
    return value;
}
$37dff9aa04444f9c$exports = $37dff9aa04444f9c$var$identity;


/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $7d231ba5a67a42db$var$max(array) {
    return array && array.length ? $c032706da200ef36$exports(array, $37dff9aa04444f9c$exports, $da4e1fe5f8bd1939$exports) : undefined;
}
$7d231ba5a67a42db$exports = $7d231ba5a67a42db$var$max;


var $2c30ec7848ba160d$exports = {};

var $cdf01b2c29e1be9c$exports = {};
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $cdf01b2c29e1be9c$var$baseLt(value, other) {
    return value < other;
}
$cdf01b2c29e1be9c$exports = $cdf01b2c29e1be9c$var$baseLt;



/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $2c30ec7848ba160d$var$min(array) {
    return array && array.length ? $c032706da200ef36$exports(array, $37dff9aa04444f9c$exports, $cdf01b2c29e1be9c$exports) : undefined;
}
$2c30ec7848ba160d$exports = $2c30ec7848ba160d$var$min;






var $1cb7998639d45551$exports = {};
var $b1d5985487d54dea$exports = {};

var $035bd928078475ee$exports = {};



/** Built-in value references. */ var $035bd928078475ee$var$spreadableSymbol = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $035bd928078475ee$var$isFlattenable(value) {
    return $0488fde9aa355453$exports(value) || $7d0c6fd0eb26be0e$exports(value) || !!($035bd928078475ee$var$spreadableSymbol && value && value[$035bd928078475ee$var$spreadableSymbol]);
}
$035bd928078475ee$exports = $035bd928078475ee$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $b1d5985487d54dea$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $035bd928078475ee$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $b1d5985487d54dea$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $cc77dbb7c08db6a8$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$b1d5985487d54dea$exports = $b1d5985487d54dea$var$baseFlatten;


var $2f2d1bf022ac3e3d$exports = {};

var $5aba4f6d9f8304a3$exports = {};
var $e780807e2b795134$exports = {};
var $ec073f38db6e7d54$exports = {};


/** Used to compose bitmasks for value comparisons. */ var $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG = 1, $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $ec073f38db6e7d54$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $bbb2d98cae25b61a$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $769812b29c18141e$exports(srcValue, objValue, $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG | $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$ec073f38db6e7d54$exports = $ec073f38db6e7d54$var$baseIsMatch;


var $6b4f84f6be7f825c$exports = {};
var $0ff8edf4f90a7955$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $0ff8edf4f90a7955$var$isStrictComparable(value) {
    return value === value && !$f9ff2e983beb6b86$exports(value);
}
$0ff8edf4f90a7955$exports = $0ff8edf4f90a7955$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $6b4f84f6be7f825c$var$getMatchData(object) {
    var result = $08f0eaf3fbcb2fde$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $0ff8edf4f90a7955$exports(value)
        ];
    }
    return result;
}
$6b4f84f6be7f825c$exports = $6b4f84f6be7f825c$var$getMatchData;


var $1f9d5e891556ddb9$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1f9d5e891556ddb9$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$1f9d5e891556ddb9$exports = $1f9d5e891556ddb9$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $e780807e2b795134$var$baseMatches(source) {
    var matchData = $6b4f84f6be7f825c$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $1f9d5e891556ddb9$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $ec073f38db6e7d54$exports(object, source, matchData);
    };
}
$e780807e2b795134$exports = $e780807e2b795134$var$baseMatches;


var $d5fe8a98fe4800eb$exports = {};


var $221e04e57e35dd04$exports = {};
var $d53c6080f339a51f$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d53c6080f339a51f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$d53c6080f339a51f$exports = $d53c6080f339a51f$var$baseHasIn;


var $85aaea8f77d790ae$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $85aaea8f77d790ae$var$hasPath(object, path, hasFunc) {
    path = $38afcbfab85a0553$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $4d60aa8c33155976$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $15d215b19bcf1187$exports(length) && $d83738e053b5eb08$exports(key, length) && ($0488fde9aa355453$exports(object) || $7d0c6fd0eb26be0e$exports(object));
}
$85aaea8f77d790ae$exports = $85aaea8f77d790ae$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $221e04e57e35dd04$var$hasIn(object, path) {
    return object != null && $85aaea8f77d790ae$exports(object, path, $d53c6080f339a51f$exports);
}
$221e04e57e35dd04$exports = $221e04e57e35dd04$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG = 1, $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d5fe8a98fe4800eb$var$baseMatchesProperty(path, srcValue) {
    if ($03e9beb856e9b4cd$exports(path) && $0ff8edf4f90a7955$exports(srcValue)) return $1f9d5e891556ddb9$exports($4d60aa8c33155976$exports(path), srcValue);
    return function(object) {
        var objValue = $d299ac421c05c135$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $221e04e57e35dd04$exports(object, path) : $769812b29c18141e$exports(srcValue, objValue, $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG | $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG);
    };
}
$d5fe8a98fe4800eb$exports = $d5fe8a98fe4800eb$var$baseMatchesProperty;




var $87123e72266aa58c$exports = {};
var $d45a621b4548f6bb$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $d45a621b4548f6bb$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$d45a621b4548f6bb$exports = $d45a621b4548f6bb$var$baseProperty;


var $e029d02f9dd10368$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e029d02f9dd10368$var$basePropertyDeep(path) {
    return function(object) {
        return $fd2d90f592c63519$exports(object, path);
    };
}
$e029d02f9dd10368$exports = $e029d02f9dd10368$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $87123e72266aa58c$var$property(path) {
    return $03e9beb856e9b4cd$exports(path) ? $d45a621b4548f6bb$exports($4d60aa8c33155976$exports(path)) : $e029d02f9dd10368$exports(path);
}
$87123e72266aa58c$exports = $87123e72266aa58c$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $5aba4f6d9f8304a3$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $37dff9aa04444f9c$exports;
    if (typeof value == 'object') return $0488fde9aa355453$exports(value) ? $d5fe8a98fe4800eb$exports(value[0], value[1]) : $e780807e2b795134$exports(value);
    return $87123e72266aa58c$exports(value);
}
$5aba4f6d9f8304a3$exports = $5aba4f6d9f8304a3$var$baseIteratee;


var $b613e194c1b157de$exports = {};
var $35fa3296f177aa01$exports = {};
var $34edfba366a0cfa1$exports = {};
var $9f0778b809a8c692$exports = {};
var $e7bbde6376f4568a$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $e7bbde6376f4568a$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$e7bbde6376f4568a$exports = $e7bbde6376f4568a$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $9f0778b809a8c692$var$baseFor = $e7bbde6376f4568a$exports();
$9f0778b809a8c692$exports = $9f0778b809a8c692$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $34edfba366a0cfa1$var$baseForOwn(object, iteratee) {
    return object && $9f0778b809a8c692$exports(object, iteratee, $08f0eaf3fbcb2fde$exports);
}
$34edfba366a0cfa1$exports = $34edfba366a0cfa1$var$baseForOwn;


var $f03eae3721f9ace8$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $f03eae3721f9ace8$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$ac2c42592aa05543$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$f03eae3721f9ace8$exports = $f03eae3721f9ace8$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $35fa3296f177aa01$var$baseEach = $f03eae3721f9ace8$exports($34edfba366a0cfa1$exports);
$35fa3296f177aa01$exports = $35fa3296f177aa01$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $b613e194c1b157de$var$baseMap(collection, iteratee) {
    var index = -1, result = $ac2c42592aa05543$exports(collection) ? Array(collection.length) : [];
    $35fa3296f177aa01$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$b613e194c1b157de$exports = $b613e194c1b157de$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $2f2d1bf022ac3e3d$var$map(collection, iteratee) {
    var func = $0488fde9aa355453$exports(collection) ? $d26d80da1ba3948c$exports : $b613e194c1b157de$exports;
    return func(collection, $5aba4f6d9f8304a3$exports(iteratee, 3));
}
$2f2d1bf022ac3e3d$exports = $2f2d1bf022ac3e3d$var$map;


/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $1cb7998639d45551$var$flatMap(collection, iteratee) {
    return $b1d5985487d54dea$exports($2f2d1bf022ac3e3d$exports(collection, iteratee), 1);
}
$1cb7998639d45551$exports = $1cb7998639d45551$var$flatMap;



var $da6130e1e4702e32$exports = {};
var $0d9811a54a2f955a$exports = {};
var $cfe77c1a7b7c7d6e$exports = {};
var $109fb88fe59de104$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $109fb88fe59de104$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$109fb88fe59de104$exports = $109fb88fe59de104$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $cfe77c1a7b7c7d6e$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $109fb88fe59de104$exports(array, start, end);
}
$cfe77c1a7b7c7d6e$exports = $cfe77c1a7b7c7d6e$var$castSlice;


var $00fdf7eab00be2e7$exports = {};
/** Used to compose unicode character classes. */ var $00fdf7eab00be2e7$var$rsAstralRange = '\\ud800-\\udfff', $00fdf7eab00be2e7$var$rsComboMarksRange = '\\u0300-\\u036f', $00fdf7eab00be2e7$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $00fdf7eab00be2e7$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $00fdf7eab00be2e7$var$rsComboRange = $00fdf7eab00be2e7$var$rsComboMarksRange + $00fdf7eab00be2e7$var$reComboHalfMarksRange + $00fdf7eab00be2e7$var$rsComboSymbolsRange, $00fdf7eab00be2e7$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $00fdf7eab00be2e7$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $00fdf7eab00be2e7$var$reHasUnicode = RegExp('[' + $00fdf7eab00be2e7$var$rsZWJ + $00fdf7eab00be2e7$var$rsAstralRange + $00fdf7eab00be2e7$var$rsComboRange + $00fdf7eab00be2e7$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $00fdf7eab00be2e7$var$hasUnicode(string) {
    return $00fdf7eab00be2e7$var$reHasUnicode.test(string);
}
$00fdf7eab00be2e7$exports = $00fdf7eab00be2e7$var$hasUnicode;


var $9a986c87d425808c$exports = {};
var $43b96a6d93895c83$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $43b96a6d93895c83$var$asciiToArray(string) {
    return string.split('');
}
$43b96a6d93895c83$exports = $43b96a6d93895c83$var$asciiToArray;



var $c3bf9ebcb1b53b1d$exports = {};
/** Used to compose unicode character classes. */ var $c3bf9ebcb1b53b1d$var$rsAstralRange = '\\ud800-\\udfff', $c3bf9ebcb1b53b1d$var$rsComboMarksRange = '\\u0300-\\u036f', $c3bf9ebcb1b53b1d$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $c3bf9ebcb1b53b1d$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $c3bf9ebcb1b53b1d$var$rsComboRange = $c3bf9ebcb1b53b1d$var$rsComboMarksRange + $c3bf9ebcb1b53b1d$var$reComboHalfMarksRange + $c3bf9ebcb1b53b1d$var$rsComboSymbolsRange, $c3bf9ebcb1b53b1d$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $c3bf9ebcb1b53b1d$var$rsAstral = '[' + $c3bf9ebcb1b53b1d$var$rsAstralRange + ']', $c3bf9ebcb1b53b1d$var$rsCombo = '[' + $c3bf9ebcb1b53b1d$var$rsComboRange + ']', $c3bf9ebcb1b53b1d$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $c3bf9ebcb1b53b1d$var$rsModifier = '(?:' + $c3bf9ebcb1b53b1d$var$rsCombo + '|' + $c3bf9ebcb1b53b1d$var$rsFitz + ')', $c3bf9ebcb1b53b1d$var$rsNonAstral = '[^' + $c3bf9ebcb1b53b1d$var$rsAstralRange + ']', $c3bf9ebcb1b53b1d$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $c3bf9ebcb1b53b1d$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $c3bf9ebcb1b53b1d$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $c3bf9ebcb1b53b1d$var$reOptMod = $c3bf9ebcb1b53b1d$var$rsModifier + '?', $c3bf9ebcb1b53b1d$var$rsOptVar = '[' + $c3bf9ebcb1b53b1d$var$rsVarRange + ']?', $c3bf9ebcb1b53b1d$var$rsOptJoin = '(?:' + $c3bf9ebcb1b53b1d$var$rsZWJ + '(?:' + [
    $c3bf9ebcb1b53b1d$var$rsNonAstral,
    $c3bf9ebcb1b53b1d$var$rsRegional,
    $c3bf9ebcb1b53b1d$var$rsSurrPair
].join('|') + ')' + $c3bf9ebcb1b53b1d$var$rsOptVar + $c3bf9ebcb1b53b1d$var$reOptMod + ')*', $c3bf9ebcb1b53b1d$var$rsSeq = $c3bf9ebcb1b53b1d$var$rsOptVar + $c3bf9ebcb1b53b1d$var$reOptMod + $c3bf9ebcb1b53b1d$var$rsOptJoin, $c3bf9ebcb1b53b1d$var$rsSymbol = '(?:' + [
    $c3bf9ebcb1b53b1d$var$rsNonAstral + $c3bf9ebcb1b53b1d$var$rsCombo + '?',
    $c3bf9ebcb1b53b1d$var$rsCombo,
    $c3bf9ebcb1b53b1d$var$rsRegional,
    $c3bf9ebcb1b53b1d$var$rsSurrPair,
    $c3bf9ebcb1b53b1d$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $c3bf9ebcb1b53b1d$var$reUnicode = RegExp($c3bf9ebcb1b53b1d$var$rsFitz + '(?=' + $c3bf9ebcb1b53b1d$var$rsFitz + ')|' + $c3bf9ebcb1b53b1d$var$rsSymbol + $c3bf9ebcb1b53b1d$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $c3bf9ebcb1b53b1d$var$unicodeToArray(string) {
    return string.match($c3bf9ebcb1b53b1d$var$reUnicode) || [];
}
$c3bf9ebcb1b53b1d$exports = $c3bf9ebcb1b53b1d$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $9a986c87d425808c$var$stringToArray(string) {
    return $00fdf7eab00be2e7$exports(string) ? $c3bf9ebcb1b53b1d$exports(string) : $43b96a6d93895c83$exports(string);
}
$9a986c87d425808c$exports = $9a986c87d425808c$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $0d9811a54a2f955a$var$createCaseFirst(methodName) {
    return function(string) {
        string = $f5d9385a9cc7e413$exports(string);
        var strSymbols = $00fdf7eab00be2e7$exports(string) ? $9a986c87d425808c$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $cfe77c1a7b7c7d6e$exports(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$0d9811a54a2f955a$exports = $0d9811a54a2f955a$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $da6130e1e4702e32$var$upperFirst = $0d9811a54a2f955a$exports('toUpperCase');
$da6130e1e4702e32$exports = $da6130e1e4702e32$var$upperFirst;



var $300ea168693086c2$exports = {};

var $e277a64de4eeade6$exports = {};




var $6f370ce7a904568e$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $6f370ce7a904568e$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$6f370ce7a904568e$exports = $6f370ce7a904568e$var$baseSortBy;



var $b53b4bd61680c3b6$exports = {};
var $13e53edf809f77b7$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $13e53edf809f77b7$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $6b5a5095e0934938$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $6b5a5095e0934938$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$13e53edf809f77b7$exports = $13e53edf809f77b7$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $b53b4bd61680c3b6$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $13e53edf809f77b7$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$b53b4bd61680c3b6$exports = $b53b4bd61680c3b6$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $e277a64de4eeade6$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $d26d80da1ba3948c$exports(iteratees, function(iteratee) {
        if ($0488fde9aa355453$exports(iteratee)) return function(value) {
            return $fd2d90f592c63519$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $37dff9aa04444f9c$exports
    ];
    var index = -1;
    iteratees = $d26d80da1ba3948c$exports(iteratees, $692cb5474f422969$exports($5aba4f6d9f8304a3$exports));
    var result = $b613e194c1b157de$exports(collection, function(value, key, collection) {
        var criteria = $d26d80da1ba3948c$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $6f370ce7a904568e$exports(result, function(object, other) {
        return $b53b4bd61680c3b6$exports(object, other, orders);
    });
}
$e277a64de4eeade6$exports = $e277a64de4eeade6$var$baseOrderBy;


var $3db9ad8fe1351fef$exports = {};

var $81a5758ee0248452$exports = {};
var $e22d8f7aab4ea8e2$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $e22d8f7aab4ea8e2$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$e22d8f7aab4ea8e2$exports = $e22d8f7aab4ea8e2$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $81a5758ee0248452$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $81a5758ee0248452$var$overRest(func, start, transform) {
    start = $81a5758ee0248452$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $81a5758ee0248452$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $e22d8f7aab4ea8e2$exports(func, this, otherArgs);
    };
}
$81a5758ee0248452$exports = $81a5758ee0248452$var$overRest;


var $d9b21a2cad7f96c2$exports = {};
var $1dca5cc74bf5ffaf$exports = {};
var $7111863c3c692f0e$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $7111863c3c692f0e$var$constant(value) {
    return function() {
        return value;
    };
}
$7111863c3c692f0e$exports = $7111863c3c692f0e$var$constant;


var $31e24313ace94404$exports = {};

var $31e24313ace94404$var$defineProperty = function() {
    try {
        var func = $5037fd2e597c2a03$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$31e24313ace94404$exports = $31e24313ace94404$var$defineProperty;



/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $1dca5cc74bf5ffaf$var$baseSetToString = !$31e24313ace94404$exports ? $37dff9aa04444f9c$exports : function(func, string) {
    return $31e24313ace94404$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $7111863c3c692f0e$exports(string),
        'writable': true
    });
};
$1dca5cc74bf5ffaf$exports = $1dca5cc74bf5ffaf$var$baseSetToString;


var $5c7bd4e931ae22e5$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $5c7bd4e931ae22e5$var$HOT_COUNT = 800, $5c7bd4e931ae22e5$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5c7bd4e931ae22e5$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $5c7bd4e931ae22e5$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $5c7bd4e931ae22e5$var$nativeNow(), remaining = $5c7bd4e931ae22e5$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $5c7bd4e931ae22e5$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$5c7bd4e931ae22e5$exports = $5c7bd4e931ae22e5$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $d9b21a2cad7f96c2$var$setToString = $5c7bd4e931ae22e5$exports($1dca5cc74bf5ffaf$exports);
$d9b21a2cad7f96c2$exports = $d9b21a2cad7f96c2$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $3db9ad8fe1351fef$var$baseRest(func, start) {
    return $d9b21a2cad7f96c2$exports($81a5758ee0248452$exports(func, start, $37dff9aa04444f9c$exports), func + '');
}
$3db9ad8fe1351fef$exports = $3db9ad8fe1351fef$var$baseRest;


var $81b21e8b41d211e8$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $81b21e8b41d211e8$var$isIterateeCall(value, index, object) {
    if (!$f9ff2e983beb6b86$exports(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $ac2c42592aa05543$exports(object) && $d83738e053b5eb08$exports(index, object.length) : type == 'string' && index in object) return $50557587dab070a0$exports(object[index], value);
    return false;
}
$81b21e8b41d211e8$exports = $81b21e8b41d211e8$var$isIterateeCall;


/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $300ea168693086c2$var$sortBy = $3db9ad8fe1351fef$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $81b21e8b41d211e8$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $81b21e8b41d211e8$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $e277a64de4eeade6$exports(collection, $b1d5985487d54dea$exports(iteratees, 1), []);
});
$300ea168693086c2$exports = $300ea168693086c2$var$sortBy;


var $150bb5f05cbd0a1e$exports = {};
/*! decimal.js-light v2.5.1 https://github.com/MikeMcl/decimal.js-light/LICENCE */ (function(globalScope) {
    'use strict';
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', exponentOutOfRange = decimalError + 'Exponent out of range: ', mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + 'NaN');
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + 'NaN');
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != '9999') break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + 'Infinity');
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + 'NaN');
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + 'Division by zero');
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + 'LN10 precision limit exceeded');
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (e < 0 ? 'e' : 'e+') + e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === 'number') {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== 'string') throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                'precision',
                'rounding',
                'toExpNeg',
                'toExpPos',
                'LN10'
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -1 / 0,
            0,
            'toExpPos',
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ': ' + v);
        }
        if ((v = obj[p = 'LN10']) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if ($150bb5f05cbd0a1e$exports) $150bb5f05cbd0a1e$exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : Function('return this')();
        globalScope.Decimal = Decimal;
    }
})($150bb5f05cbd0a1e$exports);


function $c7a5592297cca14c$var$_toConsumableArray(arr) {
    return $c7a5592297cca14c$var$_arrayWithoutHoles(arr) || $c7a5592297cca14c$var$_iterableToArray(arr) || $c7a5592297cca14c$var$_unsupportedIterableToArray(arr) || $c7a5592297cca14c$var$_nonIterableSpread();
}
function $c7a5592297cca14c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c7a5592297cca14c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c7a5592297cca14c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c7a5592297cca14c$var$_arrayLikeToArray(o, minLen);
}
function $c7a5592297cca14c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $c7a5592297cca14c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c7a5592297cca14c$var$_arrayLikeToArray(arr);
}
function $c7a5592297cca14c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $c7a5592297cca14c$var$identity = function identity(i) {
    return i;
};
var $c7a5592297cca14c$export$ca73b6d700d0505 = {
    '@@functional/placeholder': true
};
var $c7a5592297cca14c$var$isPlaceHolder = function isPlaceHolder(val) {
    return val === $c7a5592297cca14c$export$ca73b6d700d0505;
};
var $c7a5592297cca14c$var$curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && $c7a5592297cca14c$var$isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var $c7a5592297cca14c$var$curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return $c7a5592297cca14c$var$curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== $c7a5592297cca14c$export$ca73b6d700d0505;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, $c7a5592297cca14c$var$curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return $c7a5592297cca14c$var$isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, $c7a5592297cca14c$var$_toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var $c7a5592297cca14c$export$c3095a23b368d1f2 = function curry(fn) {
    return $c7a5592297cca14c$var$curryN(fn.length, fn);
};
var $c7a5592297cca14c$export$d02631cccf789723 = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var $c7a5592297cca14c$export$871de8747c9eaa88 = $c7a5592297cca14c$export$c3095a23b368d1f2(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var $c7a5592297cca14c$export$f672e0b6f7222cd7 = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return $c7a5592297cca14c$var$identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $c7a5592297cca14c$export$66c1ae025e96b4bc = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split('').reverse.join('');
};
var $c7a5592297cca14c$export$fc10aeed3a532e2a = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};


/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ 

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function $7df23a93099ed3d6$var$getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function $7df23a93099ed3d6$var$rangeStep(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var $7df23a93099ed3d6$var$interpolateNumber = (0, $c7a5592297cca14c$export$c3095a23b368d1f2)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var $7df23a93099ed3d6$var$uninterpolateNumber = (0, $c7a5592297cca14c$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var $7df23a93099ed3d6$var$uninterpolateTruncation = (0, $c7a5592297cca14c$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
var $7df23a93099ed3d6$export$2e2bcd8739ae039 = {
    rangeStep: $7df23a93099ed3d6$var$rangeStep,
    getDigitCount: $7df23a93099ed3d6$var$getDigitCount,
    interpolateNumber: $7df23a93099ed3d6$var$interpolateNumber,
    uninterpolateNumber: $7df23a93099ed3d6$var$uninterpolateNumber,
    uninterpolateTruncation: $7df23a93099ed3d6$var$uninterpolateTruncation
};


function $83976b3dea6872a0$var$_toConsumableArray(arr) {
    return $83976b3dea6872a0$var$_arrayWithoutHoles(arr) || $83976b3dea6872a0$var$_iterableToArray(arr) || $83976b3dea6872a0$var$_unsupportedIterableToArray(arr) || $83976b3dea6872a0$var$_nonIterableSpread();
}
function $83976b3dea6872a0$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $83976b3dea6872a0$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $83976b3dea6872a0$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $83976b3dea6872a0$var$_arrayLikeToArray(arr);
}
function $83976b3dea6872a0$var$_slicedToArray(arr, i) {
    return $83976b3dea6872a0$var$_arrayWithHoles(arr) || $83976b3dea6872a0$var$_iterableToArrayLimit(arr, i) || $83976b3dea6872a0$var$_unsupportedIterableToArray(arr, i) || $83976b3dea6872a0$var$_nonIterableRest();
}
function $83976b3dea6872a0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $83976b3dea6872a0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $83976b3dea6872a0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $83976b3dea6872a0$var$_arrayLikeToArray(o, minLen);
}
function $83976b3dea6872a0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $83976b3dea6872a0$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $83976b3dea6872a0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function $83976b3dea6872a0$var$getValidInterval(_ref) {
    var _ref2 = $83976b3dea6872a0$var$_slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function $83976b3dea6872a0$var$getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(0);
    var digitCount = (0, $7df23a93099ed3d6$export$2e2bcd8739ae039).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function $83976b3dea6872a0$var$getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(10).pow((0, $7df23a93099ed3d6$export$2e2bcd8739ae039).getDigitCount(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, $c7a5592297cca14c$export$f672e0b6f7222cd7)((0, $c7a5592297cca14c$export$871de8747c9eaa88)(function(n) {
        return middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(n - middleIndex).mul(step)).toNumber();
    }), (0, $c7a5592297cca14c$export$d02631cccf789723));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function $83976b3dea6872a0$var$calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(0)
    };
     // The step which is easy to understand between two ticks
    var step = $83976b3dea6872a0$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $83976b3dea6872a0$var$calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $83976b3dea6872a0$var$getNiceTickValuesFn(_ref3) {
    var _ref4 = $83976b3dea6872a0$var$_slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = $83976b3dea6872a0$var$getValidInterval([
        min,
        max
    ]), _getValidInterval2 = $83976b3dea6872a0$var$_slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat($83976b3dea6872a0$var$_toConsumableArray((0, $c7a5592297cca14c$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat($83976b3dea6872a0$var$_toConsumableArray((0, $c7a5592297cca14c$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, $c7a5592297cca14c$export$66c1ae025e96b4bc)(_values) : _values;
    }
    if (cormin === cormax) return $83976b3dea6872a0$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = $83976b3dea6872a0$var$calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, $7df23a93099ed3d6$export$2e2bcd8739ae039).rangeStep(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(0.1).mul(step)), step);
    return min > max ? (0, $c7a5592297cca14c$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $83976b3dea6872a0$var$getTickValuesFn(_ref5) {
    var _ref6 = $83976b3dea6872a0$var$_slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = $83976b3dea6872a0$var$getValidInterval([
        min,
        max
    ]), _getValidInterval4 = $83976b3dea6872a0$var$_slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return $83976b3dea6872a0$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = $83976b3dea6872a0$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, $c7a5592297cca14c$export$f672e0b6f7222cd7)((0, $c7a5592297cca14c$export$871de8747c9eaa88)(function(n) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(cormin).add(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(n).mul(step)).toNumber();
    }), (0, $c7a5592297cca14c$export$d02631cccf789723));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, $c7a5592297cca14c$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $83976b3dea6872a0$var$getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = $83976b3dea6872a0$var$_slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = $83976b3dea6872a0$var$getValidInterval([
        min,
        max
    ]), _getValidInterval6 = $83976b3dea6872a0$var$_slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = $83976b3dea6872a0$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat($83976b3dea6872a0$var$_toConsumableArray((0, $7df23a93099ed3d6$export$2e2bcd8739ae039).rangeStep(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(cormax).sub(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, $c7a5592297cca14c$export$66c1ae025e96b4bc)(values) : values;
}
var $83976b3dea6872a0$export$b84e75ccbfe6a612 = (0, $c7a5592297cca14c$export$fc10aeed3a532e2a)($83976b3dea6872a0$var$getNiceTickValuesFn);
var $83976b3dea6872a0$export$4cc7a216492b1f53 = (0, $c7a5592297cca14c$export$fc10aeed3a532e2a)($83976b3dea6872a0$var$getTickValuesFn);
var $83976b3dea6872a0$export$e9d28da780436e98 = (0, $c7a5592297cca14c$export$fc10aeed3a532e2a)($83976b3dea6872a0$var$getTickValuesFixedDomainFn);








var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


/* eslint no-console: 0 */ var $0c26188443d0bc67$var$isDev = false;
var $0c26188443d0bc67$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($0c26188443d0bc67$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};



var $acw62 = parcelRequire("acw62");


var $bfae0ec07b91e499$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function $bfae0ec07b91e499$var$_extends() {
    $bfae0ec07b91e499$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bfae0ec07b91e499$var$_extends.apply(this, arguments);
}
function $bfae0ec07b91e499$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bfae0ec07b91e499$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $bfae0ec07b91e499$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $bfae0ec07b91e499$export$7b92b459e668cb21(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, title = props.title, desc = props.desc, others = $bfae0ec07b91e499$var$_objectWithoutProperties(props, $bfae0ec07b91e499$var$_excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-surface', className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $bfae0ec07b91e499$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(others, true, 'svg'), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("desc", null, desc), children);
}



var $acw62 = parcelRequire("acw62");




function $61aa615b92178b76$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $61aa615b92178b76$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $61aa615b92178b76$var$_typeof(o);
}
var $61aa615b92178b76$var$_excluded = [
    "type",
    "size",
    "sizeType"
];
function $61aa615b92178b76$var$_extends() {
    $61aa615b92178b76$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $61aa615b92178b76$var$_extends.apply(this, arguments);
}
function $61aa615b92178b76$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $61aa615b92178b76$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $61aa615b92178b76$var$ownKeys(Object(t), !0).forEach(function(r) {
            $61aa615b92178b76$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $61aa615b92178b76$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $61aa615b92178b76$var$_defineProperty(obj, key, value) {
    key = $61aa615b92178b76$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $61aa615b92178b76$var$_toPropertyKey(t) {
    var i = $61aa615b92178b76$var$_toPrimitive(t, "string");
    return "symbol" == $61aa615b92178b76$var$_typeof(i) ? i : i + "";
}
function $61aa615b92178b76$var$_toPrimitive(t, r) {
    if ("object" != $61aa615b92178b76$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $61aa615b92178b76$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $61aa615b92178b76$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $61aa615b92178b76$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $61aa615b92178b76$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $61aa615b92178b76$var$symbolFactories = {
    symbolCircle: (0, $9b23116271105198$exports.symbolCircle),
    symbolCross: (0, $9b23116271105198$exports.symbolCross),
    symbolDiamond: (0, $9b23116271105198$exports.symbolDiamond),
    symbolSquare: (0, $9b23116271105198$exports.symbolSquare),
    symbolStar: (0, $9b23116271105198$exports.symbolStar),
    symbolTriangle: (0, $9b23116271105198$exports.symbolTriangle),
    symbolWye: (0, $9b23116271105198$exports.symbolWye)
};
var $61aa615b92178b76$var$RADIAN = Math.PI / 180;
var $61aa615b92178b76$var$getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($da6130e1e4702e32$exports)))(type));
    return $61aa615b92178b76$var$symbolFactories[name] || (0, $9b23116271105198$exports.symbolCircle);
};
var $61aa615b92178b76$var$calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === 'area') return size;
    switch(type){
        case 'cross':
            return 5 * size * size / 9;
        case 'diamond':
            return 0.5 * size * size / Math.sqrt(3);
        case 'square':
            return size * size;
        case 'star':
            var angle = 18 * $61aa615b92178b76$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case 'triangle':
            return Math.sqrt(3) * size * size / 4;
        case 'wye':
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $61aa615b92178b76$var$registerSymbol = function registerSymbol(key, factory) {
    $61aa615b92178b76$var$symbolFactories["symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($da6130e1e4702e32$exports)))(key))] = factory;
};
var $61aa615b92178b76$export$fa456266707bf4e4 = function Symbols(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'circle' : _ref$type, _ref$size = _ref.size, size = _ref$size === void 0 ? 64 : _ref$size, _ref$sizeType = _ref.sizeType, sizeType = _ref$sizeType === void 0 ? 'area' : _ref$sizeType, rest = $61aa615b92178b76$var$_objectWithoutProperties(_ref, $61aa615b92178b76$var$_excluded);
    var props = $61aa615b92178b76$var$_objectSpread($61aa615b92178b76$var$_objectSpread({}, rest), {}, {
        type: type,
        size: size,
        sizeType: sizeType
    });
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = function getPath() {
        var symbolFactory = $61aa615b92178b76$var$getSymbolFactory(type);
        var symbol = (0, $9b23116271105198$exports.symbol)().type(symbolFactory).size($61aa615b92178b76$var$calculateAreaSize(size, sizeType, type));
        return symbol();
    };
    var className = props.className, cx = props.cx, cy = props.cy;
    var filteredProps = (0, $008f02516c156322$export$d697c39a2985a4c)(props, true);
    if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", $61aa615b92178b76$var$_extends({}, filteredProps, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-symbols', className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
$61aa615b92178b76$export$fa456266707bf4e4.registerSymbol = $61aa615b92178b76$var$registerSymbol;



function $ea93c1a04fc562aa$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ea93c1a04fc562aa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ea93c1a04fc562aa$var$_typeof(o);
}
function $ea93c1a04fc562aa$var$_extends() {
    $ea93c1a04fc562aa$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ea93c1a04fc562aa$var$_extends.apply(this, arguments);
}
function $ea93c1a04fc562aa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ea93c1a04fc562aa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ea93c1a04fc562aa$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ea93c1a04fc562aa$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ea93c1a04fc562aa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ea93c1a04fc562aa$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ea93c1a04fc562aa$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $ea93c1a04fc562aa$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $ea93c1a04fc562aa$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ea93c1a04fc562aa$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ea93c1a04fc562aa$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ea93c1a04fc562aa$var$_callSuper(t, o, e) {
    return o = $ea93c1a04fc562aa$var$_getPrototypeOf(o), $ea93c1a04fc562aa$var$_possibleConstructorReturn(t, $ea93c1a04fc562aa$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $ea93c1a04fc562aa$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $ea93c1a04fc562aa$var$_possibleConstructorReturn(self, call) {
    if (call && ($ea93c1a04fc562aa$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ea93c1a04fc562aa$var$_assertThisInitialized(self);
}
function $ea93c1a04fc562aa$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ea93c1a04fc562aa$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ea93c1a04fc562aa$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ea93c1a04fc562aa$var$_getPrototypeOf(o) {
    $ea93c1a04fc562aa$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ea93c1a04fc562aa$var$_getPrototypeOf(o);
}
function $ea93c1a04fc562aa$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $ea93c1a04fc562aa$var$_setPrototypeOf(subClass, superClass);
}
function $ea93c1a04fc562aa$var$_setPrototypeOf(o, p) {
    $ea93c1a04fc562aa$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ea93c1a04fc562aa$var$_setPrototypeOf(o, p);
}
function $ea93c1a04fc562aa$var$_defineProperty(obj, key, value) {
    key = $ea93c1a04fc562aa$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ea93c1a04fc562aa$var$_toPropertyKey(t) {
    var i = $ea93c1a04fc562aa$var$_toPrimitive(t, "string");
    return "symbol" == $ea93c1a04fc562aa$var$_typeof(i) ? i : i + "";
}
function $ea93c1a04fc562aa$var$_toPrimitive(t, r) {
    if ("object" != $ea93c1a04fc562aa$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ea93c1a04fc562aa$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $ea93c1a04fc562aa$var$SIZE = 32;
var $ea93c1a04fc562aa$export$99f8d96ed0cededa = /*#__PURE__*/ function(_PureComponent) {
    function DefaultLegendContent() {
        $ea93c1a04fc562aa$var$_classCallCheck(this, DefaultLegendContent);
        return $ea93c1a04fc562aa$var$_callSuper(this, DefaultLegendContent, arguments);
    }
    $ea93c1a04fc562aa$var$_inherits(DefaultLegendContent, _PureComponent);
    return $ea93c1a04fc562aa$var$_createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = $ea93c1a04fc562aa$var$SIZE / 2;
                var sixthSize = $ea93c1a04fc562aa$var$SIZE / 6;
                var thirdSize = $ea93c1a04fc562aa$var$SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === 'plainline') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: $ea93c1a04fc562aa$var$SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === 'line') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($ea93c1a04fc562aa$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === 'rect') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat($ea93c1a04fc562aa$var$SIZE / 8, "h").concat($ea93c1a04fc562aa$var$SIZE, "v").concat($ea93c1a04fc562aa$var$SIZE * 3 / 4, "h").concat(-$ea93c1a04fc562aa$var$SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(data.legendIcon)) {
                    var iconProps = $ea93c1a04fc562aa$var$_objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $61aa615b92178b76$export$fa456266707bf4e4), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: $ea93c1a04fc562aa$var$SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: $ea93c1a04fc562aa$var$SIZE,
                    height: $ea93c1a04fc562aa$var$SIZE
                };
                var itemStyle = {
                    display: layout === 'horizontal' ? 'inline-block' : 'block',
                    marginRight: 10
                };
                var svgStyle = {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($ea93c1a04fc562aa$var$_defineProperty($ea93c1a04fc562aa$var$_defineProperty({
                        'recharts-legend-item': true
                    }, "legend-item-".concat(i), true), "inactive", entry.inactive));
                    if (entry.type === 'none') return null;
                    // Do not render entry.value as functions. Always require static string properties.
                    var entryValue = !(0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(entry.value) ? entry.value : null;
                    (0, $0c26188443d0bc67$export$c106dd0671a0fc2d)(!(0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(entry.value), "The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name=\"Name of my Data\"/>" // eslint-disable-line max-len
                    );
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", $ea93c1a04fc562aa$var$_extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i)
                    }, (0, $909d5f835f4e917b$export$ca62be0d67a3158c)(_this.props, entry, i)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bfae0ec07b91e499$export$7b92b459e668cb21), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entryValue, entry, i) : entryValue));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === 'horizontal' ? align : 'left'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
}((0, $acw62.PureComponent));
$ea93c1a04fc562aa$var$_defineProperty($ea93c1a04fc562aa$export$99f8d96ed0cededa, "displayName", 'Legend');
$ea93c1a04fc562aa$var$_defineProperty($ea93c1a04fc562aa$export$99f8d96ed0cededa, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'middle',
    inactiveColor: '#ccc'
});



var $5b6e1b59a42de650$exports = {};

var $451cd6fc5b077ebe$exports = {};

var $a541279ebb64f2c9$exports = {};
var $565b5ed18efa4b9c$exports = {};
var $a9e76203bd7c412f$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a9e76203bd7c412f$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$a9e76203bd7c412f$exports = $a9e76203bd7c412f$var$baseFindIndex;


var $c66d4063f81f4687$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $c66d4063f81f4687$var$baseIsNaN(value) {
    return value !== value;
}
$c66d4063f81f4687$exports = $c66d4063f81f4687$var$baseIsNaN;


var $a1f1a90cd7caaefa$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a1f1a90cd7caaefa$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$a1f1a90cd7caaefa$exports = $a1f1a90cd7caaefa$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $565b5ed18efa4b9c$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $a1f1a90cd7caaefa$exports(array, value, fromIndex) : $a9e76203bd7c412f$exports(array, $c66d4063f81f4687$exports, fromIndex);
}
$565b5ed18efa4b9c$exports = $565b5ed18efa4b9c$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $a541279ebb64f2c9$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $565b5ed18efa4b9c$exports(array, value, 0) > -1;
}
$a541279ebb64f2c9$exports = $a541279ebb64f2c9$var$arrayIncludes;


var $ad409cc63f3cbe79$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $ad409cc63f3cbe79$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$ad409cc63f3cbe79$exports = $ad409cc63f3cbe79$var$arrayIncludesWith;



var $3fa8e773494800f5$exports = {};

var $6c554e32feae9faa$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $6c554e32feae9faa$var$noop() {
// No operation performed.
}
$6c554e32feae9faa$exports = $6c554e32feae9faa$var$noop;



/** Used as references for various `Number` constants. */ var $3fa8e773494800f5$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $3fa8e773494800f5$var$createSet = !($05f44e958da968eb$exports && 1 / $11f509f8f53d8c36$exports(new $05f44e958da968eb$exports([
    ,
    -0
]))[1] == $3fa8e773494800f5$var$INFINITY) ? $6c554e32feae9faa$exports : function(values) {
    return new $05f44e958da968eb$exports(values);
};
$3fa8e773494800f5$exports = $3fa8e773494800f5$var$createSet;



/** Used as the size to enable large array optimizations. */ var $451cd6fc5b077ebe$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $451cd6fc5b077ebe$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $a541279ebb64f2c9$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $ad409cc63f3cbe79$exports;
    } else if (length >= $451cd6fc5b077ebe$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $3fa8e773494800f5$exports(array);
        if (set) return $11f509f8f53d8c36$exports(set);
        isCommon = false;
        includes = $1b44096ad4b9e2d5$exports;
        seen = new $a29ccdc0f60e279e$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$451cd6fc5b077ebe$exports = $451cd6fc5b077ebe$var$baseUniq;


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $5b6e1b59a42de650$var$uniqBy(array, iteratee) {
    return array && array.length ? $451cd6fc5b077ebe$exports(array, $5aba4f6d9f8304a3$exports(iteratee, 2)) : [];
}
$5b6e1b59a42de650$exports = $5b6e1b59a42de650$var$uniqBy;



function $12cc16c3e91089ee$export$b67e33c2fb1535fa(payload, option, defaultUniqBy) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($5b6e1b59a42de650$exports)))(payload, defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($5b6e1b59a42de650$exports)))(payload, option);
    return payload;
}


function $1f4bd73be8c7e839$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1f4bd73be8c7e839$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1f4bd73be8c7e839$var$_typeof(o);
}
var $1f4bd73be8c7e839$var$_excluded = [
    "ref"
];
function $1f4bd73be8c7e839$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1f4bd73be8c7e839$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1f4bd73be8c7e839$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1f4bd73be8c7e839$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1f4bd73be8c7e839$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1f4bd73be8c7e839$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1f4bd73be8c7e839$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $1f4bd73be8c7e839$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $1f4bd73be8c7e839$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1f4bd73be8c7e839$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1f4bd73be8c7e839$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1f4bd73be8c7e839$var$_callSuper(t, o, e) {
    return o = $1f4bd73be8c7e839$var$_getPrototypeOf(o), $1f4bd73be8c7e839$var$_possibleConstructorReturn(t, $1f4bd73be8c7e839$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $1f4bd73be8c7e839$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $1f4bd73be8c7e839$var$_possibleConstructorReturn(self, call) {
    if (call && ($1f4bd73be8c7e839$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1f4bd73be8c7e839$var$_assertThisInitialized(self);
}
function $1f4bd73be8c7e839$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1f4bd73be8c7e839$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1f4bd73be8c7e839$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1f4bd73be8c7e839$var$_getPrototypeOf(o) {
    $1f4bd73be8c7e839$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1f4bd73be8c7e839$var$_getPrototypeOf(o);
}
function $1f4bd73be8c7e839$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1f4bd73be8c7e839$var$_setPrototypeOf(subClass, superClass);
}
function $1f4bd73be8c7e839$var$_setPrototypeOf(o, p) {
    $1f4bd73be8c7e839$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1f4bd73be8c7e839$var$_setPrototypeOf(o, p);
}
function $1f4bd73be8c7e839$var$_defineProperty(obj, key, value) {
    key = $1f4bd73be8c7e839$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1f4bd73be8c7e839$var$_toPropertyKey(t) {
    var i = $1f4bd73be8c7e839$var$_toPrimitive(t, "string");
    return "symbol" == $1f4bd73be8c7e839$var$_typeof(i) ? i : i + "";
}
function $1f4bd73be8c7e839$var$_toPrimitive(t, r) {
    if ("object" != $1f4bd73be8c7e839$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1f4bd73be8c7e839$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1f4bd73be8c7e839$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1f4bd73be8c7e839$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1f4bd73be8c7e839$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $1f4bd73be8c7e839$var$defaultUniqBy(entry) {
    return entry.value;
}
function $1f4bd73be8c7e839$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(content, props);
    var ref = props.ref, otherProps = $1f4bd73be8c7e839$var$_objectWithoutProperties(props, $1f4bd73be8c7e839$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ea93c1a04fc562aa$export$99f8d96ed0cededa), otherProps);
}
var $1f4bd73be8c7e839$var$EPS = 1;
var $1f4bd73be8c7e839$export$ed247974535929c7 = /*#__PURE__*/ function(_PureComponent) {
    function Legend() {
        var _this;
        $1f4bd73be8c7e839$var$_classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $1f4bd73be8c7e839$var$_callSuper(this, Legend, [].concat(args));
        $1f4bd73be8c7e839$var$_defineProperty(_this, "lastBoundingBox", {
            width: -1,
            height: -1
        });
        return _this;
    }
    $1f4bd73be8c7e839$var$_inherits(Legend, _PureComponent);
    return $1f4bd73be8c7e839$var$_createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    box.height = this.wrapperNode.offsetHeight;
                    box.width = this.wrapperNode.offsetWidth;
                    return box;
                }
                return null;
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var onBBoxUpdate = this.props.onBBoxUpdate;
                var box = this.getBBox();
                if (box) {
                    if (Math.abs(box.width - this.lastBoundingBox.width) > $1f4bd73be8c7e839$var$EPS || Math.abs(box.height - this.lastBoundingBox.height) > $1f4bd73be8c7e839$var$EPS) {
                        this.lastBoundingBox.width = box.width;
                        this.lastBoundingBox.height = box.height;
                        if (onBBoxUpdate) onBBoxUpdate(box);
                    }
                } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
                    this.lastBoundingBox.width = -1;
                    this.lastBoundingBox.height = -1;
                    if (onBBoxUpdate) onBBoxUpdate(null);
                }
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                if (this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0) return $1f4bd73be8c7e839$var$_objectSpread({}, this.lastBoundingBox);
                return {
                    width: 0,
                    height: 0
                };
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === 'center' && layout === 'vertical') {
                        var box = this.getBBoxSnapshot();
                        hPos = {
                            left: ((chartWidth || 0) - box.width) / 2
                        };
                    } else hPos = align === 'right' ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === 'middle') {
                        var _box = this.getBBoxSnapshot();
                        vPos = {
                            top: ((chartHeight || 0) - _box.height) / 2
                        };
                    } else vPos = verticalAlign === 'bottom' ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return $1f4bd73be8c7e839$var$_objectSpread($1f4bd73be8c7e839$var$_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = $1f4bd73be8c7e839$var$_objectSpread($1f4bd73be8c7e839$var$_objectSpread({
                    position: 'absolute',
                    width: width || 'auto',
                    height: height || 'auto'
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, $1f4bd73be8c7e839$var$renderContent(content, $1f4bd73be8c7e839$var$_objectSpread($1f4bd73be8c7e839$var$_objectSpread({}, this.props), {}, {
                    payload: (0, $12cc16c3e91089ee$export$b67e33c2fb1535fa)(payload, payloadUniqBy, $1f4bd73be8c7e839$var$defaultUniqBy)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var _this$defaultProps$it = $1f4bd73be8c7e839$var$_objectSpread($1f4bd73be8c7e839$var$_objectSpread({}, this.defaultProps), item.props), layout = _this$defaultProps$it.layout;
                if (layout === 'vertical' && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === 'horizontal') return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
}((0, $acw62.PureComponent));
$1f4bd73be8c7e839$var$_defineProperty($1f4bd73be8c7e839$export$ed247974535929c7, "displayName", 'Legend');
$1f4bd73be8c7e839$var$_defineProperty($1f4bd73be8c7e839$export$ed247974535929c7, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom'
});




function $3a45d033d706e33c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3a45d033d706e33c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3a45d033d706e33c$var$_typeof(o);
}
function $3a45d033d706e33c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3a45d033d706e33c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3a45d033d706e33c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3a45d033d706e33c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3a45d033d706e33c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3a45d033d706e33c$var$_defineProperty(obj, key, value) {
    key = $3a45d033d706e33c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3a45d033d706e33c$var$_toPropertyKey(t) {
    var i = $3a45d033d706e33c$var$_toPrimitive(t, "string");
    return "symbol" == $3a45d033d706e33c$var$_typeof(i) ? i : i + "";
}
function $3a45d033d706e33c$var$_toPrimitive(t, r) {
    if ("object" != $3a45d033d706e33c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3a45d033d706e33c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $3a45d033d706e33c$export$8f9424d123c36aa = function getLegendProps(_ref) {
    var children = _ref.children, formattedGraphicalItems = _ref.formattedGraphicalItems, legendWidth = _ref.legendWidth, legendContent = _ref.legendContent;
    var legendItem = (0, $008f02516c156322$export$64c61536a2b72e0f)(children, (0, $1f4bd73be8c7e839$export$ed247974535929c7));
    if (!legendItem) return null;
    var legendDefaultProps = (0, $1f4bd73be8c7e839$export$ed247974535929c7).defaultProps;
    var legendProps = legendDefaultProps !== undefined ? $3a45d033d706e33c$var$_objectSpread($3a45d033d706e33c$var$_objectSpread({}, legendDefaultProps), legendItem.props) : {};
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === 'children') legendData = (formattedGraphicalItems || []).reduce(function(result, _ref2) {
        var item = _ref2.item, props = _ref2.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref3) {
        var item = _ref3.item;
        var itemDefaultProps = item.type.defaultProps;
        var itemProps = itemDefaultProps !== undefined ? $3a45d033d706e33c$var$_objectSpread($3a45d033d706e33c$var$_objectSpread({}, itemDefaultProps), item.props) : {};
        var dataKey = itemProps.dataKey, name = itemProps.name, legendType = itemProps.legendType, hide = itemProps.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendProps.iconType || legendType || 'square',
            color: (0, $cd015374923bb5c7$export$ec6cab5a7a3b93bf)(item),
            value: name || dataKey,
            // @ts-expect-error property strokeDasharray is required in Payload but optional in props
            payload: itemProps
        };
    });
    return $3a45d033d706e33c$var$_objectSpread($3a45d033d706e33c$var$_objectSpread($3a45d033d706e33c$var$_objectSpread({}, legendProps), (0, $1f4bd73be8c7e839$export$ed247974535929c7).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};


function $cd015374923bb5c7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cd015374923bb5c7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cd015374923bb5c7$var$_typeof(o);
}
function $cd015374923bb5c7$var$_toConsumableArray(arr) {
    return $cd015374923bb5c7$var$_arrayWithoutHoles(arr) || $cd015374923bb5c7$var$_iterableToArray(arr) || $cd015374923bb5c7$var$_unsupportedIterableToArray(arr) || $cd015374923bb5c7$var$_nonIterableSpread();
}
function $cd015374923bb5c7$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cd015374923bb5c7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cd015374923bb5c7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cd015374923bb5c7$var$_arrayLikeToArray(o, minLen);
}
function $cd015374923bb5c7$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $cd015374923bb5c7$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $cd015374923bb5c7$var$_arrayLikeToArray(arr);
}
function $cd015374923bb5c7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cd015374923bb5c7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cd015374923bb5c7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cd015374923bb5c7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cd015374923bb5c7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cd015374923bb5c7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cd015374923bb5c7$var$_defineProperty(obj, key, value) {
    key = $cd015374923bb5c7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cd015374923bb5c7$var$_toPropertyKey(t) {
    var i = $cd015374923bb5c7$var$_toPrimitive(t, "string");
    return "symbol" == $cd015374923bb5c7$var$_typeof(i) ? i : i + "";
}
function $cd015374923bb5c7$var$_toPrimitive(t, r) {
    if ("object" != $cd015374923bb5c7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $cd015374923bb5c7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $cd015374923bb5c7$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(dataKey)) return defaultValue;
    if ((0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(obj, dataKey, defaultValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(dataKey)) return dataKey(obj);
    return defaultValue;
}
function $cd015374923bb5c7$export$6a1e7873444c95a7(data, key, type, filterNil) {
    var flattenData = (0, (/*@__PURE__*/$parcel$interopDefault($1cb7998639d45551$exports)))(data, function(entry) {
        return $cd015374923bb5c7$export$f97fc4a450f29a(entry, key);
    });
    if (type === 'number') {
        // @ts-expect-error parseFloat type only accepts strings
        var domain = flattenData.filter(function(entry) {
            return (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, (/*@__PURE__*/$parcel$interopDefault($2c30ec7848ba160d$exports)))(domain),
            (0, (/*@__PURE__*/$parcel$interopDefault($7d231ba5a67a42db$exports)))(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(entry);
    }) : flattenData;
    // Supports x-axis of Date type
    return validateData.map(function(entry) {
        return (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(entry) || entry instanceof Date ? entry : '';
    });
}
var $cd015374923bb5c7$export$3071d39cc844078e = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or less ticks ticks then the active tick is at index 0
    if (len <= 1) return 0;
    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
        var range = axis.range;
        // ticks are distributed in a circle
        for(var i = 0; i < len; i++){
            var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
            var cur = unsortedTicks[i].coordinate;
            var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
            var sameDirectionCoord = void 0;
            if ((0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(cur - before) !== (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(after - cur)) {
                var diffInterval = [];
                if ((0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(after - cur) === (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(range[1] - range[0])) {
                    sameDirectionCoord = after;
                    var curInRange = cur + range[1] - range[0];
                    diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                    diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                } else {
                    sameDirectionCoord = before;
                    var afterInRange = after + range[1] - range[0];
                    diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                    diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                }
                var sameInterval = [
                    Math.min(cur, (sameDirectionCoord + cur) / 2),
                    Math.max(cur, (sameDirectionCoord + cur) / 2)
                ];
                if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                    index = unsortedTicks[i].index;
                    break;
                }
            } else {
                var minValue = Math.min(before, after);
                var maxValue = Math.max(before, after);
                if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
                    index = unsortedTicks[i].index;
                    break;
                }
            }
        }
    } else {
        // ticks are distributed in a single direction
        for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
            index = ticks[_i].index;
            break;
        }
    }
    return index;
};
var $cd015374923bb5c7$export$ec6cab5a7a3b93bf = function getMainColorOfGraphicItem(item) {
    var _item$type;
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var defaultedProps = (_item$type = item.type) !== null && _item$type !== void 0 && _item$type.defaultProps ? $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var stroke = defaultedProps.stroke, fill = defaultedProps.fill;
    var result;
    switch(displayName){
        case 'Line':
            result = stroke;
            break;
        case 'Area':
        case 'Radar':
            result = stroke && stroke !== 'none' ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var $cd015374923bb5c7$export$570d306bee26c748 = function getBarSizeList(_ref2) {
    var globalSize = _ref2.barSize, totalSize = _ref2.totalSize, _ref2$stackGroups = _ref2.stackGroups, stackGroups = _ref2$stackGroups === void 0 ? {} : _ref2$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, $008f02516c156322$export$be63e0664592e141)(item.type).indexOf('Bar') >= 0;
            });
            if (barItems && barItems.length) {
                var barItemDefaultProps = barItems[0].type.defaultProps;
                var barItemProps = barItemDefaultProps !== undefined ? $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, barItemDefaultProps), barItems[0].props) : barItems[0].props;
                var selfSize = barItemProps.barSize;
                var cateId = barItemProps[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                var barSize = (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(selfSize) ? globalSize : selfSize;
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(barSize) ? undefined : (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(barSize, totalSize, 0)
                });
            }
        }
    }
    return result;
};
var $cd015374923bb5c7$export$d36834ecd87f906b = function getBarPosition(_ref3) {
    var barGap = _ref3.barGap, barCategoryGap = _ref3.barCategoryGap, bandSize = _ref3.bandSize, _ref3$sizeList = _ref3.sizeList, sizeList = _ref3$sizeList === void 0 ? [] : _ref3$sizeList, maxBarSize = _ref3.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(barGap, bandSize, 0, true);
    var result;
    var initialValue = [];
    // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        // @ts-expect-error the type check above does not check for type number explicitly
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newPosition = {
                item: entry.item,
                position: {
                    offset: prev.offset + prev.size + realBarGap,
                    // @ts-expect-error the type check above does not check for type number explicitly
                    size: useFull ? fullBarSize : entry.barSize
                }
            };
            var newRes = [].concat($cd015374923bb5c7$var$_toConsumableArray(res), [
                newPosition
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, initialValue);
    } else {
        var _offset = (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat($cd015374923bb5c7$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, initialValue);
    }
    return result;
};
var $cd015374923bb5c7$export$3a657a8c9f789617 = function appendOffsetOfLegend(offset, _unused, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0);
    var legendProps = (0, $3a45d033d706e33c$export$8f9424d123c36aa)({
        children: children,
        legendWidth: legendWidth
    });
    if (legendProps) {
        var _ref4 = legendBox || {}, boxWidth = _ref4.width, boxHeight = _ref4.height;
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'middle') && align !== 'center' && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(offset[align])) return $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, offset), {}, $cd015374923bb5c7$var$_defineProperty({}, align, offset[align] + (boxWidth || 0)));
        if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && verticalAlign !== 'middle' && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(offset[verticalAlign])) return $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, offset), {}, $cd015374923bb5c7$var$_defineProperty({}, verticalAlign, offset[verticalAlign] + (boxHeight || 0)));
    }
    return offset;
};
var $cd015374923bb5c7$var$isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(axisType)) return true;
    if (layout === 'horizontal') return axisType === 'yAxis';
    if (layout === 'vertical') return axisType === 'xAxis';
    if (direction === 'x') return axisType === 'xAxis';
    if (direction === 'y') return axisType === 'yAxis';
    return true;
};
var $cd015374923bb5c7$export$8a46d1a2b0f8e61a = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, $008f02516c156322$export$fdd5e64c0e8495bb)(children, (0, $7f4b989d0f2e91c6$export$4f4d7676bdf949e5)).filter(function(errorBarChild) {
        return $cd015374923bb5c7$var$isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = $cd015374923bb5c7$export$f97fc4a450f29a(entry, dataKey);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(entryValue)) return result;
            var mainValue = Array.isArray(entryValue) ? [
                (0, (/*@__PURE__*/$parcel$interopDefault($2c30ec7848ba160d$exports)))(entryValue),
                (0, (/*@__PURE__*/$parcel$interopDefault($7d231ba5a67a42db$exports)))(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = $cd015374923bb5c7$export$f97fc4a450f29a(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs(Array.isArray(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs(Array.isArray(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var $cd015374923bb5c7$export$2266342e22c737e8 = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return $cd015374923bb5c7$export$8a46d1a2b0f8e61a(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var $cd015374923bb5c7$export$c92c4f4286b1390d = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === 'number' && dataKey) return $cd015374923bb5c7$export$8a46d1a2b0f8e61a(data, item, dataKey, layout) || $cd015374923bb5c7$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
        return $cd015374923bb5c7$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
    });
    if (type === 'number') // Calculate the domain of number axis
    return domains.reduce(// @ts-expect-error if (type === number) means that the domain is numerical type
    // - but this link is missing in the type definition
    function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {};
    // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)// @ts-expect-error Date cannot index an object
        if (!tag[entry[i]]) {
            // @ts-expect-error Date cannot index an object
            tag[entry[i]] = true;
            // @ts-expect-error Date cannot index an object
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var $cd015374923bb5c7$export$9fc1baaa6c6368b = function isCategoricalAxis(layout, axisType) {
    return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
};
var $cd015374923bb5c7$export$846dc5ac5fecff74 = function getCoordinatesOfGrid(ticks, minValue, maxValue, syncWithTicks) {
    if (syncWithTicks) return ticks.map(function(entry) {
        return entry.coordinate;
    });
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var $cd015374923bb5c7$export$c829ee42daf7f66d = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === 'scaleBand' ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === 'angleAxis' && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) {
        var result = (axis.ticks || axis.niceTicks).map(function(entry) {
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter(function(row) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($10ed4ab35db4c025$exports)))(row.coordinate);
        });
    }
    // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} childHandler Handler function specified in child component
 * @return {Function}                The combined handler
 */ var $cd015374923bb5c7$var$handlerWeakMap = new WeakMap();
var $cd015374923bb5c7$export$760ec406ba47bace = function combineEventHandlers(defaultHandler, childHandler) {
    if (typeof childHandler !== 'function') return defaultHandler;
    if (!$cd015374923bb5c7$var$handlerWeakMap.has(defaultHandler)) $cd015374923bb5c7$var$handlerWeakMap.set(defaultHandler, new WeakMap());
    var childWeakMap = $cd015374923bb5c7$var$handlerWeakMap.get(defaultHandler);
    if (childWeakMap.has(childHandler)) return childWeakMap.get(childHandler);
    var combineHandler = function combineHandler() {
        defaultHandler.apply(void 0, arguments);
        childHandler.apply(void 0, arguments);
    };
    childWeakMap.set(childHandler, combineHandler);
    return combineHandler;
};
var $cd015374923bb5c7$export$534b094a708572c1 = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === 'auto') {
        if (layout === 'radial' && axisType === 'radiusAxis') return {
            scale: $d8f008d3b0c1a5c3$exports.scaleBand(),
            realScaleType: 'band'
        };
        if (layout === 'radial' && axisType === 'angleAxis') return {
            scale: $d8f008d3b0c1a5c3$exports.scaleLinear(),
            realScaleType: 'linear'
        };
        if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0 || chartType.indexOf('ComposedChart') >= 0 && !hasBar)) return {
            scale: $d8f008d3b0c1a5c3$exports.scalePoint(),
            realScaleType: 'point'
        };
        if (type === 'category') return {
            scale: $d8f008d3b0c1a5c3$exports.scaleBand(),
            realScaleType: 'band'
        };
        return {
            scale: $d8f008d3b0c1a5c3$exports.scaleLinear(),
            realScaleType: 'linear'
        };
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($15ee4628980e0994$exports)))(scale)) {
        var name = "scale".concat((0, (/*@__PURE__*/$parcel$interopDefault($da6130e1e4702e32$exports)))(scale));
        return {
            scale: ($d8f008d3b0c1a5c3$exports[name] || $d8f008d3b0c1a5c3$exports.scalePoint)(),
            realScaleType: $d8f008d3b0c1a5c3$exports[name] ? name : 'point'
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(scale) ? {
        scale: scale
    } : {
        scale: $d8f008d3b0c1a5c3$exports.scalePoint(),
        realScaleType: 'point'
    };
};
var $cd015374923bb5c7$var$EPS = 1e-4;
var $cd015374923bb5c7$export$9d80152e23bae434 = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var minValue = Math.min(range[0], range[1]) - $cd015374923bb5c7$var$EPS;
    var maxValue = Math.max(range[0], range[1]) + $cd015374923bb5c7$var$EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < minValue || first > maxValue || last < minValue || last > maxValue) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var $cd015374923bb5c7$export$778e70011fdf4625 = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var $cd015374923bb5c7$export$c7ec0fa96d0c462e = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(domain[0]) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var $cd015374923bb5c7$export$3104c513558164c1 = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($10ed4ab35db4c025$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
var $cd015374923bb5c7$export$9f2c6ead70935022 = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($10ed4ab35db4c025$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var $cd015374923bb5c7$var$STACK_OFFSET_MAP = {
    sign: $cd015374923bb5c7$export$3104c513558164c1,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, $9b23116271105198$exports.stackOffsetExpand),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, $9b23116271105198$exports.stackOffsetNone),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, $9b23116271105198$exports.stackOffsetSilhouette),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, $9b23116271105198$exports.stackOffsetWiggle),
    positive: $cd015374923bb5c7$export$9f2c6ead70935022
};
var $cd015374923bb5c7$export$c2170542cfc0177c = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var offsetAccessor = $cd015374923bb5c7$var$STACK_OFFSET_MAP[offsetType];
    var stack = (0, $9b23116271105198$exports.stack)()// @ts-expect-error stack.keys type wants an array of strings, but we provide array of DataKeys
    .keys(dataKeys).value(function(d, key) {
        return +$cd015374923bb5c7$export$f97fc4a450f29a(d, key, 0);
    }).order((0, $9b23116271105198$exports.stackOrderNone))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    return stack(data);
};
var $cd015374923bb5c7$export$9af3ba56474b9601 = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
    // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var parentStackGroupsInitialValue = {};
    var stackGroups = items.reduce(function(result, item) {
        var _item$type2;
        var defaultedProps = (_item$type2 = item.type) !== null && _item$type2 !== void 0 && _item$type2.defaultProps ? $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
        var stackId = defaultedProps.stackId, hide = defaultedProps.hide;
        if (hide) return result;
        var axisId = defaultedProps[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, $2ab3a7e25c8aba74$export$8b15d37bc3f197d4)('_stackId_')] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, result), {}, $cd015374923bb5c7$var$_defineProperty({}, axisId, parentGroup));
    }, parentStackGroupsInitialValue);
    var axisStackGroupsInitialValue = {};
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) {
            var stackGroupsInitialValue = {};
            group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
                var g = group.stackGroups[stackId];
                return $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, res), {}, $cd015374923bb5c7$var$_defineProperty({}, stackId, {
                    numericAxisId: numericAxisId,
                    cateAxisId: cateAxisId,
                    items: g.items,
                    stackedData: $cd015374923bb5c7$export$c2170542cfc0177c(data, g.items, offsetType)
                }));
            }, stackGroupsInitialValue);
        }
        return $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, result), {}, $cd015374923bb5c7$var$_defineProperty({}, axisId, group));
    }, axisStackGroupsInitialValue);
};
var $cd015374923bb5c7$export$ac086aaa4358d590 = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== 'auto' && scaleType !== 'linear') return null;
    if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, $83976b3dea6872a0$export$b84e75ccbfe6a612)(domain, tickCount, allowDecimals);
        scale.domain([
            (0, (/*@__PURE__*/$parcel$interopDefault($2c30ec7848ba160d$exports)))(tickValues),
            (0, (/*@__PURE__*/$parcel$interopDefault($7d231ba5a67a42db$exports)))(tickValues)
        ]);
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === 'number') {
        var _domain = scale.domain();
        var _tickValues = (0, $83976b3dea6872a0$export$e9d28da780436e98)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
function $cd015374923bb5c7$export$6e87f3defb83c3f(_ref5) {
    var axis = _ref5.axis, ticks = _ref5.ticks, bandSize = _ref5.bandSize, entry = _ref5.entry, index = _ref5.index, dataKey = _ref5.dataKey;
    if (axis.type === 'category') {
        // find coordinate of category axis by the value of category
        // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(entry[axis.dataKey])) {
            // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
            var matchedTick = (0, $2ab3a7e25c8aba74$export$66950d3869f5cc67)(ticks, 'value', entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $cd015374923bb5c7$export$f97fc4a450f29a(entry, !(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(dataKey) ? dataKey : axis.dataKey);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(value) ? axis.scale(value) : null;
}
var $cd015374923bb5c7$export$8abb9e87422f3a0c = function getCateCoordinateOfBar(_ref6) {
    var axis = _ref6.axis, ticks = _ref6.ticks, offset = _ref6.offset, bandSize = _ref6.bandSize, entry = _ref6.entry, index = _ref6.index;
    if (axis.type === 'category') return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = $cd015374923bb5c7$export$f97fc4a450f29a(entry, axis.dataKey, axis.domain[index]);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var $cd015374923bb5c7$export$54f3200dd4a8a235 = function getBaseValueOfBar(_ref7) {
    var numericAxis = _ref7.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var minValue = Math.min(domain[0], domain[1]);
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var $cd015374923bb5c7$export$a17bf3d98457878c = function getStackedDataOfItem(item, stackGroups) {
    var _item$type3;
    var defaultedProps = (_item$type3 = item.type) !== null && _item$type3 !== void 0 && _item$type3.defaultProps ? $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var stackId = defaultedProps.stackId;
    if ((0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(stackId)) {
        var group = stackGroups[stackId];
        if (group) {
            var itemIndex = group.items.indexOf(item);
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var $cd015374923bb5c7$var$getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($2c30ec7848ba160d$exports)))(entry.concat([
                result[0]
            ]).filter((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614))),
            (0, (/*@__PURE__*/$parcel$interopDefault($7d231ba5a67a42db$exports)))(entry.concat([
                result[1]
            ]).filter((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var $cd015374923bb5c7$export$26522b779eb5497c = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = $cd015374923bb5c7$var$getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var $cd015374923bb5c7$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $cd015374923bb5c7$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $cd015374923bb5c7$export$a0bc8660980558a0 = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!Array.isArray(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if ($cd015374923bb5c7$export$75a7b23ff266dfa1.test(specifiedDomain[0])) {
        var value = +$cd015374923bb5c7$export$75a7b23ff266dfa1.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if ($cd015374923bb5c7$export$19c111ec8ad6c644.test(specifiedDomain[1])) {
        var _value = +$cd015374923bb5c7$export$19c111ec8ad6c644.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var $cd015374923bb5c7$export$212ec45c42fe68a7 = function getBandSizeOfAxis(axis, ticks, isBar) {
    // @ts-expect-error we need to rethink scale type
    if (axis && axis.scale && axis.scale.bandwidth) {
        // @ts-expect-error we need to rethink scale type
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($300ea168693086c2$exports)))(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var $cd015374923bb5c7$export$c9a5230f0dda41bf = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($394ab417e9bd75cc$exports)))(specifiedDomain, (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(axisChild, 'type.defaultProps.domain'))) return calculatedDomain;
    return specifiedDomain;
};
var $cd015374923bb5c7$export$a4ea3faa19bc2d90 = function getTooltipItem(graphicalItem, payload) {
    var defaultedProps = graphicalItem.type.defaultProps ? $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, graphicalItem.type.defaultProps), graphicalItem.props) : graphicalItem.props;
    var dataKey = defaultedProps.dataKey, name = defaultedProps.name, unit = defaultedProps.unit, formatter = defaultedProps.formatter, tooltipType = defaultedProps.tooltipType, chartType = defaultedProps.chartType, hide = defaultedProps.hide;
    return $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, (0, $008f02516c156322$export$d697c39a2985a4c)(graphicalItem, false)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: $cd015374923bb5c7$export$ec6cab5a7a3b93bf(graphicalItem),
        value: $cd015374923bb5c7$export$f97fc4a450f29a(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType,
        hide: hide
    });
};


function $0f9bc5dd76ad1109$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0f9bc5dd76ad1109$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0f9bc5dd76ad1109$var$_typeof(o);
}
function $0f9bc5dd76ad1109$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0f9bc5dd76ad1109$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0f9bc5dd76ad1109$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0f9bc5dd76ad1109$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0f9bc5dd76ad1109$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0f9bc5dd76ad1109$var$_defineProperty(obj, key, value) {
    key = $0f9bc5dd76ad1109$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0f9bc5dd76ad1109$var$_toPropertyKey(t) {
    var i = $0f9bc5dd76ad1109$var$_toPrimitive(t, "string");
    return "symbol" == $0f9bc5dd76ad1109$var$_typeof(i) ? i : i + "";
}
function $0f9bc5dd76ad1109$var$_toPrimitive(t, r) {
    if ("object" != $0f9bc5dd76ad1109$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0f9bc5dd76ad1109$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0f9bc5dd76ad1109$var$_slicedToArray(arr, i) {
    return $0f9bc5dd76ad1109$var$_arrayWithHoles(arr) || $0f9bc5dd76ad1109$var$_iterableToArrayLimit(arr, i) || $0f9bc5dd76ad1109$var$_unsupportedIterableToArray(arr, i) || $0f9bc5dd76ad1109$var$_nonIterableRest();
}
function $0f9bc5dd76ad1109$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0f9bc5dd76ad1109$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0f9bc5dd76ad1109$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0f9bc5dd76ad1109$var$_arrayLikeToArray(o, minLen);
}
function $0f9bc5dd76ad1109$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0f9bc5dd76ad1109$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $0f9bc5dd76ad1109$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $0f9bc5dd76ad1109$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $0f9bc5dd76ad1109$export$4f2c4f194778dcbb = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var $0f9bc5dd76ad1109$export$1c20e104e3e29a0a = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var $0f9bc5dd76ad1109$export$5c9a959bb3fc7749 = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-$0f9bc5dd76ad1109$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$0f9bc5dd76ad1109$export$d74e8f7e9cc3fed3 * angle) * radius
    };
};
var $0f9bc5dd76ad1109$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $0f9bc5dd76ad1109$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(props.cx, width, width / 2);
    var cy = (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(props.cy, height, height / 2);
    var maxRadius = $0f9bc5dd76ad1109$export$ad5c48602371adfa(width, height, offset);
    var innerRadius = (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(axis.range)) {
            if (axisType === 'angleAxis') range = [
                startAngle,
                endAngle
            ];
            else if (axisType === 'radiusAxis') range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = $0f9bc5dd76ad1109$var$_slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, $cd015374923bb5c7$export$534b094a708572c1)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, $cd015374923bb5c7$export$9d80152e23bae434)(scale);
        var ticks = (0, $cd015374923bb5c7$export$ac086aaa4358d590)(scale, $0f9bc5dd76ad1109$var$_objectSpread($0f9bc5dd76ad1109$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = $0f9bc5dd76ad1109$var$_objectSpread($0f9bc5dd76ad1109$var$_objectSpread($0f9bc5dd76ad1109$var$_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return $0f9bc5dd76ad1109$var$_objectSpread($0f9bc5dd76ad1109$var$_objectSpread({}, result), {}, $0f9bc5dd76ad1109$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $0f9bc5dd76ad1109$export$b59117efbc9c7af = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var $0f9bc5dd76ad1109$export$bc42f851bd05a2ae = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = $0f9bc5dd76ad1109$export$b59117efbc9c7af({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $0f9bc5dd76ad1109$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $0f9bc5dd76ad1109$export$c8ca70209d427b81 = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $0f9bc5dd76ad1109$var$reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $0f9bc5dd76ad1109$export$e85a2bf8cd31c504 = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = $0f9bc5dd76ad1109$export$bc42f851bd05a2ae({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = $0f9bc5dd76ad1109$export$c8ca70209d427b81(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $0f9bc5dd76ad1109$var$_objectSpread($0f9bc5dd76ad1109$var$_objectSpread({}, sector), {}, {
        radius: radius,
        angle: $0f9bc5dd76ad1109$var$reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};
var $0f9bc5dd76ad1109$export$88d525dabc04abcd = function getTickClassName(tick) {
    return !/*#__PURE__*/ (0, $acw62.isValidElement)(tick) && !(0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(tick) && typeof tick !== 'boolean' ? tick.className : '';
};


function $77be8884b5ec622c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $77be8884b5ec622c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $77be8884b5ec622c$var$_typeof(o);
}
var $77be8884b5ec622c$var$_excluded = [
    "offset"
];
function $77be8884b5ec622c$var$_toConsumableArray(arr) {
    return $77be8884b5ec622c$var$_arrayWithoutHoles(arr) || $77be8884b5ec622c$var$_iterableToArray(arr) || $77be8884b5ec622c$var$_unsupportedIterableToArray(arr) || $77be8884b5ec622c$var$_nonIterableSpread();
}
function $77be8884b5ec622c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $77be8884b5ec622c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $77be8884b5ec622c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $77be8884b5ec622c$var$_arrayLikeToArray(o, minLen);
}
function $77be8884b5ec622c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $77be8884b5ec622c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $77be8884b5ec622c$var$_arrayLikeToArray(arr);
}
function $77be8884b5ec622c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $77be8884b5ec622c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $77be8884b5ec622c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $77be8884b5ec622c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $77be8884b5ec622c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $77be8884b5ec622c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $77be8884b5ec622c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $77be8884b5ec622c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $77be8884b5ec622c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $77be8884b5ec622c$var$_defineProperty(obj, key, value) {
    key = $77be8884b5ec622c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $77be8884b5ec622c$var$_toPropertyKey(t) {
    var i = $77be8884b5ec622c$var$_toPrimitive(t, "string");
    return "symbol" == $77be8884b5ec622c$var$_typeof(i) ? i : i + "";
}
function $77be8884b5ec622c$var$_toPrimitive(t, r) {
    if ("object" != $77be8884b5ec622c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $77be8884b5ec622c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $77be8884b5ec622c$var$_extends() {
    $77be8884b5ec622c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $77be8884b5ec622c$var$_extends.apply(this, arguments);
}
var $77be8884b5ec622c$var$getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(props.children) ? value : props.children;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(formatter)) return formatter(label);
    return label;
};
var $77be8884b5ec622c$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $77be8884b5ec622c$var$renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $77be8884b5ec622c$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === 'insideStart') {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === 'insideEnd') {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === 'end') {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle);
    var endPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(labelProps.id) ? (0, $2ab3a7e25c8aba74$export$8b15d37bc3f197d4)('recharts-radial-line-') : labelProps.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", $77be8884b5ec622c$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-radial-bar-label', className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $77be8884b5ec622c$var$getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === 'outside') {
        var _polarToCartesian = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? 'start' : 'end',
            verticalAnchor: 'middle'
        };
    }
    if (position === 'center') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
    if (position === 'centerTop') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'start'
    };
    if (position === 'centerBottom') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'end'
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
};
var $77be8884b5ec622c$var$getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height;
    // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? 'end' : 'start';
    var verticalStart = verticalSign > 0 ? 'start' : 'end';
    // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? 'end' : 'start';
    var horizontalStart = horizontalSign > 0 ? 'start' : 'end';
    if (position === 'top') {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: 'middle',
            verticalAnchor: verticalEnd
        };
        return $77be8884b5ec622c$var$_objectSpread($77be8884b5ec622c$var$_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === 'bottom') {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: 'middle',
            verticalAnchor: verticalStart
        };
        return $77be8884b5ec622c$var$_objectSpread($77be8884b5ec622c$var$_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === 'left') {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: 'middle'
        };
        return $77be8884b5ec622c$var$_objectSpread($77be8884b5ec622c$var$_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === 'right') {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: 'middle'
        };
        return $77be8884b5ec622c$var$_objectSpread($77be8884b5ec622c$var$_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === 'insideLeft') return $77be8884b5ec622c$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideRight') return $77be8884b5ec622c$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideTop') return $77be8884b5ec622c$var$_objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottom') return $77be8884b5ec622c$var$_objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideTopLeft') return $77be8884b5ec622c$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideTopRight') return $77be8884b5ec622c$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottomLeft') return $77be8884b5ec622c$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideBottomRight') return $77be8884b5ec622c$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f9ff2e983beb6b86$exports)))(position) && ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(position.x) || (0, $2ab3a7e25c8aba74$export$e50269385c77c348)(position.x)) && ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(position.y) || (0, $2ab3a7e25c8aba74$export$e50269385c77c348)(position.y))) return $77be8884b5ec622c$var$_objectSpread({
        x: x + (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(position.x, width),
        y: y + (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(position.y, height),
        textAnchor: 'end',
        verticalAnchor: 'end'
    }, sizeAttrs);
    return $77be8884b5ec622c$var$_objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    }, sizeAttrs);
};
var $77be8884b5ec622c$var$isPolar = function isPolar(viewBox) {
    return 'cx' in viewBox && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(viewBox.cx);
};
function $77be8884b5ec622c$export$b04be29aa201d4f5(_ref4) {
    var _ref4$offset = _ref4.offset, offset = _ref4$offset === void 0 ? 5 : _ref4$offset, restProps = $77be8884b5ec622c$var$_objectWithoutProperties(_ref4, $77be8884b5ec622c$var$_excluded);
    var props = $77be8884b5ec622c$var$_objectSpread({
        offset: offset
    }, restProps);
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(value) && (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(children) && !/*#__PURE__*/ (0, $acw62.isValidElement)(content) && !(0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(content)) return null;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(content)) return /*#__PURE__*/ (0, $acw62.cloneElement)(content, props);
    var label;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(content)) {
        label = /*#__PURE__*/ (0, $acw62.createElement)(content, props);
        if (/*#__PURE__*/ (0, $acw62.isValidElement)(label)) return label;
    } else label = $77be8884b5ec622c$var$getLabel(props);
    var isPolarLabel = $77be8884b5ec622c$var$isPolar(viewBox);
    var attrs = (0, $008f02516c156322$export$d697c39a2985a4c)(props, true);
    if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) return $77be8884b5ec622c$var$renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? $77be8884b5ec622c$var$getAttrsOfPolarLabel(props) : $77be8884b5ec622c$var$getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $964be52cc11879b4$export$5f1af8db9871e1d6), $77be8884b5ec622c$var$_extends({
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-label', className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
$77be8884b5ec622c$export$b04be29aa201d4f5.displayName = 'Label';
var $77be8884b5ec622c$var$parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(width) && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(height)) {
        if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(x) && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(top) && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(x) && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(cx) && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var $77be8884b5ec622c$var$parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77be8884b5ec622c$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77be8884b5ec622c$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(label)) {
        if (label.type === $77be8884b5ec622c$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $acw62.cloneElement)(label, {
            key: 'label-implicit',
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77be8884b5ec622c$export$b04be29aa201d4f5, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77be8884b5ec622c$export$b04be29aa201d4f5, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f9ff2e983beb6b86$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77be8884b5ec622c$export$b04be29aa201d4f5, $77be8884b5ec622c$var$_extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var $77be8884b5ec622c$var$renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = $77be8884b5ec622c$var$parseViewBox(parentProps);
    var explicitChildren = (0, $008f02516c156322$export$fdd5e64c0e8495bb)(children, $77be8884b5ec622c$export$b04be29aa201d4f5).map(function(child, index) {
        return /*#__PURE__*/ (0, $acw62.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            // eslint-disable-next-line react/no-array-index-key
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = $77be8884b5ec622c$var$parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat($77be8884b5ec622c$var$_toConsumableArray(explicitChildren));
};
$77be8884b5ec622c$export$b04be29aa201d4f5.parseViewBox = $77be8884b5ec622c$var$parseViewBox;
$77be8884b5ec622c$export$b04be29aa201d4f5.renderCallByParent = $77be8884b5ec622c$var$renderCallByParent;





function $88ab0dba0fc78576$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $88ab0dba0fc78576$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $88ab0dba0fc78576$var$_typeof(o);
}
var $88ab0dba0fc78576$var$_excluded = [
    "valueAccessor"
], $88ab0dba0fc78576$var$_excluded2 = [
    "data",
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll"
];
function $88ab0dba0fc78576$var$_toConsumableArray(arr) {
    return $88ab0dba0fc78576$var$_arrayWithoutHoles(arr) || $88ab0dba0fc78576$var$_iterableToArray(arr) || $88ab0dba0fc78576$var$_unsupportedIterableToArray(arr) || $88ab0dba0fc78576$var$_nonIterableSpread();
}
function $88ab0dba0fc78576$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $88ab0dba0fc78576$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $88ab0dba0fc78576$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $88ab0dba0fc78576$var$_arrayLikeToArray(o, minLen);
}
function $88ab0dba0fc78576$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $88ab0dba0fc78576$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $88ab0dba0fc78576$var$_arrayLikeToArray(arr);
}
function $88ab0dba0fc78576$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $88ab0dba0fc78576$var$_extends() {
    $88ab0dba0fc78576$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $88ab0dba0fc78576$var$_extends.apply(this, arguments);
}
function $88ab0dba0fc78576$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $88ab0dba0fc78576$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $88ab0dba0fc78576$var$ownKeys(Object(t), !0).forEach(function(r) {
            $88ab0dba0fc78576$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $88ab0dba0fc78576$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $88ab0dba0fc78576$var$_defineProperty(obj, key, value) {
    key = $88ab0dba0fc78576$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $88ab0dba0fc78576$var$_toPropertyKey(t) {
    var i = $88ab0dba0fc78576$var$_toPrimitive(t, "string");
    return "symbol" == $88ab0dba0fc78576$var$_typeof(i) ? i : i + "";
}
function $88ab0dba0fc78576$var$_toPrimitive(t, r) {
    if ("object" != $88ab0dba0fc78576$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $88ab0dba0fc78576$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $88ab0dba0fc78576$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $88ab0dba0fc78576$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $88ab0dba0fc78576$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $88ab0dba0fc78576$var$defaultAccessor = function defaultAccessor(entry) {
    return Array.isArray(entry.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($c9d0ae50fd1d1372$exports)))(entry.value) : entry.value;
};
function $88ab0dba0fc78576$export$835fcf23ab7bf88(_ref) {
    var _ref$valueAccessor = _ref.valueAccessor, valueAccessor = _ref$valueAccessor === void 0 ? $88ab0dba0fc78576$var$defaultAccessor : _ref$valueAccessor, restProps = $88ab0dba0fc78576$var$_objectWithoutProperties(_ref, $88ab0dba0fc78576$var$_excluded);
    var data = restProps.data, dataKey = restProps.dataKey, clockWise = restProps.clockWise, id = restProps.id, textBreakAll = restProps.textBreakAll, others = $88ab0dba0fc78576$var$_objectWithoutProperties(restProps, $88ab0dba0fc78576$var$_excluded2);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(dataKey) ? valueAccessor(entry, index) : (0, $cd015374923bb5c7$export$f97fc4a450f29a)(entry && entry.payload, dataKey);
        var idProps = (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $77be8884b5ec622c$export$b04be29aa201d4f5), $88ab0dba0fc78576$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, $77be8884b5ec622c$export$b04be29aa201d4f5).parseViewBox((0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(clockWise) ? entry : $88ab0dba0fc78576$var$_objectSpread($88ab0dba0fc78576$var$_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
            ,
            index: index
        }));
    }));
}
$88ab0dba0fc78576$export$835fcf23ab7bf88.displayName = 'LabelList';
function $88ab0dba0fc78576$var$parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($88ab0dba0fc78576$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(label) || (0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($88ab0dba0fc78576$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f9ff2e983beb6b86$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($88ab0dba0fc78576$export$835fcf23ab7bf88, $88ab0dba0fc78576$var$_extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function $88ab0dba0fc78576$var$renderCallByParent(parentProps, data) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChildren = (0, $008f02516c156322$export$fdd5e64c0e8495bb)(children, $88ab0dba0fc78576$export$835fcf23ab7bf88).map(function(child, index) {
        return /*#__PURE__*/ (0, $acw62.cloneElement)(child, {
            data: data,
            // eslint-disable-next-line react/no-array-index-key
            key: "labelList-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabelList = $88ab0dba0fc78576$var$parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat($88ab0dba0fc78576$var$_toConsumableArray(explicitChildren));
}
$88ab0dba0fc78576$export$835fcf23ab7bf88.renderCallByParent = $88ab0dba0fc78576$var$renderCallByParent;








var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $0658be17f7793a43$exports = {};

var $8e492c1d7a7ea307$exports = {};

/** Built-in value references. */ var $8e492c1d7a7ea307$var$getPrototype = $ff813e49bf3cca3d$exports(Object.getPrototypeOf, Object);
$8e492c1d7a7ea307$exports = $8e492c1d7a7ea307$var$getPrototype;



/** `Object#toString` result references. */ var $0658be17f7793a43$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $0658be17f7793a43$var$funcProto = Function.prototype, $0658be17f7793a43$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0658be17f7793a43$var$funcToString = $0658be17f7793a43$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0658be17f7793a43$var$hasOwnProperty = $0658be17f7793a43$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $0658be17f7793a43$var$objectCtorString = $0658be17f7793a43$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $0658be17f7793a43$var$isPlainObject(value) {
    if (!$61269cf1f3e020be$exports(value) || $a7f8a2555793d7d3$exports(value) != $0658be17f7793a43$var$objectTag) return false;
    var proto = $8e492c1d7a7ea307$exports(value);
    if (proto === null) return true;
    var Ctor = $0658be17f7793a43$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $0658be17f7793a43$var$funcToString.call(Ctor) == $0658be17f7793a43$var$objectCtorString;
}
$0658be17f7793a43$exports = $0658be17f7793a43$var$isPlainObject;


var $726b932117967293$exports = {};


/** `Object#toString` result references. */ var $726b932117967293$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $726b932117967293$var$isBoolean(value) {
    return value === true || value === false || $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $726b932117967293$var$boolTag;
}
$726b932117967293$exports = $726b932117967293$var$isBoolean;




var $acw62 = parcelRequire("acw62");



function $70f75e095c9bb92d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $70f75e095c9bb92d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $70f75e095c9bb92d$var$_typeof(o);
}
function $70f75e095c9bb92d$var$_extends() {
    $70f75e095c9bb92d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $70f75e095c9bb92d$var$_extends.apply(this, arguments);
}
function $70f75e095c9bb92d$var$_slicedToArray(arr, i) {
    return $70f75e095c9bb92d$var$_arrayWithHoles(arr) || $70f75e095c9bb92d$var$_iterableToArrayLimit(arr, i) || $70f75e095c9bb92d$var$_unsupportedIterableToArray(arr, i) || $70f75e095c9bb92d$var$_nonIterableRest();
}
function $70f75e095c9bb92d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $70f75e095c9bb92d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $70f75e095c9bb92d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $70f75e095c9bb92d$var$_arrayLikeToArray(o, minLen);
}
function $70f75e095c9bb92d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $70f75e095c9bb92d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $70f75e095c9bb92d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $70f75e095c9bb92d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $70f75e095c9bb92d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $70f75e095c9bb92d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $70f75e095c9bb92d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $70f75e095c9bb92d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $70f75e095c9bb92d$var$_defineProperty(obj, key, value) {
    key = $70f75e095c9bb92d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $70f75e095c9bb92d$var$_toPropertyKey(t) {
    var i = $70f75e095c9bb92d$var$_toPrimitive(t, "string");
    return "symbol" == $70f75e095c9bb92d$var$_typeof(i) ? i : i + "";
}
function $70f75e095c9bb92d$var$_toPrimitive(t, r) {
    if ("object" != $70f75e095c9bb92d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $70f75e095c9bb92d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $70f75e095c9bb92d$var$getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += 'Z';
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var $70f75e095c9bb92d$export$f783d19325be51d5 = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var $70f75e095c9bb92d$var$defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $70f75e095c9bb92d$export$4617fb02663045ef = function Rectangle(rectangleProps) {
    var props = $70f75e095c9bb92d$var$_objectSpread($70f75e095c9bb92d$var$_objectSpread({}, $70f75e095c9bb92d$var$defaultProps), rectangleProps);
    var pathRef = (0, $acw62.useRef)();
    var _useState = (0, $acw62.useState)(-1), _useState2 = $70f75e095c9bb92d$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $acw62.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = props.x, y = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
    var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-rectangle', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", $70f75e095c9bb92d$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: $70f75e095c9bb92d$var$getRectanglePath(x, y, width, height, radius)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $324cdcf3b9db18d1$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        to: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $324cdcf3b9db18d1$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", $70f75e095c9bb92d$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(props, true), {
            className: layerClass,
            d: $70f75e095c9bb92d$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef
        })));
    });
};



var $acw62 = parcelRequire("acw62");



function $b0f8b4122c292e26$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b0f8b4122c292e26$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b0f8b4122c292e26$var$_typeof(o);
}
function $b0f8b4122c292e26$var$_extends() {
    $b0f8b4122c292e26$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b0f8b4122c292e26$var$_extends.apply(this, arguments);
}
function $b0f8b4122c292e26$var$_slicedToArray(arr, i) {
    return $b0f8b4122c292e26$var$_arrayWithHoles(arr) || $b0f8b4122c292e26$var$_iterableToArrayLimit(arr, i) || $b0f8b4122c292e26$var$_unsupportedIterableToArray(arr, i) || $b0f8b4122c292e26$var$_nonIterableRest();
}
function $b0f8b4122c292e26$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b0f8b4122c292e26$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b0f8b4122c292e26$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b0f8b4122c292e26$var$_arrayLikeToArray(o, minLen);
}
function $b0f8b4122c292e26$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b0f8b4122c292e26$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $b0f8b4122c292e26$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b0f8b4122c292e26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b0f8b4122c292e26$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b0f8b4122c292e26$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b0f8b4122c292e26$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b0f8b4122c292e26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b0f8b4122c292e26$var$_defineProperty(obj, key, value) {
    key = $b0f8b4122c292e26$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b0f8b4122c292e26$var$_toPropertyKey(t) {
    var i = $b0f8b4122c292e26$var$_toPrimitive(t, "string");
    return "symbol" == $b0f8b4122c292e26$var$_typeof(i) ? i : i + "";
}
function $b0f8b4122c292e26$var$_toPrimitive(t, r) {
    if ("object" != $b0f8b4122c292e26$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b0f8b4122c292e26$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $b0f8b4122c292e26$var$getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
    var widthGap = upperWidth - lowerWidth;
    var path;
    path = "M ".concat(x, ",").concat(y);
    path += "L ".concat(x + upperWidth, ",").concat(y);
    path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
    path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
    path += "L ".concat(x, ",").concat(y, " Z");
    return path;
};
var $b0f8b4122c292e26$var$defaultProps = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $b0f8b4122c292e26$export$d1ed33dc592f5337 = function Trapezoid(props) {
    var trapezoidProps = $b0f8b4122c292e26$var$_objectSpread($b0f8b4122c292e26$var$_objectSpread({}, $b0f8b4122c292e26$var$defaultProps), props);
    var pathRef = (0, $acw62.useRef)();
    var _useState = (0, $acw62.useState)(-1), _useState2 = $b0f8b4122c292e26$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $acw62.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = trapezoidProps.x, y = trapezoidProps.y, upperWidth = trapezoidProps.upperWidth, lowerWidth = trapezoidProps.lowerWidth, height = trapezoidProps.height, className = trapezoidProps.className;
    var animationEasing = trapezoidProps.animationEasing, animationDuration = trapezoidProps.animationDuration, animationBegin = trapezoidProps.animationBegin, isUpdateAnimationActive = trapezoidProps.isUpdateAnimationActive;
    if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) return null;
    var layerClass = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-trapezoid', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", $b0f8b4122c292e26$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(trapezoidProps, true), {
        className: layerClass,
        d: $b0f8b4122c292e26$var$getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $324cdcf3b9db18d1$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            upperWidth: 0,
            lowerWidth: 0,
            height: height,
            x: x,
            y: y
        },
        to: {
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currUpperWidth = _ref.upperWidth, currLowerWidth = _ref.lowerWidth, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $324cdcf3b9db18d1$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", $b0f8b4122c292e26$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(trapezoidProps, true), {
            className: layerClass,
            d: $b0f8b4122c292e26$var$getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
            ref: pathRef
        })));
    });
};



var $acw62 = parcelRequire("acw62");




function $353ca4069312fa59$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $353ca4069312fa59$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $353ca4069312fa59$var$_typeof(o);
}
function $353ca4069312fa59$var$_extends() {
    $353ca4069312fa59$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $353ca4069312fa59$var$_extends.apply(this, arguments);
}
function $353ca4069312fa59$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $353ca4069312fa59$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $353ca4069312fa59$var$ownKeys(Object(t), !0).forEach(function(r) {
            $353ca4069312fa59$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $353ca4069312fa59$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $353ca4069312fa59$var$_defineProperty(obj, key, value) {
    key = $353ca4069312fa59$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $353ca4069312fa59$var$_toPropertyKey(t) {
    var i = $353ca4069312fa59$var$_toPrimitive(t, "string");
    return "symbol" == $353ca4069312fa59$var$_typeof(i) ? i : i + "";
}
function $353ca4069312fa59$var$_toPrimitive(t, r) {
    if ("object" != $353ca4069312fa59$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $353ca4069312fa59$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $353ca4069312fa59$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $353ca4069312fa59$var$getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $0f9bc5dd76ad1109$export$d74e8f7e9cc3fed3);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, centerRadius * Math.cos(theta * (0, $0f9bc5dd76ad1109$export$d74e8f7e9cc3fed3)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $353ca4069312fa59$var$getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = $353ca4069312fa59$var$getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var $353ca4069312fa59$var$getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(endAngle - startAngle);
    var _getTangentCircle = $353ca4069312fa59$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = $353ca4069312fa59$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return $353ca4069312fa59$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = $353ca4069312fa59$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = $353ca4069312fa59$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var $353ca4069312fa59$var$defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var $353ca4069312fa59$export$e98c2c7eb2b14f45 = function Sector(sectorProps) {
    var props = $353ca4069312fa59$var$_objectSpread($353ca4069312fa59$var$_objectSpread({}, $353ca4069312fa59$var$defaultProps), sectorProps);
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-sector', className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $353ca4069312fa59$var$getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = $353ca4069312fa59$var$getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", $353ca4069312fa59$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: path,
        role: "img"
    }));
};




var $4696e249b64cd95e$var$_excluded = [
    "option",
    "shapeType",
    "propTransformer",
    "activeClassName",
    "isActive"
];
function $4696e249b64cd95e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4696e249b64cd95e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4696e249b64cd95e$var$_typeof(o);
}
function $4696e249b64cd95e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4696e249b64cd95e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4696e249b64cd95e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4696e249b64cd95e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4696e249b64cd95e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4696e249b64cd95e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4696e249b64cd95e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4696e249b64cd95e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4696e249b64cd95e$var$_defineProperty(obj, key, value) {
    key = $4696e249b64cd95e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4696e249b64cd95e$var$_toPropertyKey(t) {
    var i = $4696e249b64cd95e$var$_toPrimitive(t, "string");
    return "symbol" == $4696e249b64cd95e$var$_typeof(i) ? i : i + "";
}
function $4696e249b64cd95e$var$_toPrimitive(t, r) {
    if ("object" != $4696e249b64cd95e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4696e249b64cd95e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a react element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */ function $4696e249b64cd95e$var$defaultPropTransformer(option, props) {
    return $4696e249b64cd95e$var$_objectSpread($4696e249b64cd95e$var$_objectSpread({}, props), option);
}
function $4696e249b64cd95e$var$isSymbolsProps(shapeType, _elementProps) {
    return shapeType === 'symbols';
}
function $4696e249b64cd95e$var$ShapeSelector(_ref) {
    var shapeType = _ref.shapeType, elementProps = _ref.elementProps;
    switch(shapeType){
        case 'rectangle':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $70f75e095c9bb92d$export$4617fb02663045ef), elementProps);
        case 'trapezoid':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b0f8b4122c292e26$export$d1ed33dc592f5337), elementProps);
        case 'sector':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $353ca4069312fa59$export$e98c2c7eb2b14f45), elementProps);
        case 'symbols':
            if ($4696e249b64cd95e$var$isSymbolsProps(shapeType, elementProps)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $61aa615b92178b76$export$fa456266707bf4e4), elementProps);
            break;
        default:
            return null;
    }
}
function $4696e249b64cd95e$export$33c4f706a443da24(option) {
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(option)) return option.props;
    return option;
}
function $4696e249b64cd95e$export$6428a7f2611ef1fa(_ref2) {
    var option = _ref2.option, shapeType = _ref2.shapeType, _ref2$propTransformer = _ref2.propTransformer, propTransformer = _ref2$propTransformer === void 0 ? $4696e249b64cd95e$var$defaultPropTransformer : _ref2$propTransformer, _ref2$activeClassName = _ref2.activeClassName, activeClassName = _ref2$activeClassName === void 0 ? 'recharts-active-shape' : _ref2$activeClassName, isActive = _ref2.isActive, props = $4696e249b64cd95e$var$_objectWithoutProperties(_ref2, $4696e249b64cd95e$var$_excluded);
    var shape;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(option)) shape = /*#__PURE__*/ (0, $acw62.cloneElement)(option, $4696e249b64cd95e$var$_objectSpread($4696e249b64cd95e$var$_objectSpread({}, props), $4696e249b64cd95e$export$33c4f706a443da24(option)));
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(option)) shape = option(props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($0658be17f7793a43$exports)))(option) && !(0, (/*@__PURE__*/$parcel$interopDefault($726b932117967293$exports)))(option)) {
        var nextProps = propTransformer(option, props);
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4696e249b64cd95e$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: nextProps
        });
    } else {
        var elementProps = props;
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4696e249b64cd95e$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: elementProps
        });
    }
    if (isActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
        className: activeClassName
    }, shape);
    return shape;
}
function $4696e249b64cd95e$export$4b83e8415af38a18(graphicalItem, _item) {
    return _item != null && 'trapezoids' in graphicalItem.props;
}
function $4696e249b64cd95e$export$f722d7e63cc07b(graphicalItem, _item) {
    return _item != null && 'sectors' in graphicalItem.props;
}
function $4696e249b64cd95e$export$f62b21bcfd1a733e(graphicalItem, _item) {
    return _item != null && 'points' in graphicalItem.props;
}
function $4696e249b64cd95e$export$7c9a98b3f068686f(shapeData, activeTooltipItem) {
    var _activeTooltipItem$la, _activeTooltipItem$la2;
    var xMatches = shapeData.x === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la === void 0 ? void 0 : _activeTooltipItem$la.x) || shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la2 = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la2 === void 0 ? void 0 : _activeTooltipItem$la2.y) || shapeData.y === activeTooltipItem.y;
    return xMatches && yMatches;
}
function $4696e249b64cd95e$export$b356b51e8337a02f(shapeData, activeTooltipItem) {
    var startAngleMatches = shapeData.endAngle === activeTooltipItem.endAngle;
    var endAngleMatches = shapeData.startAngle === activeTooltipItem.startAngle;
    return startAngleMatches && endAngleMatches;
}
function $4696e249b64cd95e$export$559c3a78b4889350(shapeData, activeTooltipItem) {
    var xMatches = shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === activeTooltipItem.y;
    var zMatches = shapeData.z === activeTooltipItem.z;
    return xMatches && yMatches && zMatches;
}
function $4696e249b64cd95e$var$getComparisonFn(graphicalItem, activeItem) {
    var comparison;
    if ($4696e249b64cd95e$export$4b83e8415af38a18(graphicalItem, activeItem)) comparison = $4696e249b64cd95e$export$7c9a98b3f068686f;
    else if ($4696e249b64cd95e$export$f722d7e63cc07b(graphicalItem, activeItem)) comparison = $4696e249b64cd95e$export$b356b51e8337a02f;
    else if ($4696e249b64cd95e$export$f62b21bcfd1a733e(graphicalItem, activeItem)) comparison = $4696e249b64cd95e$export$559c3a78b4889350;
    return comparison;
}
function $4696e249b64cd95e$var$getShapeDataKey(graphicalItem, activeItem) {
    var shapeKey;
    if ($4696e249b64cd95e$export$4b83e8415af38a18(graphicalItem, activeItem)) shapeKey = 'trapezoids';
    else if ($4696e249b64cd95e$export$f722d7e63cc07b(graphicalItem, activeItem)) shapeKey = 'sectors';
    else if ($4696e249b64cd95e$export$f62b21bcfd1a733e(graphicalItem, activeItem)) shapeKey = 'points';
    return shapeKey;
}
function $4696e249b64cd95e$var$getActiveShapeTooltipPayload(graphicalItem, activeItem) {
    if ($4696e249b64cd95e$export$4b83e8415af38a18(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa;
        return (_activeItem$tooltipPa = activeItem.tooltipPayload) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa[0]) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa.payload) === null || _activeItem$tooltipPa === void 0 ? void 0 : _activeItem$tooltipPa.payload;
    }
    if ($4696e249b64cd95e$export$f722d7e63cc07b(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa2;
        return (_activeItem$tooltipPa2 = activeItem.tooltipPayload) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2[0]) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2.payload) === null || _activeItem$tooltipPa2 === void 0 ? void 0 : _activeItem$tooltipPa2.payload;
    }
    if ($4696e249b64cd95e$export$f62b21bcfd1a733e(graphicalItem, activeItem)) return activeItem.payload;
    return {};
}
function $4696e249b64cd95e$export$bd5d63c57ca4468(_ref3) {
    var activeTooltipItem = _ref3.activeTooltipItem, graphicalItem = _ref3.graphicalItem, itemData = _ref3.itemData;
    var shapeKey = $4696e249b64cd95e$var$getShapeDataKey(graphicalItem, activeTooltipItem);
    var tooltipPayload = $4696e249b64cd95e$var$getActiveShapeTooltipPayload(graphicalItem, activeTooltipItem);
    var activeItemMatches = itemData.filter(function(datum, dataIndex) {
        var valuesMatch = (0, (/*@__PURE__*/$parcel$interopDefault($394ab417e9bd75cc$exports)))(tooltipPayload, datum);
        var mouseCoordinateMatches = graphicalItem.props[shapeKey].filter(function(shapeData) {
            var comparison = $4696e249b64cd95e$var$getComparisonFn(graphicalItem, activeTooltipItem);
            return comparison(shapeData, activeTooltipItem);
        });
        // get the last index in case of multiple matches
        var indexOfMouseCoordinates = graphicalItem.props[shapeKey].indexOf(mouseCoordinateMatches[mouseCoordinateMatches.length - 1]);
        var coordinatesMatch = dataIndex === indexOfMouseCoordinates;
        return valuesMatch && coordinatesMatch;
    });
    // get the last index in case of multiple matches
    var activeIndex = itemData.indexOf(activeItemMatches[activeItemMatches.length - 1]);
    return activeIndex;
}



var $b5efd6b8794dbdeb$var$_excluded = [
    "x",
    "y"
];
function $b5efd6b8794dbdeb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b5efd6b8794dbdeb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b5efd6b8794dbdeb$var$_typeof(o);
}
function $b5efd6b8794dbdeb$var$_extends() {
    $b5efd6b8794dbdeb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b5efd6b8794dbdeb$var$_extends.apply(this, arguments);
}
function $b5efd6b8794dbdeb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b5efd6b8794dbdeb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b5efd6b8794dbdeb$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b5efd6b8794dbdeb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b5efd6b8794dbdeb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b5efd6b8794dbdeb$var$_defineProperty(obj, key, value) {
    key = $b5efd6b8794dbdeb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b5efd6b8794dbdeb$var$_toPropertyKey(t) {
    var i = $b5efd6b8794dbdeb$var$_toPrimitive(t, "string");
    return "symbol" == $b5efd6b8794dbdeb$var$_typeof(i) ? i : i + "";
}
function $b5efd6b8794dbdeb$var$_toPrimitive(t, r) {
    if ("object" != $b5efd6b8794dbdeb$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b5efd6b8794dbdeb$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b5efd6b8794dbdeb$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b5efd6b8794dbdeb$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b5efd6b8794dbdeb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Rectangle props is expecting x, y, height, width as numbers, name as a string, and radius as a custom type
// When props are being spread in from a user defined component in Bar,
// the prop types of an SVGElement have these typed as something else.
// This function will return the passed in props
// along with x, y, height as numbers, name as a string, and radius as number | [number, number, number, number]
function $b5efd6b8794dbdeb$var$typeguardBarRectangleProps(_ref, props) {
    var xProp = _ref.x, yProp = _ref.y, option = $b5efd6b8794dbdeb$var$_objectWithoutProperties(_ref, $b5efd6b8794dbdeb$var$_excluded);
    var xValue = "".concat(xProp);
    var x = parseInt(xValue, 10);
    var yValue = "".concat(yProp);
    var y = parseInt(yValue, 10);
    var heightValue = "".concat(props.height || option.height);
    var height = parseInt(heightValue, 10);
    var widthValue = "".concat(props.width || option.width);
    var width = parseInt(widthValue, 10);
    return $b5efd6b8794dbdeb$var$_objectSpread($b5efd6b8794dbdeb$var$_objectSpread($b5efd6b8794dbdeb$var$_objectSpread($b5efd6b8794dbdeb$var$_objectSpread($b5efd6b8794dbdeb$var$_objectSpread({}, props), option), x ? {
        x: x
    } : {}), y ? {
        y: y
    } : {}), {}, {
        height: height,
        width: width,
        name: props.name,
        radius: props.radius
    });
}
function $b5efd6b8794dbdeb$export$f19074a6842f9217(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4696e249b64cd95e$export$6428a7f2611ef1fa), $b5efd6b8794dbdeb$var$_extends({
        shapeType: "rectangle",
        propTransformer: $b5efd6b8794dbdeb$var$typeguardBarRectangleProps,
        activeClassName: "recharts-active-bar"
    }, props));
}
var $b5efd6b8794dbdeb$export$c20d73790de171f0 = function minPointSizeCallback(minPointSize) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return function(value, index) {
        if (typeof minPointSize === 'number') return minPointSize;
        var isValueNumberOrNil = (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(value) || (0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(value);
        if (isValueNumberOrNil) return minPointSize(value, index);
        !isValueNumberOrNil && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
        return defaultValue;
    };
};


var $e752e700473a8894$var$_excluded = [
    "value",
    "background"
];
var $e752e700473a8894$var$_Bar;
function $e752e700473a8894$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e752e700473a8894$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e752e700473a8894$var$_typeof(o);
}
function $e752e700473a8894$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e752e700473a8894$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e752e700473a8894$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e752e700473a8894$var$_extends() {
    $e752e700473a8894$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e752e700473a8894$var$_extends.apply(this, arguments);
}
function $e752e700473a8894$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e752e700473a8894$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e752e700473a8894$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e752e700473a8894$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e752e700473a8894$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e752e700473a8894$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e752e700473a8894$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e752e700473a8894$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e752e700473a8894$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e752e700473a8894$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e752e700473a8894$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e752e700473a8894$var$_callSuper(t, o, e) {
    return o = $e752e700473a8894$var$_getPrototypeOf(o), $e752e700473a8894$var$_possibleConstructorReturn(t, $e752e700473a8894$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $e752e700473a8894$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $e752e700473a8894$var$_possibleConstructorReturn(self, call) {
    if (call && ($e752e700473a8894$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $e752e700473a8894$var$_assertThisInitialized(self);
}
function $e752e700473a8894$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e752e700473a8894$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e752e700473a8894$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $e752e700473a8894$var$_getPrototypeOf(o) {
    $e752e700473a8894$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e752e700473a8894$var$_getPrototypeOf(o);
}
function $e752e700473a8894$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $e752e700473a8894$var$_setPrototypeOf(subClass, superClass);
}
function $e752e700473a8894$var$_setPrototypeOf(o, p) {
    $e752e700473a8894$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e752e700473a8894$var$_setPrototypeOf(o, p);
}
function $e752e700473a8894$var$_defineProperty(obj, key, value) {
    key = $e752e700473a8894$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e752e700473a8894$var$_toPropertyKey(t) {
    var i = $e752e700473a8894$var$_toPrimitive(t, "string");
    return "symbol" == $e752e700473a8894$var$_typeof(i) ? i : i + "";
}
function $e752e700473a8894$var$_toPrimitive(t, r) {
    if ("object" != $e752e700473a8894$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e752e700473a8894$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $e752e700473a8894$export$bbc6c6369b38e3d1 = /*#__PURE__*/ function(_PureComponent) {
    function Bar() {
        var _this;
        $e752e700473a8894$var$_classCallCheck(this, Bar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $e752e700473a8894$var$_callSuper(this, Bar, [].concat(args));
        $e752e700473a8894$var$_defineProperty(_this, "state", {
            isAnimationFinished: false
        });
        $e752e700473a8894$var$_defineProperty(_this, "id", (0, $2ab3a7e25c8aba74$export$8b15d37bc3f197d4)('recharts-bar-'));
        $e752e700473a8894$var$_defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if (onAnimationEnd) onAnimationEnd();
        });
        $e752e700473a8894$var$_defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if (onAnimationStart) onAnimationStart();
        });
        return _this;
    }
    $e752e700473a8894$var$_inherits(Bar, _PureComponent);
    return $e752e700473a8894$var$_createClass(Bar, [
        {
            key: "renderRectanglesStatically",
            value: function renderRectanglesStatically(data) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, dataKey = _this$props.dataKey, activeIndex = _this$props.activeIndex, activeBar = _this$props.activeBar;
                var baseProps = (0, $008f02516c156322$export$d697c39a2985a4c)(this.props, false);
                return data && data.map(function(entry, i) {
                    var isActive = i === activeIndex;
                    var option = isActive ? activeBar : shape;
                    var props = $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, baseProps), entry), {}, {
                        isActive: isActive,
                        option: option,
                        index: i,
                        dataKey: dataKey,
                        onAnimationStart: _this2.handleAnimationStart,
                        onAnimationEnd: _this2.handleAnimationEnd
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), $e752e700473a8894$var$_extends({
                        className: "recharts-bar-rectangle"
                    }, (0, $909d5f835f4e917b$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        // https://github.com/recharts/recharts/issues/5415
                        // eslint-disable-next-line react/no-array-index-key
                        key: "rectangle-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value, "-").concat(i)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b5efd6b8794dbdeb$export$f19074a6842f9217), props));
                });
            }
        },
        {
            key: "renderRectanglesWithAnimation",
            value: function renderRectanglesWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, data = _this$props2.data, layout = _this$props2.layout, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevData = this.state.prevData;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $324cdcf3b9db18d1$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "bar-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = data.map(function(entry, index) {
                        var prev = prevData && prevData[index];
                        if (prev) {
                            var interpolatorX = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(prev.x, entry.x);
                            var interpolatorY = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(prev.y, entry.y);
                            var interpolatorWidth = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(prev.width, entry.width);
                            var interpolatorHeight = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(prev.height, entry.height);
                            return $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, entry), {}, {
                                x: interpolatorX(t),
                                y: interpolatorY(t),
                                width: interpolatorWidth(t),
                                height: interpolatorHeight(t)
                            });
                        }
                        if (layout === 'horizontal') {
                            var _interpolatorHeight = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(0, entry.height);
                            var h = _interpolatorHeight(t);
                            return $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, entry), {}, {
                                y: entry.y + entry.height - h,
                                height: h
                            });
                        }
                        var interpolator = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(0, entry.width);
                        var w = interpolator(t);
                        return $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, entry), {}, {
                            width: w
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), null, _this3.renderRectanglesStatically(stepData));
                });
            }
        },
        {
            key: "renderRectangles",
            value: function renderRectangles() {
                var _this$props3 = this.props, data = _this$props3.data, isAnimationActive = _this$props3.isAnimationActive;
                var prevData = this.state.prevData;
                if (isAnimationActive && data && data.length && (!prevData || !(0, (/*@__PURE__*/$parcel$interopDefault($394ab417e9bd75cc$exports)))(prevData, data))) return this.renderRectanglesWithAnimation();
                return this.renderRectanglesStatically(data);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this4 = this;
                var _this$props4 = this.props, data = _this$props4.data, dataKey = _this$props4.dataKey, activeIndex = _this$props4.activeIndex;
                var backgroundProps = (0, $008f02516c156322$export$d697c39a2985a4c)(this.props.background, false);
                return data.map(function(entry, i) {
                    var value = entry.value, background = entry.background, rest = $e752e700473a8894$var$_objectWithoutProperties(entry, $e752e700473a8894$var$_excluded);
                    if (!background) return null;
                    var props = $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, rest), {}, {
                        fill: '#eee'
                    }, background), backgroundProps), (0, $909d5f835f4e917b$export$ca62be0d67a3158c)(_this4.props, entry, i)), {}, {
                        onAnimationStart: _this4.handleAnimationStart,
                        onAnimationEnd: _this4.handleAnimationEnd,
                        dataKey: dataKey,
                        index: i,
                        className: 'recharts-bar-background-rectangle'
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b5efd6b8794dbdeb$export$f19074a6842f9217), $e752e700473a8894$var$_extends({
                        key: "background-bar-".concat(i),
                        option: _this4.props.background,
                        isActive: i === activeIndex
                    }, props));
                });
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props5 = this.props, data = _this$props5.data, xAxis = _this$props5.xAxis, yAxis = _this$props5.yAxis, layout = _this$props5.layout, children = _this$props5.children;
                var errorBarItems = (0, $008f02516c156322$export$fdd5e64c0e8495bb)(children, (0, $7f4b989d0f2e91c6$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    /**
         * if the value coming from `getComposedData` is an array then this is a stacked bar chart.
         * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
         * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: value,
                        errorVal: (0, $cd015374923bb5c7$export$f97fc4a450f29a)(dataPoint, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(item, {
                        key: "error-bar-".concat(clipPathId, "-").concat(item.props.dataKey),
                        data: data,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        offset: offset,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, data = _this$props6.data, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, background = _this$props6.background, id = _this$props6.id;
                if (hide || !data || !data.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-bar', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                    className: "recharts-bar-rectangles",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $88ab0dba0fc78576$export$835fcf23ab7bf88).renderCallByParent(this.props, data));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curData: nextProps.data,
                    prevData: prevState.curData
                };
                if (nextProps.data !== prevState.curData) return {
                    curData: nextProps.data
                };
                return null;
            }
        }
    ]);
}((0, $acw62.PureComponent));
$e752e700473a8894$var$_Bar = $e752e700473a8894$export$bbc6c6369b38e3d1;
$e752e700473a8894$var$_defineProperty($e752e700473a8894$export$bbc6c6369b38e3d1, "displayName", 'Bar');
$e752e700473a8894$var$_defineProperty($e752e700473a8894$export$bbc6c6369b38e3d1, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: 'rect',
    minPointSize: 0,
    hide: false,
    data: [],
    layout: 'vertical',
    activeBar: false,
    isAnimationActive: !(0, $795299547b24e258$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'ease'
});
/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition  The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */ $e752e700473a8894$var$_defineProperty($e752e700473a8894$export$bbc6c6369b38e3d1, "getComposedData", function(_ref2) {
    var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var pos = (0, $cd015374923bb5c7$export$778e70011fdf4625)(barPosition, item);
    if (!pos) return null;
    var layout = props.layout;
    var itemDefaultProps = item.type.defaultProps;
    var itemProps = itemDefaultProps !== undefined ? $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, itemDefaultProps), item.props) : item.props;
    var dataKey = itemProps.dataKey, children = itemProps.children, minPointSizeProp = itemProps.minPointSize;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, $cd015374923bb5c7$export$54f3200dd4a8a235)({
        numericAxis: numericAxis
    });
    var cells = (0, $008f02516c156322$export$fdd5e64c0e8495bb)(children, (0, $b43ffe30f81b14f2$export$f6f0c3fe4ec306ea));
    var rects = displayedData.map(function(entry, index) {
        var value, x, y, width, height, background;
        if (stackedData) value = (0, $cd015374923bb5c7$export$c7ec0fa96d0c462e)(stackedData[dataStartIndex + index], stackedDomain);
        else {
            value = (0, $cd015374923bb5c7$export$f97fc4a450f29a)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
        }
        var minPointSize = (0, $b5efd6b8794dbdeb$export$c20d73790de171f0)(minPointSizeProp, $e752e700473a8894$var$_Bar.defaultProps.minPointSize)(value[1], index);
        if (layout === 'horizontal') {
            var _ref4;
            var _ref3 = [
                yAxis.scale(value[0]),
                yAxis.scale(value[1])
            ], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
            x = (0, $cd015374923bb5c7$export$8abb9e87422f3a0c)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = Number.isNaN(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: yAxis.y,
                width: width,
                height: yAxis.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _ref5 = [
                xAxis.scale(value[0]),
                xAxis.scale(value[1])
            ], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
            x = _baseValueScale;
            y = (0, $cd015374923bb5c7$export$8abb9e87422f3a0c)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: xAxis.x,
                y: y,
                width: xAxis.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        return $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, entry), {}, {
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background
        }, cells && cells[index] && cells[index].props), {}, {
            tooltipPayload: [
                (0, $cd015374923bb5c7$export$a4ea3faa19bc2d90)(item, entry)
            ],
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            }
        });
    });
    return $e752e700473a8894$var$_objectSpread({
        data: rects,
        layout: layout
    }, offset);
});

/**
 * @fileOverview Bar Chart
 */ 
var $acw62 = parcelRequire("acw62");


var $b392b5b21038a0ce$exports = {};
var $cd7742b81dd96fb0$exports = {};
var $d3906a592348eb7a$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d3906a592348eb7a$var$nativeCeil = Math.ceil, $d3906a592348eb7a$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $d3906a592348eb7a$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $d3906a592348eb7a$var$nativeMax($d3906a592348eb7a$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$d3906a592348eb7a$exports = $d3906a592348eb7a$var$baseRange;



var $6ceabe126a95a54e$exports = {};
var $dc614d828223dea6$exports = {};
var $0542da1d887b1c4d$exports = {};
var $ef99cce288c7323e$exports = {};
/** Used to match a single whitespace character. */ var $ef99cce288c7323e$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $ef99cce288c7323e$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $ef99cce288c7323e$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$ef99cce288c7323e$exports = $ef99cce288c7323e$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $0542da1d887b1c4d$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $0542da1d887b1c4d$var$baseTrim(string) {
    return string ? string.slice(0, $ef99cce288c7323e$exports(string) + 1).replace($0542da1d887b1c4d$var$reTrimStart, '') : string;
}
$0542da1d887b1c4d$exports = $0542da1d887b1c4d$var$baseTrim;




/** Used as references for various `Number` constants. */ var $dc614d828223dea6$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $dc614d828223dea6$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $dc614d828223dea6$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $dc614d828223dea6$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $dc614d828223dea6$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $dc614d828223dea6$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($6b5a5095e0934938$exports(value)) return $dc614d828223dea6$var$NAN;
    if ($f9ff2e983beb6b86$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $f9ff2e983beb6b86$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $0542da1d887b1c4d$exports(value);
    var isBinary = $dc614d828223dea6$var$reIsBinary.test(value);
    return isBinary || $dc614d828223dea6$var$reIsOctal.test(value) ? $dc614d828223dea6$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $dc614d828223dea6$var$reIsBadHex.test(value) ? $dc614d828223dea6$var$NAN : +value;
}
$dc614d828223dea6$exports = $dc614d828223dea6$var$toNumber;


/** Used as references for various `Number` constants. */ var $6ceabe126a95a54e$var$INFINITY = 1 / 0, $6ceabe126a95a54e$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $6ceabe126a95a54e$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $dc614d828223dea6$exports(value);
    if (value === $6ceabe126a95a54e$var$INFINITY || value === -$6ceabe126a95a54e$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $6ceabe126a95a54e$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$6ceabe126a95a54e$exports = $6ceabe126a95a54e$var$toFinite;


/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $cd7742b81dd96fb0$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $81b21e8b41d211e8$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $6ceabe126a95a54e$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $6ceabe126a95a54e$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $6ceabe126a95a54e$exports(step);
        return $d3906a592348eb7a$exports(start, end, step, fromRight);
    };
}
$cd7742b81dd96fb0$exports = $cd7742b81dd96fb0$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $b392b5b21038a0ce$var$range = $cd7742b81dd96fb0$exports();
$b392b5b21038a0ce$exports = $b392b5b21038a0ce$var$range;




var $ff695783c7d42c0c$exports = {};
var $d9f195cb3938646c$exports = {};

var $6d38303b9c8735ba$exports = {};

var $23YZo = parcelRequire("23YZo");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $6d38303b9c8735ba$var$now = function() {
    return $23YZo.Date.now();
};
$6d38303b9c8735ba$exports = $6d38303b9c8735ba$var$now;



/** Error message constants. */ var $d9f195cb3938646c$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d9f195cb3938646c$var$nativeMax = Math.max, $d9f195cb3938646c$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $d9f195cb3938646c$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($d9f195cb3938646c$var$FUNC_ERROR_TEXT);
    wait = $dc614d828223dea6$exports(wait) || 0;
    if ($f9ff2e983beb6b86$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $d9f195cb3938646c$var$nativeMax($dc614d828223dea6$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $d9f195cb3938646c$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $6d38303b9c8735ba$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($6d38303b9c8735ba$exports());
    }
    function debounced() {
        var time = $6d38303b9c8735ba$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$d9f195cb3938646c$exports = $d9f195cb3938646c$var$debounce;



/** Error message constants. */ var $ff695783c7d42c0c$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $ff695783c7d42c0c$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($ff695783c7d42c0c$var$FUNC_ERROR_TEXT);
    if ($f9ff2e983beb6b86$exports(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $d9f195cb3938646c$exports(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$ff695783c7d42c0c$exports = $ff695783c7d42c0c$var$throttle;







var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");




function $c0a796aac01127ca$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c0a796aac01127ca$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c0a796aac01127ca$var$_typeof(o);
}
function $c0a796aac01127ca$var$_extends() {
    $c0a796aac01127ca$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c0a796aac01127ca$var$_extends.apply(this, arguments);
}
function $c0a796aac01127ca$var$_slicedToArray(arr, i) {
    return $c0a796aac01127ca$var$_arrayWithHoles(arr) || $c0a796aac01127ca$var$_iterableToArrayLimit(arr, i) || $c0a796aac01127ca$var$_unsupportedIterableToArray(arr, i) || $c0a796aac01127ca$var$_nonIterableRest();
}
function $c0a796aac01127ca$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c0a796aac01127ca$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c0a796aac01127ca$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c0a796aac01127ca$var$_arrayLikeToArray(o, minLen);
}
function $c0a796aac01127ca$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c0a796aac01127ca$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $c0a796aac01127ca$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c0a796aac01127ca$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c0a796aac01127ca$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c0a796aac01127ca$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c0a796aac01127ca$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c0a796aac01127ca$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c0a796aac01127ca$var$_defineProperty(obj, key, value) {
    key = $c0a796aac01127ca$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c0a796aac01127ca$var$_toPropertyKey(t) {
    var i = $c0a796aac01127ca$var$_toPrimitive(t, "string");
    return "symbol" == $c0a796aac01127ca$var$_typeof(i) ? i : i + "";
}
function $c0a796aac01127ca$var$_toPrimitive(t, r) {
    if ("object" != $c0a796aac01127ca$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c0a796aac01127ca$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c0a796aac01127ca$var$defaultFormatter(value) {
    return Array.isArray(value) && (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(value[0]) && (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(value[1]) ? value.join(' ~ ') : value;
}
var $c0a796aac01127ca$export$6fe33945eebf9ac8 = function DefaultTooltipContent(props) {
    var _props$separator = props.separator, separator = _props$separator === void 0 ? ' : ' : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter, _props$accessibilityL = props.accessibilityLayer, accessibilityLayer = _props$accessibilityL === void 0 ? false : _props$accessibilityL;
    var renderContent = function renderContent() {
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($300ea168693086c2$exports)))(payload, itemSorter) : payload).map(function(entry, i) {
                if (entry.type === 'none') return null;
                var finalItemStyle = $c0a796aac01127ca$var$_objectSpread({
                    display: 'block',
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || '#000'
                }, itemStyle);
                var finalFormatter = entry.formatter || formatter || $c0a796aac01127ca$var$defaultFormatter;
                var value = entry.value, name = entry.name;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter && finalValue != null && finalName != null) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) {
                        var _formatted = $c0a796aac01127ca$var$_slicedToArray(formatted, 2);
                        finalValue = _formatted[0];
                        finalName = _formatted[1];
                    } else finalValue = formatted;
                }
                return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || '')));
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = $c0a796aac01127ca$var$_objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
    }, contentStyle);
    var finalLabelStyle = $c0a796aac01127ca$var$_objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(label);
    var finalLabel = hasLabel ? label : '';
    var wrapperCN = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-default-tooltip', wrapperClassName);
    var labelCN = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-tooltip-label', labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    var accessibilityAttributes = accessibilityLayer ? {
        role: 'status',
        'aria-live': 'assertive'
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $c0a796aac01127ca$var$_extends({
        className: wrapperCN,
        style: finalStyle
    }, accessibilityAttributes), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};



var $acw62 = parcelRequire("acw62");


function $32b135afcb061cab$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $32b135afcb061cab$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $32b135afcb061cab$var$_typeof(o);
}
function $32b135afcb061cab$var$_defineProperty(obj, key, value) {
    key = $32b135afcb061cab$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $32b135afcb061cab$var$_toPropertyKey(t) {
    var i = $32b135afcb061cab$var$_toPrimitive(t, "string");
    return "symbol" == $32b135afcb061cab$var$_typeof(i) ? i : i + "";
}
function $32b135afcb061cab$var$_toPrimitive(t, r) {
    if ("object" != $32b135afcb061cab$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $32b135afcb061cab$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $32b135afcb061cab$var$CSS_CLASS_PREFIX = 'recharts-tooltip-wrapper';
var $32b135afcb061cab$var$TOOLTIP_HIDDEN = {
    visibility: 'hidden'
};
function $32b135afcb061cab$export$46aee7ef09f78756(_ref) {
    var coordinate = _ref.coordinate, translateX = _ref.translateX, translateY = _ref.translateY;
    return (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($32b135afcb061cab$var$CSS_CLASS_PREFIX, $32b135afcb061cab$var$_defineProperty($32b135afcb061cab$var$_defineProperty($32b135afcb061cab$var$_defineProperty($32b135afcb061cab$var$_defineProperty({}, "".concat($32b135afcb061cab$var$CSS_CLASS_PREFIX, "-right"), (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(translateX) && coordinate && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(coordinate.x) && translateX >= coordinate.x), "".concat($32b135afcb061cab$var$CSS_CLASS_PREFIX, "-left"), (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(translateX) && coordinate && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(coordinate.x) && translateX < coordinate.x), "".concat($32b135afcb061cab$var$CSS_CLASS_PREFIX, "-bottom"), (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(translateY) && coordinate && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(coordinate.y) && translateY >= coordinate.y), "".concat($32b135afcb061cab$var$CSS_CLASS_PREFIX, "-top"), (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(translateY) && coordinate && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(coordinate.y) && translateY < coordinate.y));
}
function $32b135afcb061cab$export$4cccba03fe0eccc6(_ref2) {
    var allowEscapeViewBox = _ref2.allowEscapeViewBox, coordinate = _ref2.coordinate, key = _ref2.key, offsetTopLeft = _ref2.offsetTopLeft, position = _ref2.position, reverseDirection = _ref2.reverseDirection, tooltipDimension = _ref2.tooltipDimension, viewBox = _ref2.viewBox, viewBoxDimension = _ref2.viewBoxDimension;
    if (position && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - offsetTopLeft;
    var positive = coordinate[key] + offsetTopLeft;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBox[key];
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBox[key]);
        return Math.max(negative, viewBox[key]);
    }
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBox[key] + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBox[key]);
    return Math.max(positive, viewBox[key]);
}
function $32b135afcb061cab$export$4fe0982879780f9b(_ref3) {
    var translateX = _ref3.translateX, translateY = _ref3.translateY, useTranslate3d = _ref3.useTranslate3d;
    return {
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    };
}
function $32b135afcb061cab$export$25e3b0ae21503056(_ref4) {
    var allowEscapeViewBox = _ref4.allowEscapeViewBox, coordinate = _ref4.coordinate, offsetTopLeft = _ref4.offsetTopLeft, position = _ref4.position, reverseDirection = _ref4.reverseDirection, tooltipBox = _ref4.tooltipBox, useTranslate3d = _ref4.useTranslate3d, viewBox = _ref4.viewBox;
    var cssProperties, translateX, translateY;
    if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = $32b135afcb061cab$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'x',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox: viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = $32b135afcb061cab$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'y',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox: viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = $32b135afcb061cab$export$4fe0982879780f9b({
            translateX: translateX,
            translateY: translateY,
            useTranslate3d: useTranslate3d
        });
    } else cssProperties = $32b135afcb061cab$var$TOOLTIP_HIDDEN;
    return {
        cssProperties: cssProperties,
        cssClasses: $32b135afcb061cab$export$46aee7ef09f78756({
            translateX: translateX,
            translateY: translateY,
            coordinate: coordinate
        })
    };
}


function $2a173c9072cdf4ec$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2a173c9072cdf4ec$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2a173c9072cdf4ec$var$_typeof(o);
}
function $2a173c9072cdf4ec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2a173c9072cdf4ec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2a173c9072cdf4ec$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2a173c9072cdf4ec$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2a173c9072cdf4ec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2a173c9072cdf4ec$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2a173c9072cdf4ec$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $2a173c9072cdf4ec$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $2a173c9072cdf4ec$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2a173c9072cdf4ec$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2a173c9072cdf4ec$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $2a173c9072cdf4ec$var$_callSuper(t, o, e) {
    return o = $2a173c9072cdf4ec$var$_getPrototypeOf(o), $2a173c9072cdf4ec$var$_possibleConstructorReturn(t, $2a173c9072cdf4ec$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $2a173c9072cdf4ec$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $2a173c9072cdf4ec$var$_possibleConstructorReturn(self, call) {
    if (call && ($2a173c9072cdf4ec$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $2a173c9072cdf4ec$var$_assertThisInitialized(self);
}
function $2a173c9072cdf4ec$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $2a173c9072cdf4ec$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2a173c9072cdf4ec$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $2a173c9072cdf4ec$var$_getPrototypeOf(o) {
    $2a173c9072cdf4ec$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2a173c9072cdf4ec$var$_getPrototypeOf(o);
}
function $2a173c9072cdf4ec$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $2a173c9072cdf4ec$var$_setPrototypeOf(subClass, superClass);
}
function $2a173c9072cdf4ec$var$_setPrototypeOf(o, p) {
    $2a173c9072cdf4ec$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2a173c9072cdf4ec$var$_setPrototypeOf(o, p);
}
function $2a173c9072cdf4ec$var$_defineProperty(obj, key, value) {
    key = $2a173c9072cdf4ec$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2a173c9072cdf4ec$var$_toPropertyKey(t) {
    var i = $2a173c9072cdf4ec$var$_toPrimitive(t, "string");
    return "symbol" == $2a173c9072cdf4ec$var$_typeof(i) ? i : i + "";
}
function $2a173c9072cdf4ec$var$_toPrimitive(t, r) {
    if ("object" != $2a173c9072cdf4ec$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2a173c9072cdf4ec$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $2a173c9072cdf4ec$var$EPSILON = 1;
var $2a173c9072cdf4ec$export$9e6cee7b86551b9c = /*#__PURE__*/ function(_PureComponent) {
    function TooltipBoundingBox() {
        var _this;
        $2a173c9072cdf4ec$var$_classCallCheck(this, TooltipBoundingBox);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $2a173c9072cdf4ec$var$_callSuper(this, TooltipBoundingBox, [].concat(args));
        $2a173c9072cdf4ec$var$_defineProperty(_this, "state", {
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            },
            lastBoundingBox: {
                width: -1,
                height: -1
            }
        });
        $2a173c9072cdf4ec$var$_defineProperty(_this, "handleKeyDown", function(event) {
            if (event.key === 'Escape') {
                var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
                _this.setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_this$props$coordinat = (_this$props$coordinat2 = _this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
                        y: (_this$props$coordinat3 = (_this$props$coordinat4 = _this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
                    }
                });
            }
        });
        return _this;
    }
    $2a173c9072cdf4ec$var$_inherits(TooltipBoundingBox, _PureComponent);
    return $2a173c9072cdf4ec$var$_createClass(TooltipBoundingBox, [
        {
            key: "updateBBox",
            value: function updateBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(box.width - this.state.lastBoundingBox.width) > $2a173c9072cdf4ec$var$EPSILON || Math.abs(box.height - this.state.lastBoundingBox.height) > $2a173c9072cdf4ec$var$EPSILON) this.setState({
                        lastBoundingBox: {
                            width: box.width,
                            height: box.height
                        }
                    });
                } else if (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) this.setState({
                    lastBoundingBox: {
                        width: -1,
                        height: -1
                    }
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener('keydown', this.handleKeyDown);
                this.updateBBox();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener('keydown', this.handleKeyDown);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this$props$coordinat5, _this$props$coordinat6;
                if (this.props.active) this.updateBBox();
                if (!this.state.dismissed) return;
                if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) this.state.dismissed = false;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, children = _this$props.children, coordinate = _this$props.coordinate, hasPayload = _this$props.hasPayload, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var _getTooltipTranslate = (0, $32b135afcb061cab$export$25e3b0ae21503056)({
                    allowEscapeViewBox: allowEscapeViewBox,
                    coordinate: coordinate,
                    offsetTopLeft: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    tooltipBox: this.state.lastBoundingBox,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox
                }), cssClasses = _getTooltipTranslate.cssClasses, cssProperties = _getTooltipTranslate.cssProperties;
                var outerStyle = $2a173c9072cdf4ec$var$_objectSpread($2a173c9072cdf4ec$var$_objectSpread({
                    transition: isAnimationActive && active ? "transform ".concat(animationDuration, "ms ").concat(animationEasing) : undefined
                }, cssProperties), {}, {
                    pointerEvents: 'none',
                    visibility: !this.state.dismissed && active && hasPayload ? 'visible' : 'hidden',
                    position: 'absolute',
                    top: 0,
                    left: 0
                }, wrapperStyle);
                return(/*#__PURE__*/ // This element allow listening to the `Escape` key.
                // See https://github.com/recharts/recharts/pull/2925
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    tabIndex: -1,
                    className: cssClasses,
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, children));
            }
        }
    ]);
}((0, $acw62.PureComponent));




function $3258e2bab55a6a07$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3258e2bab55a6a07$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3258e2bab55a6a07$var$_typeof(o);
}
function $3258e2bab55a6a07$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3258e2bab55a6a07$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3258e2bab55a6a07$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3258e2bab55a6a07$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3258e2bab55a6a07$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3258e2bab55a6a07$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3258e2bab55a6a07$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $3258e2bab55a6a07$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $3258e2bab55a6a07$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3258e2bab55a6a07$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3258e2bab55a6a07$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3258e2bab55a6a07$var$_callSuper(t, o, e) {
    return o = $3258e2bab55a6a07$var$_getPrototypeOf(o), $3258e2bab55a6a07$var$_possibleConstructorReturn(t, $3258e2bab55a6a07$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $3258e2bab55a6a07$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $3258e2bab55a6a07$var$_possibleConstructorReturn(self, call) {
    if (call && ($3258e2bab55a6a07$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3258e2bab55a6a07$var$_assertThisInitialized(self);
}
function $3258e2bab55a6a07$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3258e2bab55a6a07$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3258e2bab55a6a07$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $3258e2bab55a6a07$var$_getPrototypeOf(o) {
    $3258e2bab55a6a07$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3258e2bab55a6a07$var$_getPrototypeOf(o);
}
function $3258e2bab55a6a07$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $3258e2bab55a6a07$var$_setPrototypeOf(subClass, superClass);
}
function $3258e2bab55a6a07$var$_setPrototypeOf(o, p) {
    $3258e2bab55a6a07$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3258e2bab55a6a07$var$_setPrototypeOf(o, p);
}
function $3258e2bab55a6a07$var$_defineProperty(obj, key, value) {
    key = $3258e2bab55a6a07$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3258e2bab55a6a07$var$_toPropertyKey(t) {
    var i = $3258e2bab55a6a07$var$_toPrimitive(t, "string");
    return "symbol" == $3258e2bab55a6a07$var$_typeof(i) ? i : i + "";
}
function $3258e2bab55a6a07$var$_toPrimitive(t, r) {
    if ("object" != $3258e2bab55a6a07$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3258e2bab55a6a07$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3258e2bab55a6a07$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $3258e2bab55a6a07$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(content, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c0a796aac01127ca$export$6fe33945eebf9ac8), props);
}
var $3258e2bab55a6a07$export$28c660c63b792dea = /*#__PURE__*/ function(_PureComponent) {
    function Tooltip() {
        $3258e2bab55a6a07$var$_classCallCheck(this, Tooltip);
        return $3258e2bab55a6a07$var$_callSuper(this, Tooltip, arguments);
    }
    $3258e2bab55a6a07$var$_inherits(Tooltip, _PureComponent);
    return $3258e2bab55a6a07$var$_createClass(Tooltip, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, content = _this$props.content, coordinate = _this$props.coordinate, filterNull = _this$props.filterNull, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, payload = _this$props.payload, payloadUniqBy = _this$props.payloadUniqBy, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var finalPayload = payload !== null && payload !== void 0 ? payload : [];
                if (filterNull && finalPayload.length) finalPayload = (0, $12cc16c3e91089ee$export$b67e33c2fb1535fa)(payload.filter(function(entry) {
                    return entry.value != null && (entry.hide !== true || _this.props.includeHidden);
                }), payloadUniqBy, $3258e2bab55a6a07$var$defaultUniqBy);
                var hasPayload = finalPayload.length > 0;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2a173c9072cdf4ec$export$9e6cee7b86551b9c), {
                    allowEscapeViewBox: allowEscapeViewBox,
                    animationDuration: animationDuration,
                    animationEasing: animationEasing,
                    isAnimationActive: isAnimationActive,
                    active: active,
                    coordinate: coordinate,
                    hasPayload: hasPayload,
                    offset: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox,
                    wrapperStyle: wrapperStyle
                }, $3258e2bab55a6a07$var$renderContent(content, $3258e2bab55a6a07$var$_objectSpread($3258e2bab55a6a07$var$_objectSpread({}, this.props), {}, {
                    payload: finalPayload
                })));
            }
        }
    ]);
}((0, $acw62.PureComponent));
$3258e2bab55a6a07$var$_defineProperty($3258e2bab55a6a07$export$28c660c63b792dea, "displayName", 'Tooltip');
$3258e2bab55a6a07$var$_defineProperty($3258e2bab55a6a07$export$28c660c63b792dea, "defaultProps", {
    accessibilityLayer: false,
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: 'ease',
    contentStyle: {},
    coordinate: {
        x: 0,
        y: 0
    },
    cursor: true,
    cursorStyle: {},
    filterNull: true,
    isAnimationActive: !(0, $795299547b24e258$export$98f03c5d19621d70).isSsr,
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: ' : ',
    trigger: 'hover',
    useTranslate3d: false,
    viewBox: {
        x: 0,
        y: 0,
        height: 0,
        width: 0
    },
    wrapperStyle: {}
});




var $acw62 = parcelRequire("acw62");



function $1ab98349969d46e2$var$_extends() {
    $1ab98349969d46e2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1ab98349969d46e2$var$_extends.apply(this, arguments);
}
var $1ab98349969d46e2$export$d046b3c4a416f60d = function Dot(props) {
    var cx = props.cx, cy = props.cy, r = props.r, className = props.className;
    var layerClass = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-dot', className);
    if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ $acw62.createElement("circle", $1ab98349969d46e2$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(props, false), (0, $909d5f835f4e917b$export$7c4c290a4a9c1b1e)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};





var $acw62 = parcelRequire("acw62");








function $aff99017769d4007$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $aff99017769d4007$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $aff99017769d4007$var$_typeof(o);
}
function $aff99017769d4007$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aff99017769d4007$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aff99017769d4007$var$ownKeys(Object(t), !0).forEach(function(r) {
            $aff99017769d4007$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aff99017769d4007$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $aff99017769d4007$var$_defineProperty(obj, key, value) {
    key = $aff99017769d4007$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aff99017769d4007$var$_toPropertyKey(t) {
    var i = $aff99017769d4007$var$_toPrimitive(t, "string");
    return "symbol" == $aff99017769d4007$var$_typeof(i) ? i : i + "";
}
function $aff99017769d4007$var$_toPrimitive(t, r) {
    if ("object" != $aff99017769d4007$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $aff99017769d4007$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $aff99017769d4007$var$PREFIX_LIST = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
var $aff99017769d4007$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = $aff99017769d4007$var$PREFIX_LIST.reduce(function(res, entry) {
        return $aff99017769d4007$var$_objectSpread($aff99017769d4007$var$_objectSpread({}, res), {}, $aff99017769d4007$var$_defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};



function $b0c0135ef9d67bd5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b0c0135ef9d67bd5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b0c0135ef9d67bd5$var$_typeof(o);
}
function $b0c0135ef9d67bd5$var$_extends() {
    $b0c0135ef9d67bd5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b0c0135ef9d67bd5$var$_extends.apply(this, arguments);
}
function $b0c0135ef9d67bd5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b0c0135ef9d67bd5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b0c0135ef9d67bd5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b0c0135ef9d67bd5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b0c0135ef9d67bd5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b0c0135ef9d67bd5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b0c0135ef9d67bd5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $b0c0135ef9d67bd5$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $b0c0135ef9d67bd5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b0c0135ef9d67bd5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b0c0135ef9d67bd5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $b0c0135ef9d67bd5$var$_callSuper(t, o, e) {
    return o = $b0c0135ef9d67bd5$var$_getPrototypeOf(o), $b0c0135ef9d67bd5$var$_possibleConstructorReturn(t, $b0c0135ef9d67bd5$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $b0c0135ef9d67bd5$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $b0c0135ef9d67bd5$var$_possibleConstructorReturn(self, call) {
    if (call && ($b0c0135ef9d67bd5$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $b0c0135ef9d67bd5$var$_assertThisInitialized(self);
}
function $b0c0135ef9d67bd5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b0c0135ef9d67bd5$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b0c0135ef9d67bd5$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $b0c0135ef9d67bd5$var$_getPrototypeOf(o) {
    $b0c0135ef9d67bd5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b0c0135ef9d67bd5$var$_getPrototypeOf(o);
}
function $b0c0135ef9d67bd5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $b0c0135ef9d67bd5$var$_setPrototypeOf(subClass, superClass);
}
function $b0c0135ef9d67bd5$var$_setPrototypeOf(o, p) {
    $b0c0135ef9d67bd5$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b0c0135ef9d67bd5$var$_setPrototypeOf(o, p);
}
function $b0c0135ef9d67bd5$var$_defineProperty(obj, key, value) {
    key = $b0c0135ef9d67bd5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b0c0135ef9d67bd5$var$_toPropertyKey(t) {
    var i = $b0c0135ef9d67bd5$var$_toPrimitive(t, "string");
    return "symbol" == $b0c0135ef9d67bd5$var$_typeof(i) ? i : i + "";
}
function $b0c0135ef9d67bd5$var$_toPrimitive(t, r) {
    if ("object" != $b0c0135ef9d67bd5$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b0c0135ef9d67bd5$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $b0c0135ef9d67bd5$var$createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, $d8f008d3b0c1a5c3$exports.scalePoint)().domain((0, (/*@__PURE__*/$parcel$interopDefault($b392b5b21038a0ce$exports)))(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        isTravellerFocused: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var $b0c0135ef9d67bd5$var$isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var $b0c0135ef9d67bd5$export$59bc2e3533b384a0 = /*#__PURE__*/ function(_PureComponent) {
    function Brush(props) {
        var _this;
        $b0c0135ef9d67bd5$var$_classCallCheck(this, Brush);
        _this = $b0c0135ef9d67bd5$var$_callSuper(this, Brush, [
            props
        ]);
        $b0c0135ef9d67bd5$var$_defineProperty(_this, "handleDrag", function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        });
        $b0c0135ef9d67bd5$var$_defineProperty(_this, "handleTouchMove", function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        });
        $b0c0135ef9d67bd5$var$_defineProperty(_this, "handleDragEnd", function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            }, function() {
                var _this$props = _this.props, endIndex = _this$props.endIndex, onDragEnd = _this$props.onDragEnd, startIndex = _this$props.startIndex;
                onDragEnd === null || onDragEnd === void 0 || onDragEnd({
                    endIndex: endIndex,
                    startIndex: startIndex
                });
            });
            _this.detachDragEndListener();
        });
        $b0c0135ef9d67bd5$var$_defineProperty(_this, "handleLeaveWrapper", function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        });
        $b0c0135ef9d67bd5$var$_defineProperty(_this, "handleEnterSlideOrTraveller", function() {
            _this.setState({
                isTextActive: true
            });
        });
        $b0c0135ef9d67bd5$var$_defineProperty(_this, "handleLeaveSlideOrTraveller", function() {
            _this.setState({
                isTextActive: false
            });
        });
        $b0c0135ef9d67bd5$var$_defineProperty(_this, "handleSlideDragStart", function(e) {
            var event = $b0c0135ef9d67bd5$var$isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        });
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind(_this, 'startX'),
            endX: _this.handleTravellerDragStart.bind(_this, 'endX')
        };
        _this.state = {};
        return _this;
    }
    $b0c0135ef9d67bd5$var$_inherits(Brush, _PureComponent);
    return $b0c0135ef9d67bd5$var$_createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props2 = this.props, gap = _this$props2.gap, data = _this$props2.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props3 = this.props, data = _this$props3.data, tickFormatter = _this$props3.tickFormatter, dataKey = _this$props3.dataKey;
                var text = (0, $cd015374923bb5c7$export$f97fc4a450f29a)(data[index], dataKey, index);
                return (0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener('mouseup', this.handleDragEnd, true);
                window.addEventListener('touchend', this.handleDragEnd, true);
                window.addEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener('mouseup', this.handleDragEnd, true);
                window.removeEventListener('touchend', this.handleDragEnd, true);
                window.removeEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, startIndex = _this$props4.startIndex, endIndex = _this$props4.endIndex, onChange = _this$props4.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = $b0c0135ef9d67bd5$var$isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props5 = this.props, x = _this$props5.x, width = _this$props5.width, travellerWidth = _this$props5.travellerWidth, onChange = _this$props5.onChange, gap = _this$props5.gap, data = _this$props5.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState($b0c0135ef9d67bd5$var$_defineProperty($b0c0135ef9d67bd5$var$_defineProperty({}, movingTravellerId, prevValue + delta), "brushMoveStartX", e.pageX), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "handleTravellerMoveKeyboard",
            value: function handleTravellerMoveKeyboard(direction, id) {
                var _this2 = this;
                // scaleValues are a list of coordinates. For example: [65, 250, 435, 620, 805, 990].
                var _this$state3 = this.state, scaleValues = _this$state3.scaleValues, startX = _this$state3.startX, endX = _this$state3.endX;
                // currentScaleValue refers to which coordinate the current traveller should be placed at.
                var currentScaleValue = this.state[id];
                var currentIndex = scaleValues.indexOf(currentScaleValue);
                if (currentIndex === -1) return;
                var newIndex = currentIndex + direction;
                if (newIndex === -1 || newIndex >= scaleValues.length) return;
                var newScaleValue = scaleValues[newIndex];
                // Prevent travellers from being on top of each other or overlapping
                if (id === 'startX' && newScaleValue >= endX || id === 'endX' && newScaleValue <= startX) return;
                this.setState($b0c0135ef9d67bd5$var$_defineProperty({}, id, newScaleValue), function() {
                    _this2.props.onChange(_this2.getIndex({
                        startX: _this2.state.startX,
                        endX: _this2.state.endX
                    }));
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, fill = _this$props6.fill, stroke = _this$props6.stroke;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props7 = this.props, x = _this$props7.x, y = _this$props7.y, width = _this$props7.width, height = _this$props7.height, data = _this$props7.data, children = _this$props7.children, padding = _this$props7.padding;
                var chartElement = (0, $acw62.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _data$startIndex, _data$endIndex, _this3 = this;
                var _this$props8 = this.props, y = _this$props8.y, travellerWidth = _this$props8.travellerWidth, height = _this$props8.height, traveller = _this$props8.traveller, ariaLabel = _this$props8.ariaLabel, data = _this$props8.data, startIndex = _this$props8.startIndex, endIndex = _this$props8.endIndex;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = $b0c0135ef9d67bd5$var$_objectSpread($b0c0135ef9d67bd5$var$_objectSpread({}, (0, $008f02516c156322$export$d697c39a2985a4c)(this.props, false)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                var ariaLabelBrush = ariaLabel || "Min value: ".concat((_data$startIndex = data[startIndex]) === null || _data$startIndex === void 0 ? void 0 : _data$startIndex.name, ", Max value: ").concat((_data$endIndex = data[endIndex]) === null || _data$endIndex === void 0 ? void 0 : _data$endIndex.name);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                    tabIndex: 0,
                    role: "slider",
                    "aria-label": ariaLabelBrush,
                    "aria-valuenow": travellerX,
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    onKeyDown: function onKeyDown(e) {
                        if (![
                            'ArrowLeft',
                            'ArrowRight'
                        ].includes(e.key)) return;
                        e.preventDefault();
                        e.stopPropagation();
                        _this3.handleTravellerMoveKeyboard(e.key === 'ArrowRight' ? 1 : -1, id);
                    },
                    onFocus: function onFocus() {
                        _this3.setState({
                            isTravellerFocused: true
                        });
                    },
                    onBlur: function onBlur() {
                        _this3.setState({
                            isTravellerFocused: false
                        });
                    },
                    style: {
                        cursor: 'col-resize'
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props9 = this.props, y = _this$props9.y, height = _this$props9.height, stroke = _this$props9.stroke, travellerWidth = _this$props9.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: 'move'
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props10 = this.props, startIndex = _this$props10.startIndex, endIndex = _this$props10.endIndex, y = _this$props10.y, height = _this$props10.height, travellerWidth = _this$props10.travellerWidth, stroke = _this$props10.stroke;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: 'none',
                    fill: stroke
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $964be52cc11879b4$export$5f1af8db9871e1d6), $b0c0135ef9d67bd5$var$_extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $964be52cc11879b4$export$5f1af8db9871e1d6), $b0c0135ef9d67bd5$var$_extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props11 = this.props, data = _this$props11.data, className = _this$props11.className, children = _this$props11.children, x = _this$props11.x, y = _this$props11.y, width = _this$props11.width, height = _this$props11.height, alwaysShowText = _this$props11.alwaysShowText;
                var _this$state5 = this.state, startX = _this$state5.startX, endX = _this$state5.endX, isTextActive = _this$state5.isTextActive, isSlideMoving = _this$state5.isSlideMoving, isTravellerMoving = _this$state5.isTravellerMoving, isTravellerFocused = _this$state5.isTravellerFocused;
                if (!data || !data.length || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(x) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(y) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(width) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-brush', className);
                var isPanoramic = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(children) === 1;
                var style = (0, $aff99017769d4007$export$4a9169b65825efee)('userSelect', 'none');
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                    className: layerClass,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, 'startX'), this.renderTravellerLayer(endX, 'endX'), (isTextActive || isSlideMoving || isTravellerMoving || isTravellerFocused || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(option)) rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return $b0c0135ef9d67bd5$var$_objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? $b0c0135ef9d67bd5$var$createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(valueRange, x) {
                var len = valueRange.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (valueRange[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= valueRange[end] ? end : start;
            }
        }
    ]);
}((0, $acw62.PureComponent));
$b0c0135ef9d67bd5$var$_defineProperty($b0c0135ef9d67bd5$export$59bc2e3533b384a0, "displayName", 'Brush');
$b0c0135ef9d67bd5$var$_defineProperty($b0c0135ef9d67bd5$export$59bc2e3533b384a0, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: '#fff',
    stroke: '#666',
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
});






var $acw62 = parcelRequire("acw62");






var $8ca5391289a51027$export$3fb112445eb31879 = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = 'extendDomain';
    return ifOverflow === value;
};


var $17211428bc2045c4$exports = {};
var $96b401257ea00d24$exports = {};

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $96b401257ea00d24$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $31e24313ace94404$exports) $31e24313ace94404$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$96b401257ea00d24$exports = $96b401257ea00d24$var$baseAssignValue;




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $17211428bc2045c4$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $5aba4f6d9f8304a3$exports(iteratee, 3);
    $34edfba366a0cfa1$exports(object, function(value, key, object) {
        $96b401257ea00d24$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$17211428bc2045c4$exports = $17211428bc2045c4$var$mapValues;


var $b3635322c399904d$exports = {};
var $492b7c32fdf9fe9f$exports = {};
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $492b7c32fdf9fe9f$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
$492b7c32fdf9fe9f$exports = $492b7c32fdf9fe9f$var$arrayEvery;


var $7bc6550757287062$exports = {};

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $7bc6550757287062$var$baseEvery(collection, predicate) {
    var result = true;
    $35fa3296f177aa01$exports(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
$7bc6550757287062$exports = $7bc6550757287062$var$baseEvery;





/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $b3635322c399904d$var$every(collection, predicate, guard) {
    var func = $0488fde9aa355453$exports(collection) ? $492b7c32fdf9fe9f$exports : $7bc6550757287062$exports;
    if (guard && $81b21e8b41d211e8$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $5aba4f6d9f8304a3$exports(predicate, 3));
}
$b3635322c399904d$exports = $b3635322c399904d$var$every;






function $7dad4d5151ba4a01$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7dad4d5151ba4a01$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7dad4d5151ba4a01$var$_typeof(o);
}
function $7dad4d5151ba4a01$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7dad4d5151ba4a01$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7dad4d5151ba4a01$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7dad4d5151ba4a01$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7dad4d5151ba4a01$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7dad4d5151ba4a01$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7dad4d5151ba4a01$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7dad4d5151ba4a01$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7dad4d5151ba4a01$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7dad4d5151ba4a01$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7dad4d5151ba4a01$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7dad4d5151ba4a01$var$_defineProperty(obj, key, value) {
    key = $7dad4d5151ba4a01$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7dad4d5151ba4a01$var$_toPropertyKey(t) {
    var i = $7dad4d5151ba4a01$var$_toPrimitive(t, "string");
    return "symbol" == $7dad4d5151ba4a01$var$_typeof(i) ? i : i + "";
}
function $7dad4d5151ba4a01$var$_toPrimitive(t, r) {
    if ("object" != $7dad4d5151ba4a01$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7dad4d5151ba4a01$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $7dad4d5151ba4a01$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, $008f02516c156322$export$64c61536a2b72e0f)(children, (0, $e752e700473a8894$export$bbc6c6369b38e3d1));
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? 'Mirror' : '');
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === 'number' && (axis.padding === 'gap' || axis.padding === 'no-gap')) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort((0, $2ab3a7e25c8aba74$export$6ab1df3197f7c641));
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            if (Number.isFinite(smallestDistanceBetweenValues)) {
                var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
                var rangeWidth = axis.layout === 'vertical' ? offset.height : offset.width;
                if (axis.padding === 'gap') calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
                if (axis.padding === 'no-gap') {
                    var gap = (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                    var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                    calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
                }
            }
        }
        if (axisType === 'xAxis') range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === 'yAxis') range = layout === 'horizontal' ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, $cd015374923bb5c7$export$534b094a708572c1)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, $cd015374923bb5c7$export$9d80152e23bae434)(scale);
        var ticks = (0, $cd015374923bb5c7$export$ac086aaa4358d590)(scale, $7dad4d5151ba4a01$var$_objectSpread($7dad4d5151ba4a01$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === 'xAxis') {
            needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === 'yAxis') {
            needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = $7dad4d5151ba4a01$var$_objectSpread($7dad4d5151ba4a01$var$_objectSpread($7dad4d5151ba4a01$var$_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === 'xAxis' ? offset.width : axis.width,
            height: axisType === 'yAxis' ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, $cd015374923bb5c7$export$212ec45c42fe68a7)(finalAxis, ticks);
        if (!axis.hide && axisType === 'xAxis') steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return $7dad4d5151ba4a01$var$_objectSpread($7dad4d5151ba4a01$var$_objectSpread({}, result), {}, $7dad4d5151ba4a01$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $7dad4d5151ba4a01$export$c7964a5b9439ae62 = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $7dad4d5151ba4a01$export$6df2062b9e15eec0 = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return $7dad4d5151ba4a01$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var $7dad4d5151ba4a01$export$dae1ac4449a69ee8 = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        $7dad4d5151ba4a01$var$_classCallCheck(this, ScaleHelper);
        this.scale = scale;
    }
    return $7dad4d5151ba4a01$var$_createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case 'start':
                        return this.scale(value);
                    case 'middle':
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case 'end':
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
}();
$7dad4d5151ba4a01$var$_defineProperty($7dad4d5151ba4a01$export$dae1ac4449a69ee8, "EPS", 1e-4);
var $7dad4d5151ba4a01$export$db77ae668c18269f = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return $7dad4d5151ba4a01$var$_objectSpread($7dad4d5151ba4a01$var$_objectSpread({}, res), {}, $7dad4d5151ba4a01$var$_defineProperty({}, key, $7dad4d5151ba4a01$export$dae1ac4449a69ee8.create(options[key])));
    }, {});
    return $7dad4d5151ba4a01$var$_objectSpread($7dad4d5151ba4a01$var$_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, (/*@__PURE__*/$parcel$interopDefault($17211428bc2045c4$exports)))(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($b3635322c399904d$exports)))(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};
function $7dad4d5151ba4a01$export$e3df76cf4464bc81(angle) {
    return (angle % 180 + 180) % 180;
}
var $7dad4d5151ba4a01$export$3ee78d51cffc2b68 = function getAngledRectangleWidth(_ref6) {
    var width = _ref6.width, height = _ref6.height;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = $7dad4d5151ba4a01$export$e3df76cf4464bc81(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};




function $9ea7041db7d573c0$var$_extends() {
    $9ea7041db7d573c0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9ea7041db7d573c0$var$_extends.apply(this, arguments);
}
function $9ea7041db7d573c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9ea7041db7d573c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9ea7041db7d573c0$var$_typeof(o);
}
function $9ea7041db7d573c0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9ea7041db7d573c0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9ea7041db7d573c0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9ea7041db7d573c0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9ea7041db7d573c0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9ea7041db7d573c0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9ea7041db7d573c0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $9ea7041db7d573c0$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $9ea7041db7d573c0$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9ea7041db7d573c0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9ea7041db7d573c0$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $9ea7041db7d573c0$var$_callSuper(t, o, e) {
    return o = $9ea7041db7d573c0$var$_getPrototypeOf(o), $9ea7041db7d573c0$var$_possibleConstructorReturn(t, $9ea7041db7d573c0$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $9ea7041db7d573c0$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $9ea7041db7d573c0$var$_possibleConstructorReturn(self, call) {
    if (call && ($9ea7041db7d573c0$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $9ea7041db7d573c0$var$_assertThisInitialized(self);
}
function $9ea7041db7d573c0$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9ea7041db7d573c0$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9ea7041db7d573c0$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $9ea7041db7d573c0$var$_getPrototypeOf(o) {
    $9ea7041db7d573c0$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9ea7041db7d573c0$var$_getPrototypeOf(o);
}
function $9ea7041db7d573c0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $9ea7041db7d573c0$var$_setPrototypeOf(subClass, superClass);
}
function $9ea7041db7d573c0$var$_setPrototypeOf(o, p) {
    $9ea7041db7d573c0$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9ea7041db7d573c0$var$_setPrototypeOf(o, p);
}
function $9ea7041db7d573c0$var$_defineProperty(obj, key, value) {
    key = $9ea7041db7d573c0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9ea7041db7d573c0$var$_toPropertyKey(t) {
    var i = $9ea7041db7d573c0$var$_toPrimitive(t, "string");
    return "symbol" == $9ea7041db7d573c0$var$_typeof(i) ? i : i + "";
}
function $9ea7041db7d573c0$var$_toPrimitive(t, r) {
    if ("object" != $9ea7041db7d573c0$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9ea7041db7d573c0$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $9ea7041db7d573c0$var$getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, $7dad4d5151ba4a01$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, $8ca5391289a51027$export$3fb112445eb31879)(props, 'discard') && !scales.isInRange(result)) return null;
    return result;
};
var $9ea7041db7d573c0$export$aa7f0b0106bff39 = /*#__PURE__*/ function(_React$Component) {
    function ReferenceDot() {
        $9ea7041db7d573c0$var$_classCallCheck(this, ReferenceDot);
        return $9ea7041db7d573c0$var$_callSuper(this, ReferenceDot, arguments);
    }
    $9ea7041db7d573c0$var$_inherits(ReferenceDot, _React$Component);
    return $9ea7041db7d573c0$var$_createClass(ReferenceDot, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x = _this$props.x, y = _this$props.y, r = _this$props.r, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
                var isX = (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(x);
                var isY = (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(y);
                (0, $0c26188443d0bc67$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
                if (!isX || !isY) return null;
                var coordinate = $9ea7041db7d573c0$var$getCoordinate(this.props);
                if (!coordinate) return null;
                var cx = coordinate.x, cy = coordinate.y;
                var _this$props2 = this.props, shape = _this$props2.shape, className = _this$props2.className;
                var clipPath = (0, $8ca5391289a51027$export$3fb112445eb31879)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
                var dotProps = $9ea7041db7d573c0$var$_objectSpread($9ea7041db7d573c0$var$_objectSpread({
                    clipPath: clipPath
                }, (0, $008f02516c156322$export$d697c39a2985a4c)(this.props, true)), {}, {
                    cx: cx,
                    cy: cy
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-reference-dot', className)
                }, ReferenceDot.renderDot(shape, dotProps), (0, $77be8884b5ec622c$export$b04be29aa201d4f5).renderCallByParent(this.props, {
                    x: cx - r,
                    y: cy - r,
                    width: 2 * r,
                    height: 2 * r
                }));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$9ea7041db7d573c0$var$_defineProperty($9ea7041db7d573c0$export$aa7f0b0106bff39, "displayName", 'ReferenceDot');
$9ea7041db7d573c0$var$_defineProperty($9ea7041db7d573c0$export$aa7f0b0106bff39, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#fff',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1
});
$9ea7041db7d573c0$var$_defineProperty($9ea7041db7d573c0$export$aa7f0b0106bff39, "renderDot", function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(option)) dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1ab98349969d46e2$export$d046b3c4a416f60d), $9ea7041db7d573c0$var$_extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
});



var $acw62 = parcelRequire("acw62");

var $cde44aad7de4d096$exports = {};


var $8cd52c0fe2cccbdf$exports = {};

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $8cd52c0fe2cccbdf$var$baseSome(collection, predicate) {
    var result;
    $35fa3296f177aa01$exports(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
$8cd52c0fe2cccbdf$exports = $8cd52c0fe2cccbdf$var$baseSome;




/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $cde44aad7de4d096$var$some(collection, predicate, guard) {
    var func = $0488fde9aa355453$exports(collection) ? $aae24ad60cc3cfcb$exports : $8cd52c0fe2cccbdf$exports;
    if (guard && $81b21e8b41d211e8$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $5aba4f6d9f8304a3$exports(predicate, 3));
}
$cde44aad7de4d096$exports = $cde44aad7de4d096$var$some;











var $acw62 = parcelRequire("acw62");

var $6578d05764c8afc8$exports = {};
var $acb3703f94fb96ce$exports = {};



/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $acb3703f94fb96ce$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$ac2c42592aa05543$exports(collection)) {
            var iteratee = $5aba4f6d9f8304a3$exports(predicate, 3);
            collection = $08f0eaf3fbcb2fde$exports(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$acb3703f94fb96ce$exports = $acb3703f94fb96ce$var$createFind;


var $90893b1abc59631b$exports = {};


var $20712de2064d78dd$exports = {};

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $20712de2064d78dd$var$toInteger(value) {
    var result = $6ceabe126a95a54e$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$20712de2064d78dd$exports = $20712de2064d78dd$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $90893b1abc59631b$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $90893b1abc59631b$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $20712de2064d78dd$exports(fromIndex);
    if (index < 0) index = $90893b1abc59631b$var$nativeMax(length + index, 0);
    return $a9e76203bd7c412f$exports(array, $5aba4f6d9f8304a3$exports(predicate, 3), index);
}
$90893b1abc59631b$exports = $90893b1abc59631b$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $6578d05764c8afc8$var$find = $acb3703f94fb96ce$exports($90893b1abc59631b$exports);
$6578d05764c8afc8$exports = $6578d05764c8afc8$var$find;




var $74469ccda5093500$export$7e29f973febe72ad = (0, (/*@__PURE__*/$parcel$interopDefault($17f5c88c594eac51$exports)))(function(offset) {
    return {
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height
    };
}, function(offset) {
    return [
        'l',
        offset.left,
        't',
        offset.top,
        'w',
        offset.width,
        'h',
        offset.height
    ].join('');
});



function $e573f10901a87cfb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e573f10901a87cfb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e573f10901a87cfb$var$_typeof(o);
}
var $e573f10901a87cfb$export$92c2a2c8239475bf = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $e573f10901a87cfb$export$40ceabe61e17c4dc = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $e573f10901a87cfb$export$29b7735f8b5653b2 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $e573f10901a87cfb$export$482c85f2026f212e = /*#__PURE__*/ (0, $acw62.createContext)({});
var $e573f10901a87cfb$export$e42cfe3f3988c70f = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $e573f10901a87cfb$export$b18854f928720bc8 = /*#__PURE__*/ (0, $acw62.createContext)(0);
var $e573f10901a87cfb$export$3c3f0c9338cf7530 = /*#__PURE__*/ (0, $acw62.createContext)(0);
var $e573f10901a87cfb$export$e22c0f72c980af5a = function ChartLayoutContextProvider(props) {
    var _props$state = props.state, xAxisMap = _props$state.xAxisMap, yAxisMap = _props$state.yAxisMap, offset = _props$state.offset, clipPathId = props.clipPathId, children = props.children, width = props.width, height = props.height;
    /**
   * Perhaps we should compute this property when reading? Let's see what is more often used
   */ var viewBox = (0, $74469ccda5093500$export$7e29f973febe72ad)(offset);
    /*
   * This pretends to be a single context but actually is split into multiple smaller ones.
   * Why?
   * Because one React Context only allows to set one value.
   * But we need to set multiple values.
   * If we do that with one context, then we force re-render on components that might not even be interested
   * in the part of the state that has changed.
   *
   * By splitting into smaller contexts, we allow each components to be optimized and only re-render when its dependencies change.
   *
   * To actually achieve the optimal re-render, it is necessary to use React.memo().
   * See the test file for details.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e573f10901a87cfb$export$92c2a2c8239475bf.Provider, {
        value: xAxisMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e573f10901a87cfb$export$40ceabe61e17c4dc.Provider, {
        value: yAxisMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e573f10901a87cfb$export$482c85f2026f212e.Provider, {
        value: offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e573f10901a87cfb$export$29b7735f8b5653b2.Provider, {
        value: viewBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e573f10901a87cfb$export$e42cfe3f3988c70f.Provider, {
        value: clipPathId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e573f10901a87cfb$export$b18854f928720bc8.Provider, {
        value: height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e573f10901a87cfb$export$3c3f0c9338cf7530.Provider, {
        value: width
    }, children)))))));
};
var $e573f10901a87cfb$export$71e825c43eae6ca6 = function useClipPathId() {
    return (0, $acw62.useContext)($e573f10901a87cfb$export$e42cfe3f3988c70f);
};
function $e573f10901a87cfb$var$getKeysForDebug(object) {
    var keys = Object.keys(object);
    if (keys.length === 0) return 'There are no available ids.';
    return "Available ids are: ".concat(keys, ".");
}
var $e573f10901a87cfb$export$54f54805c81085c5 = function useXAxisOrThrow(xAxisId) {
    var xAxisMap = (0, $acw62.useContext)($e573f10901a87cfb$export$92c2a2c8239475bf);
    !(xAxisMap != null) && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
    var xAxis = xAxisMap[xAxisId];
    !(xAxis != null) && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
    return xAxis;
};
var $e573f10901a87cfb$export$1d855c2865750a72 = function useArbitraryXAxis() {
    var xAxisMap = (0, $acw62.useContext)($e573f10901a87cfb$export$92c2a2c8239475bf);
    return (0, $2ab3a7e25c8aba74$export$b88993f0aa0bf776)(xAxisMap);
};
var $e573f10901a87cfb$export$a691147b33d52613 = function useArbitraryYAxis() {
    var yAxisMap = (0, $acw62.useContext)($e573f10901a87cfb$export$40ceabe61e17c4dc);
    return (0, $2ab3a7e25c8aba74$export$b88993f0aa0bf776)(yAxisMap);
};
var $e573f10901a87cfb$export$631ee617f1052e16 = function useYAxisWithFiniteDomainOrRandom() {
    var yAxisMap = (0, $acw62.useContext)($e573f10901a87cfb$export$40ceabe61e17c4dc);
    var yAxisWithFiniteDomain = (0, (/*@__PURE__*/$parcel$interopDefault($6578d05764c8afc8$exports)))(yAxisMap, function(axis) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($b3635322c399904d$exports)))(axis.domain, Number.isFinite);
    });
    return yAxisWithFiniteDomain || (0, $2ab3a7e25c8aba74$export$b88993f0aa0bf776)(yAxisMap);
};
var $e573f10901a87cfb$export$6f8958021ad81c20 = function useYAxisOrThrow(yAxisId) {
    var yAxisMap = (0, $acw62.useContext)($e573f10901a87cfb$export$40ceabe61e17c4dc);
    !(yAxisMap != null) && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
    var yAxis = yAxisMap[yAxisId];
    !(yAxis != null) && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
    return yAxis;
};
var $e573f10901a87cfb$export$76b29bb074e0c45a = function useViewBox() {
    var viewBox = (0, $acw62.useContext)($e573f10901a87cfb$export$29b7735f8b5653b2);
    return viewBox;
};
var $e573f10901a87cfb$export$99e5207fa7e69f17 = function useOffset() {
    return (0, $acw62.useContext)($e573f10901a87cfb$export$482c85f2026f212e);
};
var $e573f10901a87cfb$export$8854f7ece606854b = function useChartWidth() {
    return (0, $acw62.useContext)($e573f10901a87cfb$export$3c3f0c9338cf7530);
};
var $e573f10901a87cfb$export$369ae257969c6f9f = function useChartHeight() {
    return (0, $acw62.useContext)($e573f10901a87cfb$export$b18854f928720bc8);
};


function $c541166c885e1544$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c541166c885e1544$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c541166c885e1544$var$_typeof(o);
}
function $c541166c885e1544$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c541166c885e1544$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c541166c885e1544$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c541166c885e1544$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c541166c885e1544$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c541166c885e1544$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c541166c885e1544$var$_callSuper(t, o, e) {
    return o = $c541166c885e1544$var$_getPrototypeOf(o), $c541166c885e1544$var$_possibleConstructorReturn(t, $c541166c885e1544$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $c541166c885e1544$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $c541166c885e1544$var$_possibleConstructorReturn(self, call) {
    if (call && ($c541166c885e1544$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c541166c885e1544$var$_assertThisInitialized(self);
}
function $c541166c885e1544$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c541166c885e1544$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c541166c885e1544$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $c541166c885e1544$var$_getPrototypeOf(o) {
    $c541166c885e1544$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c541166c885e1544$var$_getPrototypeOf(o);
}
function $c541166c885e1544$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c541166c885e1544$var$_setPrototypeOf(subClass, superClass);
}
function $c541166c885e1544$var$_setPrototypeOf(o, p) {
    $c541166c885e1544$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c541166c885e1544$var$_setPrototypeOf(o, p);
}
function $c541166c885e1544$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c541166c885e1544$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c541166c885e1544$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c541166c885e1544$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c541166c885e1544$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c541166c885e1544$var$_defineProperty(obj, key, value) {
    key = $c541166c885e1544$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c541166c885e1544$var$_toPropertyKey(t) {
    var i = $c541166c885e1544$var$_toPrimitive(t, "string");
    return "symbol" == $c541166c885e1544$var$_typeof(i) ? i : i + "";
}
function $c541166c885e1544$var$_toPrimitive(t, r) {
    if ("object" != $c541166c885e1544$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c541166c885e1544$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c541166c885e1544$var$_slicedToArray(arr, i) {
    return $c541166c885e1544$var$_arrayWithHoles(arr) || $c541166c885e1544$var$_iterableToArrayLimit(arr, i) || $c541166c885e1544$var$_unsupportedIterableToArray(arr, i) || $c541166c885e1544$var$_nonIterableRest();
}
function $c541166c885e1544$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c541166c885e1544$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c541166c885e1544$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c541166c885e1544$var$_arrayLikeToArray(o, minLen);
}
function $c541166c885e1544$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c541166c885e1544$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $c541166c885e1544$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c541166c885e1544$var$_extends() {
    $c541166c885e1544$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c541166c885e1544$var$_extends.apply(this, arguments);
}
/**
 * This excludes `viewBox` prop from svg for two reasons:
 * 1. The components wants viewBox of object type, and svg wants string
 *    - so there's a conflict, and the component will throw if it gets string
 * 2. Internally the component calls `filterProps` which filters the viewBox away anyway
 */ var $c541166c885e1544$var$renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(option)) line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(option)) line = option(props);
    else line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", $c541166c885e1544$var$_extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
};
var $c541166c885e1544$export$f273d496b213b6da = function getEndPoints(scales, isFixedX, isFixedY, isSegment, viewBox, position, xAxisOrientation, yAxisOrientation, props) {
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (isFixedY) {
        var yCoord = props.y;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, $8ca5391289a51027$export$3fb112445eb31879)(props, 'discard') && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return yAxisOrientation === 'left' ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, $8ca5391289a51027$export$3fb112445eb31879)(props, 'discard') && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return xAxisOrientation === 'top' ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, $8ca5391289a51027$export$3fb112445eb31879)(props, 'discard') && (0, (/*@__PURE__*/$parcel$interopDefault($cde44aad7de4d096$exports)))(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function $c541166c885e1544$var$ReferenceLineImpl(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxisId = props.xAxisId, yAxisId = props.yAxisId, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow;
    var clipPathId = (0, $e573f10901a87cfb$export$71e825c43eae6ca6)();
    var xAxis = (0, $e573f10901a87cfb$export$54f54805c81085c5)(xAxisId);
    var yAxis = (0, $e573f10901a87cfb$export$6f8958021ad81c20)(yAxisId);
    var viewBox = (0, $e573f10901a87cfb$export$76b29bb074e0c45a)();
    if (!clipPathId || !viewBox) return null;
    (0, $0c26188443d0bc67$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, $7dad4d5151ba4a01$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(fixedX);
    var isY = (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = $c541166c885e1544$export$f273d496b213b6da(scales, isX, isY, isSegment, viewBox, props.position, xAxis.orientation, yAxis.orientation, props);
    if (!endPoints) return null;
    var _endPoints = $c541166c885e1544$var$_slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, $8ca5391289a51027$export$3fb112445eb31879)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = $c541166c885e1544$var$_objectSpread($c541166c885e1544$var$_objectSpread({
        clipPath: clipPath
    }, (0, $008f02516c156322$export$d697c39a2985a4c)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-reference-line', className)
    }, $c541166c885e1544$var$renderLine(shape, lineProps), (0, $77be8884b5ec622c$export$b04be29aa201d4f5).renderCallByParent(props, (0, $7dad4d5151ba4a01$export$6df2062b9e15eec0)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
var $c541166c885e1544$export$b2f28e248e7838eb = /*#__PURE__*/ function(_React$Component) {
    function ReferenceLine() {
        $c541166c885e1544$var$_classCallCheck(this, ReferenceLine);
        return $c541166c885e1544$var$_callSuper(this, ReferenceLine, arguments);
    }
    $c541166c885e1544$var$_inherits(ReferenceLine, _React$Component);
    return $c541166c885e1544$var$_createClass(ReferenceLine, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c541166c885e1544$var$ReferenceLineImpl, this.props);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$c541166c885e1544$var$_defineProperty($c541166c885e1544$export$b2f28e248e7838eb, "displayName", 'ReferenceLine');
$c541166c885e1544$var$_defineProperty($c541166c885e1544$export$b2f28e248e7838eb, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    fill: 'none',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1,
    position: 'middle'
});



var $acw62 = parcelRequire("acw62");










function $ab818fa12c183ba2$var$_extends() {
    $ab818fa12c183ba2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ab818fa12c183ba2$var$_extends.apply(this, arguments);
}
function $ab818fa12c183ba2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ab818fa12c183ba2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ab818fa12c183ba2$var$_typeof(o);
}
function $ab818fa12c183ba2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ab818fa12c183ba2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ab818fa12c183ba2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ab818fa12c183ba2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ab818fa12c183ba2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ab818fa12c183ba2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ab818fa12c183ba2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $ab818fa12c183ba2$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $ab818fa12c183ba2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ab818fa12c183ba2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ab818fa12c183ba2$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ab818fa12c183ba2$var$_callSuper(t, o, e) {
    return o = $ab818fa12c183ba2$var$_getPrototypeOf(o), $ab818fa12c183ba2$var$_possibleConstructorReturn(t, $ab818fa12c183ba2$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $ab818fa12c183ba2$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $ab818fa12c183ba2$var$_possibleConstructorReturn(self, call) {
    if (call && ($ab818fa12c183ba2$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ab818fa12c183ba2$var$_assertThisInitialized(self);
}
function $ab818fa12c183ba2$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ab818fa12c183ba2$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ab818fa12c183ba2$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ab818fa12c183ba2$var$_getPrototypeOf(o) {
    $ab818fa12c183ba2$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ab818fa12c183ba2$var$_getPrototypeOf(o);
}
function $ab818fa12c183ba2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $ab818fa12c183ba2$var$_setPrototypeOf(subClass, superClass);
}
function $ab818fa12c183ba2$var$_setPrototypeOf(o, p) {
    $ab818fa12c183ba2$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ab818fa12c183ba2$var$_setPrototypeOf(o, p);
}
function $ab818fa12c183ba2$var$_defineProperty(obj, key, value) {
    key = $ab818fa12c183ba2$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ab818fa12c183ba2$var$_toPropertyKey(t) {
    var i = $ab818fa12c183ba2$var$_toPrimitive(t, "string");
    return "symbol" == $ab818fa12c183ba2$var$_typeof(i) ? i : i + "";
}
function $ab818fa12c183ba2$var$_toPrimitive(t, r) {
    if ("object" != $ab818fa12c183ba2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ab818fa12c183ba2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $ab818fa12c183ba2$var$getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, $7dad4d5151ba4a01$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: 'start'
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: 'start'
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: 'end'
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: 'end'
        }) : scales.y.rangeMax
    };
    if ((0, $8ca5391289a51027$export$3fb112445eb31879)(props, 'discard') && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, $7dad4d5151ba4a01$export$c7964a5b9439ae62)(p1, p2);
};
var $ab818fa12c183ba2$export$b4ec4f050ce240b9 = /*#__PURE__*/ function(_React$Component) {
    function ReferenceArea() {
        $ab818fa12c183ba2$var$_classCallCheck(this, ReferenceArea);
        return $ab818fa12c183ba2$var$_callSuper(this, ReferenceArea, arguments);
    }
    $ab818fa12c183ba2$var$_inherits(ReferenceArea, _React$Component);
    return $ab818fa12c183ba2$var$_createClass(ReferenceArea, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x1 = _this$props.x1, x2 = _this$props.x2, y1 = _this$props.y1, y2 = _this$props.y2, className = _this$props.className, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
                (0, $0c26188443d0bc67$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
                var hasX1 = (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(x1);
                var hasX2 = (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(x2);
                var hasY1 = (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(y1);
                var hasY2 = (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(y2);
                var shape = this.props.shape;
                if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
                var rect = $ab818fa12c183ba2$var$getRect(hasX1, hasX2, hasY1, hasY2, this.props);
                if (!rect && !shape) return null;
                var clipPath = (0, $8ca5391289a51027$export$3fb112445eb31879)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-reference-area', className)
                }, ReferenceArea.renderRect(shape, $ab818fa12c183ba2$var$_objectSpread($ab818fa12c183ba2$var$_objectSpread({
                    clipPath: clipPath
                }, (0, $008f02516c156322$export$d697c39a2985a4c)(this.props, true)), rect)), (0, $77be8884b5ec622c$export$b04be29aa201d4f5).renderCallByParent(this.props, rect));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$ab818fa12c183ba2$var$_defineProperty($ab818fa12c183ba2$export$b4ec4f050ce240b9, "displayName", 'ReferenceArea');
$ab818fa12c183ba2$var$_defineProperty($ab818fa12c183ba2$export$b4ec4f050ce240b9, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#ccc',
    fillOpacity: 0.5,
    stroke: 'none',
    strokeWidth: 1
});
$ab818fa12c183ba2$var$_defineProperty($ab818fa12c183ba2$export$b4ec4f050ce240b9, "renderRect", function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(option)) rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $70f75e095c9bb92d$export$4617fb02663045ef), $ab818fa12c183ba2$var$_extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
});





function $e8f3ee16c7c854b9$var$_toConsumableArray(arr) {
    return $e8f3ee16c7c854b9$var$_arrayWithoutHoles(arr) || $e8f3ee16c7c854b9$var$_iterableToArray(arr) || $e8f3ee16c7c854b9$var$_unsupportedIterableToArray(arr) || $e8f3ee16c7c854b9$var$_nonIterableSpread();
}
function $e8f3ee16c7c854b9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e8f3ee16c7c854b9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e8f3ee16c7c854b9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e8f3ee16c7c854b9$var$_arrayLikeToArray(o, minLen);
}
function $e8f3ee16c7c854b9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $e8f3ee16c7c854b9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $e8f3ee16c7c854b9$var$_arrayLikeToArray(arr);
}
function $e8f3ee16c7c854b9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $e8f3ee16c7c854b9$export$62ecf5c04b491381 = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, $008f02516c156322$export$fdd5e64c0e8495bb)(children, (0, $c541166c885e1544$export$b2f28e248e7838eb));
    var dots = (0, $008f02516c156322$export$fdd5e64c0e8495bb)(children, (0, $9ea7041db7d573c0$export$aa7f0b0106bff39));
    var elements = [].concat($e8f3ee16c7c854b9$var$_toConsumableArray(lines), $e8f3ee16c7c854b9$var$_toConsumableArray(dots));
    var areas = (0, $008f02516c156322$export$fdd5e64c0e8495bb)(children, (0, $ab818fa12c183ba2$export$b4ec4f050ce240b9));
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, $8ca5391289a51027$export$3fb112445eb31879)(el.props, 'extendDomain') && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, $8ca5391289a51027$export$3fb112445eb31879)(el.props, 'extendDomain') && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(el.props[key1]) && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};




var $28edd11f6c7e9f5f$exports = {};
'use strict';
var $28edd11f6c7e9f5f$var$has = Object.prototype.hasOwnProperty, $28edd11f6c7e9f5f$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $28edd11f6c7e9f5f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $28edd11f6c7e9f5f$var$Events().__proto__) $28edd11f6c7e9f5f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $28edd11f6c7e9f5f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $28edd11f6c7e9f5f$var$EE(fn, context || emitter, once), evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $28edd11f6c7e9f5f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $28edd11f6c7e9f5f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $28edd11f6c7e9f5f$var$EventEmitter() {
    this._events = new $28edd11f6c7e9f5f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($28edd11f6c7e9f5f$var$has.call(events, name)) names.push($28edd11f6c7e9f5f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $28edd11f6c7e9f5f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
        if (this._events[evt]) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        this._events = new $28edd11f6c7e9f5f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$28edd11f6c7e9f5f$var$EventEmitter.prototype.off = $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener;
$28edd11f6c7e9f5f$var$EventEmitter.prototype.addListener = $28edd11f6c7e9f5f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$28edd11f6c7e9f5f$var$EventEmitter.prefixed = $28edd11f6c7e9f5f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$28edd11f6c7e9f5f$var$EventEmitter.EventEmitter = $28edd11f6c7e9f5f$var$EventEmitter;
$28edd11f6c7e9f5f$exports = $28edd11f6c7e9f5f$var$EventEmitter;


var $bbd08cd38300f8df$export$9bcdfe5f29bb33 = new (0, (/*@__PURE__*/$parcel$interopDefault($28edd11f6c7e9f5f$exports)))();
var $bbd08cd38300f8df$export$ff9a08f6d0c38b8f = 'recharts.syncMouseEvents';



function $bde81ec92d1b0fae$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $bde81ec92d1b0fae$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $bde81ec92d1b0fae$var$_typeof(o);
}
function $bde81ec92d1b0fae$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bde81ec92d1b0fae$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $bde81ec92d1b0fae$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $bde81ec92d1b0fae$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bde81ec92d1b0fae$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bde81ec92d1b0fae$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $bde81ec92d1b0fae$var$_defineProperty(obj, key, value) {
    key = $bde81ec92d1b0fae$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bde81ec92d1b0fae$var$_toPropertyKey(t) {
    var i = $bde81ec92d1b0fae$var$_toPrimitive(t, "string");
    return "symbol" == $bde81ec92d1b0fae$var$_typeof(i) ? i : i + "";
}
function $bde81ec92d1b0fae$var$_toPrimitive(t, r) {
    if ("object" != $bde81ec92d1b0fae$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $bde81ec92d1b0fae$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $bde81ec92d1b0fae$export$a2c2de1efa8671eb = /*#__PURE__*/ function() {
    function AccessibilityManager() {
        $bde81ec92d1b0fae$var$_classCallCheck(this, AccessibilityManager);
        $bde81ec92d1b0fae$var$_defineProperty(this, "activeIndex", 0);
        $bde81ec92d1b0fae$var$_defineProperty(this, "coordinateList", []);
        $bde81ec92d1b0fae$var$_defineProperty(this, "layout", 'horizontal');
    }
    return $bde81ec92d1b0fae$var$_createClass(AccessibilityManager, [
        {
            key: "setDetails",
            value: function setDetails(_ref) {
                var _ref2;
                var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? null : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
                this.coordinateList = (_ref2 = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList) !== null && _ref2 !== void 0 ? _ref2 : [];
                this.container = container !== null && container !== void 0 ? container : this.container;
                this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
                this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
                this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
                // Keep activeIndex in the bounds between 0 and the last coordinate index
                this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.spoofMouse();
            }
        },
        {
            key: "keyboardEvent",
            value: function keyboardEvent(e) {
                // The AccessibilityManager relies on the Tooltip component. When tooltips suddenly stop existing,
                // it can cause errors. We use this function to check. We don't want arrow keys to be processed
                // if there are no tooltips, since that will cause unexpected behavior of users.
                if (this.coordinateList.length === 0) return;
                switch(e.key){
                    case 'ArrowRight':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
                        this.spoofMouse();
                        break;
                    case 'ArrowLeft':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.max(this.activeIndex - 1, 0);
                        this.spoofMouse();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "setIndex",
            value: function setIndex(newIndex) {
                this.activeIndex = newIndex;
            }
        },
        {
            key: "spoofMouse",
            value: function spoofMouse() {
                var _window, _window2;
                if (this.layout !== 'horizontal') return;
                // This can happen when the tooltips suddenly stop existing as children of the component
                // That update doesn't otherwise fire events, so we have to double check here.
                if (this.coordinateList.length === 0) return;
                var _this$container$getBo = this.container.getBoundingClientRect(), x = _this$container$getBo.x, y = _this$container$getBo.y, height = _this$container$getBo.height;
                var coordinate = this.coordinateList[this.activeIndex].coordinate;
                var scrollOffsetX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
                var scrollOffsetY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
                var pageX = x + coordinate + scrollOffsetX;
                var pageY = y + this.offset.top + height / 2 + scrollOffsetY;
                this.mouseHandlerCallback({
                    pageX: pageX,
                    pageY: pageY
                });
            }
        }
    ]);
}();



function $77a63a99eb6fec8b$export$33279f645a5831b7(domain, allowDataOverflow, axisType) {
    if (axisType === 'number' && allowDataOverflow === true && Array.isArray(domain)) {
        var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
        var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
        /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */ if (!!domainStart && !!domainEnd && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(domainStart) && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(domainEnd)) return true;
    }
    return false;
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");







function $af2055905739b7f2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $af2055905739b7f2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $af2055905739b7f2$var$_typeof(o);
}
function $af2055905739b7f2$var$_extends() {
    $af2055905739b7f2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $af2055905739b7f2$var$_extends.apply(this, arguments);
}
function $af2055905739b7f2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $af2055905739b7f2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $af2055905739b7f2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $af2055905739b7f2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $af2055905739b7f2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $af2055905739b7f2$var$_defineProperty(obj, key, value) {
    key = $af2055905739b7f2$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $af2055905739b7f2$var$_toPropertyKey(t) {
    var i = $af2055905739b7f2$var$_toPrimitive(t, "string");
    return "symbol" == $af2055905739b7f2$var$_typeof(i) ? i : i + "";
}
function $af2055905739b7f2$var$_toPrimitive(t, r) {
    if ("object" != $af2055905739b7f2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $af2055905739b7f2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $af2055905739b7f2$var$CURVE_FACTORIES = {
    curveBasisClosed: (0, $9b23116271105198$exports.curveBasisClosed),
    curveBasisOpen: (0, $9b23116271105198$exports.curveBasisOpen),
    curveBasis: (0, $9b23116271105198$exports.curveBasis),
    curveBumpX: (0, $9b23116271105198$exports.curveBumpX),
    curveBumpY: (0, $9b23116271105198$exports.curveBumpY),
    curveLinearClosed: (0, $9b23116271105198$exports.curveLinearClosed),
    curveLinear: (0, $9b23116271105198$exports.curveLinear),
    curveMonotoneX: (0, $9b23116271105198$exports.curveMonotoneX),
    curveMonotoneY: (0, $9b23116271105198$exports.curveMonotoneY),
    curveNatural: (0, $9b23116271105198$exports.curveNatural),
    curveStep: (0, $9b23116271105198$exports.curveStep),
    curveStepAfter: (0, $9b23116271105198$exports.curveStepAfter),
    curveStepBefore: (0, $9b23116271105198$exports.curveStepBefore)
};
var $af2055905739b7f2$var$defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var $af2055905739b7f2$var$getX = function getX(p) {
    return p.x;
};
var $af2055905739b7f2$var$getY = function getY(p) {
    return p.y;
};
var $af2055905739b7f2$var$getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(type)) return type;
    var name = "curve".concat((0, (/*@__PURE__*/$parcel$interopDefault($da6130e1e4702e32$exports)))(type));
    if ((name === 'curveMonotone' || name === 'curveBump') && layout) return $af2055905739b7f2$var$CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
    return $af2055905739b7f2$var$CURVE_FACTORIES[name] || (0, $9b23116271105198$exports.curveLinear);
};
var $af2055905739b7f2$export$2aa3fd96c49a84a8 = function getPath(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'linear' : _ref$type, _ref$points = _ref.points, points = _ref$points === void 0 ? [] : _ref$points, baseLine = _ref.baseLine, layout = _ref.layout, _ref$connectNulls = _ref.connectNulls, connectNulls = _ref$connectNulls === void 0 ? false : _ref$connectNulls;
    var curveFactory = $af2055905739b7f2$var$getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(function(entry) {
        return $af2055905739b7f2$var$defined(entry);
    }) : points;
    var lineFunction;
    if (Array.isArray(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
            return $af2055905739b7f2$var$defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function(entry, index) {
            return $af2055905739b7f2$var$_objectSpread($af2055905739b7f2$var$_objectSpread({}, entry), {}, {
                base: formatBaseLine[index]
            });
        });
        if (layout === 'vertical') lineFunction = (0, $9b23116271105198$exports.area)().y($af2055905739b7f2$var$getY).x1($af2055905739b7f2$var$getX).x0(function(d) {
            return d.base.x;
        });
        else lineFunction = (0, $9b23116271105198$exports.area)().x($af2055905739b7f2$var$getX).y1($af2055905739b7f2$var$getY).y0(function(d) {
            return d.base.y;
        });
        lineFunction.defined($af2055905739b7f2$var$defined).curve(curveFactory);
        return lineFunction(areaPoints);
    }
    if (layout === 'vertical' && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $9b23116271105198$exports.area)().y($af2055905739b7f2$var$getY).x1($af2055905739b7f2$var$getX).x0(baseLine);
    else if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $9b23116271105198$exports.area)().x($af2055905739b7f2$var$getX).y1($af2055905739b7f2$var$getY).y0(baseLine);
    else lineFunction = (0, $9b23116271105198$exports.line)().x($af2055905739b7f2$var$getX).y($af2055905739b7f2$var$getY);
    lineFunction.defined($af2055905739b7f2$var$defined).curve(curveFactory);
    return lineFunction(formatPoints);
};
var $af2055905739b7f2$export$b0e83c3ef8d2db1 = function Curve(props) {
    var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
    if ((!points || !points.length) && !path) return null;
    var realPath = points && points.length ? $af2055905739b7f2$export$2aa3fd96c49a84a8(props) : path;
    return /*#__PURE__*/ $acw62.createElement("path", $af2055905739b7f2$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(props, false), (0, $909d5f835f4e917b$export$7c4c290a4a9c1b1e)(props), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-curve', className),
        d: realPath,
        ref: pathRef
    }));
};



var $acw62 = parcelRequire("acw62");



function $2ae8a72d4579aba0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2ae8a72d4579aba0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2ae8a72d4579aba0$var$_typeof(o);
}
var $2ae8a72d4579aba0$var$_excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function $2ae8a72d4579aba0$var$_extends() {
    $2ae8a72d4579aba0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2ae8a72d4579aba0$var$_extends.apply(this, arguments);
}
function $2ae8a72d4579aba0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2ae8a72d4579aba0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2ae8a72d4579aba0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2ae8a72d4579aba0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2ae8a72d4579aba0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2ae8a72d4579aba0$var$_defineProperty(obj, key, value) {
    key = $2ae8a72d4579aba0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2ae8a72d4579aba0$var$_toPropertyKey(t) {
    var i = $2ae8a72d4579aba0$var$_toPrimitive(t, "string");
    return "symbol" == $2ae8a72d4579aba0$var$_typeof(i) ? i : i + "";
}
function $2ae8a72d4579aba0$var$_toPrimitive(t, r) {
    if ("object" != $2ae8a72d4579aba0$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2ae8a72d4579aba0$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2ae8a72d4579aba0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2ae8a72d4579aba0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2ae8a72d4579aba0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $2ae8a72d4579aba0$var$getPath = function getPath(x, y, width, height, top, left) {
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var $2ae8a72d4579aba0$export$3c877bb842c36952 = function Cross(_ref) {
    var _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$width = _ref.width, width = _ref$width === void 0 ? 0 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 0 : _ref$height, className = _ref.className, rest = $2ae8a72d4579aba0$var$_objectWithoutProperties(_ref, $2ae8a72d4579aba0$var$_excluded);
    var props = $2ae8a72d4579aba0$var$_objectSpread({
        x: x,
        y: y,
        top: top,
        left: left,
        width: width,
        height: height
    }, rest);
    if (!(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(x) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(y) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(width) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(height) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(top) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(left)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", $2ae8a72d4579aba0$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(props, true), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-cross', className),
        d: $2ae8a72d4579aba0$var$getPath(x, y, width, height, top, left)
    }));
};


function $f95663c86cd8230d$export$f84ec1ecc69a13c9(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: 'none',
        fill: '#ccc',
        x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
        height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
    };
}




function $2f00d3350e823531$export$ad661ef85a042a4f(activeCoordinate) {
    var cx = activeCoordinate.cx, cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
    var startPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, radius, startAngle);
    var endPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx: cx,
        cy: cy,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}





function $747acf019ef7786e$export$56e1305620ce5745(layout, activeCoordinate, offset) {
    var x1, y1, x2, y2;
    if (layout === 'horizontal') {
        x1 = activeCoordinate.x;
        x2 = x1;
        y1 = offset.top;
        y2 = offset.top + offset.height;
    } else if (layout === 'vertical') {
        y1 = activeCoordinate.y;
        y2 = y1;
        x1 = offset.left;
        x2 = offset.left + offset.width;
    } else if (activeCoordinate.cx != null && activeCoordinate.cy != null) {
        if (layout === 'centric') {
            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
            var innerPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, innerRadius, angle);
            var outerPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, outerRadius, angle);
            x1 = innerPoint.x;
            y1 = innerPoint.y;
            x2 = outerPoint.x;
            y2 = outerPoint.y;
        } else return (0, $2f00d3350e823531$export$ad661ef85a042a4f)(activeCoordinate);
    }
    return [
        {
            x: x1,
            y: y1
        },
        {
            x: x2,
            y: y2
        }
    ];
}



function $d690e81478a10d12$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d690e81478a10d12$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d690e81478a10d12$var$_typeof(o);
}
function $d690e81478a10d12$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d690e81478a10d12$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d690e81478a10d12$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d690e81478a10d12$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d690e81478a10d12$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d690e81478a10d12$var$_defineProperty(obj, key, value) {
    key = $d690e81478a10d12$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d690e81478a10d12$var$_toPropertyKey(t) {
    var i = $d690e81478a10d12$var$_toPrimitive(t, "string");
    return "symbol" == $d690e81478a10d12$var$_typeof(i) ? i : i + "";
}
function $d690e81478a10d12$var$_toPrimitive(t, r) {
    if ("object" != $d690e81478a10d12$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d690e81478a10d12$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d690e81478a10d12$export$b6a79797ad180576(props) {
    var _element$props$cursor, _defaultProps;
    var element = props.element, tooltipEventType = props.tooltipEventType, isActive = props.isActive, activeCoordinate = props.activeCoordinate, activePayload = props.activePayload, offset = props.offset, activeTooltipIndex = props.activeTooltipIndex, tooltipAxisBandSize = props.tooltipAxisBandSize, layout = props.layout, chartName = props.chartName;
    var elementPropsCursor = (_element$props$cursor = element.props.cursor) !== null && _element$props$cursor !== void 0 ? _element$props$cursor : (_defaultProps = element.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps.cursor;
    if (!element || !elementPropsCursor || !isActive || !activeCoordinate || chartName !== 'ScatterChart' && tooltipEventType !== 'axis') return null;
    var restProps;
    var cursorComp = (0, $af2055905739b7f2$export$b0e83c3ef8d2db1);
    if (chartName === 'ScatterChart') {
        restProps = activeCoordinate;
        cursorComp = (0, $2ae8a72d4579aba0$export$3c877bb842c36952);
    } else if (chartName === 'BarChart') {
        restProps = (0, $f95663c86cd8230d$export$f84ec1ecc69a13c9)(layout, activeCoordinate, offset, tooltipAxisBandSize);
        cursorComp = (0, $70f75e095c9bb92d$export$4617fb02663045ef);
    } else if (layout === 'radial') {
        var _getRadialCursorPoint = (0, $2f00d3350e823531$export$ad661ef85a042a4f)(activeCoordinate), cx = _getRadialCursorPoint.cx, cy = _getRadialCursorPoint.cy, radius = _getRadialCursorPoint.radius, startAngle = _getRadialCursorPoint.startAngle, endAngle = _getRadialCursorPoint.endAngle;
        restProps = {
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: radius,
            outerRadius: radius
        };
        cursorComp = (0, $353ca4069312fa59$export$e98c2c7eb2b14f45);
    } else {
        restProps = {
            points: (0, $747acf019ef7786e$export$56e1305620ce5745)(layout, activeCoordinate, offset)
        };
        cursorComp = (0, $af2055905739b7f2$export$b0e83c3ef8d2db1);
    }
    var cursorProps = $d690e81478a10d12$var$_objectSpread($d690e81478a10d12$var$_objectSpread($d690e81478a10d12$var$_objectSpread($d690e81478a10d12$var$_objectSpread({
        stroke: '#ccc',
        pointerEvents: 'none'
    }, offset), restProps), (0, $008f02516c156322$export$d697c39a2985a4c)(elementPropsCursor, false)), {}, {
        payload: activePayload,
        payloadIndex: activeTooltipIndex,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-tooltip-cursor', elementPropsCursor.className)
    });
    return /*#__PURE__*/ (0, $acw62.isValidElement)(elementPropsCursor) ? /*#__PURE__*/ (0, $acw62.cloneElement)(elementPropsCursor, cursorProps) : /*#__PURE__*/ (0, $acw62.createElement)(cursorComp, cursorProps);
}



var $6d459a69f64f5f55$var$_excluded = [
    "item"
], $6d459a69f64f5f55$var$_excluded2 = [
    "children",
    "className",
    "width",
    "height",
    "style",
    "compact",
    "title",
    "desc"
];
function $6d459a69f64f5f55$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6d459a69f64f5f55$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6d459a69f64f5f55$var$_typeof(o);
}
function $6d459a69f64f5f55$var$_extends() {
    $6d459a69f64f5f55$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6d459a69f64f5f55$var$_extends.apply(this, arguments);
}
function $6d459a69f64f5f55$var$_slicedToArray(arr, i) {
    return $6d459a69f64f5f55$var$_arrayWithHoles(arr) || $6d459a69f64f5f55$var$_iterableToArrayLimit(arr, i) || $6d459a69f64f5f55$var$_unsupportedIterableToArray(arr, i) || $6d459a69f64f5f55$var$_nonIterableRest();
}
function $6d459a69f64f5f55$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6d459a69f64f5f55$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $6d459a69f64f5f55$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $6d459a69f64f5f55$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6d459a69f64f5f55$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6d459a69f64f5f55$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6d459a69f64f5f55$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6d459a69f64f5f55$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $6d459a69f64f5f55$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $6d459a69f64f5f55$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6d459a69f64f5f55$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6d459a69f64f5f55$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6d459a69f64f5f55$var$_callSuper(t, o, e) {
    return o = $6d459a69f64f5f55$var$_getPrototypeOf(o), $6d459a69f64f5f55$var$_possibleConstructorReturn(t, $6d459a69f64f5f55$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $6d459a69f64f5f55$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $6d459a69f64f5f55$var$_possibleConstructorReturn(self, call) {
    if (call && ($6d459a69f64f5f55$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $6d459a69f64f5f55$var$_assertThisInitialized(self);
}
function $6d459a69f64f5f55$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6d459a69f64f5f55$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($6d459a69f64f5f55$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $6d459a69f64f5f55$var$_getPrototypeOf(o) {
    $6d459a69f64f5f55$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6d459a69f64f5f55$var$_getPrototypeOf(o);
}
function $6d459a69f64f5f55$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $6d459a69f64f5f55$var$_setPrototypeOf(subClass, superClass);
}
function $6d459a69f64f5f55$var$_setPrototypeOf(o, p) {
    $6d459a69f64f5f55$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6d459a69f64f5f55$var$_setPrototypeOf(o, p);
}
function $6d459a69f64f5f55$var$_toConsumableArray(arr) {
    return $6d459a69f64f5f55$var$_arrayWithoutHoles(arr) || $6d459a69f64f5f55$var$_iterableToArray(arr) || $6d459a69f64f5f55$var$_unsupportedIterableToArray(arr) || $6d459a69f64f5f55$var$_nonIterableSpread();
}
function $6d459a69f64f5f55$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6d459a69f64f5f55$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6d459a69f64f5f55$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6d459a69f64f5f55$var$_arrayLikeToArray(o, minLen);
}
function $6d459a69f64f5f55$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $6d459a69f64f5f55$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $6d459a69f64f5f55$var$_arrayLikeToArray(arr);
}
function $6d459a69f64f5f55$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6d459a69f64f5f55$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6d459a69f64f5f55$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6d459a69f64f5f55$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6d459a69f64f5f55$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6d459a69f64f5f55$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6d459a69f64f5f55$var$_defineProperty(obj, key, value) {
    key = $6d459a69f64f5f55$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6d459a69f64f5f55$var$_toPropertyKey(t) {
    var i = $6d459a69f64f5f55$var$_toPrimitive(t, "string");
    return "symbol" == $6d459a69f64f5f55$var$_typeof(i) ? i : i + "";
}
function $6d459a69f64f5f55$var$_toPrimitive(t, r) {
    if ("object" != $6d459a69f64f5f55$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6d459a69f64f5f55$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $6d459a69f64f5f55$var$ORIENT_MAP = {
    xAxis: [
        'bottom',
        'top'
    ],
    yAxis: [
        'left',
        'right'
    ]
};
var $6d459a69f64f5f55$var$FULL_WIDTH_AND_HEIGHT = {
    width: '100%',
    height: '100%'
};
var $6d459a69f64f5f55$var$originCoordinate = {
    x: 0,
    y: 0
};
/**
 * This function exists as a temporary workaround.
 *
 * Why? generateCategoricalChart does not render `{children}` directly;
 * instead it passes them through `renderByOrder` function which reads their handlers.
 *
 * So, this is a handler that does nothing.
 * Once we get rid of `renderByOrder` and switch to JSX only, we can get rid of this handler too.
 *
 * @param {JSX} element as is in JSX
 * @returns {JSX} the same element
 */ function $6d459a69f64f5f55$var$renderAsIs(element) {
    return element;
}
var $6d459a69f64f5f55$var$calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === 'horizontal') return rangeObj.x;
    if (layout === 'vertical') return rangeObj.y;
    if (layout === 'centric') return rangeObj.angle;
    return rangeObj.radius;
};
var $6d459a69f64f5f55$var$getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === 'horizontal') return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === 'vertical') return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === 'centric') {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, rangeObj), (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, rangeObj), (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return $6d459a69f64f5f55$var$originCoordinate;
};
var $6d459a69f64f5f55$var$getDisplayedData = function getDisplayedData(data, _ref) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems !== null && graphicalItems !== void 0 ? graphicalItems : []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat($6d459a69f64f5f55$var$_toConsumableArray(result), $6d459a69f64f5f55$var$_toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData.length > 0) return itemsData;
    if (data && data.length && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(dataStartIndex) && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
function $6d459a69f64f5f55$var$getDefaultDomainByAxisType(axisType) {
    return axisType === 'number' ? [
        0,
        'auto'
    ] : undefined;
}
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var $6d459a69f64f5f55$var$getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = $6d459a69f64f5f55$var$getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
    // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var _child$props$data;
        /**
     * Fixes: https://github.com/recharts/recharts/issues/3669
     * Defaulting to chartData below to fix an edge case where the tooltip does not include data from all charts
     * when a separate dataset is passed to chart prop data and specified on Line/Area/etc prop data
     */ var data = (_child$props$data = child.props.data) !== null && _child$props$data !== void 0 ? _child$props$data : chartData;
        if (data && state.dataStartIndex + state.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
        // The data is sliced only when the active index is within the start/end index range.
        state.dataEndIndex - state.dataStartIndex >= activeIndex) data = data.slice(state.dataStartIndex, state.dataEndIndex + 1);
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, $2ab3a7e25c8aba74$export$66950d3869f5cc67)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat($6d459a69f64f5f55$var$_toConsumableArray(result), [
            (0, $cd015374923bb5c7$export$a4ea3faa19bc2d90)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var $6d459a69f64f5f55$var$getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = $6d459a69f64f5f55$var$calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, $cd015374923bb5c7$export$3071d39cc844078e)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = $6d459a69f64f5f55$var$getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = $6d459a69f64f5f55$var$getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
var $6d459a69f64f5f55$export$7a36da8ad5d1965e = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, $cd015374923bb5c7$export$9fc1baaa6c6368b)(layout, axisType);
    // Eliminate duplicated axes
    return axes.reduce(function(result, child) {
        var _childProps$domain2;
        var childProps = child.type.defaultProps !== undefined ? $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, child.type.defaultProps), child.props) : child.props;
        var type = childProps.type, dataKey = childProps.dataKey, allowDataOverflow = childProps.allowDataOverflow, allowDuplicatedCategory = childProps.allowDuplicatedCategory, scale = childProps.scale, ticks = childProps.ticks, includeHidden = childProps.includeHidden;
        var axisId = childProps[axisIdKey];
        if (result[axisId]) return result;
        var displayedData = $6d459a69f64f5f55$var$getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                var _defaultProps;
                var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps = item.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps[axisIdKey];
                return itemAxisId === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var domain, duplicateDomain, categoricalDomain;
        /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */ if ((0, $77a63a99eb6fec8b$export$33279f645a5831b7)(childProps.domain, allowDataOverflow, type)) {
            domain = (0, $cd015374923bb5c7$export$a0bc8660980558a0)(childProps.domain, null, allowDataOverflow);
            /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */ if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, $cd015374923bb5c7$export$6a1e7873444c95a7)(displayedData, dataKey, 'category');
        }
        // if the domain is defaulted we need this for `originalDomain` as well
        var defaultDomain = $6d459a69f64f5f55$var$getDefaultDomainByAxisType(type);
        // we didn't create the domain from user's props above, so we need to calculate it
        if (!domain || domain.length === 0) {
            var _childProps$domain;
            var childDomain = (_childProps$domain = childProps.domain) !== null && _childProps$domain !== void 0 ? _childProps$domain : defaultDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, $cd015374923bb5c7$export$6a1e7873444c95a7)(displayedData, dataKey, type);
                if (type === 'category' && isCategorical) {
                    // the field type is category data and this axis is categorical axis
                    var duplicate = (0, $2ab3a7e25c8aba74$export$732baf6a98f122)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain;
                        // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, (/*@__PURE__*/$parcel$interopDefault($b392b5b21038a0ce$exports)))(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, $cd015374923bb5c7$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat($6d459a69f64f5f55$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === 'category') {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, $cd015374923bb5c7$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === '' || (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(entry) ? finalDomain : [].concat($6d459a69f64f5f55$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== '' && !(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(entry);
                    });
                } else if (type === 'number') {
                    // the field type is numerical
                    var errorBarsDomain = (0, $cd015374923bb5c7$export$2266342e22c737e8)(displayedData, graphicalItems.filter(function(item) {
                        var _defaultProps2, _defaultProps3;
                        var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps2 = item.type.defaultProps) === null || _defaultProps2 === void 0 ? void 0 : _defaultProps2[axisIdKey];
                        var itemHide = 'hide' in item.props ? item.props.hide : (_defaultProps3 = item.type.defaultProps) === null || _defaultProps3 === void 0 ? void 0 : _defaultProps3.hide;
                        return itemAxisId === axisId && (includeHidden || !itemHide);
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, $cd015374923bb5c7$export$6a1e7873444c95a7)(displayedData, dataKey, 'category');
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, (/*@__PURE__*/$parcel$interopDefault($b392b5b21038a0ce$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === 'expand' ? [
                0,
                1
            ] : (0, $cd015374923bb5c7$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, $cd015374923bb5c7$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : item.type.defaultProps[axisIdKey];
                var itemHide = 'hide' in item.props ? item.props.hide : item.type.defaultProps.hide;
                return itemAxisId === axisId && (includeHidden || !itemHide);
            }), type, layout, true);
            if (type === 'number') {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, $e8f3ee16c7c854b9$export$62ecf5c04b491381)(children, domain, axisId, axisType, ticks);
                if (childDomain) domain = (0, $cd015374923bb5c7$export$a0bc8660980558a0)(childDomain, domain, allowDataOverflow);
            } else if (type === 'category' && childDomain) {
                var axisDomain = childDomain;
                var isDomainValid = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValid) domain = axisDomain;
            }
        }
        return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, result), {}, $6d459a69f64f5f55$var$_defineProperty({}, axisId, $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, childProps), {}, {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain: (_childProps$domain2 = childProps.domain) !== null && _childProps$domain2 !== void 0 ? _childProps$domain2 : defaultDomain,
            isCategorical: isCategorical,
            layout: layout
        })));
    }, {});
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var $6d459a69f64f5f55$var$getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = $6d459a69f64f5f55$var$getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, $cd015374923bb5c7$export$9fc1baaa6c6368b)(layout, axisType);
    var index = -1;
    // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    return graphicalItems.reduce(function(result, child) {
        var childProps = child.type.defaultProps !== undefined ? $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, child.type.defaultProps), child.props) : child.props;
        var axisId = childProps[axisIdKey];
        var originalDomain = $6d459a69f64f5f55$var$getDefaultDomainByAxisType('number');
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, (/*@__PURE__*/$parcel$interopDefault($b392b5b21038a0ce$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, $cd015374923bb5c7$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, $e8f3ee16c7c854b9$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            } else {
                domain = (0, $cd015374923bb5c7$export$a0bc8660980558a0)(originalDomain, (0, $cd015374923bb5c7$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                    var _defaultProps4, _defaultProps5;
                    var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps4 = item.type.defaultProps) === null || _defaultProps4 === void 0 ? void 0 : _defaultProps4[axisIdKey];
                    var itemHide = 'hide' in item.props ? item.props.hide : (_defaultProps5 = item.type.defaultProps) === null || _defaultProps5 === void 0 ? void 0 : _defaultProps5.hide;
                    return itemAxisId === axisId && !itemHide;
                }), 'number', layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, $e8f3ee16c7c854b9$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            }
            return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, result), {}, $6d459a69f64f5f55$var$_defineProperty({}, axisId, $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))($6d459a69f64f5f55$var$ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: originalDomain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {React.ComponentType}  [AxisComp]      Axis Component
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var $6d459a69f64f5f55$var$getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? 'xAxis' : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id");
    // Get all the instance of Axis
    var axes = (0, $008f02516c156322$export$fdd5e64c0e8495bb)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = $6d459a69f64f5f55$export$7a36da8ad5d1965e(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = $6d459a69f64f5f55$var$getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var $6d459a69f64f5f55$var$tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, $2ab3a7e25c8aba74$export$b88993f0aa0bf776)(axisMap);
    var tooltipTicks = (0, $cd015374923bb5c7$export$c829ee42daf7f66d)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, (/*@__PURE__*/$parcel$interopDefault($300ea168693086c2$exports)))(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, $cd015374923bb5c7$export$212ec45c42fe68a7)(axis, tooltipTicks)
    };
};
var $6d459a69f64f5f55$export$e5182fb58612e577 = function createDefaultState(props) {
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, $008f02516c156322$export$64c61536a2b72e0f)(children, (0, $b0c0135ef9d67bd5$export$59bc2e3533b384a0));
    var startIndex = 0;
    var endIndex = 0;
    if (props.data && props.data.length !== 0) endIndex = props.data.length - 1;
    if (brushItem && brushItem.props) {
        if (brushItem.props.startIndex >= 0) startIndex = brushItem.props.startIndex;
        if (brushItem.props.endIndex >= 0) endIndex = brushItem.props.endIndex;
    }
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: Boolean(defaultShowTooltip)
    };
};
var $6d459a69f64f5f55$var$hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, $008f02516c156322$export$be63e0664592e141)(item && item.type);
        return name && name.indexOf('Bar') >= 0;
    });
};
var $6d459a69f64f5f55$var$getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === 'horizontal') return {
        numericAxisName: 'yAxis',
        cateAxisName: 'xAxis'
    };
    if (layout === 'vertical') return {
        numericAxisName: 'xAxis',
        cateAxisName: 'yAxis'
    };
    if (layout === 'centric') return {
        numericAxisName: 'radiusAxis',
        cateAxisName: 'angleAxis'
    };
    return {
        numericAxisName: 'angleAxis',
        cateAxisName: 'radiusAxis'
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} params.props          Latest props
 * @param  {Array}  params.graphicalItems The instances of item
 * @param  {Object} params.xAxisMap       The configuration of x-axis
 * @param  {Object} params.yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox        The boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var $6d459a69f64f5f55$var$calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, $008f02516c156322$export$64c61536a2b72e0f)(children, (0, $b0c0135ef9d67bd5$export$59bc2e3533b384a0));
    var legendItem = (0, $008f02516c156322$export$64c61536a2b72e0f)(children, (0, $1f4bd73be8c7e839$export$ed247974535929c7));
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, result), {}, $6d459a69f64f5f55$var$_defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, result), {}, $6d459a69f64f5f55$var$_defineProperty({}, orientation, (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, $b0c0135ef9d67bd5$export$59bc2e3533b384a0).defaultProps.height;
    if (legendItem && prevLegendBBox) // @ts-expect-error margin is optional in props but required in appendOffsetOfLegend
    offset = (0, $cd015374923bb5c7$export$3a657a8c9f789617)(offset, graphicalItems, props, prevLegendBBox);
    var offsetWidth = width - offset.left - offset.right;
    var offsetHeight = height - offset.top - offset.bottom;
    return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
};
// Determine the size of the axis, used for calculation of relative bar sizes
var $6d459a69f64f5f55$var$getCartesianAxisSize = function getCartesianAxisSize(axisObj, axisName) {
    if (axisName === 'xAxis') return axisObj[axisName].width;
    if (axisName === 'yAxis') return axisObj[axisName].height;
    // This is only supported for Bar charts (i.e. charts with cartesian axes), so we should never get here
    return undefined;
};
var $6d459a69f64f5f55$export$77871aede60e6838 = function generateCategoricalChart(_ref6) {
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? 'axis' : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        'axis'
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = $6d459a69f64f5f55$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = $6d459a69f64f5f55$var$hasGraphicalBarItem(graphicalItems);
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = $6d459a69f64f5f55$var$getDisplayedData(props.data, {
                graphicalItems: [
                    item
                ],
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            });
            var itemProps = item.type.defaultProps !== undefined ? $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
            var dataKey = itemProps.dataKey, childMaxBarSize = itemProps.maxBarSize;
            // axisId of the numerical axis
            var numericAxisId = itemProps["".concat(numericAxisName, "Id")];
            // axisId of the categorical axis
            var cateAxisId = itemProps["".concat(cateAxisName, "Id")];
            var axisObjInitialValue = {};
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _item$type$displayNam, _item$type;
                // map of axisId to axis for a specific axis type
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                // axisId of axis we are currently computing
                var id = itemProps["".concat(entry.axisType, "Id")];
                /**
         * tell the user in dev mode that their configuration is incorrect if we cannot find a match between
         * axisId on the chart and axisId on the axis. zAxis does not get passed in the map for ComposedChart,
         * leave it out of the check for now.
         */ !(axisMap && axisMap[id] || entry.axisType === 'zAxis') && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
                // the axis we are currently formatting
                var axis = axisMap[id];
                return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, result), {}, $6d459a69f64f5f55$var$_defineProperty($6d459a69f64f5f55$var$_defineProperty({}, entry.axisType, axis), "".concat(entry.axisType, "Ticks"), (0, $cd015374923bb5c7$export$c829ee42daf7f66d)(axis)));
            }, axisObjInitialValue);
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, $cd015374923bb5c7$export$a17bf3d98457878c)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, $008f02516c156322$export$be63e0664592e141)(item.type).indexOf('Bar') >= 0;
            var bandSize = (0, $cd015374923bb5c7$export$212ec45c42fe68a7)(cateAxis, cateTicks);
            var barPosition = [];
            var sizeList = hasBar && (0, $cd015374923bb5c7$export$570d306bee26c748)({
                barSize: barSize,
                stackGroups: stackGroups,
                totalSize: $6d459a69f64f5f55$var$getCartesianAxisSize(axisObj, cateAxisName)
            });
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // If it is bar, calculate the position of bar
                var maxBarSize = (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, $cd015374923bb5c7$export$212ec45c42fe68a7)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, $cd015374923bb5c7$export$d36834ecd87f906b)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, pos), {}, {
                        position: $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            // @ts-expect-error we should stop reading data from ReactElements
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) formattedItems.push({
                props: $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, composedFn($6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, axisObj), {}, {
                    displayedData: displayedData,
                    props: props,
                    dataKey: dataKey,
                    item: item,
                    bandSize: bandSize,
                    barPosition: barPosition,
                    offset: offset,
                    stackedData: stackedData,
                    layout: layout,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }))), {}, $6d459a69f64f5f55$var$_defineProperty($6d459a69f64f5f55$var$_defineProperty($6d459a69f64f5f55$var$_defineProperty({
                    key: item.key || "item-".concat(index)
                }, numericAxisName, axisObj[numericAxisName]), cateAxisName, axisObj[cateAxisName]), "animationId", updateId)),
                childIndex: (0, $008f02516c156322$export$857ca101f741953)(item, props.children),
                item: item
            });
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, $008f02516c156322$export$5301de6bfd3cfa2a)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = $6d459a69f64f5f55$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, $008f02516c156322$export$fdd5e64c0e8495bb)(children, GraphicalChild);
        var stackGroups = (0, $cd015374923bb5c7$export$9af3ba56474b9601)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, result), {}, $6d459a69f64f5f55$var$_defineProperty({}, name, $6d459a69f64f5f55$var$getAxisMap(props, $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = $6d459a69f64f5f55$var$calculateOffset($6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = $6d459a69f64f5f55$var$tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    var CategoricalChartWrapper = /*#__PURE__*/ function(_Component) {
        function CategoricalChartWrapper(_props) {
            var _props$id, _props$throttleDelay;
            var _this;
            $6d459a69f64f5f55$var$_classCallCheck(this, CategoricalChartWrapper);
            _this = $6d459a69f64f5f55$var$_callSuper(this, CategoricalChartWrapper, [
                _props
            ]);
            $6d459a69f64f5f55$var$_defineProperty(_this, "eventEmitterSymbol", Symbol('rechartsEventEmitter'));
            $6d459a69f64f5f55$var$_defineProperty(_this, "accessibilityManager", new (0, $bde81ec92d1b0fae$export$a2c2de1efa8671eb)());
            $6d459a69f64f5f55$var$_defineProperty(_this, "handleLegendBBoxUpdate", function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState($6d459a69f64f5f55$var$_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "handleReceiveSyncEvent", function(cId, data, emitter) {
                if (_this.props.syncId === cId) {
                    if (emitter === _this.eventEmitterSymbol && typeof _this.props.syncMethod !== 'function') return;
                    _this.applySyncEvent(data);
                }
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "handleBrushChange", function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return $6d459a69f64f5f55$var$_objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            });
            /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */ $6d459a69f64f5f55$var$_defineProperty(_this, "handleMouseEnter", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    var onMouseEnter = _this.props.onMouseEnter;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "triggeredAfterMouseMove", function(e) {
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseMove = _this.props.onMouseMove;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(onMouseMove)) onMouseMove(nextState, e);
            });
            /**
       * The handler of mouse entering a scatter
       * @param {Object} el The active scatter
       * @return {Object} no return
       */ $6d459a69f64f5f55$var$_defineProperty(_this, "handleItemMouseEnter", function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            });
            /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */ $6d459a69f64f5f55$var$_defineProperty(_this, "handleItemMouseLeave", function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            });
            /**
       * The handler of mouse moving in chart
       * @param  {React.MouseEvent} e        Event object
       * @return {void} no return
       */ $6d459a69f64f5f55$var$_defineProperty(_this, "handleMouseMove", function(e) {
                e.persist();
                _this.throttleTriggeredAfterMouseMove(e);
            });
            /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */ $6d459a69f64f5f55$var$_defineProperty(_this, "handleMouseLeave", function(e) {
                _this.throttleTriggeredAfterMouseMove.cancel();
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseLeave = _this.props.onMouseLeave;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(onMouseLeave)) onMouseLeave(nextState, e);
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "handleOuterEvent", function(e) {
                var eventName = (0, $008f02516c156322$export$afb3591bc51a0b70)(e);
                var event = (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(_this.props, "".concat(eventName));
                if (eventName && (0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(event)) {
                    var _mouse;
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    event((_mouse = mouse) !== null && _mouse !== void 0 ? _mouse : {}, e);
                }
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "handleClick", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    var onClick = _this.props.onClick;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(onClick)) onClick(_nextState2, e);
                }
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "handleMouseDown", function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "handleMouseUp", function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "handleTouchMove", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.throttleTriggeredAfterMouseMove(e.changedTouches[0]);
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "handleTouchStart", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "handleTouchEnd", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "handleDoubleClick", function(e) {
                var onDoubleClick = _this.props.onDoubleClick;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(onDoubleClick)) {
                    var _nextState5 = _this.getMouseInfo(e);
                    onDoubleClick(_nextState5, e);
                }
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "handleContextMenu", function(e) {
                var onContextMenu = _this.props.onContextMenu;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(onContextMenu)) {
                    var _nextState6 = _this.getMouseInfo(e);
                    onContextMenu(_nextState6, e);
                }
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "triggerSyncEvent", function(data) {
                if (_this.props.syncId !== undefined) (0, $bbd08cd38300f8df$export$9bcdfe5f29bb33).emit((0, $bbd08cd38300f8df$export$ff9a08f6d0c38b8f), _this.props.syncId, data, _this.eventEmitterSymbol);
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "applySyncEvent", function(data) {
                var _this$props = _this.props, layout = _this$props.layout, syncMethod = _this$props.syncMethod;
                var updateId = _this.state.updateId;
                var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                if (data.dataStartIndex !== undefined || data.dataEndIndex !== undefined) _this.setState($6d459a69f64f5f55$var$_objectSpread({
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }, updateStateOfAxisMapsOffsetAndStackGroups({
                    props: _this.props,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex,
                    updateId: updateId
                }, _this.state)));
                else if (data.activeTooltipIndex !== undefined) {
                    var chartX = data.chartX, chartY = data.chartY;
                    var activeTooltipIndex = data.activeTooltipIndex;
                    var _this$state2 = _this.state, offset = _this$state2.offset, tooltipTicks = _this$state2.tooltipTicks;
                    if (!offset) return;
                    if (typeof syncMethod === 'function') // Call a callback function. If there is an application specific algorithm
                    activeTooltipIndex = syncMethod(tooltipTicks, data);
                    else if (syncMethod === 'value') {
                        // Set activeTooltipIndex to the index with the same value as data.activeLabel
                        // For loop instead of findIndex because the latter is very slow in some browsers
                        activeTooltipIndex = -1; // in case we cannot find the element
                        for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                            activeTooltipIndex = i;
                            break;
                        }
                    }
                    var viewBox = $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    });
                    // When a categorical chart is combined with another chart, the value of chartX
                    // and chartY may beyond the boundaries.
                    var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                    var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                    var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                    var activePayload = $6d459a69f64f5f55$var$getTooltipContent(_this.state, _this.props.data, activeTooltipIndex);
                    var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                        x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                        y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                    } : $6d459a69f64f5f55$var$originCoordinate;
                    _this.setState($6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, data), {}, {
                        activeLabel: activeLabel,
                        activeCoordinate: activeCoordinate,
                        activePayload: activePayload,
                        activeTooltipIndex: activeTooltipIndex
                    }));
                } else _this.setState(data);
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "renderCursor", function(element) {
                var _element$props$active;
                var _this$state3 = _this.state, isTooltipActive = _this$state3.isTooltipActive, activeCoordinate = _this$state3.activeCoordinate, activePayload = _this$state3.activePayload, offset = _this$state3.offset, activeTooltipIndex = _this$state3.activeTooltipIndex, tooltipAxisBandSize = _this$state3.tooltipAxisBandSize;
                var tooltipEventType = _this.getTooltipEventType();
                // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
                var isActive = (_element$props$active = element.props.active) !== null && _element$props$active !== void 0 ? _element$props$active : isTooltipActive;
                var layout = _this.props.layout;
                var key = element.key || '_recharts-cursor';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d690e81478a10d12$export$b6a79797ad180576), {
                    key: key,
                    activeCoordinate: activeCoordinate,
                    activePayload: activePayload,
                    activeTooltipIndex: activeTooltipIndex,
                    chartName: chartName,
                    element: element,
                    isActive: isActive,
                    layout: layout,
                    offset: offset,
                    tooltipAxisBandSize: tooltipAxisBandSize,
                    tooltipEventType: tooltipEventType
                });
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "renderPolarAxis", function(element, displayName, index) {
                var axisType = (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(element, 'type.axisType');
                var axisMap = (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(_this.state, "".concat(axisType, "Map"));
                var elementDefaultProps = element.type.defaultProps;
                var elementProps = elementDefaultProps !== undefined ? $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, elementDefaultProps), element.props) : element.props;
                var axisOption = axisMap && axisMap[elementProps["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, $acw62.cloneElement)(element, $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, axisOption), {}, {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(axisType, axisOption.className),
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, $cd015374923bb5c7$export$c829ee42daf7f66d)(axisOption, true)
                }));
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "renderPolarGrid", function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state4 = _this.state, radiusAxisMap = _this$state4.radiusAxisMap, angleAxisMap = _this$state4.angleAxisMap;
                var radiusAxis = (0, $2ab3a7e25c8aba74$export$b88993f0aa0bf776)(radiusAxisMap);
                var angleAxis = (0, $2ab3a7e25c8aba74$export$b88993f0aa0bf776)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, $acw62.cloneElement)(element, {
                    polarAngles: Array.isArray(polarAngles) ? polarAngles : (0, $cd015374923bb5c7$export$c829ee42daf7f66d)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: Array.isArray(polarRadius) ? polarRadius : (0, $cd015374923bb5c7$export$c829ee42daf7f66d)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || 'polar-grid',
                    radialLines: radialLines
                });
            });
            /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */ $6d459a69f64f5f55$var$_defineProperty(_this, "renderLegend", function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props2 = _this.props, children = _this$props2.children, width = _this$props2.width, height = _this$props2.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, $3a45d033d706e33c$export$8f9424d123c36aa)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = $6d459a69f64f5f55$var$_objectWithoutProperties(props, $6d459a69f64f5f55$var$_excluded);
                return /*#__PURE__*/ (0, $acw62.cloneElement)(item, $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            });
            /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */ $6d459a69f64f5f55$var$_defineProperty(_this, "renderTooltip", function() {
                var _tooltipItem$props$ac;
                var _this$props3 = _this.props, children = _this$props3.children, accessibilityLayer = _this$props3.accessibilityLayer;
                var tooltipItem = (0, $008f02516c156322$export$64c61536a2b72e0f)(children, (0, $3258e2bab55a6a07$export$28c660c63b792dea));
                if (!tooltipItem) return null;
                var _this$state5 = _this.state, isTooltipActive = _this$state5.isTooltipActive, activeCoordinate = _this$state5.activeCoordinate, activePayload = _this$state5.activePayload, activeLabel = _this$state5.activeLabel, offset = _this$state5.offset;
                // The user can set isActive on the Tooltip,
                // and we respect the user to enable customisation.
                // The Tooltip is active if the user has set isActive, or if the tooltip is active due to a mouse event.
                var isActive = (_tooltipItem$props$ac = tooltipItem.props.active) !== null && _tooltipItem$props$ac !== void 0 ? _tooltipItem$props$ac : isTooltipActive;
                return /*#__PURE__*/ (0, $acw62.cloneElement)(tooltipItem, {
                    viewBox: $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isActive,
                    label: activeLabel,
                    payload: isActive ? activePayload : [],
                    coordinate: activeCoordinate,
                    accessibilityLayer: accessibilityLayer
                });
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "renderBrush", function(element) {
                var _this$props4 = _this.props, margin = _this$props4.margin, data = _this$props4.data;
                var _this$state6 = _this.state, offset = _this$state6.offset, dataStartIndex = _this$state6.dataStartIndex, dataEndIndex = _this$state6.dataEndIndex, updateId = _this$state6.updateId;
                // TODO: update brush when children update
                return /*#__PURE__*/ (0, $acw62.cloneElement)(element, {
                    key: element.key || '_recharts-brush',
                    onChange: (0, $cd015374923bb5c7$export$760ec406ba47bace)(_this.handleBrushChange, element.props.onChange),
                    data: data,
                    x: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(element.props.x) ? element.props.x : offset.left,
                    y: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "renderReferenceElement", function(element, displayName, index) {
                if (!element) return null;
                var _this2 = _this, clipPathId = _this2.clipPathId;
                var _this$state7 = _this.state, xAxisMap = _this$state7.xAxisMap, yAxisMap = _this$state7.yAxisMap, offset = _this$state7.offset;
                var elementDefaultProps = element.type.defaultProps || {};
                var _element$props2 = element.props, _element$props2$xAxis = _element$props2.xAxisId, xAxisId = _element$props2$xAxis === void 0 ? elementDefaultProps.xAxisId : _element$props2$xAxis, _element$props2$yAxis = _element$props2.yAxisId, yAxisId = _element$props2$yAxis === void 0 ? elementDefaultProps.yAxisId : _element$props2$yAxis;
                return /*#__PURE__*/ (0, $acw62.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "renderActivePoints", function(_ref10) {
                var item = _ref10.item, activePoint = _ref10.activePoint, basePoint = _ref10.basePoint, childIndex = _ref10.childIndex, isRange = _ref10.isRange;
                var result = [];
                // item is not a React Element so we don't need to resolve defaultProps.
                var key = item.props.key;
                var itemItemProps = item.item.type.defaultProps !== undefined ? $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, item.item.type.defaultProps), item.item.props) : item.item.props;
                var activeDot = itemItemProps.activeDot, dataKey = itemItemProps.dataKey;
                var dotProps = $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, $cd015374923bb5c7$export$ec6cab5a7a3b93bf)(item.item),
                    strokeWidth: 2,
                    stroke: '#fff',
                    payload: activePoint.payload,
                    value: activePoint.value
                }, (0, $008f02516c156322$export$d697c39a2985a4c)(activeDot, false)), (0, $909d5f835f4e917b$export$7c4c290a4a9c1b1e)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps, "".concat(key, "-activePoint-").concat(childIndex)));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y
                }), "".concat(key, "-basePoint-").concat(childIndex)));
                else if (isRange) result.push(null);
                return result;
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "renderGraphicChild", function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state8 = _this.state, isTooltipActive = _this$state8.isTooltipActive, tooltipAxis = _this$state8.tooltipAxis, activeTooltipIndex = _this$state8.activeTooltipIndex, activeLabel = _this$state8.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, $008f02516c156322$export$64c61536a2b72e0f)(children, (0, $3258e2bab55a6a07$export$28c660c63b792dea));
                // item is not a React Element so we don't need to resolve defaultProps
                var _item$props = item.props, points = _item$props.points, isRange = _item$props.isRange, baseLine = _item$props.baseLine;
                var itemItemProps = item.item.type.defaultProps !== undefined ? $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, item.item.type.defaultProps), item.item.props) : item.item.props;
                var activeDot = itemItemProps.activeDot, hide = itemItemProps.hide, activeBar = itemItemProps.activeBar, activeShape = itemItemProps.activeShape;
                var hasActive = Boolean(!hide && isTooltipActive && tooltipItem && (activeDot || activeBar || activeShape));
                var itemEvents = {};
                if (tooltipEventType !== 'axis' && tooltipItem && tooltipItem.props.trigger === 'click') itemEvents = {
                    onClick: (0, $cd015374923bb5c7$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onClick)
                };
                else if (tooltipEventType !== 'axis') itemEvents = {
                    onMouseLeave: (0, $cd015374923bb5c7$export$760ec406ba47bace)(_this.handleItemMouseLeave, element.props.onMouseLeave),
                    onMouseEnter: (0, $cd015374923bb5c7$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, $acw62.cloneElement)(element, $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === 'function' ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    if (activeTooltipIndex >= 0) {
                        var activePoint, basePoint;
                        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                            // number transform to string
                            var specifiedKey = typeof tooltipAxis.dataKey === 'function' ? findWithPayload : 'payload.'.concat(tooltipAxis.dataKey.toString());
                            activePoint = (0, $2ab3a7e25c8aba74$export$66950d3869f5cc67)(points, specifiedKey, activeLabel);
                            basePoint = isRange && baseLine && (0, $2ab3a7e25c8aba74$export$66950d3869f5cc67)(baseLine, specifiedKey, activeLabel);
                        } else {
                            activePoint = points === null || points === void 0 ? void 0 : points[activeTooltipIndex];
                            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                        }
                        if (activeShape || activeBar) {
                            var activeIndex = element.props.activeIndex !== undefined ? element.props.activeIndex : activeTooltipIndex;
                            return [
                                /*#__PURE__*/ (0, $acw62.cloneElement)(element, $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, item.props), itemEvents), {}, {
                                    activeIndex: activeIndex
                                })),
                                null,
                                null
                            ];
                        }
                        if (!(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(activePoint)) return [
                            graphicalItem
                        ].concat($6d459a69f64f5f55$var$_toConsumableArray(_this.renderActivePoints({
                            item: item,
                            activePoint: activePoint,
                            basePoint: basePoint,
                            childIndex: activeTooltipIndex,
                            isRange: isRange
                        })));
                    } else {
                        var _this$getItemByXY;
                        /**
             * We hit this block if consumer uses a Tooltip without XAxis and/or YAxis.
             * In which case, this.state.activeTooltipIndex never gets set
             * because the mouse events that trigger that value getting set never get trigged without the axis components.
             *
             * An example usage case is a FunnelChart
             */ var _ref11 = (_this$getItemByXY = _this.getItemByXY(_this.state.activeCoordinate)) !== null && _this$getItemByXY !== void 0 ? _this$getItemByXY : {
                            graphicalItem: graphicalItem
                        }, _ref11$graphicalItem = _ref11.graphicalItem, _ref11$graphicalItem$ = _ref11$graphicalItem.item, xyItem = _ref11$graphicalItem$ === void 0 ? element : _ref11$graphicalItem$, childIndex = _ref11$graphicalItem.childIndex;
                        var elementProps = $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, item.props), itemEvents), {}, {
                            activeIndex: childIndex
                        });
                        return [
                            /*#__PURE__*/ (0, $acw62.cloneElement)(xyItem, elementProps),
                            null,
                            null
                        ];
                    }
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "renderCustomized", function(element, displayName, index) {
                return /*#__PURE__*/ (0, $acw62.cloneElement)(element, $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "renderMap", {
                CartesianGrid: {
                    handler: $6d459a69f64f5f55$var$renderAsIs,
                    once: true
                },
                ReferenceArea: {
                    handler: _this.renderReferenceElement
                },
                ReferenceLine: {
                    handler: $6d459a69f64f5f55$var$renderAsIs
                },
                ReferenceDot: {
                    handler: _this.renderReferenceElement
                },
                XAxis: {
                    handler: $6d459a69f64f5f55$var$renderAsIs
                },
                YAxis: {
                    handler: $6d459a69f64f5f55$var$renderAsIs
                },
                Brush: {
                    handler: _this.renderBrush,
                    once: true
                },
                Bar: {
                    handler: _this.renderGraphicChild
                },
                Line: {
                    handler: _this.renderGraphicChild
                },
                Area: {
                    handler: _this.renderGraphicChild
                },
                Radar: {
                    handler: _this.renderGraphicChild
                },
                RadialBar: {
                    handler: _this.renderGraphicChild
                },
                Scatter: {
                    handler: _this.renderGraphicChild
                },
                Pie: {
                    handler: _this.renderGraphicChild
                },
                Funnel: {
                    handler: _this.renderGraphicChild
                },
                Tooltip: {
                    handler: _this.renderCursor,
                    once: true
                },
                PolarGrid: {
                    handler: _this.renderPolarGrid,
                    once: true
                },
                PolarAngleAxis: {
                    handler: _this.renderPolarAxis
                },
                PolarRadiusAxis: {
                    handler: _this.renderPolarAxis
                },
                Customized: {
                    handler: _this.renderCustomized
                }
            });
            _this.clipPathId = "".concat((_props$id = _props.id) !== null && _props$id !== void 0 ? _props$id : (0, $2ab3a7e25c8aba74$export$8b15d37bc3f197d4)('recharts'), "-clip");
            // trigger 60fps
            _this.throttleTriggeredAfterMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($ff695783c7d42c0c$exports)))(_this.triggeredAfterMouseMove, (_props$throttleDelay = _props.throttleDelay) !== null && _props$throttleDelay !== void 0 ? _props$throttleDelay : 1000 / 60);
            _this.state = {};
            return _this;
        }
        $6d459a69f64f5f55$var$_inherits(CategoricalChartWrapper, _Component);
        return $6d459a69f64f5f55$var$_createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this$props$margin$le, _this$props$margin$to;
                    this.addListener();
                    this.accessibilityManager.setDetails({
                        container: this.container,
                        offset: {
                            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
                            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
                        },
                        coordinateList: this.state.tooltipTicks,
                        mouseHandlerCallback: this.triggeredAfterMouseMove,
                        layout: this.props.layout
                    });
                    this.displayDefaultTooltip();
                }
            },
            {
                key: "displayDefaultTooltip",
                value: function displayDefaultTooltip() {
                    var _this$props5 = this.props, children = _this$props5.children, data = _this$props5.data, height = _this$props5.height, layout = _this$props5.layout;
                    var tooltipElem = (0, $008f02516c156322$export$64c61536a2b72e0f)(children, (0, $3258e2bab55a6a07$export$28c660c63b792dea));
                    // If the chart doesn't include a <Tooltip /> element, there's no tooltip to display
                    if (!tooltipElem) return;
                    var defaultIndex = tooltipElem.props.defaultIndex;
                    // Protect against runtime errors
                    if (typeof defaultIndex !== 'number' || defaultIndex < 0 || defaultIndex > this.state.tooltipTicks.length - 1) return;
                    var activeLabel = this.state.tooltipTicks[defaultIndex] && this.state.tooltipTicks[defaultIndex].value;
                    var activePayload = $6d459a69f64f5f55$var$getTooltipContent(this.state, data, defaultIndex, activeLabel);
                    var independentAxisCoord = this.state.tooltipTicks[defaultIndex].coordinate;
                    var dependentAxisCoord = (this.state.offset.top + height) / 2;
                    var isHorizontal = layout === 'horizontal';
                    var activeCoordinate = isHorizontal ? {
                        x: independentAxisCoord,
                        y: dependentAxisCoord
                    } : {
                        y: independentAxisCoord,
                        x: dependentAxisCoord
                    };
                    // Unlike other chart types, scatter plot's tooltip positions rely on both X and Y coordinates. Only the scatter plot
                    // element knows its own Y coordinates.
                    // If there's a scatter plot, we'll want to grab that element for an interrogation.
                    var scatterPlotElement = this.state.formattedGraphicalItems.find(function(_ref12) {
                        var item = _ref12.item;
                        return item.type.name === 'Scatter';
                    });
                    if (scatterPlotElement) {
                        activeCoordinate = $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, activeCoordinate), scatterPlotElement.props.points[defaultIndex].tooltipPosition);
                        activePayload = scatterPlotElement.props.points[defaultIndex].tooltipPayload;
                    }
                    var nextState = {
                        activeTooltipIndex: defaultIndex,
                        isTooltipActive: true,
                        activeLabel: activeLabel,
                        activePayload: activePayload,
                        activeCoordinate: activeCoordinate
                    };
                    this.setState(nextState);
                    this.renderCursor(tooltipElem);
                    // Make sure that anyone who keyboard-only users who tab to the chart will start their
                    // cursors at defaultIndex
                    this.accessibilityManager.setIndex(defaultIndex);
                }
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {
                    if (!this.props.accessibilityLayer) return null;
                    if (this.state.tooltipTicks !== prevState.tooltipTicks) this.accessibilityManager.setDetails({
                        coordinateList: this.state.tooltipTicks
                    });
                    if (this.props.layout !== prevProps.layout) this.accessibilityManager.setDetails({
                        layout: this.props.layout
                    });
                    if (this.props.margin !== prevProps.margin) {
                        var _this$props$margin$le2, _this$props$margin$to2;
                        this.accessibilityManager.setDetails({
                            offset: {
                                left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
                                top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
                            }
                        });
                    }
                    // Something has to be returned for getSnapshotBeforeUpdate
                    return null;
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    // Check to see if the Tooltip updated. If so, re-check default tooltip position
                    if (!(0, $008f02516c156322$export$acdc716e08572f94)([
                        (0, $008f02516c156322$export$64c61536a2b72e0f)(prevProps.children, (0, $3258e2bab55a6a07$export$28c660c63b792dea))
                    ], [
                        (0, $008f02516c156322$export$64c61536a2b72e0f)(this.props.children, (0, $3258e2bab55a6a07$export$28c660c63b792dea))
                    ])) this.displayDefaultTooltip();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeListener();
                    this.throttleTriggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, $008f02516c156322$export$64c61536a2b72e0f)(this.props.children, (0, $3258e2bab55a6a07$export$28c660c63b792dea));
                    if (tooltipItem && typeof tooltipItem.props.shared === 'boolean') {
                        var eventType = tooltipItem.props.shared ? 'axis' : 'item';
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var element = this.container;
                    var boundingRect = element.getBoundingClientRect();
                    var containerOffset = (0, $41867cca6cb93873$export$622cea445a1c5b7d)(boundingRect);
                    var e = {
                        chartX: Math.round(event.pageX - containerOffset.left),
                        chartY: Math.round(event.pageY - containerOffset.top)
                    };
                    var scale = boundingRect.width / element.offsetWidth || 1;
                    var rangeObj = this.inRange(e.chartX, e.chartY, scale);
                    if (!rangeObj) return null;
                    var _this$state9 = this.state, xAxisMap = _this$state9.xAxisMap, yAxisMap = _this$state9.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    var toolTipData = $6d459a69f64f5f55$var$getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (tooltipEventType !== 'axis' && xAxisMap && yAxisMap) {
                        var xScale = (0, $2ab3a7e25c8aba74$export$b88993f0aa0bf776)(xAxisMap).scale;
                        var yScale = (0, $2ab3a7e25c8aba74$export$b88993f0aa0bf776)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        }, toolTipData);
                    }
                    if (toolTipData) return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                    var layout = this.props.layout;
                    var scaledX = x / scale, scaledY = y / scale;
                    if (layout === 'horizontal' || layout === 'vertical') {
                        var offset = this.state.offset;
                        var isInRange = scaledX >= offset.left && scaledX <= offset.left + offset.width && scaledY >= offset.top && scaledY <= offset.top + offset.height;
                        return isInRange ? {
                            x: scaledX,
                            y: scaledY
                        } : null;
                    }
                    var _this$state10 = this.state, angleAxisMap = _this$state10.angleAxisMap, radiusAxisMap = _this$state10.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, $2ab3a7e25c8aba74$export$b88993f0aa0bf776)(angleAxisMap);
                        return (0, $0f9bc5dd76ad1109$export$e85a2bf8cd31c504)({
                            x: scaledX,
                            y: scaledY
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, $008f02516c156322$export$64c61536a2b72e0f)(children, (0, $3258e2bab55a6a07$export$28c660c63b792dea));
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === 'axis') {
                        if (tooltipItem.props.trigger === 'click') tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onDoubleClick: this.handleDoubleClick,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd,
                            onContextMenu: this.handleContextMenu
                        };
                    }
                    // @ts-expect-error adaptEventHandlers expects DOM Event but generateCategoricalChart works with React UIEvents
                    var outerEvents = (0, $909d5f835f4e917b$export$7c4c290a4a9c1b1e)(this.props, this.handleOuterEvent);
                    return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, $bbd08cd38300f8df$export$9bcdfe5f29bb33).on((0, $bbd08cd38300f8df$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, $bbd08cd38300f8df$export$9bcdfe5f29bb33).removeListener((0, $bbd08cd38300f8df$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, $008f02516c156322$export$be63e0664592e141)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref13) {
                        var _ref14 = $6d459a69f64f5f55$var$_slicedToArray(_ref13, 2), axisId = _ref14[0], axisProps = _ref14[1];
                        return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, res), {}, $6d459a69f64f5f55$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref15) {
                        var _ref16 = $6d459a69f64f5f55$var$_slicedToArray(_ref15, 2), axisId = _ref16[0], axisProps = _ref16[1];
                        return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, res), {}, $6d459a69f64f5f55$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 || (_this$state$xAxisMap = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap === void 0 ? void 0 : _this$state$xAxisMap.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 || (_this$state$yAxisMap = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap === void 0 ? void 0 : _this$state$yAxisMap.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var _this$state11 = this.state, formattedGraphicalItems = _this$state11.formattedGraphicalItems, activeItem = _this$state11.activeItem;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        // graphicalItem is not a React Element so we don't need to resolve defaultProps
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemProps = item.type.defaultProps !== undefined ? $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
                        var itemDisplayName = (0, $008f02516c156322$export$be63e0664592e141)(item.type);
                        if (itemDisplayName === 'Bar') {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $70f75e095c9bb92d$export$f783d19325be51d5)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === 'RadialBar') {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $0f9bc5dd76ad1109$export$e85a2bf8cd31c504)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        } else if ((0, $4696e249b64cd95e$export$4b83e8415af38a18)(graphicalItem, activeItem) || (0, $4696e249b64cd95e$export$f722d7e63cc07b)(graphicalItem, activeItem) || (0, $4696e249b64cd95e$export$f62b21bcfd1a733e)(graphicalItem, activeItem)) {
                            var activeIndex = (0, $4696e249b64cd95e$export$bd5d63c57ca4468)({
                                graphicalItem: graphicalItem,
                                activeTooltipItem: activeItem,
                                itemData: itemProps.data
                            });
                            var childIndex = itemProps.activeIndex === undefined ? activeIndex : itemProps.activeIndex;
                            return {
                                graphicalItem: $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, graphicalItem), {}, {
                                    childIndex: childIndex
                                }),
                                payload: (0, $4696e249b64cd95e$export$f62b21bcfd1a733e)(graphicalItem, activeItem) ? itemProps.data[activeIndex] : graphicalItem.props.data[activeIndex]
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this3 = this;
                    if (!(0, $008f02516c156322$export$5301de6bfd3cfa2a)(this)) return null;
                    var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = $6d459a69f64f5f55$var$_objectWithoutProperties(_this$props6, $6d459a69f64f5f55$var$_excluded2);
                    var attrs = (0, $008f02516c156322$export$d697c39a2985a4c)(others, false);
                    // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e573f10901a87cfb$export$e22c0f72c980af5a), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bfae0ec07b91e499$export$7b92b459e668cb21), $6d459a69f64f5f55$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, $008f02516c156322$export$a98d6da55570cb82)(children, this.renderMap)));
                    if (this.props.accessibilityLayer) {
                        var _this$props$tabIndex, _this$props$role;
                        // Set tabIndex to 0 by default (can be overwritten)
                        attrs.tabIndex = (_this$props$tabIndex = this.props.tabIndex) !== null && _this$props$tabIndex !== void 0 ? _this$props$tabIndex : 0;
                        // Set role to img by default (can be overwritten)
                        attrs.role = (_this$props$role = this.props.role) !== null && _this$props$role !== void 0 ? _this$props$role : 'application';
                        attrs.onKeyDown = function(e) {
                            _this3.accessibilityManager.keyboardEvent(e);
                        // 'onKeyDown' is not currently a supported prop that can be passed through
                        // if it's added, this should be added: this.props.onKeyDown(e);
                        };
                        attrs.onFocus = function() {
                            _this3.accessibilityManager.focus();
                        // 'onFocus' is not currently a supported prop that can be passed through
                        // if it's added, the focus event should be forwarded to the prop
                        };
                    }
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e573f10901a87cfb$export$e22c0f72c980af5a), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $6d459a69f64f5f55$var$_extends({
                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-wrapper', className),
                        style: $6d459a69f64f5f55$var$_objectSpread({
                            position: 'relative',
                            cursor: 'default',
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this3.container = node;
                        }
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bfae0ec07b91e499$export$7b92b459e668cb21), $6d459a69f64f5f55$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc,
                        style: $6d459a69f64f5f55$var$FULL_WIDTH_AND_HEIGHT
                    }), this.renderClipPath(), (0, $008f02516c156322$export$a98d6da55570cb82)(children, this.renderMap)), this.renderLegend(), this.renderTooltip()));
                }
            }
        ]);
    }((0, $acw62.Component));
    $6d459a69f64f5f55$var$_defineProperty(CategoricalChartWrapper, "displayName", chartName);
    // todo join specific chart propTypes
    $6d459a69f64f5f55$var$_defineProperty(CategoricalChartWrapper, "defaultProps", $6d459a69f64f5f55$var$_objectSpread({
        layout: 'horizontal',
        stackOffset: 'none',
        barCategoryGap: '10%',
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: 'index'
    }, defaultProps));
    $6d459a69f64f5f55$var$_defineProperty(CategoricalChartWrapper, "getDerivedStateFromProps", function(nextProps, prevState) {
        var dataKey = nextProps.dataKey, data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        var dataStartIndex = prevState.dataStartIndex, dataEndIndex = prevState.dataEndIndex;
        if (prevState.updateId === undefined) {
            var defaultState = $6d459a69f64f5f55$export$e5182fb58612e577(nextProps);
            return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups($6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (dataKey !== prevState.prevDataKey || data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, $0f60d716238978d6$export$d36bdfa510afb180)(margin, prevState.prevMargin)) {
            var _defaultState = $6d459a69f64f5f55$export$e5182fb58612e577(nextProps);
            // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, $6d459a69f64f5f55$var$getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups($6d459a69f64f5f55$var$_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, $008f02516c156322$export$acdc716e08572f94)(children, prevState.prevChildren)) {
            var _brush$props$startInd, _brush$props, _brush$props$endIndex, _brush$props2;
            // specifically check for Brush - if it exists and the start and end indexes are different, re-render with the new ones
            var brush = (0, $008f02516c156322$export$64c61536a2b72e0f)(children, (0, $b0c0135ef9d67bd5$export$59bc2e3533b384a0));
            var startIndex = brush ? (_brush$props$startInd = (_brush$props = brush.props) === null || _brush$props === void 0 ? void 0 : _brush$props.startIndex) !== null && _brush$props$startInd !== void 0 ? _brush$props$startInd : dataStartIndex : dataStartIndex;
            var endIndex = brush ? (_brush$props$endIndex = (_brush$props2 = brush.props) === null || _brush$props2 === void 0 ? void 0 : _brush$props2.endIndex) !== null && _brush$props$endIndex !== void 0 ? _brush$props$endIndex : dataEndIndex : dataEndIndex;
            var hasDifferentStartOrEndIndex = startIndex !== dataStartIndex || endIndex !== dataEndIndex;
            // update configuration in children
            var hasGlobalData = !(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(data);
            var newUpdateId = hasGlobalData && !hasDifferentStartOrEndIndex ? prevState.updateId : prevState.updateId + 1;
            return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups($6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            }), prevState)), {}, {
                prevChildren: children,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            });
        }
        return null;
    });
    $6d459a69f64f5f55$var$_defineProperty(CategoricalChartWrapper, "renderActiveDot", function(option, props, key) {
        var dot;
        if (/*#__PURE__*/ (0, $acw62.isValidElement)(option)) dot = /*#__PURE__*/ (0, $acw62.cloneElement)(option, props);
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1ab98349969d46e2$export$d046b3c4a416f60d), props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
            className: "recharts-active-dot",
            key: key
        }, dot);
    });
    var CategoricalChart = /*#__PURE__*/ (0, $acw62.forwardRef)(function CategoricalChart(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CategoricalChartWrapper, $6d459a69f64f5f55$var$_extends({}, props, {
            ref: ref
        }));
    });
    CategoricalChart.displayName = CategoricalChartWrapper.displayName;
    return CategoricalChart;
};




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");















/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */ function $b250a459bfd5f59b$export$41514b9f058a6886(array, n, isValid) {
    if (n < 1) return [];
    if (n === 1 && isValid === undefined) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        if (isValid === undefined || isValid(array[i]) === true) result.push(array[i]);
        else return undefined;
    }
    return result;
}


function $19a932367b9d461a$export$a1966f4ad955c82b(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, $7dad4d5151ba4a01$export$3ee78d51cffc2b68)(size, angle);
}
function $19a932367b9d461a$export$a257eb8806d5033d(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === 'width';
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function $19a932367b9d461a$export$795910f5f15a9633(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function $19a932367b9d461a$export$beeebbe3ff1b306b(ticks, interval) {
    return (0, $b250a459bfd5f59b$export$41514b9f058a6886)(ticks, interval + 1);
}




function $ca4e8736ea4f469e$export$77bf2ab5711b7f99(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var initialStart = boundaries.start, end = boundaries.end;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluate all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, $b250a459bfd5f59b$export$41514b9f058a6886)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, $19a932367b9d461a$export$795910f5f15a9633)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}


function $582ebde04d312f24$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $582ebde04d312f24$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $582ebde04d312f24$var$_typeof(o);
}
function $582ebde04d312f24$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $582ebde04d312f24$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $582ebde04d312f24$var$ownKeys(Object(t), !0).forEach(function(r) {
            $582ebde04d312f24$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $582ebde04d312f24$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $582ebde04d312f24$var$_defineProperty(obj, key, value) {
    key = $582ebde04d312f24$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $582ebde04d312f24$var$_toPropertyKey(t) {
    var i = $582ebde04d312f24$var$_toPrimitive(t, "string");
    return "symbol" == $582ebde04d312f24$var$_typeof(i) ? i : i + "";
}
function $582ebde04d312f24$var$_toPrimitive(t, r) {
    if ("object" != $582ebde04d312f24$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $582ebde04d312f24$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $582ebde04d312f24$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start;
    var end = boundaries.end;
    var _loop = function _loop(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $19a932367b9d461a$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
            result[i] = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = len - 1; i >= 0; i--)_loop(i);
    return result;
}
function $582ebde04d312f24$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start, end = boundaries.end;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailSize = getTickSize(tail, len - 1);
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = (0, $19a932367b9d461a$export$795910f5f15a9633)(sign, tail.tickCoord, function() {
            return tailSize;
        }, start, end);
        if (isTailShow) {
            end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
            result[len - 1] = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, tail), {}, {
                isShow: true
            });
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $19a932367b9d461a$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
            result[i] = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = 0; i < count; i++)_loop2(i);
    return result;
}
function $582ebde04d312f24$export$3d27d42b1034de5c(props, fontSize, letterSpacing) {
    var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit, angle = props.angle;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(interval) || (0, $795299547b24e258$export$98f03c5d19621d70).isSsr) return (0, $19a932367b9d461a$export$beeebbe3ff1b306b)(ticks, typeof interval === 'number' && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(interval) ? interval : 0);
    var candidates = [];
    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    var unitSize = unit && sizeKey === 'width' ? (0, $41867cca6cb93873$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = function getTickSize(content, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(tickFormatter) ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === 'width' ? (0, $19a932367b9d461a$export$a1966f4ad955c82b)((0, $41867cca6cb93873$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $41867cca6cb93873$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
    };
    var sign = ticks.length >= 2 ? (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(ticks[1].coordinate - ticks[0].coordinate) : 1;
    var boundaries = (0, $19a932367b9d461a$export$a257eb8806d5033d)(viewBox, sign, sizeKey);
    if (interval === 'equidistantPreserveStart') return (0, $ca4e8736ea4f469e$export$77bf2ab5711b7f99)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === 'preserveStart' || interval === 'preserveStartEnd') candidates = $582ebde04d312f24$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === 'preserveStartEnd');
    else candidates = $582ebde04d312f24$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter(function(entry) {
        return entry.isShow;
    });
}


var $247385db510d7b7c$var$_excluded = [
    "viewBox"
], $247385db510d7b7c$var$_excluded2 = [
    "viewBox"
], $247385db510d7b7c$var$_excluded3 = [
    "ticks"
];
function $247385db510d7b7c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $247385db510d7b7c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $247385db510d7b7c$var$_typeof(o);
}
function $247385db510d7b7c$var$_extends() {
    $247385db510d7b7c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $247385db510d7b7c$var$_extends.apply(this, arguments);
}
function $247385db510d7b7c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $247385db510d7b7c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $247385db510d7b7c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $247385db510d7b7c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $247385db510d7b7c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $247385db510d7b7c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $247385db510d7b7c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $247385db510d7b7c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $247385db510d7b7c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $247385db510d7b7c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $247385db510d7b7c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $247385db510d7b7c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $247385db510d7b7c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $247385db510d7b7c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $247385db510d7b7c$var$_callSuper(t, o, e) {
    return o = $247385db510d7b7c$var$_getPrototypeOf(o), $247385db510d7b7c$var$_possibleConstructorReturn(t, $247385db510d7b7c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $247385db510d7b7c$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $247385db510d7b7c$var$_possibleConstructorReturn(self, call) {
    if (call && ($247385db510d7b7c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $247385db510d7b7c$var$_assertThisInitialized(self);
}
function $247385db510d7b7c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $247385db510d7b7c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($247385db510d7b7c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $247385db510d7b7c$var$_getPrototypeOf(o) {
    $247385db510d7b7c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $247385db510d7b7c$var$_getPrototypeOf(o);
}
function $247385db510d7b7c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $247385db510d7b7c$var$_setPrototypeOf(subClass, superClass);
}
function $247385db510d7b7c$var$_setPrototypeOf(o, p) {
    $247385db510d7b7c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $247385db510d7b7c$var$_setPrototypeOf(o, p);
}
function $247385db510d7b7c$var$_defineProperty(obj, key, value) {
    key = $247385db510d7b7c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $247385db510d7b7c$var$_toPropertyKey(t) {
    var i = $247385db510d7b7c$var$_toPrimitive(t, "string");
    return "symbol" == $247385db510d7b7c$var$_typeof(i) ? i : i + "";
}
function $247385db510d7b7c$var$_toPrimitive(t, r) {
    if ("object" != $247385db510d7b7c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $247385db510d7b7c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $247385db510d7b7c$export$bdd99f2cdf352bae = /*#__PURE__*/ function(_Component) {
    function CartesianAxis(props) {
        var _this;
        $247385db510d7b7c$var$_classCallCheck(this, CartesianAxis);
        _this = $247385db510d7b7c$var$_callSuper(this, CartesianAxis, [
            props
        ]);
        _this.state = {
            fontSize: '',
            letterSpacing: ''
        };
        return _this;
    }
    $247385db510d7b7c$var$_inherits(CartesianAxis, _Component);
    return $247385db510d7b7c$var$_createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref, nextState) {
                var viewBox = _ref.viewBox, restProps = $247385db510d7b7c$var$_objectWithoutProperties(_ref, $247385db510d7b7c$var$_excluded);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = $247385db510d7b7c$var$_objectWithoutProperties(_this$props, $247385db510d7b7c$var$_excluded2);
                return !(0, $0f60d716238978d6$export$d36bdfa510afb180)(viewBox, viewBoxOld) || !(0, $0f60d716238978d6$export$d36bdfa510afb180)(restProps, restPropsOld) || !(0, $0f60d716238978d6$export$d36bdfa510afb180)(nextState, this.state);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var htmlLayer = this.layerReference;
                if (!htmlLayer) return;
                var tick = htmlLayer.getElementsByClassName('recharts-cartesian-axis-tick-value')[0];
                if (tick) this.setState({
                    fontSize: window.getComputedStyle(tick).fontSize,
                    letterSpacing: window.getComputedStyle(tick).letterSpacing
                });
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case 'top':
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case 'left':
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case 'right':
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case 'left':
                        textAnchor = mirror ? 'start' : 'end';
                        break;
                    case 'right':
                        textAnchor = mirror ? 'end' : 'start';
                        break;
                    default:
                        textAnchor = 'middle';
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = 'end';
                switch(orientation){
                    case 'left':
                    case 'right':
                        verticalAnchor = 'middle';
                        break;
                    case 'top':
                        verticalAnchor = mirror ? 'start' : 'end';
                        break;
                    default:
                        verticalAnchor = mirror ? 'end' : 'start';
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, (0, $008f02516c156322$export$d697c39a2985a4c)(this.props, false)), (0, $008f02516c156322$export$d697c39a2985a4c)(axisLine, false)), {}, {
                    fill: 'none'
                });
                if (orientation === 'top' || orientation === 'bottom') {
                    var needHeight = +(orientation === 'top' && !mirror || orientation === 'bottom' && mirror);
                    props = $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === 'left' && !mirror || orientation === 'right' && mirror);
                    props = $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", $247385db510d7b7c$var$_extends({}, props, {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-cartesian-axis-line', (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(axisLine, 'className'))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @param {string} fontSize Fontsize to consider for tick spacing
     * @param {string} letterSpacing Letterspacing to consider for tick spacing
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks, fontSize, letterSpacing) {
                var _this2 = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = (0, $582ebde04d312f24$export$3d27d42b1034de5c)($247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }), fontSize, letterSpacing);
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, $008f02516c156322$export$d697c39a2985a4c)(this.props, false);
                var customTickProps = (0, $008f02516c156322$export$d697c39a2985a4c)(tick, false);
                var tickLineProps = $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, axisProps), {}, {
                    fill: 'none'
                }, (0, $008f02516c156322$export$d697c39a2985a4c)(tickLine, false));
                var items = finalTicks.map(function(entry, i) {
                    var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
                    var tickProps = $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), $247385db510d7b7c$var$_extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
                    }, (0, $909d5f835f4e917b$export$ca62be0d67a3158c)(_this2.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", $247385db510d7b7c$var$_extends({}, tickLineProps, lineCoord, {
                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-cartesian-axis-tick-line', (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(tickLine, 'className'))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || '')));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = $247385db510d7b7c$var$_objectWithoutProperties(_this$props8, $247385db510d7b7c$var$_excluded3);
                var finalTicks = ticks;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-cartesian-axis', className),
                    ref: function ref(_ref2) {
                        _this3.layerReference = _ref2;
                    }
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), (0, $77be8884b5ec622c$export$b04be29aa201d4f5).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                var combinedClassName = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(props.className, 'recharts-cartesian-axis-tick-value');
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(option, $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, props), {}, {
                    className: combinedClassName
                }));
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(option)) tickItem = option($247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, props), {}, {
                    className: combinedClassName
                }));
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $964be52cc11879b4$export$5f1af8db9871e1d6), $247385db510d7b7c$var$_extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
}((0, $acw62.Component));
$247385db510d7b7c$var$_defineProperty($247385db510d7b7c$export$bdd99f2cdf352bae, "displayName", 'CartesianAxis');
$247385db510d7b7c$var$_defineProperty($247385db510d7b7c$export$bdd99f2cdf352bae, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: 'bottom',
    // The ticks
    ticks: [],
    stroke: '#666',
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: 'preserveEnd'
});



function $f21953d5ea7d4fb8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f21953d5ea7d4fb8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f21953d5ea7d4fb8$var$_typeof(o);
}
function $f21953d5ea7d4fb8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f21953d5ea7d4fb8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $f21953d5ea7d4fb8$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $f21953d5ea7d4fb8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f21953d5ea7d4fb8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f21953d5ea7d4fb8$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $f21953d5ea7d4fb8$var$_callSuper(t, o, e) {
    return o = $f21953d5ea7d4fb8$var$_getPrototypeOf(o), $f21953d5ea7d4fb8$var$_possibleConstructorReturn(t, $f21953d5ea7d4fb8$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $f21953d5ea7d4fb8$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $f21953d5ea7d4fb8$var$_possibleConstructorReturn(self, call) {
    if (call && ($f21953d5ea7d4fb8$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $f21953d5ea7d4fb8$var$_assertThisInitialized(self);
}
function $f21953d5ea7d4fb8$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f21953d5ea7d4fb8$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f21953d5ea7d4fb8$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $f21953d5ea7d4fb8$var$_getPrototypeOf(o) {
    $f21953d5ea7d4fb8$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f21953d5ea7d4fb8$var$_getPrototypeOf(o);
}
function $f21953d5ea7d4fb8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $f21953d5ea7d4fb8$var$_setPrototypeOf(subClass, superClass);
}
function $f21953d5ea7d4fb8$var$_setPrototypeOf(o, p) {
    $f21953d5ea7d4fb8$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f21953d5ea7d4fb8$var$_setPrototypeOf(o, p);
}
function $f21953d5ea7d4fb8$var$_defineProperty(obj, key, value) {
    key = $f21953d5ea7d4fb8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f21953d5ea7d4fb8$var$_toPropertyKey(t) {
    var i = $f21953d5ea7d4fb8$var$_toPrimitive(t, "string");
    return "symbol" == $f21953d5ea7d4fb8$var$_typeof(i) ? i : i + "";
}
function $f21953d5ea7d4fb8$var$_toPrimitive(t, r) {
    if ("object" != $f21953d5ea7d4fb8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f21953d5ea7d4fb8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f21953d5ea7d4fb8$var$_extends() {
    $f21953d5ea7d4fb8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f21953d5ea7d4fb8$var$_extends.apply(this, arguments);
}
/** Define of XAxis props */ function $f21953d5ea7d4fb8$var$XAxisImpl(_ref) {
    var xAxisId = _ref.xAxisId;
    var width = (0, $e573f10901a87cfb$export$8854f7ece606854b)();
    var height = (0, $e573f10901a87cfb$export$369ae257969c6f9f)();
    var axisOptions = (0, $e573f10901a87cfb$export$54f54805c81085c5)(xAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    $acw62.createElement((0, $247385db510d7b7c$export$bdd99f2cdf352bae), $f21953d5ea7d4fb8$var$_extends({}, axisOptions, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, $cd015374923bb5c7$export$c829ee42daf7f66d)(axis, true);
        }
    })));
}
var $f21953d5ea7d4fb8$export$ea77231de273b52d = /*#__PURE__*/ function(_React$Component) {
    function XAxis() {
        $f21953d5ea7d4fb8$var$_classCallCheck(this, XAxis);
        return $f21953d5ea7d4fb8$var$_callSuper(this, XAxis, arguments);
    }
    $f21953d5ea7d4fb8$var$_inherits(XAxis, _React$Component);
    return $f21953d5ea7d4fb8$var$_createClass(XAxis, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ $acw62.createElement($f21953d5ea7d4fb8$var$XAxisImpl, this.props);
            }
        }
    ]);
}($acw62.Component);
$f21953d5ea7d4fb8$var$_defineProperty($f21953d5ea7d4fb8$export$ea77231de273b52d, "displayName", 'XAxis');
$f21953d5ea7d4fb8$var$_defineProperty($f21953d5ea7d4fb8$export$ea77231de273b52d, "defaultProps", {
    allowDecimals: true,
    hide: false,
    orientation: 'bottom',
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: 'category',
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false,
    allowDuplicatedCategory: true
});



var $acw62 = parcelRequire("acw62");




function $0e2dfd8b3bfb4506$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0e2dfd8b3bfb4506$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0e2dfd8b3bfb4506$var$_typeof(o);
}
function $0e2dfd8b3bfb4506$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0e2dfd8b3bfb4506$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $0e2dfd8b3bfb4506$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $0e2dfd8b3bfb4506$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0e2dfd8b3bfb4506$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0e2dfd8b3bfb4506$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $0e2dfd8b3bfb4506$var$_callSuper(t, o, e) {
    return o = $0e2dfd8b3bfb4506$var$_getPrototypeOf(o), $0e2dfd8b3bfb4506$var$_possibleConstructorReturn(t, $0e2dfd8b3bfb4506$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $0e2dfd8b3bfb4506$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $0e2dfd8b3bfb4506$var$_possibleConstructorReturn(self, call) {
    if (call && ($0e2dfd8b3bfb4506$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $0e2dfd8b3bfb4506$var$_assertThisInitialized(self);
}
function $0e2dfd8b3bfb4506$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $0e2dfd8b3bfb4506$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0e2dfd8b3bfb4506$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $0e2dfd8b3bfb4506$var$_getPrototypeOf(o) {
    $0e2dfd8b3bfb4506$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $0e2dfd8b3bfb4506$var$_getPrototypeOf(o);
}
function $0e2dfd8b3bfb4506$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $0e2dfd8b3bfb4506$var$_setPrototypeOf(subClass, superClass);
}
function $0e2dfd8b3bfb4506$var$_setPrototypeOf(o, p) {
    $0e2dfd8b3bfb4506$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0e2dfd8b3bfb4506$var$_setPrototypeOf(o, p);
}
function $0e2dfd8b3bfb4506$var$_defineProperty(obj, key, value) {
    key = $0e2dfd8b3bfb4506$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0e2dfd8b3bfb4506$var$_toPropertyKey(t) {
    var i = $0e2dfd8b3bfb4506$var$_toPrimitive(t, "string");
    return "symbol" == $0e2dfd8b3bfb4506$var$_typeof(i) ? i : i + "";
}
function $0e2dfd8b3bfb4506$var$_toPrimitive(t, r) {
    if ("object" != $0e2dfd8b3bfb4506$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0e2dfd8b3bfb4506$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0e2dfd8b3bfb4506$var$_extends() {
    $0e2dfd8b3bfb4506$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0e2dfd8b3bfb4506$var$_extends.apply(this, arguments);
}
var $0e2dfd8b3bfb4506$var$YAxisImpl = function YAxisImpl(_ref) {
    var yAxisId = _ref.yAxisId;
    var width = (0, $e573f10901a87cfb$export$8854f7ece606854b)();
    var height = (0, $e573f10901a87cfb$export$369ae257969c6f9f)();
    var axisOptions = (0, $e573f10901a87cfb$export$6f8958021ad81c20)(yAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    $acw62.createElement((0, $247385db510d7b7c$export$bdd99f2cdf352bae), $0e2dfd8b3bfb4506$var$_extends({}, axisOptions, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, $cd015374923bb5c7$export$c829ee42daf7f66d)(axis, true);
        }
    })));
};
var $0e2dfd8b3bfb4506$export$f96c4024c52de8f4 = /*#__PURE__*/ function(_React$Component) {
    function YAxis() {
        $0e2dfd8b3bfb4506$var$_classCallCheck(this, YAxis);
        return $0e2dfd8b3bfb4506$var$_callSuper(this, YAxis, arguments);
    }
    $0e2dfd8b3bfb4506$var$_inherits(YAxis, _React$Component);
    return $0e2dfd8b3bfb4506$var$_createClass(YAxis, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ $acw62.createElement($0e2dfd8b3bfb4506$var$YAxisImpl, this.props);
            }
        }
    ]);
}($acw62.Component);
$0e2dfd8b3bfb4506$var$_defineProperty($0e2dfd8b3bfb4506$export$f96c4024c52de8f4, "displayName", 'YAxis');
$0e2dfd8b3bfb4506$var$_defineProperty($0e2dfd8b3bfb4506$export$f96c4024c52de8f4, "defaultProps", {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: 'left',
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: 'number',
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false
});



var $74d07378047db57c$export$94aefc399ef206a9 = (0, $6d459a69f64f5f55$export$77871aede60e6838)({
    chartName: 'BarChart',
    GraphicalChild: (0, $e752e700473a8894$export$bbc6c6369b38e3d1),
    defaultTooltipEventType: 'axis',
    validateTooltipEventTypes: [
        'axis',
        'item'
    ],
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, $f21953d5ea7d4fb8$export$ea77231de273b52d)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, $0e2dfd8b3bfb4506$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $7dad4d5151ba4a01$export$ece7de1383db5ac)
});


var $acw62 = parcelRequire("acw62");








var $eae69ed53f30e7ce$var$_excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
], $eae69ed53f30e7ce$var$_excluded2 = [
    "offset"
];
function $eae69ed53f30e7ce$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $eae69ed53f30e7ce$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $eae69ed53f30e7ce$var$_typeof(o);
}
function $eae69ed53f30e7ce$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eae69ed53f30e7ce$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eae69ed53f30e7ce$var$ownKeys(Object(t), !0).forEach(function(r) {
            $eae69ed53f30e7ce$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eae69ed53f30e7ce$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $eae69ed53f30e7ce$var$_defineProperty(obj, key, value) {
    key = $eae69ed53f30e7ce$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $eae69ed53f30e7ce$var$_toPropertyKey(t) {
    var i = $eae69ed53f30e7ce$var$_toPrimitive(t, "string");
    return "symbol" == $eae69ed53f30e7ce$var$_typeof(i) ? i : i + "";
}
function $eae69ed53f30e7ce$var$_toPrimitive(t, r) {
    if ("object" != $eae69ed53f30e7ce$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $eae69ed53f30e7ce$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $eae69ed53f30e7ce$var$_extends() {
    $eae69ed53f30e7ce$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $eae69ed53f30e7ce$var$_extends.apply(this, arguments);
}
function $eae69ed53f30e7ce$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $eae69ed53f30e7ce$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $eae69ed53f30e7ce$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * The <CartesianGrid horizontal
 */ var $eae69ed53f30e7ce$var$Background = function Background(props) {
    var fill = props.fill;
    if (!fill || fill === 'none') return null;
    var fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, ry = props.ry;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: x,
        y: y,
        ry: ry,
        width: width,
        height: height,
        stroke: "none",
        fill: fill,
        fillOpacity: fillOpacity,
        className: "recharts-cartesian-grid-bg"
    });
};
function $eae69ed53f30e7ce$var$renderLineItem(option, props) {
    var lineItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(option)) // @ts-expect-error typescript does not see the props type when cloning an element
    lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(option)) lineItem = option(props);
    else {
        var x1 = props.x1, y1 = props.y1, x2 = props.x2, y2 = props.y2, key = props.key, others = $eae69ed53f30e7ce$var$_objectWithoutProperties(props, $eae69ed53f30e7ce$var$_excluded);
        var _filterProps = (0, $008f02516c156322$export$d697c39a2985a4c)(others, false), __ = _filterProps.offset, restOfFilteredProps = $eae69ed53f30e7ce$var$_objectWithoutProperties(_filterProps, $eae69ed53f30e7ce$var$_excluded2);
        lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", $eae69ed53f30e7ce$var$_extends({}, restOfFilteredProps, {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            fill: "none",
            key: key
        }));
    }
    return lineItem;
}
function $eae69ed53f30e7ce$var$HorizontalGridLines(props) {
    var x = props.x, width = props.width, _props$horizontal = props.horizontal, horizontal = _props$horizontal === void 0 ? true : _props$horizontal, horizontalPoints = props.horizontalPoints;
    if (!horizontal || !horizontalPoints || !horizontalPoints.length) return null;
    var items = horizontalPoints.map(function(entry, i) {
        var lineItemProps = $eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, props), {}, {
            x1: x,
            y1: entry,
            x2: x + width,
            y2: entry,
            key: "line-".concat(i),
            index: i
        });
        return $eae69ed53f30e7ce$var$renderLineItem(horizontal, lineItemProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        className: "recharts-cartesian-grid-horizontal"
    }, items);
}
function $eae69ed53f30e7ce$var$VerticalGridLines(props) {
    var y = props.y, height = props.height, _props$vertical = props.vertical, vertical = _props$vertical === void 0 ? true : _props$vertical, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalPoints || !verticalPoints.length) return null;
    var items = verticalPoints.map(function(entry, i) {
        var lineItemProps = $eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, props), {}, {
            x1: entry,
            y1: y,
            x2: entry,
            y2: y + height,
            key: "line-".concat(i),
            index: i
        });
        return $eae69ed53f30e7ce$var$renderLineItem(vertical, lineItemProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        className: "recharts-cartesian-grid-vertical"
    }, items);
}
function $eae69ed53f30e7ce$var$HorizontalStripes(props) {
    var horizontalFill = props.horizontalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, horizontalPoints = props.horizontalPoints, _props$horizontal2 = props.horizontal, horizontal = _props$horizontal2 === void 0 ? true : _props$horizontal2;
    if (!horizontal || !horizontalFill || !horizontalFill.length) return null;
    // Why =y -y? I was trying to find any difference that this makes, with floating point numbers and edge cases but ... nothing.
    var roundedSortedHorizontalPoints = horizontalPoints.map(function(e) {
        return Math.round(e + y - y);
    }).sort(function(a, b) {
        return a - b;
    });
    // Why is this condition `!==` instead of `<=` ?
    if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
    var items = roundedSortedHorizontalPoints.map(function(entry, i) {
        // Why do we strip only the last stripe if it is invisible, and not all invisible stripes?
        var lastStripe = !roundedSortedHorizontalPoints[i + 1];
        var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
        if (lineHeight <= 0) return null;
        var colorIndex = i % horizontalFill.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            y: entry,
            x: x,
            height: lineHeight,
            width: width,
            stroke: "none",
            fill: horizontalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        className: "recharts-cartesian-gridstripes-horizontal"
    }, items);
}
function $eae69ed53f30e7ce$var$VerticalStripes(props) {
    var _props$vertical2 = props.vertical, vertical = _props$vertical2 === void 0 ? true : _props$vertical2, verticalFill = props.verticalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalFill || !verticalFill.length) return null;
    var roundedSortedVerticalPoints = verticalPoints.map(function(e) {
        return Math.round(e + x - x);
    }).sort(function(a, b) {
        return a - b;
    });
    if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
    var items = roundedSortedVerticalPoints.map(function(entry, i) {
        var lastStripe = !roundedSortedVerticalPoints[i + 1];
        var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
        if (lineWidth <= 0) return null;
        var colorIndex = i % verticalFill.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            x: entry,
            y: y,
            width: lineWidth,
            height: height,
            stroke: "none",
            fill: verticalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        className: "recharts-cartesian-gridstripes-vertical"
    }, items);
}
var $eae69ed53f30e7ce$var$defaultVerticalCoordinatesGenerator = function defaultVerticalCoordinatesGenerator(_ref, syncWithTicks) {
    var xAxis = _ref.xAxis, width = _ref.width, height = _ref.height, offset = _ref.offset;
    return (0, $cd015374923bb5c7$export$846dc5ac5fecff74)((0, $582ebde04d312f24$export$3d27d42b1034de5c)($eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, (0, $247385db510d7b7c$export$bdd99f2cdf352bae).defaultProps), xAxis), {}, {
        ticks: (0, $cd015374923bb5c7$export$c829ee42daf7f66d)(xAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.left, offset.left + offset.width, syncWithTicks);
};
var $eae69ed53f30e7ce$var$defaultHorizontalCoordinatesGenerator = function defaultHorizontalCoordinatesGenerator(_ref2, syncWithTicks) {
    var yAxis = _ref2.yAxis, width = _ref2.width, height = _ref2.height, offset = _ref2.offset;
    return (0, $cd015374923bb5c7$export$846dc5ac5fecff74)((0, $582ebde04d312f24$export$3d27d42b1034de5c)($eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, (0, $247385db510d7b7c$export$bdd99f2cdf352bae).defaultProps), yAxis), {}, {
        ticks: (0, $cd015374923bb5c7$export$c829ee42daf7f66d)(yAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.top, offset.top + offset.height, syncWithTicks);
};
var $eae69ed53f30e7ce$var$defaultProps = {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: '#ccc',
    fill: 'none',
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
};
function $eae69ed53f30e7ce$export$6440e27b9f186856(props) {
    var _props$stroke, _props$fill, _props$horizontal3, _props$horizontalFill, _props$vertical3, _props$verticalFill;
    var chartWidth = (0, $e573f10901a87cfb$export$8854f7ece606854b)();
    var chartHeight = (0, $e573f10901a87cfb$export$369ae257969c6f9f)();
    var offset = (0, $e573f10901a87cfb$export$99e5207fa7e69f17)();
    var propsIncludingDefaults = $eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, props), {}, {
        stroke: (_props$stroke = props.stroke) !== null && _props$stroke !== void 0 ? _props$stroke : $eae69ed53f30e7ce$var$defaultProps.stroke,
        fill: (_props$fill = props.fill) !== null && _props$fill !== void 0 ? _props$fill : $eae69ed53f30e7ce$var$defaultProps.fill,
        horizontal: (_props$horizontal3 = props.horizontal) !== null && _props$horizontal3 !== void 0 ? _props$horizontal3 : $eae69ed53f30e7ce$var$defaultProps.horizontal,
        horizontalFill: (_props$horizontalFill = props.horizontalFill) !== null && _props$horizontalFill !== void 0 ? _props$horizontalFill : $eae69ed53f30e7ce$var$defaultProps.horizontalFill,
        vertical: (_props$vertical3 = props.vertical) !== null && _props$vertical3 !== void 0 ? _props$vertical3 : $eae69ed53f30e7ce$var$defaultProps.vertical,
        verticalFill: (_props$verticalFill = props.verticalFill) !== null && _props$verticalFill !== void 0 ? _props$verticalFill : $eae69ed53f30e7ce$var$defaultProps.verticalFill,
        x: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(props.x) ? props.x : offset.left,
        y: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(props.y) ? props.y : offset.top,
        width: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(props.width) ? props.width : offset.width,
        height: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(props.height) ? props.height : offset.height
    });
    var x = propsIncludingDefaults.x, y = propsIncludingDefaults.y, width = propsIncludingDefaults.width, height = propsIncludingDefaults.height, syncWithTicks = propsIncludingDefaults.syncWithTicks, horizontalValues = propsIncludingDefaults.horizontalValues, verticalValues = propsIncludingDefaults.verticalValues;
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var xAxis = (0, $e573f10901a87cfb$export$1d855c2865750a72)();
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var yAxis = (0, $e573f10901a87cfb$export$631ee617f1052e16)();
    if (!(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(height) || height <= 0 || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(x) || x !== +x || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(y) || y !== +y) return null;
    /*
   * verticalCoordinatesGenerator and horizontalCoordinatesGenerator are defined
   * outside of the propsIncludingDefaults because they were never part of the original props
   * and they were never passed as a prop down to horizontal/vertical custom elements.
   * If we add these two to propsIncludingDefaults then we are changing public API.
   * Not a bad thing per se but also not necessary.
   */ var verticalCoordinatesGenerator = propsIncludingDefaults.verticalCoordinatesGenerator || $eae69ed53f30e7ce$var$defaultVerticalCoordinatesGenerator;
    var horizontalCoordinatesGenerator = propsIncludingDefaults.horizontalCoordinatesGenerator || $eae69ed53f30e7ce$var$defaultHorizontalCoordinatesGenerator;
    var horizontalPoints = propsIncludingDefaults.horizontalPoints, verticalPoints = propsIncludingDefaults.verticalPoints;
    // No horizontal points are specified
    if ((!horizontalPoints || !horizontalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(horizontalCoordinatesGenerator)) {
        var isHorizontalValues = horizontalValues && horizontalValues.length;
        var generatorResult = horizontalCoordinatesGenerator({
            yAxis: yAxis ? $eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, yAxis), {}, {
                ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isHorizontalValues ? true : syncWithTicks);
        (0, $0c26188443d0bc67$export$c106dd0671a0fc2d)(Array.isArray(generatorResult), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat($eae69ed53f30e7ce$var$_typeof(generatorResult), "]"));
        if (Array.isArray(generatorResult)) horizontalPoints = generatorResult;
    }
    // No vertical points are specified
    if ((!verticalPoints || !verticalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(verticalCoordinatesGenerator)) {
        var isVerticalValues = verticalValues && verticalValues.length;
        var _generatorResult = verticalCoordinatesGenerator({
            xAxis: xAxis ? $eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, xAxis), {}, {
                ticks: isVerticalValues ? verticalValues : xAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isVerticalValues ? true : syncWithTicks);
        (0, $0c26188443d0bc67$export$c106dd0671a0fc2d)(Array.isArray(_generatorResult), "verticalCoordinatesGenerator should return Array but instead it returned [".concat($eae69ed53f30e7ce$var$_typeof(_generatorResult), "]"));
        if (Array.isArray(_generatorResult)) verticalPoints = _generatorResult;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        className: "recharts-cartesian-grid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eae69ed53f30e7ce$var$Background, {
        fill: propsIncludingDefaults.fill,
        fillOpacity: propsIncludingDefaults.fillOpacity,
        x: propsIncludingDefaults.x,
        y: propsIncludingDefaults.y,
        width: propsIncludingDefaults.width,
        height: propsIncludingDefaults.height,
        ry: propsIncludingDefaults.ry
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eae69ed53f30e7ce$var$HorizontalGridLines, $eae69ed53f30e7ce$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        horizontalPoints: horizontalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eae69ed53f30e7ce$var$VerticalGridLines, $eae69ed53f30e7ce$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        verticalPoints: verticalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eae69ed53f30e7ce$var$HorizontalStripes, $eae69ed53f30e7ce$var$_extends({}, propsIncludingDefaults, {
        horizontalPoints: horizontalPoints
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eae69ed53f30e7ce$var$VerticalStripes, $eae69ed53f30e7ce$var$_extends({}, propsIncludingDefaults, {
        verticalPoints: verticalPoints
    })));
}
$eae69ed53f30e7ce$export$6440e27b9f186856.displayName = 'CartesianGrid';



var $acw62 = parcelRequire("acw62");




function $0431397098acacbe$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0431397098acacbe$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0431397098acacbe$var$_typeof(o);
}
function $0431397098acacbe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0431397098acacbe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0431397098acacbe$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0431397098acacbe$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0431397098acacbe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0431397098acacbe$var$_defineProperty(obj, key, value) {
    key = $0431397098acacbe$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0431397098acacbe$var$_toPropertyKey(t) {
    var i = $0431397098acacbe$var$_toPrimitive(t, "string");
    return "symbol" == $0431397098acacbe$var$_typeof(i) ? i : i + "";
}
function $0431397098acacbe$var$_toPrimitive(t, r) {
    if ("object" != $0431397098acacbe$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0431397098acacbe$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0431397098acacbe$var$_slicedToArray(arr, i) {
    return $0431397098acacbe$var$_arrayWithHoles(arr) || $0431397098acacbe$var$_iterableToArrayLimit(arr, i) || $0431397098acacbe$var$_unsupportedIterableToArray(arr, i) || $0431397098acacbe$var$_nonIterableRest();
}
function $0431397098acacbe$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0431397098acacbe$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0431397098acacbe$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0431397098acacbe$var$_arrayLikeToArray(o, minLen);
}
function $0431397098acacbe$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0431397098acacbe$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $0431397098acacbe$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $0431397098acacbe$export$e60a4704009a0009 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
        width: -1,
        height: -1
    } : _ref$initialDimension, _ref$width = _ref.width, width = _ref$width === void 0 ? '100%' : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? '100%' : _ref$height, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className, onResize = _ref.onResize, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
    var containerRef = (0, $acw62.useRef)(null);
    var onResizeRef = (0, $acw62.useRef)();
    onResizeRef.current = onResize;
    (0, $acw62.useImperativeHandle)(ref, function() {
        return Object.defineProperty(containerRef.current, 'current', {
            get: function get() {
                // eslint-disable-next-line no-console
                console.warn('The usage of ref.current.current is deprecated and will no longer be supported.');
                return containerRef.current;
            },
            configurable: true
        });
    });
    var _useState = (0, $acw62.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    }), _useState2 = $0431397098acacbe$var$_slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var setContainerSize = (0, $acw62.useCallback)(function(newWidth, newHeight) {
        setSizes(function(prevState) {
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    (0, $acw62.useEffect)(function() {
        var callback = function callback(entries) {
            var _onResizeRef$current;
            var _entries$0$contentRec = entries[0].contentRect, containerWidth = _entries$0$contentRec.width, containerHeight = _entries$0$contentRec.height;
            setContainerSize(containerWidth, containerHeight);
            (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
        };
        if (debounce > 0) callback = (0, (/*@__PURE__*/$parcel$interopDefault($ff695783c7d42c0c$exports)))(callback, debounce, {
            trailing: true,
            leading: false
        });
        var observer = new ResizeObserver(callback);
        var _containerRef$current = containerRef.current.getBoundingClientRect(), containerWidth = _containerRef$current.width, containerHeight = _containerRef$current.height;
        setContainerSize(containerWidth, containerHeight);
        observer.observe(containerRef.current);
        return function() {
            observer.disconnect();
        };
    }, [
        setContainerSize,
        debounce
    ]);
    var chartContent = (0, $acw62.useMemo)(function() {
        var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
        if (containerWidth < 0 || containerHeight < 0) return null;
        (0, $0c26188443d0bc67$export$c106dd0671a0fc2d)((0, $2ab3a7e25c8aba74$export$e50269385c77c348)(width) || (0, $2ab3a7e25c8aba74$export$e50269385c77c348)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
        (0, $0c26188443d0bc67$export$c106dd0671a0fc2d)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
        var calculatedWidth = (0, $2ab3a7e25c8aba74$export$e50269385c77c348)(width) ? containerWidth : width;
        var calculatedHeight = (0, $2ab3a7e25c8aba74$export$e50269385c77c348)(height) ? containerHeight : height;
        if (aspect && aspect > 0) {
            // Preserve the desired aspect ratio
            if (calculatedWidth) // Will default to using width for aspect ratio
            calculatedHeight = calculatedWidth / aspect;
            else if (calculatedHeight) // But we should also take height into consideration
            calculatedWidth = calculatedHeight * aspect;
            // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
            if (maxHeight && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
        }
        (0, $0c26188443d0bc67$export$c106dd0671a0fc2d)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
        var isCharts = !Array.isArray(children) && (0, $008f02516c156322$export$be63e0664592e141)(children.type).endsWith('Chart');
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(children, function(child) {
            if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(child)) return /*#__PURE__*/ (0, $acw62.cloneElement)(child, $0431397098acacbe$var$_objectSpread({
                width: calculatedWidth,
                height: calculatedHeight
            }, isCharts ? {
                style: $0431397098acacbe$var$_objectSpread({
                    height: '100%',
                    width: '100%',
                    maxHeight: calculatedHeight,
                    maxWidth: calculatedWidth
                }, child.props.style)
            } : {}));
            return child;
        });
    }, [
        aspect,
        children,
        height,
        maxHeight,
        minHeight,
        minWidth,
        sizes,
        width
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id ? "".concat(id) : undefined,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-responsive-container', className),
        style: $0431397098acacbe$var$_objectSpread($0431397098acacbe$var$_objectSpread({}, style), {}, {
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        }),
        ref: containerRef
    }, chartContent);
});


const $63ac2dce3b5a5e6d$var$ProgressTracker = ({ progress: progress })=>{
    const averageScore = progress.quizHistory.length > 0 ? (progress.quizHistory.reduce((acc, curr)=>acc + curr.score, 0) / progress.quizHistory.length).toFixed(1) : 'N/A';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-8 animate-fade-in",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        className: "text-3xl font-bold text-white",
                        children: "Your Progress"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-gray-400",
                        children: "Track your learning journey and past quiz scores."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-3 gap-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-gray-800 p-6 rounded-2xl text-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-400",
                                children: "Streak"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-4xl font-bold text-orange-400",
                                children: [
                                    progress.streak,
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-xl",
                                        children: "days"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-gray-800 p-6 rounded-2xl text-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-400",
                                children: "Tasks Done"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-4xl font-bold text-green-400",
                                children: progress.completedTasks
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-gray-800 p-6 rounded-2xl text-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-400",
                                children: "Avg. Score"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-4xl font-bold text-blue-400",
                                children: [
                                    averageScore,
                                    averageScore !== 'N/A' && '%'
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-gray-800 p-6 rounded-2xl shadow-lg",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-2xl font-bold text-white mb-4",
                        children: "Learning Curve"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            width: '100%',
                            height: 300
                        },
                        children: progress.learningData.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0431397098acacbe$export$e60a4704009a0009), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $74d07378047db57c$export$94aefc399ef206a9), {
                                data: progress.learningData,
                                margin: {
                                    top: 5,
                                    right: 20,
                                    left: -10,
                                    bottom: 5
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eae69ed53f30e7ce$export$6440e27b9f186856), {
                                        strokeDasharray: "3 3",
                                        stroke: "#4A5568"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f21953d5ea7d4fb8$export$ea77231de273b52d), {
                                        dataKey: "date",
                                        stroke: "#A0AEC0"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e2dfd8b3bfb4506$export$f96c4024c52de8f4), {
                                        stroke: "#A0AEC0"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3258e2bab55a6a07$export$28c660c63b792dea), {
                                        contentStyle: {
                                            backgroundColor: '#1A202C',
                                            border: '1px solid #4A5568'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e752e700473a8894$export$bbc6c6369b38e3d1), {
                                        dataKey: "score",
                                        fill: "#4299E1",
                                        radius: [
                                            4,
                                            4,
                                            0,
                                            0
                                        ]
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex items-center justify-center h-full text-gray-400",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "Complete some quizzes to see your learning curve!"
                            })
                        })
                    })
                ]
            }),
            progress.quizHistory.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-gray-800 p-6 rounded-2xl shadow-lg",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-2xl font-bold text-white mb-4",
                        children: "Quiz History"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "space-y-3 max-h-60 overflow-y-auto",
                        children: progress.quizHistory.slice().reverse().map((result, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex justify-between items-center bg-gray-700/50 p-3 rounded-lg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "font-semibold text-white",
                                                children: result.topic
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-gray-400",
                                                children: result.date
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: `font-bold text-lg ${result.score >= 70 ? 'text-green-400' : 'text-orange-400'}`,
                                        children: [
                                            result.score,
                                            "%"
                                        ]
                                    })
                                ]
                            }, index))
                    })
                ]
            })
        ]
    });
};
var $63ac2dce3b5a5e6d$export$2e2bcd8739ae039 = $63ac2dce3b5a5e6d$var$ProgressTracker;




var $acw62 = parcelRequire("acw62");


const $c186152a5c4d96a6$var$QuizMaker = ({ onQuizComplete: onQuizComplete })=>{
    const [quizState, setQuizState] = (0, $acw62.useState)('config');
    const [topic, setTopic] = (0, $acw62.useState)('');
    const [questionCount, setQuestionCount] = (0, $acw62.useState)(5);
    const [quiz, setQuiz] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)('');
    const [currentQuestionIndex, setCurrentQuestionIndex] = (0, $acw62.useState)(0);
    const [userAnswers, setUserAnswers] = (0, $acw62.useState)([]);
    const [score, setScore] = (0, $acw62.useState)(0);
    const handleGenerateQuiz = async (e)=>{
        e.preventDefault();
        if (!topic) {
            setError('Please enter a topic.');
            return;
        }
        setError('');
        setQuizState('loading');
        try {
            const quizData = await (0, $116f6b541640fbf7$export$9c32e01ad104c2c0)(topic, questionCount);
            setQuiz(quizData);
            setQuizState('taking');
        } catch (err) {
            setError(err.message);
            setQuizState('config');
        }
    };
    const handleAnswerSubmit = (answer)=>{
        const newAnswers = [
            ...userAnswers,
            answer
        ];
        setUserAnswers(newAnswers);
        if (currentQuestionIndex < (quiz?.questions.length || 0) - 1) setCurrentQuestionIndex(currentQuestionIndex + 1);
        else {
            // End of quiz
            calculateScore(newAnswers);
            setQuizState('results');
        }
    };
    const calculateScore = (finalAnswers)=>{
        if (!quiz) return;
        let correctCount = 0;
        quiz.questions.forEach((q, i)=>{
            if (q.answer.toLowerCase().trim() === finalAnswers[i]?.toLowerCase().trim()) correctCount++;
        });
        const finalScore = Math.round(correctCount / quiz.questions.length * 100);
        setScore(finalScore);
        // Update parent component
        onQuizComplete({
            score: finalScore,
            topic: quiz.topic
        });
    };
    const resetQuiz = ()=>{
        setQuizState('config');
        setTopic('');
        setQuestionCount(5);
        setQuiz(null);
        setCurrentQuestionIndex(0);
        setUserAnswers([]);
        setScore(0);
        setError('');
    };
    const renderContent = ()=>{
        switch(quizState){
            case 'loading':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col items-center justify-center text-center p-8",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e7fd069000a3c94$export$647aae5028016fe9), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "mt-4 text-lg",
                            children: [
                                'Generating your quiz on "',
                                topic,
                                '"...'
                            ]
                        })
                    ]
                });
            case 'taking':
                if (!quiz) return null;
                const question = quiz.questions[currentQuestionIndex];
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c186152a5c4d96a6$var$QuizTaker, {
                    question: question,
                    questionNumber: currentQuestionIndex + 1,
                    totalQuestions: quiz.questions.length,
                    onSubmit: handleAnswerSubmit
                });
            case 'results':
                if (!quiz) return null;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c186152a5c4d96a6$var$QuizResults, {
                    quiz: quiz,
                    userAnswers: userAnswers,
                    score: score,
                    onReset: resetQuiz
                });
            case 'config':
            default:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "bg-gray-800 p-8 rounded-2xl shadow-lg max-w-lg mx-auto",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            className: "text-3xl font-bold text-white mb-6 text-center",
                            children: "Create a Quiz"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                            onSubmit: handleGenerateQuiz,
                            className: "space-y-6",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-300 mb-1",
                                            children: "Topic"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: topic,
                                            onChange: (e)=>setTopic(e.target.value),
                                            placeholder: "e.g., JavaScript Promises",
                                            className: "w-full bg-gray-700 text-white p-3 rounded-md border border-gray-600 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            className: "block text-sm font-medium text-gray-300 mb-1",
                                            children: [
                                                "Number of Questions: ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "font-bold text-blue-400",
                                                    children: questionCount
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "range",
                                            min: "3",
                                            max: "15",
                                            value: questionCount,
                                            onChange: (e)=>setQuestionCount(parseInt(e.target.value)),
                                            className: "w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer accent-blue-500"
                                        })
                                    ]
                                }),
                                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-red-400 text-sm text-center",
                                    children: error
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "submit",
                                    className: "w-full bg-blue-600 text-white font-bold py-3 px-4 rounded-md hover:bg-blue-700 transition-colors transform hover:scale-105",
                                    children: "Generate Quiz"
                                })
                            ]
                        })
                    ]
                });
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "animate-fade-in",
        children: renderContent()
    });
};
const $c186152a5c4d96a6$var$QuizTaker = ({ question: question, questionNumber: questionNumber, totalQuestions: totalQuestions, onSubmit: onSubmit })=>{
    const [selectedAnswer, setSelectedAnswer] = (0, $acw62.useState)('');
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (selectedAnswer) {
            onSubmit(selectedAnswer);
            setSelectedAnswer('');
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bg-gray-800 p-8 rounded-2xl shadow-lg max-w-2xl mx-auto",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-sm font-semibold text-blue-400 mb-2",
                children: [
                    "Question ",
                    questionNumber,
                    " of ",
                    totalQuestions
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-xl text-white mb-6",
                children: question.question
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "space-y-3 mb-6",
                        children: question.options.map((option, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: `block p-4 rounded-lg cursor-pointer transition-all ${selectedAnswer === option ? 'bg-blue-600 ring-2 ring-blue-400' : 'bg-gray-700 hover:bg-gray-600'}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "radio",
                                        name: "option",
                                        value: option,
                                        checked: selectedAnswer === option,
                                        onChange: (e)=>setSelectedAnswer(e.target.value),
                                        className: "hidden"
                                    }),
                                    option
                                ]
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "submit",
                        disabled: !selectedAnswer,
                        className: "w-full bg-blue-600 text-white font-bold py-3 px-4 rounded-md hover:bg-blue-700 transition-colors disabled:bg-gray-500 disabled:cursor-not-allowed",
                        children: questionNumber < totalQuestions ? 'Next Question' : 'Finish Quiz'
                    })
                ]
            })
        ]
    });
};
const $c186152a5c4d96a6$var$QuizResults = ({ quiz: quiz, userAnswers: userAnswers, score: score, onReset: onReset })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-gray-800 p-8 rounded-2xl shadow-lg text-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        className: "text-2xl font-bold text-white",
                        children: [
                            "Quiz Results for ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-blue-400",
                                children: quiz.topic
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-6xl font-extrabold my-4",
                        style: {
                            color: score >= 70 ? '#48BB78' : '#F56565'
                        },
                        children: [
                            score,
                            "%"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-gray-400",
                        children: [
                            "You answered ",
                            Math.round(score / 100 * quiz.questions.length),
                            " out of ",
                            quiz.questions.length,
                            " questions correctly."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: onReset,
                        className: "mt-6 bg-blue-600 text-white font-bold py-2 px-6 rounded-md hover:bg-blue-700 transition-colors",
                        children: "Take Another Quiz"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-xl font-bold text-white",
                        children: "Review Your Answers"
                    }),
                    quiz.questions.map((q, i)=>{
                        const userAnswer = userAnswers[i];
                        const isCorrect = q.answer.toLowerCase().trim() === userAnswer?.toLowerCase().trim();
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-gray-800 p-5 rounded-lg border-l-4",
                            style: {
                                borderColor: isCorrect ? '#48BB78' : '#F56565'
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "font-semibold text-white mb-2",
                                    children: [
                                        i + 1,
                                        ". ",
                                        q.question
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-2 mb-2",
                                    children: [
                                        isCorrect ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e7fd069000a3c94$export$7dd004358974b05d), {
                                            className: "w-5 h-5 text-green-500"
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e7fd069000a3c94$export$5e658a8851ae9322), {
                                            className: "w-5 h-5 text-red-500"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: `italic ${isCorrect ? 'text-gray-400' : 'text-red-400 line-through'}`,
                                            children: [
                                                "Your answer: ",
                                                userAnswer || "No answer"
                                            ]
                                        })
                                    ]
                                }),
                                !isCorrect && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "text-green-400 italic",
                                    children: [
                                        "Correct answer: ",
                                        q.answer
                                    ]
                                }),
                                q.explanation && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "text-sm text-gray-400 mt-3 pt-3 border-t border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Explanation:"
                                        }),
                                        " ",
                                        q.explanation
                                    ]
                                })
                            ]
                        }, i);
                    })
                ]
            })
        ]
    });
};
var $c186152a5c4d96a6$export$2e2bcd8739ae039 = $c186152a5c4d96a6$var$QuizMaker;




var $acw62 = parcelRequire("acw62");




const $51d8c6d286cf0927$var$genId = ()=>Date.now().toString(36) + Math.random().toString(36).substring(2);
const $51d8c6d286cf0927$var$PDFChat = ()=>{
    const [file, setFile] = (0, $acw62.useState)(null);
    const [uploadedFileInfo, setUploadedFileInfo] = (0, $acw62.useState)(null);
    const [uploadStatus, setUploadStatus] = (0, $acw62.useState)('idle');
    const [messages, setMessages] = (0, $acw62.useState)([]);
    const [input, setInput] = (0, $acw62.useState)('');
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)('');
    const chatEndRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        chatEndRef.current?.scrollIntoView({
            behavior: 'smooth'
        });
    }, [
        messages
    ]);
    const handleFileChange = async (selectedFile)=>{
        if (selectedFile && selectedFile.type === 'application/pdf') {
            setError('');
            setFile(selectedFile);
            setUploadStatus('uploading');
            try {
                const uploadedFile = await (0, $116f6b541640fbf7$export$a5575dbeeffdad98)(selectedFile);
                setUploadStatus('processing');
                const pollFileState = async ()=>{
                    let getFileResponse = await (0, $116f6b541640fbf7$export$8b3ca78f81ec578c)(uploadedFile.name);
                    while(getFileResponse.state === 'PROCESSING'){
                        await new Promise((resolve)=>setTimeout(resolve, 3000));
                        getFileResponse = await (0, $116f6b541640fbf7$export$8b3ca78f81ec578c)(uploadedFile.name);
                    }
                    if (getFileResponse.state === 'ACTIVE' && getFileResponse.uri) {
                        setUploadedFileInfo({
                            name: getFileResponse.displayName || selectedFile.name,
                            uri: getFileResponse.uri,
                            mimeType: getFileResponse.mimeType || selectedFile.type
                        });
                        setUploadStatus('success');
                        setMessages([
                            {
                                id: $51d8c6d286cf0927$var$genId(),
                                role: 'model',
                                text: `I've finished processing "${selectedFile.name}". What would you like to know?`
                            }
                        ]);
                    } else throw new Error('File processing failed on the server.');
                };
                await pollFileState();
            } catch (err) {
                setError(err.message);
                setUploadStatus('failed');
                setFile(null);
            }
        } else setError('Please upload a valid PDF file.');
    };
    const handleDragOver = (e)=>e.preventDefault();
    const handleDrop = (e)=>{
        e.preventDefault();
        const droppedFile = e.dataTransfer.files[0];
        handleFileChange(droppedFile);
    };
    const handleSend = (0, $acw62.useCallback)(async ()=>{
        const content = input.trim();
        if (!content || isLoading || !uploadedFileInfo) return;
        const userMsg = {
            id: $51d8c6d286cf0927$var$genId(),
            role: 'user',
            text: content
        };
        const newMessages = [
            ...messages,
            userMsg
        ];
        setMessages(newMessages);
        setInput('');
        setIsLoading(true);
        const botMsgId = $51d8c6d286cf0927$var$genId();
        setMessages((prev)=>[
                ...prev,
                {
                    id: botMsgId,
                    role: 'model',
                    text: ''
                }
            ]);
        try {
            const stream = await (0, $116f6b541640fbf7$export$c17ea0f2f35725c5)(newMessages, uploadedFileInfo.uri, uploadedFileInfo.mimeType);
            let fullReply = '';
            for await (const chunk of stream){
                const delta = chunk.text;
                if (delta) {
                    fullReply += delta;
                    setMessages((prev)=>prev.map((m)=>m.id === botMsgId ? {
                                ...m,
                                text: fullReply
                            } : m));
                }
            }
        } catch (err) {
            console.error("Error fetching Gemini response:", err);
            setMessages((prev)=>prev.map((m)=>m.id === botMsgId ? {
                        ...m,
                        text: "Sorry, an error occurred."
                    } : m));
        } finally{
            setIsLoading(false);
        }
    }, [
        input,
        isLoading,
        messages,
        uploadedFileInfo
    ]);
    const reset = ()=>{
        setFile(null);
        setUploadedFileInfo(null);
        setUploadStatus('idle');
        setMessages([]);
        setError('');
    };
    if (uploadStatus === 'uploading' || uploadStatus === 'processing') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col items-center justify-center h-full text-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e7fd069000a3c94$export$647aae5028016fe9), {
                className: "w-12 h-12"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-4 text-lg text-gray-300",
                children: [
                    uploadStatus === 'uploading' ? 'Uploading' : 'Analyzing',
                    " your document: ",
                    file?.name
                ]
            }),
            uploadStatus === 'processing' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-gray-400",
                children: "This might take a moment for large files..."
            })
        ]
    });
    if (!uploadedFileInfo) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col items-center justify-center h-full text-center animate-fade-in p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "text-3xl font-bold text-white mb-2",
                children: "Chat With Your PDF"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-gray-400 mb-8",
                children: "Upload a document to start asking questions."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                onDragOver: handleDragOver,
                onDrop: handleDrop,
                className: "w-full max-w-lg p-10 border-2 border-dashed border-gray-600 rounded-2xl cursor-pointer hover:border-blue-500 hover:bg-gray-800/50 transition-all",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "file",
                        id: "pdf-upload",
                        accept: "application/pdf",
                        onChange: (e)=>handleFileChange(e.target.files?.[0] ?? null),
                        className: "hidden"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        htmlFor: "pdf-upload",
                        className: "flex flex-col items-center cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e7fd069000a3c94$export$6b5c34a0be8f60b9), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-4 text-lg font-semibold text-white",
                                children: "Drag & drop your PDF here"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-500",
                                children: "or click to browse"
                            })
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-4 text-red-400",
                children: error
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col h-full max-w-3xl mx-auto bg-gray-900 text-white animate-fade-in",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                className: "p-4 border-b border-gray-700 flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                                className: "text-2xl font-bold text-white flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e7fd069000a3c94$export$605674723bcc715c), {
                                        className: "w-6 h-6 text-blue-400"
                                    }),
                                    " Q&A on your Document"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-400 truncate max-w-sm",
                                title: uploadedFileInfo.name,
                                children: uploadedFileInfo.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: reset,
                        className: "bg-gray-700 hover:bg-gray-600 text-white font-semibold py-2 px-4 rounded-md transition-colors",
                        children: "New PDF"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex-1 overflow-y-auto p-4 space-y-4",
                children: [
                    messages.map((msg)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: `flex ${msg.role === "user" ? "justify-end" : "justify-start"}`,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: `p-4 rounded-2xl max-w-lg ${msg.role === "user" ? "bg-blue-600 text-white rounded-br-none" : "bg-gray-800 text-gray-200 rounded-bl-none"}`,
                                children: msg.text ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "prose prose-invert max-w-none",
                                    dangerouslySetInnerHTML: {
                                        __html: (0, (/*@__PURE__*/$parcel$interopDefault($d349326c2b62c55f$exports))).sanitize((0, $d55025bea272cdc1$exports.marked).parse(msg.text))
                                    }
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e7fd069000a3c94$export$647aae5028016fe9), {})
                            })
                        }, msg.id)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        ref: chatEndRef
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "p-4 border-t border-gray-700 bg-gray-900",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center bg-gray-800 rounded-xl p-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            value: input,
                            onChange: (e)=>setInput(e.target.value),
                            onKeyDown: (e)=>e.key === "Enter" && !e.shiftKey && (e.preventDefault(), handleSend()),
                            placeholder: "Ask something about the document...",
                            className: "flex-1 bg-transparent text-white px-4 py-2 focus:outline-none",
                            disabled: isLoading
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: handleSend,
                            disabled: isLoading || !input,
                            className: "bg-blue-600 hover:bg-blue-700 text-white font-bold p-3 rounded-lg ml-2 disabled:bg-gray-600 disabled:cursor-not-allowed transition-colors",
                            children: isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e7fd069000a3c94$export$647aae5028016fe9), {
                                className: "w-5 h-5"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e7fd069000a3c94$export$8ab25e1bd13dc8cb), {
                                className: "w-5 h-5"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $51d8c6d286cf0927$export$2e2bcd8739ae039 = $51d8c6d286cf0927$var$PDFChat;



const $19d9deac12f277fb$var$App = ()=>{
    const [view, setView] = (0, $acw62.useState)((0, $ba3ca70f36990d50$export$27a5bd065ad55220).DASHBOARD);
    const [studyPlan, setStudyPlan] = (0, $db9b33d6dfbcb14b$export$2e2bcd8739ae039)('studyPlan', null);
    const [progress, setProgress] = (0, $db9b33d6dfbcb14b$export$2e2bcd8739ae039)('progress', {
        streak: 0,
        completedTasks: 0,
        quizHistory: [],
        learningData: []
    });
    const [isMenuOpen, setIsMenuOpen] = (0, $acw62.useState)(false);
    // Checks on app load if the streak was broken
    (0, $acw62.useEffect)(()=>{
        setProgress((prev)=>{
            if (!prev.lastActivityDate) return prev; // No activity yet, do nothing
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const lastActivity = new Date(prev.lastActivityDate);
            lastActivity.setHours(0, 0, 0, 0);
            const yesterday = new Date(today);
            yesterday.setDate(today.getDate() - 1);
            // If last activity was before yesterday, reset streak to 0
            if (lastActivity.getTime() < yesterday.getTime()) return {
                ...prev,
                streak: 0
            };
            return prev;
        });
    }, [
        setProgress
    ]); // Run once on mount
    const updateStreak = (0, $acw62.useCallback)((currentProgress)=>{
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Normalize to start of day
        const todayStr = today.toISOString().split('T')[0];
        if (!currentProgress.lastActivityDate) // First activity
        return {
            ...currentProgress,
            streak: 1,
            lastActivityDate: todayStr
        };
        const lastActivity = new Date(currentProgress.lastActivityDate);
        lastActivity.setHours(0, 0, 0, 0); // Normalize
        if (today.getTime() === lastActivity.getTime()) // Same day activity, no change in streak
        return currentProgress;
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        if (lastActivity.getTime() === yesterday.getTime()) // Consecutive day
        return {
            ...currentProgress,
            streak: currentProgress.streak + 1,
            lastActivityDate: todayStr
        };
        else // Not consecutive, reset streak
        return {
            ...currentProgress,
            streak: 1,
            lastActivityDate: todayStr
        };
    }, []);
    const updateProgress = (0, $acw62.useCallback)((taskId)=>{
        if (!studyPlan) return;
        let taskFound = false;
        let taskWasCompleted = false; // Check if a task is being marked complete
        const updatedPlan = {
            ...studyPlan,
            days: studyPlan.days.map((day)=>({
                    ...day,
                    tasks: day.tasks.map((task)=>{
                        if (task.id === taskId) {
                            taskFound = true;
                            taskWasCompleted = !task.completed; // True if task was incomplete before click
                            return {
                                ...task,
                                completed: !task.completed
                            };
                        }
                        return task;
                    })
                }))
        };
        if (taskFound) {
            setStudyPlan(updatedPlan);
            const completedCount = updatedPlan.days.flatMap((d)=>d.tasks).filter((t)=>t.completed).length;
            setProgress((prev)=>{
                let newProgress = {
                    ...prev,
                    completedTasks: completedCount
                };
                if (taskWasCompleted) // Only update streak if a task is marked as complete
                newProgress = updateStreak(newProgress);
                return newProgress;
            });
        }
    }, [
        studyPlan,
        setProgress,
        setStudyPlan,
        updateStreak
    ]);
    const handleQuizCompletion = (0, $acw62.useCallback)((result)=>{
        const newResult = {
            ...result,
            date: new Date().toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric'
            })
        };
        setProgress((prev)=>{
            const newProgress = {
                ...prev,
                quizHistory: [
                    ...prev.quizHistory,
                    newResult
                ],
                learningData: [
                    ...prev.learningData,
                    {
                        date: newResult.date,
                        score: newResult.score
                    }
                ]
            };
            return updateStreak(newProgress);
        });
    }, [
        setProgress,
        updateStreak
    ]);
    const NavButton = ({ icon: icon, label: label, targetView: targetView })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
            onClick: ()=>{
                setView(targetView);
                setIsMenuOpen(false);
            },
            className: `flex flex-col items-center justify-center space-y-1 w-full py-2 rounded-lg transition-colors duration-200 ${view === targetView ? 'text-blue-400 bg-gray-700/50' : 'text-gray-400 hover:bg-gray-700/30 hover:text-blue-300'}`,
            children: [
                icon,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-xs font-medium",
                    children: label
                })
            ]
        });
    const renderView = ()=>{
        switch(view){
            case (0, $ba3ca70f36990d50$export$27a5bd065ad55220).STUDY_PLAN:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bddcd414e638c254$export$2e2bcd8739ae039), {
                    studyPlan: studyPlan,
                    setStudyPlan: setStudyPlan,
                    updateProgress: updateProgress
                });
            case (0, $ba3ca70f36990d50$export$27a5bd065ad55220).PDF_CHAT:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51d8c6d286cf0927$export$2e2bcd8739ae039), {});
            case (0, $ba3ca70f36990d50$export$27a5bd065ad55220).PROGRESS:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ac2dce3b5a5e6d$export$2e2bcd8739ae039), {
                    progress: progress
                });
            case (0, $ba3ca70f36990d50$export$27a5bd065ad55220).QUIZ:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c186152a5c4d96a6$export$2e2bcd8739ae039), {
                    onQuizComplete: handleQuizCompletion
                });
            case (0, $ba3ca70f36990d50$export$27a5bd065ad55220).DASHBOARD:
            default:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b993228d74a8acd1$export$2e2bcd8739ae039), {
                    setView: setView,
                    progress: progress,
                    studyPlan: studyPlan
                });
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-h-screen bg-gray-900 text-gray-100 font-sans flex flex-col md:flex-row",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                className: "md:hidden sticky top-0 bg-gray-900/80 backdrop-blur-sm z-20 p-4 flex justify-between items-center border-b border-gray-700",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        className: "text-xl font-bold text-blue-400",
                        children: "AuraLearn"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>setIsMenuOpen(!isMenuOpen),
                        className: "p-2",
                        children: isMenuOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e7fd069000a3c94$export$5e658a8851ae9322), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e7fd069000a3c94$export$92c8767b874048d), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("aside", {
                className: `fixed md:relative top-0 left-0 h-full bg-gray-800/50 backdrop-blur-lg md:bg-gray-900 border-r border-gray-700 p-4 transform ${isMenuOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0 transition-transform duration-300 ease-in-out z-30 md:z-auto w-48 md:w-20 lg:w-48 flex flex-col items-center space-y-6`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "hidden md:flex flex-col items-center space-y-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e7fd069000a3c94$export$32d9dd3fbd9d1c94), {
                                    className: "w-6 h-6 text-white"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "text-xl font-bold text-blue-400 hidden lg:block",
                                children: "AuraLearn"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
                        className: "flex flex-col items-center w-full space-y-4 pt-10 md:pt-16",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(NavButton, {
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e7fd069000a3c94$export$92c8767b874048d), {}),
                                label: "Dashboard",
                                targetView: (0, $ba3ca70f36990d50$export$27a5bd065ad55220).DASHBOARD
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(NavButton, {
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e7fd069000a3c94$export$32d9dd3fbd9d1c94), {}),
                                label: "Study Plan",
                                targetView: (0, $ba3ca70f36990d50$export$27a5bd065ad55220).STUDY_PLAN
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(NavButton, {
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e7fd069000a3c94$export$605674723bcc715c), {}),
                                label: "PDF Q&A",
                                targetView: (0, $ba3ca70f36990d50$export$27a5bd065ad55220).PDF_CHAT
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(NavButton, {
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e7fd069000a3c94$export$9da4f9d7ed027300), {}),
                                label: "Progress",
                                targetView: (0, $ba3ca70f36990d50$export$27a5bd065ad55220).PROGRESS
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(NavButton, {
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e7fd069000a3c94$export$2ea670c40c4ad81b), {}),
                                label: "Quiz",
                                targetView: (0, $ba3ca70f36990d50$export$27a5bd065ad55220).QUIZ
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
                className: "flex-1 p-4 sm:p-6 lg:p-8 overflow-y-auto",
                children: renderView()
            })
        ]
    });
};
var $19d9deac12f277fb$export$2e2bcd8739ae039 = $19d9deac12f277fb$var$App;


const $f85b6d3c5c511c65$var$rootElement = document.getElementById('root');
if (!$f85b6d3c5c511c65$var$rootElement) throw new Error("Could not find root element to mount to");
const $f85b6d3c5c511c65$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot($f85b6d3c5c511c65$var$rootElement);
$f85b6d3c5c511c65$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).StrictMode, {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $19d9deac12f277fb$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=path0.4b8e0084.js.map
